(function ()
{
    'use strict';

    angular
        .module('app.scrumboard',
            [
                // 3rd Party Dependencies
                'moment-picker',
                'ui.calendar',
                'ui.sortable',
                'xeditable'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        $stateProvider
            .state('app.scrumboard', {
                abstract : true,
                url      : '/scrumboard',
                resolve  : {
                    BoardList: function (msApi)
                    {
                        return msApi.resolve('scrumboard.boardList@get');
                    }
                },
                bodyClass: 'scrumboard'
            })

            // Home
            .state('app.scrumboard.boards', {
                url  : '/boards',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/scrumboard/views/boards/boards-view.html',
                        controller : 'BoardsViewController as vm'
                    }
                }
            })

            // Board
            .state('app.scrumboard.boards.board', {
                    url    : '/:id/:uri',
                    views  : {
                        'content@app'                                  : {
                            templateUrl: 'app/main/apps/scrumboard/scrumboard.html',
                            controller : 'ScrumboardController as vm'
                        },
                        'scrumboardContent@app.scrumboard.boards.board': {
                            templateUrl: 'app/main/apps/scrumboard/views/board/board-view.html',
                            controller : 'BoardViewController as vm'
                        }
                    },
                    resolve: {
                        BoardData: function ($stateParams, BoardService)
                        {
                            return BoardService.getBoardData($stateParams.id);
                        }
                    }
                }
            )

            // Add board
            .state('app.scrumboard.boards.addBoard', {
                    url    : '/add',
                    views  : {
                        'content@app'                                     : {
                            templateUrl: 'app/main/apps/scrumboard/scrumboard.html',
                            controller : 'ScrumboardController as vm'
                        },
                        'scrumboardContent@app.scrumboard.boards.addBoard': {
                            templateUrl: 'app/main/apps/scrumboard/views/board/board-view.html',
                            controller : 'BoardViewController as vm'
                        }
                    },
                    resolve: {
                        BoardData: function ($stateParams, BoardService)
                        {
                            return BoardService.addNewBoard();
                        }
                    }
                }
            )

            // Calendar
            .state('app.scrumboard.boards.board.calendar', {
                url  : '/calendar',
                views: {
                    'scrumboardContent@app.scrumboard.boards.board': {
                        templateUrl: 'app/main/apps/scrumboard/views/calendar/calendar-view.html',
                        controller : 'CalendarViewController as vm'
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/scrumboard');

        // Api
        msApiProvider.register('scrumboard.boardList', ['app/data/scrumboard/board-list.json']);
        msApiProvider.register('scrumboard.board', ['app/data/scrumboard/boards/:id.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('apps.scrumboard', {
            title : 'Scrumboard',
            icon  : 'icon-trello',
            state : 'app.scrumboard.boards',
            weight: 8
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ScrumboardCalendarEventDialogController', ScrumboardCalendarEventDialogController);

    /** @ngInject */
    function ScrumboardCalendarEventDialogController($mdDialog, dueDate, BoardService, msUtils)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.dueDate = dueDate;
        vm.newCard = {
            name  : '',
            listId: ''
        };
        vm.selectedCards = [];

        // Methods
        vm.exists = msUtils.exists;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.closeDialog = closeDialog;
        vm.addNewCard = addNewCard;
        vm.assignDueDate = assignDueDate;

        //////////

        /**
         * Close Dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Add New Card
         */
        function addNewCard()
        {
            var newCardId = msUtils.guidGenerator();

            vm.board.cards.push({
                'id'               : newCardId,
                'name'             : vm.newCard.name,
                'description'      : '',
                'idAttachmentCover': '',
                'idMembers'        : [],
                'idLabels'         : [],
                'attachments'      : [],
                'subscribed'       : false,
                'checklists'       : [],
                'checkItems'       : 0,
                'checkItemsChecked': 0,
                'comments'         : [],
                'activities'       : [],
                'due'              : vm.dueDate
            });

            vm.board.lists.getById(vm.newCard.listId).idCards.push(newCardId);

            // Reset the newCard object
            vm.newCard = {
                name: '',
                listId: ''
            };

            closeDialog();
        }

        /**
         * Assign Due Date
         */
        function assignDueDate()
        {
            angular.forEach(vm.selectedCards, function (cardId)
            {
                vm.board.cards.getById(cardId).due = vm.dueDate;
            });

            vm.selectedCards = [];

            closeDialog();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('MembersMenuController', MembersMenuController);

    /** @ngInject */
    function MembersMenuController($document, $mdDialog, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.newMemberSearchInput = '';

        // Methods
        vm.addNewMember = addNewMember;
        vm.removeMember = removeMember;

        ////////

        /**
         * Add New Member
         */
        function addNewMember()
        {
            // Add new member
        }

        /**
         * Remove member
         *
         * @param ev
         * @param memberId
         */
        function removeMember(ev, memberId)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove Member',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove member?',
                ariaLabel          : 'remove member',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });

            $mdDialog.show(confirm).then(function ()
            {
                var arr = vm.board.members;
                arr.splice(arr.indexOf(arr.getById(memberId)), 1);

                angular.forEach(vm.board.cards, function (card)
                {
                    if ( card.idMembers && card.idMembers.indexOf(memberId) > -1 )
                    {
                        card.idMembers.splice(card.idMembers.indexOf(memberId), 1);
                    }
                });
            }, function ()
            {
                // Canceled
            });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('LabelsMenuController', LabelsMenuController);

    /** @ngInject */
    function LabelsMenuController($document, $mdColorPalette, $mdDialog, fuseGenerator, msUtils, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.palettes = $mdColorPalette;
        vm.rgba = fuseGenerator.rgba;
        vm.hue = 500;
        vm.newLabelColor = 'red';
        vm.newLabelName = '';

        // Methods
        vm.addNewLabel = addNewLabel;
        vm.removeLabel = removeLabel;

        ////////

        /**
         * Add New Label
         */
        function addNewLabel()
        {
            vm.board.labels.push({
                id   : msUtils.guidGenerator(),
                name : vm.newLabelName,
                color: vm.newLabelColor
            });
            vm.newLabelName = '';
        }

        /**
         * Remove label
         *
         * @param ev
         * @param labelId
         */
        function removeLabel(ev, labelId)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove Label',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove label?',
                ariaLabel          : 'remove label',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });

            $mdDialog.show(confirm).then(function ()
            {
                var arr = vm.board.labels;
                arr.splice(arr.indexOf(arr.getById(labelId)), 1);

                angular.forEach(vm.board.cards, function (card)
                {
                    if ( card.idLabels && card.idLabels.indexOf(labelId) > -1 )
                    {
                        card.idLabels.splice(card.idLabels.indexOf(labelId), 1);
                    }
                });
            }, function ()
            {
                // Canceled
            });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ColorMenuController', ColorMenuController);

    /** @ngInject */
    function ColorMenuController($mdColorPalette, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.palettes = $mdColorPalette;

        // Methods

        ////////

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('CalendarViewController', CalendarViewController);

    /** @ngInject */
    function CalendarViewController($scope, $document, $mdDialog, $mdSidenav, BoardService, DialogService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.eventSources = [];

        vm.calendarUiConfig = {
            calendar: {
                editable                 : true,
                eventLimit               : true,
                header                   : '',
                handleWindowResize       : false,
                aspectRatio              : 1,
                dayNames                 : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                dayNamesShort            : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                timezone                 : 'local',
                eventDurationEditable    : false,
                defaultTimedEventDuration: '01:00:00',
                viewRender               : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                },
                columnFormat             : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd D'
                },
                eventClick               : function eventDetail(calendarEvent, ev)
                {
                    vm.openCardDialog(ev, calendarEvent.idCard);
                },
                eventDrop                : function (event)
                {
                    vm.board.cards.getById(event.idCard).due = moment.utc(event.start).format('x');
                },
                selectable               : true,
                selectHelper             : true,
                dayClick                 : function (date, ev)
                {
                    var offset = moment().utcOffset();
                    var corrDate = '';

                    if ( offset < 0 )
                    {
                        corrDate = moment.utc(date).subtract(offset, 'm').format('x');
                    }
                    else
                    {
                        corrDate = moment.utc(date).add(offset, 'm').format('x');
                    }

                    eventDialog(corrDate, ev);
                }
            }
        };

        // Methods
        vm.next = next;
        vm.prev = prev;
        vm.goToDate = goToDate;
        vm.openCardDialog = DialogService.openCardDialog;
        vm.toggleSidenav = toggleSidenav;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            vm.cards = getScheduledCards();
            vm.eventSources[0] = vm.cards;
        }

        /**
         * Get scheduled cards and prepare
         * them to show on the calendar
         *
         * @returns {Array}
         */
        function getScheduledCards()
        {
            var cards = [];

            angular.forEach(vm.board.cards, function (card)
            {
                if ( card.due )
                {
                    cards.push({
                        idCard         : card.id,
                        title          : card.name,
                        start          : moment.utc(card.due, 'x'),
                        due            : card.due,
                        backgroundColor: getEventBgColor(card.due)
                    });
                }
            });

            return cards;
        }

        /**
         * Get background color
         *
         * @param cardDue
         * @returns {*}
         */
        function getEventBgColor(cardDue)
        {
            if ( moment() > moment(cardDue, 'x') )
            {
                return '#F44336';
            }

            return '#4CAF50';
        }

        /**
         * Watch board changes
         */
        $scope.$watch('vm.board', function (current, old)
        {
            if ( angular.equals(current, old) )
            {
                return;
            }

            init();

        }, true);

        /**
         * Go to Date
         *
         * @param date
         */
        function goToDate(date)
        {
            vm.calendarView.calendar.gotoDate(date);
            $mdSidenav('scheduled-tasks-sidenav').close();
        }

        /**
         * Go to next on current view (week, month etc.)
         */
        function next()
        {
            vm.calendarView.calendar.next();
        }

        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev()
        {
            vm.calendarView.calendar.prev();
        }

        /**
         * Event Dialog
         */
        function eventDialog(date, ev)
        {
            $mdDialog.show({
                templateUrl        : 'app/main/apps/scrumboard/views/calendar/dialogs/event/event-dialog.html',
                controller         : 'ScrumboardCalendarEventDialogController',
                controllerAs       : 'vm',
                parent             : $document.find('#scrumboard'),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    dueDate: date
                }
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('BoardsViewController', BoardsViewController);

    /** @ngInject */
    function BoardsViewController(BoardList)
    {
        var vm = this;

        // Data
        vm.boardList = BoardList.data;

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('BoardViewController', BoardViewController);

    /** @ngInject */
    function BoardViewController($document, $window, $timeout, $mdDialog, msUtils, BoardList, BoardService, CardFilters, DialogService)
    {
        var vm = this;

        // Data
        vm.currentView = 'board';
        vm.board = BoardService.data;
        vm.boardList = BoardList.data;
        vm.cardFilters = CardFilters;
        vm.card = {};
        vm.cardOptions = {};
        vm.newListName = '';
        vm.sortableListOptions = {
            axis       : 'x',
            delay      : 75,
            distance   : 7,
            items      : '> .list-wrapper',
            handle     : '.list-header',
            placeholder: 'list-wrapper list-sortable-placeholder',
            tolerance  : 'pointer',
            start      : function (event, ui)
            {
                var width = ui.item[0].children[0].clientWidth;
                var height = ui.item[0].children[0].clientHeight;
                ui.placeholder.css({
                    'min-width': width + 'px',
                    'width'    : width + 'px',
                    'height'   : height + 'px'
                });
            }
        };
        vm.sortableCardOptions = {
            appendTo            : 'body',
            connectWith         : '.list-cards',
            delay               : 75,
            distance            : 7,
            forceHelperSize     : true,
            forcePlaceholderSize: true,
            handle              : msUtils.isMobile() ? '.list-card-sort-handle' : false,
            helper              : function (event, el)
            {
                return el.clone().addClass('list-card-sort-helper');
            },
            placeholder         : 'list-card card-sortable-placeholder',
            tolerance           : 'pointer',
            scroll              : true,
            sort                : function (event, ui)
            {
                var listContentEl = ui.placeholder.closest('.list-content');
                var boardContentEl = ui.placeholder.closest('#board');

                if ( listContentEl )
                {
                    var listContentElHeight = listContentEl[0].clientHeight,
                        listContentElScrollHeight = listContentEl[0].scrollHeight;

                    if ( listContentElHeight !== listContentElScrollHeight )
                    {
                        var itemTop = ui.position.top,
                            itemBottom = itemTop + ui.item.height(),
                            listTop = listContentEl.offset().top,
                            listBottom = listTop + listContentElHeight;

                        if ( itemTop < listTop + 25 )
                        {
                            listContentEl.scrollTop(listContentEl.scrollTop() - 25);
                        }

                        if ( itemBottom > listBottom - 25 )
                        {
                            listContentEl.scrollTop(listContentEl.scrollTop() + 25);
                        }
                    }
                }

                if ( boardContentEl )
                {
                    var boardContentElWidth = boardContentEl[0].clientWidth;
                    var boardContentElScrollWidth = boardContentEl[0].scrollWidth;

                    if ( boardContentElWidth !== boardContentElScrollWidth )
                    {
                        var itemLeft = ui.position.left,
                            itemRight = itemLeft + ui.item.width(),
                            boardLeft = boardContentEl.offset().left,
                            boardRight = boardLeft + boardContentElWidth;

                        if ( itemLeft < boardLeft + 25 )
                        {
                            boardContentEl.scrollLeft(boardContentEl.scrollLeft() - 25);
                        }

                        if ( itemRight > boardRight )
                        {
                            boardContentEl.scrollLeft(boardContentEl.scrollLeft() + 25);
                        }
                    }
                }
            }
        };

        // Methods
        vm.openCardDialog = DialogService.openCardDialog;
        vm.addNewList = addNewList;
        vm.removeList = removeList;
        vm.cardFilter = cardFilter;
        vm.isOverdue = isOverdue;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {

            $timeout(function ()
            {
                // IE list-content max-height hack
                if ( angular.element('html').hasClass('explorer') )
                {
                    // Calculate the height for the first time
                    calculateListContentHeight();

                    // Attach calculateListContentHeight function to window resize
                    $window.onresize = function ()
                    {
                        calculateListContentHeight();
                    };
                }
            }, 0);

        }

        /**
         * IE ONLY
         * Calculate the list-content height
         * IE ONLY
         */
        function calculateListContentHeight()
        {
            var boardEl = angular.element('#board');
            var boardElHeight = boardEl.height();

            boardEl.find('.list-wrapper').each(function (index, el)
            {
                // Get the required heights for calculations
                var listWrapperEl = angular.element(el),
                    listHeaderElHeight = listWrapperEl.find('.list-header').height(),
                    listFooterElHeight = listWrapperEl.find('.list-footer').height();

                // Calculate the max height
                var maxHeight = boardElHeight - listHeaderElHeight - listFooterElHeight;

                // Add the max height
                listWrapperEl.find('.list-content').css({'max-height': maxHeight});
            });
        }

        /**
         * Add new list
         */
        function addNewList()
        {
            if ( vm.newListName === '' )
            {
                return;
            }

            vm.board.lists.push({
                id     : msUtils.guidGenerator(),
                name   : vm.newListName,
                idCards: []
            });

            vm.newListName = '';
        }

        /**
         * Remove list
         *
         * @param ev
         * @param list
         */
        function removeList(ev, list)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove List',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove list?',
                ariaLabel          : 'remove list',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });
            $mdDialog.show(confirm).then(function ()
            {
                vm.board.lists.splice(vm.board.lists.indexOf(list), 1);
            }, function ()
            {
                // Canceled
            });

        }

        /**
         * Card filter
         *
         * @param cardId
         * @returns {*}
         */
        function cardFilter(cardId)
        {
            var card = vm.board.cards.getById(cardId);

            try
            {
                if ( angular.lowercase(card.name).indexOf(angular.lowercase(vm.cardFilters.name)) < 0 )
                {
                    throw false;
                }

                angular.forEach(vm.cardFilters.labels, function (label)
                {
                    if ( !msUtils.exists(label, card.idLabels) )
                    {
                        throw false;
                    }
                });

                angular.forEach(vm.cardFilters.members, function (member)
                {
                    if ( !msUtils.exists(member, card.idMembers) )
                    {
                        throw false;
                    }
                });


            } catch ( err )
            {
                return err;
            }

            return true;
        }

        /**
         * Is the card overdue?
         *
         * @param cardDate
         * @returns {boolean}
         */
        function isOverdue(cardDate)
        {
            return moment() > moment(cardDate, 'x');
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('SettingsSidenavController', SettingsSidenavController);

    /** @ngInject */
    function SettingsSidenavController($mdColorPalette, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.palettes = $mdColorPalette;
        vm.selectedMenu = 'Settings';

        // Methods

        ////////

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('FiltersSidenavController', FiltersSidenavController);

    /** @ngInject */
    function FiltersSidenavController(msUtils, BoardService, CardFilters)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.cardFilters = CardFilters;
        vm.labels = vm.board.labels;
        vm.members = vm.board.members;
        vm.selectedMenu = 'Settings';

        // Methods
        vm.exists = msUtils.exists;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.clearFilters = CardFilters.clear;
        vm.filteringIsOn = CardFilters.isOn;

        ////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('msSbAddCardController', msSbAddCardController)
        .directive('msSbAddCard', msSbAddCardDirective);

    /** @ngInject */
    function msSbAddCardController($scope, $timeout, BoardService, msUtils)
    {
        var vm = this;

        vm.newCardName = '';
        vm.listId = $scope.msListId;
        vm.board = BoardService.data;
        vm.cards = vm.board.cards;
        vm.list = vm.board.lists.getById(vm.listId);

        // Methods
        vm.addNewCard = addNewCard;

        /////

        /**
         * Add New Card
         */
        function addNewCard()
        {
            if ( vm.newCardName === '' )
            {
                return;
            }

            var newCardId = msUtils.guidGenerator();

            vm.cards.push({
                id               : newCardId,
                name             : vm.newCardName,
                description      : '',
                idAttachmentCover: '',
                idMembers        : [],
                idLabels         : [],
                attachments      : [],
                subscribed       : false,
                checklists       : [],
                checkItems       : 0,
                checkItemsChecked: 0,
                comments         : [],
                activities       : [],
                due              : null
            });

            vm.list.idCards.push(newCardId);

            $timeout(function ()
            {
                $scope.scrollListContentBottom();
            });

            vm.newCardName = '';
        }
    }

    /** @ngInject */
    function msSbAddCardDirective($document, $window, $timeout)
    {
        return {
            restrict   : 'E',
            controller : 'msSbAddCardController as vm',
            templateUrl: 'app/main/apps/scrumboard/directives/ms-sb-add-card/ms-sb-add-card.html',
            scope      : {
                msListId: '='
            },
            link       : function (scope, iElement)
            {
                scope.formActive = false;
                scope.toggleForm = toggleForm;
                scope.scrollListContentBottom = scrollListContentBottom;

                var buttonEl = iElement.find('.ms-sb-add-card-button'),
                    formEl = iElement.find('.ms-sb-add-card-form'),
                    listCards = iElement.parent().prev().find('.list-cards');

                /**
                 * Click Event
                 */
                buttonEl.on('click', toggleForm);

                /**
                 * Toggle Form
                 */
                function toggleForm()
                {
                    scope.$evalAsync(function ()
                    {
                        scope.formActive = !scope.formActive;

                        if ( scope.formActive )
                        {
                            $timeout(function ()
                            {
                                formEl.find('input').focus();

                                scrollListContentBottom();
                            });

                            $document.on('click', outSideClick);
                        }
                        else
                        {
                            PerfectScrollbar.update(listCards[0]);
                            $document.off('click', outSideClick);
                        }

                        $timeout(function ()
                        {
                            // IE list-content max-height hack
                            if ( angular.element('html').hasClass('explorer') )
                            {
                                angular.element($window).trigger('resize');
                            }
                        });

                    });
                }

                /**
                 * Scroll List to the Bottom
                 */
                function scrollListContentBottom()
                {
                    listCards[0].scrollTop = listCards[0].scrollHeight;
                }

                /**
                 * Click Outside Event Handler
                 * @param event
                 */
                var outSideClick = function (event)
                {
                    var isChild = formEl.has(event.target).length > 0;
                    var isSelf = formEl[0] === event.target;
                    var isInside = isChild || isSelf;

                    if ( !isInside )
                    {
                        toggleForm();
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ScrumboardCardDialogController', ScrumboardCardDialogController);

    /** @ngInject */
    function ScrumboardCardDialogController($document, $mdDialog, fuseTheming, fuseGenerator, msUtils, BoardService, cardId)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.card = vm.board.cards.getById(cardId);
        vm.newLabelColor = 'red';
        vm.members = vm.board.members;
        vm.labels = vm.board.labels;

        // Methods
        vm.palettes = fuseTheming.getRegisteredPalettes();
        vm.rgba = fuseGenerator.rgba;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.closeDialog = closeDialog;
        vm.getCardList = getCardList;
        vm.removeCard = removeCard;
        /* Attachment */
        vm.toggleCoverImage = toggleCoverImage;
        vm.removeAttachment = removeAttachment;
        /* Labels */
        vm.labelQuerySearch = labelQuerySearch;
        vm.filterLabel = filterLabel;
        vm.addNewLabel = addNewLabel;
        vm.removeLabel = removeLabel;
        /* Members */
        vm.memberQuerySearch = memberQuerySearch;
        vm.filterMember = filterMember;
        /* Checklist */
        vm.updateCheckedCount = updateCheckedCount;
        vm.addCheckItem = addCheckItem;
        vm.removeChecklist = removeChecklist;
        vm.removeChecklistItem = removeChecklistItem;
        vm.createCheckList = createCheckList;
        /* Comment */
        vm.addNewComment = addNewComment;

        //////////

        /**
         * Close Dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Get Card List
         */
        function getCardList()
        {
            var response;
            for ( var i = 0, len = vm.board.lists.length; i < len; i++ )
            {
                if ( vm.board.lists[i].idCards.indexOf(vm.card.id) > -1 )
                {
                    response = vm.board.lists[i];
                    break;
                }
            }
            return response;
        }

        /**
         * Remove card
         *
         * @param ev
         */
        function removeCard(ev)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove Card',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove card?',
                ariaLabel          : 'remove card',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });

            $mdDialog.show(confirm).then(function ()
            {
                var cardList = getCardList();

                cardList.idCards.splice(cardList.idCards.indexOf(vm.card.id), 1);

                vm.board.cards.splice(vm.board.cards.indexOf(vm.card), 1);

            }, function ()
            {
                // Canceled
            });
        }

        /**
         * Toggle cover image
         *
         * @param attachmentId
         */
        function toggleCoverImage(attachmentId)
        {
            if ( attachmentId === vm.card.idAttachmentCover )
            {
                vm.card.idAttachmentCover = null;
            }
            else
            {
                vm.card.idAttachmentCover = attachmentId;
            }
        }

        /**
         * Remove attachment
         *
         * @param item
         */
        function removeAttachment(item)
        {
            if ( vm.card.idAttachmentCover === item.id )
            {
                vm.card.idAttachmentCover = '';
            }
            vm.card.attachments.splice(vm.card.attachments.indexOf(item), 1);
        }

        /**
         * Add label chips
         *
         * @param query
         * @returns {filterFn}
         */
        function labelQuerySearch(query)
        {
            return query ? vm.labels.filter(createFilterFor(query)) : [];
        }

        /**
         * Label filter
         *
         * @param label
         * @returns {boolean}
         */
        function filterLabel(label)
        {
            if ( !vm.labelSearchText || vm.labelSearchText === '' )
            {
                return true;
            }

            return angular.lowercase(label.name).indexOf(angular.lowercase(vm.labelSearchText)) >= 0;
        }

        /**
         * Add new label
         */
        function addNewLabel()
        {
            vm.board.labels.push({
                id   : msUtils.guidGenerator(),
                name : vm.newLabelName,
                color: vm.newLabelColor
            });

            vm.newLabelName = '';
        }

        /**
         * Remove label
         */
        function removeLabel()
        {
            var arr = vm.board.labels;
            arr.splice(arr.indexOf(arr.getById(vm.editLabelId)), 1);

            angular.forEach(vm.board.cards, function (card)
            {
                if ( card.idLabels && card.idLabels.indexOf(vm.editLabelId) > -1 )
                {
                    card.idLabels.splice(card.idLabels.indexOf(vm.editLabelId), 1);
                }
            });

            vm.newLabelName = '';
        }

        /**
         * Add member chips
         *
         * @param query
         * @returns {Array}
         */
        function memberQuerySearch(query)
        {
            return query ? vm.members.filter(createFilterFor(query)) : [];
        }

        /**
         * Member filter
         *
         * @param member
         * @returns {boolean}
         */
        function filterMember(member)
        {
            if ( !vm.memberSearchText || vm.memberSearchText === '' )
            {
                return true;
            }

            return angular.lowercase(member.name).indexOf(angular.lowercase(vm.memberSearchText)) >= 0;
        }

        /**
         * Update check list stats
         * @param list
         */
        function updateCheckedCount(list)
        {
            var checkItems = list.checkItems;
            var checkedItems = 0;
            var allCheckedItems = 0;
            var allCheckItems = 0;

            angular.forEach(checkItems, function (checkItem)
            {
                if ( checkItem.checked )
                {
                    checkedItems++;
                }
            });

            list.checkItemsChecked = checkedItems;

            angular.forEach(vm.card.checklists, function (item)
            {
                allCheckItems += item.checkItems.length;
                allCheckedItems += item.checkItemsChecked;
            });

            vm.card.checkItems = allCheckItems;
            vm.card.checkItemsChecked = allCheckedItems;
        }

        /**
         * Add checklist item
         *
         * @param text
         * @param checkList
         */
        function addCheckItem(text, checkList)
        {
            if ( !text || text === '' )
            {
                return;
            }

            var newCheckItem = {
                'name'   : text,
                'checked': false
            };

            checkList.checkItems.push(newCheckItem);

            updateCheckedCount(checkList);
        }

        /**
         * Remove checklist
         *
         * @param item
         */
        function removeChecklist(item)
        {
            vm.card.checklists.splice(vm.card.checklists.indexOf(item), 1);

            angular.forEach(vm.card.checklists, function (list)
            {
                updateCheckedCount(list);
            });
        }

        /**
         * Remove checklist Item
         *
         * @param item
         */
        function removeChecklistItem(item, list)
        {
            list.splice(list.indexOf(item), 1);

            angular.forEach(vm.card.checklists, function (list)
            {
                updateCheckedCount(list);
            });
        }

        /**
         * Create checklist
         */
        function createCheckList()
        {
            vm.card.checklists.push({
                id               : msUtils.guidGenerator(),
                name             : vm.newCheckListTitle,
                checkItemsChecked: 0,
                checkItems       : []
            });

            vm.newCheckListTitle = '';
        }

        /**
         * Add new comment
         *
         * @param newCommentText
         */
        function addNewComment(newCommentText)
        {
            var newComment = {
                idMember: '36027j1930450d8bf7b10158',
                message : newCommentText,
                time    : 'now'
            };

            vm.card.comments.unshift(newComment);
        }

        /**
         * Filter for chips
         *
         * @param query
         * @returns {filterFn}
         */
        function createFilterFor(query)
        {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(item)
            {
                return angular.lowercase(item.name).indexOf(lowercaseQuery) >= 0;
            };
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .factory('CardFilters', CardFiltersService);

    /** @ngInject */
    function CardFiltersService()
    {
        var service = {
            name   : '',
            labels : [],
            members: [],
            clear  : clear,
            isOn   : isOn
        };

        /**
         * Clear
         */
        function clear()
        {
            service.name = '';
            service.labels = [];
            service.members = [];
        }

        /**
         * Is on
         *
         * @returns {boolean}
         */
        function isOn()
        {
            return (service.name === '' && service.labels.length === 0 && service.members.length === 0 ) ? false : true;
        }

        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .factory('DialogService', DialogService);

    /** @ngInject */
    function DialogService($mdDialog, $document)
    {
        var service = {
            openCardDialog: openCardDialog
        };

        //////////

        /**
         * Open card dialog
         *
         * @param ev
         * @param cardId
         */
        function openCardDialog(ev, cardId)
        {
            $mdDialog.show({
                templateUrl        : 'app/main/apps/scrumboard/dialogs/card/card-dialog.html',
                controller         : 'ScrumboardCardDialogController',
                controllerAs       : 'vm',
                parent             : $document.find('#scrumboard'),
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                locals             : {
                    cardId: cardId
                }
            });
        }

        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .factory('BoardService', BoardService);

    /** @ngInject */
    function BoardService($q, msApi)
    {
        var service = {
            data        : {},
            addNewBoard : addNewBoard,
            getBoardData: getBoardData
        };

        /**
         * Get board data from the server
         *
         * @param boardId
         * @returns {*}
         */
        function getBoardData(boardId)
        {
            // Create a new deferred object
            var deferred = $q.defer();

            msApi.request('scrumboard.board@get', {id: boardId},

                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the promise
                    deferred.resolve(response);
                },

                // ERROR
                function (response)
                {
                    // Reject the promise
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        /**
         * Create an empty board object and set it.
         *
         * For the demonstration purposes, we are creating the
         * empty object in the javascript which you wouldn't do
         * it in real life. Rather, you would make an API call
         * to your server to generate an empty object that fills
         * some of the areas for you like an ID, labels, members
         * or the default board settings.
         *
         * Then you would grab the response that comes from
         * the API call and attach it to the service.data object.
         */
        function addNewBoard()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Here you would make an API call to your server...
            _generateEmptyScrumboardObject().then(
                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the response
                    deferred.resolve(response);
                },
                // ERROR
                function (response)
                {
                    // Reject the response
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        /**
         * Dummy function for generating an empty
         * scrumboard object for demonstration
         * purposes
         *
         * @private
         * returns {$promise}
         */
        function _generateEmptyScrumboardObject()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Fake id generator
            var id = parseInt(new Date().valueOf(), 16);

            // Prepare an empty scrumboard object
            var emptyObject = {
                data: {
                    name    : 'Untitled Board',
                    uri     : 'untitled-board',
                    id      : id,
                    settings: {
                        color          : '',
                        subscribed     : false,
                        cardCoverImages: true
                    },
                    lists   : [],
                    cards   : [],
                    members : [
                        {
                            id    : '56027c1930450d8bf7b10758',
                            name  : 'Alice Freeman',
                            avatar: 'assets/images/avatars/alice.jpg'
                        },
                        {
                            id    : '26027s1930450d8bf7b10828',
                            name  : 'Danielle Obrien',
                            avatar: 'assets/images/avatars/danielle.jpg'
                        },
                        {
                            id    : '76027g1930450d8bf7b10958',
                            name  : 'James Lewis',
                            avatar: 'assets/images/avatars/james.jpg'
                        },
                        {
                            id    : '36027j1930450d8bf7b10158',
                            name  : 'Vincent Munoz',
                            avatar: 'assets/images/avatars/vincent.jpg'
                        }
                    ],
                    labels  : [
                        {
                            id   : '26022e4129ad3a5sc28b36cd',
                            name : 'High Priority',
                            color: 'red'
                        },
                        {
                            id   : '56027e4119ad3a5dc28b36cd',
                            name : 'Design',
                            color: 'orange'
                        },
                        {
                            id   : '5640635e19ad3a5dc21416b2',
                            name : 'App',
                            color: 'blue'
                        },
                        {
                            id   : '6540635g19ad3s5dc31412b2',
                            name : 'Feature',
                            color: 'green'
                        }
                    ]
                }
            };

            // Resolve the promise
            deferred.resolve(emptyObject);

            return deferred.promise;
        }

        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.scheduling', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        console.log("scheduling module");
        $stateProvider
          .state('app.scheduling', {
              url      : '/Scheduling/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/scheduling/scheduling.html',
                      controller : 'SchedulingController as vm'
                  }
              },
              resolve  : {
                  Scheduling: function (api, $stateParams)
                  {
                      return api.scheduling.get({ id: $stateParams.id }).$promise;
                  },
                  SchedulingEmail: function (api, $stateParams)
                  {
                      return api.schedulingemail.get({ id: $stateParams.id }).$promise;
                  }
              },
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/scheduling');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.scheduling')
        .controller('SchedulingController', SchedulingController);

    function SchedulingController($scope, $document, $mdToast, $state, api, Scheduling, SchedulingEmail,$window, $translate, $mdDialog, localStorageService)
    {
        console.log("Scheduling");

        var vm = this;    
        vm.caixaedicao = 0;
    
        vm.gotoScheduling = gotoScheduling;

        function gotoScheduling()
        {
            console.log('go Scheduling');
            $state.go('app.scheduling');
        }

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg) {
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');

            $mdToast.show(toast);
        }        

        vm.schedules = Scheduling.records;
        vm.schedulesemails = SchedulingEmail.records;

        vm.cancel = function()
        {
            vm.caixaedicao = 0;
            vm.schedule = [];
            vm.scheduleemails = [];
            vm.schemail = [];
        }

        vm.deleteExistSchedule = function(ev, id) {
          var confirm = $mdDialog.confirm(
                    /* Este código seguinte só é preciso para mudar a cor ao botão (para vermelho para remover, por ex.) */
                    {
                        onComplete: function afterShowAnimation() {
                            var $dialog = angular.element(document.querySelector('md-dialog'));
                            var $actionsSection = $dialog.find('md-dialog-actions');
                            var $cancelButton = $actionsSection.children()[0];
                            var $confirmButton = $actionsSection.children()[1];
                            angular.element($confirmButton).addClass('md-raised md-warn');
                            angular.element($cancelButton).addClass('md-primary');
                        }
                    }
                )
                .title('Are you sure?')
                .textContent('Please confirm if you would like to remove this schedule.')
                .ariaLabel('Remove confirm box')
                .targetEvent(ev)
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('Yes, Remove!')
                .cancel('No, Cancel');
          $mdDialog.show(confirm).then(function() {
                console.log(id);
                deleteSchedule(id);
          }, function() {
            /* If Cancel... */
          });
        };

        vm.schemail = [];

        vm.addEmail = function(id){
            if(id!=0){
               console.log(vm.scheduleemails);
                vm.scheduleemails.push({
                            scheduling_email_id:0,
                            email:vm.novoemail
                            });
                vm.novoemail = '';               
                console.log(vm.scheduleemails);
            }else{
                console.log(vm.schemail);
                 vm.schemail.push({
                            scheduling_email_id:0,
                            email:vm.novoemail
                            });
                vm.novoemail = '';
                console.log(vm.schemail);                
            }
        }        

        vm.saveSchedule = function(record)
        {       
           console.log("saveSchedule...");   
            var msg = 'Schedule saved sucessfully!';
            if(vm.scheduleemails){
                record.emails = vm.scheduleemails;
            }else{
                record.emails = vm.schemail;   
            }
            api.scheduling.save({ record: record }).$promise.then(function (result) {
                delete record.emails;
                if(record.scheduling_id == 0){
                    vm.schedules.push(record);      
                }
                record.scheduling_id = result.id;                                          
                if(vm.scheduleemails){ // If editing an existing Scheduling...
                    vm.scheduleemails.forEach(function(nscheduleemails) {
                        if(!nscheduleemails.scheduling_email_id){
                            nscheduleemails.scheduling_email_id = 0;
                        }
                        // if(result.id){
                        //     nscheduleemails.scheduling_id = result.id;
                        // }else{
                        nscheduleemails.scheduling_id = record.scheduling_id;
                        // }
                        delete nscheduleemails['$$hashKey'];
                        api.schedulingemail.save({record: nscheduleemails}).$promise.then(function (result2) {
                            if(result2.id){ // If new email
                                var emid = result2.id;
                                console.log("Result2:" + emid);
                                console.log("Antes nscheduleemails:");
                                console.log(nscheduleemails);
                                nscheduleemails.scheduling_email_id = emid;
                                delete nscheduleemails['$$hashKey'];
                                console.log("Depois nscheduleemails:");
                                console.log(nscheduleemails);
                                vm.schedulesemails.push(nscheduleemails);
                                console.log("Todos:");                                
                                console.log(vm.schedulesemails);
                            }
                        });
                    });
                }else{ // If creating an new Scheduling...
                    vm.schemail.forEach(function(nschemail) {
                        if(!nschemail.scheduling_email_id){
                            nschemail.scheduling_email_id = 0;
                        }
                        nschemail.scheduling_id = result.id;
                        delete nschemail['$$hashKey'];
                        console.log(nschemail);
                        api.schedulingemail.save({record: nschemail}).$promise.then(function (result3) {
                            if(result3.id){ // If new email
                                var emid = result3.id;
                                nschemail.scheduling_email_id = emid;
                                delete nschemail['$$hashKey'];
                                vm.schedulesemails.push(nschemail);
                            }
                        });
                    });
                }
                vm.cancel();                    
                showToast(msg);                                              
            });
        }

        vm.editSchedule = function(id){
            vm.caixaedicao = 1;           
            api.scheduling.query({ id: id }).$promise.then(function (result) {
                vm.schedule = result.record;
                console.log(vm.schedule);
            });   
            api.schedulingemail.query({ id: id }).$promise.then(function (result) {
                vm.scheduleemails = result.record;
                console.log(vm.scheduleemails);    
            });
        }

        var deleteSchedule = function(id){
            console.log("Delete Schedule");
            var msg = "Schedule were deleted sucessfully.";
            api.scheduling.delete({id: id}).$promise.then(function (result) {
                api.schedulingemail.deleteall({id: id});
                vm.schedules = vm.schedules.filter(function( obj ) {
                    return obj.scheduling_id !== id;
                });               
                showToast(msg);
                vm.cancel();                               
            });       
        }

        vm.deleteInviteEmail = function(id, email){
            console.log("deleteInviteEmail");
            if(id!=0){            
                api.schedulingemail.delete({id: id}).$promise.then(function (result) {                
                });
            }
            if(vm.scheduleemails){
                vm.scheduleemails = vm.scheduleemails.filter(function( obj ) {
                    return obj.email !== email;
                });
                vm.schedulesemails = vm.schedulesemails.filter(function( obj ) {
                    return obj.email !== email;
                });
                console.log(vm.scheduleemails);
            }else{       
                vm.schemail = vm.schemail.filter(function( obj ) {
                    return obj.email !== email;
                }); 
                vm.schedulesemails = vm.schedulesemails.filter(function( obj ) {
                    return obj.email !== email;
                });                                                 
                console.log(vm.schemail);
            }
            var msg = "Invite E-mail deleted sucessfully.";
            showToast(msg);                   
        }


    }
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.researchd', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.researchd', {
              url      : '/researchd/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/researchd/researchd.html',
                      controller : 'RDController as vm'
                  }
              },
              resolve  : {
                  Marketing: function (api, $stateParams)
                  {
                    return api.marketing.get({id: "rd"}).$promise;
                  }
              },            
              bodyClass: 'researchd-app'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/researchd');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.researchd')
        .controller('RDController', RDController);

    function RDController($scope, $document, $mdToast, $state, api, $window, $translate, $mdDialog, localStorageService,CONFIG,Marketing)
    {
        console.log("RDController");

        var vm = this;

        vm.userid = localStorageService.get('userid');
        vm.username = localStorageService.get('username');
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
        }
        vm.admin = localStorageService.get('admin');
        vm.levelid = localStorageService.get('levelid');
    
        vm.disabled = false;
    
        /* Verifica se tem permissões de ver e/ou alterar conteúdos */
        if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || (vm.privileges[47].privileges.view != '1' && vm.privileges[47].privileges.view != '1')){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if((vm.privileges[47].privileges.edit == '0' || vm.privileges[47].privileges.edit == null || vm.privileges[47].privileges.edit == false) && (vm.privileges[47].privileges.view == '1' || vm.privileges[47].privileges.view == '1')){
                vm.disabled = true;
            }
        }

        vm.caixaedicao = 0;
        vm.caixaedicaomulti = 0;


        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg, state, error) {
            if (typeof(state)==='undefined') state = true;
            if(state == true){
            msg = msg + 'a success!';
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');
            }else if(state == "info"){
              var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(10000)
                .theme("orange")
                .position('top right');
            }else{
            if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
            if (typeof(error)!=='undefined') msg = error;
              var toast = $mdToast.simple()
                  .content(msg)
                  .highlightAction(true)
                  .hideDelay(3000)
                  .theme("error-toast")
                  .position('top right');              
            }
            $mdToast.show(toast); 
        }

        vm.cards = Marketing.record;
        /*console.log("vm.cards");
        console.log(vm.cards);*/

        vm.emails = [];
        
        vm.addEmail = function(){
            vm.emails.push(vm.novoemail); 
            /*console.log(vm.emails);*/
            vm.novoemail = undefined;           
        }

        vm.deleteInviteEmail = function(email){
            console.log("deleteInviteEmail");
            vm.emails = vm.emails.filter(function( obj ) {
                return obj !== email;
            });
            /*console.log(vm.emails);*/
        }

        vm.reset = function(){
            vm.search = [];
        }

        vm.changeCompleteStatus = function(id,completed){
            var record = {
                marketing_id: id,
                completed: completed
            }          
            api.marketing.save({ record: record }).$promise.then(function (result) {
                console.log(result); 
                var msg = "Completed change status was ";
                if(result.status !== 'success'){ 
                    showToast(msg, false); 
                }else{
                    showToast(msg);                      
                }                
            }, function(error) {
                var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                showToast(msg, false, erro);
                }); 
  
        }

        vm.saveMarketing = function(record)
        {          
           console.log("saveMarketing...");
           console.log(record);
           record.emails = vm.emails;
           var msg = 'New event or task insertion was ';
            api.marketing.save({ record: record }).$promise.then(function (result) {
                console.log(result);
                if(result.status == "success"){                   
                    showToast(msg);
                    vm.caixaedicao = 0;
                    vm.marketing = undefined;
                    record.marketing_id = result.id;
                    record.name = vm.username;
                    record.created_date = new Date();
                    vm.cards.push(record);
                    vm.cancel();
                }else{
                    showToast(msg, false);
                }                
          }, function(error) {
            var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
            showToast(msg, false, erro);
            }); 
        }       

        vm.cancel = function()
        {
            vm.caixaedicao = 0;
            vm.emails = [];
        }

        vm.deleteExistingMarketing = function(ev, id) {
            var confirm = $mdDialog.confirm(
                      /* Este código seguinte só é preciso para mudar a cor ao botão (para vermelho para remover, por ex.) */
                      {
                          onComplete: function afterShowAnimation() {
                              var $dialog = angular.element(document.querySelector('md-dialog'));
                              var $actionsSection = $dialog.find('md-dialog-actions');
                              var $cancelButton = $actionsSection.children()[0];
                              var $confirmButton = $actionsSection.children()[1];
                              angular.element($confirmButton).addClass('md-raised md-warn');
                              angular.element($cancelButton).addClass('md-primary');
                          }
                      }
                  )
                  .title('Are you sure?')
                  .textContent('Please confirm if you would like to remove this event/task.')
                  .ariaLabel('Remove confirm box')
                  .targetEvent(ev)
                  .clickOutsideToClose(true)
                  .parent(angular.element(document.body))
                  .ok('Yes, Remove!')
                  .cancel('No, Cancel');
            $mdDialog.show(confirm).then(function() {
                  console.log(id);
                  deleteMarketing(id);
            }, function() {
              /* If Cancel... */
            });
          };

          var deleteMarketing = function(id){
            console.log("Delete Marketing");
            var msg = "Event/Task were deletion was ";
            api.marketing.delete({id: id}).$promise.then(function (result) {
                if(result.status == "success"){
                    vm.cards = vm.cards.filter(function( obj ) {
                        return obj.marketing_id !== id;
                    });               
                    showToast(msg);
                }else{
                    showToast(msg, false);
                }                                               
            }, function(error) {
                var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                showToast(msg, false, erro);
                });       
        }
        
    }      
    
    RDController.$inject = ['$scope', '$document', '$mdToast', '$state', 'api', '$window', '$translate', '$mdDialog', 'localStorageService','CONFIG','Marketing'];  
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.reportsproducts', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.reportsproducts', {
              url      : '/reports/products/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/reportsproducts/reportsproducts.html',
                      controller : 'ReportsProductsController as vm'
                  }
              },
              resolve  : {               
                OrdersStatusTotal: function (api)
                  {
                  return api.orders.get({ id: 'orderstatus' }).$promise;
                  }
              },               
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/reportsproducts');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.reportsproducts')
        .controller('ReportsProductsController', ReportsProductsController)
        .factory('postService', function($http, CONFIG) {
            var postService = {
              async: function(controller, id, cache, params) {
                /* $http returns a promise, which has a then function, which also returns a promise */
                var promise = $http({
                  cache: cache,
                  method: 'POST',    
                  url: CONFIG.apiBaseUrl + controller + '/' + id,
                  data: params
                }).then(function (response) {
                  /* The then function here is an opportunity to modify the response */
                  console.log(response);
                  /* The return value gets picked up by the then in the controller. */
                  return response.data;
                });
                /* Return the promise to the controller */
                return promise;
              }
            };
            return postService;
          });

    function ReportsProductsController($scope, $document, $mdToast, $state, api, $window, $translate, $mdDialog, localStorageService, postService, DTOptionsBuilder, DTColumnBuilder, CONFIG, $location,OrdersStatusTotal)
    {
        console.log("Reports");

        var vm = this;

        vm.userid = localStorageService.get('userid');
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
        }
        vm.admin = localStorageService.get('admin');
        vm.levelid = localStorageService.get('levelid');
    
        /* Verifica se tem permissões de ver e/ou alterar conteúdos */
        if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || vm.privileges[31].privileges.view != '1'){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if((vm.privileges[31].privileges.edit == '0' || vm.privileges[31].privileges.edit == null || vm.privileges[31].privileges.edit == false) && vm.privileges[31].privileges.view == '1'){
                vm.disabled = true;
            }            
        }

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        vm.disabled = false;

        function showToast(msg, state, error) {
            if (typeof(state)==='undefined') state = true;
            if(state == true){
            msg = msg + 'a success!';
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');
            }else if(state == "info"){
              var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(10000)
                .theme("orange")
                .position('top right');
            }else{
            if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
            if (typeof(error)!=='undefined') msg = error;
              var toast = $mdToast.simple()
                  .content(msg)
                  .highlightAction(true)
                  .hideDelay(3000)
                  .theme("error-toast")
                  .position('top right');              
            }
            $mdToast.show(toast); 
        }

        vm.onstoporders = OrdersStatusTotal.onstoporders;        
        vm.dueorders = OrdersStatusTotal.dueorders;
        vm.approvedvia = OrdersStatusTotal.approvedvia;
        vm.approvedwaiting = OrdersStatusTotal.approvedwaiting;
        vm.waitingcall = OrdersStatusTotal.waitingcall;
        vm.waitingimpression = OrdersStatusTotal.waitingimpression;
        vm.inactiveorders = OrdersStatusTotal.inactiveorders;        
        vm.numcompleted = OrdersStatusTotal.numcompleted;

        vm.gotoOrderStatus = gotoOrderStatus;
        
        function gotoOrderStatus()
        {
            console.log('go OrderStatus');
            $state.go('app.orderstatus');
        }


        vm.openPage = function(page){
            console.log('go ' + page);
            $state.go('app.'+page);
        }

        /* Total Sales by Product */
        vm.dtInstance1 = {};
        var numcolunas1 = 7;

        vm.dtOptions1 = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'Reports/totalsperproduct',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas1; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search1"+i+";";
                    eval(f);
                    }
                    console.log(d);
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',false)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $('td', nRow).css('cursor', 'pointer');
                $('td', nRow).unbind('click');
                $('td', nRow).bind('click', function() {
                    $scope.$apply(function() {
                        console.log(aData['4']);
                        var productsid = aData['4'];
                        vm.openPopupOther(event, 'searchperproduct', productsid);
                        return nRow;
                        });                      
                    });
                })
            .withOption('order', [])        
            .withOption('initComplete', function(){
                /*var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;*/

                vm.searchTable1 = function(searchText, column){                
                    var f = "self.search1"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance1.DataTable.search(searchText).draw();
                }
                
                vm.reset = function(){                    
                    vm.search1 = [];
                    vm.search1.startDate = undefined;
                    vm.search1.endDate = undefined;
                    for (var i = 0; i < numcolunas1; ++i) {
                        var f = "self.search1"+i+" = undefined;";
                        eval(f);
                    }
                    vm.dtInstance1.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "sInfo": 'Info',
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns1 = [          
            DTColumnBuilder.newColumn(0).withTitle('Product Description'),
            DTColumnBuilder.newColumn(1).withTitle('Product Code'),
            DTColumnBuilder.newColumn(2).withTitle('Group Name'),
            DTColumnBuilder.newColumn(3).withTitle('Quantity'),       
            DTColumnBuilder.newColumn(4).withTitle('Products ID').notVisible(),
            DTColumnBuilder.newColumn(5).withTitle('Start Creation Date').notVisible(),
            DTColumnBuilder.newColumn(6).withTitle('End Creation Date').notVisible()
        ];

        /* FIM Total Sales by Product */

        /* Total Sales by GROUP */
        vm.dtInstance2 = {};
        var numcolunas2 = 4;

        vm.dtOptions2 = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'Reports/totalspergroup',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas2; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search2"+i+";";
                    eval(f);
                    }
                    console.log(d);
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',false)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $('td', nRow).css('cursor', 'pointer');
                $('td', nRow).unbind('click');
                $('td', nRow).bind('click', function() {
                    $scope.$apply(function() {
                        console.log(aData['3']);
                        var productsgroupsid = aData['3'];
                        vm.openPopupOther(event, 'searchpergroup', productsgroupsid);
                        return nRow;
                        });                      
                    });
                })
            .withOption('order', [])        
            .withOption('initComplete', function(){
                /*var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;*/

                vm.searchTable2 = function(searchText, column){                
                    var f = "self.search2"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance2.DataTable.search(searchText).draw();
                }
                
                vm.reset_pg = function(){                    
                    vm.search2 = [];
                    vm.search2.startDate = undefined;
                    vm.search2.endDate = undefined;
                    for (var i = 0; i < numcolunas2; ++i) {
                        var f = "self.search2"+i+" = undefined;";
                        eval(f);
                    }                   
                    vm.dtInstance2.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns2 = [           
            DTColumnBuilder.newColumn(0).withTitle('Group Name'),
            DTColumnBuilder.newColumn(1).withTitle('Product Code'),
            DTColumnBuilder.newColumn(2).withTitle('Sales'),       
            DTColumnBuilder.newColumn(3).withTitle('Products Groups ID').notVisible()
        ];

        /* FIM Total Sales by Group */

        vm.autoPrintPage = function(){
            html2canvas($("#pagina-reports"), {
                onrendered: function(canvas) {                    
                    var myImage = canvas.toDataURL("image/png");
                    var tWindow = window.open("");
                    $(tWindow.document.body)
                        .html("<img id='Image' src=" + myImage + " style='width:100%;'></img>")
                        .ready(function() {                            
                            tWindow.focus();
                            tWindow.print();
                        });
                }
            });
        }

        /* CQR - 05/10/2018 - Implementação Popup com Dados */

        vm.openPopupOther = function(ev, tipopopup, id) {                       
            $mdDialog.show({
              controller: eval("OtherController"),
              controllerAs: 'octrl',
              resolve: {
                popuptype: function () {
                  return {
                    'tipoPopup': tipopopup,
                    'id': id 
                  };
                }
              },
              templateUrl: 'app/main/pages/reportsproducts/others/'+tipopopup.toLowerCase()+'.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: $scope.customFullscreen 
            });
          };
  
          vm.openPopupOther.$inject = ['ev','tipopopup'];
  
          function createdRow(row, data, dataIndex) {
            $compile(angular.element(row).contents())($scope);
        }
  
          function OtherController($compile, $scope, $mdDialog, $http, popuptype, $timeout, CONFIG, DTOptionsBuilder,DTColumnBuilder,$location) {
              var self = this;
              self.id = popuptype.id;
  
              switch(popuptype.tipoPopup.toLowerCase()){                
                case 'searchperproduct':             
                case 'searchpergroup':
                  self.dtInstance = {};
                  var itemabrir = [];
                  var itemdata = {};          
  
                  if(popuptype.tipoPopup.toLowerCase() == "searchperproduct"){
                    var urlpost = CONFIG.apiBaseUrl + 'Orders/ordersperproduct';
                    var numcolumns = 11;
                    var tipo = "searchperproduct";
                  }
                  else if(popuptype.tipoPopup.toLowerCase() == "searchpergroup"){
                    var urlpost = CONFIG.apiBaseUrl + 'Orders/orderspergroup';
                    var numcolumns = 11;
                    var tipo = "searchpergroup";
                  }
  
                  self.dtOptions = DTOptionsBuilder.newOptions()
                  .withOption('ajax', {
                      url: urlpost,
                      type: 'POST',
                      "dataSrc": function(json) {
                        if(json.status && json.status == "login"){
                            $mdDialog.hide();
                            var infor = "Your login has expired. Please login again.";
                            showToast(infor, "info");
                            $location.path('/login');
                        }else{
                            console.log(json);
                            return json.data;
                        }
                      },
                      "data": function(d){
                        /*d.search['value'] = self.searchz;*/
                        for (var i = 0; i < numcolumns; ++i) {
                            var f = "d.columns["+i+"].search.value = self.search"+i+";";
                            eval(f);
                        }
                        d.id = self.id;                          
                      },
                      "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
                  })
                  .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
                  .withDataProp('data')
                  .withOption('processing', true)
                  .withOption('serverSide', true)
                  .withOption('filter', false)
                  .withOption('bLengthChange', true)
                  .withOption('bSort', false)
                  .withOption('responsive',false)
                  .withPaginationType('full_numbers')
                  .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $('td', nRow).css('cursor', 'pointer');
                    $('td', nRow).unbind('click');
                    $('td', nRow).bind('click', function() {
                        $scope.$apply(function() {
                          console.log(aData);                               
                        itemdata = {
                            orders_id: aData[0],
                            department_alias: aData[10],
                            departments_id: aData[9]
                            }
                            var verifica = 0;
                            angular.forEach(itemabrir, function(item) {
                            if(item.orders_id==aData[0]){
                                verifica = 1;                            
                                $(nRow).removeClass('highlitedRow');
                                itemabrir = itemabrir.filter(function( obj ) {return obj.orders_id !== aData[0]; });
                            } 
                            });
                            if(verifica == 0){
                            itemabrir.push(itemdata);
                            $(nRow).addClass('highlitedRow');
                            }
                        self.itemabrir = itemabrir;
                        console.log(self.itemabrir);
                        return nRow;                  
                        });
                    });
                  })
                  .withOption('createdRow', function(row) {
                    /* Recompiling so we can bind Angular directive to the DT */
                    $compile(angular.element(row).contents())($scope);
                })
                  .withOption('order', [])
                  .withOption('initComplete', function(){
                      var api = this.api();
      
                      self.totalRecords = api.page.info().recordsTotal;
                      self.totalRecordsFiltered = api.page.info().recordsDisplay;
  
                      self.searchTable = function(searchText, column){
                        var f = "self.search"+column+" = searchText;";
                        eval(f);
                        self.dtInstance.DataTable.search(searchText).draw();                  
                      } 
                      
                      self.reset = function(){                      
                        self.search = [];
                        self.startDate = undefined;
                        self.endDate = undefined;
                        self.onDate = undefined;
                        for (var i = 0; i < numcolumns; ++i) {
                        var f = "self.search"+i+" = undefined;";
                        eval(f);
                        }
                        self.dtInstance.reloadData(null, true);                      
                      }    
                      
                  })
                  .withLanguage({
                      "paginate": {
                          "first": 'First',
                          "last": 'Last',
                          "next": 'Next',
                          "previous": 'Previous'
                      }
                  });
  
                if(popuptype.tipoPopup.toLowerCase() == "searchperproduct"){  
                    self.dtColumns = [
                        DTColumnBuilder.newColumn(0).withTitle('Orders ID').notVisible(),
                        DTColumnBuilder.newColumn(1).withTitle('Order Number'),
                        DTColumnBuilder.newColumn(2).withTitle('Invoice Number'),
                        DTColumnBuilder.newColumn(3).withTitle('Client Name'),
                        DTColumnBuilder.newColumn(4).withTitle('Patient Name'),
                        DTColumnBuilder.newColumn(5).withTitle('Quantity'),
                        DTColumnBuilder.newColumn(6).withTitle('Date Completed'),
                        DTColumnBuilder.newColumn(7).withTitle('Date Completed').notVisible(),
                        DTColumnBuilder.newColumn(8).withTitle('Date Completed').notVisible(),
                        DTColumnBuilder.newColumn(9).withTitle('Departments ID').notVisible(),
                        DTColumnBuilder.newColumn(10).withTitle('Department Alias').notVisible()
                    ];
                }else if(popuptype.tipoPopup.toLowerCase() == "searchpergroup"){
                    self.dtColumns = [
                        DTColumnBuilder.newColumn(0).withTitle('Orders ID').notVisible(),
                        DTColumnBuilder.newColumn(1).withTitle('Order Number'),
                        DTColumnBuilder.newColumn(2).withTitle('Invoice Number'),
                        DTColumnBuilder.newColumn(3).withTitle('Client Name'),
                        DTColumnBuilder.newColumn(4).withTitle('Patient Name'),
                        DTColumnBuilder.newColumn(5).withTitle('Sales'),
                        DTColumnBuilder.newColumn(6).withTitle('Date Completed'),
                        DTColumnBuilder.newColumn(7).withTitle('Date Completed').notVisible(),
                        DTColumnBuilder.newColumn(8).withTitle('Date Completed').notVisible(),
                        DTColumnBuilder.newColumn(9).withTitle('Departments ID').notVisible(),
                        DTColumnBuilder.newColumn(10).withTitle('Department Alias').notVisible()
                    ];
                }
  
              }
  
              $scope.hide = function() {
                $mdDialog.hide();
              };
              $scope.cancel = function() {
                $mdDialog.cancel();
              };
              $scope.gravar = function(gravar) {                
                   /*switch(popuptype.tipoPopup.toLowerCase()){                    
                   case 'searchperproduct' :
                      var record = {};
                          if (typeof gravar !== 'undefined') {
                            for (var i = 0; i < gravar.length; i++) {                          
                                record[i] = {
                                  orders_opened_id: 0,
                                  orders_id: gravar[i],
                                  users_id: $scope.userid,
                                  departments_id: vm.departmentsid,
                                  dld: 0
                                }
                            }
                          }
                      gravar = record;                    
                    break;
                  }*/  
                  console.log(gravar);
                  vm.gravar(gravar);
              };
          }
  
          OtherController.$inject = ['$compile', '$scope', '$mdDialog', '$http','popuptype', '$timeout', 'CONFIG', 'DTOptionsBuilder','DTColumnBuilder','$location'];

          vm.gravar = function(gravar) {                
            var record = {};
            var departmentin = gravar[0].department_alias;
            if (typeof gravar !== 'undefined') {
                for (var i = 0; i < gravar.length; i++) {                          
                    record[i] = {
                        orders_opened_id: 0,
                        orders_id: gravar[i].orders_id,
                        users_id: vm.userid
                    }
                }
                gravar = record;
                console.log(gravar);
                var msg = "Order opening was ";
                var orderid = record[0].orders_id;
                api.ordersopened.save({ record: record, orderid: orderid }).$promise.then(function (result) { 
                    console.log(result); 
                    if(result.status !== 'success'){ 
                        showToast(msg, false) 
                    }else{ 
                        showToast(msg);
                        var url = $state.href('app.production', {'id': record[0].orders_id, 'module' : departmentin});                            
                        $window.open(url, '_blank');
                    } 
                }, function(error) { 
                    var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                    showToast(msg, false, erro); 
                });
            }
    }

        /* FIM CQR - Implementação Popup com Dados */
        

    }

    ReportsProductsController.$inject = ['$scope', '$document', '$mdToast', '$state', 'api', '$window', '$translate', '$mdDialog', 'localStorageService', 'postService', 'DTOptionsBuilder', 'DTColumnBuilder', 'CONFIG', '$location','OrdersStatusTotal'];
    
    
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.reportsorders', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.reportsorders', {
              url      : '/reports/orders/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/reportsorders/reportsorders.html',
                      controller : 'ReportsOrdersController as vm'
                  }
              },
              resolve  : {               
                OrdersStatusTotal: function (api)
                  {
                  return api.orders.get({ id: 'orderstatus' }).$promise;
                  },
              },               
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/reportsorders');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.reportsorders')
        .controller('ReportsOrdersController', ReportsOrdersController)
        .factory('postService', function($http, CONFIG) {
            var postService = {
              async: function(controller, id, cache, params) {
                /* $http returns a promise, which has a then function, which also returns a promise */
                var promise = $http({
                  cache: cache,
                  method: 'POST',    
                  url: CONFIG.apiBaseUrl + controller + '/' + id,
                  data: params
                }).then(function (response) {
                  /* The then function here is an opportunity to modify the response */
                  console.log(response);
                  /* The return value gets picked up by the then in the controller. */
                  return response.data;
                });
                /* Return the promise to the controller */
                return promise;
              }
            };
            return postService;
          });

    function ReportsOrdersController($scope, $document, $mdToast, $state, api, $window, $translate, $mdDialog, localStorageService, postService, DTOptionsBuilder, DTColumnBuilder, CONFIG, $location, OrdersStatusTotal)
    {
        console.log("Reports");

        var vm = this;

        vm.userid = localStorageService.get('userid');
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
        }
        vm.admin = localStorageService.get('admin');
        vm.levelid = localStorageService.get('levelid');
    
        /* Verifica se tem permissões de ver e/ou alterar conteúdos */
        if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || vm.privileges[31].privileges.view != '1'){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if((vm.privileges[31].privileges.edit == '0' || vm.privileges[31].privileges.edit == null || vm.privileges[31].privileges.edit == false) && vm.privileges[31].privileges.view == '1'){
                vm.disabled = true;
            }            
        }

        vm.onstoporders = OrdersStatusTotal.onstoporders;        
        vm.dueorders = OrdersStatusTotal.dueorders;
        vm.approvedvia = OrdersStatusTotal.approvedvia;
        vm.approvedwaiting = OrdersStatusTotal.approvedwaiting;
        vm.waitingcall = OrdersStatusTotal.waitingcall;
        vm.waitingimpression = OrdersStatusTotal.waitingimpression;
        vm.inactiveorders = OrdersStatusTotal.inactiveorders;        
        vm.numcompleted = OrdersStatusTotal.numcompleted;

        vm.gotoOrderStatus = gotoOrderStatus;
        
        function gotoOrderStatus()
        {
            console.log('go OrderStatus');
            $state.go('app.orderstatus');
        }

        vm.openPage = function(page){
            console.log('go ' + page);
            $state.go('app.'+page);
        }

        vm.order = [];
        vm.startDate = [];
        vm.endDate = [];

        vm.changeTotalSales = function(id, field, value){            
            if(typeof field != 'undefined' && typeof value != 'undefined'){
                var params = {};
                var f = "params."+field+" = '"+value+"'";
                eval(f);
            }else{
                var params = null;
            }
            postService.async("Reports", id, false, params).then(function(d) {                            
                console.log(d);
                vm.order[id] = d.orders;
                if(vm.order[id] == null || vm.order[id] == ""){
                    vm.order[id] = 0;
                }
            });      
        }

        /* Run First Time */
        var ids = ['neworders','ordersdue','orderswfc','orderswfi','ordersonstop','completedorders'];

        ids.forEach(function(id){
            vm.changeTotalSales(id);
        });
        /* END Run First Time */

        vm.clean = function(type){
            vm.startDate[type] = undefined;
            vm.endDate[type] = undefined;
            vm.changeTotalSales(type);
        }
        
        vm.autoPrintPage = function(){
            html2canvas($("#pagina-reports"), {
                onrendered: function(canvas) {                    
                    var myImage = canvas.toDataURL("image/png");
                    var tWindow = window.open("");
                    $(tWindow.document.body)
                        .html("<img id='Image' src=" + myImage + " style='width:100%;'></img>")
                        .ready(function() {                            
                            tWindow.focus();
                            tWindow.print();
                        });
                }
            });
        }

    }

    ReportsOrdersController.$inject = ['$scope', '$document', '$mdToast', '$state', 'api', '$window', '$translate', '$mdDialog', 'localStorageService', 'postService', 'DTOptionsBuilder', 'DTColumnBuilder', 'CONFIG', '$location','OrdersStatusTotal'];
    
    
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.reportsclients', ['nvd3'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.reportsclients', {
              url      : '/reports/clients/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/reportsclients/reportsclients.html',
                      controller : 'ReportsClientsController as vm'
                  }
              },
              resolve  : {
                  Reports: function (api)
                  {
                      return api.reports.get({ id: 'clientsdistribution' }).$promise;
                  },
                  OrdersStatusTotal: function (api)
                  {
                  return api.orders.get({ id: 'orderstatus' }).$promise;
                  },
              },               
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/reportsclients');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.reportsclients')
        .controller('ReportsClientsController', ReportsClientsController)
        .factory('postService', function($http, CONFIG) {
            var postService = {
              async: function(controller, id, cache, params) {
                /* $http returns a promise, which has a then function, which also returns a promise */
                var promise = $http({
                  cache: cache,
                  method: 'POST',    
                  url: CONFIG.apiBaseUrl + controller + '/' + id,
                  data: params
                }).then(function (response) {
                  /* The then function here is an opportunity to modify the response */
                  console.log(response);
                  /* The return value gets picked up by the then in the controller. */
                  return response.data;
                });
                /* Return the promise to the controller */
                return promise;
              }
            };
            return postService;
          });

    function ReportsClientsController($scope, $document, $mdToast, $state, api, $window, $translate, $mdDialog, localStorageService, postService, DTOptionsBuilder, DTColumnBuilder, CONFIG, $location, Reports, OrdersStatusTotal)
    {
        console.log("ReportsClients");

        var vm = this;

        vm.userid = localStorageService.get('userid');
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
        }
        vm.admin = localStorageService.get('admin');
        vm.levelid = localStorageService.get('levelid');
    
        /* Verifica se tem permissões de ver e/ou alterar conteúdos */
        if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || vm.privileges[31].privileges.view != '1'){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if((vm.privileges[31].privileges.edit == '0' || vm.privileges[31].privileges.edit == null || vm.privileges[31].privileges.edit == false) && vm.privileges[31].privileges.view == '1'){
                vm.disabled = true;
            }            
        }

        vm.openPage = function(page){
            console.log('go ' + page);
            $state.go('app.'+page);
        }

        vm.onstoporders = OrdersStatusTotal.onstoporders;        
        vm.dueorders = OrdersStatusTotal.dueorders;
        vm.approvedvia = OrdersStatusTotal.approvedvia;
        vm.approvedwaiting = OrdersStatusTotal.approvedwaiting;
        vm.waitingcall = OrdersStatusTotal.waitingcall;
        vm.waitingimpression = OrdersStatusTotal.waitingimpression;
        vm.inactiveorders = OrdersStatusTotal.inactiveorders;        
        vm.numcompleted = OrdersStatusTotal.numcompleted;

        vm.gotoOrderStatus = gotoOrderStatus;
        
        function gotoOrderStatus()
        {
            console.log('go OrderStatus');
            $state.go('app.orderstatus');
        }        

        var tooltip = nv.models.tooltip();
        tooltip.duration(0);

        vm.clientsdistribution = Reports.clientsdistribution;
        vm.total = Reports.totalclients;

        vm.pieChart = {
            options: {                
                chart: {
                    type: 'pieChart',
                    height: 350,
                    x: function(d) {
                        // if (d.key.length > 30) {
                            // return d.key.substr(0, 30) + "...";
                        // } else {
                            return d.key;
                        // }
                    },
                    y: function(d) {
                        return d.value;
                    },
                    showLabels: true,
                    transitionDuration: 500,
                    legend: {
                        vers: 'furious',
                        dispatch: {
                          legendMouseover: function(o) {
                            if (tooltip.hidden()) {
                              var data = {
                                series: {
                                  value: "Click to Show/Hide or double-<br />-click to select only this item",
                                  color: o.color
                                }
                              };
                              tooltip.data(data)
                                .hidden(false);
                            }
                            // tooltip.position({
                            //   top: d3.event.pageY,
                            //   left: d3.event.pageX
                            // })();
                          },
                          legendMouseout: function(o) {
                            tooltip.hidden(true);
                          }
                        }
                      },
                    legendPosition: 'right',
                    valueFormat: function(d) {
                    return d;
                    }
                }
            }
            // ,
            // data   : [{ key: 'Teste', value: 1 },{ key: 'Teste 2 ', value: 3 }]            
        }

        

        vm.changeTotalSales = function(field, value){            
            var idtotalsales = "totalsales";
            if(typeof field != 'undefined' && typeof value != 'undefined'){
                var params = {};
                var f = "params."+field+" = '"+value+"'";
                eval(f);
            }else{
                var params = null;
            }
            postService.async("Reports", idtotalsales, false, params).then(function(d) {                            
                vm.totalcost = d.totalsales.totalcost;
                if(vm.totalcost == null){
                    vm.totalcost = 0;
                }
                vm.totalvat = d.totalsales.totalvat;
                if(vm.totalvat == null){
                    vm.totalvat = 0;
                }
            });      
        }

        vm.changeTotalSales();

        vm.clean = function(type){
            switch(type){
                case 'topsales':
                    vm.startDate = undefined;
                    vm.endDate = undefined;
                    vm.changeTotalSales();
                break;
            }
        }

        /* Total Sales by Product */
        vm.dtInstance1 = {};
        var numcolunas1 = 6;

        vm.dtOptions1 = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'Reports/topsalesproduct',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas1; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search1"+i+";";
                    eval(f);
                    }
                    console.log(d);
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',false)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    return nRow;
                    });                      
                });
            })
            .withOption('order', [])        
            .withOption('initComplete', function(){
                /*var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;*/

                vm.searchTable1 = function(searchText, column){                
                    var f = "self.search1"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance1.DataTable.search(searchText).draw();
                }
                
                vm.reset = function(){                    
                    vm.search1 = [];
                    vm.search1.startDate = undefined;
                    vm.search1.endDate = undefined;
                    for (var i = 0; i < numcolunas1; ++i) {
                        var f = "self.search1"+i+" = undefined;";
                        eval(f);
                    }
                    vm.dtInstance1.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "sInfo": 'Info',
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns1 = [          
            DTColumnBuilder.newColumn(0).withTitle('Client Name'),
            DTColumnBuilder.newColumn(1).withTitle('Client Number'),
            DTColumnBuilder.newColumn(2).withTitle('Product Description'),
            DTColumnBuilder.newColumn(3).withTitle('Product Code'),
            DTColumnBuilder.newColumn(4).withTitle('Sales'),            
            DTColumnBuilder.newColumn(5).withTitle('Products ID').notVisible()
        ];

        /* FIM Total Sales by Product */

        /* Total Sales by GROUP */
        vm.dtInstance2 = {};
        var numcolunas2 = 5;

        vm.dtOptions2 = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'Reports/topsalesproductgroup',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas2; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search2"+i+";";
                    eval(f);
                    }
                    console.log(d);
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',false)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    return nRow;
                    });                      
                });
            })
            .withOption('order', [])        
            .withOption('initComplete', function(){
                /*var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;*/

                vm.searchTable2 = function(searchText, column){                
                    var f = "self.search2"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance2.DataTable.search(searchText).draw();
                }
                
                vm.reset_pg = function(){                    
                    vm.search2 = [];
                    vm.search2.startDate = undefined;
                    vm.search2.endDate = undefined;
                    for (var i = 0; i < numcolunas2; ++i) {
                        var f = "self.search2"+i+" = undefined;";
                        eval(f);
                    }                   
                    vm.dtInstance2.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "sInfo": 'Info',
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns2 = [           
            DTColumnBuilder.newColumn(0).withTitle('Client Name'),
            DTColumnBuilder.newColumn(1).withTitle('Client Number'),
            DTColumnBuilder.newColumn(2).withTitle('Group Name'),
            DTColumnBuilder.newColumn(3).withTitle('Sales'),            
            DTColumnBuilder.newColumn(4).withTitle('Products ID').notVisible()
        ];

        /* FIM Total Sales by Group */

        /* Total Sales by LOCATION */
        vm.dtInstance3 = {};
        var numcolunas3 = 6;

        vm.dtOptions3 = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'Reports/topsalesclientlocation',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas3; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search3"+i+";";
                    eval(f);
                    }
                    console.log(d);
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',false)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    return nRow;
                    });                      
                });
            })
            .withOption('order', [])        
            .withOption('initComplete', function(){
                /*var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;*/

                vm.searchTable3 = function(searchText, column){                
                    var f = "self.search3"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance3.DataTable.search(searchText).draw();
                }
                
                vm.reset_cl = function(){                    
                    vm.search3 = [];
                    vm.search3.startDate = undefined;
                    vm.search3.endDate = undefined;
                    for (var i = 0; i < numcolunas3; ++i) {
                        var f = "self.search3"+i+" = undefined;";
                        eval(f);
                    }                   
                    vm.dtInstance3.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "sInfo": 'Info',
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns3 = [           
            DTColumnBuilder.newColumn(0).withTitle('Client Name'),
            DTColumnBuilder.newColumn(1).withTitle('Client Number'),
            DTColumnBuilder.newColumn(2).withTitle('City'),
            DTColumnBuilder.newColumn(3).withTitle('Postcode'),
            DTColumnBuilder.newColumn(4).withTitle('Sales'),            
            DTColumnBuilder.newColumn(5).withTitle('Products ID').notVisible()
        ];

        /* FIM Total Sales by Group */

        /* Total Sales */

        vm.dtInstance4 = {};
        var numcolunas4 = 3;

        vm.dtOptions4 = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'Reports/topsales',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas4; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search4"+i+";";
                    eval(f);
                    }
                    console.log(d);
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',false)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    return nRow;
                    });                      
                });
            })
            .withOption('order', [])        
            .withOption('initComplete', function(){
                /*var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;*/

                vm.searchTable4 = function(searchText, column){                
                    var f = "self.search4"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance4.DataTable.search(searchText).draw();
                }
                
                vm.reset_ts = function(){                    
                    vm.search4 = [];
                    vm.search4.startDate = undefined;
                    vm.search4.endDate = undefined;
                    for (var i = 0; i < numcolunas4; ++i) {
                        var f = "self.search4"+i+" = undefined;";
                        eval(f);
                    }                   
                    vm.dtInstance4.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "sInfo": 'Info',
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns4 = [           
            DTColumnBuilder.newColumn(0).withTitle('Client Name'),
            DTColumnBuilder.newColumn(1).withTitle('Client Number'),
            DTColumnBuilder.newColumn(2).withTitle('Sales')
        ];

        /* FIM Total Sales */

        /* New Clients */

        vm.dtInstance5 = {};
        var numcolunas5 = 4;

        vm.dtOptions5 = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'Reports/newclients',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas5; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search5"+i+";";
                    eval(f);
                    }
                    console.log(d);
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',false)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    return nRow;
                    });                      
                });
            })
            .withOption('order', [])        
            .withOption('initComplete', function(){
                /*var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;*/

                vm.searchTable5 = function(searchText, column){                
                    var f = "self.search5"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance5.DataTable.search(searchText).draw();
                }
                
                vm.reset_5 = function(){                    
                    vm.search5 = [];
                    vm.search5.startDate = undefined;
                    vm.search5.endDate = undefined;
                    for (var i = 0; i < numcolunas5; ++i) {
                        var f = "self.search5"+i+" = undefined;";
                        eval(f);
                    }                   
                    vm.dtInstance5.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "sInfo": 'Info',
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns5 = [           
            DTColumnBuilder.newColumn(0).withTitle('Client Name'),
            DTColumnBuilder.newColumn(1).withTitle('Client Number'),
            DTColumnBuilder.newColumn(2).withTitle('Address'),
            DTColumnBuilder.newColumn(3).withTitle('Postcode')
        ];

        /* FIM Total Sales */

        /* Clients per Location */

        vm.dtInstance6 = {};
        var numcolunas6 = 4;

        vm.dtOptions6 = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'Reports/clientslocation',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas6; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search6"+i+";";
                    eval(f);
                    }
                    console.log(d);
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',false)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    return nRow;
                    });                      
                });
            })
            .withOption('order', [])        
            .withOption('initComplete', function(){
                /*var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;*/

                vm.searchTable6 = function(searchText, column){                
                    var f = "self.search6"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance6.DataTable.search(searchText).draw();
                }
                
                vm.reset_6 = function(){                    
                    vm.search6 = [];
                    for (var i = 0; i < numcolunas5; ++i) {
                        var f = "self.search6"+i+" = undefined;";
                        eval(f);
                    }                   
                    vm.dtInstance6.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "sInfo": 'Info',
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns6 = [           
            DTColumnBuilder.newColumn(0).withTitle('Client Name'),
            DTColumnBuilder.newColumn(1).withTitle('Client Number'),
            DTColumnBuilder.newColumn(2).withTitle('City'),
            DTColumnBuilder.newColumn(3).withTitle('Postcode')
        ];

        /* FIM Client per Location */

        /* Clients Location and Products */
        vm.dtInstance7 = {};
        var numcolunas7 = 7;

        vm.dtOptions7 = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'Reports/clientslocationproduct',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas7; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search7"+i+";";
                    eval(f);
                    }
                    console.log(d);
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',false)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    return nRow;
                    });                      
                });
            })
            .withOption('order', [])        
            .withOption('initComplete', function(){
                /*var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;*/

                vm.searchTable7 = function(searchText, column){                
                    var f = "self.search7"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance7.DataTable.search(searchText).draw();
                }
                
                vm.reset_7 = function(){                    
                    vm.search7 = [];
                    vm.search7.startDate = undefined;
                    vm.search7.endDate = undefined;
                    for (var i = 0; i < numcolunas7; ++i) {
                        var f = "self.search7"+i+" = undefined;";
                        eval(f);
                    }
                    vm.dtInstance7.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "sInfo": 'Info',
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns7 = [          
            DTColumnBuilder.newColumn(0).withTitle('Client Name'),
            DTColumnBuilder.newColumn(1).withTitle('Client Number'),
            DTColumnBuilder.newColumn(2).withTitle('City'),
            DTColumnBuilder.newColumn(3).withTitle('Postcode'),
            DTColumnBuilder.newColumn(2).withTitle('Product Description'),
            DTColumnBuilder.newColumn(3).withTitle('Product Code'),
            DTColumnBuilder.newColumn(4).withTitle('Sales')
        ];

        /* FIM Clients Location and Product */

        vm.autoPrintPage = function(){
            html2canvas($("#pagina-reportsclients"), {
                onrendered: function(canvas) {                    
                    var myImage = canvas.toDataURL("image/png");
                    var tWindow = window.open("");
                    $(tWindow.document.body)
                        .html("<img id='Image' src=" + myImage + " style='width:100%;'></img>")
                        .ready(function() {                            
                            tWindow.focus();
                            tWindow.print();
                        });
                }
            });
        }

    }

    ReportsClientsController.$inject = ['$scope', '$document', '$mdToast', '$state', 'api', '$window', '$translate', '$mdDialog', 'localStorageService', 'postService', 'DTOptionsBuilder', 'DTColumnBuilder', 'CONFIG', '$location', 'Reports','OrdersStatusTotal'];
    
    
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.reports', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.reports', {
              url      : '/reports/sales/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/reports/reports.html',
                      controller : 'ReportsController as vm'
                  }
              },
              resolve  : {               
                OrdersStatusTotal: function (api)
                  {
                  return api.orders.get({ id: 'orderstatus' }).$promise;
                  },
              },               
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/reports');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsController', ReportsController)
        .factory('postService', function($http, CONFIG) {
            var postService = {
              async: function(controller, id, cache, params) {
                /* $http returns a promise, which has a then function, which also returns a promise */
                var promise = $http({
                  cache: cache,
                  method: 'POST',    
                  url: CONFIG.apiBaseUrl + controller + '/' + id,
                  data: params
                }).then(function (response) {
                  /* The then function here is an opportunity to modify the response */
                  console.log(response);
                  /* The return value gets picked up by the then in the controller. */
                  return response.data;
                });
                /* Return the promise to the controller */
                return promise;
              }
            };
            return postService;
          })
          .directive('printDiv', function () {
          return {
            restrict: 'A',
            link: function(scope, element, attrs) {
              element.bind('click', function(evt){    
                evt.preventDefault();    
                PrintElem(attrs.printDiv);
              });
        
              function PrintElem(elem)
              {
                PrintWithIframe($(elem).html());
              }
        
              function PrintWithIframe(data) 
              {
                // console.log(data);
                if ($('iframe#printf').length == 0) {
                  $('html').append('<iframe id="printf" name="printf"></iframe>');

                  var mywindow = window.frames["printf"];
                //   mywindow.document.write('<html><head><title></title><style>@page {margin: 2cm; font-family: "Roboto", "Helvetica Neue", "Arial", sans-serif; font-size: 14px;}</style>'
                //                   + '</head><body><div>'
                //                   + data
                //                   + '</div></body></html>');
                //  mywindow.document.write(htmlContent);
                // var yourDOCTYPE = "<!DOCTYPE html..."; // your doctype declaration
                var printPreview = window.open('about:blank', 'print_preview');
                var printDocument = printPreview.document;
                printDocument.open();
                printDocument.write(
                           "<html>"+
                               document.documentElement.innerHTML+
                           "</html>");
                printDocument.close();
        
                  /*$(mywindow.document).ready(function(){
                    mywindow.print();
                    setTimeout(function(){
                      $('iframe#printf').remove();
                    },
                    2000);
                  });*/
                }
        
                return true;
              }
            }
          };
        });

    function ReportsController($scope, $document, $mdToast, $state, api, $window, $translate, $mdDialog, localStorageService, postService, DTOptionsBuilder, DTColumnBuilder, CONFIG, $location,OrdersStatusTotal,$timeout)
    {
        console.log("Reports");

        var vm = this;

        vm.userid = localStorageService.get('userid');
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
        }
        vm.admin = localStorageService.get('admin');
        vm.levelid = localStorageService.get('levelid');
    
        /* Verifica se tem permissões de ver e/ou alterar conteúdos */
        if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || vm.privileges[31].privileges.view != '1'){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if((vm.privileges[31].privileges.edit == '0' || vm.privileges[31].privileges.edit == null || vm.privileges[31].privileges.edit == false) && vm.privileges[31].privileges.view == '1'){
                vm.disabled = true;
            }            
        }

        vm.onstoporders = OrdersStatusTotal.onstoporders;        
        vm.dueorders = OrdersStatusTotal.dueorders;
        vm.approvedvia = OrdersStatusTotal.approvedvia;
        vm.approvedwaiting = OrdersStatusTotal.approvedwaiting;
        vm.waitingcall = OrdersStatusTotal.waitingcall;
        vm.waitingimpression = OrdersStatusTotal.waitingimpression;
        vm.inactiveorders = OrdersStatusTotal.inactiveorders;        
        vm.numcompleted = OrdersStatusTotal.numcompleted; 

        vm.gotoOrderStatus = gotoOrderStatus;
        
        function gotoOrderStatus()
        {
            console.log('go OrderStatus');
            $state.go('app.orderstatus');
        }

        vm.openPage = function(page){
            console.log('go ' + page);
            $state.go('app.'+page);
        }

        vm.params = {};

        vm.changeTotalSales = function(field, value){            
            var idtotalsales = "totalsales";
            if(typeof field != 'undefined' && typeof value != 'undefined'){
                var params = {};
                var f = "vm.params."+field+" = '"+value+"'";
                eval(f);
            }/*else{
                var params = null;
            }*/
            postService.async("Reports", idtotalsales, false, vm.params).then(function(d) { 
                /*console.log("params");
                console.log(params);*/
                vm.totalcost = d.totalsales.totalcost;
                if(vm.totalcost == null){
                    vm.totalcost = 0;
                }
                vm.totalvat = d.totalsales.totalvat;
                if(vm.totalvat == null){
                    vm.totalvat = 0;
                }
            });      
        }

        vm.changeTotalSales();

        vm.clean = function(type){
            switch(type){
                case 'topsales':
                    vm.params = {};
                    vm.startDate = undefined;
                    vm.endDate = undefined;
                    vm.changeTotalSales();
                break;
            }
        }

        /* Total Sales by Product */
        vm.dtInstance1 = {};
        var numcolunas1 = 6;

        vm.dtOptions1 = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'Reports/topsalesproduct',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas1; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search1"+i+";";
                    eval(f);
                    }
                    console.log(d);
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',false)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    return nRow;
                    });                      
                });
            })
            .withOption('order', [])        
            .withOption('initComplete', function(){
                /*var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;*/

                vm.searchTable1 = function(searchText, column){                
                    var f = "self.search1"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance1.DataTable.search(searchText).draw();
                }
                
                vm.reset = function(){                    
                    vm.search1 = [];
                    vm.search1.startDate = undefined;
                    vm.search1.endDate = undefined;
                    for (var i = 0; i < numcolunas1; ++i) {
                        var f = "self.search1"+i+" = undefined;";
                        eval(f);
                    }
                    vm.dtInstance1.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "sInfo": 'Info',
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns1 = [          
            DTColumnBuilder.newColumn(0).withTitle('Client Name'),
            DTColumnBuilder.newColumn(1).withTitle('Client Number'),
            DTColumnBuilder.newColumn(2).withTitle('Product Description'),
            DTColumnBuilder.newColumn(3).withTitle('Product Code'),
            DTColumnBuilder.newColumn(4).withTitle('Sales'),            
            DTColumnBuilder.newColumn(5).withTitle('Products ID').notVisible()
        ];

        /* FIM Total Sales by Product */

        /* Total Sales by GROUP */
        vm.dtInstance2 = {};
        var numcolunas2 = 5;

        vm.dtOptions2 = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'Reports/topsalesproductgroup',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas2; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search2"+i+";";
                    eval(f);
                    }
                    console.log(d);
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',false)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    return nRow;
                    });                      
                });
            })
            .withOption('order', [])        
            .withOption('initComplete', function(){
                /*var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;*/

                vm.searchTable2 = function(searchText, column){                
                    var f = "self.search2"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance2.DataTable.search(searchText).draw();
                }
                
                vm.reset_pg = function(){                    
                    vm.search2 = [];
                    vm.search2.startDate = undefined;
                    vm.search2.endDate = undefined;
                    for (var i = 0; i < numcolunas2; ++i) {
                        var f = "self.search2"+i+" = undefined;";
                        eval(f);
                    }                   
                    vm.dtInstance2.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "sInfo": 'Info',
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns2 = [           
            DTColumnBuilder.newColumn(0).withTitle('Client Name'),
            DTColumnBuilder.newColumn(1).withTitle('Client Number'),
            DTColumnBuilder.newColumn(2).withTitle('Group Name'),
            DTColumnBuilder.newColumn(3).withTitle('Sales'),            
            DTColumnBuilder.newColumn(4).withTitle('Products ID').notVisible()
        ];

        /* FIM Total Sales by Group */

        /* Total Sales by LOCATION */
        vm.dtInstance3 = {};
        var numcolunas3 = 6;

        vm.dtOptions3 = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'Reports/topsalesclientlocation',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas3; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search3"+i+";";
                    eval(f);
                    }
                    console.log(d);
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',false)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    return nRow;
                    });                      
                });
            })
            .withOption('order', [])        
            .withOption('initComplete', function(){
                /*var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;*/

                vm.searchTable3 = function(searchText, column){                
                    var f = "self.search3"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance3.DataTable.search(searchText).draw();
                }
                
                vm.reset_cl = function(){                    
                    vm.search3 = [];
                    vm.search3.startDate = undefined;
                    vm.search3.endDate = undefined;
                    for (var i = 0; i < numcolunas3; ++i) {
                        var f = "self.search3"+i+" = undefined;";
                        eval(f);
                    }                   
                    vm.dtInstance3.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "sInfo": 'Info',
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns3 = [           
            DTColumnBuilder.newColumn(0).withTitle('Client Name'),
            DTColumnBuilder.newColumn(1).withTitle('Client Number'),
            DTColumnBuilder.newColumn(2).withTitle('City'),
            DTColumnBuilder.newColumn(3).withTitle('Postcode'),
            DTColumnBuilder.newColumn(4).withTitle('Sales'),            
            DTColumnBuilder.newColumn(5).withTitle('Products ID').notVisible()
        ];

        /* FIM Total Sales by Group */

        /* Total Sales */

        vm.dtInstance4 = {};
        var numcolunas4 = 3;

        vm.dtOptions4 = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'Reports/topsales',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas4; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search4"+i+";";
                    eval(f);
                    }
                    console.log(d);
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',false)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    return nRow;
                    });                      
                });
            })
            .withOption('order', [])        
            .withOption('initComplete', function(){
                /*var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;*/

                vm.searchTable4 = function(searchText, column){                
                    var f = "self.search4"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance4.DataTable.search(searchText).draw();
                }
                
                vm.reset_ts = function(){                    
                    vm.search4 = [];
                    vm.search4.startDate = undefined;
                    vm.search4.endDate = undefined;
                    for (var i = 0; i < numcolunas4; ++i) {
                        var f = "self.search4"+i+" = undefined;";
                        eval(f);
                    }                   
                    vm.dtInstance4.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "sInfo": 'Info',
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns4 = [           
            DTColumnBuilder.newColumn(0).withTitle('Client Name'),
            DTColumnBuilder.newColumn(1).withTitle('Client Number'),
            DTColumnBuilder.newColumn(2).withTitle('Sales')
        ];

        /* FIM Total Sales */

        vm.autoPrintPage = function(){
            html2canvas($("#pagina-reports"), {
                onrendered: function(canvas) {                    
                    var myImage = canvas.toDataURL("image/png");
                    var tWindow = window.open("");
                    $(tWindow.document.body)
                        .html("<img id='Image' src=" + myImage + " style='width:100%;'></img>")
                        .ready(function() {                            
                            tWindow.focus();
                            tWindow.print();
                        });
                }
            });
        }            

    }

    ReportsController.$inject = ['$scope', '$document', '$mdToast', '$state', 'api', '$window', '$translate', '$mdDialog', 'localStorageService', 'postService', 'DTOptionsBuilder', 'DTColumnBuilder', 'CONFIG', '$location','OrdersStatusTotal','$timeout'];
    
    
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.profiles', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.profiles', {
              url      : '/profiles/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/profiles/profiles.html',
                      controller : 'ProfilesController as vm'
                  }
              },
              resolve  : {
                Orders: function (api)
                    {
                        return api.orders.get({id: 'orderstatus'}).$promise;
                    },
                Payments: function (api)
                    {
                        return api.payments.get().$promise;
                    },
                Discounts: function (api)
                    {
                        return api.discounts.get().$promise;
                    },
                Vat: function (api)
                    {
                        return api.vat.get().$promise;
                    },
                Clients: function (api)
                    {
                        return api.clients.get().$promise;
                    },
                ClientsType: function (api)
                    {
                        return api.clientstype.get().$promise;
                    },
            },
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/profiles');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.profiles')
        .controller('ProfilesController', ProfilesController)
        .filter('cmdate', [
            '$filter', function($filter) {
                return function(input, format) {
                    return $filter('date')(new Date(input), format);
                };
            }
          ]);

    function ProfilesController($scope, $document, $state, $window, $translate, $compile, $timeout, api, ClientsType, Clients, Orders, Payments, Discounts, Vat, $mdDialog, $mdToast, DTOptionsBuilder, DTColumnBuilder, CONFIG, localStorageService, $location)
    {
        console.log("ProfilesController");

        var vm = this;

        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
          vm.privileges = JSON.parse(localStorageService.get('privileges'));
        }
        vm.admin = localStorageService.get('admin');
        vm.levelid = localStorageService.get('levelid');

        vm.disabled = false;
        vm.settings = 2;
        vm.settingsdisabled = false;

        /* Verifica se tem permissões de ver e/ou alterar conteúdos */
        if(vm.admin != '1' && vm.levelid != '1'){
          if(vm.privileges == null || vm.privileges[33].privileges.view != '1'){
              var infor = "You don't have enough permission to enter this area.";
              showToast(infor, "info");
              $state.go('app.dashboard');
          }else if((vm.privileges[33].privileges.edit == '0' || vm.privileges[33].privileges.edit == null || vm.privileges[33].privileges.edit == false) && vm.privileges[33].privileges.view == '1'){
              vm.disabled = true;
          }
          if(vm.privileges == null || vm.privileges[34].privileges.view != '1'){
            vm.settings = 0; /* Disabled */            
          }else{
            if(vm.privileges[34].privileges.edit == '0' || vm.privileges[34].privileges.edit == null || vm.privileges[34].privileges.edit == false){
              vm.settings = 1; /* View */
              vm.settingsdisabled = true;
            }else if(vm.privileges[34].privileges.edit == '1'){
              vm.settings = 2; /* Edit */
            }else{
              vm.settings = 0; /* Disabled */
              vm.settingsdisabled = true;
            }
          }
        }

        vm.onstoporders = Orders.onstoporders;
        vm.dueorders = Orders.dueorders;
        vm.dueorders = Orders.dueorders;
        vm.approvedvia = Orders.approvedvia;
        vm.approvedwaiting = Orders.approvedwaiting;
        vm.waitingcall = Orders.waitingcall;
        vm.waitingimpression = Orders.waitingimpression;
        vm.inactiveorders = Orders.inactiveorders;        
        vm.numcompleted = Orders.numcompleted;
        vm.total = Orders.total.count;

        vm.clientstype = ClientsType.records;

        // vm.practicesdentists = Clients.practicesdentists;
        // angular.forEach(vm.practicesdentists, function(practicesdentists, index){
        //   practicesdentists.index = index;
        // });
        // vm.companies = Clients.companies;
        // angular.forEach(vm.companies, function(companies, index){
        //   companies.index = index;
        // });

        vm.allpayments = Payments.records;
        vm.discounts = Discounts.records;
        vm.vat = Vat.records;
        
        if($state.params.showToastMessage) {
          showToast($state.params.showToastMessage);
      }

      function showToast(msg, state, error) {
        if (typeof(state)==='undefined') state = true;
        if(state == true){
        msg = msg + 'a success!';
        var toast = $mdToast.simple()
            .content(msg)
            .highlightAction(true)
            .hideDelay(3000)
            .theme("success-toast")
            .position('top right');
        }else if(state == "info"){
          var toast = $mdToast.simple()
            .content(msg)
            .highlightAction(true)
            .hideDelay(10000)
            .theme("orange")
            .position('top right');
        }else{
        if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
        if (typeof(error)!=='undefined') msg = error;
          var toast = $mdToast.simple()
              .content(msg)
              .highlightAction(true)
              .hideDelay(3000)
              .theme("error-toast")
              .position('top right');              
        }
        $mdToast.show(toast); 
      }

      vm.gotoOrderStatus = gotoOrderStatus;
      function gotoOrderStatus()
      {
          console.log('go OrderStatus');
          $state.go('app.orderstatus');
      }

      vm.gotoProfile = function()
      {
          console.log('go Profile');
          $state.go('app.profile');
      }

      vm.dtInstance = {};
      vm.type = 1;
      var itemabrir;
      vm.itemabrir = "";
      var numcolunas = 9;

      vm.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('ajax', {
          url: CONFIG.apiBaseUrl + 'Clients/'+vm.type+'fetchprofiles',
          type: 'POST',
          "dataSrc": function(json) {
            if(json.status && json.status == "login"){
              $mdDialog.hide();
              var infor = "Your login has expired. Please login again.";
              showToast(infor, "info");
              $location.path('/login');
            }else{
                console.log(json);
                return json.data;
            }
          },
          "data": function(d){
              for (var i = 1; i < numcolunas; ++i) {
                var f = "d.columns["+i+"].search.value = self.search"+i+";";
                eval(f);
              }
              console.log(d);
              
          },
          "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
      })
      .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
      .withDataProp('data')
      .withOption('processing', true)
      .withOption('serverSide', true)
      .withOption('filter', false)
      .withOption('bLengthChange', true)
      .withOption('bSort', false)
      .withOption('responsive',false)
      .withPaginationType('full_numbers')
      .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        $('td', nRow).css('cursor', 'pointer');
        $('td', nRow).unbind('click');
        $('td', nRow).bind('click', function() {
            $scope.$apply(function() {
              /* Open Client */
              if($(nRow).hasClass('highlitedRow')){
                $(nRow).removeClass('highlitedRow'); 
                itemabrir = "";
              }else{
                $('table tr').removeClass('highlitedRow');
                $(nRow).addClass('highlitedRow');
                itemabrir = aData[0];
              }
              vm.itemabrir = itemabrir;
              console.log(vm.itemabrir);
              /* FIM Open Client */              
              return nRow;
              });                      
            });
        })
      .withOption('createdRow', function(row) {
        // Recompiling so we can bind Angular directive to the DT
        $compile(angular.element(row).contents())($scope);
      })
      .withOption('order', [])        
      .withOption('initComplete', function(){
          var api = this.api();

          vm.totalRecords = api.page.info().recordsTotal;
          vm.totalRecordsFiltered = api.page.info().recordsDisplay;

          vm.searchTable = function(searchText, column){
              var f = "self.search"+column+" = searchText;";
              eval(f);
              vm.dtInstance.DataTable.search(searchText).draw();                  
          } 
          
          vm.reset = function(){
              vm.search = [];
              for (var i = 1; i < numcolunas; ++i) {
                var f = "self.search"+i+" = undefined;";
                eval(f);
              }
              vm.dtInstance.reloadData(null, true);                      
          }
          
          vm.changeType = function(type){
              vm.reset();
              itemabrir = [];
              vm.itemabrir = [];
              vm.type = type;
              var newurl = CONFIG.apiBaseUrl + 'Clients/'+vm.type+'fetchprofiles';                
              $timeout( function(){                    
                  vm.dtInstance.DataTable.ajax.url(newurl).load();
              }, 100 );             
          }
          
      })
      .withLanguage({
          "sInfo": 'Info',
          "paginate": {
              "first": 'First',
              "last": 'Last',
              "next": 'Next',
              "previous": 'Previous'
          }
      });

      vm.dtColumns = [
          DTColumnBuilder.newColumn(0).withTitle('Clients ID').notVisible(),
          DTColumnBuilder.newColumn(1).withTitle('Client Type'),
          DTColumnBuilder.newColumn(2).withTitle('Client Number'),
          DTColumnBuilder.newColumn(3).withTitle('Client Name'),
          DTColumnBuilder.newColumn(4).withTitle('Postcode'),
          DTColumnBuilder.newColumn(5).withTitle('City'),
          DTColumnBuilder.newColumn(6).withTitle('Country'),
          DTColumnBuilder.newColumn(7).withTitle('Portal')
          .renderWith(function(data, type, full, meta) {
            if(full[7]==1){
              return '<md-icon md-font-icon="icon-check" class="s24 md-default-theme md-font material-icons icon-check" aria-hidden="true"></md-icon>';
            }else{
              return '';
            }
          }),
          DTColumnBuilder.newColumn(8).withTitle('Clients Type ID').notVisible()
          
      ]

      vm.openClient = function(id){
        console.log(id);
        if(typeof(id)!=undefined || id != null){
          $state.go('app.profile', {'id': id});
        }
      }

        vm.openSettings = function(ev) {                
            $mdDialog.show({
              controller: eval("SettingsController"),
              controllerAs: 'sctrl',
              templateUrl: 'app/main/pages/profiles/others/settings.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: $scope.customFullscreen 
            });
          };          
  
  
          function SettingsController($scope, $mdDialog, $mdToast, api) {
              var self = this;
              self.nomepagamento = "";
              self.nomedesconto = "";
              self.nomevat = "";
              self.allpayments = vm.allpayments;
              self.discounts = vm.discounts;
              self.vat = vm.vat;
              self.desativaTodos = function(){
                angular.forEach(self.allpayments, function(payment) {                
                  payment.isDisabled = true;
                });
                angular.forEach(self.discounts, function(discounts) {                
                  discounts.isDisabled = true;
                });
                angular.forEach(self.vat, function(vat) {                
                  vat.isDisabled = true;
                });
              }
              

              self.desativaTodos();
              $scope.editaCampo = function(index, type){
                if(type=="payments"){
                  self.allpayments[index].isDisabled = false;
                  self.nomepagamento = self.allpayments[index].type_payment;
                }
                if(type=="discounts"){
                  self.discounts[index].isDisabled = false;
                  self.nomedesconto = self.discounts[index].discount;
                }
                if(type=="vat"){
                  self.vat[index].isDisabled = false;
                  self.nomevat = self.vat[index].vat;
                }
              }
              $scope.removeOption = function(apix, id){
                
                switch(apix){
                  case 'payments':
                  var msg = "Payment deletion was ";
                  break;
                  case 'discounts':
                  var msg = "Discount deletion was ";
                  break;
                  case 'vat':
                  var msg = "VAT deletion was ";
                  break;
                }
                
                if (confirm('Are you sure you want to delete?')) {
                  var f = 'api.'+apix+'.delete({ id: id }).$promise.then(function (result) { console.log(result); if(result.status !== "success"){ showToast(msg, false) }else{ if(apix=="payments"){ self.allpayments = self.allpayments.filter(function( obj ) {return obj.payments_id !== id; }); vm.allpayments = self.allpayments; } if(apix="discounts"){ self.discounts = self.discounts.filter(function( obj ) {return obj.discounts_id !== id; }); vm.discounts = self.discounts; } if(apix="vat"){ self.vat = self.vat.filter(function( obj ) {return obj.vat_id !== id; }); vm.vat = self.vat; } showToast(msg); } }, function(error) { var erro = "Error Code: " + error["status"] + ". Please try again or contact administrator."; showToast(msg, false, erro); } );';
                  eval(f);  
                }                  
              }
              $scope.addOption = function(apix, name, id, index){
                id = (typeof(id) == undefined) ? 0 : id;

                if(name == "" || name == undefined || name == null){
                  if(apix=="payments"){
                    var erro = "Please insert a payment name.";
                  }else if(apix == "discounts"){
                    var erro = "Please insert a discount value";
                  }else if(apix == "vat"){
                    var erro = "Please insert a VAT value";
                  }
                  showToast(msg, false, erro);
                }else{
                  switch(apix){
                    case 'payments':
                    var record = {
                        payments_id: id,
                        type_payment: name
                    }
                    var msg = (id == 0) ? "Payment adding was " : "Payment change was ";
                    break;
                    case 'discounts':
                    var record = {
                        discounts_id: id,
                        discount: name
                    }
                    var msg = (id == 0) ? "Discount adding was " : "Discount change was ";
                    break;
                    case 'vat':
                    var record = {
                        vat_id: id,
                        vat: name
                    }
                    var msg = (id == 0) ? "VAT adding was " : "VAT change was ";
                    break;

                    console.log(record);
                  }

                  if(name == self.nomepagamento || name == self.nomedesconto || name == self.nomevat){                  
                    self.desativaTodos(); 
                  }else{
                    var fz = 'api.'+apix+'.save({ record: record }).$promise.then(function (result) { console.log(result); if(result.status !== "success"){ showToast(msg, false); }else{ if(id!=0){ self.desativaTodos(); }else{ if(apix=="payments"){ var novo = { "payments_id": result.newpaymentid, "type_payment": record.type_payment }; self.allpayments.push(novo); self.desativaTodos(); self.type_payment = undefined; vm.allpayments = self.allpayments; }else if(apix=="discounts"){ var novo = { "discounts_id": result.newdiscountid, "discount": record.discount }; self.discounts.push(novo); self.desativaTodos(); self.discount = undefined; vm.discounts = self.discounts; }else if(apix=="vat"){ var novo = { "vat_id": result.newvatid, "vat": record.vat }; self.vat.push(novo); self.desativaTodos(); self.vatname = undefined; vm.vat = self.vat; } } showToast(msg); } }, function(error) { var erro = "Error Code: " + error["status"] + ". Please try again or contact administrator."; showToast(msg, false, erro); } );'; 
                    console.log(fz);
                    eval(fz);
                    
                  }
                }
              }
             
              $scope.cancel = function($event) {
                $mdDialog.cancel();
              };
              $scope.finish = function($event) {
                $mdDialog.hide();
              };   
          }
  
          SettingsController.$inject = ['$scope', '$mdDialog', '$mdToast', 'api'];

    }

    ProfilesController.$inject = ['$scope', '$document', '$state', '$window', '$translate', '$compile', '$timeout', 'api', 'ClientsType', 'Clients', 'Orders', 'Payments', 'Discounts', 'Vat', '$mdDialog', '$mdToast', 'DTOptionsBuilder', 'DTColumnBuilder', 'CONFIG', 'localStorageService', '$location'];
    
})();    
(function ()
{
    'use strict';

    angular
        .module('app.profile', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        console.log("profile"); 
        $stateProvider
          .state('app.profile', {
              url      : '/Profile/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/profile/profile.html',
                      controller : 'ProfileController as vm'
                  }
              },
              resolve  : { 
                ClientsStatus: function (api, $stateParams)
                {
                    if($stateParams.id > 0){
                        return api.clientsstatus.get({ id: $stateParams.id }).$promise;
                    }
                }, 
                Clients: function (api, $stateParams)
                    {
                        if($stateParams.id > 0){
                            return api.clients.get({ id: $stateParams.id }).$promise;
                        }
                    },               
                OrdersStatusTotal: function (api)
                    {
                    return api.orders.get({ id: 'orderstatus' }).$promise;
                    },
                ClientsDeliveryAddress: function (api, $stateParams)
                    {
                        if($stateParams.id > 0){
                            return api.clientsdeliveryaddress.get({ id: $stateParams.id }).$promise;
                        }
                    },
                Payment: function (api, $stateParams)
                    {
                        if($stateParams.id > 0){
                            return api.payments.get().$promise;
                        }
                    },
                Discount: function (api, $stateParams)
                    {
                        if($stateParams.id > 0){
                            return api.discounts.get().$promise;
                        }
                    },
                ClientsProducts: function (api, $stateParams)
                    {
                        if($stateParams.id > 0){
                            return api.clientsproducts.get({ id: $stateParams.id }).$promise;
                        }
                    },
                Products: function (api, $stateParams)
                    {
                        if($stateParams.id > 0){
                            return api.products.get().$promise;
                        }
                    }, 
                EmailType: function (api)
                    {
                        return api.emailtype.get().$promise;
                    }, 
                TelType: function (api)
                    {
                        return api.teltype.get().$promise;
                    },
                ClientsEmail: function (api, $stateParams)
                    {
                        if($stateParams.id > 0){
                            return api.clientsemail.get({ id: $stateParams.id }).$promise;
                        }
                    },  
                ClientsTel: function (api, $stateParams)
                    {
                        if($stateParams.id > 0){
                            return api.clientstel.get({ id: $stateParams.id }).$promise;
                        }
                    },                  
                                  
              },             
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/profile');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.profile')
        .controller('ProfileController', ProfileController)
        .filter('cmdate', [
          '$filter', function($filter) {
              return function(input, format) {
                  return $filter('date')(new Date(input), format);
              };
          }
        ]);

    function ProfileController($scope, $document, $mdToast, $state, $stateParams, $filter, api, ClientsStatus, ClientsTel, ClientsEmail, TelType, EmailType, Products, ClientsProducts, Discount, Payment, ClientsDeliveryAddress, OrdersStatusTotal, Clients, $window, $translate, $mdDialog, localStorageService, $timeout)    
    {
        var vm = this;

        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
          vm.privileges = JSON.parse(localStorageService.get('privileges'));
        }
        vm.admin = localStorageService.get('admin');
        vm.levelid = localStorageService.get('levelid');

        vm.disabled = false;

        /* Verifica se tem permissões de ver e/ou alterar conteúdos */
        if(vm.admin != '1' && vm.levelid != '1'){
          if(vm.privileges == null || vm.privileges[33].privileges.view != '1'){
              var infor = "You don't have enough permission to enter this area.";
              showToast(infor, "info");
              $state.go('app.dashboard');
          }else if((vm.privileges[33].privileges.edit == '0' || vm.privileges[33].privileges.edit == null || vm.privileges[33].privileges.edit == false) && vm.privileges[33].privileges.view == '1'){
              vm.disabled = true;
          }
        }

        vm.id = ($stateParams.id=="") ? 0 : $stateParams.id;

        vm.onstoporders = OrdersStatusTotal.onstoporders;
        vm.dueorders = OrdersStatusTotal.dueorders;
        vm.approvedvia = OrdersStatusTotal.approvedvia;
        vm.approvedwaiting = OrdersStatusTotal.approvedwaiting;
        vm.waitingcall = OrdersStatusTotal.waitingcall;
        vm.waitingimpression = OrdersStatusTotal.waitingimpression;
        vm.inactiveorders = OrdersStatusTotal.inactiveorders;        
        vm.numcompleted = OrdersStatusTotal.numcompleted;      
        
        vm.allemailtypes = EmailType.records;          
        vm.allteltypes = TelType.records;

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg, state, error) {
          if (typeof(state)==='undefined') state = true;
          if(state == true){
          msg = msg + 'a success!';
          var toast = $mdToast.simple()
              .content(msg)
              .highlightAction(true)
              .hideDelay(3000)
              .theme("success-toast")
              .position('top right');
          }else if(state == "info"){
            var toast = $mdToast.simple()
              .content(msg)
              .highlightAction(true)
              .hideDelay(10000)
              .theme("orange")
              .position('top right');
          }else{
          if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
          if (typeof(error)!=='undefined') msg = error;
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("error-toast")
                .position('top right');              
          }
          $mdToast.show(toast); 
        }

        if(vm.id > 0){
          vm.client = Clients.record;          
          vm.delivery = ClientsDeliveryAddress.record;
          vm.practice = Clients.practice;
          vm.dentist = Clients.dentist;
          vm.payments = Payment.records;
          vm.discounts = Discount.records;
          vm.clientsproducts = ClientsProducts.record;
          vm.products = Products.records;
          vm.clientsemail = ClientsEmail.record;
          vm.clientstel = ClientsTel.record;
          vm.allemailsparent = ClientsEmail.allemailsparent;
          vm.alltelsparent = ClientsTel.alltelsparent;
          vm.clientsstatus = ClientsStatus.record;

          angular.forEach(vm.practice, function(practice) {
            practice.cemail = insertEmailsOnClient(practice, false, practice.clients_id);
            practice.ctel = insertTelsOnClient(practice, false, practice.clients_id);
          });
          angular.forEach(vm.dentist, function(dentist) {
            dentist.cemail = insertEmailsOnClient(dentist, false, dentist.clients_id);
            dentist.ctel = insertTelsOnClient(dentist, false, dentist.clients_id);
          });
          
          
          atualizaLength('delivery');
          atualizaLength('practice');
          atualizaLength('dentist');
        }

        function atualizaLength(type){
          if(type=="delivery"){
            vm.deliverylength = (vm.delivery!=null && typeof(vm.delivery)!=undefined) ? Object.keys(vm.delivery).length : 0;
          }
          if(type=="practice"){
            vm.practicelength = (vm.practice!=null && typeof(vm.practice)!=undefined) ? Object.keys(vm.practice).length : 0;
          }
          if(type=="dentist"){
            vm.dentistlength = (vm.dentist!=null && typeof(vm.dentist)!=undefined) ? Object.keys(vm.dentist).length : 0;
          }
        }  
        
        var botaoAddSize = 76; /* In pixels */
        var caixaAlertaSize = 200; /* In pixels */

        function atualizaDivSize(totalestados){
          var divSize = totalestados * caixaAlertaSize + botaoAddSize;
          angular.element('.order-messages-sub').css('width', divSize + 'px');        
        } 

        angular.element(document).ready(function () {
            /* console.log('page loading completed'); */
            if(vm.estados != null){
              atualizaDivSize(vm.estados.length);
            }
            var alturaprincipal = angular.element('.orders-page')[0].scrollHeight;				
            angular.element('.notes-page').css('max-height', alturaprincipal + 'px');
        });           

        vm.userid = localStorageService.get('userid');
        vm.username = localStorageService.get('username');

        vm.gotoOrderStatus = function ()
        {
            console.log('go OrderStatus');
            $state.go('app.orderstatus');
        }

        vm.gotoProfiles = function()
        {
            console.log('go Profiles');
            $state.go('app.profiles');
        }

        vm.gotoProfile = function()
        {
            console.log('go Profile');
            $state.go('app.profile', {'id': ''});
        }

        vm.saveClient = function(record){
          console.log(record);
          var msg = "Save client was ";
          if(typeof(record.clientnumber) == undefined || record.clientnumber == null || record.clients_type_id == null || typeof(record.clients_type_id) == undefined){
            var erro = "Client Type and Client No fields are required before saving client.";
            showToast(msg, false, erro);
          }else{          
            console.log(record);
            api.clients.save({ record: record }).$promise.then(function (result) { 
              console.log(result); 
              if(result.status !== 'success'){
                if(result.affectedrows == 0){
                  var erro = "No content was changed.";
                  showToast(msg, false, erro);
                }else if(result.affectedrows > 0){              
                  var erro = "Client number already exists. Please change.";
                  showToast(msg, false, erro); 
                }else{              
                  showToast(msg, false); 
                }
              }else{ 
                showToast(msg);
                if(vm.id==0){
                  $state.go('app.profile', {id: result.newclientid}); 
                }
              } }, function(error) { 
                var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                showToast(msg, false, erro); 
              });
          }
        }
        
        /* Funções para Search do Autocomplete do Product Specification */
        vm.isDisabled    = false;
        vm.selectedItemChange = selectedItemChange;
        vm.searchText    = null;
        // vm.newClient = newClient;
        vm.querySearch = querySearch;
        vm.ativa = ativa;
        vm.titulo = null;
        vm.alterar = alterar;

        function ativa(){
          vm.isDisabled = false;
          vm.titulo = "Click to change product";
        }
        function alterar(){
          var r = confirm("Are you sure you want to insert a new product?");
          if (r == true) {
            vm.isDisabled = false;
            delete vm.cliente;
            vm.jaexiste = 0;
          }
        }            
        function querySearch (query) {
          var querylower = query.toLowerCase()
          var res = vm.products.filter(function(obj){
            return obj.product_description.toLowerCase().indexOf(querylower) != -1;
          }); 
          return res;
        }            
        function selectedItemChange(item){
            vm.product = item;
        }

        vm.addProduct = function(product){
          if(typeof(product)==undefined || product == null || product.client_product_code == null || product.client_product_cost == null){
            var error = "All fields are mandatory.";
            showToast(msg, false, error);
          }else{
            var gravar = {
              clients_products_id: 0,
              clients_id: vm.id,
              products_id: product.products_id,
              client_product_code: product.client_product_code,
              client_product_cost: product.client_product_cost
            }
            console.log(gravar);

            var msg = "Adding product specification was ";
            var apiz = "clientsproducts";
            var page = "product";

            var options = {
              page: page
            }

            var f =  "genericSave(gravar, msg, options, apiz)";
            eval(f);
          } 
        }

        vm.deleteProduct = function(id){
          var apiz = "clientsproducts";
          var msg = "Product specification deletion was ";
          var page = "product";
          console.log(id);
          
          var f = 'genericDelete(id, apiz, msg, page);';
          eval(f);
        }
        /* FIM Funções para Search do Autocomplete do Product Specification */

        function isJson(str) {
          try {
              JSON.parse(str);
          } catch (e) {
              return false;
          }
          return true;
        }

        function deleteHashKey(vartypeids){
          if(vartypeids!=undefined &&  typeof(vartypeids['$$hashKey'])!=undefined){
            delete vartypeids['$$hashKey'];                
          }
        }

        function createRecordMail(clientid, clientmail, clienttypeids, clientemailid){
          if(typeof(clientemailid)==undefined){
            var recordemail = {
              clients_email_id: 0,
              clients_id: clientid,
              clients_email: clientmail,
              email_type_ids: JSON.stringify(clienttypeids)
            }                  
          }else{
            var recordemail = {
              clients_email_id: clientemailid,
              clients_id: clientid,
              clients_email: clientmail,
              email_type_ids: JSON.stringify(clienttypeids)
            }  
          }
          return recordemail;
        }

        function createRecordTel(clientid, clienttel, clienttypeids, clientetelid){
          if(typeof(clientetelid)==undefined){
            var recordtel = {
              clients_tel_id: 0,
              clients_id: clientid,
              clients_tel: encodeURIComponent(clienttel),
              tel_type_ids: JSON.stringify(clienttypeids)
            }                  
          }else{
            var recordtel = {
              clients_tel_id: clientetelid,
              clients_id: clientid,
              clients_tel: encodeURIComponent(clienttel),
              tel_type_ids: JSON.stringify(clienttypeids)
            }  
          }
          return recordtel;
        }

        function insertEmailsOnClient(type, parent, idclient){
          if(parent == true){
            var emails = vm.clientsemail;
          }else{
            var emails = vm.allemailsparent;
          }
          if((type!=null && typeof(type)!=undefined) && (emails!=null && typeof(emails)!=undefined)){
            type.cemail = emails.filter(function( obj ) {return obj.clients_id == idclient; });
            type.cemail.forEach(function(cemail) {
              if(isJson(cemail.email_type_ids)==true){
                cemail.email_type_ids = JSON.parse(cemail.email_type_ids);
              }
              if(cemail.email_type_ids && cemail.email_type_ids.constructor !== Array){
                var idz = cemail.email_type_ids;
                cemail.email_type_ids = [];
                cemail.email_type_ids[0] = idz;
              }
            });
            return type.cemail;            
          }
        }

        function insertTelsOnClient(type, parent, idclient){
          if(parent == true){
            var tels = vm.clientstel;
          }else{
            var tels = vm.alltelsparent;
          }
          if((type!=null && typeof(type)!=undefined) && (tels!=null && typeof(tels)!=undefined)){
            type.ctel = tels.filter(function( obj ) {return obj.clients_id == idclient; });
            type.ctel.forEach(function(ctel) {
              if(isJson(ctel.tel_type_ids)==true){
                ctel.tel_type_ids = JSON.parse(ctel.tel_type_ids);
              }
              if(ctel.tel_type_ids && ctel.tel_type_ids.constructor !== Array){
                var idz = ctel.tel_type_ids;
                ctel.tel_type_ids = [];
                ctel.tel_type_ids[0] = idz;
              }
              if(ctel.clients_tel){
                if(decodeURIComponent(ctel.clients_tel) !== ctel.clients_tel){
                  ctel.clients_tel = decodeURIComponent(ctel.clients_tel);
                }
              }
            });
            return type.ctel;                        
          }        
          
        }

        

        vm.genericRemoveConfirm = function(ev, apiz, page, id) {
          if(page=="delivery"){
            var option = "Delivery Address";
          }else if(page=="practice"){
            var option = "Practice";
          }else if(page=="dentist"){
            var option = "Dentist";
          }else if(page=="client"){
            var option = "Client";
          }else if(page=="alert"){
            var option = "Note/Alert";
          }
          var confirm = $mdDialog.confirm(
                    /* Este código seguinte só é preciso para mudar a cor ao botão (para vermelho para remover, por ex.) */
                    {
                        onComplete: function afterShowAnimation() {
                            var $dialog = angular.element(document.querySelector('md-dialog'));
                            var $actionsSection = $dialog.find('md-dialog-actions');
                            var $cancelButton = $actionsSection.children()[0];
                            var $confirmButton = $actionsSection.children()[1];
                            angular.element($confirmButton).addClass('md-raised md-warn');
                            angular.element($cancelButton).addClass('md-primary');
                        }
                    }
                )
                .title('Are you sure?')
                .textContent('Please confirm if you would like to remove the '+option+'.')
                .ariaLabel('Remove confirm box')
                .targetEvent(ev)
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('Yes, Remove!')
                .cancel('No, Cancel');
          $mdDialog.show(confirm).then(function() {
                var msg = option + " deletion was ";
                var record = id;
                console.log(record);
                
                genericDelete(record, apiz, msg, page);
          }, function() {
          });
        };

/*
              FUNÇÃO GENÉRICA DE POPUP
*/
      vm.openPopup = function(ev, page, id) {
        console.log("Open Popup"); 
        if(vm.id == 0){
          var msg;
          var erro = "Please save client before changing content.";
          showToast(msg, false, erro);
        }else if(page == "onstop"){
          var options = function () {
            return {
              'page': page,
              'id': id
            };
          }
          var gravar = {
            clients_status_id: '0',
            status_id: '7',
            isalert: '1',
            clients_id: vm.id,
            users_id: vm.userid,
            description: ''
          }
          var msg = "On Stop adding was ";
          var apiz = "clientsstatus";
          $mdDialog.hide();
          var f =  "genericSave(gravar, msg, options, apiz)";
          eval(f); 
        }else if(page == "offstop"){
          var options = function () {
            return {
              'page': page,
              'id': id
            };
          }
          var gravar = {
            clients_status_id: '0',
            status_id: '8',
            isalert: '1',
            clients_id: vm.id,
            users_id: vm.userid,
            description: ''
          }
          var msg = "Off Stop adding was ";
          var apiz = "clientsstatus";
          $mdDialog.hide();
          var f =  "genericSave(gravar, msg, options, apiz)";
          eval(f);         
        }else{             
          $mdDialog.show({
            controller: eval("GenericController"),
            controllerAs: 'pctrl',
            templateUrl: 'app/main/pages/profile/templates/'+page+'.html',
            parent: angular.element(document.body),
            resolve: {
              options: function () {
                return {
                  'page': page,
                  'id': id
                };
              }
            },
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: false 
          });
        };     
      }  

        function GenericController($scope, $mdDialog, options) {
            var self = this;
            $scope.id = vm.id;
            self.id = options.id;
            $scope.userid = vm.userid;
            self.payments = vm.payments;
            self.payments_id = vm.client.payments_id;
            self.discounts_id = vm.client.discounts_id;
            
            self.disabled = vm.disabled;
            
            if(options.page.toLowerCase() == "emailclient"){
              self.emailsclient = vm.clientsemail;
              angular.forEach(self.emailsclient, function(emailclient){
                emailclient.email_type_ids = JSON.parse(emailclient.email_type_ids);
              });
              self.emailsparents = vm.allemailsparent;
              self.allemailtypes = vm.allemailtypes;
            }else if(options.page.toLowerCase() == "deliveryaddress"){
              self.delivery = vm.delivery;
            }else if(options.page.toLowerCase() == "practice"){   
              self.allemailtypes = vm.allemailtypes; 
              self.allteltypes = vm.allteltypes;
              
              if(vm.practice!=null && typeof(vm.practice)!=undefined){
                self.practicez = vm.practice.filter(function( obj ) {return obj.clients_id == self.id; });
                if(self.practicez.length > 0 ){
                  self.practice = self.practicez[0];
                  self.practice.cemail = insertEmailsOnClient(self.practice, false, self.id);
                  self.practice.ctel = insertTelsOnClient(self.practice, false, self.id);
                }
              }

            }else if(options.page.toLowerCase() == "dentist"){
              self.allemailtypes = vm.allemailtypes; 
              self.allteltypes = vm.allteltypes;

              if((vm.dentist!=null && typeof(vm.dentist)!=undefined)){
                self.dentistz = vm.dentist.filter(function( obj ) {return obj.clients_id == self.id; });
                if(self.dentistz.length > 0 ){
                  self.dentist = self.dentistz[0];
                  self.dentist.cemail = insertEmailsOnClient(self.dentist, false, self.id);
                  self.dentist.ctel = insertTelsOnClient(self.dentist, false, self.id);
                }
              }
                
            }else if(options.page.toLowerCase() == "payment"){              
              self.client = vm.client;
              self.discounts = vm.discounts;
            }else if(options.page.toLowerCase() == "emails"){              
              self.allemailtypes = vm.allemailtypes;
              self.clientemail = {
                clients_id: vm.id
              };
              self.clientemail.cemail = vm.clientsemail;
              self.clientemail.cemail = insertEmailsOnClient(self.clientemail, true, $scope.id);

            }else if(options.page.toLowerCase() == "tels"){              
              self.allteltypes = vm.allteltypes;
              self.clienttel = {
                clients_id: vm.id
              };
              self.clienttel.ctel = vm.clientstel;
              
              self.clienttel.ctel = insertTelsOnClient(self.clienttel, true, $scope.id);           
            }
            $scope.cancel = function($event) {
              $mdDialog.cancel();
            };
            $scope.finish = function($event) {
              $mdDialog.hide();
            };
            $scope.gravar = function(gravar) {
              console.log(options.page);
              if(options.page.toLowerCase() == "newalert"){
                var msg = "New alert adding was ";
                var apiz = "clientsstatus"; 
              }else if(options.page.toLowerCase() == "newnote"){
                var msg = "New note adding was ";
                var apiz = "clientsstatus"; 
              }else if(options.page.toLowerCase() == "deliveryaddress"){
                if(gravar.clients_deliveryaddress_id>0){
                  var msg = "Delivery address changing was ";
                }else{
                  var msg = "Delivery address adding was ";
                }
                var apiz = "clientsdeliveryaddress";
              }else if(options.page.toLowerCase() == "practice"){
                if(gravar.clients_id>0){
                  var msg = "Practice changing was ";
                }else{
                  var msg = "Practice adding was ";
                }
                var apiz = "clients";
              }else if(options.page.toLowerCase() == "dentist"){
                if(gravar.clients_id>0){
                  var msg = "Dentist changing was ";
                }else{
                  var msg = "Dentist adding was ";
                }
                var apiz = "clients";
              }else if(options.page.toLowerCase() == "payment"){
                if(gravar.clients_id>0){
                  var msg = "Payment conditions changing was ";
                }else{
                  var msg = "Payment conditions adding was ";
                }
                var apiz = "clients";
              }else if(options.page.toLowerCase() == "emails"){
                if(gravar.clients_id>0){
                  var msg = "E-mail contacts changing was ";
                }else{
                  var msg = "E-mail contacts adding was ";
                }
                var apiz = "emails";
              }else if(options.page.toLowerCase() == "tels"){
                if(gravar.clients_id>0){
                  var msg = "Tel contacts changing was ";
                }else{
                  var msg = "Tel contacts adding was ";
                }
                var apiz = "tels";
              }             
              if(apiz=="clientsdeliveryaddress" || options.page.toLowerCase()=="payment" || apiz=="clientsstatus"){
                $mdDialog.hide();
                var f =  "genericSave(gravar, msg, options, apiz)";
                eval(f);
              }else{                
                if(apiz=="emails"){                  
                  gravar.cemail.forEach(function(cemailtype) {

                    deleteHashKey(cemailtype.email_type_ids);

                    var recordemail = createRecordMail(gravar.clients_id, cemailtype.clients_email, cemailtype.email_type_ids, cemailtype.clients_email_id);

                    api.clientsemail.save({ record: recordemail }).$promise.then(function (result) { 
                        console.log(result); 
                        if(result.affectedrows == 0 || result.status == "success"){
                          if(result.record){
                            angular.forEach(result.record, function(record){
                              record.email_type_ids = JSON.parse(record.email_type_ids);
                            });
                            vm.clientsemail = result.record;
                          }
                          $mdDialog.hide();
                          showToast(msg);
                        }
                      });
                    });        
                    $mdDialog.hide();
                    if(typeof erro != undefined){
                      showToast(msg);
                    }                
                  }else if(apiz=="tels"){
                      gravar.ctel.forEach(function(cteltype) {

                        deleteHashKey(cteltype.tel_type_ids);
                        
                        var recordtel = createRecordTel(gravar.clients_id, cteltype.clients_tel, cteltype.tel_type_ids, cteltype.clients_tel_id);

                        api.clientstel.save({ record: recordtel }).$promise.then(function (result) { 
                          console.log(result); 
                          if(result.affectedrows == 0 || result.status == "success"){                           
                            if(result.record){
                              angular.forEach(result.record, function(record){
                                record.clients_tel = decodeURIComponent(record.clients_tel);
                                record.tel_type_ids = JSON.parse(record.tel_type_ids);
                              });
                              vm.clientstel = result.record;
                            }
                            $mdDialog.hide();
                            showToast(msg);
                            } }, function(error) { 
                              var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                              showToast(msg, false, erro); 
                            });
                      });                
                    }else if(options.page.toLowerCase() == "practice"){
                        console.log(gravar);
                        var clientsid;

                        /* Inserção do Cliente */
                        api.clients.save({ record: gravar }).$promise.then(function (result) { 
                          console.log(result); 
                          if(result.affectedrows == 0 || result.status == "success"){                                                     
                            
                            if(result.practice){ 
                              vm.practice = result.practice; 
                              atualizaLength('practice'); 
                            }
                            
                            if(gravar.clients_id==0 || typeof(gravar.clients_id)==undefined){
                              gravar.clients_id = result.newclientid;
                            }
                            
                            /* Inserção do Contatos E-mail */
                            angular.forEach(gravar.cemail, function(cemail) {
                              
                              deleteHashKey(cemail.email_type_ids);

                              var recordemail = createRecordMail(gravar.clients_id, cemail.clients_email, cemail.email_type_ids, cemail.clients_email_id);
      
                              api.clientsemail.save({ 'record': recordemail, 'parent': gravar.parent }).$promise.then(function (result) { 
                                console.log(result); 
                                if(result.affectedrows == 0 || result.status == "success"){
                                  var msg = "E-mail Contacts insertion was a success";
                                  if(result.allemailsparent){                     
                                    vm.allemailsparent = result.allemailsparent;
                                  }
                                  console.log(msg);
                                  } }, function(error) { 
                                    var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                                    showToast(msg, false, erro); 
                                  });

                            });
                            console.log(gravar);
                            /* Inserção do Contatos Telefone */
                            angular.forEach(gravar.ctel, function(cteltype) {

                              deleteHashKey(cteltype.tel_type_ids);
                              
                              var recordtel = createRecordTel(gravar.clients_id, cteltype.clients_tel, cteltype.tel_type_ids, cteltype.clients_tel_id);                          

                              api.clientstel.save({ 'record': recordtel, 'parent': gravar.parent }).$promise.then(function (result) { 
                                console.log(result);
                                if(result.affectedrows == 0 || result.status == "success"){                           
                                  var msg = "Tel Contacts insertion was a success";
                                  if(result.alltelsparent){                           
                                    vm.alltelsparent = result.alltelsparent;
                                  }
                                  console.log(msg);
                                  } }, function(error) { 
                                    var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                                    showToast(msg, false, erro); 
                                  });
                            });
                            var msg = "Practice change was a ";
                            $mdDialog.hide();
                            showToast(msg);
                            } }, function(error) { 
                              var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                              showToast(msg, false, erro); 
                        });                             
                            
                                                                 
                    }else if(options.page.toLowerCase() == "dentist"){
                      console.log(gravar);
                      var clientsid;

                      /* Inserção do Cliente */
                      api.clients.save({ record: gravar }).$promise.then(function (result) { 
                        console.log(result); 
                        if(result.affectedrows == 0 || result.status == "success"){                                                     
                          
                          if(result.dentist){ 
                            vm.dentist = result.dentist; 
                            atualizaLength('dentist'); 
                          }
                          
                          if(gravar.clients_id==0 || typeof(gravar.clients_id)==undefined){
                            gravar.clients_id = result.newclientid;
                          }
                          
                          /* Inserção do Contatos E-mail */
                          angular.forEach(gravar.cemail, function(cemail) {
                            
                            deleteHashKey(cemail.email_type_ids);

                            var recordemail = createRecordMail(gravar.clients_id, cemail.clients_email, cemail.email_type_ids, cemail.clients_email_id);
    
                            api.clientsemail.save({ 'record': recordemail, 'parent': gravar.parent }).$promise.then(function (result) { 
                              console.log(result); 
                              if(result.affectedrows == 0 || result.status == "success"){
                                var msg = "E-mail Contacts insertion was a success";
                                if(result.allemailsparent){                    
                                  vm.allemailsparent = result.allemailsparent;
                                }
                                console.log(vm.allemailsparent);                                  

                                } }, function(error) { 
                                  var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                                  showToast(msg, false, erro); 
                                });

                          });
                          console.log(gravar);
                          /* Inserção do Contatos Telefone */
                          angular.forEach(gravar.ctel, function(cteltype) {

                            deleteHashKey(cteltype.tel_type_ids);
                            
                            var recordtel = createRecordTel(gravar.clients_id, cteltype.clients_tel, cteltype.tel_type_ids, cteltype.clients_tel_id);                          

                            api.clientstel.save({ 'record': recordtel, 'parent': gravar.parent }).$promise.then(function (result) { 
                              console.log(result);
                              if(result.affectedrows == 0 || result.status == "success"){                           
                                var msg = "Tel Contacts insertion was a success";
                                if(result.alltelsparent){                          
                                  vm.alltelsparent = result.alltelsparent;
                                }
                                console.log(msg);
                                } }, function(error) { 
                                  var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                                  showToast(msg, false, erro); 
                                });
                          });
                          var msg = "Dentist change was ";
                          $mdDialog.hide();
                          showToast(msg);
                          } }, function(error) { 
                            var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                            showToast(msg, false, erro); 
                      });                          
                                                               
                  }
                }
              }
            }         

        GenericController.$inject = ['$scope', '$mdDialog', 'options'];
        
        function genericSave(record, message, options, apiz)
        {
            console.log("save"+options.page+"...");
            console.log(record);

            var msg = message ? message : 'Settings changed.';
            var f = "api."+apiz+".save({ record: record }).$promise.then(function (result) { console.log(result); if(result.status !== 'success'){ showToast(msg, false) }else{ if(apiz=='clientsstatus'){ vm.clientsstatus.unshift(result.lastalert); atualizaDivSize(vm.clientsstatus.length); console.log(vm.clientsstatus); }else if(options.page=='deliveryaddress'){ vm.delivery = record; vm.delivery.clients_deliveryaddress_id = result.newdeliveryaddressid; atualizaLength('delivery'); }else if(options.page=='practice'){ if(result.practice){ vm.practice = result.practice; atualizaLength('practice'); } }else if(options.page=='dentist'){ if(result.dentist){ vm.dentist = result.dentist; atualizaLength('dentist'); } }else if(options.page=='product'){ if(result.clientsproducts){ vm.clientsproducts = result.clientsproducts; vm.product = []; vm.searchText = ''; vm.selectedItem = undefined; } } showToast(msg); } }, function(error) { var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; showToast(msg, false, erro); } );";
            console.log(f);
            eval(f);
        }

        genericSave.$inject = ['record', 'message', 'page', 'apiz'];        

        function genericDelete(record, apiz, message, page)
        {
            console.log("delete"+apiz+"...");
            console.log(record);
            var msg = message ? message : 'Change settings changed was ';          
            var f = "api."+apiz+".delete({ id: record }).$promise.then(function (result) { console.log(result); if(result.status !== 'success'){ showToast(msg, false) }else{ if(page==='alert'){vm.clientsstatus = vm.clientsstatus.filter(function( obj ) {return obj.clients_status_id != result.iddeleted; }); }else if(page==='delivery'){ vm.delivery = []; atualizaLength('delivery'); }else if(page==='practice'){ vm.practice = vm.practice.filter(function( obj ) {return obj.clients_id !== record; }); atualizaLength('practice'); }else if(page==='dentist'){ vm.dentist = vm.dentist.filter(function( obj ) {return obj.clients_id !== record; }); atualizaLength('dentist'); } else if(page==='product'){ vm.clientsproducts = vm.clientsproducts.filter(function( obj ) {return obj.clients_products_id !== record; }); }else if(page==='client'){ $state.go('app.profile', {id: ''}); } showToast(msg); } }, function(error) { var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; showToast(msg, false, erro); } );";
            eval(f);            
        }

        genericDelete.$inject = ['record', 'message', 'page', 'apiz'];

    }

    ProfileController.$inject = ['$scope', '$document', '$mdToast', '$state', '$stateParams', '$filter', 'api', 'ClientsStatus', 'ClientsTel', 'ClientsEmail', 'TelType', 'EmailType', 'Products','ClientsProducts','Discount','Payment','ClientsDeliveryAddress', 'OrdersStatusTotal', 'Clients', '$window', '$translate', '$mdDialog', 'localStorageService', '$timeout']

})();

(function ()
{
    'use strict';

    angular
        .module('app.productsgroups', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.productsgroups', {
              url      : '/productsgroups/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/productsgroups/productsgroups.html',
                      controller : 'ProductsGroupsController as vm'
                  }
              },
              resolve  : {
                  ProductsGroups: function (api, $stateParams)
                  {
                      return api.productsgroups.get({ id: $stateParams.id }).$promise;
                  }
              },               
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/productsgroups');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.productsgroups')
        .controller('ProductsGroupsController', ProductsGroupsController);

    function ProductsGroupsController($scope, $document, $mdToast, $state, api, ProductsGroups, $window, $translate, $mdDialog, localStorageService)
    {
        console.log("ProductsGroups");

        var vm = this;

        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
        }
        vm.admin = localStorageService.get('admin');
        vm.levelid = localStorageService.get('levelid');
    
        vm.disabled = false;
    
        /* Verifica se tem permissões de ver e/ou alterar conteúdos */
        if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || vm.privileges[28].privileges.view != '1'){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if((vm.privileges[28].privileges.edit == '0' || vm.privileges[28].privileges.edit == null || vm.privileges[28].privileges.edit == false) && vm.privileges[28].privileges.view == '1'){
                vm.disabled = true;
            }
        }

        vm.caixaedicao = 0;    
    
        vm.gotoProducts = gotoProducts;

        function gotoProducts()
        {
            console.log('go Products');
            $state.go('app.products');
        }

        vm.groups = ProductsGroups.records;        

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg, state, error) {
            if (typeof(state)==='undefined') state = true;
            if(state == true){
            msg = msg + 'a success!';
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');
            }else if(state == "info"){
              var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(10000)
                .theme("orange")
                .position('top right');
            }else{
            if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
            if (typeof(error)!=='undefined') msg = error;
              var toast = $mdToast.simple()
                  .content(msg)
                  .highlightAction(true)
                  .hideDelay(3000)
                  .theme("error-toast")
                  .position('top right');              
            }
            $mdToast.show(toast); 
        }

        vm.editGroup = editGroup;
        vm.saveExistGroup = saveExistGroup;
        vm.deleteExistGroup = deleteExistGroup;

        function editGroup(id){
            vm.caixaedicao = 1;            
            api.productsgroups.query({ id: id }).$promise.then(function (result) {
                vm.grupo = result.record;                
            });
        }

        function saveExistGroup(record)
        {          
           console.log("saveExistGroup...");
           console.log(record);
            var msg = 'Group saved! Please wait...';
            api.productsgroups.save({ record: record }).$promise.then(function (result) {
                showToast(msg);
                setTimeout(function () { // wait 0.5 second and reload
                  $state.go($state.current, {}, {reload: true});
                }, 500);                
                
          });
        }

function deleteExistGroup(ev, id) {
          var confirm = $mdDialog.confirm(
                    /* Este código seguinte só é preciso para mudar a cor ao botão (para vermelho para remover, por ex.) */
                    {
                        onComplete: function afterShowAnimation() {
                            var $dialog = angular.element(document.querySelector('md-dialog'));
                            var $actionsSection = $dialog.find('md-dialog-actions');
                            var $cancelButton = $actionsSection.children()[0];
                            var $confirmButton = $actionsSection.children()[1];
                            angular.element($confirmButton).addClass('md-raised md-warn');
                            angular.element($cancelButton).addClass('md-primary');
                        }
                    }
                )
                .title('Are you sure?')
                .textContent('Please confirm if you would like to remove this group.')
                .ariaLabel('Remove confirm box')
                .targetEvent(ev)
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('Yes, Remove!')
                .cancel('No, Cancel');
          $mdDialog.show(confirm).then(function() {
                console.log(id);
                deleteGroup(id);
          }, function() {
//            $scope.status = 'You decided to keep your debt.';
          });
        };        

        function deleteGroup(id)
        {          
            console.log("deleteExistGroup...");
            console.log(id);
            var msg = 'Group deleted! Please wait...';
            api.productsgroups.delete({id: id}).$promise.then(function (result) {
                showToast(msg);
                setTimeout(function () { // wait 0.5 second and reload
                  $state.go($state.current, {}, {reload: true});
                }, 500);                
                
          });
        }                
    }
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.products', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.products', {
              url      : '/products/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/products/products.html',
                      controller : 'ProductsController as vm'
                  }
              },
              resolve  : {
                  Products: function (api, $stateParams)
                  {
                      return api.products.get({ id: $stateParams.id }).$promise;
                  },
                  ProductsGroups: function (api, $stateParams)
                  {
                      return api.productsgroups.get({ id: $stateParams.id }).$promise;
                  },
                  Departments: function (api, $stateParams)
                  {
                      return api.departments.get({ id: $stateParams.id }).$promise;
                  }
              },               
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/products');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.products')
        .controller('ProductsController', ProductsController);

    function ProductsController($scope, $document, $mdToast, $state, api, Products, ProductsGroups, Departments, $window, $translate, $mdDialog, localStorageService)
    {
        console.log("Products");

        var vm = this;

        vm.userid = localStorageService.get('userid');
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
        }
        vm.admin = localStorageService.get('admin');
        vm.levelid = localStorageService.get('levelid');
    
        vm.disabled = false;
        vm.blockpricechange = false;
    
        /* Verifica se tem permissões de ver e/ou alterar conteúdos */
        if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || vm.privileges[26].privileges.view != '1'){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if((vm.privileges[26].privileges.edit == '0' || vm.privileges[26].privileges.edit == null || vm.privileges[26].privileges.edit == false) && vm.privileges[26].privileges.view == '1'){
                vm.disabled = true;
            }
            if(vm.privileges[27].privileges.edit == '0' || vm.privileges[27].privileges.edit == null || vm.privileges[27].privileges.edit == false){
                vm.blockpricechange = true;
            }
        }

        vm.caixaedicao = 0;
        vm.caixaedicaomulti = 0;    
    
        vm.gotoProductGroups = gotoProductGroups;

        function gotoProductGroups()
        {
            console.log('go ProductsGroups');
            $state.go('app.productsgroups');
        }

        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth()+1; //January is 0!
        var yyyy = today.getFullYear();

        if(dd<10) {
            dd = '0'+dd
        } 

        if(mm<10) {
            mm = '0'+mm
        } 

        today = yyyy + '/' + mm + '/' + dd;        

        vm.products = Products.records;
        vm.groups = ProductsGroups.records;
        vm.departamentos = Departments.records;

        vm.editProduct = editProduct;
        vm.saveExistProduct = saveExistProduct;
        vm.deleteExistProduct = deleteExistProduct;
        vm.cancel = cancel;
        vm.saveNewProduct = saveNewProduct;
        vm.saveProducts = saveProducts;
        vm.deleteProducts = deleteProducts;

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg, state, error) {
            if (typeof(state)==='undefined') state = true;
            if(state == true){
            msg = msg + 'a success!';
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');
            }else if(state == "info"){
              var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(10000)
                .theme("orange")
                .position('top right');
            }else{
            if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
            if (typeof(error)!=='undefined') msg = error;
              var toast = $mdToast.simple()
                  .content(msg)
                  .highlightAction(true)
                  .hideDelay(3000)
                  .theme("error-toast")
                  .position('top right');              
            }
            $mdToast.show(toast); 
        }

        function editProduct(id){
            vm.caixaedicao = 1;
            vm.caixaedicaomulti = 0;            
            api.products.query({ id: id }).$promise.then(function (result) {
                vm.produto = result.record;
                console.log(vm.produto);                
            });
        }

               
        function deleteProducts(){
            var msg;
            // var newestArray = []; 
            var data = getSelectedRows();
            var i = '';
            for (i = 0; i < data.length; i++) {
                    // newestArray.push(data[i].products_id);
                    api.products.delete({id: data[i].products_id})
            }
                msg = "Products were deleted sucessfully. Please wait..."
                showToast(msg);
                setTimeout(function () { // wait 0.5 second and reload
                  $state.go($state.current, {}, {reload: true});
                }, 500);
        }

        function saveNewProduct(record)
        {  
            record.date = today;        
           console.log("saveNewProduct...");
           console.log(record);
            var msg = 'Saving product was ';
            api.products.save({ record: record }).$promise.then(function (result) {
                if(result.status == "success"){                    
                    record.products_id = result.newproductid;
                    vm.products.push(record);
                    showToast(msg);
                }else{
                    showToast(msg, false);
                }                
            });
        }        

        function saveExistProduct(record)
        {          
           console.log("saveExistProduct...");
           console.log(record);
           var msg = 'Updading product was ';
            api.products.save({ record: record }).$promise.then(function (result) {
                console.log(result);
                if(result.status == "success"){                   
                    angular.forEach(vm.products, function(product, key){
                        if(product.products_id == record.products_id){
                            vm.products[key] = record;
                        }                        
                    });
                    showToast(msg);
                }else{
                    showToast(msg, false);
                }                
          });
        }

        function deleteExistProduct(ev, id) {
          var confirm = $mdDialog.confirm(
                    /* Este código seguinte só é preciso para mudar a cor ao botão (para vermelho para remover, por ex.) */
                    {
                        onComplete: function afterShowAnimation() {
                            var $dialog = angular.element(document.querySelector('md-dialog'));
                            var $actionsSection = $dialog.find('md-dialog-actions');
                            var $cancelButton = $actionsSection.children()[0];
                            var $confirmButton = $actionsSection.children()[1];
                            angular.element($confirmButton).addClass('md-raised md-warn');
                            angular.element($cancelButton).addClass('md-primary');
                        }
                    }
                )
                .title('Are you sure?')
                .textContent('Please confirm if you would like to remove this product.')
                .ariaLabel('Remove confirm box')
                .targetEvent(ev)
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('Yes, Remove!')
                .cancel('No, Cancel');
          $mdDialog.show(confirm).then(function() {
                console.log(id);
                deleteProduct(id);
          }, function() {
//            $scope.status = 'You decided to keep your debt.';
          });
        };        

        function deleteProduct(id)
        {          
            console.log("deleteProduct...");
            console.log(id);
            var msg = 'Product deleted! Please wait...';
            api.products.delete({id: id}).$promise.then(function (result) {
                showToast(msg);
                setTimeout(function () { // wait 0.5 second and reload
                  $state.go($state.current, {}, {reload: true});
                }, 500);                
                
          });
        }

        function cancel()
        {
            vm.caixaedicao = 0;
            vm.caixaedicaomulti = 0;
            vm.produto = [];
        }

        vm.total = function(){
            var rate = vm.produto.rate;
            var vat = vm.produto.VAT;
            
            if(rate > 0 && vat > 0)
            {
                return Math.round(rate * (1 + vat / 100) * 100) / 100;
            }else if (rate > 0 && vat == 0){
                return Math.round(rate * 100) / 100;
            }          
        }

        vm.vatamount = function(){
            var rate = vm.produto.rate;
            var vat = vm.produto.VAT;
            
            if(rate > 0 && vat > 0)
            {
                return Math.round(rate * (vat / 100) * 100) / 100;
            }else if (rate > 0 && vat == 0){
                return 0;
            }         
        }

        /* Datatables - Multi Select */
        var selectedRowsIndexes = [];

        $scope.selectRow = function(event, rowIndex) {
            if(event.ctrlKey) {
                changeSelectionStatus(rowIndex);
            } else if(event.shiftKey) {
                selectWithShift(rowIndex);
            } else {
                selectedRowsIndexes = [rowIndex];
            }
            // console.log(selectedRowsIndexes);
            //console.log(getSelectedRows());
            // console.log(getFirstSelectedRow());
            if(getSelectedRows().length > 1){
                vm.caixaedicaomulti = 1;
                vm.caixaedicao = 0;
            }

        };

        function selectWithShift(rowIndex) {
            var lastSelectedRowIndexInSelectedRowsList = selectedRowsIndexes.length - 1;
            var lastSelectedRowIndex = selectedRowsIndexes[lastSelectedRowIndexInSelectedRowsList];
            var selectFromIndex = Math.min(rowIndex, lastSelectedRowIndex);
            var selectToIndex = Math.max(rowIndex, lastSelectedRowIndex);
            selectRows(selectFromIndex, selectToIndex);
        }

        function getSelectedRows() {
            var selectedRows = [];
            angular.forEach(selectedRowsIndexes, function(rowIndex) {
                selectedRows.push(vm.products[rowIndex]);
            });
            return selectedRows;
        }

        function getFirstSelectedRow() {
            var firstSelectedRowIndex = selectedRowsIndexes[0];
            return vm.products[firstSelectedRowIndex];
        }

        function selectRows(selectFromIndex, selectToIndex) {
            for(var rowToSelect = selectFromIndex; rowToSelect <= selectToIndex; rowToSelect++) {
                select(rowToSelect);
            }
        }

        function changeSelectionStatus(rowIndex) {
            if($scope.isRowSelected(rowIndex)) {
                unselect(rowIndex);
            } else {
                select(rowIndex);
            }
        }

        function select(rowIndex) {
            if(!$scope.isRowSelected(rowIndex)) {
                selectedRowsIndexes.push(rowIndex)
            }
        }

        function unselect(rowIndex) {
            var rowIndexInSelectedRowsList = selectedRowsIndexes.indexOf(rowIndex);
            var unselectOnlyOneRow = 1;
            selectedRowsIndexes.splice(rowIndexInSelectedRowsList, unselectOnlyOneRow);
        }

        function resetSelection() {
            selectedRowsIndexes = [];
        }

        $scope.isRowSelected = function(rowIndex) {
            return selectedRowsIndexes.indexOf(rowIndex) > -1;
        };

        var finalData;

        function saveProducts(data){

            // console.log(getSelectedRows());
            // console.log(data);
            var selectedData = getSelectedRows();
            // console.log(selectedData);
            var i;
            var msg;
          
            if (typeof data !== 'undefined') {
                for (i = 0; i < selectedData.length; i++) {
                    if (typeof data.costincrease !== 'undefined' && typeof data.costdecrease === 'undefined') {
                        selectedData[i].rate = selectedData[i].rate * (1 + data.costincrease/100);
                    }                  
                    if (typeof data.costincrease === 'undefined' && typeof data.costdecrease !== 'undefined') {
                        selectedData[i].rate = selectedData[i].rate * (1 - data.costdecrease/100);
                    }
                    if (typeof data.upperlower !== 'undefined' ) { 
                        selectedData[i].upperlower = data.upperlower;
                    }
                    if (typeof data.products_groups_id !== 'undefined' ) { 
                        selectedData[i].products_groups_id = data.products_groups_id;
                    }
                    // if (typeof data.departments_id !== 'undefined' ) { 
                    //     selectedData[i].departments_id = data.departments_id;
                    // }
                    delete selectedData[i]['group_name'];
                    delete selectedData[i]['date'];
                    delete selectedData[i]['VAT'];
                    delete selectedData[i]['product_description'];
                    delete selectedData[i]['product_code'];
                }
            }

            // console.log(selectedData);    
            msg = "Products saved sucessfully. Please wait..."
            api.products.save({ record: selectedData }).$promise.then(function (result) {
                console.log(result);
                showToast(msg);
                setTimeout(function () { // wait 0.5 second and reload
                  $state.go($state.current, {}, {reload: true});
                }, 500);                
                
            });
        }
        

    }        
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.production', ['ngMask', 'moment-picker'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        console.log("production module"); 
        $stateProvider
          .state('app.production', {
              url      : '/Production/:module/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/production/production.html',
                      controller : 'ProductionController as vm'
                  }
              },
              resolve  : {               
                  OrdersStatusTotal: function (api)
                    {
                    return api.orders.get({ id: 'orderstatus' }).$promise;
                    },
                  Shipping: function (api, $stateParams)
                  {
                    return api.shipping.get({ id: $stateParams.id }).$promise;
                  },
                  OrdersPlasterroom: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                        return api.ordersplasterroom.get({ id: $stateParams.id }).$promise;
                    }
                  },
                  OrdersScanning: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                        return api.ordersscanning.get({ id: $stateParams.id }).$promise;
                    }
                  },
                  OrdersPlatforms: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                        return api.ordersplatforms.get({ id: $stateParams.id }).$promise;
                    }
                  },
                  OrdersDesigning: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                        return api.ordersdesigning.get({ id: $stateParams.id }).$promise;
                    }
                  },
                  OrdersManufacturing: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                        return api.ordersmanufacturing.get({ id: $stateParams.id }).$promise;
                    }
                  },
                  OrdersMatching: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                        return api.ordersmatching.get({ id: $stateParams.id }).$promise;
                    }
                  },
                  OrdersPlanning: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                        return api.ordersplanning.get({ id: $stateParams.id }).$promise;
                    }
                  },
                  OrdersDrillingDesign: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                        return api.ordersdrillingdesign.get({ id: $stateParams.id }).$promise;
                    }
                  },
                  OrdersDrillingPrinting: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                        return api.ordersdrillingprinting.get({ id: $stateParams.id }).$promise;
                    }
                  },
                  OrdersDrillingAssembly: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                        return api.ordersdrillingassembly.get({ id: $stateParams.id }).$promise;
                    }
                  },
                  OrdersCaseAssessment: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                        return api.orderscaseassessment.get({ id: $stateParams.id }).$promise;
                    }
                  },
                  OrdersClearMovement: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                        return api.ordersclearmovement.get({ id: $stateParams.id }).$promise;
                    }
                  },
                  OrdersBracketMovement: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                        return api.ordersbracketmovement.get({ id: $stateParams.id }).$promise;
                    }
                  },
                  OrdersClearManufacturing: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                        return api.ordersclearmanufacturing.get({ id: $stateParams.id }).$promise;
                    }
                  },
                  OrdersInCaseAssessment: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                        return api.ordersincaseassessment.get({ id: $stateParams.id }).$promise;
                    }
                  },
                  OrdersInMovement: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                        return api.ordersinmovement.get({ id: $stateParams.id }).$promise;
                    }
                  },
                  OrdersInManufacturing: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                        return api.ordersinmanufacturing.get({ id: $stateParams.id }).$promise;
                    }
                  },
                  OrdersWaitingCall: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                        return api.orderswaitingcall.get({ id: $stateParams.id }).$promise;
                    }
                  },
                  OrdersPackaging: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                        return api.orderspackaging.get({ id: $stateParams.id }).$promise;
                    }
                  },
                  OrdersDepartments: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                        return api.ordersdepartments.get({ id: $stateParams.id }).$promise;
                    }
                  },
                  Orders: function (api, $stateParams)
                  {
                      return api.orders.get({ id: $stateParams.id }).$promise;
                  },
                  OrdersOpened: function (api, $stateParams, localStorageService)
                  {
                      var userid = localStorageService.get('userid');
                      return api.ordersopened.get({ id: userid }).$promise;
                  }, 
                  Cliente: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                      return api.clients.get({ id: "SO"+$stateParams.id }).$promise;
                    }
                  }, 
                  Departments: function (api, $stateParams)
                  {
                    return api.departments.get().$promise;
                  }, 
                  DeliveryRoutes: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                      return api.deliveryroutes.get().$promise;
                    }
                  },
                  InvoicesOrders: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                      return api.invoicesorders.get({ id: "O"+$stateParams.id }).$promise;
                    }
                  }                 
              },             
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/shipping');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.production')
        .controller('ProductionController', ProductionControllerF)        
        .factory('getService', function($http, CONFIG) {
          var getService = {
            async: function(controller, id, cache) {
              /* $http returns a promise, which has a then function, which also returns a promise */
              var promise = $http({
                cache: cache,
                method: 'GET',    
                url: CONFIG.apiBaseUrl + controller + '/' + id
              }).then(function (response) {
                /* The then function here is an opportunity to modify the response */
                console.log(response);
                /* The return value gets picked up by the then in the controller. */
                return response.data;
              });
              /* Return the promise to the controller */
              return promise;
            }
          };
          return getService;
        })
        .filter('cmdate', [
          '$filter', function($filter) {
              return function(input, format) {
                  return $filter('date')(new Date(input), format);
              };
          }
        ])
        .filter('range', function() {
          return function(input, total) {
            total = parseInt(total);
        
            for (var i=0; i<total; i++) {
              input.push(i);
            }
        
            return input;
          };
        })
        .directive('orderAvailable', function($timeout, $q, CONFIG, $http, $state, $mdDialog, api, localStorageService) {
          return {
            restrict: 'AE',
            require: 'ngModel',
            link: function($scope, elm, attr, model) { 
              model.$asyncValidators.orderExists = function(modelValue, viewValue) {
                var valuez = modelValue || viewValue;
                var value = valuez.substr(1);                           
                  return $http.get(CONFIG.apiBaseUrl + 'Orders/con' + value).
                     then(function (response) {
                       console.log(response.data.status);
                       if(response.data.status == "success"){
                        model.$setValidity('erro', true);
                        var orderid = response.data.orderid.orders_id;
                        if(orderid != $state.params.id){
                          $mdDialog.cancel();
                          var active_module = $state.params.module.toLowerCase();
                          var departmentid;
                          switch(active_module) {
                            case 'generateorder':
                              departmentid = 1;
                              break;
                            case 'plasterroom':
                              departmentid = 2;
                              break;
                            case 'scanning':
                              departmentid = 3;
                              break;
                            case 'platforms':
                              departmentid = 4;
                              break;
                            case 'designing':
                              departmentid = 5;
                              break;
                            case 'manufacturing':
                              departmentid = 6;
                              break;
                            case 'matching':
                              departmentid = 7;
                              break;
                            case 'planning':
                              departmentid = 8;
                              break;
                            case 'drillingdesign':
                              departmentid = 9;
                              break;
                            case 'drillingprinting':
                              departmentid = 10;
                              break;
                            case 'drillingassembly':
                              departmentid = 11;
                              break;
                            case 'caseassessment':
                              departmentid = 12;
                              break;
                            case 'clearmovement':
                              departmentid = 13;
                              break;
                            case 'bracketmovement':
                              departmentid = 14;
                              break;
                            case 'clearmanufacturing':
                              departmentid = 15;
                              break;
                            case 'inmancaseassessment':
                              departmentid = 16;
                              break;
                            case 'movement':
                              departmentid = 17;
                              break;
                            case 'inmanmanufacturing':
                              departmentid = 18;
                              break;
                            case 'waiting':
                              departmentid = 19;
                              break;
                            case 'packaging':
                              departmentid = 20;
                              break;
                            case 'shipping':
                              departmentid = 21;
                              break;
                            default:
                              departmentid = 0;
                        }
                          var userid = localStorageService.get('userid');
                          var record = {};                      
                          record = {
                            orders_opened_id: 0,
                            orders_id: orderid,
                            users_id: userid,
                            departments_id: departmentid,
                            dld: 0
                          }             
                          api.ordersopened.save({ record: record, orderid: orderid });
                          $timeout( function(){ 
                            $state.go('app.production', {id: orderid});
                          }, 200 );                         
                        }else{
                          model.$setValidity('opened', false);
                          return false;
                        }
                        return true;
                       }else if(response.data.status == "failed"){             
                        model.$setValidity('erro', false);
                        return false;
                       }                       
                     }, function rejected() {
                      console.log("erro 4xx");                       
                     });            
              };
            }
          } 
        })
        .directive('printDiv', function () {
          return {
            restrict: 'A',
            link: function(scope, element, attrs) {
              element.bind('click', function(evt){    
                evt.preventDefault();    
                PrintElem(attrs.printDiv);
              });
        
              function PrintElem(elem)
              {
                PrintWithIframe($(elem).html());
              }
        
              function PrintWithIframe(data) 
              {
                console.log(data);
                if ($('iframe#printf').length == 0) {
                  $('html').append('<iframe id="printf" name="printf"></iframe>');
        
                  var mywindow = window.frames["printf"];
                  mywindow.document.write('<html><head><title></title><style>@page {margin: 2cm; font-family: "Roboto", "Helvetica Neue", "Arial", sans-serif; font-size: 14px;}</style>'
                                  + '</head><body><div>'
                                  + data
                                  + '</div></body></html>');
        
                  $(mywindow.document).ready(function(){
                    mywindow.print();
                    setTimeout(function(){
                      $('iframe#printf').remove();
                    },
                    2000);
                  });
                }
        
                return true;
              }
            }
          };
        });        

    function ProductionControllerF($compile, $scope, $document, $mdToast, $state, $stateParams, $http, getService, InvoicesOrders, Cliente, Departments, DeliveryRoutes, OrdersDepartments, OrdersStatusTotal, Shipping, OrdersOpened, OrdersCaseAssessment, OrdersClearMovement, OrdersBracketMovement, OrdersClearManufacturing, OrdersInCaseAssessment, OrdersInMovement, OrdersInManufacturing, OrdersWaitingCall, OrdersPackaging, OrdersPlasterroom, OrdersScanning, OrdersPlatforms, OrdersDesigning, OrdersManufacturing, OrdersMatching, OrdersPlanning, OrdersDrillingDesign, OrdersDrillingPrinting, OrdersDrillingAssembly, Orders, $filter, api, $window, $translate, $mdDialog, localStorageService, Upload, $timeout, CONFIG, DTOptionsBuilder,DTColumnBuilder,$location)    
    {
        var vm = this;

        vm.baseurl = $window.location.origin;
        if(vm.baseurl == "http://localhost:3000"){
          vm.baseurl = "https://nimrodtrac.app";
        }

        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
          vm.privileges = JSON.parse(localStorageService.get('privileges'));
        }
        vm.admin = localStorageService.get('admin');
        vm.levelid = localStorageService.get('levelid');        
        
        vm.disabled = false;
        
        var active_module = $state.params.module.toLowerCase();
        vm.active_module = active_module;
        console.log(vm.active_module);
        var depts = {
            generateorder: false,
            plasterroom: false,
            scanning: false,
            platforms: false,
            designing: false,
            manufacturing: false, 

            matching: false,
            planning: false,
            drillingdesign: false,
            drillingprinting: false,
            drillingassembly: false,

            caseassessment: false,
            clearmovement: false,
            bracketmovement: false,
            clearmanufacturing: false,

            inmancaseassessment: false,
            movement: false,
            inmanmanufacturing: false,

            waiting: false,
            packaging: false,
            shipping: false
        }
        var key;

        for (key in depts) {
            if (depts.hasOwnProperty(key)) {
                depts[key] = true;
                if(key == active_module) {
                    break;
                }
            }
        }
        vm.depts = depts;

        vm.onstoporders = OrdersStatusTotal.onstoporders;        
        vm.dueorders = OrdersStatusTotal.dueorders;
        vm.approvedvia = OrdersStatusTotal.approvedvia;
        vm.approvedwaiting = OrdersStatusTotal.approvedwaiting;
        vm.waitingcall = OrdersStatusTotal.waitingcall;
        vm.waitingimpression = OrdersStatusTotal.waitingimpression;
        vm.inactiveorders = OrdersStatusTotal.inactiveorders;        
        vm.numcompleted = OrdersStatusTotal.numcompleted;   

        var actions = {
          'generateorder': {            
            'name': 'Generate Order'
          }, 
          'orderinfo': {            
            'msg' : 'Change Order Info was ',
            'api': 'shipping',
            'name': 'Order Info'
          },          
          'ordercontent': {
            'msg' : 'Change Order Content was ',
            'api': 'orderscontent',
            'name': 'Order Content'
          },
          'plasterroom': {
            'msg' : 'Change PlasterRoom was ',
            'api': 'ordersplasterroom',
            'name': 'Plaster Room'
          },
          'scanning': {
            'msg' : 'Change Scanning was ',
            'api': 'ordersscanning',
            'name': '3D - Scanning'
          },
          'platforms': {
            'msg' : 'Change Platforms was ',
            'api': 'ordersplatforms',
            'name': '3D - Platforms'
          },
          'designing': {
            'msg' : 'Change Designing was ',
            'api': 'ordersdesigning',
            'name': '3D - Designing'
          },
          'manufacturing': {
            'msg' : 'Change Manufacturing was ',
            'api': 'ordersmanufacturing',
            'name': '3D - Manufacturing'
          },
          'matching': {
            'msg' : 'Change Matching was ',
            'api': 'ordersmatching',
            'name': 'Implants - Matching'
          },
          'planning': {
            'msg' : 'Change Planning was ',
            'api': 'ordersplanning',
            'name': 'Implants - Planning'
          },
          'drillingdesign': {
            'msg' : 'Change Drilling Guide Design was ',
            'api': 'ordersdrillingdesign',
            'name': 'Implants - Drilling Guide Design'
          },
          'drillingprinting': {
            'msg' : 'Change Drilling Guide Printing was ',
            'api': 'ordersdrillingprinting',
            'name': 'Implants - Drilling Guide Printing'
          },
          'drillingassembly': {
            'msg' : 'Change Drilling Guide Assembly was ',
            'api': 'ordersdrillingassembly',
            'name': 'Implants - Drilling Guide Assembly'
          },
          'caseassessment': {
            'msg' : 'Change Case Assessment was ',
            'api': 'orderscaseassessment',
            'name': 'Clear Aligner - Case Assessment'
          },
          'clearmovement': {
            'msg' : 'Change Movement was ',
            'api': 'ordersclearmovement',
            'name': 'Clear Aligner - Clear Movement'
          },
          'bracketmovement': {
            'msg' : 'Change Bracket Movement was ',
            'api': 'ordersbracketmovement',
            'name': 'Clear Aligner - Bracket Movement'
          },
          'clearmanufacturing': {
            'msg' : 'Change Manufacturing was ',
            'api': 'ordersclearmanufacturing',
            'name': 'Clear Aligner - Manufacturing'
          },
          'inmancaseassessment': {
            'msg' : 'Change Case Assessment was ',
            'api': 'ordersincaseassessment',
            'name': 'Removable Appliance - Case Assessment'
          },          
          'movement': {
            'msg' : 'Change Movement was ',
            'api': 'ordersinmovement',
            'name': 'Removable Appliance - Movement'
          },
          'inmanmanufacturing': {
            'msg' : 'Change Manufacturing was ',
            'api': 'ordersinmanufacturing',
            'name': 'Removable Appliance - Manufacturing'
          },
          'waiting': {
            'msg' : 'Change Waiting Call was ',
            'api': 'orderswaitingcall',
            'name': 'Waiting for Call'
          },
          'packaging': {
            'msg' : 'Change Packaging was ',
            'api': 'orderspackaging',
            'name': 'Packaging'
          }
        };

        vm.actions = actions;

       var popuptypes = {
          'cancelOrder': {
            'msg' : 'New Cancel Alert was ',
            'api' : 'orderstatus'
          },
          'approveOrder': {
            'msg' : 'New Approve Alert was ',
            'api' : 'orderstatus'
          },
          'waitingImpressions': {
            'msg' : 'New WFI Alert was ',
            'api' : 'orderstatus'
          },
          'waitingCall': {
            'msg' : 'New WFC Alert was ',
            'api' : 'orderstatus'
          },
          'completeOrder': {
            'msg' : 'New Complete Order Alert was ',
            'api' : 'orderstatus'
          },
          'newOrderAlert': {
            'msg' : 'New Custom Order Alert was ',
            'api' : 'orderstatus'
          },
          'addNewMessage': {
            'msg' : 'New Comment Message was ',
            'api' : 'ordercomments'
          },
          'addNewDeliveryRoute': {
            'msg' : 'Delivery Route Change was ',
            'api' : 'shipping'
          },
          'RemoveDeliveryRoute': {
            'msg' : 'Delivery Route Removal was ',
            'removemsg' : 'Please confirm if you would like to remove the Delivery Route.',
            'api' : 'shipping'
          },
          'addNewLinkOrder': {
            'msg' : 'New Link Order was ',
            'api' : 'orderslinked'
          },
          'removeLinkedOrder': {
            'msg' : 'Link Order removal was ',
            'removemsg' : 'Please confirm if you would like to remove this Linked Order.',
            'api' : 'orderslinked'
          },
          'addLabDoc': {
            'msg' : 'New Lab Doc was '
          },
          'removeLabDoc': {
            'msg' : 'Lab Doc removal was ',
            'removemsg' : 'Please confirm if you would like to remove this Lab Doc.',
            'api' : 'orderslabdocs'
          },
          'showCaseType': {
            'msg' : 'Case Type Change was ',
            'api' : 'casetype'
          },
          'addNewProduct': {
            'msg' : 'Adding New Product(s) was ',
            'api' : 'ordersproduct'
          },
          'removeProduct': {
            'msg' : 'Product removal was ',
            'removemsg' : 'Please confirm if you would like to remove this product.',
            'api' : 'ordersproduct'
          },
          'removeProducts': {
            'msg' : 'All Product removal was ',
            'removemsg' : 'Please confirm if you would like to remove all products.',
            'api' : 'ordersproduct'
          },
          'verified': {
            'msg' : 'Verify Order Change was ',
            'api' : 'shipping'
          },
          'treatmentplan_upper': {
            'msg' : 'Treatment Plan Upper Change was ',
            'api' : 'shipping'
          },
          'treatmentplan_lower': {
            'msg' : 'Treatment Plan Lower Change was ',
            'api' : 'shipping'
          },
          'approvedvia': {
            'msg' : 'Approved Via Change was ',
            'api' : 'shipping'
          },
          'search': {
            'msg' : 'Order opening was ',
            'api' : 'ordersopened'
          },
          'changeOrderStatus': {
            'msg' : 'Order Status Change was ',
            'api' : 'shipping'
          }
          
       };

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg, state, error) {
            if (typeof(state)==='undefined') state = true;
            if(state == true){
            msg = msg + 'a success!';
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');
            }else if(state == "info"){
              var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(10000)
                .theme("orange")
                .position('top right');
            }else{
            if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
            if (typeof(error)!=='undefined') msg = error;
              var toast = $mdToast.simple()
                  .content(msg)
                  .highlightAction(true)
                  .hideDelay(3000)
                  .theme("error-toast")
                  .position('top right');              
            }
            $mdToast.show(toast);
        }        
        
        vm.order = Shipping.records ? Shipping.records : null;
        vm.estados = Shipping.estados ? Shipping.estados : null;       
        
        vm.casetypes = Shipping.casetypes;
        vm.dldactions = Shipping.dldactions;
        vm.comments = Shipping.comments;
        vm.linkedorders = Shipping.linkedorders;
        vm.labdocs = Shipping.labdocs;
        vm.orderscontent = Shipping.orderscontent;
        vm.products = Shipping.products;      
        
        vm.orders_opened = OrdersOpened.record;        

        vm.departments = Departments.records;
        vm.departments.forEach(function(department) {
          if(department.department_alias == active_module){
            vm.departmentsid = department.departments_id;              
          }
        });

        /* Verifica se tem permissões de ver e/ou alterar conteúdos */
        if(vm.admin != '1' && vm.levelid != '1'){
          var conta = 0;
          vm.privileges.forEach(function(privilege){
            if(privilege.privileges_id == vm.departmentsid){
              if((privilege.privileges.edit == '0' || privilege.privileges.edit == null || privilege.privileges.edit == false) && privilege.privileges.view == '1'){
                vm.disabled = true;
              }else if(privilege.privileges.view != '1'){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
              }
              conta++;
            }
          });
          if(conta == 0){
            var infor = "You don't have enough permission to enter this area.";
            showToast(infor, "info");
            $state.go('app.dashboard');
          }
        }

        vm.id = Shipping.id ? Shipping.id : 0; /* If existing order ID else new order ID */
        if(vm.id > 0){ 
          

          vm.dld = 1; /* Default access = DLD */
          vm.orders_opened.forEach(function(order) {
            if(order.orders_id == vm.id){
              vm.dld = order.dld; /* The exception if it has dld = 0 */
            }
          });
          if(vm.dld == 1){
            var msg = "You are viewing the DLD.";
            showToast(msg, "info");
          }

          vm.ordersdepartments = OrdersDepartments.record;
          /*vm.statuses = Shipping.statuses;*/

          vm.plasterroom = OrdersPlasterroom.record;
          vm.scanning = OrdersScanning.record;
          vm.platforms = OrdersPlatforms.record;
          vm.designing = OrdersDesigning.record;
          vm.manufacturing = OrdersManufacturing.record;
          vm.matching = OrdersMatching.record;
          vm.planning = OrdersPlanning.record;
          vm.dridesign = OrdersDrillingDesign.record;
          vm.driprinting = OrdersDrillingPrinting.record;
          vm.driassembly = OrdersDrillingAssembly.record;
          vm.caseassessment = OrdersCaseAssessment.record;
          vm.clearmovement = OrdersClearMovement.record;
          vm.bracketmovement = OrdersBracketMovement.record;
          vm.clearmanufacturing = OrdersClearManufacturing.record;
          vm.incaseassessment = OrdersInCaseAssessment.record;
          vm.inmovement = OrdersInMovement.record;
          vm.inmanufacturing = OrdersInManufacturing.record;
          vm.waiting = OrdersWaitingCall.record;
          vm.packaging = OrdersPackaging.record;

          vm.cliente = Cliente.cliente;
          vm.droutes = DeliveryRoutes.records;

          atualizaEstados();          
          atualizaStatus();
          vm.verified = vm.order[0].verified == 1 ? vm.verified = true : false;
          vm.treatmentplan_upper = vm.order[0].treatmentplan_upper == 1 ? vm.treatmentplan_upper = true : false;
          vm.treatmentplan_lower = vm.order[0].treatmentplan_lower == 1 ? vm.treatmentplan_lower = true : false;

          /* Deselect SetUp on Manufacturing */
          if(vm.departmentsid == 6 || vm.departmentsid == 15 || vm.departmentsid == 18){
            if(vm.clearmovement != null && Object.keys(vm.clearmovement).length > 0){ 
              var record = {
                orders_clear_movement_id: vm.clearmovement.orders_clear_movement_id,
                upsetupplan: 0,
                lowsetupplan: 0
              }                            
              vm.clearmovement.upsetupplan = 0;
              vm.clearmovement.lowsetupplan = 0;
              api.ordersclearmovement.save({ record: record });
            }
            if(vm.inmovement != null && Object.keys(vm.inmovement).length > 0){ 
              var recordz = {
                orders_in_movement_id: vm.inmovement.orders_in_movement_id,
                upsetupplan: 0,
                lowsetupplan: 0
              }
              vm.inmovement.upsetupplan = 0;
              vm.inmovement.lowsetupplan = 0;
              api.ordersinmovement.save({ record: recordz });
            }
          }
          /* END Deselect SetUp on Manufacturing */

          if(InvoicesOrders.status=="success"){
            InvoicesOrders.invoiced.forEach(function(invoice) {
              if(invoice.invoices_status == 1){
                vm.disabled = true;              
              }
            });            
          }          

        }

        function atualizaStatus(){
          if(vm.id > 0){
            vm.statusid = vm.order[0].status_id ? vm.order[0].status_id : 0; /* If existing status ID else 0 */
            vm.statusname = vm.order[0].status ? vm.order[0].status : 0; /* If existing status ID else 0 */
          } 
        }

        function atualizaEstados(){ /* Barra de Estado composto por Principal e Secundário */ 
          if(vm.estados.length > 0){
            if(vm.estados[0].status_id===3 || vm.estados[0].status_id===4 || vm.estados[0].status_id===7){
              vm.estadosecundario = 1;
            }else if(vm.estados[0].status_id===1 || vm.estados[0].status_id===2 || vm.estados[0].status_id===5 || vm.estados[0].status_id===6){
              vm.estadosecundario = 0;
              vm.order[0].status_id = vm.estados[0].status_id;
              vm.statusid = vm.estados[0].status_id;
              vm.statusname = vm.estados[0].status;
              var record = {
                orders_id: vm.id,
                status_id: vm.estados[0].status_id 
              }
              api.shipping.save({ record: record });
            }else{
              vm.estadosecundario = 0;
            }
          }else{
            vm.estadosecundario = 0;
          }
        }

        vm.module = $state.params.module;
        
        vm.submitted = false;        
        
        var botaoAddSize = 76; /* In pixels */
        var caixaAlertaSize = 200; /* In pixels */

        function atualizaDivSize(totalestados){
          var divSize = totalestados * caixaAlertaSize + botaoAddSize;
          angular.element('.order-messages-sub').css('width', divSize + 'px');        
        } 

        angular.element(document).ready(function () {
            /* console.log('page loading completed'); */
            if(vm.estados != null){
              atualizaDivSize(vm.estados.length);
            }
        });        

        vm.userid = localStorageService.get('userid');
        vm.username = localStorageService.get('username');

        function downloadFile(url, success) {
          var xhr = new XMLHttpRequest();
          xhr.open('GET', url, true);
          xhr.setRequestHeader("Authorization", 'Bearer ' + localStorageService.get('token'));
          xhr.responseType = "blob";
          xhr.onreadystatechange = function() {
              if (xhr.readyState == 4) {
                  if (success) success(xhr.response);
              }
          };
          xhr.send(null);
        }

        vm.openLabDoc = function(ev){
          console.log("Open Lab Doc");
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            /* IE 11 */
            downloadFile(vm.baseurl+'/api/Dlfile?type=labdocs&name='+vm.order[0].ordernumber, function(blob) {
              window.navigator.msSaveOrOpenBlob(blob);
            });                
          }else{              
            /* Chrome e Firefox */
            var win = window.open('_blank');
            downloadFile(vm.baseurl+'/api/Dlfile?type=labdocs&name='+vm.order[0].ordernumber, function(blob) {
                var url = URL.createObjectURL(blob);
                win.location = url;
            });
          }
        }

        vm.printBarCode = function(){
          var id = "GB"+vm.id;
          getService.async("Orders", id, false).then(function(d) {
            if(d.status == "success"){              
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                /* IE 11 */
                downloadFile(vm.baseurl+'/api/Dlfile?type=barcode&name='+vm.order[0].ordernumber, function(blob) {
                  window.navigator.msSaveOrOpenBlob(blob);
              });                
              }else{              
                /* Chrome e Firefox */
                var win = window.open('_blank');
                downloadFile(vm.baseurl+'/api/Dlfile?type=barcode&name='+vm.order[0].ordernumber, function(blob) {
                    var url = URL.createObjectURL(blob);
                    win.location = url;
                });
              }
            }else{
              var msg;
              var erro = d.erro;
              showToast(msg, false, erro);
            }
          });          
        }        

        function saveDepartment(id){
          id = (typeof id !== 'undefined') ? id : vm.id;               
          vm.departmentsid = (typeof vm.departmentsid  !== 'undefined') ? vm.departmentsid : 1;
          console.log("Departments ID:");
          console.log(vm.departmentsid);
          var recordz = {
            orders_departments_id: 0,
            orders_id: id,
            departments_id: vm.departmentsid                         
          }
          var conta = 0;
          if(vm.ordersdepartments){                  
            vm.ordersdepartments.forEach(function(orderdepartment) {
              if(orderdepartment.departments_id == vm.departmentsid){
                conta += 1;
              }
            });
          }
          if(conta == 0){
            console.log(recordz);
            var msg = "Saving Department was ";
            api.ordersdepartments.save({ record: recordz }).$promise.then(function (result) 
            { 
              console.log(result); 
              if(result.status !== 'success'){ 
                console.log("Saving Department Error!"); 
              }else{
                console.log("Department Saved!");
              } 
            }, function(error) {
              var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
              console.log(erro); 
              });

              var newrecord = {
                orders_id: id,
                departments_id: vm.departmentsid
              }
              console.log(newrecord);
              api.orders.save({ record: newrecord }).$promise.then(function (result) 
              { 
                console.log(result); 
                if(result.status !== 'success'){ 
                  console.log("Saving Department in Order Error!"); 
                }else{
                  console.log("Department in Order Saved!");
                } 
              }, function(error) {
                var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                console.log(erro); 
              });
          }                
        }

        function saveDLDaction(id){
          id = (typeof id !== 'undefined') ? id : vm.id;
          if(vm.departments){
            vm.departments.forEach(function(department) {
              if(department.department_alias == active_module){
                var currentdate = new Date(); 
                var datetime = currentdate.getFullYear() + "-"
                                + (currentdate.getMonth()+1)  + "-" 
                                + currentdate.getDate() + " "  
                                + currentdate.getHours() + ":"  
                                + currentdate.getMinutes() + ":" 
                                + currentdate.getSeconds();
                var record = {
                  dld_actions_id: 0,
                  users_id: vm.userid,
                  departments_id: department.departments_id,
                  date: datetime,
                  orders_id: id
                }
                var msg = "DLD Action was ";
                api.dldactions.save({ record: record }).$promise.then(function (result) 
                { 
                  if(result.status !== 'success'){ 
                    console.log("DLD Action Erro!"); 
                  }else{
                    var novodldaction = {
                      date: datetime,
                      department_name: department.department_name,
                      name: vm.username
                    }
                    if(vm.dldactions){
                      vm.dldactions.unshift(novodldaction);
                    }else{
                      vm.dldactions = novodldaction;
                    }
                    var deleteorders = vm.orders_opened.filter(function( obj ) {
                      return (obj.departments_id !== vm.departmentsid && obj.users_id == vm.userid); 
                    }); 
                    if(deleteorders.length > 0){
                      angular.forEach(deleteorders, (function(deleteorder){
                        api.ordersopened.delete({ id: deleteorder.orders_opened_id }).$promise.then(function (result) { 
                        }, function(error) { var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                        console.log(erro); } );
                      }));
                    }
                    var deletethisorder = vm.orders_opened.filter(function( obj ) {
                      return (obj.orders_id == vm.id); 
                    });
                    if(deletethisorder.length > 0){ 
                      api.ordersopened.delete({ id: deletethisorder[0].orders_opened_id }).$promise.then(function (result) { 
                      }, function(error) { var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                      console.log(erro); } );
                    }
                  } 
                }, function(error) {
                   var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                   console.log(erro); 
                  });
              }
            });  
          }
        }       
        

        vm.goToPage = function(page, orderid, close, orderopenedid, changepage){
            close = typeof close !== 'undefined' ? close : false;
            orderid = typeof orderid !== 'undefined' ? orderid : null;
            orderopenedid = typeof orderopenedid !== 'undefined' ? orderopenedid : null;
            changepage = typeof changepage !== 'undefined' ? changepage : false;
            if(close == true){
              api.ordersopened.delete({ id: orderopenedid }).$promise.then(function (result) { console.log(result); if(result.status !== 'success'){ showToast(msg, false) } }, function(error) { var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; showToast(msg, false, erro); } );              
              vm.orders_opened = vm.orders_opened.filter(function( obj ) {return obj.orders_opened_id !== orderopenedid; }); 

              if(Object.keys(vm.orders_opened).length > 0){
                vm.orders_opened.forEach(function(order) {
                  if(order.departments_id == vm.departmentsid){
                    orderid = vm.orders_opened[0].orders_id;
                    vm.departmentsidto = vm.orders_opened[0].departments_id;
                    vm.departments.forEach(function(department) {
                      if(department.departments_id == vm.departmentsidto){
                        vm.department_aliasto = department.department_alias;
                        console.log("vm.department_aliasto:");
                        console.log(vm.department_aliasto);
                      }
                    });
                  }else{
                    orderid = '';
                  }                
                });
              }else{
                orderid = '';
              }
            }
            if(typeof vm.department_aliasto === 'undefined'){
              vm.department_aliasto = active_module
            }            
                          
            if(changepage == true){
              console.log('Go to ' + page + ' with id ' + orderid + ' and department: ' + vm.department_aliasto);
              if(orderid != null && orderid != ''){
                $timeout( function(){ 
                  $state.go('app.'+page, {'id': orderid, 'module': vm.department_aliasto});
                }, 200 );                
              }else{
                $timeout( function(){ 
                  $state.go('app.'+page, {id: '', 'module': vm.department_aliasto}); 
                }, 200 );                            
              }
            }
                       
        }
        
        vm.gotoOrderStatus = gotoOrderStatus;

        function gotoOrderStatus()
        {
            console.log('go OrderStatus');
            $state.go('app.orderstatus');
        }

        $scope.customFullscreen = false;

        updateRate();

        function updateRate(){
          if(vm.products){
            vm.products.forEach(function(product) {
              if ((product.rate > 0 && product.product_discount > 0) && (product.rate > 0 && product.product_qty > 0)){
                  var precoqty = product.rate * product.product_qty;
                  product.rate = Math.round(precoqty - (product.product_discount / 100 + 1));
              }else if(product.rate > 0 && product.product_qty > 0){
                  product.rate = Math.round(product.rate * product.product_qty);
              }else if ((product.rate > 0 && product.product_discount > 0)){
                  product.rate = Math.round(product.rate - (product.product_discount / 100 + 1));
              }
            });
          }
        }

        vm.saveOnChange = function(value, field){
          switch(field){
            case 'verified':
            case 'treatmentplan_upper' :
            case 'treatmentplan_lower' :
              value = value == true ? value = 1 : 0;
            break;
          }
          var record = {
            orders_id: vm.id
          };
          record[field] = value;

          /* saveDLDaction(); */
          if(field=="verified" && vm.order[0].status_id!=5){
            var erro = "Please Complete the order before verified it.";
            showToast('', false, erro);
            vm.verified = false;
          }else{
            var msg = popuptypes[field]['msg'];
            otherSave(record, msg, field);
          }
        }
        
        vm.removeProduct = removeProduct;
        
        vm.createOrder = function(ev) {
          var inform = "Creating new order. Please wait...";
          showToast(inform, "info");
          var record = {
            orders_id: 0,
            datereceived: new Date()
          };
          console.log(record);
          var msg = 'New Order was ';
          api.orders.save({ record: record }).$promise.then(function (result) { 
            console.log(result); 
            if(result.status !== 'success'){ 
              showToast(msg, false);
            }else{                  
              var orderopeneditem = {
                orders_opened_id: 0,
                orders_id: result.neworderid,
                users_id: vm.userid,
                departments_id: vm.departmentsid,
                dld: 0
              }
              console.log(orderopeneditem);
              api.ordersopened.save({ record: orderopeneditem }).$promise;
              showToast(msg); 
              saveDLDaction(result.neworderid);
              saveDepartment(result.neworderid);
              $state.go('app.production', {id: result.neworderid, module: 'GenerateOrder'});              
            } }, function(error) { 
              var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
              showToast(msg, false, erro); 
            });              
        };            

        vm.genericRemoveConfirm = function(ev, tipopopup, id, upperlower) {
          if (typeof(upperlower)==='undefined') upperlower = 0;
          var confirm = $mdDialog.confirm(
                    /* Este código seguinte só é preciso para mudar a cor ao botão (para vermelho para remover, por ex.) */
                    {
                        onComplete: function afterShowAnimation() {
                            var $dialog = angular.element(document.querySelector('md-dialog'));
                            var $actionsSection = $dialog.find('md-dialog-actions');
                            var $cancelButton = $actionsSection.children()[0];
                            var $confirmButton = $actionsSection.children()[1];
                            angular.element($confirmButton).addClass('md-raised md-warn');
                            angular.element($cancelButton).addClass('md-primary');
                        }
                    }
                )
                .title('Are you sure?')
                .textContent(popuptypes[tipopopup]['removemsg'])
                .ariaLabel('Remove confirm box')
                .targetEvent(ev)
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('Yes, Remove!')
                .cancel('No, Cancel');
          $mdDialog.show(confirm).then(function() {
                switch(tipopopup.toLowerCase()){
                  case 'removedeliveryroute' :
                    var record = {
                      orders_id: vm.id,
                      deliveryroutes_id: 0
                    };
                  break;
                  default :
                    var record = id;
                  break;
                }
                console.log(record);
                var msg = popuptypes[tipopopup]['msg'];
                if(tipopopup.toLowerCase() === 'removedeliveryroute'){
                  otherSave(record, msg, tipopopup);
                }else{
                  if(tipopopup.toLowerCase() === 'removeproduct'){
                    console.log("removeproduct Teste");
                    console.log(record.orders_product_id);
                    console.log(vm.order[0].treatmentplan_upper_products_id);
                    if(record == vm.order[0].treatmentplan_upper_products_id) { 
                      vm.treatmentplan_upper = false; 
                      vm.saveOnChange(0, 'treatmentplan_upper'); 
                    } 
                    if(record == vm.order[0].treatmentplan_lower_products_id) { 
                      vm.treatmentplan_lower = false; 
                      vm.saveOnChange(0, 'treatmentplan_lower'); 
                    }
                  }
                  otherDelete(record, msg, tipopopup, upperlower);
                }
          }, function() {
          });
        };
        
        function removeProduct(ev, id) {
          var confirm = $mdDialog.confirm(
                    /* Este código seguinte só é preciso para mudar a cor ao botão (para vermelho para remover, por ex.) */
                    {
                        onComplete: function afterShowAnimation() {
                            var $dialog = angular.element(document.querySelector('md-dialog'));
                            var $actionsSection = $dialog.find('md-dialog-actions');
                            var $cancelButton = $actionsSection.children()[0];
                            var $confirmButton = $actionsSection.children()[1];
                            angular.element($confirmButton).addClass('md-raised md-warn');
                            angular.element($cancelButton).addClass('md-primary');
                        }
                    }
                )
                .title('Are you sure?')
                .textContent('Please confirm if you would like to remove this product.')
                .ariaLabel('Remove confirm box')
                .targetEvent(ev)
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('Yes, Remove!')
                .cancel('No, Cancel');
          $mdDialog.show(confirm).then(function() {
/*               var record = { 'id' : id } ;
                console.log(record); */
                var msg = "Product removed from order! Reloading page...";
                deleteProduct(id, msg);
          }, function() {
          });
        };
      function removeProducts(ev, id) {
          var confirm = $mdDialog.confirm(
                    /* Este código seguinte só é preciso para mudar a cor ao botão (para vermelho para remover, por ex.) */
                    {
                        onComplete: function afterShowAnimation() {
                            var $dialog = angular.element(document.querySelector('md-dialog'));
                            var $actionsSection = $dialog.find('md-dialog-actions');
                            var $cancelButton = $actionsSection.children()[0];
                            var $confirmButton = $actionsSection.children()[1];
                            angular.element($confirmButton).addClass('md-raised md-warn');
                            angular.element($cancelButton).addClass('md-primary');
                        }
                    }
                )
                .title('Are you sure?')
                .textContent('Please confirm if you would like to remove this product.')
                .ariaLabel('Remove confirm box')
                .targetEvent(ev)
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('Yes, Remove!')
                .cancel('No, Cancel');
          $mdDialog.show(confirm).then(function() {
/*                var record = { 'id' : id } ;
                console.log(record); */
                var msg = "Products removed from order! Reloading page...";
                deleteProducts(id, msg);
          }, function() {
          });
        }; 


/*
              FUNÇÃO GENÉRICA DE POPUP
*/
      $scope.openPopupDep = function(ev, module) {
        console.log(module);                
          $mdDialog.show({
            controller: eval("GenericController"),
            controllerAs: 'pctrl',
            templateUrl: 'app/main/pages/production/departments/'+module+'.html',
            parent: angular.element(document.body),
            locals : {
              module : module
            },
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: $scope.customFullscreen 
          });
        };          


        function GenericController($scope, $mdDialog, module, CONFIG, DTOptionsBuilder, DTColumnBuilder, api, $location,$timeout) {
            var self = this;
            $scope.id = vm.id;
            self.disabled = vm.disabled;
            
            switch(module.toLowerCase()){
              case "orderinfo":
                  self.droutes = vm.droutes;
                  self.deliveryroutes_id = vm.order[0].deliveryroutes_id;
                  self.cliente = vm.cliente;
                  self.dtInstance = {};
                  self.order = {};
                  self.order.patient_name = vm.order[0].patient_name;
                  self.order.patient_ref = vm.order[0].patient_ref;
                  self.order.ordertype = vm.order[0].ordertype;
                  self.packaging = vm.packaging;
                  console.log(self.packaging);
                  /*var itemdata = {};*/

                  self.dtOptions = DTOptionsBuilder.newOptions()
                  .withOption('ajax', {
                      url: CONFIG.apiBaseUrl + 'Clients/fetchclients',
                      type: 'POST',
                      "dataSrc": function(json) {
                        if(json.status && json.status == "login"){
                          $mdDialog.hide();
                          var infor = "Your login has expired. Please login again.";
                          showToast(infor, "info");
                          $location.path('/login');
                        }else{
                            console.log(json);
                            return json.data;
                        }
                      },
                      "data": function(d){
                          /*d.search['value'] = self.searchz;*/   
                          for (var i = 1; i < 9; ++i) {
                            var f = "d.columns["+i+"].search.value = self.search"+i+";";
                            eval(f);
                          }
                          console.log(d);
                          
                      },
                      "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
                  })
                  .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
                  .withDataProp('data')
                  .withOption('processing', true)
                  .withOption('serverSide', true)
                  .withOption('filter', false)
                  .withOption('bLengthChange', true)
                  .withOption('bSort', false)
                  .withOption('responsive',false)
                  .withPaginationType('full_numbers')
                  .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $('td', nRow).css('cursor', 'pointer');
                    $('td', nRow).unbind('click');
                    $('td', nRow).bind('click', function() {
                        $scope.$apply(function() {
                            self.cliente = {
                              clients_id: aData[0],
                              clientnumber: aData[1],
                              clientname: aData[2],
                            }
                            $scope.showDetails1 = !$scope.showDetails1;
                            getService.async("Clients", "OI"+aData[0], true).then(function(d) {
                              self.cliente = d.cliente;
                            });
                            console.log(self.cliente);
                            return nRow;
                          });                      
                        });
                    })
                  .withOption('order', [])
                  .withOption('initComplete', function(){
                      var api = this.api();
      
                      self.totalRecords = api.page.info().recordsTotal;
                      self.totalRecordsFiltered = api.page.info().recordsDisplay;

                      self.searchTable = function(searchText, column){
                          var f = "self.search"+column+" = searchText;";
                          eval(f);
                        self.dtInstance.DataTable.search(searchText).draw();                  
                      } 
                      
                      self.reset = function(){
                          self.search = [];
                          for (var i = 1; i < 9; ++i) {
                            var f = "self.search"+i+" = undefined;";
                            eval(f);
                          }
                        self.dtInstance.reloadData(null, true);                      
                      }    
                      
                  })
                  .withLanguage({
                      "sInfo": 'Info',
                      "paginate": {
                          "first": 'First',
                          "last": 'Last',
                          "next": 'Next',
                          "previous": 'Previous'
                      }
                  });

                  self.dtColumns = [
                    DTColumnBuilder.newColumn(0).withTitle('Client ID').notVisible(),
                    DTColumnBuilder.newColumn(1).withTitle('Client Number').notSortable(),
                    DTColumnBuilder.newColumn(2).withTitle('Client Name').notSortable(),
                    DTColumnBuilder.newColumn(3).withTitle('Post Code').notSortable(),
                    DTColumnBuilder.newColumn(4).withTitle('City').notVisible(),
                    DTColumnBuilder.newColumn(5).withTitle('County').notVisible(),
                    DTColumnBuilder.newColumn(6).withTitle('Country').notVisible(),
                    DTColumnBuilder.newColumn(7).withTitle('Address 1').notSortable(),
                    DTColumnBuilder.newColumn(8).withTitle('Address 2').notSortable(),
                    DTColumnBuilder.newColumn(9).withTitle('Practice Number').notVisible(),
                    DTColumnBuilder.newColumn(10).withTitle('GDC Number').notVisible()
                  ] 

              break;              
              case "ordercontent":
                self.orderscontent = vm.orderscontent;
                self.printOrderContent = function(){
                  var id = "OC"+vm.id;
                  getService.async("Orders", id, false).then(function(d) {
                    if(d.status == "success"){
                      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        /* IE 11 */
                        downloadFile(vm.baseurl+'/api/Dlfile?type=ordercontent&name='+d.filename, function(blob) {
                          window.navigator.msSaveOrOpenBlob(blob);
                      });                
                      }else{              
                        /* Chrome e Firefox */
                        var win = window.open('_blank');
                        downloadFile(vm.baseurl+'/api/Dlfile?type=ordercontent&name='+d.filename, function(blob) {
                            var url = URL.createObjectURL(blob);
                            win.location = url;
                        });
                      }
                    }else{
                      var msg;
                      var erro = "Please insert and save Order Content data first.";
                      showToast(msg, false, erro);
                    }
                  });
                }
              break;
              case "plasterroom":
                self.plasterroom = vm.plasterroom;
              break;
              case "scanning":
                self.scanning = vm.scanning;
              break;
              case "platforms":
                self.platforms = vm.platforms;
              break;
              case "designing":
                self.designing = vm.designing;
              break;
              case "manufacturing":
                self.manufacturing = vm.manufacturing;
              break;
              case "matching":
                self.matching = vm.matching;
              break;
              case "planning":
                self.planning = vm.planning;
              break;
              case "drillingdesign":
                self.dridesign = vm.dridesign;
              break;
              case "drillingprinting":
                self.driprinting = vm.driprinting;
              break;
              case "drillingassembly":
                self.driassembly = vm.driassembly;
              break;
              case "caseassessment":
                self.caseassessment = vm.caseassessment;
              break;
              case "clearmovement":
                self.clearmovement = vm.clearmovement;
              break;
              case "bracketmovement":
                self.bracketmovement = vm.bracketmovement;
              break;
              case "clearmanufacturing":
                self.clearmanufacturing = vm.clearmanufacturing;
                $scope.checkUpTrays = function(){
                  if(parseInt(self.clearmanufacturing.upnumtrays) > parseInt(self.clearmanufacturing.upnumclear)){
                    self.clearmanufacturing.upnumclear = self.clearmanufacturing.upnumtrays;
                  }
                }
                $scope.checkLowTrays = function(){
                  if(parseInt(self.clearmanufacturing.lownumtrays) > parseInt(self.clearmanufacturing.lownumclear)){
                    self.clearmanufacturing.lownumclear = self.clearmanufacturing.lownumtrays;
                  }
                }
                $scope.checkUpClears = function(){                  
                  self.clearmanufacturing.upnumtrays = self.clearmanufacturing.upnumclear;              
                }
                $scope.checkLowClears = function(){                  
                  self.clearmanufacturing.lownumtrays = self.clearmanufacturing.lownumclear;              
                }
              break;
              case "inmancaseassessment":                
                self.incaseassessment = vm.incaseassessment;
              break;
              case "movement":
                self.inmovement = vm.inmovement;                
              break;
              case "inmanmanufacturing":
                self.inmanufacturing = vm.inmanufacturing;
              break;
              case "waiting":
                self.waiting = vm.waiting;
              break;
              case "packaging":
                self.platforms = vm.platforms;
                self.orderscontent = vm.orderscontent;
                self.plasterroom = vm.plasterroom;
                self.manufacturing = vm.manufacturing;
                self.clearmanufacturing = vm.clearmanufacturing;
                self.inmanufacturing = vm.inmanufacturing;

                self.packaging = vm.packaging;
                self.droutes = vm.droutes;
                if(vm.packaging != null && typeof vm.packaging.deliveryroutes_id != 'undefined'){
                  self.deliveryroutes_id = self.packaging.deliveryroutes_id - 1;
                }
              break;
            }            
            
            $scope.cancel = function($event) {
              $mdDialog.cancel();
            };
            $scope.finish = function($event) {
              $mdDialog.hide();
            };
            $scope.gravar = function(gravar, order, packagingdata) {
              order = (typeof order !== 'undefined') ? order : "";
              packagingdata = (typeof packagingdata !== 'undefined') ? packagingdata : "";
              console.log(packagingdata);
              if(module.toLowerCase() == "orderinfo"){
                console.log(gravar);
                vm.cliente = gravar;               
                if(gravar.deliveryroutes){
                  vm.order[0].deliveryroutes_id = gravar.deliveryroutes.deliveryroutes_id;
                  vm.order[0].route = gravar.deliveryroutes.route;
                  vm.order[0].rate = gravar.deliveryroutes.rate;                
                }
                gravar = {
                  orders_id: $scope.id,
                  clients_id: (gravar.clients_id) ? gravar.clients_id : vm.order[0].clients_id,
                  deliveryroutes_id: (gravar.deliveryroutes) ? gravar.deliveryroutes.deliveryroutes_id : vm.order[0].deliveryroutes_id                  

                }
                var patient_name = (typeof order.patient_name !== 'undefined') ? order.patient_name : "";
                var patient_ref = (typeof order.patient_ref !== 'undefined') ? order.patient_ref : "";
                var ordertype = (typeof order.ordertype !== 'undefined') ? order.ordertype : "";
                var record = {
                  orders_id: vm.id,
                  patient_name: patient_name,
                  patient_ref: patient_ref,
                  ordertype: ordertype
                }
                if(patient_name != "" || patient_ref != "" || ordertype != ""){
                  api.orders.save({ record: record }).$promise;
                  vm.order[0].patient_name = patient_name;
                  vm.order[0].patient_ref = patient_ref;
                  vm.order[0].ordertype = ordertype;
                }
                packagingdata.deliveryroutes_id = (gravar.deliveryroutes) ? gravar.deliveryroutes.deliveryroutes_id : vm.order[0].deliveryroutes_id;
                api.orderspackaging.save({ record: packagingdata }).$promise;
                vm.packaging = packagingdata;
              }else if(module.toLowerCase() == "packaging"){
                if(gravar.deliveryroutes){
                  vm.order[0].deliveryroutes_id = gravar.deliveryroutes.deliveryroutes_id;
                  vm.order[0].route = gravar.deliveryroutes.route;
                  vm.order[0].rate = gravar.deliveryroutes.rate;                
                }
                if(typeof gravar.shippingdate !== 'undefined' && gravar.shippingdate != ''){
                  vm.order[0].shippingdate = gravar.shippingdate;
                }
                if(gravar.deliveryroutes && gravar.deliveryroutes.deliveryroutes_id != '0'){                
                  var delivery = {};
                  delivery = {
                    orders_id: $scope.id,
                    deliveryroutes_id: gravar.deliveryroutes.deliveryroutes_id                 
                  }
                  gravar.deliveryroutes_id = gravar.deliveryroutes.deliveryroutes_id;                
                  api.shipping.save({ record: delivery }).$promise;
                }
                $timeout( function(){ 
                  delete gravar.deliveryroutes; 
                }, 100 );                
              }              
              /* console.log(gravar); */
              $mdDialog.hide();              
              var msg = actions[module]['msg'];
              var f =  "genericSave(gravar, msg, module)";
              $timeout( function(){
                eval(f);                 
              }, 200 );                        
            };          
        }

        GenericController.$inject = ['$scope', '$mdDialog', 'module', 'CONFIG', 'DTOptionsBuilder', 'DTColumnBuilder', 'api', '$location','$timeout'];

        function updateVMDepartments(module, record){
          console.log("going to updateVMDepartments");
          switch(module.toLowerCase()){
            case "ordercontent":
              vm.orderscontent = record;
            break;
            case "plasterroom":
              vm.plasterroom = record;
            break;
            case "scanning":
              vm.scanning = record;
            break;
            case "platforms":
              vm.platforms = record;
            break;
            case "designing":
              vm.designing = record;
            break;
            case "manufacturing":
              vm.manufacturing = record;
            break;
            case "matching":
              vm.matching = record;
            break;
            case "planning":
              vm.planning = record;
            break;
            case "drillingdesign":
              vm.dridesign = record;
            break;
            case "drillingprinting":
              vm.driprinting = record;
            break;
            case "drillingassembly":
              vm.driassembly = record;
            break;
            case "caseassessment":
              vm.caseassessment = record;
            break;
            case "clearmovement":
              vm.clearmovement = record;
            break;
            case "bracketmovement":
              vm.bracketmovement = record;
            break;
            case "clearmanufacturing":
              vm.clearmanufacturing = record;              
            break;
            case "inmancaseassessment":                
              vm.incaseassessment = record;
            break;
            case "movement":
              vm.inmovement = record;                
            break;
            case "inmanmanufacturing":
              vm.inmanufacturing = record;
            break;
            case "waiting":
              vm.waiting = record;
            break;
            case "packaging":
              vm.packaging = record;
            break;
          }
        }

        updateVMDepartments.$inject = ['module', 'record'];
        
        function genericSave(record, message, module)
        {
            console.log("save"+module+"...");
            console.log(record);

            var msg = message ? message : 'Settings changed.';
            var f = "api."+actions[module]['api']+".save({ record: record }).$promise.then(function (result) { console.log(result); if(result.status !== 'success'){ showToast(msg, false); }else{ updateVMDepartments(module, record); showToast(msg); } }, function(error) { var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; showToast(msg, false, erro); } );";
            console.log(f);
            eval(f);
            saveDLDaction();
            saveDepartment(vm.id);
            if(module.toLowerCase() == "ordercontent"){
              var id = "OC"+vm.id;
              $timeout( function(){ 
                getService.async("Orders", id, false).then(function(d) {
                  if(d.status == "success"){
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                      /* IE 11 */
                      downloadFile(vm.baseurl+'/api/Dlfile?type=ordercontent&name='+d.filename, function(blob) {
                        window.navigator.msSaveOrOpenBlob(blob);
                    });                
                    }else{              
                      /* Chrome e Firefox */
                      var win = window.open('_blank');
                      downloadFile(vm.baseurl+'/api/Dlfile?type=ordercontent&name='+d.filename, function(blob) {
                          var url = URL.createObjectURL(blob);
                          win.location = url;
                      });
                    }
                  /*}else{
                    var msg;
                    var erro = "Please insert and save Order Content data first.";
                    showToast(msg, false, erro);*/
                  }
                  vm.printBarCode();
                });
              }, 200 );              
            }else if(module.toLowerCase() == "orderinfo"){            
              getService.async("Clients", "SO"+vm.id, true).then(function(d) {
                vm.cliente = d.cliente;
              });
            }else if(module.toLowerCase() == "clearmanufacturing"){ /* Atribuir Pontos ao User */
              var points = 0;
              if (typeof(record.lownumclear)!=='undefined') points += parseFloat(record.lownumclear) * 10;
              if (typeof(record.upnumclear)!=='undefined') points += parseFloat(record.upnumclear) * 10;
              if (typeof(record.lownumessix)!=='undefined') points += parseFloat(record.lownumessix) * 16;
              if (typeof(record.upnumessix)!=='undefined') points += parseFloat(record.upnumessix) * 16;

              atribuirPontos(points);
              
            }else if(module.toLowerCase() == "clearmovement"){ /* Atribuir Pontos ao User */
              var points = 0;
              var totallow = 0;
              var totalup = 0;
              if (typeof(record.lownummodels)!=='undefined'){
                points += parseFloat(record.lownummodels);
                totallow = parseFloat(record.lownummodels);
              } 
              if (typeof(record.upnummodels)!=='undefined'){
                points += parseFloat(record.upnummodels);
                totalup = parseFloat(record.upnummodels);
              }
              if (typeof(record.lowtreatmentplan)!=='undefined' && record.lowtreatmentplan !== false && record.lowtreatmentplan > 0) points += parseFloat(totallow) * 0.25;
              if (typeof(record.uptreatmentplan)!=='undefined' && record.uptreatmentplan !== false && record.uptreatmentplan > 0) points += parseFloat(totalup) * 0.25;
              
              atribuirPontos(points);
              
            }else if(module.toLowerCase() == "bracketmovement"){ /* Atribuir Pontos ao User */
              var points = 0;
              var totallow = 0;
              var totalup = 0;
              if (typeof(record.lownumbrackets)!=='undefined'){
                points += parseFloat(record.lownumbrackets) * 40;
                totallow = parseFloat(record.lownumbrackets) * 40;
              } 
              if (typeof(record.upnumbrackets)!=='undefined'){
                points += parseFloat(record.upnumbrackets) * 40;
                totalup = parseFloat(record.upnumbrackets) * 40;
              }
              if (typeof(record.low)!=='undefined' && record.low !== false && record.low > 0) points += parseFloat(totallow) * 0.25;
              if (typeof(record.uptreatmentplan)!=='undefined' && record.uptreatmentplan !== false && record.uptreatmentplan > 0) points += parseFloat(totalup) * 0.25;
              
              atribuirPontos(points);
              
            }else if(module.toLowerCase() == "scanning"){ /* Atribuir Pontos ao User */
              var points = 0;

              if (typeof(record.lower)!=='undefined'){
                points += parseFloat(record.lower);
              } 
              if (typeof(record.upper)!=='undefined'){
                points += parseFloat(record.upper);
              }             
              
              atribuirPontos(points);
              
            }else if(module.toLowerCase() == "platforms"){ /* Atribuir Pontos ao User */
              var points = 0;

              if (typeof(record.lower)!=='undefined'){
                points += parseFloat(record.lower);
              } 
              if (typeof(record.upper)!=='undefined'){
                points += parseFloat(record.upper);
              }             
              
              atribuirPontos(points);
              
            }else if(module.toLowerCase() == "designing"){ /* Atribuir Pontos ao User */
              var points = 0;

              if (typeof(record.low4x4)!=='undefined'){
                points += parseFloat(record.low4x4);
              } 
              if (typeof(record.lowimplant)!=='undefined'){
                points += parseFloat(record.lowimplant);
              }
              if (typeof(record.lowjigs)!=='undefined'){
                points += parseFloat(record.lowjigs);
              } 
              if (typeof(record.lowmilled)!=='undefined'){
                points += parseFloat(record.lowmilled);
              } 
              if (typeof(record.lownimrodali)!=='undefined'){
                points += parseFloat(record.lownimrodali);
              } 
              if (typeof(record.lownimrodret)!=='undefined'){
                points += parseFloat(record.lownimrodret);
              } 
              if (typeof(record.lowsplint)!=='undefined'){
                points += parseFloat(record.lowsplint);
              }                
              if (typeof(record.lowstudymodels)!=='undefined'){
                points += parseFloat(record.lowstudymodels);
              } 
              if (typeof(record.up4x4)!=='undefined'){
                points += parseFloat(record.up4x4);
              } 
              if (typeof(record.upimplant)!=='undefined'){
                points += parseFloat(record.upimplant);
              } 
              if (typeof(record.upjigs)!=='undefined'){
                points += parseFloat(record.upjigs);
              } 
              if (typeof(record.upmilled)!=='undefined'){
                points += parseFloat(record.upmilled);
              } 
              if (typeof(record.upnimrodali)!=='undefined'){
                points += parseFloat(record.upnimrodali);
              } 
              if (typeof(record.upnimrodret)!=='undefined'){
                points += parseFloat(record.upnimrodret);
              } 
              if (typeof(record.upsplint)!=='undefined'){
                points += parseFloat(record.upsplint);
              }   
              if (typeof(record.upstudymodels)!=='undefined'){
                points += parseFloat(record.upstudymodels);
              }              
              
              atribuirPontos(points);
              
            }else if(module.toLowerCase() == "plasterroom"){ /* Atribuir Pontos ao User */
              var points = 0;

              if (typeof(record.lower)!=='undefined'){
                points += parseFloat(record.lower);
              } 
              if (typeof(record.upper)!=='undefined'){
                points += parseFloat(record.upper);
              }             
              
              atribuirPontos(points);              
            }

        }

        genericSave.$inject = ['record', 'message', 'module'];

        vm.openPopupOther = function(ev, tipopopup, upperlower) {
          if(tipopopup == "treatmentplan_upper" || tipopopup == "treatmentplan_lower"){
            if(vm.products.length == 0){
              var f = "vm."+tipopopup+" = false;";
              eval(f);
              var msg;
              var erro = 'Please add a product first.'; 
              showToast(msg, false, erro);
              return false;
            }
            if(tipopopup == "treatmentplan_upper"){
              vm.valor = 0;
              angular.forEach(vm.products, function(product) {                
                if(product.upperORlower == 1){
                  vm.valor = 1;
                }                
              });
              if(vm.valor == 0){
                var msg;
                var erro = 'Please add a product first.'; 
                showToast(msg, false, erro);
                var f = "vm."+tipopopup+" = false;";
                eval(f);
                console.log(vm.valor);
                return false;
              }
            }               
            if(tipopopup == "treatmentplan_lower"){
              vm.valor = 0;
              angular.forEach(vm.products, function(product) {                
                if(product.upperORlower == 2){
                  vm.valor = 1;
                }                
              });
              if(vm.valor == 0){
                var msg;
                var erro = 'Please add a product first.'; 
                showToast(msg, false, erro);
                var f = "vm."+tipopopup+" = false;";
                eval(f);
                console.log(vm.valor);
                return false;
              }
            }

            if (upperlower == true){
              upperlower = 1;
            }else{
              upperlower = 0;
              vm.saveOnChange(0, tipopopup);
              return false;
            }
          }            

          if (typeof(upperlower)==='undefined') upperlower = 0;               
          $mdDialog.show({
            controller: eval("OtherController"),
            controllerAs: 'octrl',
            resolve: {
              popuptype: function () {
                return {
                  'tipoPopup': tipopopup,
                  'upperlower': upperlower
                };
              }
            },
            templateUrl: 'app/main/pages/production/others/'+tipopopup.toLowerCase()+'.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: $scope.customFullscreen 
          });
        };

        vm.openPopupOther.$inject = ['ev','tipopopup'];

        function createdRow(row, data, dataIndex) {
          $compile(angular.element(row).contents())($scope);
      }

        function OtherController($compile, $scope, $mdDialog, $http, popuptype, Upload, $timeout, CONFIG, DTOptionsBuilder,DTColumnBuilder,$location) {
            var self = this;
            $scope.userid = vm.userid;
            $scope.username = vm.username;
            $scope.data = new Date();
            $scope.id = vm.id;

            switch(popuptype.tipoPopup.toLowerCase()){
              case "scanorder":               
              break;
              case 'treatmentplan_upper':              
                self.products = vm.products;
                self.orders_product_id = vm.order[0].treamentplan_upper_products_id;
              case 'treatmentplan_lower':
                self.products = vm.products;
                self.orders_product_id = vm.order[0].treamentplan_lower_products_id;
              break;
              case 'dldactionsprint':
                self.dldactions = vm.dldactions;
              break;
              case 'addnewdeliveryroute' :
                self.droutes = vm.droutes;
                self.deliveryroutes_id = vm.order[0].deliveryroutes_id;
              break;
              /*case 'addnewlinkorder':
                self.listorders = vm.listorders;
                self.selectedOrderIdChange = selectedOrderIdChange;
                self.searchText = null;                
                function selectedOrderIdChange(item){
                    self.linkedtoid = item.orders_id;
                }                
              break;*/
              /*case 'addlabdoc' :
                $scope.orderid = vm.id;
                $scope.determinateValue = 0;        
                $scope.$watch('files', function () {
                    $scope.upload($scope.files);
                });
                $scope.$watch('file', function () {
                    if ($scope.file != null) {
                        $scope.files = [$scope.file]; 
                    }
                });
                $scope.log = '';
                $scope.upload = function (files) {
                    if (files && files.length) {
                        for (var i = 0; i < files.length; i++) {
                          var file = files[i];
                          if (!file.$error) {
                            Upload.upload({
                                url: CONFIG.apiBaseUrl + 'LabDoc',
                                data: {
                                  orders_id: $scope.orderid,
                                  user_id: $scope.userid,
                                  file: file  
                                }
                            }).then(function (resp) {
                              vm.labdocs.push(resp.data.order_lab_doc);
                              $mdDialog.hide();
                              var tipopopup = popuptype.tipoPopup;
                              var msg = popuptypes[tipopopup]['msg'];                              
                              showToast(msg);

                            }, function (error){
                              var tipopopup = popuptype.tipoPopup;
                              var msg = popuptypes[tipopopup]['msg'];
                              var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                              showToast(msg, false, erro);
                          }, function (evt) {
                                var progressPercentage = parseInt(100.0 *
                                            evt.loaded / evt.total);
                                            $scope.determinateValue = progressPercentage;
                            }
                          );
                          }
                        }
                    }
                };
              break;*/
              case 'showcasetype' :
                self.casetypes = vm.casetypes;
              break;
              case 'addnewproduct' :
              case 'search':
              case 'addnewlinkorder':
                /*self.listorders = vm.listorders;
                self.selectedOrderIdChange = selectedOrderIdChange;
                self.searchText = null;                
                function selectedOrderIdChange(item){
                    self.linkedtoid = item.orders_id;
                }*/               
            
                self.upperlower = popuptype.upperlower;

                if(vm.id > 0){
                  self.departments = vm.departments;
                }else{
                  getService.async("Departments", "", true).then(function(d) {
                    self.departments = d.records;
                  });                
                  getService.async("Status", "", true).then(function(d) {
                    self.statuses = d.records;
                  });
                }

                self.dtInstance = {};
                var itemabrir = [];
                var itemdata = {};
                self.product_qty = [];
                self.product_discount = [];
                self.products_groups_id = [];          

                if(popuptype.tipoPopup.toLowerCase() == "search"){
                  var urlpost = CONFIG.apiBaseUrl + 'Orders/fetchorders';
                  var numcolumns = 18;
                  var tipo = "search";
                }else if(popuptype.tipoPopup.toLowerCase() == "addnewlinkorder") {
                  var urlpost = CONFIG.apiBaseUrl + 'Orders/' + vm.id;
                  var numcolumns = 5;
                  var tipo = "addnewlinkorder";
                }else if(popuptype.tipoPopup.toLowerCase() == "addnewproduct"){
                  var urlpost = CONFIG.apiBaseUrl + 'Products/fetchproducts';
                  var numcolumns = 11;
                  var tipo = "product";
                }

                self.dtOptions = DTOptionsBuilder.newOptions()
                .withOption('ajax', {
                    url: urlpost,
                    type: 'POST',
                    "dataSrc": function(json) {
                      if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                      }else{
                          console.log(json);
                          return json.data;
                      }
                    },
                    "data": function(d){
                        /*d.search['value'] = self.searchz;*/
                        if(tipo == "search"){
                          for (var i = 0; i < numcolumns; ++i) {
                            var f = "d.columns["+i+"].search.value = self.search"+i+";";
                            eval(f);
                          }
                        }else if (tipo == "product" || tipo == "addnewlinkorder"){
                          d.search['value'] = self.search;
                        }
                        console.log(d);
                        
                    },
                    "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
                })
                .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
                .withDataProp('data')
                .withOption('processing', true)
                .withOption('serverSide', true)
                .withOption('filter', false)
                .withOption('bLengthChange', true)
                .withOption('bSort', false)
                .withOption('responsive',false)
                .withPaginationType('full_numbers')
                .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                  $('td', nRow).css('cursor', 'pointer');
                  $('td', nRow).unbind('click');
                  $('td', nRow).bind('click', function() {
                      $scope.$apply(function() {
                        console.log(aData); 
                        if(tipo == "search"){                                    
                          if(itemabrir.includes(aData[12])==true){                            
                            var index = itemabrir.indexOf(aData[12]);
                            if (index > -1) {
                              $(nRow).removeClass('highlitedRow');
                              itemabrir.splice(index, 1);
                            }
                          }else{
                            itemabrir.push(aData[12]);
                            $(nRow).addClass('highlitedRow');
                          }
                          self.itemabrir = itemabrir;
                          console.log(self.itemabrir);
                          return nRow;  
                        }else if(tipo == "addnewlinkorder"){                                    
                          if(itemabrir.includes(aData[0])==true){                            
                            var index = itemabrir.indexOf(aData[0]);
                            if (index > -1) {
                              $(nRow).removeClass('highlitedRow');
                              itemabrir.splice(index, 1);
                            }
                          }else{
                            itemabrir.push(aData[0]);
                            $(nRow).addClass('highlitedRow');
                          }
                          self.itemabrir = itemabrir;
                          console.log(self.itemabrir);
                          return nRow;  
                        }else if(tipo == "product"){
                          itemdata = {
                            orders_id: vm.id,
                            products_id: aData[7],
                            products_groups_id: aData[8],
                            product_qty: parseInt(self.product_qty[aData[7]]),
                            product_discount: parseInt(self.product_discount[aData[7]]),
                            product_rate: parseFloat(Math.round(self.product_rate[aData[7]] * 100) / 100).toFixed(2),
                            product_rate_final: parseFloat(Math.round(self.product_rate_final[aData[7]] * 100) / 100).toFixed(2),
                            upperORlower: self.upperlower
                          }
                          var verifica = 0;
                          angular.forEach(itemabrir, function(item) {
                            if(item.products_id==aData[7]){
                                verifica = 1;                            
                                $(nRow).removeClass('highlitedRow');
                                itemabrir = itemabrir.filter(function( obj ) {return obj.products_id !== aData[7]; });
                            } 
                          });
                          if(verifica == 0){
                            itemabrir.push(itemdata);
                            $(nRow).addClass('highlitedRow');
                          }
                          self.itemabrir = itemabrir;
                          console.log(self.itemabrir);
                          return nRow; 
                        }                      
                      });
                  });
                })
                .withOption('createdRow', function(row) {
                  /* Recompiling so we can bind Angular directive to the DT */
                  $compile(angular.element(row).contents())($scope);
              })
                .withOption('order', [])
                .withOption('initComplete', function(){
                    var api = this.api();
    
                    self.totalRecords = api.page.info().recordsTotal;
                    self.totalRecordsFiltered = api.page.info().recordsDisplay;

                    self.searchTable = function(searchText, column){
                      if (tipo == "search"){
                        var f = "self.search"+column+" = searchText;";
                        eval(f);
                      }else if (tipo == "product" || tipo == "addnewlinkorder"){
                        self.search = searchText;
                      }
                      self.dtInstance.DataTable.search(searchText).draw();                  
                    } 
                    
                    self.reset = function(){                      
                      if(tipo == "search"){
                        self.search = [];
                        self.startDate = undefined;
                        self.endDate = undefined;
                        self.onDate = undefined;
                        for (var i = 0; i < numcolumns; ++i) {
                          var f = "self.search"+i+" = undefined;";
                          eval(f);
                        }
                      }else if (tipo == "product" || tipo == "addnewlinkorder"){
                        self.search = undefined;
                      }
                      self.dtInstance.reloadData(null, true);                      
                    }    
                    
                })
                .withLanguage({
                    "sInfo": 'Info',
                    "paginate": {
                        "first": 'First',
                        "last": 'Last',
                        "next": 'Next',
                        "previous": 'Previous'
                    }
                });

                if(tipo == "search"){            
                  /*self.dtColumnDefs = [
                    { 
                      orderable: false, 
                      targets: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] 
                    },
                    {                 
                      visible: false,
                      searchable: true, 
                      targets: [ 11, 12, 13, 14, 15, 16, 17 ]
                    }
                  ]*/
                  self.dtColumns = [                    
                    DTColumnBuilder.newColumn(0).withTitle('Order No'),
                    DTColumnBuilder.newColumn(1).withTitle('Invoice No'),
                    DTColumnBuilder.newColumn(2).withTitle('Prescription No'),
                    DTColumnBuilder.newColumn(3).withTitle('City'),
                    DTColumnBuilder.newColumn(4).withTitle('Country'),
                    DTColumnBuilder.newColumn(5).withTitle('Postcode'),
                    DTColumnBuilder.newColumn(6).withTitle('Pratice Name'),
                    DTColumnBuilder.newColumn(7).withTitle('Practice No'),
                    DTColumnBuilder.newColumn(8).withTitle('Client Name'),
                    DTColumnBuilder.newColumn(9).withTitle('Due Date'),
                    DTColumnBuilder.newColumn(10).withTitle('Patient Name'),
                    DTColumnBuilder.newColumn(11).withTitle('Client Name').notVisible(),
                    DTColumnBuilder.newColumn(12).withTitle('Orders ID').notVisible(),
                    DTColumnBuilder.newColumn(13).withTitle('Departments ID').notVisible(),
                    DTColumnBuilder.newColumn(14).withTitle('Status ID').notVisible(),
                    DTColumnBuilder.newColumn(15).withTitle('Date Received 1').notVisible(),
                    DTColumnBuilder.newColumn(16).withTitle('Date Received 2').notVisible(),
                    DTColumnBuilder.newColumn(17).withTitle('Date Received 3').notVisible()
                  ]
                }else if(tipo == "addnewlinkorder"){
                  self.dtColumns = [
                    DTColumnBuilder.newColumn(0).withTitle('Orders ID').notVisible(),
                    DTColumnBuilder.newColumn(1).withTitle('Order Number'),
                    DTColumnBuilder.newColumn(2).withTitle('Status'),
                    DTColumnBuilder.newColumn(3).withTitle('Patient Name'),
                    DTColumnBuilder.newColumn(4).withTitle('Patient Ref')
                  ]                
                }else if (tipo == "product"){
                  self.dtColumns = [
                    DTColumnBuilder.newColumn(0).withTitle('Product Code'),
                    DTColumnBuilder.newColumn(1).withTitle('Product Description'),
                    DTColumnBuilder.newColumn(2).withTitle('Product Group').notSortable(),
                    /*.renderWith(function(data, type, full, meta) {
                      return '<md-input-container class="md-block"><label>Product Group</label><md-select name="products_groups_id" ng-init="octrl.products_groups_id['+full[7]+']=\'0\'" ng-model="octrl.products_groups_id['+full[7]+']" ng-change="updateItemData(\''+full[7]+'\',\'products_groups_id\',octrl.products_groups_id['+full[7]+'])"><md-option value="1">Plaster Room</md-option><md-option value="3">3D</md-option><md-option value="4">Implants</md-option><md-option value="5">Clear Aligner</md-option><md-option value="7">Removable Appliance</md-option><md-option value="8">Packaging</md-option></md-select></md-input-container>';
                    }),*/
                    DTColumnBuilder.newColumn(3).withTitle('Rate').notSortable()
                    .renderWith(function(data, type, full, meta) {
                      return '<md-input-container class="md-block"><input type="text" name="product_rate" ng-model="octrl.product_rate['+full[7]+']" ng-init="octrl.product_rate['+full[7]+']=\''+full[3]+'\'" ng-change="updateItemData(\''+full[7]+'\',\'product_rate\',octrl.product_rate['+full[7]+'])" value="'+full[3]+'" aria-label="Rate"></md-input-container>';
                      /*return  '£ ' + full[3];*/
                    }),
                    DTColumnBuilder.newColumn(4).withTitle('VAT').notSortable()
                    .renderWith(function(data, type, full, meta) {
                      return '<md-input-container class="md-block"><input type="text" name="vat" ng-model="octrl.vat['+full[7]+']" ng-init="octrl.vat['+full[7]+']=\''+full[4]+'\'" value="'+full[4]+'" aria-label="VAT" disabled></md-input-container>';
                      /*return full[4] + '%';*/
                    }),
                    DTColumnBuilder.newColumn(5).withTitle('Quantity').notSortable()
                    .renderWith(function(data, type, full, meta) {
                          return '<md-input-container class="md-block"><input type="text" name="product_qty" ng-model="octrl.product_qty['+full[7]+']" ng-init="octrl.product_qty['+full[7]+']=\'1\'" ng-change="updateItemData(\''+full[7]+'\',\'product_qty\',octrl.product_qty['+full[7]+'])" value="1" aria-label="Quantity" maxlength="3"></md-input-container>';
                    }),
                    DTColumnBuilder.newColumn(6).withTitle('Discount %').notSortable()
                    .renderWith(function(data, type, full, meta) {
                          return '<md-input-container class="md-block"><input type="text" name="product_discount" ng-model="octrl.product_discount['+full[7]+']" ng-init="octrl.product_discount['+full[7]+']=\'0\'" ng-change="updateItemData(\''+full[7]+'\',\'product_discount\',octrl.product_discount['+full[7]+'])" value="0" aria-label="Discount" maxlength="3"></md-input-container>';
                    }),
                    DTColumnBuilder.newColumn(9).withTitle('Final Price').notSortable()
                    .renderWith(function(data, type, full, meta) {
                      var finalpriceinit = full[3]+((full[3] / 100) * full[4]); 
                      return '<md-input-container class="md-block"><input type="text" name="product_rate_final" ng-model="octrl.product_rate_final['+full[7]+']" ng-init="octrl.product_rate_final['+full[7]+']=\''+finalpriceinit+'\'" value="'+finalpriceinit+'" aria-label="Rate"></md-input-container>';
                      /*return  '£ ' + full[3];*/
                    }),
                    DTColumnBuilder.newColumn(7).withTitle('Product ID').notVisible(),
                    DTColumnBuilder.newColumn(8).withTitle('Product Groups ID').notVisible()
                    /* DTColumnBuilder.newColumn(9).withTitle('Product Rate').notVisible()*/
                  ] 
                }

               $scope.updateItemData = function(id, fieldtoupdate, newvalue){                  
                  var ratefinalwdiscount = parseFloat(self.product_rate[id]) - parseFloat(self.product_rate[id] * (self.product_discount[id] / 100));
                  var ratefinalwvat = ratefinalwdiscount * (1 + parseFloat(self.vat[id] / 100));
                  var ratefinal = parseFloat(ratefinalwvat * parseInt(self.product_qty[id]));
                  self.product_rate_final[id] = parseFloat(Math.round(ratefinal * 100) / 100).toFixed(2);
                  

                  angular.forEach(itemabrir, function(item) {
                    if(item.products_id==id && fieldtoupdate!="product_rate"){
                        var f = "item."+fieldtoupdate+" = parseInt('"+newvalue+"');";                        
                        eval(f);
                        item.product_rate_final = self.product_rate_final[id];                      
                        /*item.product_rate_final = item.product_rate * item.product_qty - (item.product_rate * (item.product_discount / 100));
                        console.log(item.product_rate_final);*/
                    }else if(item.products_id==id && fieldtoupdate=="product_rate"){
                        var f = "item."+fieldtoupdate+" = parseFloat(Math.round('"+newvalue+"' * 100) / 100).toFixed(2);";                        
                        eval(f);
                        item.product_rate_final = self.product_rate_final[id];  
                        /*item.product_rate_final = item.product_rate * item.product_qty - (item.product_rate * (item.product_discount / 100));
                        //console.log(item.product_rate_final);*/
                    }
                  });
                  /*console.log("Ver alteração:");
                  console.log(itemabrir);*/
                }
                
              break;
              case 'changeorderstatus' :
              /*self.statuses = vm.statuses;*/
              getService.async("Status", "", true).then(function(d) {
                self.statuses = d.records;
              });
              self.status_id = vm.order[0].status_id;
              break;

            }

            $scope.hide = function() {
              $mdDialog.hide();
            };
            $scope.cancel = function() {
              switch(popuptype.tipoPopup.toLowerCase()){
                case 'treatmentplan_upper':
                case 'treatmentplan_lower':
                var f = "vm."+popuptype.tipoPopup.toLowerCase()+" = false;";
                eval(f);
                break;
              }
              $mdDialog.cancel();
            };
            $scope.gravar = function(gravar, upperlower) {                
                switch(popuptype.tipoPopup.toLowerCase()){
                  case 'treatmentplan_upper':
                    var record = {};
                    record = {
                      orders_id: gravar.orders_id,
                      treatmentplan_upper: 1,
                      treatmentplan_upper_products_id: gravar.orders_product_id
                    }
                    gravar = record;
                  break;
                  case 'treatmentplan_lower':
                  var record = {};
                  record = {
                    orders_id: gravar.orders_id,
                    treatmentplan_lower: 1,
                    treatmentplan_lower_products_id: gravar.orders_product_id
                  }
                  gravar = record;
                break;
                  /*case 'addnewlinkorder':
                    gravar.linkedto_orders_id = self.linkedtoid;
                    return false;
                  break;
                  case 'addnewproduct':
                    if (typeof gravar !== 'undefined') {
                        console.log(gravar);                       
                    }
                    return false;
                  break;*/
                  case 'search' :
                    var record = {};
                        if (typeof gravar !== 'undefined') {
                          for (var i = 0; i < gravar.length; i++) {                          
                              record[i] = {
                                orders_opened_id: 0,
                                orders_id: gravar[i],
                                users_id: $scope.userid,
                                departments_id: vm.departmentsid,
                                dld: 0
                              }
                          }
                        }
                    gravar = record;                    
                  break;
                }  
                console.log(gravar);
                $mdDialog.hide();
                var tipopopup = popuptype.tipoPopup;
                var msg = popuptypes[tipopopup]['msg'];  
                otherSave(gravar, msg, tipopopup);             
            };
        }

        OtherController.$inject = ['$compile', '$scope', '$mdDialog', '$http','popuptype', 'Upload', '$timeout', 'CONFIG', 'DTOptionsBuilder','DTColumnBuilder','$location'];

        vm.otherSave = otherSave;

        function otherSave(record, message, tipopopup)
        {
            console.log("save"+tipopopup+"...");
            console.log(record);
            var orderid = vm.id;
            
            var msg = message ? message : 'Change settings changed was ';
            if((popuptypes[tipopopup]['api']==='casetype') || (popuptypes[tipopopup]['api']==='ordersproduct') || (popuptypes[tipopopup]['api']==='ordersopened') || (popuptypes[tipopopup]['api']==='orderslinked')){
              var f = "api."+popuptypes[tipopopup]['api']+".save({ record: record, orderid: orderid }).$promise.then(function (result) { console.log(result); if(result.status !== 'success'){ var erro = 'Error on changing '+result.numberfailed+' items. Please try again.'; showToast(msg, false, erro); }else{ if(popuptypes[tipopopup]['api']==='orderslinked'){ vm.linkedorders = result.linkedorders; } if(popuptypes[tipopopup]['api']==='ordersproduct'){ vm.products = result.products; updateRate(); vm.desativaTodos(); } showToast(msg);  } }, function(error) { var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; showToast(msg, false, erro); } );";
            }else{
              var f = "api."+popuptypes[tipopopup]['api']+".save({ record: record }).$promise.then(function (result) { console.log(result); if(result.status !== 'success'){ showToast(msg, false) }else{ if(popuptypes[tipopopup]['api']==='orderstatus'){ vm.estados.unshift(result.lastalert); atualizaDivSize(vm.estados.length); atualizaEstados(); } if(popuptypes[tipopopup]['api']==='ordercomments'){ vm.comments.unshift(result.lastcomment); vm.record.comment = ' '; } if(popuptypes[tipopopup]['api']==='shipping'){ vm.order = []; vm.order[0] = result.record[0]; atualizaStatus(); } showToast(msg); } }, function(error) { var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; showToast(msg, false, erro); } );";
            }
            eval(f);
            if(tipopopup!=='search'){
              saveDLDaction();
            }

            if(tipopopup==='search'){
              $timeout( function(){ 
                $state.go('app.production', {id: record[0].orders_id, 'module': active_module}, {reload: true, inherit: false, notify: true});
              }, 200 );
            }             
        }

        otherSave.$inject = ['record', 'message', 'tipopopup'];

        function otherDelete(record, message, tipopopup, upperlower)
        {
            console.log("delete"+tipopopup+"...");
            if (typeof(upperlower)==='undefined') upperlower = 0;
            var msg = message ? message : 'Change settings changed was ';            
            if(tipopopup==='removeProducts'){
              var apagartodos = record + 'h' + upperlower;
              var f = "api.ordersproduct.deleteall({ id: apagartodos }).$promise.then(function (result) { console.log(result); if(result.status !== 'success'){ showToast(msg, false) }else{ vm.products = vm.products.filter(function( obj ) {return obj.upperORlower !== upperlower; }); showToast(msg); } }, function(error) { var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; showToast(msg, false, erro); } );";
            }else{            
              var f = "api."+popuptypes[tipopopup]['api']+".delete({ id: record }).$promise.then(function (result) { console.log(result); if(result.status !== 'success'){ showToast(msg, false) }else{ if(popuptypes[tipopopup]['api']==='orderslinked'){ vm.linkedorders = vm.linkedorders.filter(function( obj ) {return obj.orders_linked_id !== result.id; }); } if(popuptypes[tipopopup]['api']==='orderslabdocs'){ vm.labdocs = vm.labdocs.filter(function( obj ) {return obj.orders_lab_docs_id !== result.id; }); } if(popuptypes[tipopopup]['api']==='ordersproduct'){ vm.products = vm.products.filter(function( obj ) {return obj.orders_product_id !== result.id; }); vm.desativaTodos(); } showToast(msg); } }, function(error) { var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; showToast(msg, false, erro); } );";
            }
            eval(f);
            saveDLDaction();             
        }

        otherDelete.$inject = ['record', 'message', 'tipopopup','upperlower'];

        /* Edição Valores Produtos */

        vm.isDisabled = [];

        vm.desativaTodos = function(){
          angular.forEach(vm.products, function(product) {            
            vm.isDisabled[product.products_id] = {
              qty: true,
              discount: true,
              price: true 
            }
          });
        }
        vm.desativaTodos();

        vm.editaCampo = function(id, field){
          var f = "vm.isDisabled['"+id+"']."+field+" = false;";
          eval(f);
        }
        
        vm.produtos = [];

        vm.atualizaValor = function(id, field, value){
          angular.forEach(vm.products, function(product) {            
            if(product.orders_product_id==id){
              var f = "product."+field+" = " + value;
              eval(f);
              if(vm.produtos[product.orders_product_id]){
                var g = "vm.produtos['"+product.orders_product_id+"']."+field+" = "+value;
                eval(g);
              }else{
                vm.produtos[product.orders_product_id] = {};
                vm.produtos[product.orders_product_id].orders_product_id = product.orders_product_id;
                var h = "vm.produtos['"+product.orders_product_id+"']."+field+" = "+value;
                eval(h);
              }
            }
          });
        }

        vm.gravaCampos = function(id){
          var count = 0;
          angular.forEach(vm.produtos, function(produto) {
            if(produto.orders_product_id == id){
              count +=1;
              var msg = "Product value(s) update was ";
              api.ordersproduct.save({record: produto}).$promise.then(function (result) 
              { 
                if(result.status !== 'success'){ 
                  showToast(msg, false);
                }else{                  
                  angular.forEach(vm.products, function(product) {
                    if(product.orders_product_id == produto.orders_product_id){
                      vm.isDisabled[product.products_id] = {
                        qty: true,
                        discount: true,
                        price: true 
                      }
                    }
                  });
                  showToast(msg);
                }
              });
            }          
          });
          if(count == 0){
            var erro = "Please change values first before saving.";
            showToast(msg, false, erro);
          }
        }

        /* FIM Edição Valores Produtos */

        /* Função Atribuir Pontos ao User */

        function atribuirPontos(points, userpointsid){
          if (typeof(userpointsid)==='undefined') userpointsid = 0;
          var recordz = {
            "user_points_id": userpointsid,
            "users_id": vm.userid,
            "orders_id": vm.id,
            "departments_id": vm.departmentsid,
            "points": points
          };

          api.userpoints.save({ record: recordz }).$promise.then(function (result) 
          { 
            console.log(result); 
            if(result.status !== 'success'){ 
              console.log("Error inserting/update user points!"); 
            }else{
              console.log("Points saved!");
            } 
          });
          
        }

        /* FIM Função Atribuir Pontos ao User */
        

    }

  ProductionControllerF.$inject = ['$compile', '$scope', '$document', '$mdToast', '$state', '$stateParams', '$http', 'getService', 'InvoicesOrders','Cliente', 'Departments', 'DeliveryRoutes', 'OrdersDepartments', 'OrdersStatusTotal', 'Shipping', 'OrdersOpened', 'OrdersCaseAssessment', 'OrdersClearMovement', 'OrdersBracketMovement', 'OrdersClearManufacturing', 'OrdersInCaseAssessment', 'OrdersInMovement', 'OrdersInManufacturing', 'OrdersWaitingCall', 'OrdersPackaging', 'OrdersPlasterroom', 'OrdersScanning', 'OrdersPlatforms', 'OrdersDesigning', 'OrdersManufacturing', 'OrdersMatching', 'OrdersPlanning', 'OrdersDrillingDesign', 'OrdersDrillingPrinting', 'OrdersDrillingAssembly', 'Orders', '$filter', 'api', '$window', '$translate', '$mdDialog', 'localStorageService', 'Upload', '$timeout', 'CONFIG', 'DTOptionsBuilder','DTColumnBuilder','$location'];

})();

(function ()
{
    'use strict';

    angular
        .module('app.orderstatus', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.orderstatus', {
              url      : '/orderstatus/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/orderstatus/orderstatus.html',
                      controller : 'OrderStatusController as vm'
                  }
              },
              resolve  : {
                Orders: function (api)
                    {
                        return api.orders.get({id: 'orderstatus'}).$promise;
                    },
                },
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/orderstatus');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.orderstatus')
        .controller('OrderStatusController', OrderStatusController)
        .filter('cmdate', [
            '$filter', function($filter) {
                return function(input, format) {
                    return $filter('date')(new Date(input), format);
                };
            }
          ]);

    function OrderStatusController($scope, $document, $mdDialog, $mdToast, $state, $window, $translate, api, Orders, DTOptionsBuilder, DTColumnBuilder, CONFIG, $timeout, localStorageService, $location)
    {
        console.log("OrderStatusController");

        var vm = this;

        vm.userid = localStorageService.get('userid');

        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
          }
          vm.admin = localStorageService.get('admin');
          vm.levelid = localStorageService.get('levelid');
  
          vm.disabled = false;
  
          /* Verifica se tem permissões de ver e/ou alterar conteúdos */
          if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || (vm.privileges[32].privileges.view != '1' && vm.privileges[22].privileges.view != '1')){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if(((vm.privileges[32].privileges.edit == '0' || vm.privileges[32].privileges.edit == null || vm.privileges[32].privileges.edit == false) && vm.privileges[32].privileges.view == '1') && (((vm.privileges[22].privileges.edit == '0' || vm.privileges[22].privileges.edit == null || vm.privileges[22].privileges.edit == false) && vm.privileges[22].privileges.view == '1'))){
                vm.disabled = true;
            }
          }

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg, state, error) {
            if (typeof(state)==='undefined') state = true;
            if(state == true){
            msg = msg + 'a success!';
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');
            }else{
            if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
            if (typeof(error)!=='undefined') msg = error;
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("error-toast")
                .position('top right');              
            }
            $mdToast.show(toast);
        }

        vm.onstoporders = Orders.onstoporders;
        vm.dueorders = Orders.dueorders;
        vm.approvedvia = Orders.approvedvia;
        vm.approvedwaiting = Orders.approvedwaiting;
        vm.waitingcall = Orders.waitingcall;
        vm.waitingimpression = Orders.waitingimpression;
        vm.inactiveorders = Orders.inactiveorders;        
        vm.numcompleted = Orders.numcompleted;
        if(typeof(Orders.total)!=='undefined'){
            vm.total = Orders.total.count;
        }else{
            vm.total = 0;
        }
        

        // vm.inactiveDate = function (data){
        //     var inactive = new Date(data);
        //     inactive.setDate(inactive.getDate() + 15);
        //     return inactive;
        // }
       
        vm.dtInstance = {};
        vm.type = 1;
        var itemabrir = [];
        var itemdata = {};

        vm.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('ajax', {
            url: CONFIG.apiBaseUrl + 'Orders/'+vm.type+'orderstatusinfo',
            type: 'POST',
            "dataSrc": function(json) {
                if(json.status && json.status == "login"){
                    $mdDialog.hide();
                    var infor = "Your login has expired. Please login again.";
                    showToast(infor, "info");
                    $location.path('/login');
                }else{
                    console.log(json);
                    return json.data;
                }
            },
            "data": function(d){
                d.search['value'] = vm.search;
                /*for (var i = 1; i < 3; ++i) {
                  var f = "d.columns["+i+"].search.value = self.search"+i+";";
                  eval(f);
                }*/
                console.log(d);
                
            },
            "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
        })
        .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
        .withDataProp('data')
        .withOption('processing', true)
        .withOption('serverSide', true)
        .withOption('filter', false)
        .withOption('bLengthChange', true)
        .withOption('bSort', false)
        .withOption('responsive',false)
        .withPaginationType('full_numbers')
        .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $('td', nRow).css('cursor', 'pointer');
          $('td', nRow).unbind('click');
          $('td', nRow).bind('click', function() {
              $scope.$apply(function() {                
                itemdata = {
                    orders_id: aData[0],
                    department_alias: aData[1],
                    departments_id: aData[2]
                  }
                  var verifica = 0;
                  angular.forEach(itemabrir, function(item) {
                    if(item.orders_id==aData[0]){
                        verifica = 1;                            
                        $(nRow).removeClass('highlitedRow');
                        itemabrir = itemabrir.filter(function( obj ) {return obj.orders_id !== aData[0]; });
                    } 
                  });
                  if(verifica == 0){
                    itemabrir.push(itemdata);
                    $(nRow).addClass('highlitedRow');
                  }
                vm.itemabrir = itemabrir;
                console.log(vm.itemabrir);
                return nRow;
                });                      
              });
          })
        .withOption('order', [])        
        .withOption('initComplete', function(){
            var api = this.api();

            vm.totalRecords = api.page.info().recordsTotal;
            vm.totalRecordsFiltered = api.page.info().recordsDisplay;

            vm.searchTable = function(searchText){
                /*var f = "self.search"+column+" = searchText;";
                eval(f);*/
                vm.search = searchText;
                vm.dtInstance.DataTable.search(searchText).draw();                  
            } 
            
            vm.reset = function(){
                vm.search = undefined;
                /*for (var i = 1; i < 3; ++i) {
                  var f = "self.search"+i+" = undefined;";
                  eval(f);
                }*/
                vm.dtInstance.reloadData(null, true);                      
            }
            
            vm.changeType = function(type){
                vm.reset();
                itemabrir = [];
                vm.itemabrir = [];
                vm.type = type;
                var newurl = CONFIG.apiBaseUrl + 'Orders/'+vm.type+'orderstatusinfo';  
                changeColumn(type);              
                $timeout( function(){                    
                    vm.dtInstance.DataTable.ajax.url(newurl).load();
                }, 100 );
                                
            }
            
        })
        .withLanguage({
            "sInfo": 'Info',
            "paginate": {
                "first": 'First',
                "last": 'Last',
                "next": 'Next',
                "previous": 'Previous'
            }
        });

        function criarColunas(){
            vm.dtColumns = [
                DTColumnBuilder.newColumn(0).withTitle('Order ID').notVisible(),
                DTColumnBuilder.newColumn(1).withTitle('Department Alias').notVisible(),
                DTColumnBuilder.newColumn(2).withTitle('Departments ID ').notVisible(),
                DTColumnBuilder.newColumn(3).withTitle('Order No'),
                DTColumnBuilder.newColumn(4).withTitle('Invoice No'),
                DTColumnBuilder.newColumn(5).withTitle('Prescription No'),
                DTColumnBuilder.newColumn(6).withTitle('Client'),
                DTColumnBuilder.newColumn(7).withTitle('Patient Name/Ref'),
                DTColumnBuilder.newColumn(8).withTitle('Patient Ref').notVisible(),
                DTColumnBuilder.newColumn(9).withTitle('Date Approved'),
                DTColumnBuilder.newColumn(10).withTitle('Postcode'),
                DTColumnBuilder.newColumn(11).withTitle('Location')            
            ]
        }
        
        criarColunas();
        changeColumn(vm.type);

        function changeColumn(type){
            if(type==1){
                vm.dtColumns = [];
                criarColunas();
                vm.dtColumns.push(
                    DTColumnBuilder.newColumn(12).withTitle('On Stop Date')
                );
            }else if(type==2){
                vm.dtColumns = [];
                criarColunas();
                vm.dtColumns.push(
                    DTColumnBuilder.newColumn(12).withTitle('Due Date')
                );
            }else if(type==3 || type==4){
                vm.dtColumns = [];
                criarColunas();
                vm.dtColumns.push(
                    DTColumnBuilder.newColumn(12).withTitle('Approved Via')
                );
            }else if(type==5){
                vm.dtColumns = [];
                criarColunas();
                vm.dtColumns.push(
                    DTColumnBuilder.newColumn(12).withTitle('WFC Date')
                );
            }else if(type==6){
                vm.dtColumns = [];
                criarColunas();
                vm.dtColumns.push(
                    DTColumnBuilder.newColumn(12).withTitle('WFI Date')
                );
            }else if(type==7){
                vm.dtColumns = [];
                criarColunas();
                vm.dtColumns.push(
                    DTColumnBuilder.newColumn(12).withTitle('Inactive Date')
                );
            }
        }
        

        /* FIM Funções Current Orders e On Invoice*/

        vm.gotoOrderStatus = gotoOrderStatus;

        function gotoOrderStatus()
        {
            console.log('go OrderStatus');
            $state.go('app.orderstatus');
        } 

        vm.gravar = function(gravar) {                
                var record = {};
                var departmentin = gravar[0].department_alias;
                var departmentsid = gravar[0].departments_id;
                if (typeof gravar !== 'undefined') {
                    for (var i = 0; i < gravar.length; i++) {                          
                        record[i] = {
                            orders_opened_id: 0,
                            orders_id: gravar[i].orders_id,
                            users_id: vm.userid,
                            departments_id: departmentsid
                        }
                    }
                    gravar = record;
                    console.log(gravar);
                    $mdDialog.hide();
                    var msg = "Order opening was ";
                    var orderid = vm.id;
                    api.ordersopened.save({ record: record, orderid: orderid }).$promise.then(function (result) { 
                        console.log(result); 
                        if(result.status !== 'success'){ 
                            showToast(msg, false) 
                        }else{ 
                            showToast(msg);
                            var url = $state.href('app.production', {'id': record[0].orders_id, 'module' : departmentin});                            
                            $window.open(url, '_blank');
                        } 
                    }, function(error) { 
                        var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                        showToast(msg, false, erro); 
                    });
                }
        }           
 
    }
    
})();    
(function ()
{
    'use strict';

    angular
        .module('app.members', ['ngFileUpload','angular.img'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.members', {
              url      : '/members/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/members/members.html',
                      controller : 'MembersController as vm'
                  }
              },
              resolve  : {
                /*User: function (api, $stateParams)
                {
                    return api.user.get({ id: $stateParams.id }).$promise;
                },*/
              },
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/members');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.members')
        .controller('MembersController', MembersController);
        
    function MembersController($scope, $document, $mdToast, $state, api, $http, $window, $translate, $mdDialog, CONFIG, localStorageService, DTOptionsBuilder,DTColumnBuilder, Upload, $location)
    {
        console.log("Members");

        var vm = this;

        vm.baseurl = $window.location.origin;
        if(vm.baseurl == "http://localhost:3000"){
          vm.baseurl = "https://nimrodtrac.app";
        }
        vm.uploadpath = 

        vm.userid = localStorageService.get('userid');

        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
          }
          vm.admin = localStorageService.get('admin');
          vm.levelid = localStorageService.get('levelid');
  
          vm.disabled = false;
  
          /* Verifica se tem permissões de ver e/ou alterar conteúdos */
          if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || vm.privileges[41].privileges.view != '1'){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if((vm.privileges[41].privileges.edit == '0' || vm.privileges[41].privileges.edit == null || vm.privileges[41].privileges.edit == false) && vm.privileges[41].privileges.view == '1'){
                vm.disabled = true;
            }
          }

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg, state, error) {
            if (typeof(state)==='undefined') state = true;
            if(state == true){
            msg = msg + 'a success!';
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');
            }else if(state == "info"){
              var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(10000)
                .theme("orange")
                .position('top right');
            }else{
            if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
            if (typeof(error)!=='undefined') msg = error;
              var toast = $mdToast.simple()
                  .content(msg)
                  .highlightAction(true)
                  .hideDelay(3000)
                  .theme("error-toast")
                  .position('top right');              
            }
            $mdToast.show(toast); 
        }
        
        function isJson(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        }

        vm.openPopup = function(ev, tipopopup) {
            if(tipopopup == "userprivileges" || tipopopup == "addpic" || tipopopup == "holidays"){
                if(typeof vm.member.id == undefined|| vm.member.id==0){
                    var msg;
                    var error = "Please create/save the user first.";
                    showToast(msg, false, error);
                    return false;
                }
            }            
            $mdDialog.show({
              controller: eval("PopupController"),
              controllerAs: 'pctrl',
              resolve: {
                popuptype: function () {
                  return {
                    'tipoPopup': tipopopup
                  };
                }
              },
              templateUrl: 'app/main/pages/members/others/'+tipopopup.toLowerCase()+'.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: $scope.customFullscreen 
            });
          };
  
          vm.openPopup.$inject = ['ev','tipopopup'];

          vm.formatDate = function (date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();
        
            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;
        
            return [year, month, day].join('-');
        }

          function PopupController($scope, $mdDialog, popuptype, $timeout, Upload, CONFIG) {
            var self = this;
            console.log(Upload);

            self.disabled = vm.disabled;

            if(popuptype.tipoPopup.toLowerCase() == "userprivileges"){
                self.selectDeselect = function(section){
                    if(self.member.privileges == null){
                        self.member.privileges = [];
                    }
                    switch (section){
                        case 1:
                            for (var i = 1; i <= 22; i++){                            
                                if(typeof self.member.privileges[i] == 'undefined'){
                                    self.member.privileges[i] = {};
                                }
                                if(typeof self.member.privileges[i].privileges == 'undefined'){
                                    self.member.privileges[i].privileges = {};
                                }
                                self.member.privileges[i].privileges.view = self.production;
                                self.member.privileges[i].privileges.edit = self.production;
                            }                    
                        break;
                        case 2:
                            for (var i = 23; i <= 34; i++){
                                if(typeof self.member.privileges[i] == 'undefined'){
                                    self.member.privileges[i] = {};
                                }
                                if(typeof self.member.privileges[i].privileges == 'undefined'){
                                    self.member.privileges[i].privileges = {};
                                }
                                self.member.privileges[i].privileges.view = self.invoicing;
                                self.member.privileges[i].privileges.edit = self.invoicing;
                            }
                        break;
                        case 3:
                            for (var i = 35; i <= 40; i++){
                                if(typeof self.member.privileges[i] == 'undefined'){
                                    self.member.privileges[i] = {};
                                }
                                if(typeof self.member.privileges[i].privileges == 'undefined'){
                                    self.member.privileges[i].privileges = {};
                                }
                                self.member.privileges[i].privileges.view = self.analytics;
                                self.member.privileges[i].privileges.edit = self.analytics;
                            }                    
                        break;
                        case 4:
                            if(typeof self.member.privileges[41] == 'undefined'){
                                self.member.privileges[41] = {};
                            }
                            if(typeof self.member.privileges[41].privileges == 'undefined'){
                                self.member.privileges[41].privileges = {};
                            }
                            self.member.privileges[41].privileges.view = self.system;
                            self.member.privileges[41].privileges.edit = self.system;
                        break;
                        case 5:
                            for (var i = 42; i <= 45; i++){
                                if(typeof self.member.privileges[i] == 'undefined'){
                                    self.member.privileges[i] = {};
                                }
                                if(typeof self.member.privileges[i].privileges == 'undefined'){
                                    self.member.privileges[i].privileges = {};
                                }
                                self.member.privileges[i].privileges.view = self.lab;
                                self.member.privileges[i].privileges.edit = self.lab;                            
                            }                    
                        break;
                        case 6:
                            if(typeof self.member.privileges[46] == 'undefined'){
                                self.member.privileges[46] = {};
                            }
                            if(typeof self.member.privileges[46].privileges == 'undefined'){
                                self.member.privileges[46].privileges = {};
                            }
                            self.member.privileges[46].privileges.view = self.marketing;
                            self.member.privileges[46].privileges.edit = self.marketing;                        
                        break;
                        case 7:
                            if(typeof self.member.privileges[47] == 'undefined'){
                                self.member.privileges[47] = {};
                            }
                            if(typeof self.member.privileges[47].privileges == 'undefined'){
                                self.member.privileges[47].privileges = {};
                            }
                            self.member.privileges[47].privileges.view = self.rd;
                            self.member.privileges[47].privileges.edit = self.rd;                        
                        break;
                    }
                }
            }else if(popuptype.tipoPopup.toLowerCase() == "addpic"){
                console.log(Upload);
                // self.userid = vm.userid;
                self.userid = vm.member.id;
                self.data = new Date();
                self.determinateValue = 0;        
                $scope.$watch('files', function () {
                    self.upload($scope.files);
                });
                $scope.$watch('file', function () {
                    if ($scope.file != null) {
                        $scope.files = [$scope.file]; 
                    }
                });
                self.log = '';
                self.upload = function (files) {
                    if (files && files.length) {
                        for (var i = 0; i < files.length; i++) {
                            var file = files[i];
                            console.log(file);
                            if (!file.$error) {
                            Upload.upload({
                                url: CONFIG.apiBaseUrl + 'AddPic',
                                data: {
                                    user_id: self.userid,
                                    file: file  
                                }
                            }).then(function (resp) {
                                console.log(resp.data);
                                vm.pic = resp.data.updatepic;
                                localStorageService.set('profileimg', resp.data.updatepic);                                
                                $mdDialog.hide();
                                var msg = "Profile Image upload were ";                        
                                showToast(msg);
    
                            }, function (error){
                                var msg = "";
                                var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                                showToast(msg, false, erro);
                            }, function (evt) {
                                var progressPercentage = parseInt(100.0 *
                                            evt.loaded / evt.total);
                                            self.determinateValue = progressPercentage;
                            }
                            );
                            }
                        }
                        }
                    };
            }else if(popuptype.tipoPopup.toLowerCase() == "holidays"){
                self.userid = vm.member.id;


                api.holidaysusersettings.get({ id: self.userid }).$promise.then(function (result) {
                    console.log(result); 
                    self.holidays.settings = result.record;
                    if(self.holidays.settings != null && typeof self.holidays.settings.month_start != 'undefined' && typeof self.holidays.settings.month_finish != 'undefined'){
                        self.holidays.settings.month_start = vm.formatDate(self.holidays.settings.month_start);
                        self.holidays.settings.month_finish = vm.formatDate(self.holidays.settings.month_finish);
                    }
                    console.log(self.holidays.settings.month_start);
                    var idx = "getDatas" + self.userid;
                    if(self.holidays.settings !== null && typeof self.holidays.settings.allowance_days != 'undefined' && self.holidays.settings.allowance_days !== null){
                        api.holidays.get({ id: idx }).$promise.then(function (result) {
                            console.log(result); 
                            self.holidays.holidayscurr = result.current_year;
                            self.holidays.holidaysprev = result.previous_year;
                            
                            self.totalcdays = 0;
                            self.totalpdays = 0;
                            
                            angular.forEach(self.holidayscurr, function(datec){
                                self.totalcdays += parseFloat(datec.totaldays);
                            });
                            angular.forEach(self.holidaysprev, function(datep){
                                self.totalpdays += parseFloat(datep.totaldays);
                            });
                            
                            self.remainingcdays = parseFloat(self.holidays.settings.allowance_days) - parseFloat(self.totalcdays);
                            self.remainingpdays = parseFloat(self.holidays.settings.allowance_days) - parseFloat(self.totalpdays);
                        });
                    }
                });
                
            }

            

            self.member = vm.member;
            console.log(self.member);
            
            $scope.hide = function() {
                $mdDialog.hide();
            };
            $scope.cancel = function() {
                $mdDialog.cancel();
            };
            $scope.gravar = function(gravar) {                
                
                if(popuptype.tipoPopup.toLowerCase() == "userprivileges" ){
                    // console.log(gravar.privileges);
                    saveUserPrivileges(gravar);
                    
                }
                if(popuptype.tipoPopup.toLowerCase() == "holidays" ){
                    gravar.settings.users_id = vm.member.id;
                    console.log(gravar);
                    var msg = "Holidays settings saving was ";
                    api.holidaysusersettings.save({ record: gravar.settings }).$promise.then(function (result) {
                        console.log(result); 
                        if(result.status !== 'success'){ 
                          showToast(msg, false); 
                        }else{ 
                          showToast(msg);
                          $mdDialog.hide();
                        } 
                    }, function(error) {
                        var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.';
                        showToast(msg, false, erro);  
                        console.log(erro); 
                    }); 
                }                 
                //$mdDialog.hide();
                gravar.id = vm.member.id;
                /*var tipopopup = popuptype.tipoPopup;
                var msg = popuptypes[tipopopup]['msg'];  
                otherSave(gravar, msg, tipopopup);*/
                };
            }

        PopupController.$inject = ['$scope', '$mdDialog', 'popuptype', '$timeout', 'Upload','CONFIG'];        

        vm.saveMember = saveMember;
        vm.cancel = cancel;
        vm.deleteMember = deleteMember;

        function saveUserPrivileges(gravar)
        {          
            console.log("saveUserPrivileges...");                     

            if(typeof gravar.privileges != 'undefined'){
                var data = gravar.privileges;
            }
            if(typeof data != 'undefined'){
                if(gravar.user_privileges_id == 0){                           
                    var record = [];            
                    for (var key in data) {
                        console.log("key " + key + " has value " + data[key]);
                        var item = {
                            privileges_id: key,
                            privileges: data[key].privileges
                        }
                        record.push(item);
                    }                
                    record = JSON.stringify(record);
                    var privilege = {};
                    privilege.user_privileges_id = gravar.user_privileges_id;
                    privilege.users_id = gravar.id;
                    privilege.privileges = record;
                }else{
                    var privilege = {};
                    privilege.user_privileges_id = gravar.user_privileges_id;                    
                    privilege.users_id = gravar.id;                    
                    privilege.privileges = JSON.stringify(gravar.privileges);
                }

                console.log(privilege);

                api.userprivileges.save({ record: privilege }).$promise.then(function (result) { 
                    console.log(result);
                    var msg = "User Privileges adding was ";
                    if(result.status !== 'success'){ 
                      showToast(msg, false);
                    }else{ 
                        if(privilege.user_privileges_id == 0){
                            privilege.user_privileges_id = result.userprivilegesid;
                        }                     
                        vm.member.privileges = JSON.parse(privilege.privileges); 
                        showToast(msg);
                        console.log(vm.member);                 
                    } }, function(error) { 
                      var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                      showToast(msg, false, erro); 
                    });
                
                $mdDialog.hide();
            }

        }

        function saveMember(data)
        {          
            console.log("saveMember...");
                     
            if(typeof data.workschedule != 'undefined'){
                data.workschedule = JSON.stringify(data.workschedule);
            }
            if(typeof data.privileges != 'undefined'){
                delete data.privileges;
            }
            if(typeof data.user_privileges_id != 'undefined'){
                delete data.user_privileges_id;
            }
            console.log(data);
            if(data.id == 0){
                var msg = 'New user created was ';
            }else{
                var msg = "User " + data.name + " change was ";
            }
            api.user.save({ record: data }).$promise.then(function (result) { 
                console.log(result);
                if(result.status == 'failed'){
                    showToast(msg, false, result.erro);                    
                }else if(result.status !== 'success'){ 
                  showToast(msg, false);
                }else{ 
                    vm.dtInstance.reloadData(null, true);
                    if(data.id == 0){
                        vm.member = {};
                    }
                    showToast(msg);
                    // if(typeof data.privileges != 'undefined'){
                    //     vm.member.privileges = JSON.parse(data.privileges);
                    // }
                    console.log(vm.member);                 
                } }, function(error) { 
                  var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                  showToast(msg, false, erro); 
                });
        }

        function cancel(){
            vm.member = [];
            vm.caixaedicao = 0;
        }

        function deleteMember(ev, id) {            
            var confirm = $mdDialog.confirm(
                        /* Este código seguinte só é preciso para mudar a cor ao botão (para vermelho para remover, por ex.) */
                        {
                            onComplete: function afterShowAnimation() {
                                var $dialog = angular.element(document.querySelector('md-dialog'));
                                var $actionsSection = $dialog.find('md-dialog-actions');
                                var $cancelButton = $actionsSection.children()[0];
                                var $confirmButton = $actionsSection.children()[1];
                                angular.element($confirmButton).addClass('md-raised md-warn');
                                angular.element($cancelButton).addClass('md-primary');
                            }
                        }
                    )
                    .title('Are you sure?')
                    .textContent('Please confirm if you would like to remove this member.')
                    .ariaLabel('Remove confirm box')
                    .targetEvent(ev)
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .ok('Yes, Remove!')
                    .cancel('No, Cancel');
            $mdDialog.show(confirm).then(function() {
                    console.log(id);
                    deleteMemberz(id);
            }, function() {
            });
        };        

        function deleteMemberz(id)
        {          
            console.log("deleteMemberz...");
            console.log(id);
            var msg = 'User deletion was ';
            api.user.delete({ id: id }).$promise.then(function (result) { 
                console.log(result); 
                if(result.status !== 'success'){ 
                    showToast(msg, false);
                }else{ 
                    vm.dtInstance.reloadData(null, true);
                    vm.member = [];
                    vm.caixaedicao = 0;
                    showToast(msg);                    
                } }, function(error) { 
                    var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                    showToast(msg, false, erro); 
                });                              
        }
            

            vm.dtInstance = {};
            var orderabrir = [];

            vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'User/fetchusers',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    /*d.search['value'] = self.search;*/
                    for (var i = 0; i < 4; ++i) {
                        var f = "d.columns["+i+"].search.value = vm.search"+i+";";
                        eval(f);
                      }
                    console.log(d);
                    
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', true)
            .withOption('bSort', false)
            .withOption('responsive',false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
              $('td', nRow).css('cursor', 'pointer');
              $('td', nRow).unbind('click');
              $('td', nRow).bind('click', function() {
                  $scope.$apply(function() {
                      if(vm.disabled == false){  
                        console.log(aData[5]);
                        var iduser = aData[5];
                        $http({
                            method: 'GET',
                            url: CONFIG.apiBaseUrl + 'User/' + iduser,
                        }).then(function successCallback(response) {                         
                                vm.member = response.data.user;
                                vm.pic = vm.member.profile_img;
                                if(isJson(vm.member.workschedule)==true){
                                    vm.member.workschedule = JSON.parse(vm.member.workschedule);
                                }
                                if(isJson(vm.member.privileges)==true){
                                    vm.member.privileges = JSON.parse(vm.member.privileges);
                                }
                                vm.caixaedicao = 1;                            
                                console.log(vm.member);
                            }, function errorCallback(response) {
                                console.log(response);
                                var erro = 'Error Code: ' + response['status'] + '. Please try again or contact administrator.'; 
                                showToast(msg, false, erro); 
                            });
                        /*if(orderabrir.includes(aData[11])==true){                            
                            var index = orderabrir.indexOf(aData[11]);
                            if (index > -1) {
                            $(nRow).removeClass('highlitedRow');
                            orderabrir.splice(index, 1);
                            }
                        }else{
                            orderabrir.push(aData[11]);
                            $(nRow).addClass('highlitedRow');
                        }
                        vm.orderabrir = orderabrir;
                        console.log(vm.orderabrir);
                        return nRow;*/
                    }
                  });
              });
            })
            .withOption('order', [])
            .withOption('initComplete', function(){
                var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;

                vm.searchTable = function(searchText, column){
                    var f = "vm.search"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance.DataTable.search(searchText).draw();                  
                } 
                
                vm.reset = function(){
                    vm.search = [];
                    for (var i = 0; i < 4; ++i) {
                        var f = "vm.search"+i+" = undefined;";
                        eval(f);
                      }
                    vm.dtInstance.reloadData(null, true);                      
                }    
                
            })
            .withLanguage({
                "sInfo": 'Info',
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(0).withTitle('Code'),
            DTColumnBuilder.newColumn(1).withTitle('Name'),
            DTColumnBuilder.newColumn(2).withTitle('Level').notSortable(),
            DTColumnBuilder.newColumn(3).withTitle('Job Title').notSortable(),
            DTColumnBuilder.newColumn(4).withTitle('Active').notSortable()
            .renderWith(function(data, type, full, meta) {
                if(typeof full[4] != 'undefined' && full[4] == 1){
                    return '<md-icon md-font-icon="icon-check" class="s24 md-default-theme md-font material-icons icon-check" aria-hidden="true"></md-icon>';
                }else{
                    return '';
                }
            }),
            DTColumnBuilder.newColumn(5).withTitle('ID').notVisible()           
        ]      
    }

    MembersController.$inject = ['$scope', '$document', '$mdToast', '$state', 'api', '$http', '$window', '$translate', '$mdDialog', 'CONFIG', 'localStorageService', 'DTOptionsBuilder','DTColumnBuilder','Upload','$location'];
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.marketing', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.marketing', {
              url      : '/marketing/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/marketing/marketing.html',
                      controller : 'MarketingController as vm'
                  }
              },
              resolve  : {
                  Marketing: function (api, $stateParams)
                  {
                    return api.marketing.get({id: "marketing"}).$promise;
                  }
              },            
              bodyClass: 'marketing-app'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/marketing');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.marketing')
        .controller('MarketingController', MarketingController);

    function MarketingController($scope, $document, $mdToast, $state, api, $window, $translate, $mdDialog, localStorageService,DTOptionsBuilder,DTColumnBuilder,CONFIG,Marketing)
    {
        console.log("Marketing");

        var vm = this;

        vm.userid = localStorageService.get('userid');
        vm.username = localStorageService.get('username');
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
        }
        vm.admin = localStorageService.get('admin');
        vm.levelid = localStorageService.get('levelid');
    
        vm.disabled = false;
    
        /* Verifica se tem permissões de ver e/ou alterar conteúdos */
        if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || (vm.privileges[46].privileges.view != '1' && vm.privileges[46].privileges.view != '1')){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if((vm.privileges[46].privileges.edit == '0' || vm.privileges[46].privileges.edit == null || vm.privileges[46].privileges.edit == false) && (vm.privileges[40].privileges.view == '1' || vm.privileges[40].privileges.view == '1')){
                vm.disabled = true;
            }
        }

        vm.caixaedicao = 0;
        vm.caixaedicaomulti = 0;    
    
        // vm.gotoProductGroups = gotoProductGroups;

        vm.goto = function(app)
        {
            console.log('go '+app);
            $state.go('app.'+app);
        }

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg, state, error) {
            if (typeof(state)==='undefined') state = true;
            if(state == true){
            msg = msg + 'a success!';
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');
            }else if(state == "info"){
              var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(10000)
                .theme("orange")
                .position('top right');
            }else{
            if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
            if (typeof(error)!=='undefined') msg = error;
              var toast = $mdToast.simple()
                  .content(msg)
                  .highlightAction(true)
                  .hideDelay(3000)
                  .theme("error-toast")
                  .position('top right');              
            }
            $mdToast.show(toast); 
        }

        vm.cards = Marketing.record;
        /*console.log("vm.cards");
        console.log(vm.cards);*/

        vm.emails = [];
        
        vm.addEmail = function(){
            vm.emails.push(vm.novoemail); 
            /*console.log(vm.emails);*/
            vm.novoemail = undefined;           
        }

        vm.deleteInviteEmail = function(email){
            console.log("deleteInviteEmail");
            vm.emails = vm.emails.filter(function( obj ) {
                return obj !== email;
            });
            /*console.log(vm.emails);*/
        }

        vm.reset = function(){
            vm.search = [];
        }

        vm.changeCompleteStatus = function(id,completed){
            var record = {
                marketing_id: id,
                completed: completed
            }          
            api.marketing.save({ record: record }).$promise.then(function (result) {
                console.log(result); 
                var msg = "Completed change status was ";
                if(result.status !== 'success'){ 
                    showToast(msg, false); 
                }else{
                    showToast(msg);                      
                }                
            }, function(error) {
                var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                showToast(msg, false, erro);
                }); 
  
        }

        vm.saveMarketing = function(record)
        {          
           console.log("saveMarketing...");
           console.log(record);
           record.emails = vm.emails;
           var msg = 'New event or task insertion was ';
            api.marketing.save({ record: record }).$promise.then(function (result) {
                console.log(result);
                if(result.status == "success"){                   
                    showToast(msg);
                    vm.caixaedicao = 0;
                    vm.marketing = undefined;
                    record.marketing_id = result.id;
                    record.name = vm.username;
                    record.created_date = new Date();
                    vm.cards.push(record);
                    vm.cancel();
                }else{
                    showToast(msg, false);
                }                
          }, function(error) {
            var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
            showToast(msg, false, erro);
            }); 
        }       

        vm.cancel = function()
        {
            vm.caixaedicao = 0;
            vm.emails = [];
        }

        vm.deleteExistingMarketing = function(ev, id) {
            var confirm = $mdDialog.confirm(
                      /* Este código seguinte só é preciso para mudar a cor ao botão (para vermelho para remover, por ex.) */
                      {
                          onComplete: function afterShowAnimation() {
                              var $dialog = angular.element(document.querySelector('md-dialog'));
                              var $actionsSection = $dialog.find('md-dialog-actions');
                              var $cancelButton = $actionsSection.children()[0];
                              var $confirmButton = $actionsSection.children()[1];
                              angular.element($confirmButton).addClass('md-raised md-warn');
                              angular.element($cancelButton).addClass('md-primary');
                          }
                      }
                  )
                  .title('Are you sure?')
                  .textContent('Please confirm if you would like to remove this event/task.')
                  .ariaLabel('Remove confirm box')
                  .targetEvent(ev)
                  .clickOutsideToClose(true)
                  .parent(angular.element(document.body))
                  .ok('Yes, Remove!')
                  .cancel('No, Cancel');
            $mdDialog.show(confirm).then(function() {
                  console.log(id);
                  deleteMarketing(id);
            }, function() {
              /* If Cancel... */
            });
          };

          var deleteMarketing = function(id){
            console.log("Delete Marketing");
            var msg = "Event/Task were deletion was ";
            api.marketing.delete({id: id}).$promise.then(function (result) {
                if(result.status == "success"){
                    vm.cards = vm.cards.filter(function( obj ) {
                        return obj.marketing_id !== id;
                    });               
                    showToast(msg);
                }else{
                    showToast(msg, false);
                }                                               
            }, function(error) {
                var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                showToast(msg, false, erro);
                });       
        }
        
    }      
    
    MarketingController.$inject = ['$scope', '$document', '$mdToast', '$state', 'api', '$window', '$translate', '$mdDialog', 'localStorageService','DTOptionsBuilder','DTColumnBuilder','CONFIG','Marketing'];  
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.invoicesearch', ['ngMask'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        console.log("invoicesearch module"); 
        $stateProvider
          .state('app.invoicesearch', {
              url      : '/Invoicing/InvoiceSearch/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/invoicesearch/invoicesearch.html',
                      controller : 'InvoiceSearchController as vm'
                  }
              },
              resolve  : {  
                InvoiceOpened: function (api, $stateParams, localStorageService)
                {
                    var userid = localStorageService.get('userid');
                    return api.invoiceopened.get({ id: userid }).$promise;
                },
                Invoice: function (api, $stateParams)
                {
                    return api.invoice.get({ id: $stateParams.id }).$promise;
                },
                InvoicesOrders: function (api, $stateParams)
                {
                    return api.invoicesorders.get({ id: $stateParams.id }).$promise;
                }, 
                Payments: function (api)
                {
                    return api.payments.get().$promise;
                }, 
                InvoicesItems: function (api, $stateParams)
                {
                    return api.invoicesitems.get({ id: $stateParams.id }).$promise;
                },
                Products: function (api)
                {
                    return api.products.get().$promise;
                },
                Clients: function (api, $stateParams)
                {
                    return api.clients.get({ id: $stateParams.id }).$promise;
                }                           
              },             
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/invoicesearch');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.invoicesearch')
        .controller('InvoiceSearchController', InvoiceSearchController)
        .factory('postService', function($http, CONFIG) {
          var postService = {
            async: function(controller, id, cache, params) {
              /* $http returns a promise, which has a then function, which also returns a promise */
              var promise = $http({
                cache: cache,
                method: 'POST',    
                url: CONFIG.apiBaseUrl + controller + '/' + id,
                data: params
              }).then(function (response) {
                /* The then function here is an opportunity to modify the response */
                console.log(response);
                /* The return value gets picked up by the then in the controller. */
                return response.data;
              });
              /* Return the promise to the controller */
              return promise;
            }
          };
          return postService;
        })
        .filter('dateRange', function() {
            return function( items, fromDate, toDate ) {
                function switchdaymonth(dateBefore){
                  var chunks = dateBefore.split('/');                
                  return chunks[1]+'/'+chunks[0]+'/'+chunks[2];
                }
                var filtered = [];
                var from_date = fromDate != undefined ? new Date(switchdaymonth(fromDate)) : 0;
                var to_date = toDate != undefined ? new Date(switchdaymonth(toDate)) : 0;
                 if(fromDate != undefined && toDate == undefined){                
                  angular.forEach(items, function(item) {
                      var data1 = new Date(item.creation_date);
                      if(data1 >= from_date) { 
                          filtered.push(item);
                      }
                  });
                  return filtered;
                }
                else if(fromDate == undefined && toDate != undefined){
                  angular.forEach(items, function(item) {
                      var data1 = new Date(item.creation_date);
                      if(data1 <= to_date) {                      
                          filtered.push(item);
                      }
                  });
                  return filtered;
                }else if(fromDate != undefined && toDate != undefined){
                  angular.forEach(items, function(item) {
                      var data1 = new Date(item.creation_date);
                      if(data1 != null) {
                          data1.setHours(0);
                          data1.setMinutes(0);
                          data1.setSeconds(0);
                          data1.setMilliseconds(0);
                      }
                      if(data1 >= from_date && data1 <= to_date) {                      
                          filtered.push(item);
                      }
                  });
                  return filtered;                
                }else if(fromDate == undefined && toDate == undefined){
                  return items;
                }
            };
        })
        .directive('validateDropdown', ['$timeout', function($timeout){        

    /* Diretiva para obrigar a escolher uma das opções do Autocomplete */    
/*    function validateDropdown($timeout) { */
                return {
                  restrict: 'A',
                  require: 'mdAutocomplete',
                  link: function(scope, elm, attr, mdAutoCompleteCtrl) {
                    $timeout(function() {
                      var input = elm.find('md-autocomplete-wrap')[0].querySelector('input');

                      /**
                      * Revalidate input model fix based on the official commit
                      * 
                      * https://github.com/angular/material/commit/399016dc76ea347cf36a9d063bcc5b5894b80f55
                      */

                      var revalidateInputModel = function() {
                        var ngModel = angular.element(input).controller('ngModel');
                        var autoCompleteScope = mdAutoCompleteCtrl.scope;
                        ngModel.$setValidity('md-require-match', !!autoCompleteScope.selectedItem || !autoCompleteScope.searchText);
                      };

                      input.addEventListener('focus', function() {
                        revalidateInputModel();
                      });

                      input.addEventListener('input', function() {
                        revalidateInputModel();
                      });
                     
                    });
                  }
                }
              }])
              .directive('scanInvoice', function($timeout, $q, CONFIG, $http, $state, $mdDialog, api, localStorageService, $window) {
                return {
                  restrict: 'AE',
                  require: 'ngModel',
                  link: function($scope, elm, attr, model) { 
                    model.$asyncValidators.orderExists = function(modelValue, viewValue) {
                      var valuez = modelValue || viewValue;
                      var value = valuez.substr(1);                           
                        return $http.get(CONFIG.apiBaseUrl + 'Invoice/con' + value).
                           then(function (response) {
                             console.log(response.data.status);
                             if(response.data.status == "success"){
                                model.$setValidity('erro', true);
                                $mdDialog.cancel();
                                var invoiceid = response.data.invoiceid.invoices_id;
                                var userid = localStorageService.get('userid');
                                var record = {};                      
                                record = {
                                    invoices_opened_id: 0,                                    
                                    users_id: userid,
                                    invoices_id: invoiceid                                    
                                }           
                                api.invoiceopened.save({ record: record });
                                $timeout( function(){
                                    var url = $state.href('app.invoice', {id: invoiceid});
                                    $window.open(url, '_blank');
                                }, 200 );                      
                              return true;
                             }else if(response.data.status == "failed"){             
                              model.$setValidity('erro', false);
                              return false;
                             }                       
                           }, function rejected() {
                            console.log("erro 4xx");                       
                           });            
                    };
                  }
                } 
              });

    function InvoiceSearchController($scope, $document, $mdToast, $state, $stateParams, $filter, Invoice, InvoiceOpened, InvoicesOrders, Payments, InvoicesItems, Products, Clients, api, $window, $translate, $mdDialog, localStorageService, $timeout, CONFIG, DTOptionsBuilder,DTColumnBuilder, postService)
    {
        var vm = this; 
        
        vm.baseurl = $window.location.origin;
        if(vm.baseurl == "http://localhost:3000"){
          vm.baseurl = "https://nimrodtrac.app";
        }
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
          }
          vm.admin = localStorageService.get('admin');
          vm.levelid = localStorageService.get('levelid');
  
          vm.disabled = false;
  
          /* Verifica se tem permissões de ver e/ou alterar conteúdos */
          if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || vm.privileges[24].privileges.view != '1'){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if((vm.privileges[24].privileges.edit == '0' || vm.privileges[24].privileges.edit == null || vm.privileges[24].privileges.edit == false) && vm.privileges[24].privileges.view == '1'){
                vm.disabled = true;
            }
          }

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }
        
        function showToast(msg, state, error) {
            if (typeof(state)==='undefined') state = true;
            if(state == true || state == 2){
              msg = (state == 2) ? msg : msg + 'a success!';
              /*msg = msg + 'a success!';*/
              /*var delay = (state == 2) ? 0 : 3000;*/
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay('10000')
                .theme("success-toast")
                .position('top right');                
            }else if(state == "info"){
              var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(10000)
                .theme("orange")
                .position('top right');
            }else{
            if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
            if (typeof(error)!=='undefined') msg = error;
              var toast = $mdToast.simple()
                  .content(msg)
                  .highlightAction(true)
                  .hideDelay(10000)
                  .theme("error-toast")
                  .position('top right');              
            }
            $mdToast.show(toast); 
          }        
        
        vm.allinvoices = Invoice.records;
        angular.forEach(vm.allinvoices, function(invoice, index){
            invoice.index = index;
          });

        vm.userid = localStorageService.get('userid');  
        // vm.invoices_opened = InvoiceOpened.record;        
        // console.log(vm.allinvoices);

        // vm.invoiceid = $state.params.id !="" ? $state.params.id : 0;              
        

        // if(vm.invoiceid > 0){
        //   vm.invoice = Invoice.record;          
        //   vm.invoices_orders = InvoicesOrders.records;
        //   vm.payments = Payments.records;
        //   vm.allproducts = Products.records;
        // }

        /********************* */
        /* Funções Botões Topo */
        /***********************/

        
        /***************************/
        /* END Funções Botões Topo */
        /***************************/

        /*****************************/
        /* Funções Pesquisa / Search */
        /*****************************/

        vm.reset = function(){
          vm.search = [];
          vm.startDate = undefined;
          vm.endDate = undefined;
        }

        /* Datatables - Multi Select */
        vm.itemabrir = [];
        vm.dtInstance = {};
        var itemabrir = [];
        var itemdata = {};       

        var urlpost = CONFIG.apiBaseUrl + 'Invoice/fetchinvoices';
        var numcolumns = 16;

        vm.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('ajax', {
            url: urlpost,
            type: 'POST',
            "dataSrc": function(json) {
              if(json.status && json.status == "login"){
                $mdDialog.hide();
                var infor = "Your login has expired. Please login again.";
                showToast(infor, "info");
                $location.path('/login');
              }else{
                console.log(json);
                return json.data;
              }
            },
            "data": function(d){
                /*d.search['value'] = self.searchz;*/
                for (var i = 0; i < numcolumns; ++i) {
                  var f = "d.columns["+i+"].search.value = self.search"+i+";";
                  eval(f);
                }
                console.log(d);
                
            },
            "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}                    
        })
        .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
        .withDataProp('data')
        .withOption('processing', true)
        .withOption('serverSide', true)
        .withOption('filter', false)
        .withOption('bLengthChange', true)
        .withOption('bSort', false)
        .withOption('responsive',false)
        .withPaginationType('full_numbers')
        .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $('td', nRow).css('cursor', 'pointer');
          $('td', nRow).unbind('click');
          $('td', nRow).bind('click', function() {
              $scope.$apply(function() {                                 
                if(itemabrir.includes(aData[9])==true){                            
                  var index = itemabrir.indexOf(aData[9]);
                  if (index > -1) {
                    $(nRow).removeClass('highlitedRow');
                    itemabrir.splice(index, 1);
                  }
                }else{
                  itemabrir.push(aData[9]);
                  $(nRow).addClass('highlitedRow');
                }
                vm.itemabrir = itemabrir;
                console.log(vm.itemabrir);
                return nRow;                      
              });
          });
        })
        /*.withOption('createdRow', function(row) {
          // Recompiling so we can bind Angular directive to the DT
          $compile(angular.element(row).contents())($scope);
      })*/
        .withOption('order', [])
        .withOption('initComplete', function(){
            var api = this.api();

            vm.totalRecords = api.page.info().recordsTotal;
            vm.totalRecordsFiltered = api.page.info().recordsDisplay;

            vm.searchTable = function(searchText, column){
                var f = "self.search"+column+" = searchText;";
                eval(f);
              vm.dtInstance.DataTable.search(searchText).draw();                  
            } 
            
            vm.reset = function(){                      
              vm.search = [];
              vm.startDate = undefined;
              vm.endDate = undefined;
              vm.onDate = undefined;
              for (var i = 0; i < numcolumns; ++i) {
                var f = "self.search"+i+" = undefined;";
                eval(f);
              }
              vm.dtInstance.reloadData(null, true);                      
            }    
            
        })
        .withLanguage({
            "sInfo": 'Info',
            "paginate": {
                "first": 'First',
                "last": 'Last',
                "next": 'Next',
                "previous": 'Previous'
            }
        });

        
        vm.dtColumns = [
          DTColumnBuilder.newColumn(0).withTitle('Invoice Number'),
          DTColumnBuilder.newColumn(1).withTitle('Prescription No').notVisible(),
          DTColumnBuilder.newColumn(2).withTitle('City'),
          DTColumnBuilder.newColumn(3).withTitle('Country'),
          DTColumnBuilder.newColumn(4).withTitle('Postcode'),
          DTColumnBuilder.newColumn(5).withTitle('Practice Name')/*.notVisible()*/,
          DTColumnBuilder.newColumn(6).withTitle('Practice No'),
          DTColumnBuilder.newColumn(7).withTitle('Client'),
          DTColumnBuilder.newColumn(8).withTitle('GDC No'),
          DTColumnBuilder.newColumn(9).withTitle('Invoices ID').notVisible(),
          DTColumnBuilder.newColumn(10).withTitle('Patient Name'),
          DTColumnBuilder.newColumn(11).withTitle('Client Name'),
          DTColumnBuilder.newColumn(12).withTitle('Invoices Status').notVisible(),
          DTColumnBuilder.newColumn(13).withTitle('Creation Date').notVisible(),
          DTColumnBuilder.newColumn(14).withTitle('Start Date').notVisible(),
          DTColumnBuilder.newColumn(15).withTitle('End Date').notVisible(),
        ];                                 
        /* END Datatables - Multi Select */

        /* FIM Funções Current Orders e On Invoice*/

        vm.goToPage = function(page, invoiceid, close){          
            close = typeof close !== 'undefined' ? close : false;
            invoiceid = typeof invoiceid !== 'undefined' ? invoiceid : null;
            console.log('Antes: ' + invoiceid);
            if(close == true){
              api.invoiceopened.delete({ id: invoiceid }).$promise.then(function (result) { console.log(result); if(result.status !== 'success'){ showToast(msg, false) } }, function(error) { var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; showToast(msg, false, erro); } );

              vm.invoices_opened = vm.invoices_opened.filter(function( obj ) {return obj.invoices_id !== invoiceid; }); 
              if(Object.keys(vm.invoices_opened).length > 0){           
                invoiceid = vm.invoices_opened[0].invoices_id;
              }else{
                invoiceid = '';
              }              
            }
            
            console.log('Go to ' + page + ' with id ' + invoiceid);
            if(invoiceid != null && invoiceid != ''){
              $state.go('app.'+page, {id: invoiceid});
            }else{
              $state.go('app.'+page, {id: ''});             
            }
                       
        }

        function downloadFile(url, success) {
          var xhr = new XMLHttpRequest();
          xhr.open('GET', url, true);
          xhr.setRequestHeader("Authorization", 'Bearer ' + localStorageService.get('token'));
          xhr.responseType = "blob";
          xhr.onreadystatechange = function() {
              if (xhr.readyState == 4) {
                  if (success) success(xhr.response);
              }
          };
          xhr.send(null);
        }

        vm.sendEmail = function(invoicesid){
          if(typeof invoicesid != 'undefined' && invoicesid.length > 0 ){
            var id = "sendemailz";
            postService.async("Invoice", id, false, invoicesid).then(function(d) {
              if(d.status == "success"){              
                showToast(d.msg, 2);
              }else{
                showToast('', false, d.error);
              }
            });
          }else{
            showToast('', false, 'Please select a invoice first');
          }
        }

        vm.printInvoices = function(invoicesid){
          if(typeof invoicesid != 'undefined' && invoicesid.length > 0 ){
            var id = "printselected";
            postService.async("Invoice", id, false, invoicesid).then(function(d) {
              if(d.status == "success"){
                  if(d.file){                        
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                      /* IE 11 */
                      downloadFile(vm.baseurl+'/api/Dlfile?type=invoices&name='+d.file, function(blob) {
                      window.navigator.msSaveOrOpenBlob(blob);
                      });                
                    }else{              
                      /* Chrome e Firefox */
                      var win = window.open('_blank');
                      downloadFile(vm.baseurl+'/api/Dlfile?type=invoices&name='+d.file, function(blob) {
                          var url = URL.createObjectURL(blob);
                          win.location = url;
                      });
                    }              
                  }
                  showToast(d.msg, 2);              
              }else{
                showToast('', false, d.error);
              }
            });
          }else{
            showToast('', false, 'Please select a invoice first');
          }
        }
        
        vm.gotoOrderStatus = gotoOrderStatus;

        function gotoOrderStatus()
        {
            console.log('go OrderStatus');
            $state.go('app.orderstatus');
            /* TESTES.... :
            $state.go('app.production', { 'id': 1, 'module' : 'Go'});
            $state.go('app.production', {id: 2}, {notify: false});             
            $state.transitionTo('app.production', {id: 1}, {
                location: true,
                inherit: true,
                relative: $state.$current,
                notify: true,
                reload: false
             });*/
        }
        
        vm.openInvoice = function(gravar){
          var record = {};
          if (typeof gravar !== 'undefined') {
            for (var i = 0; i < gravar.length; i++) {                          
                record[i] = {
                  invoices_opened_id: 0,
                  invoices_id: gravar[i],
                  users_id: vm.userid
                }
            }
          }
          var msg = "Invoice opening was ";  
          api.invoiceopened.save({ record: record }).$promise.then(function (result) { console.log(result); 
            if(result.status !== 'success'){ 
              showToast(msg, false) 
            }else{ 
              showToast(msg);
              $timeout( function(){                
                var url = $state.href('app.invoice', {'id': record[0].invoices_id}, {reload: true, inherit: false, notify: true});                          
                $window.open(url, '_blank');
              }, 200 );
            } 
          }, function(error) { 
            var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
            showToast(msg, false, erro); 
            } 
          );          
        }

        vm.openPopupOther = function(ev, tipopopup, upperlower) {
          if (typeof(upperlower)==='undefined') upperlower = 0;               
          $mdDialog.show({
            controller: eval("OtherController"),
            controllerAs: 'octrl',
            resolve: {
              popuptype: function () {
                return {
                  'tipoPopup': tipopopup,
                  'upperlower': upperlower
                };
              }
            },
            templateUrl: 'app/main/pages/invoice/templates/'+tipopopup.toLowerCase()+'.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: $scope.customFullscreen 
          });
        };

        vm.openPopupOther.$inject = ['ev','tipopopup'];

        function OtherController($scope, $mdDialog, popuptype, $timeout, CONFIG, DTOptionsBuilder) {
            var self = this;
            $scope.userid = vm.userid;
            $scope.username = vm.username;
            $scope.data = new Date();
            $scope.id = vm.id;
            $scope.hide = function() {
              $mdDialog.hide();
            };
            $scope.cancel = function() {
              $mdDialog.cancel();
            };
            $scope.gravar = function(gravar, upperlower) {                
                switch(popuptype.tipoPopup.toLowerCase()){
                  case 'search' :
                    var record = {};
                    if (typeof gravar !== 'undefined') {
                      for (i = 0; i < gravar.length; i++) {                          
                          record[i] = {
                            invoices_opened_id: 0,
                            invoices_id: gravar[i].invoices_id,
                            users_id: $scope.userid
                          }
                      }
                    }
                    gravar = record;
                    console.log(gravar);
                  break;
                }  
                $mdDialog.hide();
                var tipopopup = popuptype.tipoPopup;
                var msg = popuptypes[tipopopup]['msg'];  
                otherSave(gravar, msg, tipopopup);             
            };
        }

        OtherController.$inject = ['$scope', '$mdDialog', 'popuptype', '$timeout', 'CONFIG', 'DTOptionsBuilder'];

        vm.otherSave = otherSave;

        function otherSave(record, message, tipopopup)
        {
            console.log("save"+tipopopup+"...");
            console.log(record);
            var invoiceid = vm.invoiceid;
            
            var msg = message ? message : 'Change settings changed was ';
            if((popuptypes[tipopopup]['api']==='invoicesitems') || (popuptypes[tipopopup]['api']==='invoiceopened')){
              var f = "api."+popuptypes[tipopopup]['api']+".save({ record: record, invoiceid: invoiceid }).$promise.then(function (result) { console.log(result); if(result.status !== 'success'){ var erro = 'Error on changing '+result.numberfailed+' items. Please try again.'; showToast(msg, false, erro); }else{ if(popuptypes[tipopopup]['api']==='invoicesitems'){ vm.invoicesitems = result.items; updateNetVATTotal(); vm.allproducts = result.allproducts; } showToast(msg);  } }, function(error) { var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; showToast(msg, false, erro); } );";
            }else{
              var f = "api."+popuptypes[tipopopup]['api']+".save({ record: record }).$promise.then(function (result) { console.log(result); if(result.status !== 'success'){ showToast(msg, false) }else{ showToast(msg); } }, function(error) { var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; showToast(msg, false, erro); } );";
            }
            eval(f);
            if(tipopopup!=='search'){
              //saveDLDaction();
            }

            if(tipopopup==='search'){
              $state.go('app.invoice', {id: record[0].invoices_id});
            }             
        }

        otherSave.$inject = ['record', 'message', 'tipopopup'];

        function otherDelete(record, message, tipopopup, upperlower)
        {
            console.log("delete"+tipopopup+"...");
            if (typeof(upperlower)==='undefined') upperlower = 0;
            var msg = message ? message : 'Change settings changed was ';            
            if(tipopopup==='removeProducts'){
              var apagartodos = record + 'h' + upperlower;
              var f = "api.ordersproduct.deleteall({ id: apagartodos }).$promise.then(function (result) { console.log(result); if(result.status !== 'success'){ showToast(msg, false) }else{ vm.products = vm.products.filter(function( obj ) {return obj.upperORlower !== upperlower; }); showToast(msg); } }, function(error) { var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; showToast(msg, false, erro); } );";
            }else{            
              var f = "api."+popuptypes[tipopopup]['api']+".delete({ id: record }).$promise.then(function (result) { console.log(result); if(result.status !== 'success'){ showToast(msg, false) }else{ if(popuptypes[tipopopup]['api']==='orderslinked'){ vm.linkedorders = vm.linkedorders.filter(function( obj ) {return obj.orders_linked_id !== result.id; }); vm.listorders = result.listorders; } if(popuptypes[tipopopup]['api']==='orderslabdocs'){ vm.labdocs = vm.labdocs.filter(function( obj ) {return obj.orders_lab_docs_id !== result.id; }); } if(popuptypes[tipopopup]['api']==='ordersproduct'){ vm.products = vm.products.filter(function( obj ) {return obj.orders_product_id !== result.id; }); } showToast(msg); } }, function(error) { var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; showToast(msg, false, erro); } );";
            }
            eval(f);
            saveDLDaction();             
        }

        otherDelete.$inject = ['record', 'message', 'tipopopup'];

    }

    InvoiceSearchController.$inject = ['$scope', '$document', '$mdToast', '$state', '$stateParams', '$filter', 'Invoice', 'InvoiceOpened', 'InvoicesOrders', 'Payments', 'InvoicesItems', 'Products', 'Clients', 'api', '$window', '$translate', '$mdDialog', 'localStorageService', '$timeout', 'CONFIG', 'DTOptionsBuilder','DTColumnBuilder', 'postService'];

})();

(function ()
{
    'use strict';

    angular
        .module('app.invoice', ['ngMask'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, $httpProvider)
    {
        console.log("invoice module");       
        $stateProvider
          .state('app.invoice', {
              url      : '/Invoicing/Invoice/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/invoice/invoice.html',
                      controller : 'InvoiceController as vm'
                  }
              },
              resolve  : {                  
                InvoiceOpened: function (api, $stateParams, localStorageService)
                {
                    var userid = localStorageService.get('userid');
                    return api.invoiceopened.get({ id: userid }).$promise;
                },
                Invoice: function (api, $stateParams)
                {
                    return api.invoice.get({ id: $stateParams.id }).$promise;
                },
                InvoicesOrders: function (api, $stateParams)
                {
                    return api.invoicesorders.get({ id: $stateParams.id }).$promise;
                }, 
                Payments: function (api)
                {
                    return api.payments.get().$promise;
                }, 
                InvoicesItems: function (api, $stateParams)
                {
                    return api.invoicesitems.get({ id: $stateParams.id }).$promise;
                },
                Products: function (api)
                {
                    return api.products.get().$promise;
                },
                Clients: function (api, $stateParams)
                {
                    return api.clients.get({ id: $stateParams.id }).$promise;
                }              
              },             
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/invoice');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.invoice')
        .controller('InvoiceController', InvoiceController)
        .factory('getService', function($http, CONFIG, localStorageService) {
          var getService = {            
            async: function(controller, id, cache) {
              // $http returns a promise, which has a then function, which also returns a promise
              var promise = $http({
                cache: cache,
                method: 'GET',    
                url: CONFIG.apiBaseUrl + controller + '/' + id,
                // headers: {'Authorization' : 'Bearer ' + localStorageService.get('token')}
              }).then(function (response) {
                // The then function here is an opportunity to modify the response
                console.log(response);
                // The return value gets picked up by the then in the controller.
                return response.data;
              });
              // Return the promise to the controller
              return promise;
            }
          };
          return getService;
          console.log('Bearer ' + localStorageService.get('token'));
        })
        .factory('postService', function($http, CONFIG) {
          var postService = {
            async: function(controller, id, record) {
              // $http returns a promise, which has a then function, which also returns a promise
              var promise = $http({
                method: 'POST',
                data: record,    
                url: CONFIG.apiBaseUrl + controller + '/' + id,
                // headers: {'Authorization' : 'Bearer ' + localStorageService.get('token')}
              }).then(function (response) {
                // The then function here is an opportunity to modify the response
                console.log(response);
                // The return value gets picked up by the then in the controller.
                return response.data;
              });
              // Return the promise to the controller
              return promise;
            }
          };
          return postService;
        })
        .filter('cmdate', [
          '$filter', function($filter) {
              return function(input, format) {
                  return $filter('date')(new Date(input), format);
              };
          }
        ])
        .filter('dateRange', function() {
          return function( items, fromDate, toDate ) {
              var filtered = [];      
              if(fromDate != undefined && toDate == undefined){
                var from_date = Date.parse(fromDate);
                var to_date = Date.parse(toDate);
                angular.forEach(items, function(item) {
                    var data1 = Date.parse(item.creation_date);
                    if(data1 > from_date) {                      
                        filtered.push(item);
                    }
                });
                return filtered;
              }else if(fromDate == undefined && toDate != undefined){
                var from_date = Date.parse(fromDate);
                var to_date = Date.parse(toDate);
                angular.forEach(items, function(item) {
                    var data1 = Date.parse(item.creation_date);
                    if(data1 < to_date) {                      
                        filtered.push(item);
                    }
                });
                return filtered;
              }else if(fromDate != undefined && toDate != undefined){
                var from_date = Date.parse(fromDate);
                var to_date = Date.parse(toDate);
                angular.forEach(items, function(item) {
                    var data1 = Date.parse(item.creation_date);
                    if(data1 > from_date && data1 < to_date) {                      
                        filtered.push(item);
                    }
                });
                return filtered;                
              }else if(fromDate == undefined && toDate == undefined){
                return items;
              }
          };
      })
        .directive('validateDropdown', ['$timeout', function($timeout){        

    /* Diretiva para obrigar a escolher uma das opções do Autocomplete */    
/*    function validateDropdown($timeout) { */
                return {
                  restrict: 'A',
                  require: 'mdAutocomplete',
                  link: function(scope, elm, attr, mdAutoCompleteCtrl) {
                    $timeout(function() {
                      var input = elm.find('md-autocomplete-wrap')[0].querySelector('input');

                      /**
                      * Revalidate input model fix based on the official commit
                      * 
                      * https://github.com/angular/material/commit/399016dc76ea347cf36a9d063bcc5b5894b80f55
                      */

                      var revalidateInputModel = function() {
                        var ngModel = angular.element(input).controller('ngModel');
                        var autoCompleteScope = mdAutoCompleteCtrl.scope;
                        ngModel.$setValidity('md-require-match', !!autoCompleteScope.selectedItem || !autoCompleteScope.searchText);
                      };

                      input.addEventListener('focus', function() {
                        revalidateInputModel();
                      });

                      input.addEventListener('input', function() {
                        revalidateInputModel();
                      });
                     
                    });
                  }
                }
              }]);

    function InvoiceController($compile, $scope, $document, $mdToast, $state, $stateParams, $filter, getService, postService, Invoice, InvoiceOpened, InvoicesOrders, Payments, InvoicesItems, Products, Clients, api, $window, $translate, $mdDialog, localStorageService, $timeout, CONFIG, DTOptionsBuilder, DTColumnBuilder, $location, $rootScope)
    {
        var vm = this;

        vm.baseurl = $window.location.origin;
        if(vm.baseurl == "http://localhost:3000"){
          vm.baseurl = "https://nimrodtrac.app";
        }
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
          vm.privileges = JSON.parse(localStorageService.get('privileges'));
        }
        vm.admin = localStorageService.get('admin');
        vm.levelid = localStorageService.get('levelid');

        vm.disabled = false;

        /* Verifica se tem permissões de ver e/ou alterar conteúdos */
        if(vm.admin != '1' && vm.levelid != '1'){
          if(vm.privileges == null || vm.privileges[23].privileges.view != '1'){
              var infor = "You don't have enough permission to enter this area.";
              showToast(infor, "info");
              $state.go('app.dashboard');
          }else if((vm.privileges[23].privileges.edit == '0' || vm.privileges[23].privileges.edit == null || vm.privileges[23].privileges.edit == false) && vm.privileges[23].privileges.view == '1'){
              vm.disabled = true;
          }
        }        
        
        var popuptypes = {
          'cancelOrder': {
            'msg' : 'New Cancel Alert was ',
            'api' : 'orderstatus'
          },
          'approveOrder': {
            'msg' : 'New Approve Alert was ',
            'api' : 'orderstatus'
          },
          'waitingImpressions': {
            'msg' : 'New WFI Alert was ',
            'api' : 'orderstatus'
          },
          'waitingCall': {
            'msg' : 'New WFC Alert was ',
            'api' : 'orderstatus'
          },
          'completeOrder': {
            'msg' : 'New Complete Order Alert was ',
            'api' : 'orderstatus'
          },
          'newOrderAlert': {
            'msg' : 'New Custom Order Alert was ',
            'api' : 'orderstatus'
          },
          'addNewMessage': {
            'msg' : 'New Comment Message was ',
            'api' : 'ordercomments'
          },
          'addNewDeliveryRoute': {
            'msg' : 'Delivery Route Change was ',
            'api' : 'shipping'
          },
          'RemoveDeliveryRoute': {
            'msg' : 'Delivery Route Removal was ',
            'removemsg' : 'Please confirm if you would like to remove the Delivery Route.',
            'api' : 'shipping'
          },
          'addNewLinkOrder': {
            'msg' : 'New Link Order was ',
            'api' : 'orderslinked'
          },
          'removeLinkedOrder': {
            'msg' : 'Link Order removal was ',
            'removemsg' : 'Please confirm if you would like to remove this Linked Order.',
            'api' : 'orderslinked'
          },
          'addLabDoc': {
            'msg' : 'New Lab Doc was '
          },
          'removeLabDoc': {
            'msg' : 'Lab Doc removal was ',
            'removemsg' : 'Please confirm if you would like to remove this Lab Doc.',
            'api' : 'orderslabdocs'
          },
          'showCaseType': {
            'msg' : 'Case Type Change was ',
            'api' : 'casetype'
          },
          'addNewProduct': {
            'msg' : 'Adding Product(s) was ',
            'api' : 'invoicesitems'
          },
          'addProductsFromOrder': {
            'msg' : 'Adding of Products from Order ',
            'api' : 'invoicesitems'
          },
          'removeProduct': {
            'msg' : 'Product removal was ',
            'removemsg' : 'Please confirm if you would like to remove this product.',
            'api' : 'ordersproduct'
          },
          'removeProducts': {
            'msg' : 'All Product removal was ',
            'removemsg' : 'Please confirm if you would like to remove all products.',
            'api' : 'ordersproduct'
          },
          'verified': {
            'msg' : 'Verify Order Change was ',
            'api' : 'shipping'
          },
          'treatmentplan_upper': {
            'msg' : 'Treatment Plan Upper Change was ',
            'api' : 'shipping'
          },
          'treatmentplan_lower': {
            'msg' : 'Treatment Plan Lower Change was ',
            'api' : 'shipping'
          },
          'approvedvia': {
            'msg' : 'Approved Via Change was ',
            'api' : 'shipping'
          },
          'search': {
            'msg' : 'Order opening was ',
            'api' : 'invoiceopened'
          },
          'changeOrderStatus': {
            'msg' : 'Order Status Change was ',
            'api' : 'shipping'
          },
          'sendInvoice': {
            'msg' : 'E-mail invoice was ',
            'api' : 'invoice'
          }
          
       };

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg, state, error) {
          if (typeof(state)==='undefined') state = true;
          if(state == true){
          msg = msg + 'a success!';
          var toast = $mdToast.simple()
              .content(msg)
              .highlightAction(true)
              .hideDelay(3000)
              .theme("success-toast")
              .position('top right');
          }else if(state == "info"){
            var toast = $mdToast.simple()
              .content(msg)
              .highlightAction(true)
              .hideDelay(10000)
              .theme("orange")
              .position('top right');
          }else{
          if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
          if (typeof(error)!=='undefined') msg = error;
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("error-toast")
                .position('top right');              
          }
          $mdToast.show(toast); 
        }        
        
        /*vm.allinvoices = Invoice.records;*/
        vm.invoices_opened = InvoiceOpened.record;        
        // console.log(vm.invoices_opened);

        vm.invoiceid = $state.params.id !="" ? $state.params.id : 0;              
        

        if(vm.invoiceid > 0){
          vm.invoice = Invoice.record;          
          vm.invoices_orders = InvoicesOrders.records;
          vm.payments = Payments.records;
          /*vm.allproducts = Products.records;*/
          
          updateOrders();

          vm.invoicesitems = InvoicesItems.records;
          updateNetVATTotal();

          invoiceExist();

        }

        function downloadFile(url, success) {
          var xhr = new XMLHttpRequest();
          xhr.open('GET', url, true);
          xhr.setRequestHeader("Authorization", 'Bearer ' + localStorageService.get('token'));
          xhr.responseType = "blob";
          xhr.onreadystatechange = function() {
              if (xhr.readyState == 4) {
                  if (success) success(xhr.response);
              }
          };
          xhr.send(null);
        }

        function invoiceExist(){
          var id = "CIO"+vm.invoiceid;
          getService.async("Invoice", id, false).then(function(d) {
            if(d.status == "failed"){
              vm.invoiceexist = true;
            }else{
              vm.invoiceexist = false;
            }
          });
        }

        function updateOrders(){
          if(vm.invoice.clients_id!=0){
            vm.current_orders = {};
            api.ordersbyclient.get({id: vm.invoice.clients_id}).$promise.then(function (result) { 

              if(result.status !== 'success'){                         
                showToast(msg, false) 
              }else{
                if(result.records){
                  vm.current_orders = result.records;
                  vm.current_orders.forEach(function(currorder) {
                    currorder.checked = false;
                  });
                }
              }
            });
          }
        }

        /********************* */
        /* Funções Botões Topo */
        /***********************/

        vm.createInvoice = function(ev) {
          var confirm = $mdDialog.confirm(
                    /* Este código seguinte só é preciso para mudar a cor ao botão (para vermelho para remover, por ex.) */
                    {
                        onComplete: function afterShowAnimation() {
                            var $dialog = angular.element(document.querySelector('md-dialog'));
                            var $actionsSection = $dialog.find('md-dialog-actions');
                            var $cancelButton = $actionsSection.children()[0];
                            var $confirmButton = $actionsSection.children()[1];
                            angular.element($confirmButton).addClass('md-green-500-bg branco');
                            angular.element($cancelButton).addClass('md-primary');
                        }
                    }
                )
                .title('Are you sure?')
                .textContent('Please confirm if you would like to create a new invoice.')
                .ariaLabel('Creation confirm box')
                .targetEvent(ev)
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('Yes, Create!')
                .cancel('No, Cancel');
          $mdDialog.show(confirm).then(function() {
                    api.invoice.get().$promise.then(function (result) { 
                      console.log(result); 
                      if(result.status !== 'OK'){                         
                        showToast(msg, false) 
                      }else{
                        if(result.lastinvoicenumber){
                          var order_numberZ = parseInt((result.lastinvoicenumber.invoice_number).substring(2)) + 1;
                          if(order_numberZ == 999999){order_numberZ = 100001; };
                        }else{
                          var order_numberZ = 100001;
                        }                        
                        var order_number = "IO"+order_numberZ;                        
                        var record = {
                          invoices_id: 0,
                          invoice_number: order_number
                        };
                        console.log(record);
                        var msg = 'New Order was ';
                        api.invoice.save({ record: record }).$promise.then(function (result) { 
                          console.log(result); 
                          if(result.status !== 'success'){ 
                            showToast(msg, false) 
                          }else{ 
                            showToast(msg); 
                            console.log(result.newinvoiceid);
                            saveDLDaction(result.newinvoiceid);
                            
                            var newrecord = {
                              invoices_opened_id: 0,
                              users_id: vm.userid,
                              invoices_id: result.newinvoiceid
                            }

                            api.invoiceopened.save({ record: newrecord }).$promise.then(function (result) { 
                              console.log(result); 
                              if(result.status !== 'success'){ 
                                showToast(msg, false);
                              }                   
                            }, 
                            function(error) { 
                              var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                              showToast(msg, false, erro); 
                            }); 

                            $state.go('app.invoice', {id: result.newinvoiceid}); 
                          } }, function(error) { 
                            var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                            showToast(msg, false, erro); 
                          });
                      } 
                    }, function(error) { 
                      var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                      showToast(msg, false, erro); 
                    });                
                
          }, function() {
          });
        };

        /*vm.generateInvoice = function(ev) {
          if(vm.invoice.invoices_status == 0 && vm.invoicesitems.length > 0){
            var confirm = $mdDialog.confirm(
              /* Este código seguinte só é preciso para mudar a cor ao botão (para vermelho para remover, por ex.) 
              {
                  onComplete: function afterShowAnimation() {
                      var $dialog = angular.element(document.querySelector('md-dialog'));
                      var $actionsSection = $dialog.find('md-dialog-actions');
                      var $cancelButton = $actionsSection.children()[0];
                      var $confirmButton = $actionsSection.children()[1];
                      angular.element($confirmButton).addClass('md-green-500-bg branco');
                      angular.element($cancelButton).addClass('md-primary');
                  }
              }
              )
              .title('Are you sure?')
              .textContent('Please confirm if you would like to generate this invoice.')
              .ariaLabel('Generate invoice confirm box')
              .targetEvent(ev)
              .clickOutsideToClose(true)
              .parent(angular.element(document.body))
              .ok('Yes, generate!')
              .cancel('No, Cancel');
            $mdDialog.show(confirm).then(function() {

              var record = {
                invoices_id: vm.invoiceid,
                invoices_status: 1
              }

              /* change status to invoiced 
              api.invoice.save({ record: record }).$promise.then(function (result) { 
                console.log(result); 
                if(result.status !== 'success'){ 
                  showToast(msg, false);
                }else{
                  var msg = "Invoice generated was ";
                  vm.invoice.invoices_status = 1;
                  showToast(msg);                  
                }                   
              }, 
              function(error) { 
                var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                showToast(msg, false, erro); 
              });

            });

          }else if(vm.invoicesitems.length == 0){
            var msg = "";
            var error = "There are not items yet."
            showToast(msg, false, error);
          }else if (vm.invoice.invoices_status == 1){
            var msg = "";
            var error = "Sorry, already invoiced."
            showToast(msg, false, error);
          }

        }
        */

        /*vm.deleteInvoice = function(ev) {

          if(vm.invoiceid > 0){
              var confirm = $mdDialog.confirm(
                /* Este código seguinte só é preciso para mudar a cor ao botão (para vermelho para remover, por ex.) 
                {
                    onComplete: function afterShowAnimation() {
                        var $dialog = angular.element(document.querySelector('md-dialog'));
                        var $actionsSection = $dialog.find('md-dialog-actions');
                        var $cancelButton = $actionsSection.children()[0];
                        var $confirmButton = $actionsSection.children()[1];
                        angular.element($confirmButton).addClass('md-raised md-warn');
                        angular.element($cancelButton).addClass('md-primary');
                    }
                }
                )
                .title('Are you sure?')
                .textContent('Please confirm if you would like to remove this invoice.')
                .ariaLabel('Invoice removal confirm box')
                .targetEvent(ev)
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('Yes, delete!')
                .cancel('No, Cancel');
              $mdDialog.show(confirm).then(function() {

              var invoiceid = vm.invoiceid;
              /* delete invoice items *//*
              api.invoice.deleteinvoiceid({ id: invoiceid }).$promise.then(function (result) { 
                console.log(result); 
                /*if(result.status !== 'success'){ 
                  showToast(msg, false) 
                }else{
              } */ /*                 
              }, 
              function(error) { 
                var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                showToast(msg, false, erro); 
              });


              /* delete invoices opened *//*
              api.invoiceopened.delete({ id: invoiceid }).$promise.then(function (result) { 
                console.log(result); 
                /*if(result.status !== 'success'){ 
                  showToast(msg, false);
              }*/ /*               
              }, 
              function(error) { 
                var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                showToast(msg, false, erro); 
              });

              /* delete invoices orders *//*
              api.invoicesorders.deleteinvoiceid({ id: invoiceid }).$promise.then(function (result) { 
                console.log(result); 
                /*if(result.status !== 'success'){ 
                  showToast(msg, false, erro);
                  console.log("Erro api.invoicesorders.deleteinvoiceid");
              }*/  /*                 
              }, 
              function(error) { 
                var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                showToast(msg, false, erro); 
              });


              /* delete invoice *//*
              api.invoice.delete({ id: invoiceid }).$promise.then(function (result) { 
                console.log(result); 
                /*if(result.status !== 'success'){ 
                  showToast(msg, false) 
              } */ /*                 
              }, 
              function(error) { 
                var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                showToast(msg, false, erro); 
              });

              var msg = "Invoice removal was ";
              showToast(msg);

              var page = "invoice";
              vm.invoices_opened = vm.invoices_opened.filter(function( obj ) {return obj.invoices_id !== invoiceid; }); 
              if(Object.keys(vm.invoices_opened).length > 0){           
                invoiceid = vm.invoices_opened[0].invoices_id;
              }else{
                invoiceid = '';
              }
            
              console.log('Go to ' + page + ' with id ' + invoiceid);
              if(invoiceid != null && invoiceid != ''){
                $state.go('app.'+page, {id: invoiceid});
              }else{
                $state.go('app.'+page, {id: ''});             
              }

              });
              
              
            }
          }
          */

          vm.verificaStatus = function(){
            if(vm.invoice.invoices_status == 1){
              return true;
            }else{
              return false;
            }
          }

           
          vm.modifyInvoice = function(){
            var id = "DIO"+vm.invoiceid;
            getService.async("Invoice", id, false).then(function(d) {
              if(d.status == "success"){
                var record = {
                  invoices_id: vm.invoiceid,
                  invoices_status: 0
                }                
                api.invoice.save({ record: record }).$promise; /* change status to invoiced */
                var msg = "Modifying invoice enable was ";
                showToast(msg);
                vm.invoiceexist = false;
                vm.invoice.invoices_status = 0;
              }else{
                var msg;
                var erro = "Invoice not yet generated or error while trying to modify.";
                showToast(msg, false, erro);
              }
            });
          }

          vm.deleteInvoice = function(ev){
            var confirm = $mdDialog.confirm(
              /*Este código seguinte só é preciso para mudar a cor ao botão (para vermelho para remover, por ex.) */
              {
                  onComplete: function afterShowAnimation() {
                      var $dialog = angular.element(document.querySelector('md-dialog'));
                      var $actionsSection = $dialog.find('md-dialog-actions');
                      var $cancelButton = $actionsSection.children()[0];
                      var $confirmButton = $actionsSection.children()[1];
                      angular.element($confirmButton).addClass('md-raised md-warn');
                      angular.element($cancelButton).addClass('md-primary');
                  }
              }
              )
              .title('Are you sure?')
              .textContent('Please confirm if you would like to delete this invoice.')
              .ariaLabel('Invoice removal confirm box')
              .targetEvent(ev)
              .clickOutsideToClose(true)
              .parent(angular.element(document.body))
              .ok('Yes, delete!')
              .cancel('No, Cancel');
            $mdDialog.show(confirm).then(function() {
              var id = "DIO"+vm.invoiceid;
              getService.async("Invoice", id, false).then(function(d) {             
                api.invoice.delete({ id: vm.invoiceid }).$promise.then(function (result) {
                  var msg = "Invoice deletion was ";
                  if(result.status !== 'success'){                         
                    showToast(msg, false);
                  }else{                    
                    showToast(msg);
                    vm.goToPage('invoice', null, true);                                     
                  }             
                }, 
                function(error) { 
                  var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                  showToast(msg, false, erro); 
                });
              }); 
            });                          
          }

          vm.printInvoice = function(){
            var id = "PIO"+vm.invoiceid;
            getService.async("Invoice", id, false).then(function(d) {
              if(d.status == "success"){
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                  /* IE 11 */
                  downloadFile(vm.baseurl+'/api/Dlfile?type=invoice&name='+d.filename, function(blob) {
                  window.navigator.msSaveOrOpenBlob(blob);
                  });                
              }else{              
                  /* Chrome e Firefox */
                  var win = window.open('_blank');
                  downloadFile(vm.baseurl+'/api/Dlfile?type=invoice&name='+d.filename, function(blob) {
                      var url = URL.createObjectURL(blob);
                      win.location = url;
                  });
              }
              }else{
                var msg;
                var erro = "Please generate Invoice first.";
                showToast(msg, false, erro);
              }
            });
          }

          vm.generateInvoice = function(){
            var id = "GIO"+vm.invoiceid;
            getService.async("Invoice", id, false).then(function(d) {
              if(d.status == "success"){
                /*var record = {
                  invoices_id: vm.invoiceid,
                  invoices_status: 1
                }                
                api.invoice.save({ record: record }).$promise; /* change status to invoiced - OLD - done now by controller */
                var msg = "Invoice generation was ";
                showToast(msg);
                console.log(d.filename);
                vm.invoiceexist = true;
              }else if(d.status == "exist"){
                var msg;
                var erro = "Invoice already generated.";
                showToast(msg, false, erro);
              }else if(d.status == "noinvoice"){
                var msg;
                var erro = "Please create/save invoice first.";
                showToast(msg, false, erro);
              }
            });
          }

        /***************************/
        /* END Funções Botões Topo */
        /***************************/

        /************************************* */
        /* Funções Current Orders e On Invoice */
        /****************************************/

        vm.toggleCheckbox = function(index){
          if(vm.current_orders[index].verified == 1){
            vm.current_orders[index].checked = vm.current_orders[index].checked == true ? false : true;
          }
        }

        vm.addAll = function(all){
          if(all == 1){
            var gravar = vm.current_orders.filter(function( obj ) {return obj.verified == 1; });
          }else{
            var gravar = vm.current_orders.filter(function( obj ) {return obj.checked == true; });
          }
          if(vm.invoiceexist==true){
            var msg;
            var erro = "Error: Cannot change invoice already generated.";
            showToast(msg, false, erro);
            return false;
          }else if(gravar.length == 0){
            var msg = "";
            if(all == 1){            
              var error = "Sorry, there is no more verified orders to add.";
            }else{
              var error = "Sorry, there is no orders selected.";
            }
            showToast(msg, false, error);
          }else{
            gravar.forEach(function(order) {
              var ordersid = order.orders_id;
              var invoiceid = vm.invoiceid;
              /* 1nd - Change the Order to Invoiced */
              var orderinvoiced = {
                invoices_orders_id: 0,
                invoices_id: invoiceid,
                orders_id: ordersid                
              }
              api.invoicesorders.save({record: orderinvoiced}).$promise.then(function (result) {
                if(result.status !== 'success'){                         
                  showToast(msg, false) 
                }else{
                  var invoiceorder = vm.current_orders.filter(function( obj ) {return obj.orders_id == orderinvoiced.orders_id; });
                  vm.current_orders = vm.current_orders.filter(function( obj ) {return obj.orders_id !== orderinvoiced.orders_id; });
                  invoiceorder[0].invoices_id = vm.invoiceid;
                  invoiceorder[0].invoices_orders_id = result.orderinvoiceid;
                  vm.invoices_orders.push(invoiceorder[0]);
                }
              });
              /* END 1nd - Change the Order to Invoiced */
              /* 2nd - Save all Products From the Order */
              api.ordersproduct.get({id: ordersid}).$promise.then(function (result) { 
                // console.log(result); 
                if(result.status !== 'success'){                         
                  showToast(msg, false);
                }else{
                  var allproducts = [];
                  var msg = "Order added to Invoice was ";
                  result.record.forEach(function(product) { 
                    var products = {
                      invoices_items_id: 0,
                      invoices_id: vm.invoiceid,
                      products_id: product.products_id,
                      orders_id: product.orders_id,
                      qty: product.product_qty,
                      irate: product.product_rate,
                      ratefinal: product.product_rate_final,
                      discount: product.product_discount
                    }                    
                    allproducts.push(products);              
                  });
                  api.invoicesitems.save({record: allproducts, invoiceid: invoiceid}).$promise.then(function (result) {
                    if(result.status !== 'success'){
                      showToast(msg, false);
                    }else{
                      vm.invoicesitems = result.items; 
                      updateNetVATTotal(); 
                      /*vm.allproducts = result.allproducts;*/
                      showToast(msg);                   
                    } 
                  },
                    function(error) { 
                      var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                      showToast(msg, false, erro); 
                    }
                  );

                }
              });
              /* END 2nd - Save all Products From the Order */
              

            });
          }
        }

        vm.removeOrder = function(ev, id) {
          console.log(vm.invoiceexist);
          if(vm.invoiceexist==true){
            var msg;
            var erro = "Error: Cannot change invoice already generated.";
            showToast(msg, false, erro);
            return false;
          }else{  
            var confirm = $mdDialog.confirm(
                      /* Este código seguinte só é preciso para mudar a cor ao botão (para vermelho para remover, por ex.) */
                      {
                          onComplete: function afterShowAnimation() {
                              var $dialog = angular.element(document.querySelector('md-dialog'));
                              var $actionsSection = $dialog.find('md-dialog-actions');
                              var $cancelButton = $actionsSection.children()[0];
                              var $confirmButton = $actionsSection.children()[1];
                              angular.element($confirmButton).addClass('md-raised md-warn');
                              angular.element($cancelButton).addClass('md-primary');
                          }
                      }
                  )
                  .title('Are you sure?')
                  .textContent('Please confirm if you would like to remove this order.')
                  .ariaLabel('Remove confirm box')
                  .targetEvent(ev)
                  .clickOutsideToClose(true)
                  .parent(angular.element(document.body))
                  .ok('Yes, Remove!')
                  .cancel('No, Cancel');
            $mdDialog.show(confirm).then(function() {
                  var success = 0;
                  api.invoicesitems.delete({ id: id }).$promise.then(function (result) { 
                    console.log(result); 
                    if(result.status !== 'success'){ 
                      showToast(msg, false) 
                    }else{
                      vm.invoicesitems = vm.invoicesitems.filter(function( obj ) {
                        return obj.orders_id !== id; 
                      });
                      updateNetVATTotal();
                    }                    
                }, 
                function(error) { 
                  var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                  showToast(msg, false, erro); 
                });
                api.invoicesorders.delete({ id: id }).$promise.then(function (result) { 
                  console.log(result); 
                  if(result.status !== 'success'){ 
                    showToast(msg, false) 
                  }else{ 
                    var currentorder = vm.invoices_orders.filter(function( obj ) {
                      return obj.orders_id === result.id; 
                    });
                    currentorder[0].checked = false;
                    vm.current_orders.push(currentorder[0]);
                    console.log(currentorder);
                    console.log(vm.current_orders);
                    vm.invoices_orders = vm.invoices_orders.filter(function( obj ) {
                      return obj.orders_id !== result.id; 
                    });
                  } 
                }, function(error) { 
                  var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                  showToast(msg, false, erro); 
                });
                var  msg = "Order remove from Invoice was ";
                showToast(msg);

            }, function() {
            });
          }
        }
        
        vm.removeAllOrders = function(){
          if(vm.invoiceexist==true){
            var msg;
            var erro = "Error: Cannot change invoice already generated.";
            showToast(msg, false, erro);
            return false;
          }else if(vm.invoices_orders.length == 0){
            var msg = "";
            var error = "Sorry, there is no orders on invoice.";
            showToast(msg, false, error);
          }else{
            vm.invoices_orders.forEach(function(order) {
              var numorders = vm.invoices_orders.length;
              var success = 0;
              var ordersid = order.orders_id;
              /* 1nd - Remove the Order from Invoiced */
              api.invoicesorders.delete({id: ordersid}).$promise.then(function (result) {
                if(result.status !== 'success'){                         
                  showToast(msg, false);
                  return false;
                }else{
                  var removedorder = vm.invoices_orders.filter(function( obj ) {return obj.orders_id == ordersid; });
                  vm.invoices_orders = vm.invoices_orders.filter(function( obj ) {return obj.orders_id !== ordersid; });
                  removedorder[0].checked = false;
                  vm.current_orders.push(removedorder[0]);
                  success += 1;
                }
              });
              api.invoicesitems.delete({id: ordersid}).$promise.then(function (result) {
                if(result.status !== 'success'){
                  showToast(msg, false);
                  return false;
                }else{
                  vm.invoicesitems = vm.invoicesitems.filter(function( obj ) {return obj.orders_id !== ordersid; }); 
                  success += 1;
                  updateNetVATTotal();                  
                } 
              },
                function(error) { 
                  var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                  showToast(msg, false, erro);
                  return false; 
                }
              );

              var msg = "Order removal was ";
              showToast(msg);
            });
          }
        }
        /* FIM Funções Current Orders e On Invoice*/

        /* Funções Invoice */

        /* Alteração Cliente */
        /*vm.clientes = Clients.allclients;*/
        /* console.log(vm.clientes);*/
        vm.cliente = vm.invoice ? vm.invoice : null;
        vm.isDisabled = false;
        vm.searchText = null;
        vm.titulo = null;

        if(vm.cliente != null){
          vm.jaexiste = 1;
        }else{
          vm.jaexiste = 0;
        }

        vm.newClient = function() {
          console.log('open new page on profile page');
          var url = $state.href('app.profile');                            
          $window.open(url, '_blank');
        }
        vm.ativa = function(){        
          vm.isDisabled = false;
          vm.titulo = "Click to change new client name";          
        }
        vm.alterar = function(){ 
          if(vm.invoiceexist==true){
            var msg;
            var erro = "Error: Cannot change invoice already generated.";
            showToast(msg, false, erro);
            return false;
          }else if(vm.invoices_orders.length > 0){
            var msg = "";
            var erro = "Please remove orders from invoice first.";
            showToast(msg, false, erro);
          }else{
            var r = confirm("Are you sure you want to insert a new client?");
            if (r == true) {
              vm.isDisabled = false;
              delete vm.cliente;
              /* console.log(vm.cliente); */
              vm.jaexiste = 0;
              delete vm.current_orders;
              vm.searchText = '';
              vm.selectedItem = undefined;
            }
          }
        }
        
        

        vm.querySearch = function (query) {                    
          var querylower = query.toLowerCase();          
          return getService.async("Clients", "IO"+querylower, false).then(function(d) {
            if(d.status == "success"){
              vm.clientes = d.clients;
              return vm.clientes;
            }else if(d.status == "notfound"){
              vm.clientes = {};
              return vm.clientes;
            }
          });
        }            
        vm.selectedItemChange = function(item){            
            vm.cliente = item;
            if(item && typeof item.clients_id !== 'undefined'){
              vm.invoice.clients_id = item.clients_id;
              updateOrders();
              var record = {
                invoices_id: vm.invoiceid,
                clients_id: item.clients_id
              }
              api.invoice.save({ record: record }).$promise.then(function (result) { 
                console.log(result); 
                if(result.status !== 'success'){ 
                  showToast(msg, false) 
                }else{
                  console.log("Client was inserted.");
                }                  
              }, 
              function(error) { 
                var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                showToast(msg, false, erro); 
              });
              $timeout(function() { vm.jaexiste = 1;}, 1000);
          }
        }
        /* END Alteração Cliente */
        
        function updateNetVATTotal(){
          vm.invoiceTotalNet = 0;
          vm.invoiceTotalVAT = 0;
          vm.invoiceTotalTotal = 0;
          vm.invoicesitems.forEach(function(item, key) {
            /*item.totalrate = updateUnitTotal(item.qty, item.irate, item.VAT, item.discount);*/
            /*vm.invoiceTotalNet += updateTotalNet(item.qty, item.irate, item.discount);*/
            /*vm.invoiceTotalNet += item.ratefinal * (1 - parseFloat(item.VAT / 100));*/
            /*vm.invoiceTotalTotal += item.totalrate;*/
            vm.invoiceTotalTotal += item.ratefinal;
            /* vm.invoiceTotalVAT = roundTo(vm.invoiceTotalTotal - vm.invoiceTotalNet,2); */
            vm.invoiceTotalVAT += item.irate * (parseInt(item.VAT) / 100);
            vm.invoiceTotalNet = vm.invoiceTotalTotal - vm.invoiceTotalVAT;
            /* Converte datas para poder agrupá-las */
            var next = (key + 1) == vm.invoicesitems.length ? 0 : vm.invoicesitems[key + 1];
            var nextdate = $filter('cmdate')(next.date, "yyyy-MM-dd");
            var actualdate = $filter('cmdate')(item.date, "yyyy-MM-dd");
            item.nextdate = nextdate;
            item.date = actualdate;
            /* END Converte datas para poder agrupá-las */
          });
          vm.invoiceTotalNet = roundTo(vm.invoiceTotalNet,2);
          vm.invoiceTotalVAT = roundTo(vm.invoiceTotalVAT,2);
          vm.invoiceTotalTotal = roundTo(vm.invoiceTotalTotal,2);
        }


        function updateTotalNet(qty,rate,discount){
          if(rate > 0 && discount > 0){
            rate = rate - ((discount / 100) * rate); 
          }
          if(rate > 0 && qty > 0){
            rate = rate * qty; 
          }
          return rate;
        }

        function updateUnitTotal(qty,rate,vat,product_discount){
              if(rate > 0 && qty > 0){
                if(qty > 1){
                  rate = rate * qty; 
                }
                if(product_discount > 0){
                  rate = rate - ((product_discount / 100) * rate);                   
                }                
                if(vat > 0){
                  rate = rate * (vat / 100 + 1); 
                }
                return roundTo(rate, 2);
              }else{
                return 0;
              }
        }

        function roundTo(n, digits) {
          if (digits === undefined) {
            digits = 0;
          }
     
          var multiplicator = Math.pow(10, digits);
          n = parseFloat((n * multiplicator).toFixed(11));
          var test =(Math.round(n) / multiplicator);
          return +(test.toFixed(digits));
        }

               
        var botaoAddSize = 76; /* In pixels */
        var caixaAlertaSize = 200; /* In pixels */

        function atualizaDivSize(totalestados){
          var divSize = totalestados * caixaAlertaSize + botaoAddSize;
          angular.element('.order-messages-sub').css('width', divSize + 'px');        
        } 

        angular.element(document).ready(function () {
            /* console.log('page loading completed'); */
            if(vm.estados != null){
              atualizaDivSize(vm.estados.length);
            }
        });        

        vm.userid = localStorageService.get('userid');
        vm.username = localStorageService.get('username');

        function saveDLDaction(id){
          id = typeof id !== 'undefined' ? id : vm.invoiceid;
          if(vm.departments){
            vm.departments.forEach(function(department) {
              if(department.department_alias == active_module){
                var currentdate = new Date(); 
                var datetime = currentdate.getFullYear() + "-"
                                + (currentdate.getMonth()+1)  + "-" 
                                + currentdate.getDate() + " "  
                                + currentdate.getHours() + ":"  
                                + currentdate.getMinutes() + ":" 
                                + currentdate.getSeconds();
                var record = {
                  dld_actions_id: 0,
                  users_id: vm.userid,
                  departments_id: department.departments_id,
                  date: datetime,
                  orders_id: id
                }
                var msg = "DLD Action was ";
                api.dldactions.save({ record: record }).$promise.then(function (result) 
                { 
                  console.log(result); 
                  if(result.status !== 'success'){ 
                    console.log("DLD Action Erro!"); 
                  }else{
                    var novodldaction = {
                      date: datetime,
                      department_name: department.department_name,
                      name: vm.username
                    }
                    if(vm.dldactions){
                      vm.dldactions.unshift(novodldaction);
                    }else{
                      vm.dldactions = novodldaction;
                    }
                  } 
                }, function(error) {
                   var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                   console.log(erro); 
                  });
              }
            });  
          }
        }       
        

        vm.goToPage = function(page, invoiceid, close, changepage){          
            close = typeof close !== 'undefined' ? close : false;
            changepage = typeof changepage !== 'undefined' ? changepage : false;
            invoiceid = typeof invoiceid !== 'undefined' ? invoiceid : null;
            console.log('Antes: ' + invoiceid);
            if(close == true){
              if(invoiceid != null){
                api.invoiceopened.delete({ id: invoiceid, userid: vm.userid }).$promise.then(function (result) { console.log(result); if(result.status !== 'success'){ console.log("Erro ao apagar Invoice Opened") } }, function(error) { var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; console.log("Erro: " + erro) } );
              }

              var invoice_id;

              vm.invoices_opened = vm.invoices_opened.filter(function( obj ) {return obj.invoices_id !== invoiceid; }); 
              if(Object.keys(vm.invoices_opened).length > 0){           
                invoice_id = vm.invoices_opened[0].invoices_id;
              }else{
                invoice_id = '';
              }              
            }
            if(changepage == true){
              invoice_id = typeof invoice_id !== 'undefined' ? invoice_id : invoiceid;
              console.log('Go to ' + page + ' with id ' + invoice_id);
              if(invoice_id != null && invoice_id != ''){
                $state.go('app.'+page, {id: invoice_id});
              }else{
                $timeout( function(){ 
                  $state.go('app.'+page, {id: ''});
                }, 200 );                            
              }
            }
                       
        }
        
        vm.gotoOrderStatus = gotoOrderStatus;

        function gotoOrderStatus()
        {
            console.log('go OrderStatus');
            $state.go('app.orderstatus');
        }
    
        $scope.customFullscreen = false;

        updateRate();

        function updateRate(){
          if(vm.products){
            vm.products.forEach(function(product) {
              if ((product.rate > 0 && product.product_discount > 0) && (product.rate > 0 && product.product_qty > 0)){
                  var precoqty = product.rate * product.product_qty;
                  product.rate = Math.round(precoqty - (product.product_discount / 100 + 1));
              }else if(product.rate > 0 && product.product_qty > 0){
                  product.rate = Math.round(product.rate * product.product_qty);
              }else if ((product.rate > 0 && product.product_discount > 0)){
                  product.rate = Math.round(product.rate - (product.product_discount / 100 + 1));
              }
            });
          }
        }

        /*vm.saveOnChange = function(value, field){
          switch(field){
            case 'verified':
            case 'treatmentplan_upper' :
            case 'treatmentplan_lower' :
              value = value == true ? value = 1 : 0;
            break;
          }
          var record = {
            orders_id: vm.id
          };
          record[field] = value;

          /* saveDLDaction(); *//*
          if(field=="verified" && vm.order[0].status_id!=5){
            var erro = "Please Complete the order before verified it.";
            showToast('', false, erro);
            vm.verified = false;
          }else{
            var msg = popuptypes[field]['msg'];
            otherSave(record, msg, field);
          }
        }    */                

        vm.genericRemoveConfirm = function(ev, tipopopup, id, upperlower) {
          if (typeof(upperlower)==='undefined') upperlower = 0;
          var confirm = $mdDialog.confirm(
                    /* Este código seguinte só é preciso para mudar a cor ao botão (para vermelho para remover, por ex.) */
                    {
                        onComplete: function afterShowAnimation() {
                            var $dialog = angular.element(document.querySelector('md-dialog'));
                            var $actionsSection = $dialog.find('md-dialog-actions');
                            var $cancelButton = $actionsSection.children()[0];
                            var $confirmButton = $actionsSection.children()[1];
                            angular.element($confirmButton).addClass('md-raised md-warn');
                            angular.element($cancelButton).addClass('md-primary');
                        }
                    }
                )
                .title('Are you sure?')
                .textContent(popuptypes[tipopopup]['removemsg'])
                .ariaLabel('Remove confirm box')
                .targetEvent(ev)
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('Yes, Remove!')
                .cancel('No, Cancel');
          $mdDialog.show(confirm).then(function() {
                switch(tipopopup.toLowerCase()){
                  case 'removedeliveryroute' :
                    var record = {
                      orders_id: vm.id,
                      deliveryroutes_id: 0
                    };
                  break;
                  default :
                    var record = id;
                  break;
                }
                console.log(record);
                var msg = popuptypes[tipopopup]['msg'];
                if(tipopopup.toLowerCase() === 'removedeliveryroute'){
                  otherSave(record, msg, tipopopup);
                }else{
                  otherDelete(record, msg, tipopopup, upperlower);
                }
          }, function() {
          });
        };

        
      function removeProducts(ev, id) {
          var confirm = $mdDialog.confirm(
                    /* Este código seguinte só é preciso para mudar a cor ao botão (para vermelho para remover, por ex.) */
                    {
                        onComplete: function afterShowAnimation() {
                            var $dialog = angular.element(document.querySelector('md-dialog'));
                            var $actionsSection = $dialog.find('md-dialog-actions');
                            var $cancelButton = $actionsSection.children()[0];
                            var $confirmButton = $actionsSection.children()[1];
                            angular.element($confirmButton).addClass('md-raised md-warn');
                            angular.element($cancelButton).addClass('md-primary');
                        }
                    }
                )
                .title('Are you sure?')
                .textContent('Please confirm if you would like to remove this product.')
                .ariaLabel('Remove confirm box')
                .targetEvent(ev)
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('Yes, Remove!')
                .cancel('No, Cancel');
          $mdDialog.show(confirm).then(function() {
/*                var record = { 'id' : id } ;
                console.log(record); */
                var msg = "Products removed from order! Reloading page...";
                deleteProducts(id, msg);
          }, function() {
          });
        };

        vm.openPopupOther = function(ev, tipopopup) {
          if(tipopopup.toLowerCase() == 'addnewproduct' && vm.invoiceexist == true){            
            var msg;
            var erro = "Error: Cannot change invoice already generated.";
            showToast(msg, false, erro);
            return false;
          }else if(tipopopup.toLowerCase() == 'sendinvoice' && vm.invoiceexist == false){            
            var msg;
            var erro = "Error: Please generate invoice first.";
            showToast(msg, false, erro);
            return false;
          }else{          
            $mdDialog.show({
              controller: eval("OtherController"),
              controllerAs: 'octrl',
              resolve: {
                popuptype: function () {
                  return {
                    'tipoPopup': tipopopup
                  };
                }
              },
              templateUrl: 'app/main/pages/invoice/templates/'+tipopopup.toLowerCase()+'.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: $scope.customFullscreen 
            });
          }
        }          

        vm.openPopupOther.$inject = ['ev','tipopopup'];

        

        function OtherController($compile, $scope, $mdDialog, popuptype, $timeout, CONFIG, DTOptionsBuilder, DTColumnBuilder, postService) {
            var self = this;
            $scope.userid = vm.userid;
            $scope.username = vm.username;
            $scope.data = new Date();
            $scope.id = vm.invoiceid;

            function isJson(str) {
              try {
                  JSON.parse(str);
              } catch (e) {
                  return false;
              }
              return true;
            }

            switch(popuptype.tipoPopup.toLowerCase()){
              case 'sendinvoice' :
              console.log('sendinvoice');
              self.record = {};
              self.record.emailto = "";
              var numcontas = 0;
              var listaemails = [];
              var clientid = vm.invoice.clients_id;
              getService.async("ClientsEmail", clientid, true).then(function(d) {
                if(d.status == 'success'){
                  d.record.forEach(function(email) {
                    if(email.email_type_ids != "" && isJson(email.email_type_ids)==true){
                      email.email_type_ids = JSON.parse(email.email_type_ids);
                      angular.forEach(email.email_type_ids, function(typeid) {  
                        if(typeid==1){
                          numcontas += 1;
                          listaemails.push(email.clients_email);                     
                        }
                      });
                    }
                  });                  
                }
                self.record.emailto = listaemails;
              });
              break;
              case 'addnewproduct' :
              case 'search':
                // self.upperlower = popuptype.upperlower;
                /*self.allproducts = vm.allproducts;*/
                /*self.allinvoices = vm.allinvoices;*/

                self.dtInstance = {};
                var itemabrir = [];
                var itemdata = {};
                self.qty = [];
                self.discount = [];
                self.products_groups_id = [];
                self.rate = [];        

                if(popuptype.tipoPopup.toLowerCase() == "search"){
                  var urlpost = CONFIG.apiBaseUrl + 'Invoice/fetchinvoices';
                  var numcolumns = 16;
                  var tipo = "search";
                }else if(popuptype.tipoPopup.toLowerCase() == "addnewproduct"){
                  var urlpost = CONFIG.apiBaseUrl + 'Products/fetchproducts';
                  var numcolumns = 9;
                  var tipo = "product";
                }

                self.dtOptions = DTOptionsBuilder.newOptions()
                .withOption('ajax', {
                    url: urlpost,
                    type: 'POST',
                    "dataSrc": function(json) {
                      if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                      }else{
                        console.log(json);
                        return json.data;
                      }
                    },
                    "data": function(d){
                        /*d.search['value'] = self.searchz;*/
                        if(tipo == "search"){
                          for (var i = 0; i < numcolumns; ++i) {
                            var f = "d.columns["+i+"].search.value = self.search"+i+";";
                            eval(f);
                          }
                        }else if (tipo == "product"){
                          d.search['value'] = self.search;
                        }
                        console.log(d);
                        
                    },
                    "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}                    
                })
                .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
                .withDataProp('data')
                .withOption('processing', true)
                .withOption('serverSide', true)
                .withOption('filter', false)
                .withOption('bLengthChange', true)
                .withOption('bSort', false)
                .withOption('responsive',false)
                .withPaginationType('full_numbers')
                .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                  $('td', nRow).css('cursor', 'pointer');
                  $('td', nRow).unbind('click');
                  $('td', nRow).bind('click', function() {
                      $scope.$apply(function() { 
                        if(tipo == "search"){                                    
                          if(itemabrir.includes(aData[9])==true){                            
                            var index = itemabrir.indexOf(aData[9]);
                            if (index > -1) {
                              $(nRow).removeClass('highlitedRow');
                              itemabrir.splice(index, 1);
                            }
                          }else{
                            itemabrir.push(aData[9]);
                            $(nRow).addClass('highlitedRow');
                          }
                          self.itemabrir = itemabrir;
                          console.log(self.itemabrir);
                          return nRow;  
                        }else if(tipo == "product"){
                          var ratefinalwdiscount = aData[3] - (aData[3] * (parseInt(self.discount[aData[7]]) / 100));
                          var ratefinalwvat = ratefinalwdiscount * (1 + (parseInt(self.VAT[aData[7]]) / 100));
                          var ratefinalz = ratefinalwvat * parseInt(self.qty[aData[7]]);
                          itemdata = {
                            orders_id: vm.id,
                            products_id: aData[7],
                            products_groups_id: self.products_groups_id[aData[7]],
                            qty: parseInt(self.qty[aData[7]]),
                            discount: parseInt(self.discount[aData[7]]),
                            irate: aData[3],
                            ratefinal: parseFloat(ratefinalz)
                          }
                          var verifica = 0;
                          angular.forEach(itemabrir, function(item) {
                            if(item.products_id==aData[7]){
                                verifica = 1;                            
                                $(nRow).removeClass('highlitedRow');
                                itemabrir = itemabrir.filter(function( obj ) {return obj.products_id !== aData[7]; });
                            } 
                          });
                          if(verifica == 0){
                            itemabrir.push(itemdata);
                            $(nRow).addClass('highlitedRow');
                          }
                          self.itemabrir = itemabrir;
                          console.log(self.itemabrir);
                          return nRow; 
                        }                      
                      });
                  });
                })
                .withOption('createdRow', function(row) {
                  // Recompiling so we can bind Angular directive to the DT
                  $compile(angular.element(row).contents())($scope);
              })
                .withOption('order', [])
                .withOption('initComplete', function(){
                    var api = this.api();
    
                    self.totalRecords = api.page.info().recordsTotal;
                    self.totalRecordsFiltered = api.page.info().recordsDisplay;

                    self.searchTable = function(searchText, column){
                      if (tipo == "search"){
                        var f = "self.search"+column+" = searchText;";
                        eval(f);
                      }else if (tipo == "product"){
                        self.search = searchText;
                      }
                      self.dtInstance.DataTable.search(searchText).draw();                  
                    } 
                    
                    self.reset = function(){                      
                      if(tipo == "search"){
                        self.search = [];
                        self.startDate = undefined;
                        self.endDate = undefined;
                        self.onDate = undefined;
                        for (var i = 0; i < numcolumns; ++i) {
                          var f = "self.search"+i+" = undefined;";
                          eval(f);
                        }
                      }else if (tipo == "product"){
                        self.search = undefined;
                      }
                      self.dtInstance.reloadData(null, true);                      
                    }    
                    
                })
                .withLanguage({
                    "sInfo": 'Info',
                    "paginate": {
                        "first": 'First',
                        "last": 'Last',
                        "next": 'Next',
                        "previous": 'Previous'
                    }
                });

                if(tipo == "search"){            
                  self.dtColumns = [
                    DTColumnBuilder.newColumn(0).withTitle('Invoice Number'),
                    DTColumnBuilder.newColumn(1).withTitle('Prescription Number').notVisible(),
                    DTColumnBuilder.newColumn(2).withTitle('City'),
                    DTColumnBuilder.newColumn(3).withTitle('Country'),
                    DTColumnBuilder.newColumn(4).withTitle('Postcode'),
                    DTColumnBuilder.newColumn(5).withTitle('Practice Name')/*.notVisible()*/,
                    DTColumnBuilder.newColumn(6).withTitle('Practice No'),
                    DTColumnBuilder.newColumn(7).withTitle('Client'),
                    DTColumnBuilder.newColumn(8).withTitle('GDC No'),
                    DTColumnBuilder.newColumn(9).withTitle('Invoices ID').notVisible(),
                    DTColumnBuilder.newColumn(10).withTitle('Patient Name').notVisible(),
                    DTColumnBuilder.newColumn(11).withTitle('Client Name'),
                    DTColumnBuilder.newColumn(12).withTitle('Invoices Status').notVisible(),
                    DTColumnBuilder.newColumn(13).withTitle('Creation Date').notVisible(),
                    DTColumnBuilder.newColumn(14).withTitle('Start Date').notVisible(),
                    DTColumnBuilder.newColumn(15).withTitle('End Date').notVisible(),
                  ]                                 
                }else if (tipo == "product"){
                  self.dtColumns = [
                    DTColumnBuilder.newColumn(0).withTitle('Product Code'),
                    DTColumnBuilder.newColumn(1).withTitle('Product Description'),
                    DTColumnBuilder.newColumn(2).withTitle('Product Group').notSortable(),
                    // .renderWith(function(data, type, full, meta) {
                    //   return '<md-input-container class="md-block"><label>Product Group</label><md-select name="products_groups_id" ng-init="octrl.products_groups_id['+full[7]+']=\'0\'" ng-model="octrl.products_groups_id['+full[7]+']" ng-change="updateItemData(\''+full[7]+'\',\'products_groups_id\',octrl.products_groups_id['+full[7]+'])"><md-option value="1">Plaster Room</md-option><md-option value="3">3D</md-option><md-option value="4">Implants</md-option><md-option value="5">Clear Aligner</md-option><md-option value="7">Removable Appliance</md-option><md-option value="8">Packaging</md-option></md-select></md-input-container>';
                    // }),
                    DTColumnBuilder.newColumn(3).withTitle('Rate').notSortable(),
                    DTColumnBuilder.newColumn(4).withTitle('VAT').notSortable()
                    .renderWith(function(data, type, full, meta) {
                      return '<md-input-container class="md-block"><input type="text" name="VAT" ng-model="octrl.VAT['+full[7]+']" ng-init="octrl.VAT['+full[7]+']=\''+full[4]+'\'" value="'+full[4]+'" aria-label="VAT" disabled></md-input-container>';
                    }),
                    DTColumnBuilder.newColumn(5).withTitle('Quantity').notSortable()
                    .renderWith(function(data, type, full, meta) {
                          return '<md-input-container class="md-block"><input type="text" name="qty" ng-model="octrl.qty['+full[7]+']" ng-init="octrl.qty['+full[7]+']=\'1\'" ng-change="updateItemData(\''+full[7]+'\',\'qty\',octrl.qty['+full[7]+'])" value="1" aria-label="Quantity" maxlength="3"></md-input-container>';
                    }),
                    DTColumnBuilder.newColumn(6).withTitle('Discount %').notSortable()
                    .renderWith(function(data, type, full, meta) {
                          return '<md-input-container class="md-block"><input type="text" name="discount" ng-model="octrl.discount['+full[7]+']" ng-init="octrl.discount['+full[7]+']=\'0\'" ng-change="updateItemData(\''+full[7]+'\',\'discount\',octrl.discount['+full[7]+'])" value="0" aria-label="Discount" maxlength="3"></md-input-container>';
                    }),
                    DTColumnBuilder.newColumn(7).withTitle('Product ID').notVisible(),
                    DTColumnBuilder.newColumn(8).withTitle('Product Groups ID').notVisible()
                  ] 
                }

                $scope.updateItemData = function(id, fieldtoupdate, newvalue){
                  angular.forEach(itemabrir, function(item) {
                    if(item.products_id==id){
                        var f = "item."+fieldtoupdate+" = parseInt('"+newvalue+"');";                        
                        eval(f);                      
                    } 
                  });
                }

              break;
            }

            $scope.hide = function() {
              $mdDialog.hide();
            };
            $scope.cancel = function() {
              $mdDialog.cancel();
            };
            $scope.gravar = function(gravar) {               
                switch(popuptype.tipoPopup.toLowerCase()){
                  /*case 'addnewproduct':
                    var i;
                    if (typeof gravar !== 'undefined') {
                      for (i = 0; i < gravar.length; i++) {
                          delete gravar[i]['group_name'];
                          delete gravar[i]['date'];
                          delete gravar[i]['VAT'];
                          delete gravar[i]['product_description'];
                          delete gravar[i]['product_code'];                          
                          delete gravar[i]['upperlower'];
                          delete gravar[i]['product_code'];
                          delete gravar[i]['products_groups_id'];
                          gravar[i]['irate'] = gravar[i]['rate'];
                          delete gravar[i]['rate'];   
                          /*gravar[i]['orders_id'] = null;*//*
                      }
                    }
                  break;*/
                  case 'search' :
                    var record = {};
                    if (typeof gravar !== 'undefined') {
                      for (var i = 0; i < gravar.length; i++) {                          
                          record[i] = {
                            invoices_opened_id: 0,
                            invoices_id: gravar[i],
                            users_id: $scope.userid
                          }
                      }
                    }
                    gravar = record;                    
                  break;
                }
                console.log(gravar);  
                $mdDialog.hide();
                var tipopopup = popuptype.tipoPopup;
                var msg = popuptypes[tipopopup]['msg'];
                if(popuptype.tipoPopup.toLowerCase()=="sendinvoice"){
                  var id = "sendemail";
                  postService.async("Invoice", id, gravar).then(function(d) {
                    if(d.status == "success"){
                      showToast(msg);
                    }else{
                      showToast(msg, false, d.error);
                    }
                  });
                }else{
                  otherSave(gravar, msg, tipopopup);            
                }
                
            };
        }

        OtherController.$inject = ['$compile', '$scope', '$mdDialog', 'popuptype', '$timeout', 'CONFIG', 'DTOptionsBuilder', 'DTColumnBuilder', 'postService'];

        vm.otherSave = otherSave;

        function otherSave(record, message, tipopopup)
        {
            console.log("save"+tipopopup+"...");
            console.log(record);
            var invoiceid = vm.invoiceid;
            console.log(invoiceid);
            
            var msg = message ? message : 'Change settings changed was ';
            if((popuptypes[tipopopup]['api']==='invoicesitems') || (popuptypes[tipopopup]['api']==='invoiceopened')){
              var f = "api."+popuptypes[tipopopup]['api']+".save({ record: record, invoiceid: invoiceid }).$promise.then(function (result) { console.log(result); if(result.status !== 'success'){ var erro = 'Error on changing '+result.numberfailed+' items. Please try again.'; showToast(msg, false, erro); }else{ if(popuptypes[tipopopup]['api']==='invoicesitems'){ vm.invoicesitems = result.items; updateNetVATTotal(); } showToast(msg);  } }, function(error) { var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; showToast(msg, false, erro); } );";
            }else{
              var f = "api."+popuptypes[tipopopup]['api']+".save({ record: record }).$promise.then(function (result) { console.log(result); if(result.status !== 'success'){ showToast(msg, false) }else{ showToast(msg); } }, function(error) { var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; showToast(msg, false, erro); } );";
            }
            eval(f);
            if(tipopopup!=='search'){
              //saveDLDaction();
            }

            if(tipopopup==='search'){
              $timeout( function(){                    
                $state.go('app.invoice', {id: record[0].invoices_id}, {reload: true, inherit: false, notify: true});
              }, 200 );
            }             
        }

        otherSave.$inject = ['record', 'message', 'tipopopup'];

        function otherDelete(record, message, tipopopup, upperlower)
        {
            console.log("delete"+tipopopup+"...");
            if (typeof(upperlower)==='undefined') upperlower = 0;
            var msg = message ? message : 'Change settings changed was ';            
            if(tipopopup==='removeProducts'){
              var apagartodos = record + 'h' + upperlower;
              var f = "api.ordersproduct.deleteall({ id: apagartodos }).$promise.then(function (result) { console.log(result); if(result.status !== 'success'){ showToast(msg, false) }else{ vm.products = vm.products.filter(function( obj ) {return obj.upperORlower !== upperlower; }); showToast(msg); } }, function(error) { var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; showToast(msg, false, erro); } );";
            }else{            
              var f = "api."+popuptypes[tipopopup]['api']+".delete({ id: record }).$promise.then(function (result) { console.log(result); if(result.status !== 'success'){ showToast(msg, false) }else{ if(popuptypes[tipopopup]['api']==='orderslinked'){ vm.linkedorders = vm.linkedorders.filter(function( obj ) {return obj.orders_linked_id !== result.id; }); vm.listorders = result.listorders; } if(popuptypes[tipopopup]['api']==='orderslabdocs'){ vm.labdocs = vm.labdocs.filter(function( obj ) {return obj.orders_lab_docs_id !== result.id; }); } if(popuptypes[tipopopup]['api']==='ordersproduct'){ vm.products = vm.products.filter(function( obj ) {return obj.orders_product_id !== result.id; }); } showToast(msg); } }, function(error) { var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; showToast(msg, false, erro); } );";
            }
            eval(f);
            saveDLDaction();             
        }

        otherDelete.$inject = ['record', 'message', 'tipopopup'];

    }

    InvoiceController.$inject = ['$compile','$scope', '$document', '$mdToast', '$state', '$stateParams', '$filter', 'getService', 'postService','Invoice', 'InvoiceOpened', 'InvoicesOrders', 'Payments', 'InvoicesItems', 'Products', 'Clients', 'api', '$window', '$translate', '$mdDialog', 'localStorageService', '$timeout', 'CONFIG', 'DTOptionsBuilder', 'DTColumnBuilder', '$location', '$rootScope'];

})();

(function ()
{
    'use strict';

    angular
        .module('app.holidays', ['ngMask', 'mwl.calendar'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.holidays', {
              url      : '/holidays/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/holidays/holidays.html',
                      controller : 'HolidaysController as vm'
                  }
                },
                resolve  : {
                    HolidaysUserSettings: function (api, $stateParams, localStorageService)
                        {
                            var userid = localStorageService.get('userid');
                            return api.holidaysusersettings.get({ id: userid }).$promise;
                        },
                    HolidaysCurrPrev: function (api, $stateParams, localStorageService)
                    {
                        var userid = "getDatas" + localStorageService.get('userid');
                        return api.holidays.get({ id: userid }).$promise;
                    },
                    Managers: function (api, $stateParams)
                    {
                        var idz = "GMT";
                        return api.user.get({ id: idz }).$promise;
                    },
                },                
              bodyClass: 'holidays-body'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/holidays');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.holidays')
        .controller('HolidaysController', HolidaysController)
        .factory('postService', function($http, CONFIG) {
            var postService = {
              async: function(controller, id, registo) {                  
                // $http returns a promise, which has a then function, which also returns a promise
                var promise = $http({
                  method: 'POST',
                  data: registo,    
                  url: CONFIG.apiBaseUrl + controller + '/' + id
                }).then(function (response) {
                  // The then function here is an opportunity to modify the response
                  console.log(response);
                  // The return value gets picked up by the then in the controller.
                  return response.data;
                });
                // Return the promise to the controller
                return promise;
              }
            };
            return postService;
          });

    function HolidaysController($scope, $document, $state, $window, $translate, $timeout, api, $mdToast, $mdDialog, postService, localStorageService, DTOptionsBuilder, DTColumnBuilder, CONFIG, $location, $http, HolidaysUserSettings, HolidaysCurrPrev, Managers)
    {
        console.log("HolidaysController");

        var vm = this;

        vm.baseurl = $window.location.origin;
        if(vm.baseurl == "http://localhost:3000"){
          vm.baseurl = "https://nimrodtrac.app";
        }
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
          }
          vm.admin = localStorageService.get('admin');
          vm.levelid = localStorageService.get('levelid');
          vm.manage = localStorageService.get('manage');
  
          vm.disabled = false;
  
          /* Verifica se tem permissões de ver e/ou alterar conteúdos */
          if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || (vm.privileges[44].privileges.view != '1' && vm.privileges[45].privileges.view != '1')){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if((vm.privileges[44].privileges.edit == '0' || vm.privileges[44].privileges.edit == null || vm.privileges[44].privileges.edit == false) && vm.privileges[44].privileges.view == '1'){
                vm.disabled = true;
            }
          }

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg, state, error) {
            if (typeof(state)==='undefined') state = true;
            if(state == true){
            msg = msg + 'a success!';
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');
            }else if(state == "info"){
              var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(0)
                .theme("orange")
                .position('top right');
            }else{
            if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
            if (typeof(error)!=='undefined') msg = error;
              var toast = $mdToast.simple()
                  .content(msg)
                  .highlightAction(true)
                  .hideDelay(0)
                  .theme("error-toast")
                  .position('top right')
                  .action('CLOSE');             
            }
            $mdToast.show(toast); 
          }

        vm.userid = localStorageService.get('userid');
        vm.username = localStorageService.get('username');

        vm.user_settings = HolidaysUserSettings.record;
        
        vm.managers = Managers.managers;        
        vm.techs = Managers.techs;

        vm.caixaedicao = 0;
        vm.comments = [];

        function getHistoryDate(userid,result){
            if(userid == vm.userid){
                vm.holidayscurr = HolidaysCurrPrev.current_year;
                vm.holidaysprev = HolidaysCurrPrev.previous_year;
            }else if (typeof(result)!=='undefined'){
                vm.holidayscurr = result.current_year;
                vm.holidaysprev = result.previous_year;
            }

            vm.totalcdays = 0;
            vm.totalpdays = 0;
            
            angular.forEach(vm.holidayscurr, function(datec){
                vm.totalcdays += parseFloat(datec.totaldays);
            });
            angular.forEach(vm.holidaysprev, function(datep){
                vm.totalpdays += parseFloat(datep.totaldays);
            });
            
            vm.remainingcdays = parseFloat(vm.user_settings.allowance_days) - parseFloat(vm.totalcdays);
            vm.remainingpdays = parseFloat(vm.user_settings.allowance_days) - parseFloat(vm.totalpdays);
        }

        getHistoryDate(vm.userid);

        function editRequest(id){
            vm.caixaedicao = 1;        
            api.holidays.query({ id: id }).$promise.then(function (result) {
                vm.request = result.request;
                vm.comments = result.comments;
                getHistoryDate(result.userid, result);  
            });
        }
        
        vm.gotoNotCheckinout = function()
        {
            console.log('go NotCheckinout');
            $state.go('app.notcheckinout');
        }

        

        console.log("Techs:");
        console.log(vm.techs);        

        vm.cellIsOpen = false;
    
        // console.log(vm.eventos);

        vm.loading = false;

        vm.requestEventos = function(data){
            /* Fazer request de eventos */
            console.log("Request eventos datas:");
            console.log(data);
            var id = "getDatasCalendario";
            vm.loading = true;
            postService.async("Holidays", id, data).then(function(d) {                
                if(d.status == "success"){
                    vm.loading = false;
                    vm.eventos = d.datas;
                }else{
                    var error = "Error fetching dates from database. Please try again.";
                    showToast(msg, false, error);
                }
            });
        }

        vm.requestEventos(new Date());


        vm.eventClicked = function(d){
            console.log("event Clicked");
            console.log(d);
        }

        vm.viewChangeClicked = function(d){
            /* Disabling All Day View */
            if (d !== 'month') {
                return false;
            }
        };

        vm.calendarView = 'month';
        vm.viewDate = new Date();

        vm.allmonths = {
            "jan": {
                "data": new Date(new Date().getFullYear(), 0, new Date().getDay()),
                "eventos": []
            },
            "feb": {
                "data": new Date(new Date().getFullYear(), 1, new Date().getDay()),
                "eventos": []
            },
            "mar": {
                "data": new Date(new Date().getFullYear(), 2, new Date().getDay()),
                "eventos": []
            },
            "apr": {
                "data": new Date(new Date().getFullYear(), 3, new Date().getDay()),
                "eventos": []
            },
            "may": {
                "data": new Date(new Date().getFullYear(), 4, new Date().getDay()),
                "eventos": []
            },
            "jun": {
                "data": new Date(new Date().getFullYear(), 5, new Date().getDay()),
                "eventos": []
            },
            "jul": {
                "data": new Date(new Date().getFullYear(), 6, new Date().getDay()),
                "eventos": []
            },
            "aug": {
                "data": new Date(new Date().getFullYear(), 7, new Date().getDay()),
                "eventos": []
            },
            "sep": {
                "data": new Date(new Date().getFullYear(), 8, new Date().getDay()),
                "eventos": []
            },
            "oct": {
                "data": new Date(new Date().getFullYear(), 9, new Date().getDay()),
                "eventos": []
            },
            "nov": {
                "data": new Date(new Date().getFullYear(), 10, new Date().getDay()),
                "eventos": []
            },
            "dec": {
                "data": new Date(new Date().getFullYear(), 11, new Date().getDay()),
                "eventos": []
            }
        };

        vm.currYear = new Date().getFullYear();

        $timeout( function(){           
            angular.forEach(vm.allmonths, function(month){
                console.log("Mes");
                console.log(month);
                var id = "getDatasCalendario";
                postService.async("Holidays", id, month.data).then(function(d) {                
                    if(d.status == "success"){
                        month.eventos = d.datas;
                    }else{
                        var msg;
                        var error = "Error fetching dates from database. Please try again.";
                        showToast(msg, false, error);
                    }
                });
            });
        }, 1000 );      

        
        
        vm.dtInstance = {};
        vm.type = 1;
        var numcolunas = 7;

        vm.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('ajax', {
            url: CONFIG.apiBaseUrl + 'Holidays/'+vm.type+'fetchHolidays',
            type: 'POST',
            "dataSrc": function(json) {
                if(json.status && json.status == "login"){
                    $mdDialog.hide();
                    var infor = "Your login has expired. Please login again.";
                    showToast(infor, "info");
                    $location.path('/login');
                  }else{
                      console.log(json);
                      return json.data;
                  }
            },
            "data": function(d){
                console.log(d);
                for (var i = 0; i < numcolunas; ++i) {
                  var f = "d.columns["+i+"].search.value = self.search"+i+";";
                  eval(f);
                  d.userid = vm.userid;
                }                
                
            },
            "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
        })
        .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
        .withDataProp('data')
        .withOption('processing', true)
        .withOption('serverSide', true)
        .withOption('filter', false)
        .withOption('bLengthChange', true)
        .withOption('bSort', false)
        .withOption('responsive',false)
        .withPaginationType('full_numbers')
        .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).css('cursor', 'pointer');
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    if(vm.type == 1){
                        console.log(aData);
                        if($(nRow).hasClass('highlitedRow')){
                                $(nRow).removeClass('highlitedRow'); 
                                vm.caixaedicao = 0;
                                vm.request = undefined;
                        }else{
                            editRequest(aData[6]);
                            $('table tr').removeClass('highlitedRow');
                            $(nRow).addClass('highlitedRow');
                        }
                        return nRow;
                    }
                });                      
            });
        })
        .withOption('order', [])        
        .withOption('initComplete', function(){
            var api = this.api();

            vm.totalRecords = api.page.info().recordsTotal;
            vm.totalRecordsFiltered = api.page.info().recordsDisplay;
            

            vm.searchTable = function(searchText, column){
                var f = "self.search"+column+" = searchText;";
                eval(f);
                vm.dtInstance.DataTable.search(searchText).draw();                  
            } 
            
            vm.reset = function(){
                vm.search = [];
                vm.startDate = undefined;
                vm.endDate = undefined;
                vm.onDate = undefined;
                for (var i = 0; i < numcolunas; ++i) {
                  var f = "self.search"+i+" = undefined;";
                  eval(f);
                }
                vm.dtInstance.reloadData(null, true);                      
            }

            vm.changeType = function(type){
                vm.reset();
                vm.type = type;
                var newurl = CONFIG.apiBaseUrl + 'Holidays/'+vm.type+'fetchHolidays';  
                criarColunas();              
                $timeout( function(){                    
                    vm.dtInstance.DataTable.ajax.url(newurl).load();
                }, 100 );
                vm.cancel();                                
            }
            
        })
        .withLanguage({
            "paginate": {
                "first": 'First',
                "last": 'Last',
                "next": 'Next',
                "previous": 'Previous'
            }
        });

        function criarColunas(){
            vm.dtColumns = [
                DTColumnBuilder.newColumn(0).withTitle('From Date'),
                DTColumnBuilder.newColumn(1).withTitle('To Date'),
                DTColumnBuilder.newColumn(2).withTitle('Name'),
                DTColumnBuilder.newColumn(3).withTitle('Manager'),
                DTColumnBuilder.newColumn(4).withTitle('Status'),
                DTColumnBuilder.newColumn(5).withTitle('On Date').notVisible(),
                DTColumnBuilder.newColumn(6).withTitle('ID').notVisible(),
            ]      
        }

        criarColunas();

        vm.saveNewRequest = function(request){
            console.log(request);
            var msg = "Request submission was ";
            request.requested_date = new Date();          
            api.holidays.save({ record: request }).$promise.then(function (result) 
            { 
              console.log(result); 
              if(result.status !== 'success'){ 
                showToast(msg, false); 
              }else{
                vm.changeType(vm.type);  
                showToast(msg);
                vm.request = [];
                vm.request.name_id = vm.userid;
                var request = undefined;
              } 
            }, function(error) {
               var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.';
               showToast(msg, false, erro);  
               console.log(erro); 
              });            
        }

        vm.cancel = function()
        {
            vm.caixaedicao = 0;
            vm.request = [];
            vm.request.name_id = vm.userid;            
            $('table tr').removeClass('highlitedRow');
            getHistoryDate(vm.userid);
        }

        vm.approveDecline = function(id, approve, comment)
        {          
           console.log("approveDecline...");
           console.log(id);
           if(approve == 1){
                var msg = 'Approval request was ';
                var statusid = 2;
           }else{
                var msg = 'Decline request was ';
                var statusid = 3;
           }
           var record = {
               holidays_id: id,
               holiday_status_id: statusid,
               approval_date: new Date(),
               users_id: vm.userid,
               comment: comment
           }; 
           console.log("Record");          
           console.log(record);
            api.holidays.save({ record: record }).$promise.then(function (result) {  
                console.log(result);
                if(result.status == "success"){                
                    vm.changeType(vm.type);  
                    showToast(msg);
                    vm.request = [];
                    vm.comments = [];
                    vm.caixaedicao = 0;
                    vm.request.name_id = vm.userid;
                }else{
                    showToast(msg, false);
                }                
            }, function(error) {
                var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.';
                showToast(msg, false, erro);  
                console.log(erro); 
               }); 
        }

    }

HolidaysController.$inject = ['$scope', '$document', '$state', '$window', '$translate', '$timeout', 'api', '$mdToast', '$mdDialog', 'postService', 'localStorageService', 'DTOptionsBuilder', 'DTColumnBuilder', 'CONFIG', '$location', '$http', 'HolidaysUserSettings', 'HolidaysCurrPrev', 'Managers'];
    
})();    
(function ()
{
    'use strict';

    angular
        .module('app.go', ['ngFileUpload'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        console.log("go module");
        $stateProvider
          .state('app.go', {
              url      : '/go/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/go/go.html',
                      controller : 'GoController as vm'
                  }
              },
              resolve  : {
                  Go: function (api, $stateParams)
                  {
                      return api.go.get({ id: $stateParams.id }).$promise;
                  },
                  Products: function (api, $stateParams)
                  {
                      return api.products.get({ id: $stateParams.id }).$promise;
                  }
              },              
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/go');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.go')
        .controller('GoController', GoController)
        .directive('validateDropdown', ['$timeout', validateDropdown]);
        

    /* Diretiva para obrigar a escolher uma das opÃ§Ãµes do Autocomplete */    
    function validateDropdown($timeout) {
                return {
                  restrict: 'A',
                  require: 'mdAutocomplete',
                  link: function(scope, elm, attr, mdAutoCompleteCtrl) {
                    $timeout(function() {
                      var input = elm.find('md-autocomplete-wrap')[0].querySelector('input');

                      /**
                      * Revalidate input model fix based on the official commit
                      * 
                      * https://github.com/angular/material/commit/399016dc76ea347cf36a9d063bcc5b5894b80f55
                      */

                      var revalidateInputModel = function() {
                        var ngModel = angular.element(input).controller('ngModel');
                        var autoCompleteScope = mdAutoCompleteCtrl.scope;
                        ngModel.$setValidity('md-require-match', !!autoCompleteScope.selectedItem || !autoCompleteScope.searchText);
                      };

                      input.addEventListener('focus', function() {
                        revalidateInputModel();
                      });

                      input.addEventListener('input', function() {
                        revalidateInputModel();
                      });
                     
                    });
                  }
                }
              }

    function GoController($scope, $document, $mdToast, $state, Go, Products, $filter, api, $window, $translate, $mdDialog, localStorageService, Upload, $timeout, CONFIG)
    {
//        console.log(Go.records);

        var vm = this;
        vm.uploadpath = CONFIG.uploadsBaseUrl;
        
        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg) {
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');

            $mdToast.show(toast);
        }        
        
//        vm.order = Go.records;
        vm.order = Go.records ? Go.records : null;
//        console.log("Order:");
//        console.log(vm.order[0].route);
        vm.estados = Go.estados;
        vm.clientes = Go.clients;
        vm.cliente = Go.cliente;
        vm.droutes = Go.deliveryroutes;
        vm.casetypes = Go.casetypes;
        vm.dldactions = Go.dldactions;
        vm.comments = Go.comments;
        vm.listorders = Go.listorders;
        vm.linkedorders = Go.linkedorders;
        vm.labdocs = Go.labdocs;
        vm.orderscontent = Go.orderscontent;
        vm.products = Go.products;
        vm.produtos = Products.records;
       console.log(vm.produtos);        
        
        vm.id = Go.id ? Go.id : 0; // If existing order ID else new order ID
//        console.log("ID: " + vm.id);

        vm.save = save;
        vm.saveAlert = saveAlert;
        vm.saveClient = saveClient;
        vm.saveCasetype = saveCasetype;
        vm.saveLinkOrder = saveLinkOrder;
        vm.saveOrderContent = saveOrderContent;
        vm.submitted = false;        
        
        var botaoAddSize = 76; // In pixels
        var caixaAlertaSize = 200; // In pixels
        var divSize = vm.estados.length * caixaAlertaSize + botaoAddSize;        
        angular.element('.order-messages-sub').css('width', divSize + 'px');
        
        vm.userid = localStorageService.get('userid');
        vm.username = localStorageService.get('username');

        
        function save(record, message)
        {            
            var msg = message ? message : 'Settings changed. Reloading page...';
            api.go.save({ record: record }).$promise.then(function (result) {
                showToast(msg);
                setTimeout(function () { // wait 0.5 second and reload
                  $state.go($state.current, {}, {reload: true});
                }, 500);                
                
          });
        }
        function saveAlert(record, message)
        {            
            var msg = message ? message : 'Settings changed. Reloading page...';
            api.orderstatus.save({ record: record }).$promise.then(function (result) {
                showToast(msg);
                setTimeout(function () { // wait 0.5 second and reload
                  $state.go($state.current, {}, {reload: true});
                }, 500);                
                
          });
        }
        function saveClient(record, message)
        {          
//            console.log("saveClient...");
//            console.log(record);
            var msg = message ? message : 'Settings changed. Reloading page...';
            api.clients.save({ record: record }).$promise.then(function (result) {
                showToast(msg);
                setTimeout(function () { // wait 0.5 second and reload
                  $state.go($state.current, {}, {reload: true});
                }, 500);                
                
          });
        }         
        function saveCasetype(record, message)
        {          
//            console.log("saveCasetype...");
//            console.log(record);
            var msg = message ? message : 'Settings changed. Reloading page...';
            api.casetype.save({ record: record }).$promise.then(function (result) {
                showToast(msg);
                setTimeout(function () { // wait 0.5 second and reload
                  $state.go($state.current, {}, {reload: true});
                }, 500);                
                
          });
        } 
        
        function saveLinkOrder(record, message)
        {          
            console.log("saveLinkOrder...");
            console.log(record);
            var msg = message ? message : 'Settings changed. Reloading page...';
            api.orderslinked.save({ record: record }).$promise.then(function (result) {
                showToast(msg);
                setTimeout(function () { // wait 0.5 second and reload
                  $state.go($state.current, {}, {reload: true});
                }, 500);                
                
          });
        }

        function saveOrderContent(record, message)
        {          
            console.log("saveOrderContent...");
            console.log(record);
            var msg = message ? message : 'Settings changed. Reloading page...';
            api.orderscontent.save({ record: record }).$promise.then(function (result) {
                showToast(msg);
                setTimeout(function () { // wait 0.5 second and reload
                  $state.go($state.current, {}, {reload: true});
                }, 500);                
                
          });
        }
        
        function deleteLinkedOrder(id, message)
        {          
            console.log("deleteLinkOrder...");
            console.log(id);
            var msg = message ? message : 'Settings changed. Reloading page...';
            api.orderslinked.delete({id: id}).$promise.then(function (result) {
                showToast(msg);
                setTimeout(function () { // wait 0.5 second and reload
                  $state.go($state.current, {}, {reload: true});
                }, 500);                
                
          });
        }

        function deleteProduct(id, message)
        {          
            console.log("deleteProduct...");
            console.log(id);
            var msg = message ? message : 'Settings changed. Reloading page...';
            api.ordersproduct.delete({id: id}).$promise.then(function (result) {
                showToast(msg);
                setTimeout(function () { // wait 0.5 second and reload
                  $state.go($state.current, {}, {reload: true});
                }, 500);                
                
          });
        }

        function deleteProducts(id, message)
        {          
            console.log("deleteProducts...");
            console.log(id);
            var msg = message ? message : 'Settings changed. Reloading page...';
            api.ordersproduct.deleteall({id: id}).$promise.then(function (result) {
                showToast(msg);
                setTimeout(function () { // wait 0.5 second and reload
                  $state.go($state.current, {}, {reload: true});
                }, 500);                
                
          });
        }                
        
        function deleteLabDoc(id, message)
        {          
            console.log("deleteLabDoc...");
            console.log(id);
            var msg = message ? message : 'Settings changed. Reloading page...';
            api.orderslabdocs.delete({id: id}).$promise.then(function (result) {
                showToast(msg);
                setTimeout(function () { // wait 0.5 second and reload
                  $state.go($state.current, {}, {reload: true});
                }, 500);                
                
          });
        }        
        
        vm.gotoOrderStatus = gotoOrderStatus;

        function gotoOrderStatus()
        {
            console.log('go OrderStatus');
            $state.go('app.orderstatus');
        }        
    
        $scope.casetypestatus = '  ';
        $scope.orderinfostatus = '  ';
        $scope.casetypestatus = '  ';
        $scope.customFullscreen = false;
        
        vm.addLabDoc = addLabDoc;
        vm.addNewDeliveryRoute = addNewDeliveryRoute;
        vm.removeDeliveryRoute = removeDeliveryRoute;
        vm.addNewMessage = addNewMessage;
        vm.addNewLinkOrder = addNewLinkOrder;
        vm.removeLinkedOrder = removeLinkedOrder;        
        vm.removeLabDoc = removeLabDoc;
        vm.removeProduct = removeProduct;
        
        function addNewMessage(record)
        {          
            console.log("addNewMessage...");
            console.log(record);
            var msg = 'Comment added! Reloading page...';
            api.ordercomments.save({ record: record }).$promise.then(function (result) {
                showToast(msg);
                setTimeout(function () { // wait 0.5 second and reload
                  $state.go($state.current, {}, {reload: true});
                }, 500);                
                
          });
        }
        
        function removeDeliveryRoute(ev) {
          var confirm = $mdDialog.confirm(
                    /* Este cÃ³digo seguinte sÃ³ Ã© preciso para mudar a cor ao botÃ£o (para vermelho para remover, por ex.) */
                    {
                        onComplete: function afterShowAnimation() {
                            var $dialog = angular.element(document.querySelector('md-dialog'));
                            var $actionsSection = $dialog.find('md-dialog-actions');
                            var $cancelButton = $actionsSection.children()[0];
                            var $confirmButton = $actionsSection.children()[1];
                            angular.element($confirmButton).addClass('md-raised md-warn');
                            angular.element($cancelButton).addClass('md-primary');
                        }
                    }
                )
                .title('Are you sure?')
                .textContent('Please confirm if you would like to remove this delivery route.')
                .ariaLabel('Remove confirm box')
                .targetEvent(ev)
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('Yes, Remove!')
                .cancel('No, Cancel');
          $mdDialog.show(confirm).then(function() {
                var record = {
                 orders_id: vm.id,
                 deliveryroutes_id: 0
                };
                console.log(record);
                var msg = "Delivery route removed! Reloading page...";
                save(record, msg);
          }, function() {
//            $scope.status = 'You decided to keep your debt.';
          });
        };
    function removeLinkedOrder(ev, id) {
          var confirm = $mdDialog.confirm(
                    /* Este cÃ³digo seguinte sÃ³ Ã© preciso para mudar a cor ao botÃ£o (para vermelho para remover, por ex.) */
                    {
                        onComplete: function afterShowAnimation() {
                            var $dialog = angular.element(document.querySelector('md-dialog'));
                            var $actionsSection = $dialog.find('md-dialog-actions');
                            var $cancelButton = $actionsSection.children()[0];
                            var $confirmButton = $actionsSection.children()[1];
                            angular.element($confirmButton).addClass('md-raised md-warn');
                            angular.element($cancelButton).addClass('md-primary');
                        }
                    }
                )
                .title('Are you sure?')
                .textContent('Please confirm if you would like to remove this linked order.')
                .ariaLabel('Remove confirm box')
                .targetEvent(ev)
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('Yes, Remove!')
                .cancel('No, Cancel');
          $mdDialog.show(confirm).then(function() {
//                var record = { 'id' : id } ;
//                console.log(record);
                var msg = "Linked order removed! Reloading page...";
                deleteLinkedOrder(id, msg);
          }, function() {
//            $scope.status = 'You decided to keep your debt.';
          });
        };
        function removeProduct(ev, id) {
          var confirm = $mdDialog.confirm(
                    /* Este cÃ³digo seguinte sÃ³ Ã© preciso para mudar a cor ao botÃ£o (para vermelho para remover, por ex.) */
                    {
                        onComplete: function afterShowAnimation() {
                            var $dialog = angular.element(document.querySelector('md-dialog'));
                            var $actionsSection = $dialog.find('md-dialog-actions');
                            var $cancelButton = $actionsSection.children()[0];
                            var $confirmButton = $actionsSection.children()[1];
                            angular.element($confirmButton).addClass('md-raised md-warn');
                            angular.element($cancelButton).addClass('md-primary');
                        }
                    }
                )
                .title('Are you sure?')
                .textContent('Please confirm if you would like to remove this product.')
                .ariaLabel('Remove confirm box')
                .targetEvent(ev)
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('Yes, Remove!')
                .cancel('No, Cancel');
          $mdDialog.show(confirm).then(function() {
//                var record = { 'id' : id } ;
//                console.log(record);
                var msg = "Product removed from order! Reloading page...";
                deleteProduct(id, msg);
          }, function() {
//            $scope.status = 'You decided to keep your debt.';
          });
        };
function removeProducts(ev, id) {
          var confirm = $mdDialog.confirm(
                    /* Este cÃ³digo seguinte sÃ³ Ã© preciso para mudar a cor ao botÃ£o (para vermelho para remover, por ex.) */
                    {
                        onComplete: function afterShowAnimation() {
                            var $dialog = angular.element(document.querySelector('md-dialog'));
                            var $actionsSection = $dialog.find('md-dialog-actions');
                            var $cancelButton = $actionsSection.children()[0];
                            var $confirmButton = $actionsSection.children()[1];
                            angular.element($confirmButton).addClass('md-raised md-warn');
                            angular.element($cancelButton).addClass('md-primary');
                        }
                    }
                )
                .title('Are you sure?')
                .textContent('Please confirm if you would like to remove this product.')
                .ariaLabel('Remove confirm box')
                .targetEvent(ev)
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('Yes, Remove!')
                .cancel('No, Cancel');
          $mdDialog.show(confirm).then(function() {
//                var record = { 'id' : id } ;
//                console.log(record);
                var msg = "Products removed from order! Reloading page...";
                deleteProducts(id, msg);
          }, function() {
//            $scope.status = 'You decided to keep your debt.';
          });
        };        
    function removeLabDoc(ev, id) {
          var confirm = $mdDialog.confirm(
                    /* Este cÃ³digo seguinte sÃ³ Ã© preciso para mudar a cor ao botÃ£o (para vermelho para remover, por ex.) */
                    {
                        onComplete: function afterShowAnimation() {
                            var $dialog = angular.element(document.querySelector('md-dialog'));
                            var $actionsSection = $dialog.find('md-dialog-actions');
                            var $cancelButton = $actionsSection.children()[0];
                            var $confirmButton = $actionsSection.children()[1];
                            angular.element($confirmButton).addClass('md-raised md-warn');
                            angular.element($cancelButton).addClass('md-primary');
                        }
                    }
                )
                .title('Are you sure?')
                .textContent('Please confirm if you would like to remove this linked order.')
                .ariaLabel('Remove confirm box')
                .targetEvent(ev)
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('Yes, Remove!')
                .cancel('No, Cancel');
          $mdDialog.show(confirm).then(function() {
                console.log("Lab Doc: " + id);
                var msg = "Lab doc removed! Reloading page...";
                deleteLabDoc(id, msg);
          }, function() {
//            $scope.status = 'You decided to keep your debt.';
          });
        };        
        function addNewDeliveryRoute(ev) {
                $mdDialog.show({
                  controller: addNewDeliveryRouteController,
                  controllerAs: 'ctrlz',
                  templateUrl: 'app/main/pages/go/templates/adddeliveryroute.tpl.html',
                  parent: angular.element(document.body),
                  targetEvent: ev,
                  clickOutsideToClose:true,
                  fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function() {
//                  $scope.casetypestatus = 'Changes were saved.';
                }, function() {
//                  $scope.casetypestatus = 'Changes were not saved.';
                });
              }; 
        function addNewLinkOrder(ev) {
                $mdDialog.show({
                  controller: addNewLinkOrderController,
                  controllerAs: 'ctrlx',
                  templateUrl: 'app/main/pages/go/templates/addnewlinkorder.tpl.html',
                  parent: angular.element(document.body),
                  targetEvent: ev,
                  clickOutsideToClose:true,
                  fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function() {
//                  $scope.casetypestatus = 'Changes were saved.';
                }, function() {
//                  $scope.casetypestatus = 'Changes were not saved.';
                });
              };              
        function addLabDoc(ev) {
                $mdDialog.show({
                  controller: addLabDocController,
                  controllerAs: 'labctrl',
                  templateUrl: 'app/main/pages/go/templates/lab-doc-popup.html',
                  parent: angular.element(document.body),
                  targetEvent: ev,
                  clickOutsideToClose:true,
                  fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function() {
//                  $scope.casetypestatus = 'Changes were saved.';
                }, function() {
//                  $scope.casetypestatus = 'Changes were not saved.';
                });
              };         
        $scope.completeOrder = function(ev) {
                $mdDialog.show({
                  controller: DialogController,
                  templateUrl: 'app/main/pages/go/completed.tpl.html',
                  parent: angular.element(document.body),
                  targetEvent: ev,
                  clickOutsideToClose:true,
                  fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function() {
//                  $scope.casetypestatus = 'Changes were saved.';
                }, function() {
//                  $scope.casetypestatus = 'Changes were not saved.';
                });
              };        
        $scope.approveOrder = function(ev) {
                $mdDialog.show({
                  controller: DialogController,
                  templateUrl: 'app/main/pages/go/approve.tpl.html',
                  parent: angular.element(document.body),
                  targetEvent: ev,
                  clickOutsideToClose:true,
                  fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function() {
//                  $scope.casetypestatus = 'Changes were saved.';
                }, function() {
//                  $scope.casetypestatus = 'Changes were not saved.';
                });
              };        
        $scope.cancelOrder = function(ev) {
                $mdDialog.show({
                  controller: DialogController,
                  templateUrl: 'app/main/pages/go/cancelorder.tpl.html',
                  parent: angular.element(document.body),
                  targetEvent: ev,
                  clickOutsideToClose:true,
                  fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function() {
//                  $scope.casetypestatus = 'Changes were saved.';
                }, function() {
//                  $scope.casetypestatus = 'Changes were not saved.';
                });
              };         
        $scope.waitingCall = function(ev) {
                $mdDialog.show({
                  controller: DialogController,
                  templateUrl: 'app/main/pages/go/wfc.tpl.html',
                  parent: angular.element(document.body),
                  targetEvent: ev,
                  clickOutsideToClose:true,
                  fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function() {
//                  $scope.casetypestatus = 'Changes were saved.';
                }, function() {
//                  $scope.casetypestatus = 'Changes were not saved.';
                });
              };        
        $scope.waitingImpressions = function(ev) {
                $mdDialog.show({
                  controller: DialogController,
                  templateUrl: 'app/main/pages/go/wfi.tpl.html',
                  parent: angular.element(document.body),
                  targetEvent: ev,
                  clickOutsideToClose:true,
                  fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function() {
//                  $scope.casetypestatus = 'Changes were saved.';
                }, function() {
//                  $scope.casetypestatus = 'Changes were not saved.';
                });
              };        
        $scope.newOrderAlert = function(ev) {
                $mdDialog.show({
                  controller: DialogController,
                  templateUrl: 'app/main/pages/go/order-alert.tpl.html',
                  parent: angular.element(document.body),
                  targetEvent: ev,
                  clickOutsideToClose:true,
                  fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function() {
                    console.log('A tentar gravar... sucesso newOrderAlert');
                }, function() {
                    console.log('A tentar gravar... failed newOrderAlert');
                });
              };        
        vm.addNewProduct = function(ev) {
                $mdDialog.show({
                  controller: addNewProductController,
                  controllerAs: 'addnewpctrl',
                  templateUrl: 'app/main/templates/addproduct.tpl.html',
                  parent: angular.element(document.body),
                  targetEvent: ev,
                  clickOutsideToClose:true,
                  fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function() {
//                  $scope.casetypestatus = 'Changes were saved.';
                }, function() {
//                  $scope.casetypestatus = 'Changes were not saved.';
                });
              };        
        $scope.search = function(ev) {
                $mdDialog.show({
                  controller: DialogController,
                  templateUrl: 'app/main/pages/go/search.tpl.html',
                  parent: angular.element(document.body),
                  targetEvent: ev,
                  clickOutsideToClose:true,
                  fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function() {
//                  $scope.casetypestatus = 'Changes were saved.';
                }, function() {
//                  $scope.casetypestatus = 'Changes were not saved.';
                });
              };
            $scope.showCaseType = function(ev) {
                $mdDialog.show({
                  controller: updateCaseTypeController,
                  controllerAs: 'ctrla',
                  templateUrl: 'app/main/pages/go/casetype.tpl.html',
                  parent: angular.element(document.body),
                  targetEvent: ev,
                  clickOutsideToClose:true,
                  fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function() {
//                  $scope.casetypestatus = 'Changes were saved.';
                }, function() {
//                  $scope.casetypestatus = 'Changes were not saved.';
                });
              };
            $scope.showOrderInfo = function(ev) {
                $mdDialog.show({
                  controller: updateOrderInfoController,
                  controllerAs: 'ctrl',
                  templateUrl: 'app/main/pages/go/orderinfo.tpl.html',
                  parent: angular.element(document.body),
                  targetEvent: ev,
                  clickOutsideToClose:true,
                  fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function() {
//                  $scope.orderinfostatus = 'Changes were saved.';
                }, function() {
//                  $scope.orderinfostatus = 'Changes were not saved.';
                });
              };
            $scope.showOrderContent = function(ev) {
                $mdDialog.show({
                  controller: orderContentController,
                  controllerAs: 'orderctrl',
                  templateUrl: 'app/main/pages/go/ordercontent.tpl.html',
                  parent: angular.element(document.body),
                  targetEvent: ev,
                  clickOutsideToClose:true,
                  fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                .then(function() {
                  $scope.ordercontentstatus = 'Changes were saved.';
                }, function() {
                  $scope.ordercontentstatus = 'Changes were not saved.';
                });
              };              
       
        function DialogController($scope, $mdDialog) {
            $scope.userid = vm.userid;
            $scope.username = vm.username;
            $scope.data = new Date();
            $scope.id = vm.id;
            $scope.hide = function() {
              $mdDialog.hide();
            };
            $scope.cancel = function() {
              $mdDialog.cancel();
            };
            $scope.gravar = function(gravar) {                
                console.log(gravar);
                $mdDialog.hide();
                var msg = "New alert message inserted! Reloading page...";                
                saveAlert(gravar, msg);              
            };
        }       
        function updateOrderInfoController($q, $scope, $mdDialog) {
            var self = this;
            self.clientes = vm.clientes;
            self.cliente = vm.cliente ? vm.cliente : null;
            $scope.id = vm.id;
            self.isDisabled    = false;
            self.selectedItemChange = selectedItemChange;
            self.searchText    = null;
            self.newClient = newClient;
            self.querySearch = querySearch;
            self.ativa = ativa;
            self.titulo = null;
            self.alterar = alterar;

            if(self.cliente != null){
              self.jaexiste = 1;
            }else{
              self.jaexiste = 0;
            }

            function newClient(teste) {
              self.cliente.clientname = teste;
              self.isDisabled = true;
            }
            function ativa(){
              self.isDisabled = false;
              self.titulo = "Click to change new client name";
            }
            function alterar(){
              var r = confirm("Are you sure you want to insert a new client?");
              if (r == true) {
                self.isDisabled = false;
                delete self.cliente;
                // console.log(self.cliente);
                self.jaexiste = 0;
              }
            }            
            function querySearch (query) {
              var querylower = query.toLowerCase()
              var res = self.clientes.filter(function(obj){
                return obj.clientname.toLowerCase().indexOf(querylower) != -1;
              }); 
              return res;
            }            
            function selectedItemChange(item){
                self.cliente = item;
            }            

            $scope.cancel = function($event) {
              $mdDialog.cancel();
            };
            $scope.finish = function($event) {
              $mdDialog.hide();
            };
            $scope.gravar = function(gravar) {                
               console.log(gravar);
                $mdDialog.hide();
                var msg = "Order Info Updated! Reloading page...";
                // saveClient(gravar, msg);              
            };             

        }
        function updateCaseTypeController($q, $scope, $mdDialog) {
            var self = this;
            self.casetypes = vm.casetypes;
//            self.client = vm.cliente ? vm.cliente : 0;
//            console.log(self.casetypes);
            $scope.id = vm.id;

            $scope.cancel = function($event) {
              $mdDialog.cancel();
            };
            $scope.finish = function($event) {
              $mdDialog.hide();
            };
            $scope.gravar = function(gravar) {                
                console.log(gravar);
                $mdDialog.hide();
                var msg = "Case Type Updated! Reloading page...";
                saveCasetype(gravar, msg);              
            };             

        }        
        function addNewDeliveryRouteController($q, $scope, $mdDialog, Upload) {
            var self = this;            
            self.droutes = vm.droutes;
            $scope.id = vm.id;
            self.deliveryroutes_id = vm.order[0].deliveryroutes_id - 1;
            $scope.cancel = function($event) {
              $mdDialog.cancel();
            };
            $scope.finish = function($event) {
              $mdDialog.hide();
            };
            $scope.gravar = function(gravar) {                
//                console.log(gravar.clients_id);
                $mdDialog.hide();
                var msg = "Delivery Route updated! Reloading page...";
                save(gravar, msg);              
            };          
        }
        function orderContentController($q, $scope, $mdDialog, Upload) {
            var self = this;            
            self.orderscontent = vm.orderscontent;
            $scope.id = vm.id;
            $scope.cancel = function($event) {
              $mdDialog.cancel();
            };
            $scope.finish = function($event) {
              $mdDialog.hide();
            };
            $scope.gravar = function(gravar) {                
               console.log(gravar);
                $mdDialog.hide();
                var msg = "Order Content updated! Reloading page...";
                saveOrderContent(gravar, msg);           
            };          
        }        
        function addNewLinkOrderController($q, $scope, $mdDialog) {
            var self = this;            
            self.listorders = vm.listorders;
            $scope.id = vm.id;

            self.selectedOrderIdChange = selectedOrderIdChange;
            self.searchText    = null;                        
            
            function selectedOrderIdChange(item){
//                console.log("Opcao escolhida:");
//                console.log(item.orders_id);
                self.linkedtoid = item.orders_id;
            } 
            $scope.cancel = function($event) {
              $mdDialog.cancel();
            };
            $scope.finish = function($event) {
              $mdDialog.hide();
            };
            $scope.gravar = function(gravar) {
                gravar.linkedto_orders_id = self.linkedtoid;
                console.log("Gravar:");
                console.log(gravar);
                $mdDialog.hide();
                var msg = "Link Order added! Reloading page...";
                saveLinkOrder(gravar, msg);              
            };          
        }
        function addNewProductController($q, $scope, $mdDialog) {
            var self = this;            
            self.products = vm.products;
            self.produtos = vm.produtos;
            console.log(self.produtos);
            $scope.id = vm.id;

            $scope.cancel = function($event) {
              $mdDialog.cancel();
            };
            $scope.finish = function($event) {
              $mdDialog.hide();
            };
            $scope.gravar = function(gravar) {
                console.log("Gravar:");
                console.log(gravar);
                $mdDialog.hide();
                var msg = "Product added! Reloading page...";
                // saveLinkOrder(gravar, msg);              
            };          
        }
        function addLabDocController($q, $scope, $mdDialog, Upload, $timeout, CONFIG) {
          //acamenhas
            $scope.userid = vm.userid;
            $scope.orderid = vm.id;
            $scope.determinateValue = 0;
            var self = this;            
//            self.labdocs = vm.labdocs;
//            $scope.id = vm.id;
            
            /* Upload Lab Docs */
        
            $scope.$watch('files', function () {
                    $scope.upload($scope.files);
                });
                $scope.$watch('file', function () {
                    if ($scope.file != null) {
                        $scope.files = [$scope.file]; 
                    }
                });
                $scope.log = '';

                $scope.upload = function (files) {
                    if (files && files.length) {
                        for (var i = 0; i < files.length; i++) {
                          var file = files[i];
                          if (!file.$error) {
                            Upload.upload({
                                url: CONFIG.apiBaseUrl + 'LabDoc',
                                data: {
                                  orders_id: $scope.orderid,
                                  user_id: $scope.userid,
                                  file: file  
                                }
                            }).then(function (resp) {
                              vm.labdocs.push(resp.data.order_lab_doc);
                              $mdDialog.hide();
                            }, null, function (evt) {
                                var progressPercentage = parseInt(100.0 *
                                            evt.loaded / evt.total);
                                            $scope.determinateValue = progressPercentage;
                            });
                          }
                        }
                    }
                };



            /* FIM Upload Lab Docs */

            $scope.cancel = function($event) {
              $mdDialog.cancel();
            };
            $scope.finish = function($event) {
              $mdDialog.hide();
            };
            $scope.gravar = function(gravar) {
//                gravar.lab_docs_id = self.lab_docs_id;
                console.log("Gravar:");
                console.log(gravar);
                $mdDialog.hide();
                var msg = "Lab Doc added! Reloading page...";
//                saveLinkOrder(gravar, msg);              
            };          
        }        
        
        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.financesrevenue', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.financesrevenue', {
              url      : '/finances/revenue/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/financesrevenue/financesrevenue.html',
                      controller : 'financesRevenueController as vm'
                  }
              },
              /*resolve  : {
                  Expenditure: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                        return api.expenditure.get({ id: $stateParams.id }).$promise;
                    }
                  }
              },*/               
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/financesrevenue');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.financesrevenue')
        .controller('financesRevenueController', financesRevenueController);

    function financesRevenueController($scope, $document, $mdToast, $state, api, $window, $translate, $mdDialog, localStorageService,DTOptionsBuilder,DTColumnBuilder,CONFIG)
    {
        console.log("financesRevenue");

        var vm = this;

        vm.userid = localStorageService.get('userid');
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
        }
        vm.admin = localStorageService.get('admin');
        vm.levelid = localStorageService.get('levelid');
    
        vm.disabled = false;
    
        /* Verifica se tem permissões de ver e/ou alterar conteúdos */
        if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || (vm.privileges[39].privileges.view != '1' && vm.privileges[40].privileges.view != '1')){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if(((vm.privileges[39].privileges.edit == '0' || vm.privileges[39].privileges.edit == null || vm.privileges[39].privileges.edit == false) && (vm.privileges[40].privileges.edit == '0' || vm.privileges[40].privileges.edit == null || vm.privileges[40].privileges.edit == false)) && (vm.privileges[40].privileges.view == '1' || vm.privileges[40].privileges.view == '1')){
                vm.disabled = true;
            }
        }

        vm.caixaedicao = 0;
        vm.caixaedicaomulti = 0;    

        vm.goto = function(app)
        {
            console.log('go '+app);
            $state.go('app.'+app);
        }

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg, state, error) {
            if (typeof(state)==='undefined') state = true;
            if(state == true){
            msg = msg + 'a success!';
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');
            }else if(state == "info"){
              var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(10000)
                .theme("orange")
                .position('top right');
            }else{
            if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
            if (typeof(error)!=='undefined') msg = error;
              var toast = $mdToast.simple()
                  .content(msg)
                  .highlightAction(true)
                  .hideDelay(3000)
                  .theme("error-toast")
                  .position('top right');              
            }
            $mdToast.show(toast); 
        }


        vm.dtInstance = {};
        var numcolunas = 5;
        var itemabrir = [];

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'FinancesRevenue/revenue',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search"+i+";";
                    eval(f);
                    }
                    console.log(d);
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',true)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $('td', nRow).css('cursor', 'pointer');
                $('td', nRow).unbind('click');
                $('td', nRow).bind('click', function() {
                    $scope.$apply(function() {
                      console.log(aData);
                        if($(nRow).hasClass('highlitedRow')){
                            $(nRow).removeClass('highlitedRow'); 
                            vm.caixaedicao = 0;
                            vm.revenue = undefined;
                          }else{
                            editRevenue(aData[0]);
                            $('table tr').removeClass('highlitedRow');
                            $(nRow).addClass('highlitedRow');
                            itemabrir = aData[0];
                          }
                        return nRow;
                    });
                });
            })
            /*.withOption('createdRow', function(row) {
                $compile(angular.element(row).contents())($scope);
            })*/
            .withOption('order', [])        
            .withOption('initComplete', function(){
                var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;

                vm.searchTable = function(searchText, column){                
                    var f = "self.search"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance.DataTable.search(searchText).draw();
                }
                
                vm.reset = function(){                    
                    vm.search = [];
                    vm.search.startDate = undefined;
                    vm.search.endDate = undefined;
                    for (var i = 0; i < numcolunas; ++i) {
                        var f = "self.search"+i+" = undefined;";
                        eval(f);
                    }
                    vm.dtInstance.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "sInfo": 'Info',
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns = [          
            DTColumnBuilder.newColumn(0).withTitle('Revenue ID').notVisible(),
            DTColumnBuilder.newColumn(1).withTitle('Date'),
            DTColumnBuilder.newColumn(2).withTitle('Start Period'),
            DTColumnBuilder.newColumn(3).withTitle('End Period'),
            DTColumnBuilder.newColumn(4).withTitle('Revenue')
        ];

        function editRevenue(id){
            vm.caixaedicao = 1;            
            api.financesrevenue.get({ id: id }).$promise.then(function (result) {
                vm.revenue = result.record;
                console.log(vm.revenue);                
            });
        }

        vm.saveRevenue = function(record)
        {          
           console.log("saveRevenue...");
           console.log(record);
           var msg = 'Updating revenue was ';
            api.financesrevenue.save({ record: record }).$promise.then(function (result) {
                console.log(result);
                if(result.status == "success"){                   
                    showToast(msg);
                    vm.dtInstance.reloadData(null, true);
                    vm.caixaedicao = 0;
                    vm.revenue = undefined;
                }else{
                    showToast(msg, false);
                }                
          });
        }

        vm.deleteRevenue = function(id)
        {          
            console.log("deleteRevenue...");
            console.log(id);
            var msg = 'revenue delete was ';
            api.financesrevenue.delete({id: id}).$promise.then(function (result) {  
                console.log(result);
                if(result.status == "success"){                   
                    showToast(msg);
                    vm.dtInstance.reloadData(null, true);
                    vm.caixaedicao = 0;
                    vm.revenue = undefined;
                }else{
                    showToast(msg, false);
                }                
            });
        }

        vm.cancel = function()
        {
            vm.caixaedicao = 0;
            vm.revenue = [];
            $('table tr').removeClass('highlitedRow');
        }
        
    }      
    
    financesRevenueController.$inject = ['$scope', '$document', '$mdToast', '$state', 'api', '$window', '$translate', '$mdDialog', 'localStorageService','DTOptionsBuilder','DTColumnBuilder','CONFIG'];  
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.financesowed', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.financesowed', {
              url      : '/finances/owed/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/financesowed/financesowed.html',
                      controller : 'FinancesOwedController as vm'
                  }
              },
              /*resolve  : {
                  Expenditure: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                        return api.expenditure.get({ id: $stateParams.id }).$promise;
                    }
                  }
              },*/               
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/financesowed');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.financesowed')
        .controller('FinancesOwedController', FinancesOwedController);

    function FinancesOwedController($scope, $document, $mdToast, $state, api, $window, $translate, $mdDialog, localStorageService,DTOptionsBuilder,DTColumnBuilder,CONFIG)
    {
        console.log("FinancesOwed");

        var vm = this;

        vm.userid = localStorageService.get('userid');
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
        }
        vm.admin = localStorageService.get('admin');
        vm.levelid = localStorageService.get('levelid');
    
        vm.disabled = false;
    
        /* Verifica se tem permissões de ver e/ou alterar conteúdos */
        if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || (vm.privileges[39].privileges.view != '1' && vm.privileges[40].privileges.view != '1')){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if(((vm.privileges[39].privileges.edit == '0' || vm.privileges[39].privileges.edit == null || vm.privileges[39].privileges.edit == false) && (vm.privileges[40].privileges.edit == '0' || vm.privileges[40].privileges.edit == null || vm.privileges[40].privileges.edit == false)) && (vm.privileges[40].privileges.view == '1' || vm.privileges[40].privileges.view == '1')){
                vm.disabled = true;
            }
        }

        vm.caixaedicao = 0;
        vm.caixaedicaomulti = 0;    

        vm.goto = function(app)
        {
            console.log('go '+app);
            $state.go('app.'+app);
        }

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg, state, error) {
            if (typeof(state)==='undefined') state = true;
            if(state == true){
            msg = msg + 'a success!';
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');
            }else if(state == "info"){
              var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(10000)
                .theme("orange")
                .position('top right');
            }else{
            if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
            if (typeof(error)!=='undefined') msg = error;
              var toast = $mdToast.simple()
                  .content(msg)
                  .highlightAction(true)
                  .hideDelay(3000)
                  .theme("error-toast")
                  .position('top right');              
            }
            $mdToast.show(toast); 
        }


        vm.dtInstance = {};
        var numcolunas = 4;
        var itemabrir = [];

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'FinancesOwed/owed',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search"+i+";";
                    eval(f);
                    }
                    console.log(d);
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',true)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $('td', nRow).css('cursor', 'pointer');
                $('td', nRow).unbind('click');
                $('td', nRow).bind('click', function() {
                    $scope.$apply(function() {
                      console.log(aData);
                        if($(nRow).hasClass('highlitedRow')){
                            $(nRow).removeClass('highlitedRow'); 
                            vm.caixaedicao = 0;
                            vm.owed = undefined;
                          }else{
                            editOwed(aData[0]);
                            $('table tr').removeClass('highlitedRow');
                            $(nRow).addClass('highlitedRow');
                            itemabrir = aData[0];
                          }
                        return nRow;
                    });
                });
            })
            /*.withOption('createdRow', function(row) {
                $compile(angular.element(row).contents())($scope);
            })*/
            .withOption('order', [])        
            .withOption('initComplete', function(){
                var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;

                vm.searchTable = function(searchText, column){                
                    var f = "self.search"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance.DataTable.search(searchText).draw();
                }
                
                vm.reset = function(){                    
                    vm.search = [];
                    vm.search.startDate = undefined;
                    vm.search.endDate = undefined;
                    for (var i = 0; i < numcolunas; ++i) {
                        var f = "self.search"+i+" = undefined;";
                        eval(f);
                    }
                    vm.dtInstance.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "sInfo": 'Info',
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns = [          
            DTColumnBuilder.newColumn(0).withTitle('Owed ID').notVisible(),
            DTColumnBuilder.newColumn(1).withTitle('Date'),
            DTColumnBuilder.newColumn(2).withTitle('Date End').notVisible(),
            DTColumnBuilder.newColumn(3).withTitle('Current Debt'),
            DTColumnBuilder.newColumn(4).withTitle('Bad Debt')
        ];

        function editOwed(id){
            vm.caixaedicao = 1;            
            api.financesowed.get({ id: id }).$promise.then(function (result) {
                vm.owed = result.record;
                console.log(vm.owed);                
            });
        }

        vm.saveOwed = function(record)
        {          
           console.log("saveOwed...");
           console.log(record);
           var msg = 'Updating owed was ';
            api.financesowed.save({ record: record }).$promise.then(function (result) {
                console.log(result);
                if(result.status == "success"){                   
                    showToast(msg);
                    vm.dtInstance.reloadData(null, true);
                    vm.caixaedicao = 0;
                    vm.owed = undefined;
                }else{
                    showToast(msg, false);
                }                
          });
        }

        vm.deleteOwed = function(id)
        {          
            console.log("deleteOwed...");
            console.log(id);
            var msg = 'owed delete was ';
            api.financesowed.delete({id: id}).$promise.then(function (result) {  
                console.log(result);
                if(result.status == "success"){                   
                    showToast(msg);
                    vm.dtInstance.reloadData(null, true);
                    vm.caixaedicao = 0;
                    vm.owed = undefined;
                }else{
                    showToast(msg, false);
                }                
            });
        }

        vm.cancel = function()
        {
            vm.caixaedicao = 0;
            vm.owed = [];
            $('table tr').removeClass('highlitedRow');
        }
        
    }      
    
    FinancesOwedController.$inject = ['$scope', '$document', '$mdToast', '$state', 'api', '$window', '$translate', '$mdDialog', 'localStorageService','DTOptionsBuilder','DTColumnBuilder','CONFIG'];  
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.financesdebt', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.financesdebt', {
              url      : '/finances/debt/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/financesdebt/financesdebt.html',
                      controller : 'financesDebtController as vm'
                  }
              },
              /*resolve  : {
                  Expenditure: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                        return api.expenditure.get({ id: $stateParams.id }).$promise;
                    }
                  }
              },*/               
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/financesdebt');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.financesdebt')
        .controller('financesDebtController', financesDebtController);

    function financesDebtController($scope, $document, $mdToast, $state, api, $window, $translate, $mdDialog, localStorageService,DTOptionsBuilder,DTColumnBuilder,CONFIG)
    {
        console.log("financesDebt");

        var vm = this;

        vm.userid = localStorageService.get('userid');
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
        }
        vm.admin = localStorageService.get('admin');
        vm.levelid = localStorageService.get('levelid');
    
        vm.disabled = false;
    
        /* Verifica se tem permissões de ver e/ou alterar conteúdos */
        if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || (vm.privileges[39].privileges.view != '1' && vm.privileges[40].privileges.view != '1')){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if(((vm.privileges[39].privileges.edit == '0' || vm.privileges[39].privileges.edit == null || vm.privileges[39].privileges.edit == false) && (vm.privileges[40].privileges.edit == '0' || vm.privileges[40].privileges.edit == null || vm.privileges[40].privileges.edit == false)) && (vm.privileges[40].privileges.view == '1' || vm.privileges[40].privileges.view == '1')){
                vm.disabled = true;
            }
        }

        vm.caixaedicao = 0;
        vm.caixaedicaomulti = 0;    

        vm.goto = function(app)
        {
            console.log('go '+app);
            $state.go('app.'+app);
        }

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg, state, error) {
            if (typeof(state)==='undefined') state = true;
            if(state == true){
            msg = msg + 'a success!';
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');
            }else if(state == "info"){
              var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(10000)
                .theme("orange")
                .position('top right');
            }else{
            if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
            if (typeof(error)!=='undefined') msg = error;
              var toast = $mdToast.simple()
                  .content(msg)
                  .highlightAction(true)
                  .hideDelay(3000)
                  .theme("error-toast")
                  .position('top right');              
            }
            $mdToast.show(toast); 
        }


        vm.dtInstance = {};
        var numcolunas = 4;
        var itemabrir = [];

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'FinancesDebt/debt',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search"+i+";";
                    eval(f);
                    }
                    console.log(d);
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',true)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $('td', nRow).css('cursor', 'pointer');
                $('td', nRow).unbind('click');
                $('td', nRow).bind('click', function() {
                    $scope.$apply(function() {
                      console.log(aData);
                        if($(nRow).hasClass('highlitedRow')){
                            $(nRow).removeClass('highlitedRow'); 
                            vm.caixaedicao = 0;
                            vm.debt = undefined;
                          }else{
                            editDebt(aData[0]);
                            $('table tr').removeClass('highlitedRow');
                            $(nRow).addClass('highlitedRow');
                            itemabrir = aData[0];
                          }
                        return nRow;
                    });
                });
            })
            /*.withOption('createdRow', function(row) {
                $compile(angular.element(row).contents())($scope);
            })*/
            .withOption('order', [])        
            .withOption('initComplete', function(){
                var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;

                vm.searchTable = function(searchText, column){                
                    var f = "self.search"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance.DataTable.search(searchText).draw();
                }
                
                vm.reset = function(){                    
                    vm.search = [];
                    vm.search.startDate = undefined;
                    vm.search.endDate = undefined;
                    for (var i = 0; i < numcolunas; ++i) {
                        var f = "self.search"+i+" = undefined;";
                        eval(f);
                    }
                    vm.dtInstance.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "sInfo": 'Info',
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns = [          
            DTColumnBuilder.newColumn(0).withTitle('Debt ID').notVisible(),
            DTColumnBuilder.newColumn(1).withTitle('Date'),
            DTColumnBuilder.newColumn(2).withTitle('Date End').notVisible(),
            DTColumnBuilder.newColumn(3).withTitle('Description'),
            DTColumnBuilder.newColumn(4).withTitle('Debt')
        ];

        function editDebt(id){
            vm.caixaedicao = 1;            
            api.financesdebt.get({ id: id }).$promise.then(function (result) {
                vm.debt = result.record;
                console.log(vm.debt);                
            });
        }

        vm.saveDebt = function(record)
        {          
           console.log("saveDebt...");
           console.log(record);
           var msg = 'Updating debt was ';
            api.financesdebt.save({ record: record }).$promise.then(function (result) {
                console.log(result);
                if(result.status == "success"){                   
                    showToast(msg);
                    vm.dtInstance.reloadData(null, true);
                    vm.caixaedicao = 0;
                    vm.debt = undefined;
                }else{
                    showToast(msg, false);
                }                
          });
        }

        vm.deleteDebt = function(id)
        {          
            console.log("deleteDebt...");
            console.log(id);
            var msg = 'debt delete was ';
            api.financesdebt.delete({id: id}).$promise.then(function (result) {  
                console.log(result);
                if(result.status == "success"){                   
                    showToast(msg);
                    vm.dtInstance.reloadData(null, true);
                    vm.caixaedicao = 0;
                    vm.debt = undefined;
                }else{
                    showToast(msg, false);
                }                
            });
        }

        vm.cancel = function()
        {
            vm.caixaedicao = 0;
            vm.debt = [];
            $('table tr').removeClass('highlitedRow');
        }
        
    }      
    
    financesDebtController.$inject = ['$scope', '$document', '$mdToast', '$state', 'api', '$window', '$translate', '$mdDialog', 'localStorageService','DTOptionsBuilder','DTColumnBuilder','CONFIG'];  
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.financesbanking', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.financesbanking', {
              url      : '/finances/banking/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/financesbanking/financesbanking.html',
                      controller : 'FinancesBankingController as vm'
                  }
              },
              /*resolve  : {
                  Expenditure: function (api, $stateParams)
                  {
                    if($stateParams.id > 0){
                        return api.expenditure.get({ id: $stateParams.id }).$promise;
                    }
                  }
              },*/               
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/financesbanking');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.financesbanking')
        .controller('FinancesBankingController', FinancesBankingController);

    function FinancesBankingController($scope, $document, $mdToast, $state, api, $window, $translate, $mdDialog, localStorageService,DTOptionsBuilder,DTColumnBuilder,CONFIG)
    {
        console.log("FinancesBanking");

        var vm = this;

        vm.userid = localStorageService.get('userid');
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
        }
        vm.admin = localStorageService.get('admin');
        vm.levelid = localStorageService.get('levelid');
    
        vm.disabled = false;
    
        /* Verifica se tem permissões de ver e/ou alterar conteúdos */
        if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || (vm.privileges[39].privileges.view != '1' && vm.privileges[40].privileges.view != '1')){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if(((vm.privileges[39].privileges.edit == '0' || vm.privileges[39].privileges.edit == null || vm.privileges[39].privileges.edit == false) && (vm.privileges[40].privileges.edit == '0' || vm.privileges[40].privileges.edit == null || vm.privileges[40].privileges.edit == false)) && (vm.privileges[40].privileges.view == '1' || vm.privileges[40].privileges.view == '1')){
                vm.disabled = true;
            }
        }

        vm.caixaedicao = 0;
        vm.caixaedicaomulti = 0;    
    
        // vm.gotoProductGroups = gotoProductGroups;

        vm.goto = function(app)
        {
            console.log('go '+app);
            $state.go('app.'+app);
        }

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg, state, error) {
            if (typeof(state)==='undefined') state = true;
            if(state == true){
            msg = msg + 'a success!';
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');
            }else if(state == "info"){
              var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(10000)
                .theme("orange")
                .position('top right');
            }else{
            if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
            if (typeof(error)!=='undefined') msg = error;
              var toast = $mdToast.simple()
                  .content(msg)
                  .highlightAction(true)
                  .hideDelay(3000)
                  .theme("error-toast")
                  .position('top right');              
            }
            $mdToast.show(toast); 
        }


        vm.dtInstance = {};
        var numcolunas = 6;
        var itemabrir = [];

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'FinancesBanking/banking',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search"+i+";";
                    eval(f);
                    }
                    console.log(d);
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',true)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $('td', nRow).css('cursor', 'pointer');
                $('td', nRow).unbind('click');
                $('td', nRow).bind('click', function() {
                    $scope.$apply(function() {
                      console.log(aData);
                        if($(nRow).hasClass('highlitedRow')){
                            $(nRow).removeClass('highlitedRow'); 
                            vm.caixaedicao = 0;
                            vm.banking = undefined;
                          }else{
                            editBanking(aData[0]);
                            $('table tr').removeClass('highlitedRow');
                            $(nRow).addClass('highlitedRow');
                            itemabrir = aData[0];
                          }
                        return nRow;
                    });
                });
            })
            /*.withOption('createdRow', function(row) {
                $compile(angular.element(row).contents())($scope);
            })*/
            .withOption('order', [])        
            .withOption('initComplete', function(){
                var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;

                vm.searchTable = function(searchText, column){                
                    var f = "self.search"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance.DataTable.search(searchText).draw();
                }
                
                vm.reset = function(){                    
                    vm.search = [];
                    vm.search.startDate = undefined;
                    vm.search.endDate = undefined;
                    for (var i = 0; i < numcolunas; ++i) {
                        var f = "self.search"+i+" = undefined;";
                        eval(f);
                    }
                    vm.dtInstance.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "sInfo": 'Info',
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns = [          
            DTColumnBuilder.newColumn(0).withTitle('Banking ID').notVisible(),
            DTColumnBuilder.newColumn(1).withTitle('Date'),
            DTColumnBuilder.newColumn(2).withTitle('Date End').notVisible(),
            DTColumnBuilder.newColumn(3).withTitle('Account Number'),
            DTColumnBuilder.newColumn(4).withTitle('Account Name'),
            DTColumnBuilder.newColumn(5).withTitle('Amount')
        ];

        function editBanking(id){
            vm.caixaedicao = 1;            
            api.financesbanking.get({ id: id }).$promise.then(function (result) {
                vm.banking = result.record;
                console.log(vm.banking);                
            });
        }

        vm.saveBanking = function(record)
        {          
           console.log("saveExistBanking...");
           console.log(record);
           var msg = 'Updating banking was ';
            api.financesbanking.save({ record: record }).$promise.then(function (result) {
                console.log(result);
                if(result.status == "success"){                   
                    showToast(msg);
                    vm.dtInstance.reloadData(null, true);
                    vm.caixaedicao = 0;
                    vm.banking = undefined;
                }else{
                    showToast(msg, false);
                }                
          });
        }

        vm.deleteBanking = function(id)
        {          
            console.log("deleteBanking...");
            console.log(id);
            var msg = 'Banking delete was ';
            api.financesbanking.delete({id: id}).$promise.then(function (result) {  
                console.log(result);
                if(result.status == "success"){                   
                    showToast(msg);
                    vm.dtInstance.reloadData(null, true);
                    vm.caixaedicao = 0;
                    vm.banking = undefined;
                }else{
                    showToast(msg, false);
                }                
            });
        }

        vm.cancel = function()
        {
            vm.caixaedicao = 0;
            vm.banking = [];
            $('table tr').removeClass('highlitedRow');
        }
        
    }      
    
    FinancesBankingController.$inject = ['$scope', '$document', '$mdToast', '$state', 'api', '$window', '$translate', '$mdDialog', 'localStorageService','DTOptionsBuilder','DTColumnBuilder','CONFIG'];  
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.finances', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.finances', {
              url      : '/finances/expenditures/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/finances/finances.html',
                      controller : 'FinancesController as vm'
                  }
              },
              resolve  : {
                //   Expenditure: function (api, $stateParams)
                //   {
                //     if($stateParams.id > 0){
                //         return api.expenditure.get({ id: $stateParams.id }).$promise;
                //     }
                //   }
              },               
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/finances');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.finances')
        .controller('FinancesController', FinancesController);

    function FinancesController($scope, $document, $mdToast, $state, api, $window, $translate, $mdDialog, localStorageService,DTOptionsBuilder,DTColumnBuilder,CONFIG)
    {
        console.log("Finances");

        var vm = this;

        vm.userid = localStorageService.get('userid');
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
        }
        vm.admin = localStorageService.get('admin');
        vm.levelid = localStorageService.get('levelid');
    
        vm.disabled = false;
    
        /* Verifica se tem permissões de ver e/ou alterar conteúdos */
        if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || (vm.privileges[39].privileges.view != '1' && vm.privileges[40].privileges.view != '1')){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if(((vm.privileges[39].privileges.edit == '0' || vm.privileges[39].privileges.edit == null || vm.privileges[39].privileges.edit == false) && (vm.privileges[40].privileges.edit == '0' || vm.privileges[40].privileges.edit == null || vm.privileges[40].privileges.edit == false)) && (vm.privileges[40].privileges.view == '1' || vm.privileges[40].privileges.view == '1')){
                vm.disabled = true;
            }
        }

        vm.caixaedicao = 0;
        vm.caixaedicaomulti = 0;    
    
        vm.goto = function(app)
        {
            console.log('go '+app);
            $state.go('app.'+app);
        }

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg, state, error) {
            if (typeof(state)==='undefined') state = true;
            if(state == true){
            msg = msg + 'a success!';
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');
            }else if(state == "info"){
              var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(10000)
                .theme("orange")
                .position('top right');
            }else{
            if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
            if (typeof(error)!=='undefined') msg = error;
              var toast = $mdToast.simple()
                  .content(msg)
                  .highlightAction(true)
                  .hideDelay(3000)
                  .theme("error-toast")
                  .position('top right');              
            }
            $mdToast.show(toast); 
        }


        vm.dtInstance = {};
        var numcolunas = 13;
        var itemabrir = [];

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'Expenditure/expenditure',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search"+i+";";
                    eval(f);
                    }
                    console.log(d);
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',true)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $('td', nRow).css('cursor', 'pointer');
                $('td', nRow).unbind('click');
                $('td', nRow).bind('click', function() {
                    $scope.$apply(function() {
                      console.log(aData);
                        if($(nRow).hasClass('highlitedRow')){
                            $(nRow).removeClass('highlitedRow'); 
                            vm.caixaedicao = 0;
                            vm.expenditure = undefined;
                          }else{
                            editExpenditure(aData[0]);
                            $('table tr').removeClass('highlitedRow');
                            $(nRow).addClass('highlitedRow');
                            itemabrir = aData[0];
                          }
                        return nRow;
                    });
                });
            })
            /*.withOption('createdRow', function(row) {
                $compile(angular.element(row).contents())($scope);
            })*/
            .withOption('order', [])        
            .withOption('initComplete', function(){
                var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;

                vm.searchTable = function(searchText, column){                
                    var f = "self.search"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance.DataTable.search(searchText).draw();
                }
                
                vm.reset = function(){                    
                    vm.search = [];
                    vm.search.startDate = undefined;
                    vm.search.endDate = undefined;
                    vm.search.onDate = undefined;
                    for (var i = 0; i < numcolunas; ++i) {
                        var f = "self.search"+i+" = undefined;";
                        eval(f);
                    }
                    vm.dtInstance.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "sInfo": 'Info',
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns = [          
            DTColumnBuilder.newColumn(0).withTitle('Expenditure ID').notVisible(),
            DTColumnBuilder.newColumn(1).withTitle('Date'),
            DTColumnBuilder.newColumn(2).withTitle('Date Start').notVisible(),
            DTColumnBuilder.newColumn(3).withTitle('Date End').notVisible(),
            DTColumnBuilder.newColumn(4).withTitle('Type'),
            DTColumnBuilder.newColumn(5).withTitle('Description'),
            DTColumnBuilder.newColumn(6).withTitle('Invoice Number'),
            DTColumnBuilder.newColumn(7).withTitle('Amount'),            
            DTColumnBuilder.newColumn(8).withTitle('VAT Amount'),
            DTColumnBuilder.newColumn(9).withTitle('Payment Date'),
            DTColumnBuilder.newColumn(10).withTitle('Payment Method'),
            DTColumnBuilder.newColumn(11).withTitle('Supplier'),
            DTColumnBuilder.newColumn(12).withTitle('Paid')
            .renderWith(function(data, type, full, meta) {
                if(full[12] == "1"){ return '<md-icon md-font-icon="icon-check" class="s24 md-default-theme md-font material-icons icon-check" aria-hidden="true"></md-icon>'; }else{ return ""; }
            })
        ];

        function editExpenditure(id){
            vm.caixaedicao = 1;            
            api.expenditure.get({ id: id }).$promise.then(function (result) {
                vm.expenditure = result.record;
                console.log(vm.expenditure);                
            });
        }

        vm.saveExpenditure = function(record)
        {          
           console.log("saveExistExpenditure...");
           console.log(record);
           var msg = 'Updating expenditure was ';
            api.expenditure.save({ record: record }).$promise.then(function (result) {
                console.log(result);
                if(result.status == "success"){                   
                    showToast(msg);
                    vm.dtInstance.reloadData(null, true);
                    vm.caixaedicao = 0;
                    vm.expenditure = undefined;
                }else{
                    showToast(msg, false);
                }                
          });
        }

        vm.deleteExpenditure = function(id)
        {          
            console.log("deleteExpenditure...");
            console.log(id);
            var msg = 'Expenditure delete was ';
            api.expenditure.delete({id: id}).$promise.then(function (result) {  
                console.log(result);
                if(result.status == "success"){                   
                    showToast(msg);
                    vm.dtInstance.reloadData(null, true);
                    vm.caixaedicao = 0;
                    vm.expenditure = undefined;
                }else{
                    showToast(msg, false);
                }                
            });
        }

        vm.cancel = function()
        {
            vm.caixaedicao = 0;
            vm.expenditure = [];
            $('table tr').removeClass('highlitedRow');
        }
        
    }      
    
    FinancesController.$inject = ['$scope', '$document', '$mdToast', '$state', 'api', '$window', '$translate', '$mdDialog', 'localStorageService','DTOptionsBuilder','DTColumnBuilder','CONFIG'];  
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.dld', ['ngMask'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        console.log("dld module"); 
        $stateProvider
          .state('app.dld', {
              url      : '/dld/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/dld/dld.html',
                      controller : 'DLDController as vm'
                  }
              },
              resolve  : {                
                Departments: function (api)
                {
                  return api.departments.get().$promise;
                }                       
              },             
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/dld');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dld')
        .controller('DLDController', DLDController)
        .directive('scanOrder', function($timeout, $q, CONFIG, $http, $state, $mdDialog, api, localStorageService, $window) {
            return {
              restrict: 'AE',
              require: 'ngModel',
              link: function($scope, elm, attr, model) { 
                model.$asyncValidators.orderExists = function(modelValue, viewValue) {
                  var valuez = modelValue || viewValue;
                  var value = valuez.substr(1);                           
                    return $http.get(CONFIG.apiBaseUrl + 'Orders/con' + value).
                       then(function (response) {
                         console.log(response.data.status);
                         if(response.data.status == "success"){
                            model.$setValidity('erro', true);
                            $mdDialog.cancel();
                            var orderid = response.data.orderid.orders_id;
                            var userid = localStorageService.get('userid');
                            var department_alias = response.data.orderid.department_alias;
                            /*var department_id = response.data.orderid.departments_id;
                            var record = {};                      
                            record = {
                                orders_opened_id: 0,
                                orders_id: orderid,
                                users_id: userid,
                                departments_id: department_id,
                                dld: 1
                            }           
                            api.ordersopened.save({ record: record, orderid: orderid });*/
                            $timeout( function(){
                                var url = $state.href('app.production', {id: orderid, module: department_alias});
                                $window.open(url, '_blank');
                            }, 200 );                         
                          return true;
                         }else if(response.data.status == "failed"){             
                          model.$setValidity('erro', false);
                          return false;
                         }                       
                       }, function rejected() {
                        console.log("erro 4xx");                       
                       });            
                };
              }
            } 
          });

    function DLDController($scope, $document, $mdToast, $state, $stateParams, $filter, Departments, api, $window, $translate, $mdDialog, localStorageService, $timeout, CONFIG, DTOptionsBuilder, DTColumnBuilder, $compile,$location)
    {
        var vm = this;
        vm.userid = localStorageService.get('userid');  
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
          }
          vm.admin = localStorageService.get('admin');
          vm.levelid = localStorageService.get('levelid');

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        vm.disabled = false;

        function showToast(msg, state, error) {
            if (typeof(state)==='undefined') state = true;
            if(state == true){
            msg = msg + 'a success!';
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');
            }else if(state == "info"){
              var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(10000)
                .theme("orange")
                .position('top right');
            }else{
            if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
            if (typeof(error)!=='undefined') msg = error;
              var toast = $mdToast.simple()
                  .content(msg)
                  .highlightAction(true)
                  .hideDelay(3000)
                  .theme("error-toast")
                  .position('top right');              
            }
            $mdToast.show(toast); 
        }
        
        /* Verifica se tem permissões de ver e/ou alterar conteúdos */
        if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || vm.privileges[11].privileges.view != '1'){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if((vm.privileges[11].privileges.edit == '0' || vm.privileges[11].privileges.edit == null || vm.privileges[11].privileges.edit == false) && vm.privileges[11].privileges.view == '1'){
                vm.disabled = true;
            }
        }
        
        vm.departments = Departments.records;
        
        vm.dtInstance = {};
        var itemabrir = [];
        var itemdata = {};       

        var urlpost = CONFIG.apiBaseUrl + 'Orders/fetchdldorders';
        var numcolumns = 17;

        vm.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('ajax', {
            url: urlpost,
            type: 'POST',
            "dataSrc": function(json) {
                if(json.status && json.status == "login"){
                    $mdDialog.hide();
                    var infor = "Your login has expired. Please login again.";
                    showToast(infor, "info");
                    $location.path('/login');
                }else{
                    console.log(json);
                    return json.data;
                }
            },
            "data": function(d){
                for (var i = 0; i < numcolumns; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search"+i+";";
                    eval(f);
                }
                console.log(d);
                
            },
            "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
        })
        .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
        .withDataProp('data')
        .withOption('processing', true)
        .withOption('serverSide', true)
        .withOption('filter', false)
        .withOption('bLengthChange', true)
        .withOption('bSort', false)
        .withOption('responsive',false)
        .withPaginationType('full_numbers')
        .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $('td', nRow).css('cursor', 'pointer');
          $('td', nRow).unbind('click');
          $('td', nRow).bind('click', function() {
              $scope.$apply(function() {
                itemdata = {
                    orders_id: aData[0],
                    department_alias: aData[16],
                    departments_id: aData[11]
                  }
                  var verifica = 0;
                  angular.forEach(itemabrir, function(item) {
                    if(item.orders_id==aData[0]){
                        verifica = 1;                            
                        $(nRow).removeClass('highlitedRow');
                        itemabrir = itemabrir.filter(function( obj ) {return obj.orders_id !== aData[0]; });
                    } 
                  });
                  if(verifica == 0){
                    itemabrir.push(itemdata);
                    $(nRow).addClass('highlitedRow');
                  }
                vm.itemabrir = itemabrir;
                console.log(vm.itemabrir);
                return nRow;                                     
              });
          });
        })
        .withOption('createdRow', function(row) {
          // Recompiling so we can bind Angular directive to the DT
          $compile(angular.element(row).contents())($scope);
      })
        .withOption('order', [])
        .withOption('initComplete', function(){
            var api = this.api();

            vm.totalRecords = api.page.info().recordsTotal;
            vm.totalRecordsFiltered = api.page.info().recordsDisplay;

            vm.searchTable = function(searchText, column){
                var f = "self.search"+column+" = searchText;";
                eval(f);
                vm.dtInstance.DataTable.search(searchText).draw();                  
            } 
            
            vm.reset = function(){                      
                vm.search = [];
                vm.startDate = undefined;
                vm.endDate = undefined;
                vm.onDate = undefined;
                for (var i = 0; i < 17; ++i) {
                    var f = "self.search"+i+" = undefined;";
                    eval(f);
                }
                vm.dtInstance.reloadData(null, true);                      
            }    
            
        })
        .withLanguage({
            "sInfo": 'Info',
            "paginate": {
                "first": 'First',
                "last": 'Last',
                "next": 'Next',
                "previous": 'Previous'
            }
        });

        vm.dtColumns = [
        DTColumnBuilder.newColumn(0).withTitle('Orders ID').notVisible(),
        DTColumnBuilder.newColumn(1).withTitle('Invoice Number'),
        DTColumnBuilder.newColumn(2).withTitle('Order Number'),
        DTColumnBuilder.newColumn(3).withTitle('Prescription Number'),
        DTColumnBuilder.newColumn(4).withTitle('Client'),
        DTColumnBuilder.newColumn(5).withTitle('Patient Name'),
        DTColumnBuilder.newColumn(6).withTitle('Date Received'),
        DTColumnBuilder.newColumn(7).withTitle('Postcode'),
        DTColumnBuilder.newColumn(8).withTitle('Location'),
        DTColumnBuilder.newColumn(9).withTitle('Status'),
        DTColumnBuilder.newColumn(10).withTitle('Status ID').notVisible(),
        DTColumnBuilder.newColumn(11).withTitle('Departments ID').notVisible(),
        DTColumnBuilder.newColumn(12).withTitle('Start Date').notVisible(),
        DTColumnBuilder.newColumn(13).withTitle('End Date').notVisible(),
        DTColumnBuilder.newColumn(14).withTitle('City').notVisible(),
        DTColumnBuilder.newColumn(15).withTitle('Country').notVisible(),
        DTColumnBuilder.newColumn(16).withTitle('Department Alias').notVisible()
        ]                
        

        /* .notVisible(), */

        /* FIM Funções Current Orders e On Invoice*/
        
        vm.gravar = function(gravar) {                
                var record = {};
                var departmentin = gravar[0].department_alias;
                if (typeof gravar !== 'undefined') {
                    for (var i = 0; i < gravar.length; i++) {                          
                        record[i] = {
                            orders_opened_id: 0,
                            orders_id: gravar[i].orders_id,
                            users_id: vm.userid
                        }
                    }
                    gravar = record;
                    console.log(gravar);
                    $mdDialog.hide();
                    var msg = "Order opening was ";
                    var orderid = vm.id;
                    api.ordersopened.save({ record: record, orderid: orderid }).$promise.then(function (result) { 
                        console.log(result); 
                        if(result.status !== 'success'){ 
                            showToast(msg, false) 
                        }else{ 
                            showToast(msg);
                            var url = $state.href('app.production', {'id': record[0].orders_id, 'module' : departmentin});                            
                            $window.open(url, '_blank');
                        } 
                    }, function(error) { 
                        var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                        showToast(msg, false, erro); 
                    });
                }
        }  

        vm.scanOrder = function(ev) {             
            $mdDialog.show({
              controller: eval("OtherController"),
              controllerAs: 'octrl',
              templateUrl: 'app/main/pages/dld/templates/scanorder.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: $scope.customFullscreen 
            });
          };
  
          vm.scanOrder.$inject = ['ev','tipopopup'];
            
        function OtherController($compile, $scope, $mdDialog, $http) {
            var self = this;

            $scope.cancel = function() {                
                $mdDialog.cancel();
              };

            $scope.hide = function() {
                $mdDialog.hide();
            };        
        }

        OtherController.$inject = ['$compile', '$scope', '$mdDialog', '$http'];
 

    }

    DLDController.$inject = ['$scope', '$document', '$mdToast', '$state', '$stateParams', '$filter', 'Departments', 'api', '$window', '$translate', '$mdDialog', 'localStorageService', '$timeout', 'CONFIG', 'DTOptionsBuilder', 'DTColumnBuilder', '$compile','$location'];

})();

(function ()
{
    'use strict';

    angular
        .module('app.deliveryroute', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.deliveryroute', {
              url      : '/deliveryroute/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/deliveryroute/deliveryroute.html',
                      controller : 'DeliveryRouteController as vm'
                  }
              },
              resolve  : {
                  DeliveryRoutes: function (api, $stateParams)
                  {
                      return api.deliveryroutes.get({ id: $stateParams.id }).$promise;
                  },
                  DeliveryGroups: function (api, $stateParams)
                  {
                      return api.deliverygroups.get({ id: $stateParams.id }).$promise;
                  },
                  Departments: function (api, $stateParams)
                  {
                      return api.departments.get({ id: $stateParams.id }).$promise;
                  }
            },
            bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/deliveryroute');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.deliveryroute')
        .controller('DeliveryRouteController', DeliveryRouteController);
//        .module('caseType', ['ngMaterial']);

    function DeliveryRouteController($scope, $document, $mdToast, $state, api, DeliveryRoutes, DeliveryGroups, Departments, $mdDialog, localStorageService)
    {
        console.log("DeliveryRoute");

        var vm = this;  
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
          }
          vm.admin = localStorageService.get('admin');
          vm.levelid = localStorageService.get('levelid');
  
          vm.disabled = false;
  
          /* Verifica se tem permissões de ver e/ou alterar conteúdos */
          if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || vm.privileges[29].privileges.view != '1'){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if((vm.privileges[29].privileges.edit == '0' || vm.privileges[29].privileges.edit == null || vm.privileges[29].privileges.edit == false) && vm.privileges[29].privileges.view == '1'){
                vm.disabled = true;
            }
          }
        
        vm.gotoDeliveryGroup = gotoDeliveryGroup;

        function gotoDeliveryGroup()
        {
            console.log('go DeliveryGroup');
            $state.go('app.deliverygroup');
        }

        vm.caixaedicao = 0;
        vm.caixaedicaomulti = 0;         

        vm.routes = DeliveryRoutes.records;
        vm.groups = DeliveryGroups.records;
        vm.departamentos = Departments.records;

        vm.editRoute = editRoute;
        vm.saveExistRoute = saveExistRoute;
        vm.deleteExistRoute = deleteExistRoute;
        vm.cancel = cancel;
        vm.saveNewRoute = saveNewRoute;
        vm.saveRoutes = saveRoutes;
        vm.deleteRoutes = deleteRoutes;

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg, state, error) {
            if (typeof(state)==='undefined') state = true;
            if(state == true){
            msg = msg + 'a success!';
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');
            }else if(state == "info"){
              var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(10000)
                .theme("orange")
                .position('top right');
            }else{
            if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
            if (typeof(error)!=='undefined') msg = error;
              var toast = $mdToast.simple()
                  .content(msg)
                  .highlightAction(true)
                  .hideDelay(3000)
                  .theme("error-toast")
                  .position('top right');              
            }
            $mdToast.show(toast); 
        }

        function editRoute(id){
            vm.caixaedicao = 1;
            vm.caixaedicaomulti = 0;            
            api.deliveryroutes.query({ id: id }).$promise.then(function (result) {
                vm.route = result.record;
                console.log(vm.route);                
            });
        }

               
        function deleteRoutes(){
            var msg;
            // var newestArray = []; 
            var data = getSelectedRows();
            var i = '';
            for (i = 0; i < data.length; i++) {
                    api.deliveryroutes.delete({id: data[i].deliveryroutes_id});
            }
                msg = "Delivery Routes deletion were ";
                showToast(msg);
                setTimeout(function () { // wait 0.5 second and reload
                  $state.go($state.current, {}, {reload: true});
                }, 500);
        }

        function saveNewRoute(record)
        {     
           console.log("saveNewRoute...");
           console.log(record);
            var msg = 'Delivery Route saving was ';
            api.deliveryroutes.save({ record: record }).$promise.then(function (result) {
                showToast(msg);
                setTimeout(function () { // wait 0.5 second and reload
                  $state.go($state.current, {}, {reload: true});
                }, 500);                
                
            });
        }        

        function saveExistRoute(record)
        {          
           console.log("saveExistRoute...");
           console.log(record);
            var msg = 'Delivery Route saving was ';
            api.deliveryroutes.save({ record: record }).$promise.then(function (result) {
                showToast(msg);
                var existingroute = vm.routes.filter(function( obj ) {return obj.deliveryroutes_id === record.deliveryroutes_id; });
                var updatedroute = record;
                updatedroute.deliverygroup = existingroute[0].deliverygroup;
                updatedroute.department_name = existingroute[0].department_name;
                vm.routes = vm.routes.filter(function( obj ) {return obj.deliveryroutes_id !== record.deliveryroutes_id; });
                vm.routes.push(updatedroute);
                /*setTimeout(function () { // wait 0.5 second and reload
                  $state.go($state.current, {}, {reload: true});
                }, 500);*/
                
          });
        }

        function deleteExistRoute(ev, id) {
          var confirm = $mdDialog.confirm(
                    /* Este código seguinte só é preciso para mudar a cor ao botão (para vermelho para remover, por ex.) */
                    {
                        onComplete: function afterShowAnimation() {
                            var $dialog = angular.element(document.querySelector('md-dialog'));
                            var $actionsSection = $dialog.find('md-dialog-actions');
                            var $cancelButton = $actionsSection.children()[0];
                            var $confirmButton = $actionsSection.children()[1];
                            angular.element($confirmButton).addClass('md-raised md-warn');
                            angular.element($cancelButton).addClass('md-primary');
                        }
                    }
                )
                .title('Are you sure?')
                .textContent('Please confirm if you would like to remove this route.')
                .ariaLabel('Remove confirm box')
                .targetEvent(ev)
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('Yes, Remove!')
                .cancel('No, Cancel');
          $mdDialog.show(confirm).then(function() {
                console.log(id);
                deleteRoute(id);
          }, function() {
//            $scope.status = 'You decided to keep your debt.';
          });
        };        

        function deleteRoute(id)
        {          
            console.log("deleteRoute...");
            console.log(id);
            var msg = 'Delivery Route deletion was ';
            api.deliveryroutes.delete({id: id}).$promise.then(function (result) {
                showToast(msg);
                setTimeout(function () { // wait 0.5 second and reload
                  $state.go($state.current, {}, {reload: true});
                }, 500);                
                
          });
        }

        function cancel()
        {
            vm.caixaedicao = 0;
            vm.caixaedicaomulti = 0;
            vm.route = [];
        }

        // vm.total = total;
        // vm.vatamount = vatamount;

        vm.vattotal = function(){
            var rate = vm.route.rate;
            var vat = vm.route.vat;         
            
            if(rate > 0 && vat > 0)
            {
                vm.total = Math.round(rate * (1 + vat / 100) * 100) / 100;
                vm.vatamount = Math.round(rate * (vat / 100) * 100) / 100;
            }else if (rate > 0 && vat === 0){
                vm.total = Math.round(rate * 100) / 100;
                vm.vatamount = 0;
            }          
        };

        vm.totalz = function(){
            var rate = vm.route.rate;
            var vat = vm.route.vat;         
            
            if(rate > 0 && vat > 0)
            {
                return Math.round(rate * (1 + vat / 100) * 100) / 100;
            }else if (rate > 0 && vat === 0){
                return Math.round(rate * 100) / 100;
            }          
        };

        vm.vatamountz = function(){
            var rate = vm.route.rate;
            var vat = vm.route.vat;         
            
            if(rate > 0 && vat > 0)
            {
                return Math.round(rate * (vat / 100) * 100) / 100;
            }else if (rate > 0 && vat === 0){
                return 0;
            }          
        };                

        /* Datatables - Multi Select */
        var selectedRowsIndexes = [];

        $scope.selectRow = function(event, rowIndex) {
            if(event.ctrlKey) {
                changeSelectionStatus(rowIndex);
            } else if(event.shiftKey) {
                selectWithShift(rowIndex);
            } else {
                selectedRowsIndexes = [rowIndex];
            }
            // console.log(selectedRowsIndexes);
            //console.log(getSelectedRows());
            // console.log(getFirstSelectedRow());
            if(getSelectedRows().length > 1){
                vm.caixaedicaomulti = 1;
                vm.caixaedicao = 0;
            }

        };

        function selectWithShift(rowIndex) {
            var lastSelectedRowIndexInSelectedRowsList = selectedRowsIndexes.length - 1;
            var lastSelectedRowIndex = selectedRowsIndexes[lastSelectedRowIndexInSelectedRowsList];
            var selectFromIndex = Math.min(rowIndex, lastSelectedRowIndex);
            var selectToIndex = Math.max(rowIndex, lastSelectedRowIndex);
            selectRows(selectFromIndex, selectToIndex);
        }

        function getSelectedRows() {
            var selectedRows = [];
            angular.forEach(selectedRowsIndexes, function(rowIndex) {
                selectedRows.push(vm.routes[rowIndex]);
            });
            return selectedRows;
        }

        function getFirstSelectedRow() {
            var firstSelectedRowIndex = selectedRowsIndexes[0];
            return vm.routes[firstSelectedRowIndex];
        }

        function selectRows(selectFromIndex, selectToIndex) {
            for(var rowToSelect = selectFromIndex; rowToSelect <= selectToIndex; rowToSelect++) {
                select(rowToSelect);
            }
        }

        function changeSelectionStatus(rowIndex) {
            if($scope.isRowSelected(rowIndex)) {
                unselect(rowIndex);
            } else {
                select(rowIndex);
            }
        }

        function select(rowIndex) {
            if(!$scope.isRowSelected(rowIndex)) {
                selectedRowsIndexes.push(rowIndex);
            }
        }

        function unselect(rowIndex) {
            var rowIndexInSelectedRowsList = selectedRowsIndexes.indexOf(rowIndex);
            var unselectOnlyOneRow = 1;
            selectedRowsIndexes.splice(rowIndexInSelectedRowsList, unselectOnlyOneRow);
        }

        function resetSelection() {
            selectedRowsIndexes = [];
        }

        $scope.isRowSelected = function(rowIndex) {
            return selectedRowsIndexes.indexOf(rowIndex) > -1;
        };

        var finalData;

        function saveRoutes(data){

            // console.log(getSelectedRows());
            // console.log(data);
            var selectedData = getSelectedRows();
            // console.log(selectedData);
            var i;
            var msg;
          
            if (typeof data !== 'undefined') {
                for (i = 0; i < selectedData.length; i++) {
                    if (typeof data.costincrease !== 'undefined' && typeof data.costdecrease === 'undefined') {
                        selectedData[i].rate = selectedData[i].rate * (1 + data.costincrease/100);
                    }                  
                    if (typeof data.costincrease === 'undefined' && typeof data.costdecrease !== 'undefined') {
                        selectedData[i].rate = selectedData[i].rate * (1 - data.costdecrease/100);
                    }
                    if (typeof data.deliverygroups_id !== 'undefined' ) { 
                        selectedData[i].deliverygroups_id = data.deliverygroups_id;
                    }
                    if (typeof data.departments_id !== 'undefined' ) { 
                        selectedData[i].departments_id = data.departments_id;
                    }
                    delete selectedData[i]['deliverygroup'];
                    delete selectedData[i]['days'];
                    delete selectedData[i]['department_name'];
                    delete selectedData[i]['hours'];
                    delete selectedData[i]['route'];
                    delete selectedData[i]['vat'];
                }
            }

            // console.log(selectedData);    
            msg = "Delivery routes saving were ";
            api.deliveryroutes.save({ record: selectedData }).$promise.then(function (result) {
                console.log(result);
                showToast(msg);
                setTimeout(function () { // wait 0.5 second and reload
                  $state.go($state.current, {}, {reload: true});
                }, 500);                
                
            });
        }
        

    }        
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.deliverygroup', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.deliverygroup', {
              url      : '/deliverygroup/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/deliverygroup/deliverygroup.html',
                      controller : 'DeliveryGroupController as vm'
                  }
            },
              resolve  : {
                  DeliveryGroups: function (api, $stateParams)
                  {
                      return api.deliverygroups.get({ id: $stateParams.id }).$promise;
                  }
              },
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/deliverygroup');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.deliverygroup')
        .controller('DeliveryGroupController', DeliveryGroupController);
//        .module('caseType', ['ngMaterial']);

    function DeliveryGroupController($scope, $document, $mdToast, $state, api, DeliveryGroups, $window, $translate, $mdDialog, localStorageService)
    {
        console.log("DeliveryGroup");

        var vm = this;
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
          }
          vm.admin = localStorageService.get('admin');
          vm.levelid = localStorageService.get('levelid');
  
          vm.disabled = false;
  
          /* Verifica se tem permissões de ver e/ou alterar conteúdos */
          if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || vm.privileges[29].privileges.view != '1'){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if((vm.privileges[29].privileges.edit == '0' || vm.privileges[29].privileges.edit == null || vm.privileges[29].privileges.edit == false) && vm.privileges[29].privileges.view == '1'){
                vm.disabled = true;
            }
          }
    
        vm.gotoDeliveryRoute = gotoDeliveryRoute;

        function gotoDeliveryRoute()
        {
            console.log('go DeliveryRoute');
            $state.go('app.deliveryroute');
        }

        vm.groups = DeliveryGroups.records;

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg, state, error) {
            if (typeof(state)==='undefined') state = true;
            if(state == true){
            msg = msg + 'a success!';
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');
            }else if(state == "info"){
              var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(10000)
                .theme("orange")
                .position('top right');
            }else{
            if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
            if (typeof(error)!=='undefined') msg = error;
              var toast = $mdToast.simple()
                  .content(msg)
                  .highlightAction(true)
                  .hideDelay(3000)
                  .theme("error-toast")
                  .position('top right');              
            }
            $mdToast.show(toast); 
        }

        vm.editGroup = editGroup;
        vm.saveExistGroup = saveExistGroup;
        vm.deleteExistGroup = deleteExistGroup;

        function editGroup(id){
            vm.caixaedicao = 1;            
            api.deliverygroups.query({ id: id }).$promise.then(function (result) {
                vm.grupo = result.record;                
            });
        }

        function saveExistGroup(record)
        {          
           console.log("saveExistGroup...");
           console.log(record);
            var msg = 'Delivery group saving was ';
            api.deliverygroups.save({ record: record }).$promise.then(function (result) {
                showToast(msg);
                setTimeout(function () { // wait 0.5 second and reload
                  $state.go($state.current, {}, {reload: true});
                }, 500);                
                
          });
        }

        function deleteExistGroup(ev, id) {
                var confirm = $mdDialog.confirm(
                            /* Este código seguinte só é preciso para mudar a cor ao botão (para vermelho para remover, por ex.) */
                            {
                                onComplete: function afterShowAnimation() {
                                    var $dialog = angular.element(document.querySelector('md-dialog'));
                                    var $actionsSection = $dialog.find('md-dialog-actions');
                                    var $cancelButton = $actionsSection.children()[0];
                                    var $confirmButton = $actionsSection.children()[1];
                                    angular.element($confirmButton).addClass('md-raised md-warn');
                                    angular.element($cancelButton).addClass('md-primary');
                                }
                            }
                        )
                        .title('Are you sure?')
                        .textContent('Please confirm if you would like to remove this delivery group.')
                        .ariaLabel('Remove confirm box')
                        .targetEvent(ev)
                        .clickOutsideToClose(true)
                        .parent(angular.element(document.body))
                        .ok('Yes, Remove!')
                        .cancel('No, Cancel');
                $mdDialog.show(confirm).then(function() {
                        console.log(id);
                        deleteGroup(id);
                }, function() {
        //            $scope.status = 'You decided to keep your debt.';
                });
                };        

                function deleteGroup(id)
                {          
                    console.log("deleteExistGroup...");
                    console.log(id);
                    var msg = 'Delivery group deletion was ';
                    api.deliverygroups.delete({id: id}).$promise.then(function (result) {
                        showToast(msg);
                        setTimeout(function () { // wait 0.5 second and reload
                        $state.go($state.current, {}, {reload: true});
                        }, 500);                
                        
                });
                }                
            }
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.dashboard', ['ngFileUpload'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.dashboard', {
              url      : '/dashboard',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/dashboard/dashboard.html',
                      controller : 'DashboardController as vm'
                  }
              },
              resolve  : {                
                TotalOrders: function (api)
                  {
                  return api.orders.get({ id: 'totalorders' }).$promise;
                  }
                },
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/dashboard');
    }
})();

(function() {
    'use strict';

    angular
        .module('app.dashboard')
        .controller('DashboardController', DashboardController);

    function DashboardController($scope, $document, $state, $window, $mdDialog, $mdToast, $translate, $timeout, TotalOrders, Upload, CONFIG, localStorageService, api, Idle) {
        console.log("DashboardController");

        var vm = this;
        vm.uploadpath = CONFIG.uploadsBaseUrl;
        vm.userid = localStorageService.get('userid');
        vm.username = localStorageService.get('username');

        vm.disabled = false;

        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
          }
        vm.admin = localStorageService.get('admin');
        vm.levelid = localStorageService.get('levelid');

        console.log(vm.privileges);


        vm.totalorders = TotalOrders.totalordersdepartment;

        function showToast(msg, state, error) {
            if (typeof(state)==='undefined') state = true;
            if(state == true){
            msg = msg + 'a success!';
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');
            }else if(state == "info"){
              var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(0)
                .theme("orange")
                .position('top right')
                .action('CLOSE');
            }else{
            if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
            if (typeof(error)!=='undefined') msg = error;
              var toast = $mdToast.simple()
                  .content(msg)
                  .highlightAction(true)
                  .hideDelay(5000)
                  .theme("error-toast")
                  .position('top right');              
            }
            $mdToast.show(toast);
        }        

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }        

        vm.openPopup = function(ev) {            
            $mdDialog.show({
              controller: eval("PopupController"),
              controllerAs: 'octrl',
              templateUrl: 'app/main/pages/dashboard/addlabdoc.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: $scope.customFullscreen 
            });
        };
  
        vm.openPopup.$inject = ['ev'];

        function PopupController($scope, $mdDialog, Upload, $timeout, CONFIG, api) {
            var self = this;
            $scope.userid = vm.userid;
            $scope.username = vm.username;
            
            /* Verifica se tem permissões de ver e/ou alterar conteúdos */
            if(vm.admin != '1' && vm.levelid != '1'){
                if((vm.privileges[10].privileges.edit == '0' || vm.privileges[10].privileges.edit == null || vm.privileges[10].privileges.edit == false)){
                    vm.disabled = true;
                }
            }

            self.disabled = vm.disabled;

            $scope.determinateValue = 0;
            var xz = 0;        
            $scope.$watch('files', function () {
                angular.forEach($scope.files, function(file) {
                    file.counterid = xz;
                    xz++;
                });
                $scope.upload($scope.files);
            });
            $scope.$watch('file', function () {
                if ($scope.file != null) {
                    $scope.files = [$scope.file]; 
                }
            });
            $scope.log = '';
            $scope.upload = function (files) {
                if (files && files.length) {
                    for (var i = 0; i < files.length; i++) {                        
                        var file = files[i];                        
                        if (!file.$error) {                                                    
                            Upload.upload({
                                url: CONFIG.apiBaseUrl + 'LabDoc',
                                data: {
                                    ordernumber: $scope.orderid,
                                    user_id: $scope.userid,
                                    file: file,
                                    counterid: file.counterid   
                                }
                            }).then(function (resp) {
                                // $mdDialog.hide();
                                $scope.files[resp.data.counterid].status = resp.data.status;
                            }, function (error){
                                $scope.files[resp.data.counterid].status = error['status'];
                            }, function (evt) {
                                Idle.unwatch(); /* Interrompe o Sistema de Inatividade */
                                var progressPercentage = parseInt(100.0 *
                                            evt.loaded / evt.total);
                                            $scope.determinateValue = progressPercentage;
                                }
                            );                                                       
                        }                       
                    }
                }
                api.StartWatch(); /* Liga o Sistema de Inatividade */
            }; 
            $scope.cancel = function($event) {
                $mdDialog.cancel();
            };          
        }  

        PopupController.$inject = ['$scope', '$mdDialog', 'Upload', '$timeout', 'CONFIG', 'api'];

        vm.openPage = function(page){
            console.log('go ' + page);
            $state.go('app.'+page);
        }

        vm.gotoGO = gotoGO;
        vm.gotoPlasterRoom = gotoPlasterRoom;
        vm.gotoScanning = gotoScanning;
        vm.gotoPlatforms = gotoPlatforms;
        vm.gotoDesigning = gotoDesigning;
        vm.goto3DManufacturing = goto3DManufacturing;
        vm.gotoMatching = gotoMatching;
        vm.gotoPlanning = gotoPlanning;
        vm.gotoDrillingDesign = gotoDrillingDesign;
        vm.gotoCaseAssessment = gotoCaseAssessment;
        vm.gotoClearMovement = gotoClearMovement;
        vm.gotoBracketMovement = gotoBracketMovement;
        vm.gotoClearManufacturing = gotoClearManufacturing;
        vm.gotoInmanCaseAssess = gotoInmanCaseAssess;
        vm.gotoMovement = gotoMovement;
        vm.gotoInmanManufacturing = gotoInmanManufacturing;
        vm.gotoWaiting = gotoWaiting;
        vm.gotoPackaging = gotoPackaging;
        vm.gotoShipping = gotoShipping;

        vm.gotoDLD = gotoDLD;

        vm.gotoInvoice = gotoInvoice;
        vm.gotoInvoiceSearch = gotoInvoiceSearch;
        vm.gotoClientStatus = gotoClientStatus;
        vm.gotoReports = gotoReports;
        vm.gotoOrderStatus = gotoOrderStatus;
        vm.gotoProfiles = gotoProfiles;
        vm.gotoDeliveryRoutes = gotoDeliveryRoutes;
        vm.gotoEventsTasks = gotoEventsTasks;
        vm.gotoProductsGroups = gotoProductsGroups;
        vm.gotoProducts = gotoProducts;
        vm.gotoConsolidation = gotoConsolidation;
        vm.gotoFinances = gotoFinances;
        vm.gotoScheduling = gotoScheduling;
        vm.gotoHolidays = gotoHolidays;
        vm.gotoMembers = gotoMembers;
        vm.gotoCheckinout = gotoCheckinout;
        vm.gotoCheckinoutSystem = gotoCheckinoutSystem;
        vm.gotoRD = gotoRD;
        

        function gotoGO() {
            console.log('go go');
            $state.go('app.production', { 'id': '', 'module' : 'GenerateOrder'});
        }

        function gotoPlasterRoom() {
            console.log('go plaster-room');
            $state.go('app.production', { 'id': '', 'module' : 'PlasterRoom'});
        }                 

        function gotoScanning() {
            console.log('go scanning');
            $state.go('app.production', { 'id': '', 'module' : 'Scanning'});
        }
        
        function gotoPlatforms() {
            console.log('go platforms');
            $state.go('app.production', { 'id': '', 'module' : 'Platforms'});
        }
        
        function gotoDesigning() {
            console.log('go designing');
            $state.go('app.production', { 'id': '', 'module' : 'Designing'});
        }
        
        function goto3DManufacturing() {
            console.log('go 3DManufacturing');
            $state.go('app.production', { 'id': '', 'module' : 'Manufacturing'});
        }
        
        function gotoMatching() {
            console.log('go Matching');
            $state.go('app.production', { 'id': '', 'module' : 'Matching'});
        }
        
        function gotoPlanning() {
            console.log('go Planning');
            $state.go('app.production', { 'id': '', 'module' : 'Planning'});
        }
        
        function gotoDrillingDesign() {
            console.log('go DrillingDesign');
            $state.go('app.production', { 'id': '', 'module' : 'DrillingDesign'});
        }
        
        function gotoCaseAssessment() {
            console.log('go CaseAssessment');
            $state.go('app.production', { 'id': '', 'module' : 'CaseAssessment'});
        }
        
        function gotoClearMovement() {
            console.log('go ClearMovement');
            $state.go('app.production', { 'id': '', 'module' : 'ClearMovement'});
        }
        
        function gotoBracketMovement() {
            console.log('go bracketmovement');
            $state.go('app.production', { 'id': '', 'module' : 'BracketMovement'});
        }
        
        function gotoClearManufacturing() {
            console.log('go ClearManufacturing');
            $state.go('app.production', { 'id': '', 'module' : 'ClearManufacturing'});
        }
        
        function gotoInmanCaseAssess() {
            console.log('go InmanCaseAssess');
            $state.go('app.production', { 'id': '', 'module' : 'InmanCaseAssessment'});
        }
        
        function gotoMovement() {
            console.log('go Movement');
            $state.go('app.production', { 'id': '', 'module' : 'Movement'});
        }
        
        function gotoInmanManufacturing() {
            console.log('go InmanManufacturing');
            $state.go('app.production', { 'id': '', 'module' : 'InmanManufacturing'});
        }
        
        function gotoWaiting() { 
            console.log('go Waiting');
            $state.go('app.production', { 'id': '', 'module' : 'Waiting'});
        }
        
        function gotoPackaging() {
            console.log('go Packaging');
            $state.go('app.production', { 'id': '', 'module' : 'Packaging'});
        }
        
        function gotoShipping() {
            console.log('go Shipping');
            $state.go('app.production', { 'id': '', 'module' : 'Shipping'});
        }

        function gotoDLD() {
            console.log('go DLD');
            $state.go('app.dld');
        }


        function gotoInvoice() {
            console.log('go Invoice');
            $state.go('app.invoice');
        }
        function gotoInvoiceSearch() {
            console.log('go InvoiceSearch');
            $state.go('app.invoicesearch');
        }
        function gotoClientStatus() {
            console.log('go ClientStatus');
            $state.go('app.clientstatus');
        }
        function gotoReports() {
            console.log('go Reports');
            $state.go('app.reports');
        }
        function gotoOrderStatus() {
            console.log('go OrderStatus');
            $state.go('app.orderstatus');
        }
        function gotoProfiles() {
            console.log('go Profiles');
            $state.go('app.profiles');
        }
        function gotoDeliveryRoutes() {
            console.log('go DeliveryRoutes');
            $state.go('app.deliveryroute');
        }

        function gotoEventsTasks() {
            console.log('go EventsTasks');
            /*$state.go('app.scrumboard.boards.board', { 'id': '27cfcbe1', 'uri': 'marketing-application' });*/
            $state.go('app.marketing');
        }

        function gotoProductsGroups() {
            console.log('go ProductsGroups');
            $state.go('app.productsgroups');
        }

        function gotoProducts() {
            console.log('go Products');
            $state.go('app.products');
        }

        function gotoConsolidation() {
            console.log('go Consolidation');
            $state.go('app.consolidation');
        }

        function gotoFinances() {
            console.log('go Finances');
            $state.go('app.finances');
        }

        function gotoScheduling() {
            console.log('go Scheduling');
            $state.go('app.scheduling');
        }

        function gotoHolidays() {
            console.log('go Holidays');
            $state.go('app.holidays');
        }

        function gotoMembers() {
            console.log('go Members');
            $state.go('app.members');
        }

        function gotoCheckinout() {
            console.log('go Check In Out');
            $state.go('app.checkinout');
        }

        function gotoCheckinoutSystem() {
            console.log('go Check In Out - System');
            $state.go('app.checkinoutsystem');
        }

        function gotoAnalyticsPoints() {
            console.log('go Analytics Points');
            $state.go('app.analyticspoints');
        }

        function gotoRD(){
            console.log('go RD');
            $state.go('app.researchd');
        }
    }
    DashboardController.$inject = ['$scope', '$document', '$state', '$window', '$mdDialog', '$mdToast','$translate', '$timeout', 'TotalOrders','Upload', 'CONFIG', 'localStorageService','api', 'Idle'];

})();
(function ()
{
    'use strict';

    angular
        .module('app.consolidationsearch', ['ngMask'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.consolidationsearch', {
              url      : '/consolidationsearch/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/consolidationsearch/consolidationsearch.html',
                      controller : 'ConsolidationSearchController as vm'
                  }
              },
              resolve  : {
                OrdersStatus: function (api)
                    {
                        return api.orders.get({id: 'orderstatus'}).$promise;
                    },
                },
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/consolidationsearch');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.consolidationsearch')
        .controller('ConsolidationSearchController', ConsolidationSearchController)
        .factory('postService', function($http, CONFIG) {
            var postService = {
              async: function(controller, id, registo) {                  
                // $http returns a promise, which has a then function, which also returns a promise
                var promise = $http({
                  method: 'POST',
                  data: registo,    
                  url: CONFIG.apiBaseUrl + controller + '/' + id
                }).then(function (response) {
                  // The then function here is an opportunity to modify the response
                  console.log(response);
                  // The return value gets picked up by the then in the controller.
                  return response.data;
                });
                // Return the promise to the controller
                return promise;
              }
            };
            console.log("vamos ver o que passa");
            console.log(registo);
            return postService;
          });

    function ConsolidationSearchController($scope, $document, $state, $window, $translate, $http, api, localStorageService, OrdersStatus, DTOptionsBuilder, DTColumnBuilder, CONFIG, postService, $mdToast,$location)
    {
        console.log("ConsolidationSearchController");

        var vm = this;

        vm.baseurl = $window.location.origin;
        if(vm.baseurl == "http://localhost:3000"){
          vm.baseurl = "https://nimrodtrac.app";
        }

        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
          }
          vm.admin = localStorageService.get('admin');
          vm.levelid = localStorageService.get('levelid');
  
          vm.disabled = false;
  
          /* Verifica se tem permissões de ver e/ou alterar conteúdos */
          if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || vm.privileges[25].privileges.view != '1'){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if((vm.privileges[25].privileges.edit == '0' || vm.privileges[25].privileges.edit == null || vm.privileges[25].privileges.edit == false) && vm.privileges[25].privileges.view == '1'){
                vm.disabled = true;
            }
          }

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg, state, error) {
            if (typeof(state)==='undefined') state = true;
            if(state == true){
            msg = msg + 'a success!';
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');
            }else if(state == "info"){
              var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(10000)
                .theme("orange")
                .position('top right');
            }else{
            if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
            if (typeof(error)!=='undefined') msg = error;
              var toast = $mdToast.simple()
                  .content(msg)
                  .highlightAction(true)
                  .hideDelay(3000)
                  .theme("error-toast")
                  .position('top right');              
            }
            $mdToast.show(toast); 
          }

        vm.onstoporders = OrdersStatus.onstoporders;
        vm.dueorders = OrdersStatus.dueorders;
        vm.approvedvia = OrdersStatus.approvedvia;
        vm.approvedwaiting = OrdersStatus.approvedwaiting;
        vm.waitingcall = OrdersStatus.waitingcall;
        vm.waitingimpression = OrdersStatus.waitingimpression;
        vm.inactiveorders = OrdersStatus.inactiveorders;        
        vm.numcompleted = OrdersStatus.numcompleted;
        vm.total = OrdersStatus.total.count;

        vm.gotoOrderStatus = function()
        {
            console.log('go OrderStatus');
            $state.go('app.orderstatus');
        } 
        
        vm.gotoConsolidation = function()
        {
            console.log('go Consolidation');
            $state.go('app.consolidation');
        }    
        
        function downloadFile(url, success) {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.setRequestHeader("Authorization", 'Bearer ' + localStorageService.get('token'));
            xhr.responseType = "blob";
            xhr.onreadystatechange = function() {
                if (xhr.readyState == 4) {
                    if (success) success(xhr.response);
                }
            };
            xhr.send(null);
        }

        vm.dtInstance = {};
        var numcolunas = 7;

        console.log(vm.onDate);

        vm.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('ajax', {
            url: CONFIG.apiBaseUrl + 'Invoice/consolidationsearch',
            type: 'POST',
            "dataSrc": function(json) {
                if(json.status && json.status == "login"){
                    $mdDialog.hide();
                    var infor = "Your login has expired. Please login again.";
                    showToast(infor, "info");
                    $location.path('/login');
                }else{
                console.log(json);
                return json.data;
                }
            },
            "data": function(d){
                for (var i = 0; i < numcolunas; ++i) {
                  var f = "d.columns["+i+"].search.value = self.search"+i+";";
                  eval(f);
                }
                console.log(d);
            },
            "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
        })
        .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
        .withDataProp('data')
        .withOption('processing', true)
        .withOption('serverSide', true)
        .withOption('filter', false)
        .withOption('bLengthChange', true)
        .withOption('bSort', false)
        .withOption('responsive',false)
        .withPaginationType('full_numbers')
        .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $('td', nRow).unbind('click');
          $('td', nRow).bind('click', function() {
              $scope.$apply(function() {
                return nRow;
                });                      
              });
          })
        .withOption('order', [])        
        .withOption('initComplete', function(){
            var api = this.api();

            vm.totalRecords = api.page.info().recordsTotal;
            vm.totalRecordsFiltered = api.page.info().recordsDisplay;

            vm.searchTable = function(searchText, column){
                var f = "self.search"+column+" = searchText;";
                eval(f);
                vm.dtInstance.DataTable.search(searchText).draw();
            } 

            vm.exportIDH = function(){
                console.log(vm.search);
                console.log("vamos exportar IDH....");
                var id = "idhexport";
                var msg = "IDH Export was ";
                $http({
                    method: 'POST',
                    data: vm.search,    
                    url: CONFIG.apiBaseUrl + "Invoice" + '/' + id
                  }).then(function (d) {
                    console.log(d.data);
                    var r = d.data;
                    if(r.status == "success"){
                        if(r.file){                        
                            downloadFile(vm.baseurl+'/api/Dlfile?type=csv&name='+r.file, function(blob) {
                            var downloadUrl = window.URL.createObjectURL(blob);
                            var downloadLink = document.createElement('a');
                            downloadLink.href = downloadUrl;
                            downloadLink.target = "_blank";
                            downloadLink.download = r.file;
                            document.body.appendChild(downloadLink);
                            downloadLink.click();
                            setTimeout(function() {
                                if (window.navigator && window.navigator.msSaveOrOpenBlob) { /* IE 11 */
                                    window.navigator.msSaveOrOpenBlob(downloadUrl);
                                }else{
                                    window.URL.revokeObjectURL(downloadUrl);
                                }
                            }, 100);
                            });              
                        }
                        showToast(msg);
                    }else if(r.status == "erro"){
                        showToast(msg, false, r.erro);
                    }else{
                        showToast(msg, false);
                    }
                  });                                      
            }

            vm.exportSage = function(){
                console.log(vm.search);
                console.log("vamos exportar Sage....");
                var id = "sageexport";
                var msg = "Sage Export was ";
                $http({
                    method: 'POST',
                    data: vm.search,    
                    url: CONFIG.apiBaseUrl + "Invoice" + '/' + id
                  }).then(function (d) {
                    console.log(d.data);
                    var r = d.data;
                    if(r.status == "success"){
                        if(r.file){                        
                            downloadFile(vm.baseurl+'/api/Dlfile?type=csv&name='+r.file, function(blob) {
                            var downloadUrl = window.URL.createObjectURL(blob);
                            var downloadLink = document.createElement('a');
                            downloadLink.href = downloadUrl;
                            downloadLink.target = "_blank";
                            downloadLink.download = r.file;
                            document.body.appendChild(downloadLink);
                            downloadLink.click();
                            setTimeout(function() {
                                if (window.navigator && window.navigator.msSaveOrOpenBlob) { /* IE 11 */
                                    window.navigator.msSaveOrOpenBlob(downloadUrl);
                                }else{
                                    window.URL.revokeObjectURL(downloadUrl);
                                }
                            }, 100);
                            });              
                        }
                        showToast(msg);
                    }else if(r.status == "erro"){
                        showToast(msg, false, r.erro);
                    }else{
                        showToast(msg, false);
                    }
                  });
                /* OLD - Not Working anymore */
                /*postService.async("Invoice", id, vm.search).then(function(d) {
                    if(d.status == "success"){
                        if(d.file){                        
                            downloadFile(vm.baseurl+'/api/Dlfile?type=csv&name='+d.file, function(blob) {
                            var downloadUrl = window.URL.createObjectURL(blob);
                            var downloadLink = document.createElement('a');
                            downloadLink.href = downloadUrl;
                            downloadLink.target = "_blank";
                            downloadLink.download = d.file;
                            document.body.appendChild(downloadLink);
                            downloadLink.click();
                            setTimeout(function() {
                                if (window.navigator && window.navigator.msSaveOrOpenBlob) { /* IE 11
                                    window.navigator.msSaveOrOpenBlob(downloadUrl);
                                }else{
                                    window.URL.revokeObjectURL(downloadUrl);
                                }
                            }, 100);
                            });              
                        }
                        showToast(msg);
                    }else if(d.status == "erro"){
                        showToast(msg, false, d.erro);
                    }else{
                        showToast(msg, false);
                    }
                });*/                                      
            }
            
            vm.reset = function(){
                vm.search.startDate = undefined;
                vm.search.endDate = undefined;
                vm.search.onDate = undefined;
                vm.search.practicenumber = undefined;
                vm.search.practicenumberonly = undefined;
                for (var i = 0; i < numcolunas; ++i) {
                  var f = "self.search"+i+" = undefined;";
                  eval(f);
                }
                vm.dtInstance.reloadData(null, true);                      
            }            
            
        })
        .withLanguage({
            "sInfo": 'Info',
            "paginate": {
                "first": 'First',
                "last": 'Last',
                "next": 'Next',
                "previous": 'Previous'
            }
        });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(0).withTitle('Creation Date'),
            DTColumnBuilder.newColumn(1).withTitle('Start Date').notVisible(),
            DTColumnBuilder.newColumn(2).withTitle('End Date').notVisible(),
            DTColumnBuilder.newColumn(3).withTitle('Invoices Quantity'),
            DTColumnBuilder.newColumn(4).withTitle('Total Cost'),
            DTColumnBuilder.newColumn(5).withTitle('Practice Number').notVisible(),
            DTColumnBuilder.newColumn(6).withTitle('Practice Number Only').notVisible()
        ]
    }

ConsolidationSearchController.$inject = ['$scope', '$document', '$state', '$window', '$translate', '$http', 'api', 'localStorageService', 'OrdersStatus', 'DTOptionsBuilder', 'DTColumnBuilder', 'CONFIG', 'postService', '$mdToast','$location'];
    
})();    
(function ()
{
    'use strict';

    angular
        .module('app.consolidation', ['ngMask'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.consolidation', {
              url      : '/consolidation/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/consolidation/consolidation.html',
                      controller : 'ConsolidationController as vm'
                  }
                },
                resolve  : {
                    Orders: function (api)
                        {
                            return api.orders.get({id: 'orderstatus'}).$promise;
                        },
                    DeliveryRoutes: function (api, $stateParams)
                        {
                            return api.deliveryroutes.get({ id: $stateParams.id }).$promise;
                        }
                },                
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/consolidation');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.consolidation')
        .controller('ConsolidationController', ConsolidationZController)
        .factory('getService', function($http, CONFIG) {
            var getService = {
              async: function(controller, id, cache) {
                /* $http returns a promise, which has a then function, which also returns a promise */
                var promise = $http({
                  cache: cache,
                  method: 'GET',    
                  url: CONFIG.apiBaseUrl + controller + '/' + id
                }).then(function (response) {
                  /* The then function here is an opportunity to modify the response */
                  console.log(response);
                  /* The return value gets picked up by the then in the controller. */
                  return response.data;
                });
                /* Return the promise to the controller */
                return promise;
              }
            };
            return getService;
          });

    function ConsolidationZController($scope, $document, $state, $window, $translate, $timeout, api, $mdToast, $mdDialog, postService, Orders, DeliveryRoutes, localStorageService, DTOptionsBuilder, DTColumnBuilder, CONFIG, $location, $http, getService)
    {
        console.log("ConsolidationController");

        var vm = this;

        vm.baseurl = $window.location.origin;
        if(vm.baseurl == "http://localhost:3000"){
          vm.baseurl = "https://nimrodtrac.app";
        }
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
          }
          vm.admin = localStorageService.get('admin');
          vm.levelid = localStorageService.get('levelid');
  
          vm.disabled = false;
  
          /* Verifica se tem permissões de ver e/ou alterar conteúdos */
          if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || vm.privileges[25].privileges.view != '1'){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if((vm.privileges[25].privileges.edit == '0' || vm.privileges[25].privileges.edit == null || vm.privileges[25].privileges.edit == false) && vm.privileges[25].privileges.view == '1'){
                vm.disabled = true;
            }
          }

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg, state, error) {
            if (typeof(state)==='undefined') state = true;
            if(state == true){
            msg = msg + 'a success!';
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');
            }else if(state == "info"){
              var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(0)
                .theme("orange")
                .position('top right');
            }else{
            if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
            if (typeof(error)!=='undefined') msg = error;
              var toast = $mdToast.simple()
                  .content(msg)
                  .highlightAction(true)
                  .hideDelay(0)
                  .theme("error-toast")
                  .position('top right')
                  .action('CLOSE');             
            }
            $mdToast.show(toast); 
          }

        vm.userid = localStorageService.get('userid');        

        vm.onstoporders = Orders.onstoporders;
        vm.dueorders = Orders.dueorders;
        vm.approvedvia = Orders.approvedvia;
        vm.approvedwaiting = Orders.approvedwaiting;
        vm.waitingcall = Orders.waitingcall;
        vm.waitingimpression = Orders.waitingimpression;
        vm.inactiveorders = Orders.inactiveorders;        
        vm.numcompleted = Orders.numcompleted;
        vm.total = Orders.total.count;

        vm.deliveries = DeliveryRoutes.records;

        vm.gotoOrderStatus = function()
        {
            console.log('go OrderStatus');
            $state.go('app.orderstatus');
        }
        // function goToConsolidation()
        // {
        //     console.log('go Consolidation');
        //     $state.go('app.consolidation');
        // }
        vm.gotoConsolidationSearch = function()
        {
            console.log('go ConsolidationSearch');
            $state.go('app.consolidationsearch');
        }

        function downloadFile(url, success) {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.setRequestHeader("Authorization", 'Bearer ' + localStorageService.get('token'));
            xhr.responseType = "blob";
            xhr.onreadystatechange = function() {
                if (xhr.readyState == 4) {
                    if (success) success(xhr.response);
                }
            };
            xhr.send(null);
        }
        
        vm.dtInstance = {};
        vm.type = 1;
        var itemabrir = [];
        var itemdata = {};
        var consolidatedata = {};
        var consolidate = [];
        var numcolunas = 19;
        $scope.numorders = 0;

        vm.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('ajax', {
            url: CONFIG.apiBaseUrl + 'Orders/'+vm.type+'consolidationinfo',
            type: 'POST',
            "dataSrc": function(json) {
                if(json.status && json.status == "login"){
                    $mdDialog.hide();
                    var infor = "Your login has expired. Please login again.";
                    showToast(infor, "info");
                    $location.path('/login');
                  }else{
                      console.log(json);
                      return json.data;
                  }
            },
            "data": function(d){
                for (var i = 1; i < numcolunas; ++i) {
                  var f = "d.columns["+i+"].search.value = self.search"+i+";";
                  eval(f);
                }
                console.log(d);
                
            },
            "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
        })
        .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
        .withDataProp('data')
        .withOption('processing', true)
        .withOption('serverSide', true)
        .withOption('filter', false)
        .withOption('bLengthChange', true)
        .withOption('bSort', false)
        .withOption('responsive',false)
        .withPaginationType('full_numbers')
        .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $('td', nRow).css('cursor', 'pointer');
          $('td', nRow).unbind('click');
          $('td', nRow).bind('click', function() {
              $scope.$apply(function() {
                if(vm.type == 1 || vm.type == 2){  
                    /* Open Order */                
                    itemdata = {
                        orders_id: aData[0],
                        department_alias: aData[1],
                        departments_id: aData[2]
                    }
                    var verifica = 0;
                    angular.forEach(itemabrir, function(item) {
                        if(item.orders_id==aData[0]){
                            verifica = 1;                            
                            $(nRow).removeClass('highlitedRow');
                            itemabrir = itemabrir.filter(function( obj ) {return obj.orders_id !== aData[0]; });
                        } 
                    });
                    if(verifica == 0){
                        itemabrir.push(itemdata);
                        $(nRow).addClass('highlitedRow');
                    }
                    vm.itemabrir = itemabrir;
                    //console.log(vm.itemabrir);
                    /* FIM Open Order */
                }else if (vm.type == 3){
                    /* Consolidate Order */
                    var vclientes = 0;
                    var vcliente = 0;
                    var verificao = 0;
                    consolidate = vm.consolidate;                    
                    angular.forEach(consolidate, function(item, key) {
                        vclientes = 1;
                        if(item.clients_id==aData[16]){
                            vcliente = 1;
                            angular.forEach(item.orders_id, function(order) {
                                if(order==aData[0]){
                                    verificao = 1;                                                           
                                    $(nRow).removeClass('highlitedRow');
                                    $scope.numorders -= 1;
                                    item.orders_id = item.orders_id.filter(function( obj ) {return obj !== aData[0]; });
                                }                            
                            });
                            if(verificao == 1){
                                consolidate[key].orders_id = item.orders_id;
                            }else{
                                consolidate[key].orders_id.push(aData[0]);
                                $(nRow).addClass('highlitedRow');
                                $scope.numorders += 1; 
                            }
                        }                     
                    });            
                    if(vclientes == 0 || vcliente == 0){
                        consolidatedata = {
                            clients_id: aData[16],
                            orders_id: [
                                aData[0]
                            ]
                        }
                        consolidate.push(consolidatedata);
                        $(nRow).addClass('highlitedRow');
                        $scope.numorders += 1; 
                    }
                    vm.consolidate = consolidate;
                    console.log(vm.consolidate);
                    /* FIM Consolidate Order */
                }
                return nRow;
                });                      
              });
          })
        .withOption('order', [])        
        .withOption('initComplete', function(){
            var api = this.api();

            vm.totalRecords = api.page.info().recordsTotal;
            vm.totalRecordsFiltered = api.page.info().recordsDisplay;
            

            vm.searchTable = function(searchText, column){
                var f = "self.search"+column+" = searchText;";
                eval(f);
                vm.dtInstance.DataTable.search(searchText).draw();                  
            } 
            
            vm.reset = function(){
                vm.search = [];
                vm.startDate = undefined;
                vm.endDate = undefined;
                vm.onDate = undefined;
                for (var i = 1; i < numcolunas; ++i) {
                  var f = "self.search"+i+" = undefined;";
                  eval(f);
                }
                vm.dtInstance.reloadData(null, true);                      
            }
            
            vm.changeType = function(type){                
                $('table tr').removeClass('highlitedRow');
                consolidatedata = {};
                consolidate = [];
                vm.consolidate = [];
                $scope.numorders = 0;
                vm.reset();
                itemabrir = [];
                vm.itemabrir = [];
                vm.type = type;
                var newurl = CONFIG.apiBaseUrl + 'Orders/'+vm.type+'consolidationinfo';                
                $timeout( function(){                    
                    vm.dtInstance.DataTable.ajax.url(newurl).load();                    
                }, 100 );    
                $timeout( function(){                    
                    vm.totalRecordsFiltered = api.page.info().recordsDisplay;
                    console.log(vm.totalRecordsFiltered);                    
                }, 500 );  
                
                
            }

            vm.selectAll = function(){
                $('table tbody tr').removeClass('highlitedRow');
                vm.consolidate = [];                
                $scope.numorders = vm.totalRecordsFiltered;
                var consolidatedata = {};
                var consolidate = []; 
                angular.forEach(vm.dtInstance.DataTable.rows().data(), function(item){
                    vm.consolidate = selectItem(item[0], item[16]);                                        
                });
                consolidate = vm.consolidate;
                $('table tbody tr').addClass('highlitedRow');
                console.log(vm.consolidate);                
            }

            vm.deselectAll = function(){
                $('table tbody tr').removeClass('highlitedRow');
                vm.consolidate = [];                
                $scope.numorders = 0;
                var consolidatedata = {};
                var consolidate = [];           
            }
            
        })
        .withLanguage({
            "sInfo": 'Info',
            "paginate": {
                "first": 'First',
                "last": 'Last',
                "next": 'Next',
                "previous": 'Previous'
            }
        });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(0).withTitle('Order ID').notVisible(),
            DTColumnBuilder.newColumn(1).withTitle('Department Alias').notVisible(),
            DTColumnBuilder.newColumn(2).withTitle('Departments ID ').notVisible(),
            DTColumnBuilder.newColumn(3).withTitle('Client Number'),
            DTColumnBuilder.newColumn(4).withTitle('Client Name'),
            DTColumnBuilder.newColumn(5).withTitle('Order Number'),
            DTColumnBuilder.newColumn(6).withTitle('Practice Name'),
            DTColumnBuilder.newColumn(7).withTitle('Delivery Route'),
            DTColumnBuilder.newColumn(8).withTitle('Date'),
            DTColumnBuilder.newColumn(9).withTitle('Delivery Date'),
            DTColumnBuilder.newColumn(10).withTitle('Patient Name/Ref'),
            DTColumnBuilder.newColumn(11).withTitle('Postcode'),
            DTColumnBuilder.newColumn(12).withTitle('Cost'),  
            DTColumnBuilder.newColumn(13).withTitle('Start Date').notVisible(),
            DTColumnBuilder.newColumn(14).withTitle('End Date').notVisible(),
            DTColumnBuilder.newColumn(15).withTitle('Delivery ID').notVisible(),   
            DTColumnBuilder.newColumn(16).withTitle('Clients ID').notVisible(),
            DTColumnBuilder.newColumn(17).withTitle('Practice Number').notVisible(),
            DTColumnBuilder.newColumn(18).withTitle('Practice Number')
        ]

        function selectItem(ordersid, clientsid){
            var vclientes = 0;
            var vcliente = 0;
            var verificao = 0;
            var consolidate = vm.consolidate;
            angular.forEach(consolidate, function(item, key) {
                vclientes = 1;
                if(item.clients_id==clientsid){
                    vcliente = 1;
                    angular.forEach(item.orders_id, function(order) {
                        if(order==ordersid){
                            verificao = 1;                                                           
                            // $scope.numorders -= 1;
                            // item.orders_id = item.orders_id.filter(function( obj ) {return obj !== ordersid; });
                        }                            
                    });
                    if(verificao == 1){
                        consolidate[key].orders_id = item.orders_id;
                    }else{
                        consolidate[key].orders_id.push(ordersid);
                        // $(nRow).addClass('highlitedRow');
                        // $scope.numorders += 1; 
                    }
                }                                     
            });   

            if(vclientes == 0 || vcliente == 0){
                consolidatedata = {
                    clients_id: clientsid,
                    orders_id: [
                        ordersid
                    ]
                }
                consolidate.push(consolidatedata);
                // $(nRow).addClass('highlitedRow');
                // $scope.numorders += 1; 
            }
            return consolidate;                       
        }

        vm.gravar = function(gravar) {                
            var record = {};
            var departmentin = gravar[0].department_alias;
            var departmentsid = gravar[0].departments_id;
            if (typeof gravar !== 'undefined') {
                for (var i = 0; i < gravar.length; i++) {                          
                    record[i] = {
                        orders_opened_id: 0,
                        orders_id: gravar[i].orders_id,
                        users_id: vm.userid,
                        departments_id: departmentsid
                    }
                }
                gravar = record;
                console.log(gravar);
                $mdDialog.hide();
                var msg = "Order opening was ";
                var orderid = vm.id;
                api.ordersopened.save({ record: record, orderid: orderid }).$promise.then(function (result) { 
                    console.log(result); 
                    if(result.status !== 'success'){ 
                        showToast(msg, false) 
                    }else{ 
                        showToast(msg);
                        var url = $state.href('app.production', {'id': record[0].orders_id, 'module' : departmentin});                            
                        $window.open(url, '_blank');
                    } 
                }, function(error) { 
                    var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                    showToast(msg, false, erro); 
                });
            }
        } 

        vm.consolidateFunction = function(info){
            console.log("vamos consolidar....");
            var infor = "Consolidation in progress. Please wait...";
            showToast(infor, "info");
            var id = "COIO";
            var promise = $http({
                method: 'POST',
                data: info,
                url: CONFIG.apiBaseUrl + 'Invoice' + '/' + id
              }).then(function (d) {
                if(d.data.status == "success"){
                    if(d.data.allinoneprint){       
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            /* IE 11 */
                            downloadFile(vm.baseurl+'/api/Dlfile?type=invoices&name='+d.data.allinoneprint, function(blob) {
                            window.navigator.msSaveOrOpenBlob(blob);
                            });                
                        }else{              
                            /* Chrome e Firefox */
                            var win = window.open('_blank');
                            downloadFile(vm.baseurl+'/api/Dlfile?type=invoices&name='+d.data.allinoneprint, function(blob) {
                                var url = URL.createObjectURL(blob);
                                win.location = url;
                            });
                        }            
                    }
                    vm.changeType(3);
                    var msg = "Consolidate was ";
                    showToast(msg);
                  }else{
                    var erro = (d.data.erro) ? d.data.erro : "Error!";
                    if(d.data.invoices > 0){ vm.changeType(3) };
                    if(d.data.invoicenumbers){
                        angular.forEach(d.data.invoicenumbers, function(invoicenumber){
                            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                                /* IE 11 */
                                downloadFile(vm.baseurl+'/api/Dlfile?type=invoice&name='+invoicenumber, function(blob) {
                                window.navigator.msSaveOrOpenBlob(blob);
                                });                
                            }else{              
                                /* Chrome e Firefox */
                                var win = window.open('_blank');
                                downloadFile(vm.baseurl+'/api/Dlfile?type=invoice&name='+invoicenumber, function(blob) {
                                    var url = URL.createObjectURL(blob);
                                    win.location = url;
                                });
                            }
                        });                    
                    }
                    showToast(msg, false, erro);
                  }
                });
        }

    }

ConsolidationZController.$inject = ['$scope', '$document', '$state', '$window', '$translate', '$timeout', 'api', '$mdToast', '$mdDialog', 'postService','Orders', 'DeliveryRoutes', 'localStorageService', 'DTOptionsBuilder', 'DTColumnBuilder', 'CONFIG', '$location', '$http', 'getService'];
    
})();    
(function ()
{
    'use strict';

    angular
        .module('app.clientstatus', ['ngMask'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        console.log("clientstatus module"); 
        $stateProvider
          .state('app.clientstatus', {
              url      : '/Invoicing/ClientStatus/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/clientstatus/clientstatus.html',
                      controller : 'ClientStatusController as vm'
                  }
              },
              resolve  : {                
                Orders: function (api)
                {
                    return api.orders.get({id: 'ordersinfo'}).$promise;
                }, 
                OrdersStatusTotal: function (api)
                {
                    return api.orders.get({id: 'orderstatus'}).$promise;
                },                          
              },             
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/clientstatus');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.clientstatus')
        .controller('ClientStatusController', ClientStatusController)
        .filter('dateRange', function() {
          return function( items, fromDate, toDate ) {
              function switchdaymonth(dateBefore){
                var chunks = dateBefore.split('/');                
                return chunks[1]+'/'+chunks[0]+'/'+chunks[2];
              }
              var filtered = [];
              var from_date = fromDate != undefined ? new Date(switchdaymonth(fromDate)) : 0;
              var to_date = toDate != undefined ? new Date(switchdaymonth(toDate)) : 0;
               if(fromDate != undefined && toDate == undefined){                
                angular.forEach(items, function(item) {
                    var data1 = new Date(item.datereceived);
                    if(data1 != null) {
                        data1.setHours(0);
                        data1.setMinutes(0);
                        data1.setSeconds(0);
                        data1.setMilliseconds(0);
                    }
                    if(data1 >= from_date) { 
                        filtered.push(item);
                    }
                });
                return filtered;
              }
              else if(fromDate == undefined && toDate != undefined){
                angular.forEach(items, function(item) {
                    var data1 = new Date(item.datereceived);
                    if(data1 != null) {
                        data1.setHours(0);
                        data1.setMinutes(0);
                        data1.setSeconds(0);
                        data1.setMilliseconds(0);
                    }
                    if(data1 <= to_date) {                      
                        filtered.push(item);
                    }
                });
                return filtered;
              }else if(fromDate != undefined && toDate != undefined){
                angular.forEach(items, function(item) {
                    var data1 = new Date(item.datereceived);
                    if(data1 != null) {
                        data1.setHours(0);
                        data1.setMinutes(0);
                        data1.setSeconds(0);
                        data1.setMilliseconds(0);
                    }
                    if(data1 >= from_date && data1 <= to_date) {                      
                        filtered.push(item);
                    }
                });
                return filtered;                
              }else if(fromDate == undefined && toDate == undefined){
                return items;
              }
          };
      })
      .directive('scanOrder', function($timeout, $q, CONFIG, $http, $state, $mdDialog, api, localStorageService, $window) {
        return {
          restrict: 'AE',
          require: 'ngModel',
          link: function($scope, elm, attr, model) { 
            model.$asyncValidators.orderExists = function(modelValue, viewValue) {
              var valuez = modelValue || viewValue;
              var value = valuez.substr(1);                           
                return $http.get(CONFIG.apiBaseUrl + 'Orders/con' + value).
                   then(function (response) {
                     console.log(response.data.status);
                     if(response.data.status == "success"){
                        model.$setValidity('erro', true);
                        $mdDialog.cancel();
                        var orderid = response.data.orderid.orders_id;
                        var userid = localStorageService.get('userid');
                        var department_alias = response.data.orderid.department_alias;
                        /*var department_id = response.data.orderid.departments_id;
                        var record = {};                      
                        record = {
                            orders_opened_id: 0,
                            orders_id: orderid,
                            users_id: userid,
                            departments_id: department_id,
                            dld: 1
                        }           
                        api.ordersopened.save({ record: record, orderid: orderid });*/
                        $timeout( function(){
                            var url = $state.href('app.production', {id: orderid, module: department_alias});
                            $window.open(url, '_blank');
                        }, 200 );                         
                      return true;
                     }else if(response.data.status == "failed"){             
                      model.$setValidity('erro', false);
                      return false;
                     }                       
                   }, function rejected() {
                    console.log("erro 4xx");                       
                   });            
            };
          }
        } 
      });        

    function ClientStatusController($scope, $document, $mdToast, $state, $stateParams, $filter, Orders, OrdersStatusTotal, api, $window, $translate, $mdDialog, localStorageService, $timeout, CONFIG, DTOptionsBuilder, DTColumnDefBuilder)
    {
        var vm = this;

        vm.userid = localStorageService.get('userid');

        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
          }
          vm.admin = localStorageService.get('admin');
          vm.levelid = localStorageService.get('levelid');
  
          vm.disabled = false;
  
          /* Verifica se tem permissões de ver e/ou alterar conteúdos */
          if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || vm.privileges[30].privileges.view != '1'){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if((vm.privileges[30].privileges.edit == '0' || vm.privileges[30].privileges.edit == null || vm.privileges[30].privileges.edit == false) && vm.privileges[30].privileges.view == '1'){
                vm.disabled = true;
            }
          }       

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg, state, error) {
            if (typeof(state)==='undefined') state = true;
            if(state == true){
            msg = msg + 'a success!';
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');
            }else if(state == "info"){
              var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(10000)
                .theme("orange")
                .position('top right');
            }else{
            if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
            if (typeof(error)!=='undefined') msg = error;
              var toast = $mdToast.simple()
                  .content(msg)
                  .highlightAction(true)
                  .hideDelay(3000)
                  .theme("error-toast")
                  .position('top right');              
            }
            $mdToast.show(toast); 
        }      
        
        vm.allclients = Orders.allordersinfo;
        angular.forEach(vm.allclients, function(allclients, index){
            allclients.index = index;
            allclients.cost = parseFloat(Math.round(allclients.cost * 100) / 100).toFixed(2);
          });
        vm.onstoporders = OrdersStatusTotal.onstoporders;
        vm.dueorders = OrdersStatusTotal.dueorders;
        vm.approvedvia = OrdersStatusTotal.approvedvia;
        vm.approvedwaiting = OrdersStatusTotal.approvedwaiting;
        vm.waitingcall = OrdersStatusTotal.waitingcall;
        vm.waitingimpression = OrdersStatusTotal.waitingimpression;
        vm.inactiveorders = OrdersStatusTotal.inactiveorders;        
        vm.numcompleted = OrdersStatusTotal.numcompleted;

        /********************* */
        /* Funções Botões Topo */
        /***********************/

        
        /***************************/
        /* END Funções Botões Topo */
        /***************************/

        /*****************************/
        /* Funções Pesquisa / Search */
        /*****************************/

        vm.reset = function(){
          vm.search = [];
          vm.startDate = undefined;
          vm.endDate = undefined;
        }

        /* Datatables - Multi Select */
        vm.dtOptions = DTOptionsBuilder.newOptions()
        .withPaginationType('full_numbers')
        .withDisplayLength(50)
        .withOption('lengthMenu', [[10,25,50,100,200,-1],[10,25,50,100,200,"All"]])
        .withOption('order', []);
        vm.dtColumnDefs = [{ orderable: false, targets: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] }];

        // vm.dtColumnDefs = [
        //     DTColumnDefBuilder.newColumnDef(0).withOption('orderData', '1'),
        //     DTColumnDefBuilder.newColumnDef(1).withOption('type', 'nullable').notVisible(),
        // ];

        var selectedRowsIndexes = [];
        
        $scope.selectRow = function(event, rowIndex, array) {
            console.log(rowIndex);
            /*if(event.shiftKey) { */
            if(event.shiftKey) {
              selectWithShift(rowIndex);                        
            } else {
            /*} else if(event.ctrlKey) { */
                changeSelectionStatus(rowIndex);
            } 
            /* else {
                  selectedRowsIndexes = [rowIndex];
              } */

            /* console.log(selectedRowsIndexes);
            console.log(getSelectedRows(array));
            console.log(getFirstSelectedRow());
            if(getSelectedRows().length > 1){
                vm.caixaedicaomulti = 1;
                vm.caixaedicao = 0; 
              }*/
            $scope.numItensSeleccionados = Object.keys(getSelectedRows(array)).length;
            $scope.itensSeleccionados = getSelectedRows(array);

        };

        function selectWithShift(rowIndex) {
            var lastSelectedRowIndexInSelectedRowsList = selectedRowsIndexes.length - 1;
            var lastSelectedRowIndex = selectedRowsIndexes[lastSelectedRowIndexInSelectedRowsList];
            var selectFromIndex = Math.min(rowIndex, lastSelectedRowIndex);
            var selectToIndex = Math.max(rowIndex, lastSelectedRowIndex);
            selectRows(selectFromIndex, selectToIndex);
        }

        function getSelectedRows(array) {
            var selectedRows = [];
            angular.forEach(selectedRowsIndexes, function(rowIndex) {
                selectedRows.push(array[rowIndex]);
            });
            return selectedRows;
        }

        function getFirstSelectedRow(array) {
            var firstSelectedRowIndex = selectedRowsIndexes[0];
            return array[firstSelectedRowIndex];
        }

        function selectRows(selectFromIndex, selectToIndex) {
            for(var rowToSelect = selectFromIndex; rowToSelect <= selectToIndex; rowToSelect++) {
                select(rowToSelect);
            }
        }

        function changeSelectionStatus(rowIndex) {
            if($scope.isRowSelected(rowIndex)) {
                unselect(rowIndex);
            } else {
                select(rowIndex);
            }
        }

        function select(rowIndex) {
            if(!$scope.isRowSelected(rowIndex)) {
                selectedRowsIndexes.push(rowIndex)
            }
        }

        function unselect(rowIndex) {
            var rowIndexInSelectedRowsList = selectedRowsIndexes.indexOf(rowIndex);
            var unselectOnlyOneRow = 1;
            selectedRowsIndexes.splice(rowIndexInSelectedRowsList, unselectOnlyOneRow);
        }

        function resetSelection() {
            selectedRowsIndexes = [];
        }

        $scope.isRowSelected = function(rowIndex) {
            return selectedRowsIndexes.indexOf(rowIndex) > -1;
        };
        /* END Datatables - Multi Select */

        /* FIM Funções Current Orders e On Invoice*/

        vm.gotoOrderStatus = gotoOrderStatus;

        function gotoOrderStatus()
        {
            console.log('go OrderStatus');
            $state.go('app.orderstatus');
        } 

        vm.gravar = function(gravar) {                
                var record = {};
                var departmentin = gravar[0].department_alias;
                if (typeof gravar !== 'undefined') {
                    for (var i = 0; i < gravar.length; i++) {                          
                        record[i] = {
                            orders_opened_id: 0,
                            orders_id: gravar[i].orders_id,
                            users_id: vm.userid
                        }
                    }
                    gravar = record;
                    console.log(gravar);
                    $mdDialog.hide();
                    var msg = "Order opening was ";
                    var orderid = vm.id;
                    api.ordersopened.save({ record: record, orderid: orderid }).$promise.then(function (result) { 
                        console.log(result); 
                        if(result.status !== 'success'){ 
                            showToast(msg, false) 
                        }else{ 
                            showToast(msg);
                            var url = $state.href('app.production', {'id': record[0].orders_id, 'module' : departmentin});                            
                            $window.open(url, '_blank');
                        } 
                    }, function(error) { 
                        var erro = 'Error Code: ' + error['status'] + '. Please try again or contact administrator.'; 
                        showToast(msg, false, erro); 
                    });
                }
        }
        
        vm.scanOrder = function(ev) {             
            $mdDialog.show({
              controller: eval("OtherController"),
              controllerAs: 'octrl',
              templateUrl: 'app/main/pages/clientstatus/templates/scanorder.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: $scope.customFullscreen 
            });
          };
  
          vm.scanOrder.$inject = ['ev','tipopopup'];
            
        function OtherController($compile, $scope, $mdDialog, $http) {
            var self = this;

            $scope.cancel = function() {                
                $mdDialog.cancel();
              };

            $scope.hide = function() {
                $mdDialog.hide();
            };        
        } 
 

    }

    ClientStatusController.$inject = ['$scope', '$document', '$mdToast', '$state', '$stateParams', '$filter', 'Orders', 'OrdersStatusTotal', 'api', '$window', '$translate', '$mdDialog', 'localStorageService', '$timeout', 'CONFIG', 'DTOptionsBuilder', 'DTColumnDefBuilder'];

})();

(function ()
{
    'use strict';

    angular
        .module('app.checkinoutsystem', ['ngMask'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.checkinoutsystem', {
              url      : '/checkinoutsystem/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/checkinoutsystem/checkinoutsystem.html',
                      controller : 'CheckinoutsystemController as vm'
                  }
                },
                resolve  : {
                    Levels: function (api)
                        {
                            return api.levels.get().$promise;
                        },
                    // DeliveryRoutes: function (api, $stateParams)
                    //     {
                    //         return api.deliveryroutes.get({ id: $stateParams.id }).$promise;
                    //     }
                },                
              bodyClass: 'checkinoutsystem'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/checkinoutsystem');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.checkinoutsystem')
        .controller('CheckinoutsystemController', CheckinoutsystemController)
        .directive('checkIn', function($timeout, $q, CONFIG, $http, $state, $mdToast, $mdDialog, api, localStorageService) {
            return {
              restrict: 'AE',
              require: 'ngModel',
              link: function($scope, elm, attr, model) { 
                model.$asyncValidators.orderExists = function(modelValue, viewValue) {
                  var valuez = modelValue || viewValue;
                  var value = valuez.substr(1);
                  if($state.params.showToastMessage) {
                    showToast($state.params.showToastMessage);
                }        
                function showToast(msg, state) {
                    if(state == true){
                    var toast = $mdToast.simple()
                        .content(msg)
                        .highlightAction(true)
                        .hideDelay(5000)
                        .theme("success-toast")
                        .position('top right');
                    }else{
                      var toast = $mdToast.simple()
                          .content(msg)
                          .highlightAction(true)
                          .hideDelay(0)
                          .theme("error-toast")
                          .position('top right')
                          .action('CLOSE');             
                    }
                    $mdToast.show(toast); 
                  }                           
                  return $http.get(CONFIG.apiBaseUrl + 'Checkinout/checkin' + value).
                      then(function (response) {
                        console.log(response.data);
                        if(response.data.status == "success"){
                        showToast(response.data.msg, true);
                        $mdDialog.hide();
                        return true;
                        }else if(response.data.status == "failed"){
                        showToast(response.data.msg, false);            
                        model.$setValidity('erro', false);                          
                        return false;
                        }
                        model.$setValidity('erro', false);
                        return false;                       
                      }, function rejected() {
                      console.log("erro 4xx");                       
                      });            
                };
              }
            } 
          })
          .directive('checkOut', function($timeout, $q, CONFIG, $http, $state, $mdToast, $mdDialog, api, localStorageService) {
            return {
              restrict: 'AE',
              require: 'ngModel',
              link: function($scope, elm, attr, model) { 
                model.$asyncValidators.orderExists = function(modelValue, viewValue) {
                  var valuez = modelValue || viewValue;
                  var value = valuez.substr(1);
                  if($state.params.showToastMessage) {
                    showToast($state.params.showToastMessage);
                }        
                function showToast(msg, state) {
                    if(state == true){
                    var toast = $mdToast.simple()
                        .content(msg)
                        .highlightAction(true)
                        .hideDelay(5000)
                        .theme("success-toast")
                        .position('top right');
                    }else{
                      var toast = $mdToast.simple()
                          .content(msg)
                          .highlightAction(true)
                          .hideDelay(0)
                          .theme("error-toast")
                          .position('top right')
                          .action('CLOSE');             
                    }
                    $mdToast.show(toast); 
                  }                           
                  return $http.get(CONFIG.apiBaseUrl + 'Checkinout/checkout' + value).
                      then(function (response) {
                        console.log(response.data);
                        if(response.data.status == "success"){
                        showToast(response.data.msg, true);
                        $mdDialog.hide();
                        return true;
                        }else if(response.data.status == "failed"){
                        showToast(response.data.msg, false);            
                        model.$setValidity('erro', false);                          
                        return false;
                        }
                        model.$setValidity('erro', false);
                        return false;                       
                      }, function rejected() {
                      console.log("erro 4xx");                       
                      });            
                };
              }
            } 
          });

    function CheckinoutsystemController($scope, $document, $state, $window, $translate, $timeout, api, $mdToast, $mdDialog, localStorageService, CONFIG, Idle)
    {
        console.log("CheckinoutsystemController");

        var vm = this;

        Idle.unwatch();

        vm.baseurl = $window.location.origin;
        if(vm.baseurl == "http://localhost:3000"){
          vm.baseurl = "https://nimrodtrac.app";
        }
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
          }
          vm.admin = localStorageService.get('admin');
          vm.levelid = localStorageService.get('levelid');
  
          vm.disabled = false;
  
          /* Verifica se tem permissões de ver e/ou alterar conteúdos */
          if(vm.admin != '1' && vm.levelid != '1'){
            /*if(vm.privileges == null || vm.privileges[43].privileges.view != '1'){*/
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            /*}else if((vm.privileges[43].privileges.edit == '0' || vm.privileges[43].privileges.edit == null || vm.privileges[43].privileges.edit == false) && vm.privileges[43].privileges.view == '1'){
                vm.disabled = true;
            }*/
          }

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg, state, error) {
            if (typeof(state)==='undefined') state = true;
            if(state == true){
            msg = msg + 'a success!';
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');
            }else if(state == "info"){
              var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(0)
                .theme("orange")
                .position('top right');
            }else{
            if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
            if (typeof(error)!=='undefined') msg = error;
              var toast = $mdToast.simple()
                  .content(msg)
                  .highlightAction(true)
                  .hideDelay(0)
                  .theme("error-toast")
                  .position('top right')
                  .action('CLOSE');             
            }
            $mdToast.show(toast); 
          }

        vm.userid = localStorageService.get('userid');
        
        vm.openPopupOther = function(ev, tipopopup) {                           
            $mdDialog.show({
              controller: eval("OtherController"),
              controllerAs: 'octrl',
              resolve: {
                popuptype: function () {
                  return {
                    'tipoPopup': tipopopup
                  };
                }
              },
              templateUrl: 'app/main/pages/checkinoutsystem/'+tipopopup+'.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: $scope.customFullscreen 
            });
          };
  
          vm.openPopupOther.$inject = ['ev','tipopopup'];

          function OtherController($compile, $scope, $mdDialog) {
            var self = this;

            $scope.hide = function() {
                $mdDialog.hide();
              };
              $scope.cancel = function() {
                $mdDialog.cancel();
              };

          }

          OtherController.$inject = ['$compile', '$scope', '$mdDialog'];

        

    }

CheckinoutsystemController.$inject = ['$scope', '$document', '$state', '$window', '$translate', '$timeout', 'api', '$mdToast', '$mdDialog', 'localStorageService', 'CONFIG', 'Idle'];
    
})();    
(function ()
{
    'use strict';

    angular
        .module('app.analyticspoints', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.analyticspoints', {
              url      : '/analytics/points/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/analyticspoints/analyticspoints.html',
                      controller : 'AnalyticsPointsController as vm'
                  }
              },
              resolve  : {               
                /*OrdersStatusTotal: function (api)
                  {
                  return api.orders.get({ id: 'orderstatus' }).$promise;
                  },*/
              },               
              bodyClass: 'analyticspoints'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/analyticspoints');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.analyticspoints')
        .controller('AnalyticsPointsController', AnalyticsPointsController)
        .factory('postService', function($http, CONFIG) {
            var postService = {
              async: function(controller, id, cache, params) {
                /* $http returns a promise, which has a then function, which also returns a promise */
                var promise = $http({
                  cache: cache,
                  method: 'POST',    
                  url: CONFIG.apiBaseUrl + controller + '/' + id,
                  data: params
                }).then(function (response) {
                  /* The then function here is an opportunity to modify the response */
                  console.log(response);
                  /* The return value gets picked up by the then in the controller. */
                  return response.data;
                });
                /* Return the promise to the controller */
                return promise;
              }
            };
            return postService;
          })
          .directive('printDiv', function () {
          return {
            restrict: 'A',
            link: function(scope, element, attrs) {
              element.bind('click', function(evt){    
                evt.preventDefault();    
                PrintElem(attrs.printDiv);
              });
        
              function PrintElem(elem)
              {
                PrintWithIframe($(elem).html());
              }
        
              function PrintWithIframe(data) 
              {
                if ($('iframe#printf').length == 0) {
                  $('html').append('<iframe id="printf" name="printf"></iframe>');

                  var mywindow = window.frames["printf"];
                var printPreview = window.open('about:blank', 'print_preview');
                var printDocument = printPreview.document;
                printDocument.open();
                printDocument.write(
                           "<html>"+
                               document.documentElement.innerHTML+
                           "</html>");
                printDocument.close();
                }
        
                return true;
              }
            }
          };
        });

    function AnalyticsPointsController($scope, $document, $mdToast, $state, api, $window, $translate, $mdDialog, localStorageService, postService, DTOptionsBuilder, DTColumnBuilder, CONFIG, $location,$timeout)
    {
        console.log("Analytics Points");

        var vm = this;

        vm.userid = localStorageService.get('userid');
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
        }
        vm.admin = localStorageService.get('admin');
        vm.levelid = localStorageService.get('levelid');
    
        /* Verifica se tem permissões de ver e/ou alterar conteúdos */
        if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || vm.privileges[40].privileges.view != '1'){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if((vm.privileges[40].privileges.edit == '0' || vm.privileges[40].privileges.edit == null || vm.privileges[40].privileges.edit == false) && vm.privileges[40].privileges.view == '1'){
                vm.disabled = true;
            }            
        }

        vm.openPage = function(page){
            console.log('go ' + page);
            $state.go('app.'+page);
        }

        /* Points Per Date */        
        vm.dtInstance1 = {};
        var numcolunas1 = 4;

        vm.dtOptions1 = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'UserPoints/pointsperdate',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    console.log(d);
                    for (var i = 0; i < numcolunas1; ++i) {
                        var f = "d.columns["+i+"].search.value = self.search1"+i+";";
                        eval(f);
                    }                   
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',false)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    return nRow;
                    });                      
                });
            })
            .withOption('order', [])        
            .withOption('initComplete', function(){
                /*var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;*/

                vm.searchTable1 = function(searchText, column){                
                    var f = "self.search1"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance1.DataTable.search(searchText).draw();
                }
                
                vm.resetpd = function(){                    
                    vm.search1.startDate = undefined;
                    vm.search1.endDate = undefined;
                    for (var i = 0; i < numcolunas1; ++i) {
                        var f = "self.search1"+i+" = undefined;";
                        eval(f);
                    }
                    vm.dtInstance1.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns1 = [          
            DTColumnBuilder.newColumn(0).withTitle('Name'),
            DTColumnBuilder.newColumn(1).withTitle('Date'),
            DTColumnBuilder.newColumn(2).withTitle('Points'),
            DTColumnBuilder.newColumn(3).withTitle('Date End').notVisible()
        ];

        /* FIM Points per Date */        

        /* Points per Tec*/
        vm.dtInstance2 = {};
        var numcolunas2 = 4;

        vm.dtOptions2 = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'UserPoints/pointspertec',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas2; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search2"+i+";";
                    eval(f);
                    }
                    console.log(d);
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',false)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    return nRow;
                    });                      
                });
            })
            .withOption('order', [])        
            .withOption('initComplete', function(){
                /*var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;*/

                vm.searchTable2 = function(searchText, column){                
                    var f = "self.search2"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance2.DataTable.search(searchText).draw();
                }
                
                vm.reset_tec = function(){                    
                    vm.search2 = [];
                    vm.search2.startDate = undefined;
                    vm.search2.endDate = undefined;
                    for (var i = 0; i < numcolunas2; ++i) {
                        var f = "self.search2"+i+" = undefined;";
                        eval(f);
                    }                   
                    vm.dtInstance2.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns2 = [           
            DTColumnBuilder.newColumn(0).withTitle('Name'),
            DTColumnBuilder.newColumn(1).withTitle('Date'),
            DTColumnBuilder.newColumn(2).withTitle('Points'),
            DTColumnBuilder.newColumn(3).withTitle('Date End').notVisible()
        ];

        /* FIM Total Sales by Group */        

        vm.autoPrintPage = function(){
            html2canvas($("#pagina-points"), {
                onrendered: function(canvas) {                    
                    var myImage = canvas.toDataURL("image/png");
                    var tWindow = window.open("");
                    $(tWindow.document.body)
                        .html("<img id='Image' src=" + myImage + " style='width:100%;'></img>")
                        .ready(function() {                            
                            tWindow.focus();
                            tWindow.print();
                        });
                }
            });
        }            

    }

    AnalyticsPointsController.$inject = ['$scope', '$document', '$mdToast', '$state', 'api', '$window', '$translate', '$mdDialog', 'localStorageService', 'postService', 'DTOptionsBuilder', 'DTColumnBuilder', 'CONFIG', '$location','$timeout'];
    
    
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.checkinout', ['ngMask'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.checkinout', {
              url      : '/checkinout/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/checkinout/checkinout.html',
                      controller : 'CheckinoutController as vm'
                  }
                },
                resolve  : {
                    Levels: function (api)
                        {
                            return api.levels.get().$promise;
                        },
                    // DeliveryRoutes: function (api, $stateParams)
                    //     {
                    //         return api.deliveryroutes.get({ id: $stateParams.id }).$promise;
                    //     }
                },                
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/checkinout');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.checkinout')
        .controller('CheckinoutController', CheckinoutZController);

    function CheckinoutZController($scope, $document, $state, $window, $translate, $timeout, api, $mdToast, $mdDialog, postService, localStorageService, DTOptionsBuilder, DTColumnBuilder, CONFIG, $location, $http, Levels)
    {
        console.log("CheckinoutController");

        var vm = this;

        vm.baseurl = $window.location.origin;
        if(vm.baseurl == "http://localhost:3000"){
          vm.baseurl = "https://nimrodtrac.app";
        }
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
          }
          vm.admin = localStorageService.get('admin');
          vm.levelid = localStorageService.get('levelid');
  
          vm.disabled = false;
  
          /* Verifica se tem permissões de ver e/ou alterar conteúdos */
          if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || vm.privileges[43].privileges.view != '1'){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if((vm.privileges[43].privileges.edit == '0' || vm.privileges[43].privileges.edit == null || vm.privileges[43].privileges.edit == false) && vm.privileges[43].privileges.view == '1'){
                vm.disabled = true;
            }
          }

        if($state.params.showToastMessage) {
            showToast($state.params.showToastMessage);
        }

        function showToast(msg, state, error) {
            if (typeof(state)==='undefined') state = true;
            if(state == true){
            msg = msg + 'a success!';
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');
            }else if(state == "info"){
              var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(0)
                .theme("orange")
                .position('top right');
            }else{
            if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
            if (typeof(error)!=='undefined') msg = error;
              var toast = $mdToast.simple()
                  .content(msg)
                  .highlightAction(true)
                  .hideDelay(0)
                  .theme("error-toast")
                  .position('top right')
                  .action('CLOSE');             
            }
            $mdToast.show(toast); 
          }

        vm.userid = localStorageService.get('userid');
        vm.levels = Levels.records;
        
        vm.gotoNotCheckinout = function()
        {
            console.log('go NotCheckinout');
            $state.go('app.notcheckinout');
        }
        
        vm.dtInstance = {};
        vm.type = 1;
        var numcolunas = 10;

        vm.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('ajax', {
            url: CONFIG.apiBaseUrl + 'Checkinout/'+vm.type+'fetchCheckinout',
            type: 'POST',
            "dataSrc": function(json) {
                if(json.status && json.status == "login"){
                    $mdDialog.hide();
                    var infor = "Your login has expired. Please login again.";
                    showToast(infor, "info");
                    $location.path('/login');
                  }else{
                      console.log(json);
                      return json.data;
                  }
            },
            "data": function(d){
                console.log(d);
                for (var i = 0; i < numcolunas; ++i) {
                  var f = "d.columns["+i+"].search.value = self.search"+i+";";
                  eval(f);
                }                
                
            },
            "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
        })
        .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
        .withDataProp('data')
        .withOption('processing', true)
        .withOption('serverSide', true)
        .withOption('filter', false)
        .withOption('bLengthChange', true)
        .withOption('bSort', false)
        .withOption('responsive',false)
        .withPaginationType('full_numbers')
        .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          /*$('td', nRow).css('cursor', 'pointer');
          $('td', nRow).unbind('click');
          $('td', nRow).bind('click', function() {
              $scope.$apply(function() {                
                return nRow;
                });                      
              });*/
          })
        .withOption('order', [])        
        .withOption('initComplete', function(){
            var api = this.api();

            vm.totalRecords = api.page.info().recordsTotal;
            vm.totalRecordsFiltered = api.page.info().recordsDisplay;
            

            vm.searchTable = function(searchText, column){
                var f = "self.search"+column+" = searchText;";
                eval(f);
                vm.dtInstance.DataTable.search(searchText).draw();                  
            } 
            
            vm.reset = function(){
                vm.search = [];
                vm.startDate = undefined;
                vm.endDate = undefined;
                vm.onDate = undefined;
                for (var i = 0; i < numcolunas; ++i) {
                  var f = "self.search"+i+" = undefined;";
                  eval(f);
                }
                vm.dtInstance.reloadData(null, true);                      
            }

            vm.changeType = function(type){
                vm.reset();
                vm.type = type;
                var newurl = CONFIG.apiBaseUrl + 'Checkinout/'+vm.type+'fetchCheckinout';  
                changeColumn(type);              
                $timeout( function(){                    
                    vm.dtInstance.DataTable.ajax.url(newurl).load();
                }, 100 );
                                
            }
            
        })
        .withLanguage({
            "sInfo": 'Info',
            "paginate": {
                "first": 'First',
                "last": 'Last',
                "next": 'Next',
                "previous": 'Previous'
            }
        });

        function criarColunas(){
            vm.dtColumns = [
                DTColumnBuilder.newColumn(0).withTitle('Date'),
                DTColumnBuilder.newColumn(1).withTitle('Code'),
                DTColumnBuilder.newColumn(2).withTitle('Name'),
                DTColumnBuilder.newColumn(3).withTitle('Time In'),
                DTColumnBuilder.newColumn(4).withTitle('Time Out'),
                DTColumnBuilder.newColumn(5).withTitle('Level'),
                DTColumnBuilder.newColumn(6).withTitle('Job Title'),
                DTColumnBuilder.newColumn(7).withTitle('Start Date').notVisible(),
                DTColumnBuilder.newColumn(8).withTitle('End Date').notVisible(),
                DTColumnBuilder.newColumn(9).withTitle('Status').notVisible()
            ]      
        }

        criarColunas();
        changeColumn(vm.type);

        function changeColumn(type){
            if(type==1){
                vm.searchdisable = false;
                vm.dtColumns = [
                    DTColumnBuilder.newColumn(0).withTitle('Date'),
                    DTColumnBuilder.newColumn(1).withTitle('Code'),
                    DTColumnBuilder.newColumn(2).withTitle('Name'),
                    DTColumnBuilder.newColumn(3).withTitle('Time In'),
                    DTColumnBuilder.newColumn(4).withTitle('Time Out'),
                    DTColumnBuilder.newColumn(5).withTitle('Level'),
                    DTColumnBuilder.newColumn(6).withTitle('Job Title'),
                    DTColumnBuilder.newColumn(7).withTitle('Start Date').notVisible(),
                    DTColumnBuilder.newColumn(8).withTitle('End Date').notVisible(),
                    DTColumnBuilder.newColumn(9).withTitle('Status').notVisible()
                ]
            }else if(type==2){
                vm.searchdisable = true;
                vm.dtColumns = [
                    DTColumnBuilder.newColumn(0).withTitle('Date'),
                    DTColumnBuilder.newColumn(1).withTitle('Code'),
                    DTColumnBuilder.newColumn(2).withTitle('Name'),
                    DTColumnBuilder.newColumn(3).withTitle('Time In').notVisible(),
                    DTColumnBuilder.newColumn(4).withTitle('Time Out').notVisible(),
                    DTColumnBuilder.newColumn(5).withTitle('Level'),
                    DTColumnBuilder.newColumn(6).withTitle('Job Title'),
                    DTColumnBuilder.newColumn(7).withTitle('Start Date').notVisible(),
                    DTColumnBuilder.newColumn(8).withTitle('End Date').notVisible(),
                    DTColumnBuilder.newColumn(9).withTitle('Status')
                ]
            }
        }

    }

CheckinoutZController.$inject = ['$scope', '$document', '$state', '$window', '$translate', '$timeout', 'api', '$mdToast', '$mdDialog', 'postService', 'localStorageService', 'DTOptionsBuilder', 'DTColumnBuilder', 'CONFIG', '$location', '$http', 'Levels'];
    
})();    
(function ()
{
    'use strict';

    angular
        .module('app.analyticsmd', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.analyticsmd', {
              url      : '/analytics/md/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/analyticsmd/analyticsmd.html',
                      controller : 'AnalyticsMDController as vm'
                  }
              },
              resolve  : {               
                Employees: function (api)
                  {
                    return api.analytics.get({id: 'employees'}).$promise;
                  },
                User: function (api)
                {
                return api.user.get({id: 'GLDU'}).$promise;
                }
              },               
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/analyticsmd');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.analyticsmd')
        .controller('AnalyticsMDController', AnalyticsMDController)
        .factory('postService', function($http, CONFIG) {
            var postService = {
              async: function(controller, id, cache, params) {
                /* $http returns a promise, which has a then function, which also returns a promise */
                var promise = $http({
                  cache: cache,
                  method: 'POST',    
                  url: CONFIG.apiBaseUrl + controller + '/' + id,
                  data: params
                }).then(function (response) {
                  /* The then function here is an opportunity to modify the response */
                  console.log(response);
                  /* The return value gets picked up by the then in the controller. */
                  return response.data;
                });
                /* Return the promise to the controller */
                return promise;
              }
            };
            return postService;
          });

    function AnalyticsMDController($scope, $document, $mdToast, $state, api, $window, $translate, $mdDialog, localStorageService, postService, DTOptionsBuilder, DTColumnBuilder, CONFIG, $location, Employees, $timeout, User)
    {
        console.log("AnalyticsMD");

        var vm = this;

        vm.userid = localStorageService.get('userid');
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
        }
        vm.admin = localStorageService.get('admin');
        vm.levelid = localStorageService.get('levelid');
    
        /* Verifica se tem permissões de ver e/ou alterar conteúdos */
        if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || vm.privileges[35].privileges.view != '1'){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if((vm.privileges[35].privileges.edit == '0' || vm.privileges[35].privileges.edit == null || vm.privileges[35].privileges.edit == false) && vm.privileges[35].privileges.view == '1'){
                vm.disabled = true;
            }            
        }

        vm.openPage = function(page){
            console.log('go ' + page);
            $state.go('app.'+page);
        }

        vm.employees = Employees;
        vm.numusers = User.info;

        // console.log(vm.numusers);
        

        vm.order = [];
        vm.startDate = [];
        vm.endDate = [];

        vm.changeTotalSales = function(id, field, value){            
            if(typeof field != 'undefined' && typeof value != 'undefined'){
                var params = {};
                var f = "params."+field+" = '"+value+"'";
                eval(f);
            }else{
                var params = null;
            }
            postService.async("Reports", id, false, params).then(function(d) {                            
                console.log(d);
                vm.order[id] = d.orders;
                if(vm.order[id] == null || vm.order[id] == ""){
                    vm.order[id] = 0;
                }
            });      
        }

        /* Run First Time */
        var ids = ['neworders','ordersdue','orderswfc','orderswfi','ordersonstop','completedorders','bankbalance','financesincome','moneyowed','totaldebt','expenditure'];

        ids.forEach(function(id){
            vm.changeTotalSales(id);
        });
        /* END Run First Time */

        vm.clean = function(type){
            vm.startDate[type] = undefined;
            vm.endDate[type] = undefined;
            vm.changeTotalSales(type);
        } 

        vm.dtInstance = {};
        var numcolunas = 6;        
        // vm.totalexpenses = 0;

        function calculateTotalExpenses(search){
            search = (typeof (search) == undefined) ? "" : search;
            var id = "totalexpenses";
            var totalexpenses;
            postService.async("Analytics", id, false, search).then(function(d) {                            
                vm.totalexpenses = d.total;
            });
        }
        calculateTotalExpenses();
        

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'Analytics/expenditure',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);                                              
                        return json.data;                        
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search"+i+";";
                    eval(f);
                    }
                    // console.log(d);
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',true)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $('td', nRow).unbind('click');
                $('td', nRow).bind('click');
            })
            /*.withOption('createdRow', function(row) {
                $compile(angular.element(row).contents())($scope);
            })*/
            .withOption('order', [])        
            .withOption('initComplete', function(){
                var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;

                vm.searchTable = function(searchText, column){                
                    var f = "self.search"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance.DataTable.search(searchText).draw();
                    calculateTotalExpenses(vm.search);
                }
                
                vm.reset = function(){    
                    vm.search = [];                
                    vm.search.startDate = undefined;
                    vm.search.endDate = undefined;
                    for (var i = 0; i < numcolunas; ++i) {
                        var f = "self.search"+i+" = undefined;";
                        eval(f);
                    }
                    vm.dtInstance.reloadData(null, true);
                    calculateTotalExpenses(vm.search);                      
                }            
                
            })
            .withLanguage({
                "sInfo": 'Info',
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns = [          
            DTColumnBuilder.newColumn(0).withTitle('Expenditure ID').notVisible(),
            DTColumnBuilder.newColumn(1).withTitle('Date'),
            DTColumnBuilder.newColumn(2).withTitle('Date End').notVisible(),
            DTColumnBuilder.newColumn(3).withTitle('Description'),
            DTColumnBuilder.newColumn(4).withTitle('Sales'),
            DTColumnBuilder.newColumn(5).withTitle('Sales Raw').notVisible()
        ];


    }

    AnalyticsMDController.$inject = ['$scope', '$document', '$mdToast', '$state', 'api', '$window', '$translate', '$mdDialog', 'localStorageService', 'postService', 'DTOptionsBuilder', 'DTColumnBuilder', 'CONFIG', '$location', 'Employees','$timeout','User'];
    
    
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.analyticsinman', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.analyticsinman', {
              url      : '/analytics/inman/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/analyticsinman/analyticsinman.html',
                      controller : 'AnalyticsInmanController as vm'
                  }
              },
              resolve  : {               
                /*OrdersStatusTotal: function (api)
                  {
                  return api.orders.get({ id: 'orderstatus' }).$promise;
                  },*/
              },               
              bodyClass: 'analyticsinman'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/analyticsinman');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.analyticsinman')
        .controller('AnalyticsInmanController', AnalyticsInmanController)
        .factory('postService', function($http, CONFIG) {
            var postService = {
              async: function(controller, id, cache, params) {
                /* $http returns a promise, which has a then function, which also returns a promise */
                var promise = $http({
                  cache: cache,
                  method: 'POST',    
                  url: CONFIG.apiBaseUrl + controller + '/' + id,
                  data: params
                }).then(function (response) {
                  /* The then function here is an opportunity to modify the response */
                  console.log(response);
                  /* The return value gets picked up by the then in the controller. */
                  return response.data;
                });
                /* Return the promise to the controller */
                return promise;
              }
            };
            return postService;
          })
          .directive('printDiv', function () {
          return {
            restrict: 'A',
            link: function(scope, element, attrs) {
              element.bind('click', function(evt){    
                evt.preventDefault();    
                PrintElem(attrs.printDiv);
              });
        
              function PrintElem(elem)
              {
                PrintWithIframe($(elem).html());
              }
        
              function PrintWithIframe(data) 
              {
                if ($('iframe#printf').length == 0) {
                  $('html').append('<iframe id="printf" name="printf"></iframe>');

                  var mywindow = window.frames["printf"];
                var printPreview = window.open('about:blank', 'print_preview');
                var printDocument = printPreview.document;
                printDocument.open();
                printDocument.write(
                           "<html>"+
                               document.documentElement.innerHTML+
                           "</html>");
                printDocument.close();
                }
        
                return true;
              }
            }
          };
        });

    function AnalyticsInmanController($scope, $document, $mdToast, $state, api, $window, $translate, $mdDialog, localStorageService, postService, DTOptionsBuilder, DTColumnBuilder, CONFIG, $location,$timeout)
    {
        console.log("Analytics Inman");

        var vm = this;

        vm.userid = localStorageService.get('userid');
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
        }
        vm.admin = localStorageService.get('admin');
        vm.levelid = localStorageService.get('levelid');
    
        /* Verifica se tem permissões de ver e/ou alterar conteúdos */
        if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || vm.privileges[36].privileges.view != '1'){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if((vm.privileges[36].privileges.edit == '0' || vm.privileges[36].privileges.edit == null || vm.privileges[36].privileges.edit == false) && vm.privileges[36].privileges.view == '1'){
                vm.disabled = true;
            }            
        }

        vm.openPage = function(page){
            console.log('go ' + page);
            $state.go('app.'+page);
        }

        vm.section = 3; /* Inman */

        /* Top 10 Clients */        
        vm.dtInstance1 = {};
        var numcolunas1 = 5;

        vm.dtOptions1 = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'Analytics/analyticstop10',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    console.log(d);
                    for (var i = 0; i < numcolunas1; ++i) {
                        var f = "d.columns["+i+"].search.value = self.search1"+i+";";
                        eval(f);
                    }
                    d.section = vm.section;                   
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',false)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    return nRow;
                    });                      
                });
            })
            .withOption('order', [])        
            .withOption('initComplete', function(){
                /*var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;*/

                vm.searchTable1 = function(searchText, column){                
                    var f = "self.search1"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance1.DataTable.search(searchText).draw();
                }
                
                vm.resettop10 = function(){                    
                    vm.search1.startDate = undefined;
                    vm.search1.endDate = undefined;
                    for (var i = 0; i < numcolunas1; ++i) {
                        var f = "self.search1"+i+" = undefined;";
                        eval(f);
                    }
                    vm.dtInstance1.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns1 = [          
            DTColumnBuilder.newColumn(0).withTitle('Client Name'),
            DTColumnBuilder.newColumn(1).withTitle('Product'),
            DTColumnBuilder.newColumn(2).withTitle('Units'),
            DTColumnBuilder.newColumn(3).withTitle('Date Receveid 1').notVisible(),
            DTColumnBuilder.newColumn(4).withTitle('Date Receveid 2').notVisible()
        ];

        /* FIM Top 10 Clients */        

        /* Technician Orders */
        vm.dtInstance2 = {};
        var numcolunas2 = 4;

        vm.dtOptions2 = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'Analytics/analyticstecorders',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas2; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search2"+i+";";
                    eval(f);
                    }
                    console.log(d);
                    d.section = vm.section;
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',false)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    return nRow;
                    });                      
                });
            })
            .withOption('order', [])        
            .withOption('initComplete', function(){
                var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;

                vm.searchTable2 = function(searchText, column){                
                    var f = "self.search2"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance2.DataTable.search(searchText).draw();
                }
                
                vm.resetteco = function(){                    
                    vm.search2 = [];
                    vm.search2.startDate = undefined;
                    vm.search2.endDate = undefined;
                    for (var i = 0; i < numcolunas2; ++i) {
                        var f = "self.search2"+i+" = undefined;";
                        eval(f);
                    }                   
                    vm.dtInstance2.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns2 = [           
            DTColumnBuilder.newColumn(0).withTitle('Technician'),
            DTColumnBuilder.newColumn(1).withTitle('Order No'),
            DTColumnBuilder.newColumn(2).withTitle('Due Date'),
            DTColumnBuilder.newColumn(3).withTitle('Due Date 2').notVisible()
        ];

        /* FIM Technician Orders */ 
        
        /* Top 5 Clients */
        vm.dtInstance3 = {};
        var numcolunas3 = 4;

        vm.dtOptions3 = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'Analytics/analyticstop5tec',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas3; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search3"+i+";";
                    eval(f);
                    }
                    console.log(d);
                    d.section = vm.section;
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',false)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    return nRow;
                    });                      
                });
            })
            .withOption('order', [])        
            .withOption('initComplete', function(){
                var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;

                vm.searchTable3 = function(searchText, column){                
                    var f = "self.search3"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance3.DataTable.search(searchText).draw();
                }
                
                vm.resettop5tec = function(){                    
                    vm.search3 = [];
                    vm.search3.startDate = undefined;
                    vm.search3.endDate = undefined;
                    for (var i = 0; i < numcolunas3; ++i) {
                        var f = "self.search3"+i+" = undefined;";
                        eval(f);
                    }                   
                    vm.dtInstance3.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns3 = [           
            DTColumnBuilder.newColumn(0).withTitle('Technician'),
            DTColumnBuilder.newColumn(1).withTitle('Points'),
            DTColumnBuilder.newColumn(2).withTitle('Date Received').notVisible(),
            DTColumnBuilder.newColumn(3).withTitle('Date Received 2').notVisible()
        ];

        /* FIM Technician Orders */

        vm.autoPrintPage = function(){
            html2canvas($("#pagina-section"), {
                onrendered: function(canvas) {                    
                    var myImage = canvas.toDataURL("image/png");
                    var tWindow = window.open("");
                    $(tWindow.document.body)
                        .html("<img id='Image' src=" + myImage + " style='width:100%;'></img>")
                        .ready(function() {                            
                            tWindow.focus();
                            tWindow.print();
                        });
                }
            });
        }            

    }

    AnalyticsInmanController.$inject = ['$scope', '$document', '$mdToast', '$state', 'api', '$window', '$translate', '$mdDialog', 'localStorageService', 'postService', 'DTOptionsBuilder', 'DTColumnBuilder', 'CONFIG', '$location','$timeout'];
    
    
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.analyticsaccounts', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.analyticsaccounts', {
              url      : '/analytics/accounts/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/analyticsaccounts/analyticsaccounts.html',
                      controller : 'AnalyticsAccountsController as vm'
                  }
              },
              /*resolve  : {               
                Employees: function (api)
                  {
                    return api.analytics.get({id: 'employees'}).$promise;
                  },
                User: function (api)
                {
                return api.user.get({id: 'GLDU'}).$promise;
                }
              },*/               
              bodyClass: 'e-commerce'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/analyticsaccounts');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.analyticsaccounts')
        .controller('AnalyticsAccountsController', AnalyticsAccountsController)
        .factory('getService', function($http, CONFIG) {
            var getService = {
              async: function(controller, id, cache) {
                /* $http returns a promise, which has a then function, which also returns a promise */
                var promise = $http({
                  cache: cache,
                  method: 'GET',    
                  url: CONFIG.apiBaseUrl + controller + '/' + id
                }).then(function (response) {
                  /* The then function here is an opportunity to modify the response */
                  console.log(response);
                  /* The return value gets picked up by the then in the controller. */
                  return response.data;
                });
                /* Return the promise to the controller */
                return promise;
              }
            };
            return getService;
          });

    function AnalyticsAccountsController($scope, $document, $mdToast, $state, api, $window, $translate, $mdDialog, localStorageService, getService, DTOptionsBuilder, DTColumnBuilder, CONFIG, $location, $timeout)
    {
        console.log("Analytics Accounts");

        var vm = this;

        vm.userid = localStorageService.get('userid');
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
        }
        vm.admin = localStorageService.get('admin');
        vm.levelid = localStorageService.get('levelid');
    
        /* Verifica se tem permissões de ver e/ou alterar conteúdos */
        if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || vm.privileges[39].privileges.view != '1'){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if((vm.privileges[39].privileges.edit == '0' || vm.privileges[39].privileges.edit == null || vm.privileges[39].privileges.edit == false) && vm.privileges[39].privileges.view == '1'){
                vm.disabled = true;
            }            
        }

        vm.openPage = function(page){
            console.log('go ' + page);
            $state.go('app.'+page);
        }
        
        vm.clients = [];

        vm.changeTotalSales = function(id){            
            getService.async("Analytics", id, false).then(function(d) {                            
                console.log(id+":");
                var f = "vm.clients."+id+" = d;";
                eval(f);
            });      
        }

        /* Run First Time */
        var ids = ['totalclients','pastmonthactiveclients','activeclients','inactiveclients'];

        ids.forEach(function(id){
            vm.changeTotalSales(id);
        });
        
        /* END Run First Time */


        vm.dtInstance = {};
        var numcolunas = 5;        
        

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'Analytics/top10clients',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);                                              
                        return json.data;                        
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search"+i+";";
                    eval(f);
                    }
                    // console.log(d);
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',true)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $('td', nRow).unbind('click');
                $('td', nRow).bind('click');
            })
            /*.withOption('createdRow', function(row) {
                $compile(angular.element(row).contents())($scope);
            })*/
            .withOption('order', [])        
            .withOption('initComplete', function(){
                var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;

                /*vm.searchTable = function(searchText, column){                
                    var f = "self.search"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance.DataTable.search(searchText).draw();
                    calculateTotalExpenses(vm.search);
                }*/
                
                /*vm.reset = function(){    
                    vm.search = [];                
                    vm.search.startDate = undefined;
                    vm.search.endDate = undefined;
                    for (var i = 0; i < numcolunas; ++i) {
                        var f = "self.search"+i+" = undefined;";
                        eval(f);
                    }
                    vm.dtInstance.reloadData(null, true);
                    calculateTotalExpenses(vm.search);                      
                }*/            
                
            })
            .withLanguage({
                "sInfo": 'Info',
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns = [          
            DTColumnBuilder.newColumn(0).withTitle('Client Name'),
            DTColumnBuilder.newColumn(1).withTitle('Client No'),
            DTColumnBuilder.newColumn(2).withTitle('Address'),
            DTColumnBuilder.newColumn(3).withTitle('Postcode'),
            DTColumnBuilder.newColumn(4).withTitle('Amount')
        ];

    }

    AnalyticsAccountsController.$inject = ['$scope', '$document', '$mdToast', '$state', 'api', '$window', '$translate', '$mdDialog', 'localStorageService', 'getService', 'DTOptionsBuilder', 'DTColumnBuilder', 'CONFIG', '$location','$timeout'];
    
    
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.analyticsclears', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.analyticsclears', {
              url      : '/analytics/clears/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/analyticsclears/analyticsclears.html',
                      controller : 'AnalyticsClearsController as vm'
                  }
              },
              resolve  : {               
                /*OrdersStatusTotal: function (api)
                  {
                  return api.orders.get({ id: 'orderstatus' }).$promise;
                  },*/
              },               
              bodyClass: 'analyticsclears'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/analyticsclears');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.analyticsclears')
        .controller('AnalyticsClearsController', AnalyticsClearsController)
        .factory('postService', function($http, CONFIG) {
            var postService = {
              async: function(controller, id, cache, params) {
                /* $http returns a promise, which has a then function, which also returns a promise */
                var promise = $http({
                  cache: cache,
                  method: 'POST',    
                  url: CONFIG.apiBaseUrl + controller + '/' + id,
                  data: params
                }).then(function (response) {
                  /* The then function here is an opportunity to modify the response */
                  console.log(response);
                  /* The return value gets picked up by the then in the controller. */
                  return response.data;
                });
                /* Return the promise to the controller */
                return promise;
              }
            };
            return postService;
          })
          .directive('printDiv', function () {
          return {
            restrict: 'A',
            link: function(scope, element, attrs) {
              element.bind('click', function(evt){    
                evt.preventDefault();    
                PrintElem(attrs.printDiv);
              });
        
              function PrintElem(elem)
              {
                PrintWithIframe($(elem).html());
              }
        
              function PrintWithIframe(data) 
              {
                if ($('iframe#printf').length == 0) {
                  $('html').append('<iframe id="printf" name="printf"></iframe>');

                  var mywindow = window.frames["printf"];
                var printPreview = window.open('about:blank', 'print_preview');
                var printDocument = printPreview.document;
                printDocument.open();
                printDocument.write(
                           "<html>"+
                               document.documentElement.innerHTML+
                           "</html>");
                printDocument.close();
                }
        
                return true;
              }
            }
          };
        });

    function AnalyticsClearsController($scope, $document, $mdToast, $state, api, $window, $translate, $mdDialog, localStorageService, postService, DTOptionsBuilder, DTColumnBuilder, CONFIG, $location,$timeout)
    {
        console.log("Analytics Clears");

        var vm = this;

        vm.userid = localStorageService.get('userid');
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
        }
        vm.admin = localStorageService.get('admin');
        vm.levelid = localStorageService.get('levelid');
    
        /* Verifica se tem permissões de ver e/ou alterar conteúdos */
        if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || vm.privileges[37].privileges.view != '1'){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if((vm.privileges[37].privileges.edit == '0' || vm.privileges[37].privileges.edit == null || vm.privileges[37].privileges.edit == false) && vm.privileges[37].privileges.view == '1'){
                vm.disabled = true;
            }            
        }

        vm.openPage = function(page){
            console.log('go ' + page);
            $state.go('app.'+page);
        }

        vm.section = 2; /* Clears */

        /* Top 10 Clients */        
        vm.dtInstance1 = {};
        var numcolunas1 = 5;

        vm.dtOptions1 = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'Analytics/analyticstop10',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    console.log(d);
                    for (var i = 0; i < numcolunas1; ++i) {
                        var f = "d.columns["+i+"].search.value = self.search1"+i+";";
                        eval(f);
                    }
                    d.section = vm.section;                   
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',false)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    return nRow;
                    });                      
                });
            })
            .withOption('order', [])        
            .withOption('initComplete', function(){
                /*var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;*/

                vm.searchTable1 = function(searchText, column){                
                    var f = "self.search1"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance1.DataTable.search(searchText).draw();
                }
                
                vm.resettop10 = function(){                    
                    vm.search1.startDate = undefined;
                    vm.search1.endDate = undefined;
                    for (var i = 0; i < numcolunas1; ++i) {
                        var f = "self.search1"+i+" = undefined;";
                        eval(f);
                    }
                    vm.dtInstance1.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns1 = [          
            DTColumnBuilder.newColumn(0).withTitle('Client Name'),
            DTColumnBuilder.newColumn(1).withTitle('Product'),
            DTColumnBuilder.newColumn(2).withTitle('Units'),
            DTColumnBuilder.newColumn(3).withTitle('Date Receveid 1').notVisible(),
            DTColumnBuilder.newColumn(4).withTitle('Date Receveid 2').notVisible()
        ];

        /* FIM Top 10 Clients */        

        /* Technician Orders */
        vm.dtInstance2 = {};
        var numcolunas2 = 4;

        vm.dtOptions2 = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'Analytics/analyticstecorders',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas2; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search2"+i+";";
                    eval(f);
                    }
                    console.log(d);
                    d.section = vm.section;
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',false)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    return nRow;
                    });                      
                });
            })
            .withOption('order', [])        
            .withOption('initComplete', function(){
                var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;

                vm.searchTable2 = function(searchText, column){                
                    var f = "self.search2"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance2.DataTable.search(searchText).draw();
                }
                
                vm.resetteco = function(){                    
                    vm.search2 = [];
                    vm.search2.startDate = undefined;
                    vm.search2.endDate = undefined;
                    for (var i = 0; i < numcolunas2; ++i) {
                        var f = "self.search2"+i+" = undefined;";
                        eval(f);
                    }                   
                    vm.dtInstance2.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns2 = [           
            DTColumnBuilder.newColumn(0).withTitle('Technician'),
            DTColumnBuilder.newColumn(1).withTitle('Order No'),
            DTColumnBuilder.newColumn(2).withTitle('Due Date'),
            DTColumnBuilder.newColumn(3).withTitle('Due Date 2').notVisible()
        ];

        /* FIM Technician Orders */ 
        
        /* Top 5 Clients */
        vm.dtInstance3 = {};
        var numcolunas3 = 4;

        vm.dtOptions3 = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'Analytics/analyticstop5tec',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas3; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search3"+i+";";
                    eval(f);
                    }
                    console.log(d);
                    d.section = vm.section;
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',false)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    return nRow;
                    });                      
                });
            })
            .withOption('order', [])        
            .withOption('initComplete', function(){
                var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;

                vm.searchTable3 = function(searchText, column){                
                    var f = "self.search3"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance3.DataTable.search(searchText).draw();
                }
                
                vm.resettop5tec = function(){                    
                    vm.search3 = [];
                    vm.search3.startDate = undefined;
                    vm.search3.endDate = undefined;
                    for (var i = 0; i < numcolunas3; ++i) {
                        var f = "self.search3"+i+" = undefined;";
                        eval(f);
                    }                   
                    vm.dtInstance3.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns3 = [           
            DTColumnBuilder.newColumn(0).withTitle('Technician'),
            DTColumnBuilder.newColumn(1).withTitle('Points'),
            DTColumnBuilder.newColumn(2).withTitle('Date Received').notVisible(),
            DTColumnBuilder.newColumn(3).withTitle('Date Received 2').notVisible()
        ];

        /* FIM Technician Orders */

        vm.autoPrintPage = function(){
            html2canvas($("#pagina-section"), {
                onrendered: function(canvas) {                    
                    var myImage = canvas.toDataURL("image/png");
                    var tWindow = window.open("");
                    $(tWindow.document.body)
                        .html("<img id='Image' src=" + myImage + " style='width:100%;'></img>")
                        .ready(function() {                            
                            tWindow.focus();
                            tWindow.print();
                        });
                }
            });
        }            

    }

    AnalyticsClearsController.$inject = ['$scope', '$document', '$mdToast', '$state', 'api', '$window', '$translate', '$mdDialog', 'localStorageService', 'postService', 'DTOptionsBuilder', 'DTColumnBuilder', 'CONFIG', '$location','$timeout'];
    
    
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.analytics3d', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
          .state('app.analytics3d', {
              url      : '/analytics/3d/:id',
              views    : {
                  'content@app': {
                      templateUrl: 'app/main/pages/analytics3d/analytics3d.html',
                      controller : 'Analytics3DController as vm'
                  }
              },
              resolve  : {               
                /*OrdersStatusTotal: function (api)
                  {
                  return api.orders.get({ id: 'orderstatus' }).$promise;
                  },*/
              },               
              bodyClass: 'analytics3d'
          });

        $translatePartialLoaderProvider.addPart('app/main/pages/analytics3d');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.analytics3d')
        .controller('Analytics3DController', Analytics3DController)
        .factory('postService', function($http, CONFIG) {
            var postService = {
              async: function(controller, id, cache, params) {
                /* $http returns a promise, which has a then function, which also returns a promise */
                var promise = $http({
                  cache: cache,
                  method: 'POST',    
                  url: CONFIG.apiBaseUrl + controller + '/' + id,
                  data: params
                }).then(function (response) {
                  /* The then function here is an opportunity to modify the response */
                  console.log(response);
                  /* The return value gets picked up by the then in the controller. */
                  return response.data;
                });
                /* Return the promise to the controller */
                return promise;
              }
            };
            return postService;
          })
          .directive('printDiv', function () {
          return {
            restrict: 'A',
            link: function(scope, element, attrs) {
              element.bind('click', function(evt){    
                evt.preventDefault();    
                PrintElem(attrs.printDiv);
              });
        
              function PrintElem(elem)
              {
                PrintWithIframe($(elem).html());
              }
        
              function PrintWithIframe(data) 
              {
                if ($('iframe#printf').length == 0) {
                  $('html').append('<iframe id="printf" name="printf"></iframe>');

                  var mywindow = window.frames["printf"];
                var printPreview = window.open('about:blank', 'print_preview');
                var printDocument = printPreview.document;
                printDocument.open();
                printDocument.write(
                           "<html>"+
                               document.documentElement.innerHTML+
                           "</html>");
                printDocument.close();
                }
        
                return true;
              }
            }
          };
        });

    function Analytics3DController($scope, $document, $mdToast, $state, api, $window, $translate, $mdDialog, localStorageService, postService, DTOptionsBuilder, DTColumnBuilder, CONFIG, $location,$timeout)
    {
        console.log("Analytics 3D");

        var vm = this;

        vm.userid = localStorageService.get('userid');
        
        if(localStorageService.get('privileges') != null || localStorageService.get('privileges') != ""){
            vm.privileges = JSON.parse(localStorageService.get('privileges'));
        }
        vm.admin = localStorageService.get('admin');
        vm.levelid = localStorageService.get('levelid');
    
        /* Verifica se tem permissões de ver e/ou alterar conteúdos */
        if(vm.admin != '1' && vm.levelid != '1'){
            if(vm.privileges == null || vm.privileges[38].privileges.view != '1'){
                var infor = "You don't have enough permission to enter this area.";
                showToast(infor, "info");
                $state.go('app.dashboard');
            }else if((vm.privileges[38].privileges.edit == '0' || vm.privileges[38].privileges.edit == null || vm.privileges[38].privileges.edit == false) && vm.privileges[38].privileges.view == '1'){
                vm.disabled = true;
            }            
        }

        vm.openPage = function(page){
            console.log('go ' + page);
            $state.go('app.'+page);
        }

        vm.section = 1; /* 3D */

        /* Top 10 Clients */        
        vm.dtInstance1 = {};
        var numcolunas1 = 5;

        vm.dtOptions1 = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'Analytics/analyticstop10',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    console.log(d);
                    for (var i = 0; i < numcolunas1; ++i) {
                        var f = "d.columns["+i+"].search.value = self.search1"+i+";";
                        eval(f);
                    }
                    d.section = vm.section;                   
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',false)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    return nRow;
                    });                      
                });
            })
            .withOption('order', [])        
            .withOption('initComplete', function(){
                /*var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;*/

                vm.searchTable1 = function(searchText, column){                
                    var f = "self.search1"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance1.DataTable.search(searchText).draw();
                }
                
                vm.resettop10 = function(){                    
                    vm.search1.startDate = undefined;
                    vm.search1.endDate = undefined;
                    for (var i = 0; i < numcolunas1; ++i) {
                        var f = "self.search1"+i+" = undefined;";
                        eval(f);
                    }
                    vm.dtInstance1.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns1 = [          
            DTColumnBuilder.newColumn(0).withTitle('Client Name'),
            DTColumnBuilder.newColumn(1).withTitle('Product'),
            DTColumnBuilder.newColumn(2).withTitle('Units'),
            DTColumnBuilder.newColumn(3).withTitle('Date Receveid 1').notVisible(),
            DTColumnBuilder.newColumn(4).withTitle('Date Receveid 2').notVisible()
        ];

        /* FIM Top 10 Clients */        

        /* Technician Orders */
        vm.dtInstance2 = {};
        var numcolunas2 = 4;

        vm.dtOptions2 = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'Analytics/analyticstecorders',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas2; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search2"+i+";";
                    eval(f);
                    }
                    console.log(d);
                    d.section = vm.section;
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',false)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    return nRow;
                    });                      
                });
            })
            .withOption('order', [])        
            .withOption('initComplete', function(){
                var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;

                vm.searchTable2 = function(searchText, column){                
                    var f = "self.search2"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance2.DataTable.search(searchText).draw();
                }
                
                vm.resetteco = function(){                    
                    vm.search2 = [];
                    vm.search2.startDate = undefined;
                    vm.search2.endDate = undefined;
                    for (var i = 0; i < numcolunas2; ++i) {
                        var f = "self.search2"+i+" = undefined;";
                        eval(f);
                    }                   
                    vm.dtInstance2.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns2 = [           
            DTColumnBuilder.newColumn(0).withTitle('Technician'),
            DTColumnBuilder.newColumn(1).withTitle('Order No'),
            DTColumnBuilder.newColumn(2).withTitle('Due Date'),
            DTColumnBuilder.newColumn(3).withTitle('Due Date 2').notVisible()
        ];

        /* FIM Technician Orders */ 
        
        /* Top 5 Clients */
        vm.dtInstance3 = {};
        var numcolunas3 = 4;

        vm.dtOptions3 = DTOptionsBuilder.newOptions()
            .withOption('ajax', {
                url: CONFIG.apiBaseUrl + 'Analytics/analyticstop5tec',
                type: 'POST',
                "dataSrc": function(json) {
                    if(json.status && json.status == "login"){
                        $mdDialog.hide();
                        var infor = "Your login has expired. Please login again.";
                        showToast(infor, "info");
                        $location.path('/login');
                    }else{
                        console.log(json);
                        return json.data;
                    }
                },
                "data": function(d){
                    for (var i = 0; i < numcolunas3; ++i) {
                    var f = "d.columns["+i+"].search.value = self.search3"+i+";";
                    eval(f);
                    }
                    console.log(d);
                    d.section = vm.section;
                },
                "headers": {'Authorization' : 'Bearer ' + localStorageService.get('token')}
            })
            .withOption('dom','rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>')
            .withDataProp('data')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('filter', false)
            .withOption('bLengthChange', false)
            .withOption('bSort', false)
            .withOption('responsive',false)
            .withOption('info', false)
            .withPaginationType('full_numbers')
            .withOption('rowCallback', function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    return nRow;
                    });                      
                });
            })
            .withOption('order', [])        
            .withOption('initComplete', function(){
                var api = this.api();

                vm.totalRecords = api.page.info().recordsTotal;
                vm.totalRecordsFiltered = api.page.info().recordsDisplay;

                vm.searchTable3 = function(searchText, column){                
                    var f = "self.search3"+column+" = searchText;";
                    eval(f);
                    vm.dtInstance3.DataTable.search(searchText).draw();
                }
                
                vm.resetteco = function(){                    
                    vm.search3 = [];
                    vm.search3.startDate = undefined;
                    vm.search3.endDate = undefined;
                    for (var i = 0; i < numcolunas3; ++i) {
                        var f = "self.search3"+i+" = undefined;";
                        eval(f);
                    }                   
                    vm.dtInstance3.reloadData(null, true);                      
                }            
                
            })
            .withLanguage({
                "paginate": {
                    "first": 'First',
                    "last": 'Last',
                    "next": 'Next',
                    "previous": 'Previous'
                }
            });
        

        vm.dtColumns3 = [           
            DTColumnBuilder.newColumn(0).withTitle('Technician'),
            DTColumnBuilder.newColumn(1).withTitle('Points'),
            DTColumnBuilder.newColumn(2).withTitle('Date Received').notVisible(),
            DTColumnBuilder.newColumn(3).withTitle('Date Received 2').notVisible()
        ];

        /* FIM Technician Orders */

        vm.autoPrintPage = function(){
            html2canvas($("#pagina-section"), {
                onrendered: function(canvas) {                    
                    var myImage = canvas.toDataURL("image/png");
                    var tWindow = window.open("");
                    $(tWindow.document.body)
                        .html("<img id='Image' src=" + myImage + " style='width:100%;'></img>")
                        .ready(function() {                            
                            tWindow.focus();
                            tWindow.print();
                        });
                }
            });
        }            

    }

    Analytics3DController.$inject = ['$scope', '$document', '$mdToast', '$state', 'api', '$window', '$translate', '$mdDialog', 'localStorageService', 'postService', 'DTOptionsBuilder', 'DTColumnBuilder', 'CONFIG', '$location','$timeout'];
    
    
    
})();

(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ScrumboardController', ScrumboardController);

    /** @ngInject */
    function ScrumboardController($mdSidenav, BoardService, BoardList, CardFilters)
    {
        var vm = this;

        // Data
        vm.currentView = 'board';
        vm.board = BoardService.data;
        vm.boardList = BoardList.data;
        vm.boardSelectorVisible = false;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.updateBoardUri = updateBoardUri;
        vm.clearFilters = CardFilters.clear;
        vm.filteringIsOn = CardFilters.isOn;

        ////////

        /**
         * Update Board Uri
         *
         * Once you connect your app to your server,
         * you would do this on your API server.
         */
        function updateBoardUri()
        {
            if ( vm.boardList.getById(vm.board.id) )
            {
                vm.boardList.getById(vm.board.id).name = vm.board.name;
                vm.boardList.getById(vm.board.id).uri = vm.board.uri = encodeURIComponent(vm.board.name).replace(/%20/g, '-').toLowerCase();
            }
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngMaterial',
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',
                'datatables',
                'angular-jwt',
                'LocalStorageModule',
                'angular-md5'
            ]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
            
            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?',
                hideStep    : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?',
                hideStep    : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);
                    
                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {

        $mdThemingProvider.theme("success-toast");
        $mdThemingProvider.theme("error-toast");

        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'yellow',
                hues: {
                    'default': '100',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'yellow',
            options: {
                '50': '#000', //background menu with focus
                '100': '#ffc500', //background top pages
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'E',
            compile : function (element, attr)
            {
                var code;
                //No attribute? code is the content
                if ( !attr.code )
                {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr)
                {

                    if ( attr.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', ['angular.img'])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $q, api, $state, $location, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, localStorageService, $window)
    {
        var vm = this;

        vm.username = localStorageService.get('username');
        vm.userid = localStorageService.get('userid');

        vm.userpic = localStorageService.get('profileimg');

        vm.baseurl = $window.location.origin;
        if(vm.baseurl == "http://localhost:3000"){
          vm.baseurl = "https://nimrodtrac.app";
        }

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'en'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout()
        {
            api.Logout();
            $location.path('/login');
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Auth
            'app.auth',

            // Pages
            'app.pages',
            
            //Scrumboard
            'app.scrumboard'

        ]);
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, Idle, api, $location, $mdToast)
    {
        // Data
        //////////
        console.log("MainController");

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });

        function showToast(msg, state, error) {
            if (typeof(state)==='undefined') state = true;
            if(state == true){
            msg = msg + 'a success!';
            var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(3000)
                .theme("success-toast")
                .position('top right');
            }else if(state == "info"){
              var toast = $mdToast.simple()
                .content(msg)
                .highlightAction(true)
                .hideDelay(0)
                .theme("orange")
                .position('top right')
                .action('CLOSE');
            }else{
            if (typeof(error)==='undefined') msg = msg + 'failed. Please try again.';
            if (typeof(error)!=='undefined') msg = error;
              var toast = $mdToast.simple()
                  .content(msg)
                  .highlightAction(true)
                  .hideDelay(5000)
                  .theme("error-toast")
                  .position('top right');              
            }
            $mdToast.show(toast);
        }        
        
        /* IDLE */
        if($location.path() != "/login" && $location.path() != "/checkinoutsystem"){
            api.StartWatch();
        }

        $scope.events = [];
        
        $scope.$on('IdleTimeout', function() {
            console.log('Timeout!');
            /* Desbloquear Consolidation caso user estivesse lá dentro */ 
            var url = $location.path().split("/");
            var index = url.length;
            while (index-- && !url[index]);                
            var departmentalias = strip(url[index].toLowerCase());
            if(departmentalias.toLowerCase() == "consolidation"){
                var registo = {
                    blocked: '0',
                    department_alias: departmentalias
                }
                api.departments.save({ record: registo });
            }
            var msg = "You were idle for 25 minutes. Your session has expired.";
            showToast(msg, "info");
            api.Logout();
            $location.path('/login');
        });

        /* FIM IDLE */       
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, CONFIG, $sanitize)
    {
        var vm = this;

        vm.defaultLogo = $sanitize(CONFIG.defaultLogo);
        vm.title = $sanitize(CONFIG.title);

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, $translateProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider
            .state('app.auth', {
                url    : '/login',
                views    : {
                    'main@'                       : {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller : 'MainController as vm'
                    },
                    'content@app.auth': {
                        templateUrl: 'app/auth/auth.html',
                        controller : 'AuthController as vm'
                    }
                },
                bodyClass: 'login'
            });

        $translatePartialLoaderProvider.addPart('app/auth');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth')
        .controller('AuthController', AuthController);

    /** @ngInject */
    function AuthController($state, $translate, $cookies, CONFIG, $sanitize, $window, api, $mdToast)
    {
      var vm = this;
      vm.loginLogo = $sanitize(CONFIG.loginLogo);

      vm.login = function(username, password) {
      vm.loading = true;

        api.Login(username, password, function (result) {
          if (result === true) {
              $state.go('app.dashboard');
          } else {
              //exibir mensagens de erro consoante o erro
              vm.error = 'Invalid username or password';
              vm.loading = false;
              var toast = $mdToast.simple()
                  .content(vm.error)
                  .highlightAction(true)
                  .hideDelay(3000)
                  .position('top right');

              $mdToast.show(toast);
          }
        });

        /*        var expToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjEiLCJuYW1lIjoiQWRtaW5pc3RyYXRvciIsInJ1bGVzIjpbeyJtZW51IjoiQ2xpZW50cyIsInBlZGl0IjoiMSIsInBuZXciOiIxIiwicGRlbCI6IjEifV19.RKn27ls3YRZzYdwoKX0WsAbOTGytk30omSngtUeoJ4o";
                var tokenPayload = jwtHelper.decodeToken(expToken);
                console.log(tokenPayload);

                var date = jwtHelper.getTokenExpirationDate(expToken);
                console.log(date);*/

/*
        api.clients.query().$promise.then(function (result) {
            console.log(result[0]);
        });
*/
        /*
        api.get({ id: 41 }).$promise.then(function (result) {
          var user = result.client;
          user.client = ' de Belmonte';
          console.log(user);

          /*api.save({ client: user }).$promise.then(function (result) {
            console.log("user updated");
          });*/

          /*user.client.client = user.client.client + ' de Belmonte';
          user.client.$update(function(){//Then send an update HTTP PUT to server.
                console.log('Updating user with id ',user.id);
              });
        });*/
/*
        api.get({ id: 41 }).$promise.then(function (result) {
          var user = result.client;
          user.morada2 = 'Ericeira';

          api.save(user, function(response){
              console.log("fim");
            });


        });

        //DELETE
        /*
        api.delete({ id: 43 }).$promise.then(function (user) {
                console.log('delete');
        });
        */

        /*api.save({id:41,localidade:'Mafra'}, function(response){
						console.log("fim");
					});*/

        /*
        api.get({ id: 33 }.$promise, function(data) {
          console.log(data);
        });
/*
          api.user.login.login({'user': user, 'pass' : password},

              // Success
              function (response)
              {
                console.log(response);
                  if(response.status == 'OK') {
                    var user = response.user;
                      $window.localStorage.setItem('user',user.name);
                      $window.localStorage.setItem('lang',user.language_code);
                      $window.location.href = '/clients';
                  } else {

                      var toast = $mdToast.simple()
                          .content(response.status)
                          .highlightAction(true)
                          .hideDelay(3000)
                          .position('top right');

                      $mdToast.show(toast);
                  }
              },
              // Error
              function (response)
              {
                                console.log(response);
                      var toast = $mdToast.simple()
                          .content(response.status)
                          .highlightAction(true)
                          .hideDelay(0)
                          .position('top right');

                      $mdToast.show(toast);
              }
          );*/
      }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')        
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, localStorageService, $location, $http, api, $mdDialog)
    {
        
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });

        /* Redireccionar para o login se não estiver logado ao tentar aceder a url's diretos */
        var token = localStorageService.get('token');
        if(token == null){
            $location.path('/login');
        }

        function strip(html)
        {
           var tmp = document.createElement("DIV");
           tmp.innerHTML = html;
           return tmp.textContent || tmp.innerText || "";
        }

        /* Atualizar o Last Visit Date e Department de um User */        
        $rootScope.$on('$stateChangeSuccess', 
            function(event, toState, toParams, fromState, fromParams){
                var userid = localStorageService.get('userid');
                var lastvisit = "LV"+userid;
                var url = $location.path().split("/");
                var index = url.length;
                while (index-- && !url[index]);                
                var departmentalias = strip(url[index].toLowerCase());
                var record = {
                    id: userid,
                    lastvisit: lastvisit,
                    department: departmentalias
                }
                if(userid != null){
                    api.user.save({ record: record});                    
                }
                /* Gravar se alguém entrar na página do Consolidation - bloquear departamento */
                /*if(departmentalias.toLowerCase() == "consolidation"){
                    var registo = {
                        blocked: userid,
                        department_alias: departmentalias
                    }
                    api.departments.save({ record: registo });
                }*/                              
                event.preventDefault();                
            }
        );

        function showAlert(ev, userlogged, userid) {
            var useradmin = localStorageService.get('admin');
            var levelid = localStorageService.get('levelid');
            var msg = (useradmin == '1' || levelid == '1') ? "<p>Proceeding on this page may result in duplicate invoices.</p>" : "<p>If you are sure that user already left, you can ask a admin/manager to unblock this page.</p>";           
            if(useradmin == '1' || levelid == '1'){
                var confirm = $mdDialog.confirm(
                            /* Este código seguinte só é preciso para mudar a cor ao botão (para vermelho para remover, por ex.) */
                            {
                                onComplete: function afterShowAnimation() {
                                    var $dialog = angular.element(document.querySelector('md-dialog'));
                                    var $actionsSection = $dialog.find('md-dialog-actions');
                                    var $cancelButton = $actionsSection.children()[0];
                                    var $confirmButton = $actionsSection.children()[1];
                                    angular.element($confirmButton).addClass('md-primary');
                                    angular.element($cancelButton).addClass('md-primary md-raised md-green-500-bg');
                                }
                            }
                        )
                        .title('Attention')
                        .htmlContent('<p>There is already an user working in Consolidation page.</p>' + msg)
                        .ariaLabel('Remove confirm box')
                        .targetEvent(ev)
                        .clickOutsideToClose(true)
                        .parent(angular.element(document.body))                        
                        .ok('Unblock and Proceed')
                        .cancel('Leave Page');
                        $mdDialog.show(confirm).then(function() {
                            /* Gravar se alguém entrar na página do Consolidation - bloquear departamento */
                            $rootScope.userloggedconsolidation = userid;
                            var registo = {
                                blocked: userid,
                                department_alias: 'consolidation'
                            }
                            api.departments.save({ record: registo }); 
                        }, function() {                            
                            /* Leave Page */
                            $rootScope.userloggedconsolidation = userlogged;
                            var registo = {
                                blocked: userlogged,
                                department_alias: 'consolidation'
                            }
                            api.departments.save({ record: registo }); 
                            $timeout( function(){                    
                                $state.go('app.dashboard');                    
                            }, 500 );                     
                    });
                }else{
                    var confirm = $mdDialog.confirm(                        
                    )
                    .title('Attention')
                    .htmlContent('<p>There is already an user working in Consolidation page.</p>' + msg)
                    .ariaLabel('Remove confirm box')
                    .targetEvent(ev)
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .cancel('Leave Page');
                    $mdDialog.show(confirm).then(function() {
                            /* Leave Page */
                            $rootScope.userloggedconsolidation = userlogged;
                            var registo = {
                                blocked: userlogged,
                                department_alias: 'consolidation'
                            }
                            api.departments.save({ record: registo }); 
                            $timeout( function(){                    
                                $state.go('app.dashboard');                    
                            }, 500 );
                    }); 
                }
            };

        $rootScope.userloggedconsolidation = 0;

        
        
        /* Gravar se alguém sair da página do Consolidation - desbloquear departamento */ 
        $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams, options){
            var userid = localStorageService.get('userid');
            var url = $location.path().split("/");
            var index = url.length;
            while (index-- && !url[index]);                
            var departmentalias = strip(url[index].toLowerCase());
            if(departmentalias.toLowerCase() == "consolidation" && $rootScope.userloggedconsolidation == userid){
                var registo = {
                    blocked: '0',
                    department_alias: departmentalias
                }
                api.departments.save({ record: registo });
            }
        });


        /* Verificar se o departamento consolidation está bloqueado antes de entrar */
        $rootScope.$on('$locationChangeStart', function(event, next, current){
            var userid = localStorageService.get('userid');            
            var nexturl = next.split('/')[3];
            if(nexturl.toLowerCase() == "consolidation"){
                api.departments.query({ id: 'checkblocked' }).$promise.then(function (result) {
                    $rootScope.userloggedconsolidation = result.status.blocked;                    
                    if(result.status.blocked > 0 && result.status.blocked != userid){                
                        showAlert(event, result.status.blocked, userid);
                    }
                });
            }            
        });

    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('httpRequestInterceptor', function (localStorageService) {
            return {
              request: function (config) {
                var token = localStorageService.get('token');
                config.headers['Authorization'] = 'Bearer ' + token;
                                
                return config;
              }
            };
          })
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider, $httpProvider)
    {
        $locationProvider.html5Mode(true);

        $httpProvider.interceptors.push('httpRequestInterceptor');         

        $urlRouterProvider.otherwise('/login');       

        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'horizontalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    }
//                    ,
//                    'quickPanel@app': {
//                        templateUrl: 'app/quick-panel/quick-panel.html',
//                        controller : 'QuickPanelController as vm'
//                    }
                }
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);                

    /** @ngInject */
    function IndexController(fuseTheming, localStorageService, $http, jwtHelper, CONFIG, $sanitize)
    {
        console.log("IndexController");
        
        var vm = this;
        vm.defaultLogo = $sanitize(CONFIG.defaultLogo);

        // Data
        vm.themes = fuseTheming.themes;

        var token = localStorageService.get('token');
        if(token) {
          $http.defaults.headers.common.Authorization = 'Bearer ' + token;
        //   console.log("load token: " + token);
        }
   
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .constant('CONFIG', {
            'title': 'NIMRO',
            'apiBaseUrl': 'https://nimrodtrac.app/api/',
            'uploadsBaseUrl': 'https://nimrodtrac.app/api/upload/',
            'profileImgsBaseUrl': 'https://nimrodtrac.app/api/upload/profileimgs/',
            'apiBaseUrlJson': 'https://nimrodtrac.app/api/json/',
            'apiModules': 'Marketing,UserPoints,HolidaysUserSettings,HolidaysComments,Holidays,Levels,Analytics,FinancesOwed,FinancesDebt,FinancesRevenue,FinancesBanking,Expenditure,Reports,UserPrivileges,Status,User,ClientsStatus,ClientsTel,ClientsTelType,ClientsEmail,ClientsEmailType,TelType,EmailType,ClientsProducts,ClientsDeliveryAddress,ClientsType,Vat,Discounts,OrdersDepartments,InvoicesItems,Payments,OrdersByClient,InvoicesOrders,InvoiceOpened,Invoice,DldActions,Orders,OrdersOpened,Shipping,OrderStatus,Clients,Casetype,OrderComments,OrdersLinked,OrdersLabDocs,LabDocs,OrdersContent,OrdersProduct,ProductsGroups,Products,Departments,DeliveryGroups,DeliveryRoutes,OrdersPlasterroom,OrdersScanning,OrdersPlatforms,OrdersDesigning,OrdersManufacturing,OrdersMatching,OrdersPlanning,OrdersDrillingDesign,OrdersDrillingPrinting,OrdersDrillingAssembly,OrdersCaseAssessment,OrdersClearMovement,OrdersBracketMovement,OrdersClearManufacturing,OrdersInCaseAssessment,OrdersInMovement,OrdersInManufacturing,OrdersWaitingCall,OrdersPackaging,Scheduling,SchedulingEmail',
            'defaultLogo': '<span>N</span>',
            'loginLogo': '<span>N</span>',
            'device': 'desktop'
        });

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('httpRequestInterceptor', function ($q, localStorageService, $location) {
            return {
                request: function (config) {
                    // console.log("a por token no config");
                    var token = localStorageService.get('token');
                    config.headers['Authorization'] = 'Bearer ' + token;
            
                    return config;
                },              
                response: function(response){
                    if(response.data.status && response.data.status == "login"){
                        // console.log(response.data.status);
                        $location.path('/login');                        
                    }
                    return response;
                }
            };
          })
        .config(config);

    /** @ngInject */
    function config($httpProvider)
    {
        // Put your custom configurations here
        $httpProvider.interceptors.push('httpRequestInterceptor');
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource, $http, CONFIG, localStorageService, md5, Idle, $location, $cookies)
    {

      var api = {};

      //GENERIC MODULES
      var apiModules = CONFIG.apiModules.split(",");

//      for(var k=0 ; k < apiModules.length; k++) {
//        var apiModule = apiModules[k];
//        api[apiModule.toLowerCase()] = $resource( CONFIG.apiBaseUrl + apiModule +'/:id',
//                      {}, {'query':  {method:'GET', isArray:false}} );
//      }
      
        for(var k=0 ; k < apiModules.length; k++) {
                var apiModule = apiModules[k];
                api[apiModule.toLowerCase()] = $resource( CONFIG.apiBaseUrl + apiModule +'/:id',
                    {}, { 
                        'query': {method:'GET', isArray:false},
                        'delete': {method:'GET', isArray:false, url: CONFIG.apiBaseUrl + apiModule +'/delete/:id'},
                        'deleteall': {method:'GET', isArray:false, url: CONFIG.apiBaseUrl + apiModule +'/deleteall/:id'},
                        'deleteinvoiceid': {method:'GET', isArray:false, url: CONFIG.apiBaseUrl + apiModule +'/deleteinvoiceid/:id'}                        
                    } );
        }      

      //ESPECIFIC MODULES
      api.Login = Login;
      api.Logout = Logout;
      api.StartWatch = StartWatch;
      return api;

        function Login(username, password, callback) {
            /*$http.post(CONFIG.apiBaseUrl + 'users/autenticate',
                        { username: username, password: md5.createHash(password), device: CONFIG.device })*/
            $http.post(CONFIG.apiBaseUrl + 'user/autenticate',
                        { username: username, password: password, device: CONFIG.device })

                .success(function (response) {
                    if (response.token) {
                        // $cookies.put('userid', response.user.id);

                        localStorageService.set('userid', response.user.id);
                        localStorageService.set('username', response.user.name);
                        localStorageService.set('profileimg', response.user.profile_img);
                        localStorageService.set('privileges', response.user.privileges);
                        localStorageService.set('admin', response.user.admin);
                        localStorageService.set('manage', response.user.manage);
                        localStorageService.set('levelid', response.user.levels_id);
                        localStorageService.set('rules', response.rules);
                        localStorageService.set('token', response.token);
                        
                        callback(true);
                    } else {
                        callback(false);
                    }
                });
        }

        function Logout() {
            localStorageService.clearAll();
            $http.defaults.headers.common.Authorization = '';
        }

        function StartWatch() {
            if($location.host() != "localhost" && $location.path() != "/login" && $location.path() != "/checkinoutsystem"){
                Idle.watch();
            }
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('app.pages', [
            'ngIdle','app.dashboard', 'app.productsgroups', 'app.products', 'app.deliveryroute',
            'app.deliverygroup', 'app.orderstatus', 'app.invoice', 'app.invoicesearch',
            'app.consolidation', 'app.scheduling', 'app.production',
            'app.clientstatus', 'app.profiles', 'app.profile', 'app.members', 'app.consolidationsearch', 'app.dld',
            'app.reports', 'app.reportsclients', 'app.reportsproducts', 'app.reportsorders', 'app.finances', 
            'app.financesbanking','app.financesrevenue','app.financesdebt','app.financesowed', 'app.analyticsmd',
            'app.analyticsaccounts', 'app.checkinout', 'app.checkinoutsystem', 'app.holidays', 'app.analyticspoints',
            'app.marketing', 'app.researchd', 'app.analytics3d', 'app.analyticsclears', 'app.analyticsinman'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider, IdleProvider, KeepaliveProvider) {

        console.log("PagesModule");

        // configure Idle settings
        IdleProvider.idle(5); // in seconds
        IdleProvider.timeout(25*60); // in seconds
        /*KeepaliveProvider.interval(2); // in seconds*/        

        msNavigationServiceProvider.saveItem('app', {
            title: 'Menu',
            group: true,
            weight: 1
        });

        /*msNavigationServiceProvider.saveItem('app.clients', {
            title: 'Clients',
            icon: 'icon-account-multiple',
            state: 'app.clients',

            translate: 'CLIENTS.NAV',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('app.locals', {
            title: 'Locals',
            icon: 'icon-city',
            state: 'app.locals',

            translate: 'LOCALS.NAV',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('app.users', {
            title: 'Users',
            icon: 'icon-account-key',
            state: 'app.users',

            translate: 'USERS.NAV',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('app.equipments', {
            title: 'Equipments',
            icon: 'icon-barcode',
            state: 'app.equipments',

            translate: 'EQUIPMENTS.NAV',
            weight: 1
        });

        //Tabelas

        msNavigationServiceProvider.saveItem('app.routes', {
            title: 'Routes',
            icon: 'icon-map-marker',
            state: 'app.routes',

            translate: 'ROUTES.NAV',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('app.tables', {
            title: 'Tabelas',
            group: true,
            weight: 1
        });

        /*
              msNavigationServiceProvider.saveItem('app.usertypes', {
                  title    : 'Usertypes',
                  icon     : 'icon-table-large',
                  state    : 'app.usertypes',

                  translate: 'USERTYPES.NAV',
                  weight   : 1
              });

              msNavigationServiceProvider.saveItem('app.clientstates', {
                  title    : 'Clientstates',
                  icon     : 'icon-table-large',
                  state    : 'app.clientstates',

                  translate: 'CLIENTSTATES.NAV',
                  weight   : 1
              });

        msNavigationServiceProvider.saveItem('app.equipmentmodels', {
            title: 'Models',
            icon: 'icon-table-large',
            state: 'app.equipmentmodels',

            translate: 'EQUIPMENTMODELS.NAV',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('app.equipmentmodelassistances', {
            title: 'Models',
            icon: 'icon-table-large',
            state: 'app.equipmentmodelassistances',

            translate: 'EQUIPMENTMODELASSISTANCES.NAV',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('app.brands', {
            title: 'Brands',
            icon: 'icon-table-large',
            state: 'app.brands',

            translate: 'BRANDS.NAV',
            weight: 1
        });*/

    }
})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/auth/auth.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><img \nsrc=\"assets/images/logos/NimrodTRAC_logo.png\" width=\"200\" height=\"25\" alt=\"NimrodTRAC Logo\" \nstyle=\"margin:auto;display:block\"><div class=\"title\" translate=\"LOGIN.TITLE\">Log in to your account</div><form \nname=\"loginForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"text\" name=\"username\" \nng-model=\"vm.form.username\" placeholder=\"Username\" translate translate-attr-placeholder=\"LOGIN.USERNAME\" required><div \nng-messages=\"loginForm.username.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.USERNAME_REQUIRED\">Username field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" \nplaceholder=\"Password\" translate translate-attr-placeholder=\"LOGIN.PASSWORD\" required><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><md-checkbox \nclass=\"remember-me\" ng-model=\"data.cb1\" aria-label=\"Remember Me\"><span translate=\"LOGIN.REMEMBER_ME\">Remember Me</span>\n</md-checkbox><a ui-sref=\"app.pages_auth_forgot-password\" class=\"forgot-password md-accent-color\" \ntranslate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \nstyle=\"background-color: #004377\" translate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\" \nng-click=\"vm.login(vm.form.username, vm.form.password)\">LOG IN</md-button></form></div></div></div>");
$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/templates/adddeliveryroute.tpl.html","<md-dialog flex=\"20\" class=\"adddeliveryroute\" aria-label=\"Add Delivery Route\" ngapp=\"caseType\" ng-cloak><form \nname=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" \nng-model=\"vm.order.orders_id\" ng-init=\"vm.order.orders_id=id\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nAdd Delivery Route</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\">\n<md-input-container flex \nmd-is-error=\"recordForm.deliveryroutes_id.$invalid && (recordForm.deliveryroutes_id.$touched || recordForm.$submitted)\">\n<label>Delivery Route</label><md-select name=\"deliveryroutes_id\" ng-model=\"vm.order.deliveryroutes_id\"><md-option \nng-repeat=\"(index,droute) in ctrlz.droutes\" ng-value=\"droute.deliveryroutes_id\" \nng-selected=\"index == \'{{ctrlz.deliveryroutes_id}}\'\">{{droute.route}}</md-option></md-select><div \nng-messages=\"recordForm.deliveryroutes_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease choose a delivery route.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" \ntype=\"submit\" ng-click=\"recordForm.$valid && gravar(vm.order)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/templates/addnewlinkorder.tpl.html","<md-dialog flex=\"20\" class=\"adddeliveryroute\" aria-label=\"Link New Order\" ngapp=\"caseType\" ng-cloak><form \nname=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" \nng-model=\"vm.order.orders_linked_id\" ng-init=\"vm.order.orders_linked_id=\'0\'\"> <input type=\"hidden\" \nng-model=\"vm.order.orders_id\" ng-init=\"vm.order.orders_id=id\"> <input type=\"hidden\" \nng-model=\"vm.order.linkedto_orders_id\" ng-init=\"vm.order.linkedto_orders_id=linkedtoid\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Link New Order</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex \nlayout-align=\"start center\"><md-autocomplete flex validate-dropdown md-input-name=\"autocompleteField\" \nmd-no-cache=\"ctrlx.noCache\" md-selected-item=\"ctrlx.selectedItem\" \nmd-search-text-change=\"ctrlx.searchTextChange(ctrlx.searchText)\" md-search-text=\"ctrlx.searchText\" \nmd-items=\"item in ctrlx.listorders\" md-item-text=\"item.ordernumber\" \nmd-selected-item-change=\"ctrlx.selectedOrderIdChange(item)\" md-input-minlength=\"2\" md-input-maxlength=\"18\" required \nmd-required-match=\"true\" md-floating-label=\"Order Number\" md-autofocus><md-item-template><span \nmd-highlight-text=\"ctrlx.searchText\" md-highlight-flags=\"^i\">{{item.ordernumber}}</span></md-item-template><div \nng-messages=\"recordForm.autocompleteField.$error\" ng-if=\"recordForm.autocompleteField.$touched\"><div \nng-message=\"required\">Please insert an order number.</div><div ng-message=\"md-require-match\">\nPlease insert a valid order number.</div></div></md-autocomplete></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" \ntype=\"submit\" ng-click=\"recordForm.$valid && gravar(vm.order)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/templates/addproduct.tpl.html","<md-dialog aria-label=\"Add New Product\" ngapp=\"caseType\" ng-cloak><form name=\"addProduct\" class=\"casetype\"><md-toolbar>\n<div class=\"md-toolbar-tools\"><h2>Add New Product</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" \nclass=\"md-dialog-content\"><table datatable=\"ng\" class=\"simple hover tabela-pesquisa\"><thead><tr><th>Product Code</th>\n<th>Product</th><th>Product Group</th></tr></thead><tbody><tr ng-repeat=\"product in ctrlprod.products\"><td><a href=\"#\" \ntitle=\"Add Product\">{{product.product_code}}</a></td><td><a href=\"#\" title=\"Add Product\">\n{{product.product_description}}</a></td><td>{{product.group_name}}</td></tr></tbody></table></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"cancel()\">Close</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/templates/addproductin.html","<md-dialog flex=\"20\" class=\"adddeliveryroute\" aria-label=\"Add New Product\" ngapp=\"caseType\" ng-cloak><form \nname=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nAdd Product {{ctrladdprod.product.product_description}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex \nlayout-align=\"start center\"><md-input-container flex class=\"md-block\"><label>Quantity</label><md-select \nng-model=\"vm.product.product_qty\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option \nvalue=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><label>Discount</label><input type=\"text\" name=\"discount\" \nng-model=\"vm.product.product_discount\" ng-pattern=\"/^[1-9][0-9]?$|^100$/\" value=\"0\"><div \nng-messages=\"recordForm.discount.$error\"><div ng-message=\"pattern\">Please insert a valid discount between 0 to 100\n</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" \nng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(vm.order)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/templates/addtreatmanplan.tpl.html","<md-dialog aria-label=\"Add Product\" ngapp=\"caseType\" ng-cloak><form class=\"casetype\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Add Product</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><h3>Search by</h3><div \nlayout=\"row\" layout-align=\"start center\"><md-datepicker flex=\"20\" ng-model=\"ctrl.startDate\" \nmd-placeholder=\"Start date\" md-open-on-focus></md-datepicker><md-datepicker flex=\"20\" ng-model=\"ctrl.endDate\" \nmd-placeholder=\"End date\" md-open-on-focus></md-datepicker><md-input-container layout=\"row\" flex=\"30\" class=\"md-block\">\n<label>Client</label><input type=\"text\"></md-input-container><md-input-container layout=\"row\" flex=\"30\" \nclass=\"md-block\"><label>City</label><input type=\"text\"></md-input-container></div><div layout=\"row\"><md-input-container\n flex class=\"md-block\"><label>Order No</label><input type=\"text\"></md-input-container><md-input-container flex \nclass=\"md-block\"><label>Patient Name</label><input type=\"text\"></md-input-container><md-input-container flex \nclass=\"md-block\"><label>Country</label><input type=\"text\"></md-input-container></div><div layout=\"row\">\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>Perscription No</label><input type=\"text\">\n</md-input-container><md-datepicker flex=\"35\" ng-model=\"ctrl.dateReceived\" md-placeholder=\"Received date\" \nmd-open-on-focus></md-datepicker><md-input-container layout=\"row\" flex class=\"md-block\"><label>City</label><input \ntype=\"text\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"33\" class=\"md-block\"><label>\nDepartment</label><md-select ng-model=\"search.department\"><md-option value=\"1\">Go</md-option><md-option value=\"2\">\nPlaster Room</md-option><md-option value=\"3\">3D - CT Scan</md-option><md-option value=\"4\">3D - Scanning</md-option>\n</md-select></md-input-container><md-input-container flex=\"33\" class=\"md-block\"><label>Status</label><md-select \nng-model=\"delivery.route\"><md-option value=\"1\">Awaiting Approval</md-option><md-option value=\"2\">Approved</md-option>\n<md-option value=\"3\">On Hold</md-option><md-option value=\"4\">On Stop</md-option><md-option value=\"5\">Waiting for Call\n</md-option></md-select></md-input-container></div><md-button class=\"md-primary md-raised\">Search</md-button><span>\n2 Order(s) Found</span><md-divider></md-divider><div layout=\"row\" class=\"md-dialog-content\"><table \nclass=\"simple tabela-pesquisa\" ms-responsive-table><thead><tr><th>Invoice No</th><th>Prescription No</th><th>City</th>\n<th>Country</th><th>Postcode</th><th>Practice Name</th><th>Practice No</th><th>Client</th><th>GDC No</th><th>\nPatient Name</th><th>Client Name</th></tr></thead><tbody><tr><td>I000846</td><td>C000982</td><td>London</td><td>England\n</td><td>N1 8TU</td><td>Dentux Dental</td><td>0633</td><td>James Burlett</td><td>68442</td><td>SN</td><td>IDH</td></tr>\n<tr><td>I000241</td><td>C000962</td><td>London</td><td>England</td><td>N1 1HX</td><td>Top Dental</td><td>0233</td><td>\nJohn Doe</td><td>91342</td><td>ST</td><td>PCT</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"save()\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/templates/approve.tpl.html","<md-dialog class=\"order-alert\" aria-label=\"Order Alert\" ngapp=\"caseType\"><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.iscustom\" \nng-init=\"vm.record.iscustom=\'0\'\"> <input type=\"hidden\" ng-model=\"vm.record.status_id\" \nng-init=\"vm.record.status_id=\'2\'\"> <input type=\"hidden\" ng-model=\"vm.record.orders_id\" \nng-init=\"vm.record.orders_id=id\"> <input type=\"hidden\" ng-model=\"vm.record.users_id\" \nng-init=\"vm.record.users_id=userid\"><md-toolbar class=\"approveorder-bg\"><div class=\"md-toolbar-tools\"><h2>Approve Order\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex \nmd-is-error=\"recordForm.description.$invalid && (recordForm.description.$touched || recordForm.$submitted)\"><label>\nMessage</label><textarea rows=\"5\" name=\"description\" ng-model=\"vm.record.description\" required></textarea><div \nng-messages=\"recordForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease insert a approval message.</span></div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"end center\"><div class=\"user\">{{username}}, {{data | date:\'dd/MM/yyyy H:m\'}}</div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button>\n<md-button class=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"recordForm.$valid && gravar(vm.record)\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/templates/cancelorder.tpl.html","<md-dialog class=\"order-alert\" aria-label=\"Order Alert\" ngapp=\"caseType\"><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.iscustom\" \nng-init=\"vm.record.iscustom=\'0\'\"> <input type=\"hidden\" ng-model=\"vm.record.status_id\" \nng-init=\"vm.record.status_id=\'1\'\"> <input type=\"hidden\" ng-model=\"vm.record.orders_id\" \nng-init=\"vm.record.orders_id=id\"> <input type=\"hidden\" ng-model=\"vm.record.users_id\" \nng-init=\"vm.record.users_id=userid\"><md-toolbar class=\"cancelorder-bg\"><div class=\"md-toolbar-tools\"><h2>Cancel Order\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex \nmd-is-error=\"recordForm.description.$invalid && (recordForm.description.$touched || recordForm.$submitted)\"><label>\nMessage</label><textarea rows=\"5\" name=\"description\" ng-model=\"vm.record.description\" required></textarea><div \nng-messages=\"recordForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease insert a cancelation message.</span></div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"end center\"><div class=\"user\">{{username}}, {{data | date:\'dd/MM/yyyy H:m\'}}</div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button>\n<md-button class=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"recordForm.$valid && gravar(vm.record)\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/templates/dldactions.html","<div class=\"dldactions-page\" layout=\"column\" layout-align=\"start center\"><div class=\"full-width\" \nng-repeat=\"action in vm.dldactions\"><div layout=\"row\" layout-align=\"start center\"><div class=\"department\"><strong>\nDepartment: </strong>{{action.department_name}}</div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"user\"><strong>User: </strong>{{action.name}}</div></div><div flex layout=\"row\" layout-align=\"start center\"><div \nclass=\"date\"><strong>Date/Time: </strong>{{action.date}}</div></div><md-divider class=\"margem-divisoria\"></md-divider>\n</div></div>");
$templateCache.put("app/main/templates/lab-doc-popup.html","<md-dialog class=\"order-alert\" aria-label=\"Add Lab Doc\" ng-cloak><form name=\"myForm\"><input type=\"hidden\" \nng-model=\"orders_id\" ng-init=\"orders_id=id\"> <input type=\"hidden\" ng-model=\"users_id\" ng-init=\"users_id=userid\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2>Add Lab Doc</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex \nlayout-align=\"start center\"><div ngf-drop ngf-select ng-model=\"files\" class=\"drop-box\" \nngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" accept=\"image/*,application/pdf\" \nngf-pattern=\"\'image/*,application/pdf\'\">Drop files here<br>or<br>click to upload</div><div ngf-no-file-drop>\nFile Drag/Drop is not supported for this browser</div></div><div layout=\"row\" flex layout-align=\"start center\" \nng-if=\"files\">File(s):<ul><li ng-repeat=\"f in files\" style=\"font:smaller\">{{f.name}} {{f.$error}} {{f.$errorParam}}\n</li></ul></div><div layout=\"row\" flex layout-align=\"start center\" ng-if=\"log\">Upload Log:<pre>{{log}}</pre></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Close</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/templates/labdoc.html","<div class=\"products\" layout=\"column\" layout-align=\"start center\" ng-cloak><div class=\"product-box full-width\"><div \nflex layout=\"row\" layout-align=\"start center\" ng-repeat=\"labdoc in vm.labdocs\"><a \nhref=\"app/main/uploads/{{labdoc.filename}}\" target=\"_blank\" title=\"Open {{labdoc.filename}}\"><md-input-container \nclass=\"md-block nomargin\"><input type=\"text\" value=\"{{labdoc.filetitle}}\" disabled=\"disabled\"></md-input-container></a>\n<a href=\"#\" ng-click=\"vm.removeLabDoc($event,labdoc.orders_lab_docs_id)\" title=\"Remove Lab Doc\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s12 md-font\" aria-hidden=\"true\" aria-label=\"Remove Lab Doc\"></md-icon></a>\n</div><div flex layout=\"row\" layout-align=\"end center\" ng-click=\"vm.addLabDoc($event)\"><div><md-button \nclass=\"md-icon-button botao-produtos\"><md-icon md-font-icon=\"icon-plus\" class=\"s12 md-font icon-plus botao-add\" \naria-hidden=\"true\"></md-icon></md-button></div><div><md-button class=\"md-icon-button botao-produtos\"><md-icon \nmd-font-icon=\"icon-file-document\" class=\"s24 md-font icon-file-document\" aria-hidden=\"true\"></md-icon></md-button>\n</div></div></div></div>");
$templateCache.put("app/main/templates/linkedorders.html","<div class=\"products\" layout=\"column\" layout-align=\"start center\"><div class=\"product-box full-width\"><div flex \nlayout=\"row\" layout-align=\"start center\" ng-repeat=\"linked in vm.linkedorders\"><md-input-container \nclass=\"md-block nomargin\"><input type=\"text\" value=\"Order No {{linked.ordernumber}}\" disabled=\"disabled\">\n</md-input-container><a href=\"#\" ng-click=\"vm.removeLinkedOrder($event,linked.orders_linked_id)\" title=\"Remove Order\">\n<md-icon md-font-icon=\"icon-window-close\" class=\"s12 md-font\" aria-hidden=\"true\" aria-label=\"Remove Order\"></md-icon>\n</a></div><div flex layout=\"row\" layout-align=\"end center\" ng-click=\"vm.addNewLinkOrder($event)\"><div><md-button \nclass=\"md-icon-button botao-produtos\"><md-icon md-font-icon=\"icon-plus\" class=\"s12 md-font icon-plus botao-add\" \naria-hidden=\"true\"></md-icon></md-button></div><div><md-button class=\"md-icon-button botao-produtos\"><md-icon \nmd-font-icon=\"icon-file-document\" class=\"s24 md-font icon-file-document\" aria-hidden=\"true\"></md-icon></md-button>\n</div></div></div></div>");
$templateCache.put("app/main/templates/order-alert.tpl.html","<md-dialog class=\"order-alert\" aria-label=\"Order Alert\" ngapp=\"caseType\"><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.iscustom\" \nng-init=\"vm.record.iscustom=\'1\'\"> <input type=\"hidden\" ng-model=\"vm.record.orders_id\" ng-init=\"vm.record.orders_id=id\">\n <input type=\"hidden\" ng-model=\"vm.record.users_id\" ng-init=\"vm.record.users_id=userid\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>New Custom Order Alert</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex \nlayout-align=\"start center\"><md-input-container flex class=\"md-block\" \nmd-is-error=\"recordForm.subject.$invalid && (recordForm.subject.$touched || recordForm.$submitted)\"><label>Subject\n</label><input type=\"text\" name=\"subject\" ng-model=\"vm.record.subject\" required><div \nng-messages=\"recordForm.subject.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert the subject.</span>\n</div></div></md-input-container></div><div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex \nmd-is-error=\"recordForm.description.$invalid && (recordForm.description.$touched || recordForm.$submitted)\"><label>\nMessage</label><textarea rows=\"5\" name=\"description\" ng-model=\"vm.record.description\" required></textarea><div \nng-messages=\"recordForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert the message.\n</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \ntype=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(vm.record)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/templates/ordercomments.html","<div class=\"ordercomments-page\" layout=\"column\" layout-align=\"start center\"><div class=\"full-width\" \nng-repeat=\"comment in vm.comments\"><div layout=\"row\" layout-align=\"start center\"><div class=\"comment\">\n{{comment.comment}}</div></div><div layout=\"row\" layout-align=\"end center\"><div class=\"user\">\n{{comment.name}}, {{comment.date}}</div></div><div class=\"margem-divisoria\"></div></div></div><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.orders_comments_id\" \nng-init=\"vm.record.orders_comments_id=\'0\'\"> <input type=\"hidden\" ng-model=\"vm.record.orders_id\" \nng-init=\"vm.record.orders_id=vm.id\"> <input type=\"hidden\" ng-model=\"vm.record.users_id\" \nng-init=\"vm.record.users_id=vm.userid\"><div class=\"ordercomments-add\" layout=\"row\" flex layout-align=\"start center\">\n<md-input-container flex \nmd-is-error=\"recordForm.comment.$invalid && (recordForm.comment.$touched || recordForm.$submitted)\"><label>Add Comment:\n</label><textarea rows=\"5\" name=\"comment\" ng-model=\"vm.record.comment\" required></textarea><div \nng-messages=\"recordForm.comment.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert a message.</span>\n</div></div></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-primary md-raised\" type=\"submit\" ng-click=\"recordForm.$valid && vm.addNewMessage(vm.record)\">Save</md-button>\n</div></form>");
$templateCache.put("app/main/templates/products.html","<div class=\"products\" layout=\"column\" layout-align=\"start center\"><div class=\"product-box full-width\"><div \nclass=\"product-option product-blue\">Upper</div><div class=\"md-raised md-button full-width\" aria-label=\"Treatment Plan\" \nlayout=\"row\" layout-align=\"start center\"><div flex layout=\"row\" layout-align=\"start center\"><label>Treatment Plan\n</label></div><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"s12 md-font icon-plus botao-add\" aria-hidden=\"true\"></md-icon><md-icon md-font-icon=\"icon-file-document\" \nclass=\"s24 md-font icon-file-document\" aria-hidden=\"true\"></md-icon></div></div><div \nclass=\"md-raised md-button full-width\" aria-label=\"Products\" layout=\"row\" layout-align=\"start center\"><div flex \nlayout=\"row\" layout-align=\"start center\"><label>Products</label></div></div></div><div class=\"product-box full-width\">\n<div class=\"product-option product-blue\">Lower</div><div class=\"md-raised md-button full-width\" \naria-label=\"Treatment Plan\" layout=\"row\" layout-align=\"start center\"><div flex layout=\"row\" \nlayout-align=\"start center\"><label><div class=\"info-small\"><span style=\"font-size:smaller\">Products</span></div><div \nclass=\"info-normal\">Clear Products</div></label></div><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-click=\"vm.removeProducts($event,id)\" md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font icon-window-close botao-add\" aria-hidden=\"true\"></md-icon></div></div><table \nclass=\"simple products-lower\" ms-responsive><thead><tr><td width=\"50%\">Products</td><td width=\"10%\">Qty</td><td \nwidth=\"10%\">Discount</td><td width=\"25%\">Price</td><td width=\"5%\"></td></tr></thead><tbody><tr \nng-repeat=\"product in vm.products\"><td><md-input-container class=\"md-block\" title=\"{{product.product_description}}\">\n<input type=\"text\" name=\"product_description\" ng-model=\"product.product_description\" disabled=\"disabled\" \naria-label=\"Product\"></md-input-container></td><td><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"product_qty\" ng-model=\"product.product_qty\" disabled=\"disabled\" aria-label=\"Quantity\"></md-input-container></td>\n<td><md-input-container class=\"md-block\"><input type=\"text\" name=\"product_discount\" \nng-model=\"product.product_discount\" disabled=\"disabled\" aria-label=\"Discount\"></md-input-container></td><td>\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"rate\" ng-model=\"product.rate\" disabled=\"disabled\" \naria-label=\"Price\"></md-input-container></td><td><a href=\"#\" \nng-click=\"vm.removeProduct($event,product.orders_product_id)\" title=\"Remove Product\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s20 md-font remove-product\" aria-hidden=\"true\" aria-label=\"Remove Product\">\n</md-icon></a></td></tr></tbody></table><div flex layout=\"row\" layout-align=\"end center\" \nng-click=\"vm.addNewProduct($event)\"><div><md-button class=\"md-icon-button botao-produtos\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"s12 md-font icon-plus botao-add\" aria-hidden=\"true\"></md-icon></md-button></div><div>\n<md-button class=\"md-icon-button botao-produtos\"><md-icon md-font-icon=\"icon-file-document\" \nclass=\"s24 md-font icon-file-document\" aria-hidden=\"true\"></md-icon></md-button></div></div></div><div \nclass=\"product-box full-width\"><div class=\"product-option product-grey\">Delivery</div><div \nclass=\"md-raised md-button full-width\" aria-label=\"Delivery\" layout=\"row\" layout-align=\"start center\" \nng-click=\"vm.addNewDeliveryRoute($event)\"><div flex layout=\"row\" class=\"pointer\" layout-align=\"start center\"><label>\nDelivery Route</label></div><div flex layout=\"row\" layout-align=\"end center\"><div><md-icon md-font-icon=\"icon-plus\" \nclass=\"s12 md-font icon-plus botao-add\" aria-hidden=\"true\"></md-icon></div><div><md-icon \nmd-font-icon=\"icon-file-document\" class=\"s24 md-font icon-file-document\" aria-hidden=\"true\"></md-icon></div></div>\n</div><table class=\"simple products-delivery\" ms-responsive ng-if=\"vm.id!=0\"><thead><tr><td width=\"80%\"></td><td \nwidth=\"20%\">Cost</td><td width=\"5%\"></td></tr></thead><tbody><tr><td><md-input-container class=\"md-block\" \nng-repeat=\"delivery in vm.order\" ng-if=\"delivery.deliveryroutes_id!=0\"><input type=\"text\" value=\"{{delivery.route}}\" \ndisabled=\"disabled\" aria-label=\"Delivery Route\"></md-input-container></td><td><md-input-container class=\"md-block\" \nng-repeat=\"delivery in vm.order\" ng-if=\"delivery.deliveryroutes_id!=0\"><input type=\"text\" value=\"{{delivery.rate}}\" \ndisabled=\"disabled\" aria-label=\"Cost\"></md-input-container></td><td><a href=\"#\" title=\"Remove Delivery Route\" \nng-click=\"vm.removeDeliveryRoute($event)\" ng-repeat=\"delivery in vm.order\" ng-if=\"delivery.deliveryroutes_id!=0\">\n<md-icon md-font-icon=\"icon-window-close\" class=\"s12 md-font remove-product\" aria-hidden=\"true\" \naria-label=\"Remove Product\"></md-icon></a></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/templates/search.tpl.html","<md-dialog aria-label=\"Search\" ngapp=\"caseType\"><form ng-cloak class=\"casetype\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Search</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-button \nclass=\"md-primary md-raised\">Scan</md-button><md-icon md-font-icon=\"icon-barcode\" \nclass=\"s48 md-default-theme md-font material-icons icon-barcode\" aria-hidden=\"true\"></md-icon><div layout=\"row\" \nlayout-align=\"start center\"><md-datepicker flex=\"20\" ng-model=\"ctrl.startDate\" md-placeholder=\"Start date\" \nmd-open-on-focus></md-datepicker><md-datepicker flex=\"20\" ng-model=\"ctrl.endDate\" md-placeholder=\"End date\" \nmd-open-on-focus></md-datepicker><md-input-container layout=\"row\" flex=\"30\" class=\"md-block\"><label>Client</label>\n<input type=\"text\"></md-input-container><md-input-container layout=\"row\" flex=\"30\" class=\"md-block\"><label>City</label>\n<input type=\"text\"></md-input-container></div><div layout=\"row\"><md-input-container flex class=\"md-block\"><label>\nOrder No</label><input type=\"text\"></md-input-container><md-input-container flex class=\"md-block\"><label>Patient Name\n</label><input type=\"text\"></md-input-container><md-input-container flex class=\"md-block\"><label>Country</label><input \ntype=\"text\"></md-input-container></div><div layout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>\nPerscription No</label><input type=\"text\"></md-input-container><md-datepicker flex=\"35\" ng-model=\"ctrl.dateReceived\" \nmd-placeholder=\"Received date\" md-open-on-focus></md-datepicker><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>City</label><input type=\"text\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"33\" \nclass=\"md-block\"><label>Department</label><md-select ng-model=\"search.department\"><md-option value=\"1\">Go</md-option>\n<md-option value=\"2\">Plaster Room</md-option><md-option value=\"3\">3D - CT Scan</md-option><md-option value=\"4\">\n3D - Scanning</md-option></md-select></md-input-container><md-input-container flex=\"33\" class=\"md-block\"><label>Status\n</label><md-select ng-model=\"delivery.route\"><md-option value=\"1\">Awaiting Approval</md-option><md-option value=\"2\">\nApproved</md-option><md-option value=\"3\">On Hold</md-option><md-option value=\"4\">On Stop</md-option><md-option \nvalue=\"5\">Waiting for Call</md-option></md-select></md-input-container></div><md-button class=\"md-primary md-raised\">\nSearch</md-button><span>2 Order(s) Found</span><md-divider></md-divider><div layout=\"row\" class=\"md-dialog-content\">\n<table class=\"simple tabela-pesquisa\" ms-responsive-table><thead><tr><th>Invoice No</th><th>Prescription No</th><th>\nCity</th><th>Country</th><th>Postcode</th><th>Practice Name</th><th>Practice No</th><th>Client</th><th>GDC No</th><th>\nPatient Name</th><th>Client Name</th></tr></thead><tbody><tr><td>I000846</td><td>C000982</td><td>London</td><td>England\n</td><td>N1 8TU</td><td>Dentux Dental</td><td>0633</td><td>James Burlett</td><td>68442</td><td>SN</td><td>IDH</td></tr>\n<tr><td>I000241</td><td>C000962</td><td>London</td><td>England</td><td>N1 1HX</td><td>Top Dental</td><td>0233</td><td>\nJohn Doe</td><td>91342</td><td>ST</td><td>PCT</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"cancel()\">Close</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/templates/wfc.tpl.html","<md-dialog class=\"order-alert\" aria-label=\"Order Alert\" ngapp=\"caseType\"><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.iscustom\" \nng-init=\"vm.record.iscustom=\'0\'\"> <input type=\"hidden\" ng-model=\"vm.record.status_id\" \nng-init=\"vm.record.status_id=\'4\'\"> <input type=\"hidden\" ng-model=\"vm.record.orders_id\" \nng-init=\"vm.record.orders_id=id\"> <input type=\"hidden\" ng-model=\"vm.record.users_id\" \nng-init=\"vm.record.users_id=userid\"><md-toolbar class=\"wfc-bg\"><div class=\"md-toolbar-tools\"><h2>Waiting for Call</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex \nmd-is-error=\"recordForm.description.$invalid && (recordForm.description.$touched || recordForm.$submitted)\"><label>\nMessage</label><textarea rows=\"5\" name=\"description\" ng-model=\"vm.record.description\" required></textarea><div \nng-messages=\"recordForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert the message.\n</span></div></div></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><div class=\"user\">\n{{username}}, {{data | date:\'dd/MM/yyyy H:m\'}}</div></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(vm.record)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/templates/wfi.tpl.html","<md-dialog class=\"order-alert\" aria-label=\"Order Alert\" ngapp=\"caseType\"><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.iscustom\" \nng-init=\"vm.record.iscustom=\'0\'\"> <input type=\"hidden\" ng-model=\"vm.record.status_id\" \nng-init=\"vm.record.status_id=\'3\'\"> <input type=\"hidden\" ng-model=\"vm.record.orders_id\" \nng-init=\"vm.record.orders_id=id\"> <input type=\"hidden\" ng-model=\"vm.record.users_id\" \nng-init=\"vm.record.users_id=userid\"><md-toolbar class=\"wfi-bg\"><div class=\"md-toolbar-tools\"><h2>\nWaiting for Impressions</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\">\n<md-input-container flex \nmd-is-error=\"recordForm.description.$invalid && (recordForm.description.$touched || recordForm.$submitted)\"><label>\nMessage</label><textarea rows=\"5\" name=\"description\" ng-model=\"vm.record.description\" required></textarea><div \nng-messages=\"recordForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert the message.\n</span></div></div></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><div class=\"user\">\n{{username}}, {{data | date:\'dd/MM/yyyy H:m\'}}</div></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(vm.record)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" ms-scroll \nng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\">{{vm.title}}</span></div><md-icon \nclass=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\">\n</md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\">\n</ms-navigation>");
$templateCache.put("app/main/apps/scrumboard/scrumboard.html","<div id=\"scrumboard\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"cabecalho cor-marketing\" \nlayout=\"row\" layout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"wherepage\" layout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" \nhref=\"/dashboard.html\"><md-icon md-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" \naria-hidden=\"true\"></md-icon></a><span class=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Marketing\n</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\"></div></div><div class=\"topo\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Marketing</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Events / Tasks</span></div></div><div flex=\"50\" layout=\"row\" \nlayout-align=\"end center\"></div></div><div class=\"header\" layout=\"column\"><div class=\"header-content\" layout=\"row\" \nlayout-align=\"center center\" layout-wrap flex><div class=\"toolbar\" layout=\"row\" layout-align=\"center center\"><md-button\n class=\"md-icon-button\" ui-sref=\"app.scrumboard.boards.board.calendar\" \nng-hide=\"\'app.scrumboard.boards.board.calendar\' | isState\" aria-label=\"Calendar\" translate \ntranslate-attr-aria-label=\"SB.CALENDAR\"><md-icon md-font-icon=\"icon-calendar\"></md-icon><md-tooltip><span \ntranslate=\"SB.CALENDAR\">Calendar</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nui-sref=\"app.scrumboard.boards.board\" ng-hide=\"\'app.scrumboard.boards.board\' | isState\" aria-label=\"Board\" translate \ntranslate-attr-aria-label=\"SB.BOARD\"><md-icon md-font-icon=\"icon-trello\"></md-icon><md-tooltip><span \ntranslate=\"SB.BOARD\">Board</span></md-tooltip></md-button><md-button ng-if=\"vm.filteringIsOn()\" class=\"md-icon-button\" \nng-click=\"vm.clearFilters()\" aria-label=\"Clear Filters\" translate translate-attr-aria-label=\"SB.CLEAR_FILTERS\"><md-icon\n md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip sb.clear_filters>Clear Filters</md-tooltip></md-button>\n<md-button class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'filters-sidenav\')\" aria-label=\"Filter Cards\" translate \ntranslate-attr-aria-label=\"SB.FILTER_CARDS\"><md-icon md-font-icon=\"icon-filter-variant\"></md-icon><md-tooltip><span \ntranslate=\"SB.FILTER_CARDS\">Filter Events/Tasks</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'settings-sidenav\')\" aria-label=\"Settings\" translate \ntranslate-attr-aria-label=\"SB.SETTINGS\"><md-icon md-font-icon=\"icon-cog\"></md-icon><md-tooltip><span \ntranslate=\"SB.SETTINGS\">Settings</span></md-tooltip></md-button></div></div></div><div \nng-show=\"vm.boardSelectorVisible\" id=\"board-selector\" \nclass=\"md-accent-bg animate-slide-down board-list md-whiteframe-3dp\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"board-list-item\" ng-repeat=\"board in vm.boardList\" \nui-sref=\"app.scrumboard.boards.board({id:board.id, uri:board.uri})\" layout=\"column\" \nlayout-align=\"space-between center\"><div class=\"board-icon\"><i class=\"icon-trello s64\"></i></div><div flex \nclass=\"board-name\">{{board.name}}</div><div class=\"board-options\"><i class=\"icon-dots-horizontal\"></i></div><div \nng-if=\"board.id === vm.board.id\" class=\"selected-icon green-bg\"><i class=\"icon-check s24\"></i></div></div><div \nclass=\"board-list-item add-new-board\" ui-sref=\"app.scrumboard.boards.addBoard\" ui-sref-active=\"hidden\" layout=\"column\" \nlayout-align=\"space-between center\"><div class=\"board-icon\"><i class=\"icon-trello s64\"></i></div><div flex \nclass=\"board-name\" translate=\"SB.ADD_NEW_BOARD\">Add New Board</div></div></div><md-backdrop \nclass=\"board-selector-backdrop md-dialog-backdrop md-opaque\" ng-show=\"vm.boardSelectorVisible\" \nng-click=\"vm.boardSelectorVisible = false\" aria-hidden=\"true\"></md-backdrop><md-content class=\"content\" flex \nlayout=\"column\" ui-view=\"scrumboardContent\"></md-content><md-sidenav class=\"settings-sidenav md-sidenav-right\" \nmd-component-id=\"settings-sidenav\" ng-include=\"\'app/main/apps/scrumboard/sidenavs/settings/settings-sidenav.html\'\" \nng-controller=\"SettingsSidenavController as vm\" ms-sidenav-helper></md-sidenav><md-sidenav \nclass=\"filters-sidenav md-sidenav-right\" md-component-id=\"filters-sidenav\" \nng-include=\"\'app/main/apps/scrumboard/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"FiltersSidenavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/pages/analytics3d/analytics3d.html","<div id=\"pagina-analytics\" flex layout=\"column\"><div id=\"pagina-section\"><div class=\"cabecalho cor-analytics\" flex \nlayout=\"row\" layout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"wherepage\" layout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" \nhref=\"/dashboard.html\"><md-icon md-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" \naria-hidden=\"true\"></md-icon></a><span class=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Analytics\n</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\"></div></div><div class=\"topo\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Analytics</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">3D</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\"></div>\n</div><div layout=\"row\" layout-align=\"center center\"><div class=\"cor-analytics-sub md-padding\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-primary md-raised\" ng-click=\"vm.openPage(\'analyticsmd\')\">MD\n</md-button><md-button class=\"md-primary md-raised\" ng-click=\"vm.openPage(\'analyticsinman\')\">Inman</md-button>\n<md-button class=\"md-primary md-raised\" ng-click=\"vm.openPage(\'analyticsclears\')\">Clears</md-button><md-button \nclass=\"md-primary md-raised\" ng-disabled=\"true\">3D</md-button><md-button class=\"md-primary md-raised\" \nng-click=\"vm.openPage(\'analyticsaccounts\')\">Accounts</md-button><md-button class=\"md-primary md-raised\" \nng-click=\"vm.openPage(\'analyticspoints\')\">Points</md-button></div></div><div id=\"points-page\" class=\"points-page\"><div \nlayout=\"row\"><div flex=\"33\"><div class=\"md-title md-padding cor-texto-analytics\">Top 10 Clients</div><ms-card flex \nclass=\"nomaxwidth\" template=\"\'app/templates/cards/analytics/sections/top10clients.html\'\" view-model=\"vm\"></ms-card>\n</div><div flex=\"33\"><div class=\"md-title md-padding cor-texto-analytics\">Technicians Orders</div><ms-card flex \nclass=\"nomaxwidth\" template=\"\'app/templates/cards/analytics/sections/tecorders.html\'\" view-model=\"vm\"></ms-card></div>\n<div flex><div layout=\"row\"><div flex=\"80\" layout=\"row\" class=\"md-title md-padding cor-texto-analytics\" \nlayout-align=\"start center\">Top 5 Tecs</div><div flex=\"20\" layout=\"row\" layout-align=\"center center\"><a href=\"#\" \nng-click=\"vm.autoPrintPage()\"><md-icon md-font-icon=\"icon-printer\" class=\"s24 md-font icon-printer pointer\" \naria-hidden=\"true\"></md-icon><md-tooltip md-direction=\"top\">Click to print 3D page</md-tooltip></a></div></div><ms-card\n flex class=\"nomaxwidth\" template=\"\'app/templates/cards/analytics/sections/top5tecs.html\'\" view-model=\"vm\"></ms-card>\n</div></div></div></div></div>");
$templateCache.put("app/main/pages/analyticsaccounts/analyticsaccounts.html","<div id=\"pagina-analytics\" flex layout=\"column\"><div class=\"cabecalho cor-analytics\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Analytics</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"></div></div><div class=\"topo\" layout=\"row\" layout-align=\"space-between center\">\n<div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" layout=\"row\" \nlayout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Analytics</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Accounts</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\">\n</div></div><div layout=\"row\" layout-align=\"center center\"><div class=\"cor-analytics-sub md-padding\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-primary md-raised\" ng-click=\"vm.openPage(\'analyticsmd\')\">MD\n</md-button><md-button class=\"md-primary md-raised\" ng-click=\"vm.openPage(\'analyticsinman\')\">Inman</md-button>\n<md-button class=\"md-primary md-raised\" ng-click=\"vm.openPage(\'analyticsclears\')\">Clears</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.openPage(\'analytics3d\')\">3D</md-button><md-button \nclass=\"md-primary md-raised\" ng-disabled=\"true\">Accounts</md-button><md-button class=\"md-primary md-raised\" \nng-click=\"vm.openPage(\'analyticspoints\')\">Points</md-button></div></div><div class=\"reports-page\"><div layout=\"row\">\n<div flex=\"40\"><div class=\"md-title md-padding cor-texto-analytics\">Clients</div><div layout=\"row\"><div flex=\"50\"><div \nclass=\"md-title md-padding cor-texto-analytics\">Total Clients</div><ms-card flex class=\"nomaxwidth\" \ntemplate=\"\'app/templates/cards/analytics/accounts/totalclients.html\'\" view-model=\"vm\"></ms-card></div><div flex=\"50\">\n<div class=\"md-title md-padding cor-texto-analytics\">Past Month Active Clients</div><ms-card flex class=\"nomaxwidth\" \ntemplate=\"\'app/templates/cards/analytics/accounts/pastmonthclients.html\'\" view-model=\"vm\"></ms-card></div></div><div \nlayout=\"row\"><div flex=\"50\"><div class=\"md-title md-padding cor-texto-analytics\">Active Clients</div><ms-card flex \nclass=\"nomaxwidth\" template=\"\'app/templates/cards/analytics/accounts/activeclients.html\'\" view-model=\"vm\"></ms-card>\n</div><div flex=\"50\"><div class=\"md-title md-padding cor-texto-analytics\">Inactive Clients</div><ms-card flex \nclass=\"nomaxwidth\" template=\"\'app/templates/cards/analytics/accounts/inactiveclients.html\'\" view-model=\"vm\"></ms-card>\n</div></div></div><div flex><div class=\"md-title md-padding cor-texto-analytics\">Top 10 Clients</div><div \nlayout=\"row full-width\"><ms-card flex class=\"nomaxwidth\" \ntemplate=\"\'app/templates/cards/analytics/accounts/top10clients.html\'\" view-model=\"vm\"></ms-card></div></div></div>\n</div></div>");
$templateCache.put("app/main/pages/analyticsclears/analyticsclears.html","<div id=\"pagina-analytics\" flex layout=\"column\"><div id=\"pagina-section\"><div class=\"cabecalho cor-analytics\" flex \nlayout=\"row\" layout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"wherepage\" layout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" \nhref=\"/dashboard.html\"><md-icon md-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" \naria-hidden=\"true\"></md-icon></a><span class=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Analytics\n</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\"></div></div><div class=\"topo\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Analytics</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Clears</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\">\n</div></div><div layout=\"row\" layout-align=\"center center\"><div class=\"cor-analytics-sub md-padding\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-primary md-raised\" ng-click=\"vm.openPage(\'analyticsmd\')\">MD\n</md-button><md-button class=\"md-primary md-raised\" ng-click=\"vm.openPage(\'analyticsinman\')\">Inman</md-button>\n<md-button class=\"md-primary md-raised\" ng-disabled=\"true\">Clears</md-button><md-button class=\"md-primary md-raised\" \nng-click=\"vm.openPage(\'analytics3d\')\">3D</md-button><md-button class=\"md-primary md-raised\" \nng-click=\"vm.openPage(\'analyticsaccounts\')\">Accounts</md-button><md-button class=\"md-primary md-raised\" \nng-click=\"vm.openPage(\'analyticspoints\')\">Points</md-button></div></div><div id=\"points-page\" class=\"points-page\"><div \nlayout=\"row\"><div flex=\"33\"><div class=\"md-title md-padding cor-texto-analytics\">Top 10 Clients</div><ms-card flex \nclass=\"nomaxwidth\" template=\"\'app/templates/cards/analytics/sections/top10clients.html\'\" view-model=\"vm\"></ms-card>\n</div><div flex=\"33\"><div class=\"md-title md-padding cor-texto-analytics\">Technicians Orders</div><ms-card flex \nclass=\"nomaxwidth\" template=\"\'app/templates/cards/analytics/sections/tecorders.html\'\" view-model=\"vm\"></ms-card></div>\n<div flex><div layout=\"row\"><div flex=\"80\" layout=\"row\" class=\"md-title md-padding cor-texto-analytics\" \nlayout-align=\"start center\">Top 5 Tecs</div><div flex=\"20\" layout=\"row\" layout-align=\"center center\"><a href=\"#\" \nng-click=\"vm.autoPrintPage()\"><md-icon md-font-icon=\"icon-printer\" class=\"s24 md-font icon-printer pointer\" \naria-hidden=\"true\"></md-icon><md-tooltip md-direction=\"top\">Click to print 3D page</md-tooltip></a></div></div><ms-card\n flex class=\"nomaxwidth\" template=\"\'app/templates/cards/analytics/sections/top5tecs.html\'\" view-model=\"vm\"></ms-card>\n</div></div></div></div></div>");
$templateCache.put("app/main/pages/analyticsinman/analyticsinman.html","<div id=\"pagina-analytics\" flex layout=\"column\"><div id=\"pagina-section\"><div class=\"cabecalho cor-analytics\" flex \nlayout=\"row\" layout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"wherepage\" layout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" \nhref=\"/dashboard.html\"><md-icon md-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" \naria-hidden=\"true\"></md-icon></a><span class=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Analytics\n</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\"></div></div><div class=\"topo\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Analytics</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Inman</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\">\n</div></div><div layout=\"row\" layout-align=\"center center\"><div class=\"cor-analytics-sub md-padding\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-primary md-raised\" ng-click=\"vm.openPage(\'analyticsmd\')\">MD\n</md-button><md-button class=\"md-primary md-raised\" ng-disabled=\"true\">Inman</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.openPage(\'analyticsclears\')\">Clears</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.openPage(\'analytics3d\')\">3D</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.openPage(\'analyticsaccounts\')\">Accounts</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.openPage(\'analyticspoints\')\">Points</md-button></div></div><div \nid=\"points-page\" class=\"points-page\"><div layout=\"row\"><div flex=\"33\"><div \nclass=\"md-title md-padding cor-texto-analytics\">Top 10 Clients</div><ms-card flex class=\"nomaxwidth\" \ntemplate=\"\'app/templates/cards/analytics/sections/top10clients.html\'\" view-model=\"vm\"></ms-card></div><div flex=\"33\">\n<div class=\"md-title md-padding cor-texto-analytics\">Technicians Orders</div><ms-card flex class=\"nomaxwidth\" \ntemplate=\"\'app/templates/cards/analytics/sections/tecorders.html\'\" view-model=\"vm\"></ms-card></div><div flex><div \nlayout=\"row\"><div flex=\"80\" layout=\"row\" class=\"md-title md-padding cor-texto-analytics\" layout-align=\"start center\">\nTop 5 Tecs</div><div flex=\"20\" layout=\"row\" layout-align=\"center center\"><a href=\"#\" ng-click=\"vm.autoPrintPage()\">\n<md-icon md-font-icon=\"icon-printer\" class=\"s24 md-font icon-printer pointer\" aria-hidden=\"true\"></md-icon><md-tooltip \nmd-direction=\"top\">Click to print 3D page</md-tooltip></a></div></div><ms-card flex class=\"nomaxwidth\" \ntemplate=\"\'app/templates/cards/analytics/sections/top5tecs.html\'\" view-model=\"vm\"></ms-card></div></div></div></div>\n</div>");
$templateCache.put("app/main/pages/analyticsmd/analyticsmd.html","<div id=\"pagina-analytics\" flex layout=\"column\"><div class=\"cabecalho cor-analytics\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Analytics</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"></div></div><div class=\"topo\" layout=\"row\" layout-align=\"space-between center\">\n<div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" layout=\"row\" \nlayout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Analytics</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">MD</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\"></div>\n</div><div layout=\"row\" layout-align=\"center center\"><div class=\"cor-analytics-sub md-padding\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-primary md-raised\" ng-disabled=\"true\">MD</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.openPage(\'analyticsinman\')\">Inman</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.openPage(\'analyticsclears\')\">Clears</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.openPage(\'analytics3d\')\">3D</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.openPage(\'analyticsaccounts\')\">Accounts</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.openPage(\'analyticspoints\')\">Points</md-button></div></div><div \nclass=\"reports-page\"><div layout=\"row\"><div flex=\"35\"><div class=\"md-title md-padding cor-texto-analytics\">Employees\n</div><ms-card flex class=\"nomaxwidth\" template=\"\'app/templates/cards/analytics/md/employees.html\'\" view-model=\"vm\">\n</ms-card></div><div flex><div layout=\"row\"><div flex=\"50\"><div class=\"md-title md-padding cor-texto-analytics\">\nNew Orders</div><ms-card flex class=\"nomaxwidth\" template=\"\'app/templates/cards/analytics/md/neworders.html\'\" \nview-model=\"vm\"></ms-card></div><div flex=\"50\"><div class=\"md-title md-padding cor-texto-analytics\">Orders On WFI</div>\n<ms-card flex class=\"nomaxwidth\" template=\"\'app/templates/cards/analytics/md/orderswfi.html\'\" view-model=\"vm\">\n</ms-card></div></div><div layout=\"row\"><div flex=\"50\"><div class=\"md-title md-padding cor-texto-analytics\">Orders Due\n</div><ms-card flex class=\"nomaxwidth\" template=\"\'app/templates/cards/analytics/md/ordersdue.html\'\" view-model=\"vm\">\n</ms-card></div><div flex=\"50\"><div class=\"md-title md-padding cor-texto-analytics\">Orders On Stop</div><ms-card flex \nclass=\"nomaxwidth\" template=\"\'app/templates/cards/analytics/md/ordersonstop.html\'\" view-model=\"vm\"></ms-card></div>\n</div><div layout=\"row\"><div flex=\"50\"><div class=\"md-title md-padding cor-texto-analytics\">Orders Completed</div>\n<ms-card flex class=\"nomaxwidth\" template=\"\'app/templates/cards/analytics/md/completedorders.html\'\" view-model=\"vm\">\n</ms-card></div><div flex=\"50\"><div class=\"md-title md-padding cor-texto-analytics\">Orders On Wait for Call</div>\n<ms-card flex class=\"nomaxwidth\" template=\"\'app/templates/cards/analytics/md/orderswfc.html\'\" view-model=\"vm\">\n</ms-card></div></div></div><div flex=\"35\"><div class=\"md-title md-padding cor-texto-analytics\">Finances</div><div \nlayout=\"row\"><div flex><ms-card flex class=\"nomaxwidth\" template=\"\'app/templates/cards/analytics/md/bankbalance.html\'\" \nview-model=\"vm\"></ms-card></div><div flex><ms-card flex class=\"nomaxwidth\" \ntemplate=\"\'app/templates/cards/analytics/md/financesincome.html\'\" view-model=\"vm\"></ms-card></div><div flex><ms-card \nflex class=\"nomaxwidth\" template=\"\'app/templates/cards/analytics/md/moneyowed.html\'\" view-model=\"vm\"></ms-card></div>\n</div><div layout=\"row\"><div flex><ms-card flex class=\"nomaxwidth\" \ntemplate=\"\'app/templates/cards/analytics/md/totaldebt.html\'\" view-model=\"vm\"></ms-card></div><div flex><ms-card flex \nclass=\"nomaxwidth\" template=\"\'app/templates/cards/analytics/md/expenditure.html\'\" view-model=\"vm\"></ms-card></div>\n</div><ms-card flex class=\"nomaxwidth\" template=\"\'app/templates/cards/analytics/md/total.html\'\" view-model=\"vm\">\n</ms-card></div></div></div></div>");
$templateCache.put("app/main/pages/analyticspoints/analyticspoints.html","<div id=\"pagina-analytics\" flex layout=\"column\"><div id=\"pagina-points\"><div class=\"cabecalho cor-analytics\" flex \nlayout=\"row\" layout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"wherepage\" layout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" \nhref=\"/dashboard.html\"><md-icon md-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" \naria-hidden=\"true\"></md-icon></a><span class=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Analytics\n</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\"></div></div><div class=\"topo\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Analytics</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Points</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\">\n</div></div><div layout=\"row\" layout-align=\"center center\"><div class=\"cor-analytics-sub md-padding\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-primary md-raised\" ng-click=\"vm.openPage(\'analyticsmd\')\">MD\n</md-button><md-button class=\"md-primary md-raised\" ng-click=\"vm.openPage(\'analyticsinman\')\">Inman</md-button>\n<md-button class=\"md-primary md-raised\" ng-click=\"vm.openPage(\'analyticsclears\')\">Clears</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.openPage(\'analytics3d\')\">3D</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.openPage(\'analyticsaccounts\')\">Accounts</md-button><md-button \nclass=\"md-primary md-raised\" ng-disabled=\"true\">Points</md-button></div></div><div id=\"points-page\" \nclass=\"points-page\"><div layout=\"row\"><div flex=\"50\"><div class=\"md-title md-padding cor-texto-analytics\">\nPoints Per Date</div><ms-card flex class=\"nomaxwidth\" \ntemplate=\"\'app/templates/cards/analytics/points/pointsperdate.html\'\" view-model=\"vm\"></ms-card></div><div flex><div \nlayout=\"row\"><div flex=\"80\" layout=\"row\" class=\"md-title md-padding cor-texto-analytics\" layout-align=\"start center\">\nPoints per Tec</div><div flex=\"20\" layout=\"row\" layout-align=\"center center\"><a href=\"#\" ng-click=\"vm.autoPrintPage()\">\n<md-icon md-font-icon=\"icon-printer\" class=\"s24 md-font icon-printer pointer\" aria-hidden=\"true\"></md-icon><md-tooltip \nmd-direction=\"top\">Click to print Points page</md-tooltip></a></div></div><ms-card flex class=\"nomaxwidth\" \ntemplate=\"\'app/templates/cards/analytics/points/pointspertec.html\'\" view-model=\"vm\"></ms-card></div></div></div></div>\n</div>");
$templateCache.put("app/main/pages/checkinout/checkinout.html","<div id=\"pagina-consolidation\" flex layout=\"column\"><div class=\"cabecalho cor-lab\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">NimroDENTAL Lab</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"></div></div><div class=\"topo\" layout=\"row\" layout-align=\"start center\"><div \nflex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" layout=\"row\" layout-align=\"start center\"><a\n aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span class=\"font-size-16 font-weight-300\">Dashboard\n</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Check In / Out</span></div></div><div flex=\"50\" layout=\"row\" \nlayout-align=\"end center\"></div></div><div class=\"pagina-orderstatus\" layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-primary md-raised\" ng-class=\"vm.type != 1 ? \'md-primary\' : \'no-pointer\'\" \nng-click=\"vm.changeType(1)\">Check In / Out</md-button><md-button class=\"md-primary md-raised\" \nng-class=\"vm.type != 2 ? \'md-primary\' : \'no-pointer\'\" ng-click=\"vm.changeType(2)\">Not Checked In</md-button></div><div \nclass=\"pagina-orderstatus\"><md-button layout=\"row\" layout-align=\"center center\" class=\"md-primary md-raised\" \nng-click=\"vm.reset()\">Reset</md-button><div layout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>\nStart date (yyyy-mm-dd)</label><input type=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.startDate\" \nng-change=\"vm.searchTable(vm.startDate, 7)\" ng-model-options=\"{ debounce: 750 }\" ng-disabled=\"vm.searchdisable\">\n</md-input-container><md-input-container layout=\"row\" flex class=\"md-block\"><label>End date (yyyy-mm-dd)</label><input \ntype=\"text\" name=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.endDate\" ng-change=\"vm.searchTable(vm.endDate, 8)\" \nng-model-options=\"{ debounce: 750 }\" ng-disabled=\"vm.searchdisable\"></md-input-container><md-input-container \nlayout=\"row\" flex class=\"md-block\"><label>On Date (yyyy-mm-dd)</label><input type=\"text\" name=\"onDate\" \nmask=\"9999-19-39\" ng-model=\"vm.onDate\" ng-change=\"vm.searchTable(vm.onDate, 0)\" ng-model-options=\"{ debounce: 750 }\">\n</md-input-container></div><div layout=\"row\"><md-input-container flex class=\"md-block\"><label>Code</label><input \nname=\"code\" ng-model=\"vm.search.code\" ng-change=\"vm.searchTable(vm.search.code, 1)\" type=\"text\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>User Name</label><input name=\"name\" \nng-model=\"vm.search.name\" ng-change=\"vm.searchTable(vm.search.name, 2)\" type=\"text\"></md-input-container>\n<md-input-container flex class=\"md-block\"><label>User Level</label><md-select name=\"levels_id\" \nng-model=\"vm.search.levels_id\" ng-change=\"vm.searchTable(vm.search.levels_id, 5)\"><md-option value=\"\">All</md-option>\n<md-option ng-repeat=\"levelz in vm.levels\" ng-value=\"levelz.levels_id\">{{levelz.level}}</md-option></md-select>\n</md-input-container><md-input-container flex class=\"md-block\"><label>Job Title</label><input name=\"jobtitle\" \nng-model=\"vm.search.jobtitle\" ng-change=\"vm.searchTable(vm.search.jobtitle, 6)\" type=\"text\"></md-input-container></div>\n</div><div class=\"pagina-orderstatus full-width\" layout=\"row\" layout-align=\"space-between center\"><table datatable=\"\" \nclass=\"row-border hover full-width\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\">\n</table></div></div>");
$templateCache.put("app/main/pages/checkinoutsystem/checkin.html","<md-dialog flex=\"20\" class=\"adddeliveryroute\" aria-label=\"Scan Order\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2>Scan User Code</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><h3>Scan your ID barcode or insert user code</h3><div layout=\"row\" flex \nlayout-align=\"start center\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>User Code</label><input \ntype=\"text\" required md-autofocus name=\"scanusercode\" minlength=\"2\" ng-model=\"vm.scanusercode\" check-in \nng-model-options=\"{ debounce: 500 }\"><div ng-messages=\"recordForm.scanusercode.$error\"><div ng-message=\"required\">\nPlease scan ID barcode or insert an User Code, starting with *</div><div ng-message=\"minlength\">\nUser Code is short. Please insert at least 2 characters.</div><div ng-message=\"erro\">Error! See message.</div></div>\n<div ng-if=\"recordForm.scanusercode.$pending\">Trying to checking in, please wait...</div><div \nng-if=\"recordForm.scanusercode.$valid\">User checked in sucessfully!</div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/checkinoutsystem/checkinoutsystem.html","<div id=\"pagina-checkinoutsystem\" flex layout=\"column\"><div class=\"cabecalho cor-settings\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\"></div></div>\n<div class=\"topo\" layout=\"row\" layout-align=\"start center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div\n class=\"breadcrumbs\" layout=\"row\" layout-align=\"start center\"></div></div><div flex=\"50\" layout=\"row\" \nlayout-align=\"end center\"></div></div><div layout=\"row\" layout-align=\"center center\"><img \nsrc=\"assets/images/logos/nimro_logo.jpg\" width=\"593\" height=\"182\" alt=\"NimrodTRAC Management System Logo\"></div><div \nlayout=\"row\" layout-align=\"center center\"><div class=\"pagina-orderstatus\" layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-primary md-raised checkbutton\" ng-click=\"vm.openPopupOther($event, \'checkin\')\">CHECK IN\n</md-button></div><div class=\"pagina-orderstatus\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-primary md-raised checkbutton\" ng-click=\"vm.openPopupOther($event, \'checkout\')\">CHECK OUT</md-button></div>\n</div></div>");
$templateCache.put("app/main/pages/checkinoutsystem/checkout.html","<md-dialog flex=\"20\" class=\"adddeliveryroute\" aria-label=\"Scan Order\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2>Scan User Code</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><h3>Scan your ID barcode or insert user code</h3><div layout=\"row\" flex \nlayout-align=\"start center\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>User Code</label><input \ntype=\"text\" required md-autofocus name=\"scanusercode\" minlength=\"2\" ng-model=\"vm.scanusercode\" check-out \nng-model-options=\"{ debounce: 500 }\"><div ng-messages=\"recordForm.scanusercode.$error\"><div ng-message=\"required\">\nPlease scan ID barcode or insert an User Code, starting with *</div><div ng-message=\"minlength\">\nUser Code is short. Please insert at least 2 characters.</div><div ng-message=\"erro\">Error! See message.</div></div>\n<div ng-if=\"recordForm.scanusercode.$pending\">Trying to checking out, please wait...</div><div \nng-if=\"recordForm.scanusercode.$valid\">User checked in sucessfully!</div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/clientstatus/clientstatus.html","<div id=\"pagina-clientstatus\" flex layout=\"column\"><div class=\"cabecalho cor-accounts\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Invoicing</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"><div class=\"estatisticas\" layout=\"row\" layout-align=\"end center\"><ul><li>\n<md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.onstoporders}}</md-button><div \nclass=\"stat-info font-size-8\">On Stop</div></li><li><md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">\n{{vm.dueorders}}</md-button><div class=\"stat-info font-size-8\">Due Orders</div></li><li><md-button \nclass=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.approvedvia}}</md-button><div \nclass=\"stat-info font-size-8\">Portal Approved</div></li><li><md-button class=\"orders-buttons\" \nng-click=\"vm.gotoOrderStatus()\">{{vm.approvedwaiting}}</md-button><div class=\"stat-info font-size-8\">Approved & Waiting\n</div></li><li><md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.waitingcall}}</md-button><div \nclass=\"stat-info font-size-8\">Waiting for Call</div></li><li><md-button class=\"orders-buttons\" \nng-click=\"vm.gotoOrderStatus()\">{{vm.waitingimpression}}</md-button><div class=\"stat-info font-size-8\">\nWaiting for Impression</div></li><li><md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">\n{{vm.inactiveorders}}</md-button><div class=\"stat-info font-size-8\">Inactive</div></li><li><md-button \nclass=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.numcompleted}}</md-button><div \nclass=\"stat-info font-size-8\">Completed</div></li></ul></div></div></div><div class=\"topo\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Invoicing</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Client Status</span></div></div><div flex=\"50\" layout=\"row\" \nlayout-align=\"end center\"></div></div><div flex layout=\"row\"><div flex class=\"orders-page\"><md-divider></md-divider>\n<div class=\"invoicesearch-page\"><div class=\"estado-funcoes\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"estado-funcoes-esq\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-primary md-raised\" \nng-click=\"vm.scanOrder($event)\">Scan</md-button><md-icon md-font-icon=\"icon-barcode\" ng-click=\"vm.scanOrder($event)\" \nclass=\"s48 md-default-theme md-font material-icons icon-barcode pointer\" aria-hidden=\"true\"></md-icon></div><div \nclass=\"estado-funcoes-dir\" layout=\"row\" layout-align=\"end center\" ng-click=\"vm.reset()\"><md-button \nclass=\"md-primary md-raised\">Reset</md-button><md-icon md-font-icon=\"icon-refresh\" \nclass=\"s36 md-default-theme md-font material-icons icon-refresh pointer\" aria-hidden=\"true\"></md-icon></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>\nStart date (dd/mm/yyyy)</label><input type=\"text\" name=\"vm.startDate\" mask=\"39/19/9999\" ng-model=\"vm.startDate\">\n</md-input-container><md-input-container layout=\"row\" flex class=\"md-block\"><label>End date (dd/mm/yyyy)</label><input \ntype=\"text\" name=\"vm.endDate\" mask=\"39/19/9999\" ng-model=\"vm.endDate\"></md-input-container><md-input-container \nlayout=\"row\" flex class=\"md-block\"><label>Postcode</label><input ng-model=\"vm.search.cpostcode\" type=\"text\">\n</md-input-container></div><div layout=\"row\"><md-input-container flex class=\"md-block\"><label>Practice Name</label>\n<input type=\"text\" ng-model=\"vm.search.practice_name\"></md-input-container><md-input-container flex class=\"md-block\">\n<label>Order No</label><input type=\"text\" ng-model=\"vm.search.ordernumber\"></md-input-container><md-input-container \nflex class=\"md-block\"><label>Invoice Number</label><input ng-model=\"vm.search.invoice_number\" type=\"text\">\n</md-input-container></div><div layout=\"row\"><md-input-container flex class=\"md-block\"><label>Delivery Route</label>\n<input ng-model=\"vm.search.deliveryroutes_code\" type=\"text\"></md-input-container><md-input-container flex \nclass=\"md-block\"><label>Client Name</label><input type=\"text\" ng-model=\"vm.search.clientname\"></md-input-container>\n<md-input-container flex class=\"md-block\"><label>Patient Name</label><input type=\"text\" \nng-model=\"vm.search.patient_name\"></md-input-container><md-input-container flex class=\"md-block\"><label>Patient Ref\n</label><input type=\"text\" ng-model=\"vm.search.patient_ref\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-green-500-bg branco\" \nng-if=\"numItensSeleccionados && numItensSeleccionados==1\" ng-click=\"vm.gravar(itensSeleccionados)\">Open Order\n</md-button><md-button class=\"md-green-500-bg branco\" ng-if=\"numItensSeleccionados && numItensSeleccionados>1\" \nng-click=\"vm.gravar(itensSeleccionados)\">Open {{numItensSeleccionados}} Orders</md-button></div><div layout=\"row\" \nclass=\"full-width\"><table datatable=\"ng\" class=\"row-border hover full-width\" dt-options=\"vm.dtOptions\" \ndt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th>Client No</th><th>Client Name</th><th>Order No</th><th>Invoice No</th>\n<th>Practice Name</th><th>Delivery Route</th><th>Date</th><th>Delivery Date</th><th>Patient Name</th><th>Postcode</th>\n<th>Cost</th></tr></thead><tbody><tr \nng-repeat=\"client in vm.allclients | dateRange : vm.startDate : vm.endDate | filter: vm.search track by $index\" \nclass=\"pointer\" ng-click=\"selectRow($event, client.index, vm.allclients)\" \nng-class=\"{\'verified-bg\': !isRowSelected(client.index) && client.verified == 1, \'verified-bg-hover\': isRowSelected(client.index) && client.verified == 1, \'completed-bg\': !isRowSelected(client.index) && client.status_id == 5 && client.verified == 0, \'completed-bg-hover\': isRowSelected(client.index) && client.status_id == 5 && client.verified == 0,\'inproduction-bg-hover\': isRowSelected(client.index) && client.verified != 1 && client.status_id != 5}\">\n<td>{{client.clientnumber}}</td><td>{{client.clientname}}</td><td>{{client.ordernumber}}</td><td>\n{{client.invoice_number}}</td><td>{{client.practice_name}}</td><td>{{client.deliveryroute_code}}</td><td>\n{{client.datereceived | cmdate:\'dd/MM/yyyy\'}}</td><td ng-if=\"client.shippingdate\">\n{{client.shippingdate | cmdate:\'dd/MM/yyyy\'}}</td><td ng-if=\"!client.shippingdate\"></td><td \nng-if=\"client.patient_name != \'\'\">{{client.patient_name}}</td><td \nng-if=\"client.patient_ref != \'\' && client.patient_name == \'\'\">{{client.patient_ref}}</td><td>{{client.cpostcode}}</td>\n<td>£{{client.cost}}</td></tr></tbody></table></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-green-500-bg branco\" ng-if=\"numItensSeleccionados && numItensSeleccionados==1\" \nng-click=\"vm.gravar(itensSeleccionados)\">Open Order</md-button><md-button class=\"md-green-500-bg branco\" \nng-if=\"numItensSeleccionados && numItensSeleccionados>1\" ng-click=\"vm.gravar(itensSeleccionados)\">\nOpen {{numItensSeleccionados}} Orders</md-button></div></div></div></div></div>");
$templateCache.put("app/main/pages/consolidation/consolidation.html","<div id=\"pagina-consolidation\" flex layout=\"column\"><div class=\"cabecalho cor-accounts\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Invoicing</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"><div class=\"estatisticas\" layout=\"row\" layout-align=\"end center\"><ul><li>\n<md-button class=\"orders-buttons\" ng-click=\"gotoOrderStatus()\">{{vm.onstoporders}}</md-button><div \nclass=\"stat-info font-size-8\">On Stop</div></li><li><md-button class=\"orders-buttons\" ng-click=\"gotoOrderStatus()\">\n{{vm.dueorders}}</md-button><div class=\"stat-info font-size-8\">Due Orders</div></li><li><md-button \nclass=\"orders-buttons\" ng-click=\"gotoOrderStatus()\">{{vm.approvedvia}}</md-button><div class=\"stat-info font-size-8\">\nPortal Approved</div></li><li><md-button class=\"orders-buttons\" ng-click=\"gotoOrderStatus()\">{{vm.approvedwaiting}}\n</md-button><div class=\"stat-info font-size-8\">Approved & Waiting</div></li><li><md-button class=\"orders-buttons\" \nng-click=\"gotoOrderStatus()\">{{vm.waitingcall}}</md-button><div class=\"stat-info font-size-8\">Waiting for Call</div>\n</li><li><md-button class=\"orders-buttons\" ng-click=\"gotoOrderStatus()\">{{vm.waitingimpression}}</md-button><div \nclass=\"stat-info font-size-8\">Waiting for Impression</div></li><li><md-button class=\"orders-buttons\" \nng-click=\"gotoOrderStatus()\">{{vm.inactiveorders}}</md-button><div class=\"stat-info font-size-8\">Inactive</div></li>\n<li><md-button class=\"orders-buttons\" ng-click=\"gotoOrderStatus()\">{{vm.numcompleted}}</md-button><div \nclass=\"stat-info font-size-8\">Completed</div></li></ul></div></div></div><div class=\"topo\" layout=\"row\" \nlayout-align=\"start center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Invoicing</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Consolidation</span></div></div><div flex=\"50\" layout=\"row\" \nlayout-align=\"end center\"></div></div><div class=\"pagina-orderstatus\" layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-primary md-raised no-pointer\">Consolidation</md-button><md-button class=\"md-primary md-raised\" \nng-click=\"vm.gotoConsolidationSearch()\">Consolidation Search</md-button></div><div class=\"pagina-orderstatus\" \nlayout=\"row\" layout-align=\"center center\"><md-button ng-class=\"vm.type != 1 ? \'md-primary\' : \'no-pointer\'\" \nclass=\"md-raised\" ng-click=\"vm.changeType(1)\">In Production</md-button><md-button \nng-class=\"vm.type != 2 ? \'md-primary\' : \'no-pointer\'\" class=\"md-raised\" ng-click=\"vm.changeType(2)\">Completed\n</md-button><md-button ng-class=\"vm.type != 3 ? \'md-primary\' : \'no-pointer\'\" class=\"md-raised\" \nng-click=\"vm.changeType(3)\">Verified</md-button></div><div class=\"pagina-orderstatus\"><md-button layout=\"row\" \nlayout-align=\"center center\" class=\"md-primary md-raised\" ng-click=\"vm.reset()\">Reset</md-button><div layout=\"row\">\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>Start date (yyyy-mm-dd)</label><input type=\"text\" \nname=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.startDate\" ng-change=\"vm.searchTable(vm.startDate, 13)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>End date (yyyy-mm-dd)</label><input type=\"text\" name=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.endDate\" \nng-change=\"vm.searchTable(vm.endDate, 14)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>On Date (yyyy-mm-dd)</label><input type=\"text\" \nname=\"onDate\" mask=\"9999-19-39\" ng-model=\"vm.onDate\" ng-change=\"vm.searchTable(vm.onDate, 8)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>Practice Name</label><input ng-model=\"vm.search.practicename\" \nng-change=\"vm.searchTable(vm.search.practicename, 6)\" type=\"text\"></md-input-container><md-input-container \nlayout=\"row\" flex class=\"md-block\"><label>Postcode</label><input ng-model=\"vm.search.cpostcode\" \nng-change=\"vm.searchTable(vm.search.cpostcode, 11)\" type=\"text\"></md-input-container></div><div layout=\"row\">\n<md-input-container flex class=\"md-block\"><label>Order No</label><input ng-model=\"vm.search.ordernumber\" \nng-change=\"vm.searchTable(vm.search.ordernumber, 5)\" type=\"text\"></md-input-container><md-input-container layout=\"row\" \nflex class=\"md-block\"><label>Client No</label><input ng-model=\"vm.search.clientnumber\" \nng-change=\"vm.searchTable(vm.search.clientnumber, 3)\" type=\"text\"></md-input-container><md-input-container flex \nclass=\"md-block\"><label>Client Name</label><input ng-model=\"vm.search.clientname\" \nng-change=\"vm.searchTable(vm.search.clientname, 4)\" type=\"text\"></md-input-container><md-input-container flex \nclass=\"md-block\"><label>Patient Name/Ref</label><input ng-model=\"vm.search.patient_name\" \nng-change=\"vm.searchTable(vm.search.patient_name, 10)\" type=\"text\"></md-input-container><md-input-container flex \nclass=\"md-block\"><label>Practice No</label><input ng-model=\"vm.search.practicenumber\" \nng-change=\"vm.searchTable(vm.search.practicenumber, 17)\" type=\"text\"></md-input-container></div><div layout=\"row\">\n<md-input-container flex=\"20\" class=\"md-block\"><label>Delivery Route</label><md-select name=\"deliveryroutes_id\" \nng-model=\"vm.search.deliveryroutes_id\" ng-change=\"vm.searchTable(vm.search.deliveryroutes_id, 15)\"><md-option value=\"\">\nAll</md-option><md-option ng-repeat=\"delivery in vm.deliveries\" ng-value=\"delivery.deliveryroutes_id\">\n{{delivery.route}}</md-option></md-select></md-input-container><div layout=\"row\" layout-align=\"center center\" \nclass=\"practiceonly\"><md-checkbox class=\"font-size-15\" flex ng-model=\"vm.search.practicenumberonly\" \nng-change=\"vm.searchTable(vm.search.practicenumberonly, 18)\" ng-true-value=\"1\" ng-false-value=\"0\" \naria-label=\"Practice Number\">Only with Practice Number</md-checkbox></div></div></div><div class=\"pagina-orderstatus\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-green-500-bg branco\" \nng-if=\"numorders>0 && numorders<=vm.totalRecordsFiltered && vm.type==3\" ng-click=\"vm.deselectAll()\">Deselect All\n</md-button><md-button class=\"md-green-500-bg branco\" ng-if=\"numorders<vm.totalRecordsFiltered && vm.type==3\" \nng-click=\"vm.selectAll()\">Select All</md-button><md-button class=\"md-green-500-bg branco\" \nng-if=\"vm.itemabrir && vm.itemabrir.length==1\" ng-click=\"vm.gravar(vm.itemabrir)\">Open Order</md-button><md-button \nclass=\"md-green-500-bg branco\" ng-if=\"vm.itemabrir && vm.itemabrir.length>1\" ng-click=\"vm.gravar(vm.itemabrir)\">\nOpen {{vm.itemabrir.length}} Orders</md-button><md-button class=\"md-green-500-bg branco\" \nng-if=\"numorders && numorders==1 && vm.type==3 && vm.disabled == false\" \nng-click=\"vm.consolidateFunction(vm.consolidate)\">Consolidate Order</md-button><md-button \nclass=\"md-green-500-bg branco\" ng-if=\"numorders && numorders>1 && vm.type==3 && vm.disabled == false\" \nng-click=\"vm.consolidateFunction(vm.consolidate)\">Consolidate {{numorders}} Orders</md-button></div><div \nclass=\"pagina-orderstatus full-width\" layout=\"row\" layout-align=\"space-between center\"><table datatable=\"\" \nng-class=\"{\'cor-verde\': vm.type==3, \'cor-cinza\': vm.type==2}\" class=\"row-border hover full-width\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\"></table></div><div \nclass=\"pagina-orderstatus\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-green-500-bg branco\" \nng-if=\"numorders>0 && numorders<=vm.totalRecordsFiltered && vm.type==3\" ng-click=\"vm.deselectAll()\">Deselect All\n</md-button><md-button class=\"md-green-500-bg branco\" ng-if=\"numorders<vm.totalRecordsFiltered && vm.type==3\" \nng-click=\"vm.selectAll()\">Select All</md-button><md-button class=\"md-green-500-bg branco\" \nng-if=\"vm.itemabrir && vm.itemabrir.length==1\" ng-click=\"vm.gravar(vm.itemabrir)\">Open Order</md-button><md-button \nclass=\"md-green-500-bg branco\" ng-if=\"vm.itemabrir && vm.itemabrir.length>1\" ng-click=\"vm.gravar(vm.itemabrir)\">\nOpen {{vm.itemabrir.length}} Orders</md-button><md-button class=\"md-green-500-bg branco\" \nng-if=\"numorders && numorders==1 && vm.type==3 && vm.disabled == false\" \nng-click=\"vm.consolidateFunction(vm.consolidate)\">Consolidate Order</md-button><md-button \nclass=\"md-green-500-bg branco\" ng-if=\"numorders && numorders>1 && vm.type==3 && vm.disabled == false\" \nng-click=\"vm.consolidateFunction(vm.consolidate)\">Consolidate {{numorders}} Orders</md-button></div></div>");
$templateCache.put("app/main/pages/consolidationsearch/consolidationsearch.html","<div id=\"pagina-consolidation\" flex layout=\"column\"><div class=\"cabecalho cor-accounts\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Invoicing</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"><div class=\"estatisticas\" layout=\"row\" layout-align=\"end center\"><ul><li>\n<md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.onstoporders}}</md-button><div \nclass=\"stat-info font-size-8\">On Stop</div></li><li><md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">\n{{vm.dueorders}}</md-button><div class=\"stat-info font-size-8\">Due Orders</div></li><li><md-button \nclass=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.approvedvia}}</md-button><div \nclass=\"stat-info font-size-8\">Portal Approved</div></li><li><md-button class=\"orders-buttons\" \nng-click=\"vm.gotoOrderStatus()\">{{vm.approvedwaiting}}</md-button><div class=\"stat-info font-size-8\">Approved & Waiting\n</div></li><li><md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.waitingcall}}</md-button><div \nclass=\"stat-info font-size-8\">Waiting for Call</div></li><li><md-button class=\"orders-buttons\" \nng-click=\"vm.gotoOrderStatus()\">{{vm.waitingimpression}}</md-button><div class=\"stat-info font-size-8\">\nWaiting for Impression</div></li><li><md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">\n{{vm.inactiveorders}}</md-button><div class=\"stat-info font-size-8\">Inactive</div></li><li><md-button \nclass=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.numcompleted}}</md-button><div \nclass=\"stat-info font-size-8\">Completed</div></li></ul></div></div></div><div class=\"topo\" layout=\"row\" \nlayout-align=\"start center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Invoicing</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Consolidation Search</span></div></div><div flex=\"50\" layout=\"row\" \nlayout-align=\"end center\"></div></div><div class=\"pagina-orderstatus\" layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-primary md-raised\" ng-click=\"vm.gotoConsolidation()\">Consolidation</md-button><md-button \nclass=\"md-primary md-raised no-pointer\">Consolidation Search</md-button></div><div class=\"pagina-orderstatus\" \nlayout=\"row\" layout-align=\"center center\"><span class=\"searchtext\">Please use the filter below to see the results.\n</span></div><div class=\"pagina-orderstatus\"><md-button layout=\"row\" layout-align=\"center center\" \nclass=\"md-primary md-raised\" ng-click=\"vm.reset()\">Reset</md-button><div layout=\"row\"><md-input-container layout=\"row\" \nflex class=\"md-block\"><label>Consolidation On Date (yyyy-mm-dd)</label><input type=\"text\" name=\"onDate\" \nmask=\"9999-19-39\" ng-model=\"vm.search.onDate\" ng-change=\"vm.searchTable(vm.search.onDate, 0)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>Consolidation Start date (yyyy-mm-dd)</label><input type=\"text\" name=\"startDate\" mask=\"9999-19-39\" \nng-model=\"vm.search.startDate\" ng-change=\"vm.searchTable(vm.search.startDate, 1)\" ng-model-options=\"{ debounce: 750 }\">\n</md-input-container><md-input-container layout=\"row\" flex class=\"md-block\"><label>Consolidation End date (yyyy-mm-dd)\n</label><input type=\"text\" name=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.search.endDate\" \nng-change=\"vm.searchTable(vm.search.endDate, 2)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>Practice Number</label><input type=\"text\" \nname=\"practicenumber\" ng-model=\"vm.search.practicenumber\" ng-change=\"vm.searchTable(vm.search.practicenumber, 5)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container></div><div layout=\"row\" layout-align=\"center center\">\n<md-checkbox class=\"font-size-15\" flex ng-model=\"vm.search.practicenumberonly\" \nng-change=\"vm.searchTable(vm.search.practicenumberonly, 6)\" ng-true-value=\"1\" ng-false-value=\"0\" \naria-label=\"Practice Number\">Only with Practice Number</md-checkbox></div></div><div \nng-show=\"vm.search.onDate!=undefined || vm.search.startDate!=undefined || vm.search.endDate!=undefined || vm.search.practicenumber!=undefined || vm.search.practicenumberonly!=undefined\">\n<div \nng-show=\"(vm.search.onDate!=undefined || vm.search.startDate!=undefined || vm.search.endDate!=undefined) || (vm.search.practicenumber==undefined && (vm.search.practicenumberonly==undefined || vm.search.practicenumberonly==0))\" \nclass=\"pagina-orderstatus\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-green-500-bg branco\" \nng-click=\"vm.exportSage()\">Sage Export</md-button></div><div \nng-if=\"vm.search.practicenumberonly == 1 || (vm.search.practicenumber != undefined && vm.search.practicenumber != \'\')\" \nclass=\"pagina-orderstatus\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-green-500-bg branco\" \nng-click=\"vm.exportIDH()\">IDH Export</md-button></div><div class=\"pagina-orderstatus full-width\" layout=\"row\" \nlayout-align=\"space-between center\"><table datatable=\"\" class=\"row-border hover full-width\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\"></table></div><div \nng-show=\"(vm.search.onDate!=undefined || vm.search.startDate!=undefined || vm.search.endDate!=undefined) || (vm.search.practicenumber==undefined && (vm.search.practicenumberonly==undefined || vm.search.practicenumberonly==0))\" \nclass=\"pagina-orderstatus\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-green-500-bg branco\" \nng-click=\"vm.exportSage()\">Sage Export</md-button></div><div \nng-if=\"vm.search.practicenumberonly == 1 || (vm.search.practicenumber != undefined && vm.search.practicenumber != \'\')\" \nclass=\"pagina-orderstatus\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-green-500-bg branco\" \nng-click=\"vm.exportIDH()\">IDH Export</md-button></div></div></div>");
$templateCache.put("app/main/pages/dashboard/addlabdoc.html","<md-dialog class=\"order-alert\" aria-label=\"Add Lab Doc\" ng-cloak><form name=\"myForm\"><input type=\"hidden\" \nng-model=\"users_id\" ng-init=\"users_id=userid\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Add Lab Doc</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\"><div ng-disabled=\"octrl.disabled\" \nngf-drop ngf-select ng-model=\"files\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" \nngf-allow-dir=\"true\" accept=\"application/pdf\" ngf-pattern=\"\'application/pdf\'\">Drop files here<br>or<br>click to upload\n</div><div ngf-no-file-drop>File Drag/Drop is not supported for this browser</div></div><div layout=\"row\" flex \nlayout-align=\"start center\" ng-if=\"files\"><ul><li ng-repeat=\"f in files\" style=\"font:smaller\">{{f.name}}: <span \nng-if=\"f.$error\" style=\"color:red\">{{f.$error}} {{f.$errorParam}} {{f.erro}}</span> <span \nng-if=\"f.status && f.status == \'Uploaded\'\" style=\"color:green\">Uploaded</span><span \nng-if=\"f.status && f.status != \'Uploaded\'\" style=\"color:red\">{{f.status}}</span></li></ul></div><div layout=\"row\" flex \nlayout-align=\"start center\" ng-if=\"determinateValue>0 && determinateValue<100\"><md-progress-linear \nmd-mode=\"determinate\" value=\"{{determinateValue}}\"></md-progress-linear></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Close</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/dashboard/dashboard.html","<div layout=\"row\" class=\"dashboard\"><div flex><md-card md-theme=\"default\" md-theme-watch style=\"margin-top:30px\">\n<md-card-content><div class=\"div_title\"><span class=\"title\">PRODUCTION</span></div><md-content><div layout-gt-md=\"row\" \nstyle=\"cursor:pointer\"><div class=\"coluna_espaco\" flex=\"100\" flex-gt-md=\"50\"><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[1].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoGO()\"><div layout=\"row\"><div flex=\"50\"><span class=\"btn_int_left_blue\">Generate Order</span></div><div\n flex=\"50\"><span class=\"btn_int_right_blue\">{{vm.totalorders[0].total}}</span></div></div></md-button><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[2].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoPlasterRoom()\"><div layout=\"row\"><div flex=\"50\"><span class=\"btn_int_left_blue\">Plaster Room</span>\n</div><div flex=\"50\"><span class=\"btn_int_right_blue\">{{vm.totalorders[1].total}}</span></div></div></md-button>\n<md-subheader class=\"md-primary\" style=\"font-size: 15px; color: #29ABE2\">3D</md-subheader><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[3].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoScanning()\"><div layout=\"row\"><div flex=\"50\"><span class=\"btn_int_left\">Scanning</span></div><div \nflex=\"50\"><span class=\"btn_int_right\">{{vm.totalorders[2].total}}</span></div></div></md-button><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[4].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoPlatforms()\"><div layout=\"row\"><div flex=\"50\"><span class=\"btn_int_left\">Platforms</span></div><div \nflex=\"50\"><span class=\"btn_int_right\">{{vm.totalorders[3].total}}</span></div></div></md-button><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[5].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoDesigning()\"><div layout=\"row\"><div flex=\"50\"><span class=\"btn_int_left\">Designing</span></div><div \nflex=\"50\"><span class=\"btn_int_right\">{{vm.totalorders[4].total}}</span></div></div></md-button><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[6].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.goto3DManufacturing()\"><div layout=\"row\"><div flex=\"50\"><span class=\"btn_int_left\">Manufacturing</span>\n</div><div flex=\"50\"><span class=\"btn_int_right\">{{vm.totalorders[5].total}}</span></div></div></md-button>\n<md-subheader class=\"md-primary\" style=\"font-size: 15px; color: #29ABE2\">Implants</md-subheader><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[7].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoMatching()\"><div layout=\"row\"><div flex=\"50\"><span class=\"btn_int_left\">Matching</span></div><div \nflex=\"50\"><span class=\"btn_int_right\">{{vm.totalorders[6].total}}</span></div></div></md-button><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[8].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoPlanning()\"><div layout=\"row\"><div flex=\"50\"><span class=\"btn_int_left\">Planning</span></div><div \nflex=\"50\"><span class=\"btn_int_right\">{{vm.totalorders[7].total}}</span></div></div></md-button><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[9].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoDrillingDesign()\"><div layout=\"row\"><div flex=\"50\"><span class=\"btn_int_left\">Drilling Guide Design\n</span></div><div flex=\"50\"><span class=\"btn_int_right\">{{vm.totalorders[8].total}}</span></div></div></md-button>\n<md-button ng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[10].privileges.view == \'1\'\" \nclass=\"btn labdoc margin-labdoc\" ng-click=\"vm.openPopup()\"><div layout=\"row\"><div flex><span class=\"btn_int_left\">\nUpload Lab Doc</span></div></div></md-button><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[11].privileges.view == \'1\'\" class=\"btn labdoc\" \nng-click=\"vm.gotoDLD()\"><div layout=\"row\"><div flex><span class=\"btn_int_left\">DLD & Order Location</span></div></div>\n</md-button></div><div class=\"coluna_espaco\" flex=\"100\" flex-gt-md=\"50\"><md-subheader class=\"md-primary\" \nstyle=\"font-size: 15px; color: #29ABE2\">Clear Aligner</md-subheader><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[12].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoCaseAssessment()\"><div layout=\"row\"><div flex=\"50\"><span class=\"btn_int_left\">Case Assessment</span>\n</div><div flex=\"50\"><span class=\"btn_int_right\">{{vm.totalorders[11].total}}</span></div></div></md-button><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[13].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoClearMovement()\"><div layout=\"row\"><div flex=\"50\"><span class=\"btn_int_left\">Clear Movement</span>\n</div><div flex=\"50\"><span class=\"btn_int_right\">{{vm.totalorders[12].total}}</span></div></div></md-button><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[14].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoBracketMovement()\"><div layout=\"row\"><div flex=\"50\"><span class=\"btn_int_left\">Bracket Movement</span>\n</div><div flex=\"50\"><span class=\"btn_int_right\">{{vm.totalorders[13].total}}</span></div></div></md-button><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[15].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoClearManufacturing()\"><div layout=\"row\"><div flex=\"50\"><span class=\"btn_int_left\">Manufacturing</span>\n</div><div flex=\"50\"><span class=\"btn_int_right\">{{vm.totalorders[14].total}}</span></div></div></md-button>\n<md-subheader class=\"md-primary\" style=\"font-size: 15px; color: #29ABE2\">Removable Appliance</md-subheader><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[16].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoInmanCaseAssess()\"><div layout=\"row\"><div flex=\"50\"><span class=\"btn_int_left\">Case Assessment</span>\n</div><div flex=\"50\"><span class=\"btn_int_right\">{{vm.totalorders[15].total}}</span></div></div></md-button><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[17].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoMovement()\"><div layout=\"row\"><div flex=\"50\"><span class=\"btn_int_left\">Movements</span></div><div \nflex=\"50\"><span class=\"btn_int_right\">{{vm.totalorders[16].total}}</span></div></div></md-button><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[18].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoInmanManufacturing()\"><div layout=\"row\"><div flex=\"50\"><span class=\"btn_int_left\">Manufacturing</span>\n</div><div flex=\"50\"><span class=\"btn_int_right\">{{vm.totalorders[17].total}}</span></div></div></md-button><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[20].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoWaiting()\"><div layout=\"row\"><div flex=\"50\"><span class=\"btn_int_left_blue\">Waitting for Call</span>\n</div><div flex=\"50\"><span class=\"btn_int_right_blue\">{{vm.totalorders[18].total}}</span></div></div></md-button>\n<md-button ng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[21].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoPackaging()\"><div layout=\"row\"><div flex=\"50\"><span class=\"btn_int_left_blue\">Packaging</span></div>\n<div flex=\"50\"><span class=\"btn_int_right_blue\">{{vm.totalorders[19].total}}</span></div></div></md-button><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[19].privileges.view == \'1\'\" class=\"btn margin-labdoc\" \nng-click=\"vm.gotoShipping()\"><div layout=\"row\"><div flex=\"50\"><span class=\"btn_int_left_blue\">Shipping</span></div><div\n flex=\"50\"><span class=\"btn_int_right_blue\"></span></div></div></md-button><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[22].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoOrderStatus()\"><div flex=\"50 \"><span class=\"btn_int_left\">Order Status</span></div></md-button></div>\n</div></md-content></md-card-content></md-card></div><div flex><md-card md-theme=\"default\" md-theme-watch \nstyle=\"margin-top:30px\"><md-card-content><div class=\"div_title div_title_accounts\"><span class=\"title\">ACCOUNTS</span>\n</div><md-content><div layout-gt-md=\"row\" style=\"cursor:pointer\"><div class=\"coluna_espaco\" flex=\"100\" flex-gt-md=\"50\">\n<md-subheader class=\"md-primary\" style=\"font-size: 15px; color: #00676e\">Invoicing</md-subheader><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[23].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoInvoice()\"><div><span class=\"btn_int_left\">Invoice</span></div></md-button><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[24].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoInvoiceSearch()\"><div><span class=\"btn_int_left\">Invoice Search</span></div></md-button><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[25].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoConsolidation()\"><div><span class=\"btn_int_left\">Consolidation</span></div></md-button></div><div \nclass=\"coluna_espaco coluna2\" flex=\"100 \" flex-gt-md=\"50\"><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[30].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoClientStatus()\"><span class=\"btn_int_left\">Client Status</span></md-button><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[31].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoReports()\"><div flex=\"50 \"><span class=\"btn_int_left\">Reports</span></div></md-button><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[32].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoOrderStatus()\"><div flex=\"50 \"><span class=\"btn_int_left\">Order Status</span></div></md-button></div>\n</div></md-content></md-card-content></md-card><md-card md-theme=\"default \" md-theme-watch style=\"margin-top:0px\">\n<md-card-content><md-content><div layout-gt-md=\"row\" style=\"cursor:pointer\"><div class=\"coluna_espaco\" flex=\"100\" \nflex-gt-md=\"50\"><md-subheader class=\"md-primary\" style=\"font-size: 15px; color: #00676e\">Products & Groups\n</md-subheader><md-button ng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[26].privileges.view == \'1\'\" \nclass=\"btn\" ng-click=\"vm.gotoProducts() \"><div flex=\"50 \"><span class=\"btn_int_left\">Products</span></div></md-button>\n<md-button ng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[28].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoProductsGroups() \"><div flex=\"50 \"><span class=\"btn_int_left\">Products Groups</span></div></md-button>\n<md-button ng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[29].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoDeliveryRoutes()\"><div flex=\"50 \"><span class=\"btn_int_left\">Delivery Routes</span></div></md-button>\n</div><div class=\"coluna_espaco\" flex=\"100\" flex-gt-md=\"50\"><md-subheader class=\"md-primary\" \nstyle=\"font-size: 15px; color: #00676e\">Clients</md-subheader><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[33].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoProfiles()\"><span class=\"btn_int_left\">Profiles</span></md-button></div></div></md-content>\n</md-card-content></md-card><md-card md-theme=\"default \" md-theme-watch style=\"margin-top:0px\"><md-card-content>\n<md-content><div layout-gt-md=\"row\" style=\"cursor:pointer\"><div class=\"coluna_espaco\" flex=\"100\" flex-gt-md=\"50\">\n<md-subheader class=\"md-primary\" style=\"font-size: 15px; color: #00676e\">Accounts</md-subheader><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[39].privileges.view == \'1\' || vm.privileges[40].privileges.view == \'1\'\" \nclass=\"btn\" ng-click=\"vm.gotoFinances()\"><span class=\"btn_int_left\">Finances</span></md-button></div></div>\n</md-content></md-card-content></md-card><md-card md-theme=\"default \" md-theme-watch style=\"margin-top:0px\">\n<md-card-content><div class=\"div_title div_title_research\"><span class=\"title\">RESEARCH & DEVELOPMENT</span></div>\n<md-content><div layout-gt-md=\"row\" style=\"cursor:pointer\"><div \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[47].privileges.view == \'1\'\" class=\"coluna_espaco\" \nflex=\"100\" flex-gt-md=\"50\" ng-click=\"vm.gotoRD()\"><md-button class=\"btn\"><span class=\"btn_int_left\">Events / Tasks\n</span></md-button></div></div></md-content></md-card-content></md-card></div><div flex><md-card md-theme=\"default \" \nmd-theme-watch style=\"margin-top:30px\"><md-card-content><div class=\"div_title div_title_marketing\"><span class=\"title\">\nMARKETING</span></div><md-content><div layout-gt-md=\"row\" style=\"cursor:pointer\"><div class=\"coluna_espaco\" flex=\"100\" \nflex-gt-md=\"50\"><md-button ng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[46].privileges.view == \'1\'\" \nclass=\"btn\" ng-click=\"vm.gotoEventsTasks()\"><span class=\"btn_int_left\">Events / Tasks</span></md-button></div></div>\n</md-content></md-card-content></md-card><md-card md-theme=\"default \" md-theme-watch style=\"margin-top:0px\">\n<md-card-content><div class=\"div_title div_title_analytics\"><span class=\"title\">ANALYTICS</span></div><md-content><div \nlayout-gt-md=\"row\"><div class=\"coluna_espaco\" flex=\"100\" flex-gt-md=\"50\"><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[35].privileges.view == \'1\'\" \nng-click=\"vm.openPage(\'analyticsmd\')\" class=\"btn\"><div layout=\"row \"><span class=\"btn_int_left\">MD</span> <span \nclass=\"btn_int_right\"></span></div></md-button><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[36].privileges.view == \'1\'\" \nng-click=\"vm.openPage(\'analyticsinman\')\" class=\"btn\"><div layout=\"row \"><span class=\"btn_int_left\">Inman</span> <span \nclass=\"btn_int_right\"></span></div></md-button><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[37].privileges.view == \'1\'\" \nng-click=\"vm.openPage(\'analyticsclears\')\" class=\"btn\"><div layout=\"row \"><span class=\"btn_int_left\">Clears</span> <span\n class=\"btn_int_right\"></span></div></md-button></div><div class=\"coluna_espaco\" flex=\"100\" flex-gt-md=\"50\"><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[38].privileges.view == \'1\'\" \nng-click=\"vm.openPage(\'analytics3d\')\" class=\"btn\"><div layout=\"row \"><span class=\"btn_int_left\">3D</span> <span \nclass=\"btn_int_right\"></span></div></md-button><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[39].privileges.view == \'1\'\" \nng-click=\"vm.openPage(\'analyticsaccounts\')\" class=\"btn\"><div layout=\"row \"><span class=\"btn_int_left\">Accounts</span> \n<span class=\"btn_int_right\"></span></div></md-button><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[40].privileges.view == \'1\'\" \nng-click=\"vm.openPage(\'analyticspoints\')\" class=\"btn\"><div layout=\"row \"><span class=\"btn_int_left\">Points</span> <span\n class=\"btn_int_right\"></span></div></md-button></div></div></md-content></md-card-content></md-card><md-card \nmd-theme=\"default \" md-theme-watch style=\"margin-top:0px\"><md-card-content><div class=\"div_title div_title_lab\"><span \nclass=\"title\">NIMRODENTAL LAB</span></div><md-content><div layout-gt-md=\"row\" style=\"cursor:pointer\"><div \nclass=\"coluna_espaco\" flex=\"100\" flex-gt-md=\"50\"><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[43].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoCheckinout() \"><div layout=\"row \"><span class=\"btn_int_left\">Check In / Out</span></div></md-button>\n<md-button ng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[42].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoScheduling() \"><div layout=\"row \"><span class=\"btn_int_left\">Scheduling</span></div></md-button></div>\n<div ng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[44].privileges.view == \'1\'\" class=\"coluna_espaco\" \nflex=\"100\" flex-gt-md=\"50\"><md-button class=\"btn\" ng-click=\"vm.gotoHolidays()\"><div layout=\"row \"><span \nclass=\"btn_int_left\">Holidays</span></div></md-button></div></div></md-content></md-card-content></md-card><md-card \nmd-theme=\"default \" md-theme-watch style=\"margin-top:0px\"><md-card-content><div class=\"div_title div_title_system\">\n<span class=\"title\">SYSTEM SETTINGS</span></div><md-content><div layout-gt-md=\"row\" style=\"cursor:pointer\"><div \nclass=\"coluna_espaco\" flex=\"100\" flex-gt-md=\"50\"><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\' || vm.privileges[41].privileges.view == \'1\'\" class=\"btn\" \nng-click=\"vm.gotoMembers()\"><div layout=\"row \"><span class=\"btn_int_left\">Members</span></div></md-button></div><div \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\'\" class=\"coluna_espaco\" flex=\"100\" flex-gt-md=\"50\"><md-button class=\"btn\" \nng-click=\"vm.gotoCheckinoutSystem()\"><div layout=\"row \"><span class=\"btn_int_left\">Check In / Out - System</span></div>\n</md-button></div></div></md-content></md-card-content></md-card></div></div>");
$templateCache.put("app/main/pages/deliverygroup/deliverygroup.html","<div id=\"pagina-deliverygroup\" flex layout=\"column\"><div class=\"cabecalho cor-products\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Products</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"></div></div><div class=\"topo\" layout=\"row\" layout-align=\"space-between center\">\n<div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" layout=\"row\" \nlayout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Products</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Delivery Groups</span></div></div><div flex=\"50\" layout=\"row\" \nlayout-align=\"end center\"></div></div><div layout=\"row\" layout-align=\"center center\"><div \nclass=\"cor-delivery md-padding\" flex layout=\"row\" layout-align=\"center center\"><md-button class=\"md-primary md-raised\" \nng-click=\"vm.gotoDeliveryRoute()\">Delivery Routes</md-button><md-button class=\"md-primary md-raised\" \nng-disabled=\"true\">Delivery Groups</md-button></div><div class=\"branco-bg md-padding\" flex=\"25\" layout=\"row\" \nlayout-align=\"center center\"><md-button ng-if=\"vm.caixaedicao!=1\" class=\"md-primary md-raised\" ng-disabled=\"true\">\nNew Delivery Group</md-button><md-button ng-if=\"vm.caixaedicao==1\" class=\"md-primary md-raised\" ng-disabled=\"true\">\nEdit Delivery Group</md-button></div></div><div><div layout=\"row\"><div flex class=\"md-padding branco-bg\"><table \ndatatable=\"ng\" class=\"simple row-border hover\"><thead><tr><th>Code</th><th>Delivery Group</th><th>Edit</th><th>Delete\n</th></tr></thead><tbody><tr ng-repeat=\"group in vm.groups\"><td>{{group.deliverygroup_code}}</td><td>\n{{group.deliverygroup}}</td><td><md-button \nng-click=\"vm.disabled == false ? vm.editGroup(group.deliverygroups_id) : \'\'\" \nclass=\"icon-pencil font-size-20 yellow-800-fg\" aria-label=\"Edit\"></md-button></td><td><md-button \nng-click=\"vm.disabled == false ? vm.deleteExistGroup($event, group.deliverygroups_id) : \'\'\" \nclass=\"icon-delete font-size-20 red-800-fg\" aria-label=\"Delete\"></md-button></td></tr></tbody></table></div><div \nflex=\"25\"><div layout=\"row\" ng-cloak layout-align=\"center center\"></div><ms-card ng-if=\"vm.caixaedicao!=1\" flex \ntemplate=\"\'app/templates/cards/delivery/newdeliverygroup.html\'\" view-model=\"vm\"></ms-card><ms-card \nng-if=\"vm.caixaedicao==1\" flex template=\"\'app/templates/cards/delivery/editdeliverygroup.html\'\" view-model=\"vm\">\n</ms-card></div></div></div></div>");
$templateCache.put("app/main/pages/deliveryroute/deliveryroute.html","<div id=\"pagina-deliveryroute\" flex layout=\"column\"><div class=\"cabecalho cor-products\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Products</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"></div></div><div class=\"topo\" layout=\"row\" layout-align=\"space-between center\">\n<div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" layout=\"row\" \nlayout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Products</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Delivery Routes</span></div></div><div flex=\"50\" layout=\"row\" \nlayout-align=\"end center\"></div></div><div layout=\"row\" layout-align=\"center center\"><div \nclass=\"cor-delivery md-padding\" flex layout=\"row\" layout-align=\"center center\"><md-button class=\"md-primary md-raised\" \nng-disabled=\"true\">Delivery Routes</md-button><md-button class=\"md-primary md-raised\" \nng-click=\"vm.gotoDeliveryGroup()\">Delivery Groups</md-button></div><div class=\"branco-bg md-padding\" flex=\"25\" \nlayout=\"row\" layout-align=\"center center\"><md-button ng-if=\"vm.caixaedicao!=1 && vm.caixaedicaomulti!=1\" \nclass=\"md-primary md-raised\" ng-disabled=\"true\">New Delivery Route</md-button><md-button \nng-if=\"vm.caixaedicao==1 && vm.caixaedicaomulti!=1\" class=\"md-primary md-raised\" ng-disabled=\"true\">Edit Delivery Route\n</md-button><md-button ng-if=\"vm.caixaedicaomulti==1 && vm.caixaedicao!=1\" class=\"md-primary md-raised\" \nng-disabled=\"true\">Edit Multiple Delivery Routes</md-button></div></div><div><div layout=\"row\"><div flex \nclass=\"md-padding branco-bg\"><table datatable=\"ng\" class=\"row-border hover\" width=\"100%\"><thead><tr><th>Code</th><th>\nDelivery Route</th><th>Delivery Group</th><th>Days</th><th>Hours</th><th>Departments</th><th>Rate</th><th>VAT</th><th>\nEdit</th></tr></thead><tbody><tr ng-repeat=\"route in vm.routes track by $index\" ng-click=\"selectRow($event, $index)\" \nng-class=\"{highlitedRow: isRowSelected($index)}\"><td>{{route.deliveryroutes_code}}</td><td>{{route.route}}</td><td>\n{{route.deliverygroup}}</td><td>{{route.days}}</td><td>{{route.hours}}</td><td>{{route.department_name}}</td><td>\n{{route.rate}}</td><td>{{route.vat}}</td><td><md-button \nng-click=\"vm.disabled == false ? vm.editRoute(route.deliveryroutes_id) : \'\'\" \nclass=\"icon-pencil font-size-20 yellow-800-fg\" aria-label=\"Edit\"></md-button></td></tr></tbody></table></div><div \nflex=\"25\"><div layout=\"row\" ng-cloak layout-align=\"center center\"></div><ms-card \nng-if=\"vm.caixaedicao!=1 && vm.caixaedicaomulti!=1\" flex \ntemplate=\"\'app/templates/cards/delivery/newdeliveryroute.html\'\" view-model=\"vm\"></ms-card><ms-card \nng-if=\"vm.caixaedicao==1\" flex template=\"\'app/templates/cards/delivery/editdeliveryroute.html\'\" view-model=\"vm\">\n</ms-card><ms-card ng-if=\"vm.caixaedicaomulti==1 && vm.caixaedicao!=1\" flex \ntemplate=\"\'app/templates/cards/delivery/delivertyselectionedit.html\'\" view-model=\"vm\"></ms-card></div></div></div>\n</div>");
$templateCache.put("app/main/pages/dld/dld.html","<div id=\"pagina-clientstatus\" flex layout=\"column\"><div class=\"cabecalho cor-production\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Production</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"></div></div><div class=\"topo\" layout=\"row\" layout-align=\"space-between center\">\n<div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" layout=\"row\" \nlayout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">DLD & Order Location</span></div></div><div flex=\"50\" layout=\"row\" \nlayout-align=\"end center\"></div></div><div flex layout=\"row\"><div flex class=\"orders-page\"><md-divider></md-divider>\n<div class=\"invoicesearch-page\"><div class=\"estado-funcoes\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"estado-funcoes-esq\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-primary md-raised\" \nng-click=\"vm.scanOrder($event)\">Scan</md-button><md-icon md-font-icon=\"icon-barcode\" ng-click=\"vm.scanOrder($event)\" \nclass=\"s48 md-default-theme md-font material-icons icon-barcode pointer\" aria-hidden=\"true\"></md-icon></div><div \nclass=\"estado-funcoes-dir\" layout=\"row\" layout-align=\"end center\" ng-click=\"vm.reset()\"><md-button \nclass=\"md-primary md-raised\">Reset</md-button><md-icon md-font-icon=\"icon-refresh\" \nclass=\"s36 md-default-theme md-font material-icons icon-refresh pointer\" aria-hidden=\"true\"></md-icon></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>\nStart date (yyyy-mm-dd)</label><input type=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.startDate\" \nng-change=\"vm.searchTable(vm.startDate, 12)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>End date (yyyy-mm-dd)</label><input type=\"text\" \nname=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.endDate\" ng-change=\"vm.searchTable(vm.endDate, 13)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>Received Date (yyyy-mm-dd)</label><input type=\"text\" name=\"onDate\" mask=\"9999-19-39\" ng-model=\"vm.onDate\" \nng-change=\"vm.searchTable(vm.onDate, 6)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container \nlayout=\"row\" flex class=\"md-block\"><label>Client</label><input ng-model=\"vm.search.performername\" \nng-change=\"vm.searchTable(vm.search.performername, 4)\" type=\"text\"></md-input-container><md-input-container \nlayout=\"row\" flex class=\"md-block\"><label>City</label><input ng-model=\"vm.search.ccity\" \nng-change=\"vm.searchTable(vm.search.ccity, 14)\" type=\"text\"></md-input-container><md-input-container flex \nclass=\"md-block\"><label>Country</label><input ng-model=\"vm.search.ccountry\" \nng-change=\"vm.searchTable(vm.search.ccountry, 15)\" type=\"text\"></md-input-container></div><div layout=\"row\">\n<md-input-container flex class=\"md-block\"><label>Order No</label><input ng-model=\"vm.search.ordernumber\" \nng-change=\"vm.searchTable(vm.search.ordernumber, 2)\" data-column=\"0\" type=\"text\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>Perscription No</label><input \nng-model=\"vm.search.prescription_number\" ng-change=\"vm.searchTable(vm.search.prescription_number, 3)\" type=\"text\">\n</md-input-container><md-input-container flex class=\"md-block\"><label>Patient Name</label><input \nng-model=\"vm.search.patient_name\" ng-change=\"vm.searchTable(vm.search.patient_name, 5)\" type=\"text\">\n</md-input-container><md-input-container flex class=\"md-block\"><label>Department</label><md-select \nname=\"departments_id\" ng-model=\"vm.search.departments_id\" ng-change=\"vm.searchTable(vm.search.departments_id, 11)\">\n<md-option value=\"\">All</md-option><md-option ng-repeat=\"department in vm.departments\" \nng-value=\"department.departments_id\">{{department.department_name}}</md-option></md-select></md-input-container>\n<md-input-container flex class=\"md-block\"><label>Status</label><md-select name=\"status_id\" \nng-model=\"vm.search.status_id\" ng-change=\"vm.searchTable(vm.search.status_id, 10)\"><md-option value=\"\">All</md-option>\n<md-option value=\"2\">Approved</md-option><md-option value=\"6\">Awaiting Approval</md-option><md-option value=\"1\">\nCancelled</md-option><md-option value=\"5\">Completed</md-option></md-select></md-input-container><md-input-container \nlayout=\"row\" flex class=\"md-block\"><label>Postcode</label><input ng-model=\"vm.search.cpostcode\" \nng-change=\"vm.searchTable(vm.search.cpostcode, 7)\" type=\"text\"></md-input-container></div><md-input-container \nlayout=\"row\" flex class=\"md-block\"><label>Invoice No</label><input ng-model=\"vm.search.invoice_number\" \nng-change=\"vm.searchTable(vm.search.invoice_number, 1)\" type=\"text\"></md-input-container><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-green-500-bg branco\" ng-if=\"vm.itemabrir && vm.itemabrir.length==1\" \nng-click=\"vm.disabled==false ? vm.gravar(vm.itemabrir) : \'\'\">Open Order</md-button><md-button \nclass=\"md-green-500-bg branco\" ng-if=\"vm.itemabrir && vm.itemabrir.length>1\" \nng-click=\"vm.disabled==false ? vm.gravar(vm.itemabrir) : \'\'\">Open {{vm.itemabrir.length}} Orders</md-button></div><div \nlayout=\"row\" layout-align=\"center center\" class=\"full-width\"><table datatable=\"\" \nclass=\"simple tabela-pesquisa full-width\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"></table></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-green-500-bg branco\" ng-if=\"vm.itemabrir && vm.itemabrir.length==1\" \nng-click=\"vm.disabled==false ? vm.gravar(vm.itemabrir) : \'\'\">Open Order</md-button><md-button \nclass=\"md-green-500-bg branco\" ng-if=\"vm.itemabrir && vm.itemabrir.length>1\" \nng-click=\"vm.disabled==false ? vm.gravar(vm.itemabrir) : \'\'\">Open {{vm.itemabrir.length}} Orders</md-button></div>\n</div></div></div></div>");
$templateCache.put("app/main/pages/finances/finances.html","<div id=\"pagina-productgroup\" flex layout=\"column\"><div class=\"cabecalho cor-accounts\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Finances</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"></div></div><div class=\"topo\" layout=\"row\" layout-align=\"space-between center\">\n<div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" layout=\"row\" \nlayout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Accounts</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Finances</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\">\n</div></div><div layout=\"row\" layout-align=\"center center\"><div class=\"cor-delivery md-padding\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-primary md-raised\" ng-disabled=\"true\">Expenditure</md-button>\n<md-button class=\"md-primary md-raised\" ng-click=\"vm.goto(\'financesbanking\')\">Banking</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.goto(\'financesrevenue\')\">Revenue</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.goto(\'financesdebt\')\">Debt</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.goto(\'financesowed\')\">Owed</md-button></div><div \nclass=\"branco-bg md-padding\" flex=\"25\" layout=\"row\" layout-align=\"center center\"><md-button ng-if=\"vm.caixaedicao!=1\" \nclass=\"md-primary md-raised\" ng-disabled=\"true\">New</md-button><md-button ng-if=\"vm.caixaedicao==1\" \nclass=\"md-primary md-raised\" ng-disabled=\"true\">Edit</md-button></div></div><div><div layout=\"row\"><div flex \nclass=\"md-padding full-width branco-bg\"><md-button layout=\"row\" layout-align=\"center center\" \nclass=\"md-primary md-raised\" ng-click=\"vm.reset()\">Reset</md-button><div layout=\"row\"><md-input-container layout=\"row\" \nflex class=\"md-block\"><label>Start date (yyyy-mm-dd)</label><input type=\"text\" name=\"startDate\" mask=\"9999-19-39\" \nng-model=\"vm.startDate\" ng-change=\"vm.searchTable(vm.startDate, 2)\" ng-model-options=\"{ debounce: 750 }\">\n</md-input-container><md-input-container layout=\"row\" flex class=\"md-block\"><label>End date (yyyy-mm-dd)</label><input \ntype=\"text\" name=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.endDate\" ng-change=\"vm.searchTable(vm.endDate, 3)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>Payment Date (yyyy-mm-dd)</label><input type=\"text\" name=\"onDate\" mask=\"9999-19-39\" ng-model=\"vm.onDate\" \nng-change=\"vm.searchTable(vm.onDate, 1)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container \nflex layout=\"row\" class=\"full-width md-block\"><label>Payment Method</label><md-select name=\"payment_method\" \nng-model=\"vm.search.payment_method\" ng-change=\"vm.searchTable(vm.search.payment_method, 10)\"><md-option \nvalue=\"Bank Transfer\">Bank Transfer</md-option><md-option value=\"Credit Card\">Credit Card</md-option><md-option \nvalue=\"Cheque\">Cheque</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container \nlayout=\"row\" flex class=\"md-block\"><label>Payment Status</label><md-select name=\"paid\" ng-model=\"vm.search.paid\" \nng-change=\"vm.searchTable(vm.search.paid, 12)\"><md-option value=\"1\">Paid</md-option><md-option value=\"0\">Not Paid\n</md-option></md-select></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\"><label>Type</label>\n<md-select name=\"type\" ng-model=\"vm.search.type\" ng-change=\"vm.searchTable(vm.search.type, 4)\"><md-option \nvalue=\"Service\">Service</md-option><md-option value=\"Material\">Material</md-option><md-option value=\"Consumable\">\nConsumable</md-option><md-option value=\"Other\">Other</md-option></md-select></md-input-container><md-input-container \nflex class=\"md-block\"><label>Description</label><input ng-model=\"vm.search.description\" \nng-change=\"vm.searchTable(vm.search.description, 5)\" type=\"text\"></md-input-container><md-input-container flex \nclass=\"md-block\"><label>Supplier</label><input ng-model=\"vm.search.supplier\" \nng-change=\"vm.searchTable(vm.search.supplier, 11)\" type=\"text\"></md-input-container></div><div layout=\"row\"><table \ndatatable=\"\" class=\"row-border hover responsive\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"></table></div></div><div flex=\"25\"><div layout=\"row\" ng-cloak layout-align=\"center center\">\n</div><ms-card ng-if=\"vm.caixaedicao!=1\" flex template=\"\'app/templates/cards/finances/newexpenditure.html\'\" \nview-model=\"vm\"></ms-card><ms-card ng-if=\"vm.caixaedicao==1\" flex \ntemplate=\"\'app/templates/cards/finances/editexpenditure.html\'\" view-model=\"vm\"></ms-card></div></div></div></div>");
$templateCache.put("app/main/pages/financesbanking/financesbanking.html","<div id=\"pagina-productgroup\" flex layout=\"column\"><div class=\"cabecalho cor-accounts\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Finances</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"></div></div><div class=\"topo\" layout=\"row\" layout-align=\"space-between center\">\n<div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" layout=\"row\" \nlayout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Accounts</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Finances</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\">\n</div></div><div layout=\"row\" layout-align=\"center center\"><div class=\"cor-delivery md-padding\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-primary md-raised\" ng-click=\"vm.goto(\'finances\')\">Expenditure\n</md-button><md-button class=\"md-primary md-raised\" ng-disabled=\"true\">Banking</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.goto(\'financesrevenue\')\">Revenue</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.goto(\'financesdebt\')\">Debt</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.goto(\'financesowed\')\">Owed</md-button></div><div \nclass=\"branco-bg md-padding\" flex=\"25\" layout=\"row\" layout-align=\"center center\"><md-button ng-if=\"vm.caixaedicao!=1\" \nclass=\"md-primary md-raised\" ng-disabled=\"true\">New</md-button><md-button ng-if=\"vm.caixaedicao==1\" \nclass=\"md-primary md-raised\" ng-disabled=\"true\">Edit</md-button></div></div><div><div layout=\"row\"><div flex \nclass=\"md-padding full-width branco-bg\"><md-button layout=\"row\" layout-align=\"center center\" \nclass=\"md-primary md-raised\" ng-click=\"vm.reset()\">Reset</md-button><div layout=\"row\"><md-input-container layout=\"row\" \nflex class=\"md-block\"><label>Start date (yyyy-mm-dd)</label><input type=\"text\" name=\"startDate\" mask=\"9999-19-39\" \nng-model=\"vm.startDate\" ng-change=\"vm.searchTable(vm.startDate, 1)\" ng-model-options=\"{ debounce: 750 }\">\n</md-input-container><md-input-container layout=\"row\" flex class=\"md-block\"><label>End date (yyyy-mm-dd)</label><input \ntype=\"text\" name=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.endDate\" ng-change=\"vm.searchTable(vm.endDate, 2)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container flex class=\"md-block\"><label>Account No\n</label><input name=\"account_number\" ng-model=\"vm.search.account_number\" \nng-change=\"vm.searchTable(vm.search.account_number, 3)\" type=\"text\"></md-input-container><md-input-container flex \nclass=\"md-block\"><label>Account Name</label><input name=\"account_name\" ng-model=\"vm.search.account_name\" \nng-change=\"vm.searchTable(vm.search.account_name, 4)\" type=\"text\"></md-input-container></div><div layout=\"row\"><table \ndatatable=\"\" class=\"row-border hover responsive\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"></table></div></div><div flex=\"25\"><div layout=\"row\" ng-cloak layout-align=\"center center\">\n</div><ms-card ng-if=\"vm.caixaedicao!=1\" flex template=\"\'app/templates/cards/finances/newbanking.html\'\" \nview-model=\"vm\"></ms-card><ms-card ng-if=\"vm.caixaedicao==1\" flex \ntemplate=\"\'app/templates/cards/finances/editbanking.html\'\" view-model=\"vm\"></ms-card></div></div></div></div>");
$templateCache.put("app/main/pages/financesdebt/financesdebt.html","<div id=\"pagina-productgroup\" flex layout=\"column\"><div class=\"cabecalho cor-accounts\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Finances</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"></div></div><div class=\"topo\" layout=\"row\" layout-align=\"space-between center\">\n<div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" layout=\"row\" \nlayout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Accounts</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Finances</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\">\n</div></div><div layout=\"row\" layout-align=\"center center\"><div class=\"cor-delivery md-padding\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-primary md-raised\" ng-click=\"vm.goto(\'finances\')\">Expenditure\n</md-button><md-button class=\"md-primary md-raised\" ng-click=\"vm.goto(\'financesbanking\')\">Banking</md-button><md-button\n class=\"md-primary md-raised\" ng-click=\"vm.goto(\'financesrevenue\')\">Revenue</md-button><md-button \nclass=\"md-primary md-raised\" ng-disabled=\"true\">Debt</md-button><md-button class=\"md-primary md-raised\" \nng-click=\"vm.goto(\'financesowed\')\">Owed</md-button></div><div class=\"branco-bg md-padding\" flex=\"25\" layout=\"row\" \nlayout-align=\"center center\"><md-button ng-if=\"vm.caixaedicao!=1\" class=\"md-primary md-raised\" ng-disabled=\"true\">New\n</md-button><md-button ng-if=\"vm.caixaedicao==1\" class=\"md-primary md-raised\" ng-disabled=\"true\">Edit</md-button></div>\n</div><div><div layout=\"row\"><div flex class=\"md-padding full-width branco-bg\"><md-button layout=\"row\" \nlayout-align=\"center center\" class=\"md-primary md-raised\" ng-click=\"vm.reset()\">Reset</md-button><div layout=\"row\">\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>Start date (yyyy-mm-dd)</label><input type=\"text\" \nname=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.search.startDate\" ng-change=\"vm.searchTable(vm.search.startDate, 1)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>End date (yyyy-mm-dd)</label><input type=\"text\" name=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.search.endDate\" \nng-change=\"vm.searchTable(vm.search.endDate, 2)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container></div><div \nlayout=\"row\"><table datatable=\"\" class=\"row-border hover responsive\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\"></table></div></div><div flex=\"25\"><div layout=\"row\" ng-cloak \nlayout-align=\"center center\"></div><ms-card ng-if=\"vm.caixaedicao!=1\" flex \ntemplate=\"\'app/templates/cards/finances/newdebt.html\'\" view-model=\"vm\"></ms-card><ms-card ng-if=\"vm.caixaedicao==1\" \nflex template=\"\'app/templates/cards/finances/editdebt.html\'\" view-model=\"vm\"></ms-card></div></div></div></div>");
$templateCache.put("app/main/pages/financesowed/financesowed.html","<div id=\"pagina-productgroup\" flex layout=\"column\"><div class=\"cabecalho cor-accounts\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Finances</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"></div></div><div class=\"topo\" layout=\"row\" layout-align=\"space-between center\">\n<div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" layout=\"row\" \nlayout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Accounts</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Finances</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\">\n</div></div><div layout=\"row\" layout-align=\"center center\"><div class=\"cor-delivery md-padding\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-primary md-raised\" ng-click=\"vm.goto(\'finances\')\">Expenditure\n</md-button><md-button class=\"md-primary md-raised\" ng-click=\"vm.goto(\'financesbanking\')\">Banking</md-button><md-button\n class=\"md-primary md-raised\" ng-click=\"vm.goto(\'financesrevenue\')\">Revenue</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.goto(\'financesdebt\')\">Debt</md-button><md-button \nclass=\"md-primary md-raised\" ng-disabled=\"true\">Owed</md-button></div><div class=\"branco-bg md-padding\" flex=\"25\" \nlayout=\"row\" layout-align=\"center center\"><md-button ng-if=\"vm.caixaedicao!=1\" class=\"md-primary md-raised\" \nng-disabled=\"true\">New</md-button><md-button ng-if=\"vm.caixaedicao==1\" class=\"md-primary md-raised\" ng-disabled=\"true\">\nEdit</md-button></div></div><div><div layout=\"row\"><div flex class=\"md-padding full-width branco-bg\"><md-button \nlayout=\"row\" layout-align=\"center center\" class=\"md-primary md-raised\" ng-click=\"vm.reset()\">Reset</md-button><div \nlayout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Start date (yyyy-mm-dd)</label><input \ntype=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.search.startDate\" \nng-change=\"vm.searchTable(vm.search.startDate, 1)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>End date (yyyy-mm-dd)</label><input type=\"text\" \nname=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.search.endDate\" ng-change=\"vm.searchTable(vm.search.endDate, 2)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container></div><div layout=\"row\"><table datatable=\"\" \nclass=\"row-border hover responsive\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\">\n</table></div></div><div flex=\"25\"><div layout=\"row\" ng-cloak layout-align=\"center center\"></div><ms-card \nng-if=\"vm.caixaedicao!=1\" flex template=\"\'app/templates/cards/finances/newowed.html\'\" view-model=\"vm\"></ms-card>\n<ms-card ng-if=\"vm.caixaedicao==1\" flex template=\"\'app/templates/cards/finances/editowed.html\'\" view-model=\"vm\">\n</ms-card></div></div></div></div>");
$templateCache.put("app/main/pages/financesrevenue/financesrevenue.html","<div id=\"pagina-productgroup\" flex layout=\"column\"><div class=\"cabecalho cor-accounts\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Finances</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"></div></div><div class=\"topo\" layout=\"row\" layout-align=\"space-between center\">\n<div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" layout=\"row\" \nlayout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Accounts</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Finances</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\">\n</div></div><div layout=\"row\" layout-align=\"center center\"><div class=\"cor-delivery md-padding\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-primary md-raised\" ng-click=\"vm.goto(\'finances\')\">Expenditure\n</md-button><md-button class=\"md-primary md-raised\" ng-click=\"vm.goto(\'financesbanking\')\">Banking</md-button><md-button\n class=\"md-primary md-raised\" ng-disabled=\"true\">Revenue</md-button><md-button class=\"md-primary md-raised\" \nng-click=\"vm.goto(\'financesdebt\')\">Debt</md-button><md-button class=\"md-primary md-raised\" \nng-click=\"vm.goto(\'financesowed\')\">Owed</md-button></div><div class=\"branco-bg md-padding\" flex=\"25\" layout=\"row\" \nlayout-align=\"center center\"><md-button ng-if=\"vm.caixaedicao!=1\" class=\"md-primary md-raised\" ng-disabled=\"true\">New\n</md-button><md-button ng-if=\"vm.caixaedicao==1\" class=\"md-primary md-raised\" ng-disabled=\"true\">Edit</md-button></div>\n</div><div><div layout=\"row\"><div flex class=\"md-padding full-width branco-bg\"><md-button layout=\"row\" \nlayout-align=\"center center\" class=\"md-primary md-raised\" ng-click=\"vm.reset()\">Reset</md-button><div layout=\"row\">\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>Start date (yyyy-mm-dd)</label><input type=\"text\" \nname=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.search.startDate\" ng-change=\"vm.searchTable(vm.search.startDate, 2)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>End date (yyyy-mm-dd)</label><input type=\"text\" name=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.search.endDate\" \nng-change=\"vm.searchTable(vm.search.endDate, 3)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container></div><div \nlayout=\"row\"><table datatable=\"\" class=\"row-border hover responsive\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\"></table></div></div><div flex=\"25\"><div layout=\"row\" ng-cloak \nlayout-align=\"center center\"></div><ms-card ng-if=\"vm.caixaedicao!=1\" flex \ntemplate=\"\'app/templates/cards/finances/newrevenue.html\'\" view-model=\"vm\"></ms-card><ms-card ng-if=\"vm.caixaedicao==1\" \nflex template=\"\'app/templates/cards/finances/editrevenue.html\'\" view-model=\"vm\"></ms-card></div></div></div></div>");
$templateCache.put("app/main/pages/go/addproduct.tpl.html","<md-dialog aria-label=\"Add Product\" ngapp=\"caseType\"><form ng-cloak class=\"casetype\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Add Product</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><h3>Search by</h3><div \nlayout=\"row\" layout-align=\"start center\"><md-datepicker flex=\"20\" ng-model=\"ctrl.startDate\" \nmd-placeholder=\"Start date\" md-open-on-focus></md-datepicker><md-datepicker flex=\"20\" ng-model=\"ctrl.endDate\" \nmd-placeholder=\"End date\" md-open-on-focus></md-datepicker><md-input-container layout=\"row\" flex=\"30\" class=\"md-block\">\n<label>Client</label><input type=\"text\"></md-input-container><md-input-container layout=\"row\" flex=\"30\" \nclass=\"md-block\"><label>City</label><input type=\"text\"></md-input-container></div><div layout=\"row\"><md-input-container\n flex class=\"md-block\"><label>Order No</label><input type=\"text\"></md-input-container><md-input-container flex \nclass=\"md-block\"><label>Patient Name</label><input type=\"text\"></md-input-container><md-input-container flex \nclass=\"md-block\"><label>Country</label><input type=\"text\"></md-input-container></div><div layout=\"row\">\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>Perscription No</label><input type=\"text\">\n</md-input-container><md-datepicker flex=\"35\" ng-model=\"ctrl.dateReceived\" md-placeholder=\"Received date\" \nmd-open-on-focus></md-datepicker><md-input-container layout=\"row\" flex class=\"md-block\"><label>City</label><input \ntype=\"text\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"33\" class=\"md-block\"><label>\nDepartment</label><md-select ng-model=\"search.department\"><md-option value=\"1\">Go</md-option><md-option value=\"2\">\nPlaster Room</md-option><md-option value=\"3\">3D - CT Scan</md-option><md-option value=\"4\">3D - Scanning</md-option>\n</md-select></md-input-container><md-input-container flex=\"33\" class=\"md-block\"><label>Status</label><md-select \nng-model=\"delivery.route\"><md-option value=\"1\">Awaiting Approval</md-option><md-option value=\"2\">Approved</md-option>\n<md-option value=\"3\">On Hold</md-option><md-option value=\"4\">On Stop</md-option><md-option value=\"5\">Waiting for Call\n</md-option></md-select></md-input-container></div><md-button class=\"md-primary md-raised\">Search</md-button><span>\n2 Order(s) Found</span><md-divider></md-divider><div layout=\"row\" class=\"md-dialog-content\"><table \nclass=\"simple tabela-pesquisa\" ms-responsive-table><thead><tr><th>Invoice No</th><th>Prescription No</th><th>City</th>\n<th>Country</th><th>Postcode</th><th>Practice Name</th><th>Practice No</th><th>Client</th><th>GDC No</th><th>\nPatient Name</th><th>Client Name</th></tr></thead><tbody><tr><td>I000846</td><td>C000982</td><td>London</td><td>England\n</td><td>N1 8TU</td><td>Dentux Dental</td><td>0633</td><td>James Burlett</td><td>68442</td><td>SN</td><td>IDH</td></tr>\n<tr><td>I000241</td><td>C000962</td><td>London</td><td>England</td><td>N1 1HX</td><td>Top Dental</td><td>0233</td><td>\nJohn Doe</td><td>91342</td><td>ST</td><td>PCT</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"save()\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/approve.tpl.html","<md-dialog class=\"order-alert\" aria-label=\"Order Alert\" ngapp=\"caseType\"><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.iscustom\" \nng-init=\"vm.record.iscustom=\'0\'\"> <input type=\"hidden\" ng-model=\"vm.record.status_id\" \nng-init=\"vm.record.status_id=\'2\'\"> <input type=\"hidden\" ng-model=\"vm.record.orders_id\" \nng-init=\"vm.record.orders_id=id\"> <input type=\"hidden\" ng-model=\"vm.record.users_id\" \nng-init=\"vm.record.users_id=userid\"><md-toolbar class=\"approveorder-bg\"><div class=\"md-toolbar-tools\"><h2>Approve Order\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex \nmd-is-error=\"recordForm.description.$invalid && (recordForm.description.$touched || recordForm.$submitted)\"><label>\nMessage</label><textarea rows=\"5\" name=\"description\" ng-model=\"vm.record.description\" required></textarea><div \nng-messages=\"recordForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease insert a approval message.</span></div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"end center\"><div class=\"user\">{{username}}, {{data | date:\'dd/MM/yyyy H:m\'}}</div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button>\n<md-button class=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"recordForm.$valid && gravar(vm.record)\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/cancelorder.tpl.html","<md-dialog class=\"order-alert\" aria-label=\"Order Alert\" ngapp=\"caseType\"><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.iscustom\" \nng-init=\"vm.record.iscustom=\'0\'\"> <input type=\"hidden\" ng-model=\"vm.record.status_id\" \nng-init=\"vm.record.status_id=\'1\'\"> <input type=\"hidden\" ng-model=\"vm.record.orders_id\" \nng-init=\"vm.record.orders_id=id\"> <input type=\"hidden\" ng-model=\"vm.record.users_id\" \nng-init=\"vm.record.users_id=userid\"><md-toolbar class=\"cancelorder-bg\"><div class=\"md-toolbar-tools\"><h2>Cancel Order\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex \nmd-is-error=\"recordForm.description.$invalid && (recordForm.description.$touched || recordForm.$submitted)\"><label>\nMessage</label><textarea rows=\"5\" name=\"description\" ng-model=\"vm.record.description\" required></textarea><div \nng-messages=\"recordForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease insert a cancelation message.</span></div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"end center\"><div class=\"user\">{{username}}, {{data | date:\'dd/MM/yyyy H:m\'}}</div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button>\n<md-button class=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"recordForm.$valid && gravar(vm.record)\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/casetype.tpl.html","<md-dialog aria-label=\"Case Type: Case Assessment | Fixed Appliance\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"ctrla.casetypes[\'id\'].orders_id\" \nng-init=\"ctrla.casetypes[\'id\'].orders_id=id\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nCase Type: Case Assessment | Fixed Appliance</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" \nclass=\"md-dialog-content\"><table flex=\"25\"><thead><tr><th>3D</th><th>Upper</th><th>Lower</th></tr></thead><tbody><tr>\n<td>Extras</td><td><input type=\"radio\" name=\"extras\" ng-model=\"ctrla.casetypes[0].upperlower\" value=\"1\" \narial-label=\"Upper\"></td><td><input type=\"radio\" name=\"extras\" ng-model=\"ctrla.casetypes[0].upperlower\" value=\"2\" \narial-label=\"Lower\"></td></tr><tr><td>Gigs</td><td><input type=\"radio\" name=\"gigs\" \nng-model=\"ctrla.casetypes[1].upperlower\" value=\"1\" arial-label=\"Upper\"></td><td><input type=\"radio\" name=\"gigs\" \nng-model=\"ctrla.casetypes[1].upperlower\" value=\"2\" arial-label=\"Lower\"></td></tr><tr><td>NimrodAligner</td><td><input \ntype=\"radio\" name=\"nimrodaligner\" ng-model=\"ctrla.casetypes[2].upperlower\" value=\"1\" arial-label=\"Upper\"></td><td>\n<input type=\"radio\" name=\"nimrodaligner\" ng-model=\"ctrla.casetypes[2].upperlower\" value=\"2\" arial-label=\"Lower\"></td>\n</tr><tr><td>NimrodRetainer</td><td><input type=\"radio\" name=\"nimrodretainer\" ng-model=\"ctrla.casetypes[3].upperlower\" \nvalue=\"1\" arial-label=\"Upper\"></td><td><input type=\"radio\" name=\"nimrodretainer\" \nng-model=\"ctrla.casetypes[3].upperlower\" value=\"2\" arial-label=\"Lower\"></td></tr><tr><td>Splints</td><td><input \ntype=\"radio\" name=\"splints\" ng-model=\"ctrla.casetypes[4].upperlower\" value=\"1\" arial-label=\"Upper\"></td><td><input \ntype=\"radio\" name=\"splints\" ng-model=\"ctrla.casetypes[4].upperlower\" value=\"2\" arial-label=\"Lower\"></td></tr><tr><td>\nStudy Models</td><td><input type=\"radio\" name=\"studymodels\" ng-model=\"ctrla.casetypes[5].upperlower\" value=\"1\" \narial-label=\"Upper\"></td><td><input type=\"radio\" name=\"studymodels\" ng-model=\"ctrla.casetypes[5].upperlower\" value=\"2\" \narial-label=\"Lower\"></td></tr></tbody></table><table flex=\"25\"><thead><tr><th>Case Assessment</th><th>Upper</th><th>\nLower</th></tr></thead><tbody><tr><td>C. A. Brackets</td><td><input type=\"radio\" name=\"cabrackets\" \nng-model=\"ctrla.casetypes[6].upperlower\" value=\"1\" arial-label=\"Upper\"></td><td><input type=\"radio\" name=\"cabrackets\" \nng-model=\"ctrla.casetypes[6].upperlower\" value=\"2\" arial-label=\"Lower\"></td></tr><tr><td>C. A. Clears</td><td><input \ntype=\"radio\" name=\"caclears\" ng-model=\"ctrla.casetypes[7].upperlower\" value=\"1\" arial-label=\"Upper\"></td><td><input \ntype=\"radio\" name=\"caclears\" ng-model=\"ctrla.casetypes[7].upperlower\" value=\"2\" arial-label=\"Lower\"></td></tr><tr><td>\nC. A. Inman</td><td><input type=\"radio\" name=\"cainman\" ng-model=\"ctrla.casetypes[8].upperlower\" value=\"1\" \narial-label=\"Upper\"></td><td><input type=\"radio\" name=\"cainman\" ng-model=\"ctrla.casetypes[8].upperlower\" value=\"2\" \narial-label=\"Lower\"></td></tr><tr><td>C. A. Other</td><td><input type=\"radio\" name=\"caother\" \nng-model=\"ctrla.casetypes[9].upperlower\" value=\"1\" arial-label=\"Upper\"></td><td><input type=\"radio\" name=\"caother\" \nng-model=\"ctrla.casetypes[9].upperlower\" value=\"2\" arial-label=\"Lower\"></td></tr></tbody></table><table flex=\"25\">\n<thead><tr><th>Clear</th><th>Upper</th><th>Lower</th></tr></thead><tbody><tr><td>Bonded Fixed Retainer</td><td><input \ntype=\"radio\" name=\"bondedfixedretainer\" ng-model=\"ctrla.casetypes[10].upperlower\" value=\"1\" arial-label=\"Upper\"></td>\n<td><input type=\"radio\" name=\"bondedfixedretainer\" ng-model=\"ctrla.casetypes[10].upperlower\" value=\"2\" \narial-label=\"Lower\"></td></tr><tr><td>Brackets</td><td><input type=\"radio\" name=\"brackets\" \nng-model=\"ctrla.casetypes[11].upperlower\" value=\"1\" arial-label=\"Upper\"></td><td><input type=\"radio\" name=\"brackets\" \nng-model=\"ctrla.casetypes[11].upperlower\" value=\"2\" arial-label=\"Lower\"></td></tr><tr><td>Clear Aligners</td><td><input\n type=\"radio\" name=\"clearaligners\" ng-model=\"ctrla.casetypes[12].upperlower\" value=\"1\" arial-label=\"Upper\"></td><td>\n<input type=\"radio\" name=\"clearaligners\" ng-model=\"ctrla.casetypes[12].upperlower\" value=\"2\" arial-label=\"Lower\"></td>\n</tr><tr><td>Essix Retainer</td><td><input type=\"radio\" name=\"essixretainer\" ng-model=\"ctrla.casetypes[13].upperlower\" \nvalue=\"1\" arial-label=\"Upper\"></td><td><input type=\"radio\" name=\"essixretainer\" \nng-model=\"ctrla.casetypes[13].upperlower\" value=\"2\" arial-label=\"Lower\"></td></tr><tr><td>Hard & Soft Splints</td><td>\n<input type=\"radio\" name=\"hardsoftsplints\" ng-model=\"ctrla.casetypes[14].upperlower\" value=\"1\" arial-label=\"Upper\">\n</td><td><input type=\"radio\" name=\"hardsoftsplints\" ng-model=\"ctrla.casetypes[14].upperlower\" value=\"2\" \narial-label=\"Lower\"></td></tr></tbody></table><table flex=\"25\"><thead><tr><th>Inam</th><th>Upper</th><th>Lower</th>\n</tr></thead><tbody><tr><td>Fixed Appliance</td><td><input type=\"radio\" name=\"fixedappliance\" \nng-model=\"ctrla.casetypes[15].upperlower\" value=\"1\" arial-label=\"Upper\"></td><td><input type=\"radio\" \nname=\"fixedappliance\" ng-model=\"ctrla.casetypes[15].upperlower\" value=\"2\" arial-label=\"Lower\"></td></tr><tr><td>\nFunctional Appliance</td><td><input type=\"radio\" name=\"functionalappliance\" ng-model=\"ctrla.casetypes[16].upperlower\" \nvalue=\"1\" arial-label=\"Upper\"></td><td><input type=\"radio\" name=\"functionalappliance\" \nng-model=\"ctrla.casetypes[16].upperlower\" value=\"2\" arial-label=\"Lower\"></td></tr><tr><td>Heat Cure</td><td><input \ntype=\"radio\" name=\"heatcure\" ng-model=\"ctrla.casetypes[17].upperlower\" value=\"1\" arial-label=\"Upper\"></td><td><input \ntype=\"radio\" name=\"heatcure\" ng-model=\"ctrla.casetypes[17].upperlower\" value=\"2\" arial-label=\"Lower\"></td></tr><tr><td>\nInmanAligner</td><td><input type=\"radio\" name=\"inmanaligner\" ng-model=\"ctrla.casetypes[18].upperlower\" value=\"1\" \narial-label=\"Upper\"></td><td><input type=\"radio\" name=\"inmanaligner\" ng-model=\"ctrla.casetypes[18].upperlower\" \nvalue=\"2\" arial-label=\"Lower\"></td></tr><tr><td>NimrodAligner</td><td><input type=\"radio\" name=\"nimrodaligner2\" \nng-model=\"ctrla.casetypes[19].upperlower\" value=\"1\" arial-label=\"Upper\"></td><td><input type=\"radio\" \nname=\"nimrodaligner2\" ng-model=\"ctrla.casetypes[19].upperlower\" value=\"2\" arial-label=\"Lower\"></td></tr><tr><td>\nRemovable Appliance</td><td><input type=\"radio\" name=\"removableappliance\" ng-model=\"ctrla.casetypes[20].upperlower\" \nvalue=\"1\" arial-label=\"Upper\"></td><td><input type=\"radio\" name=\"removableappliance\" \nng-model=\"ctrla.casetypes[20].upperlower\" value=\"2\" arial-label=\"Lower\"></td></tr></tbody></table></div><div \nlayout=\"row\" class=\"md-dialog-content\"><table flex=\"25\"><thead><tr><th>Implants</th><th>Upper</th><th>Lower</th></tr>\n</thead><tbody><tr><td>Implant Case</td><td><input type=\"radio\" name=\"implantcase\" \nng-model=\"ctrla.casetypes[21].upperlower\" value=\"1\" arial-label=\"Upper\"></td><td><input type=\"radio\" \nname=\"implantcase\" ng-model=\"ctrla.casetypes[21].upperlower\" value=\"2\" arial-label=\"Lower\"></td></tr></tbody></table>\n<table flex=\"25\"><thead><tr><th>Treatment Plan</th><th>Upper</th><th>Lower</th></tr></thead><tbody><tr><td>\nT. P. Brackets</td><td><input type=\"radio\" name=\"tpbrackets\" ng-model=\"ctrla.casetypes[22].upperlower\" value=\"1\" \narial-label=\"Upper\"></td><td><input type=\"radio\" name=\"tpbrackets\" ng-model=\"ctrla.casetypes[22].upperlower\" value=\"2\" \narial-label=\"Lower\"></td></tr><tr><td>T. P. Clears</td><td><input type=\"radio\" name=\"tpclears\" \nng-model=\"ctrla.casetypes[23].upperlower\" value=\"1\" arial-label=\"Upper\"></td><td><input type=\"radio\" name=\"tpclears\" \nng-model=\"ctrla.casetypes[23].upperlower\" value=\"2\" arial-label=\"Lower\"></td></tr><tr><td>T. P. Iman</td><td><input \ntype=\"radio\" name=\"tpinman\" ng-model=\"ctrla.casetypes[24].upperlower\" value=\"1\" arial-label=\"Upper\"></td><td><input \ntype=\"radio\" name=\"tpinman\" ng-model=\"ctrla.casetypes[24].upperlower\" value=\"2\" arial-label=\"Lower\"></td></tr><tr><td>\nT. P. Other</td><td><input type=\"radio\" name=\"tpother\" ng-model=\"ctrla.casetypes[25].upperlower\" value=\"1\" \narial-label=\"Upper\"></td><td><input type=\"radio\" name=\"tpother\" ng-model=\"ctrla.casetypes[25].upperlower\" value=\"2\" \narial-label=\"Lower\"></td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \ntype=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(ctrla.casetypes)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/completed.tpl.html","<md-dialog class=\"order-alert\" aria-label=\"Order Alert\" ngapp=\"caseType\"><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.iscustom\" \nng-init=\"vm.record.iscustom=\'0\'\"> <input type=\"hidden\" ng-model=\"vm.record.status_id\" \nng-init=\"vm.record.status_id=\'5\'\"> <input type=\"hidden\" ng-model=\"vm.record.orders_id\" \nng-init=\"vm.record.orders_id=id\"> <input type=\"hidden\" ng-model=\"vm.record.users_id\" \nng-init=\"vm.record.users_id=userid\"><md-toolbar class=\"approveorder-bg\"><div class=\"md-toolbar-tools\"><h2>\nComplete Order</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\">\n<md-input-container flex \nmd-is-error=\"recordForm.description.$invalid && (recordForm.description.$touched || recordForm.$submitted)\"><label>\nMessage</label><textarea rows=\"5\" name=\"description\" ng-model=\"vm.record.description\" required></textarea><div \nng-messages=\"recordForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease insert a completion message.</span></div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"end center\"><div class=\"user\">{{username}}, {{data | date:\'dd/MM/yyyy H:m\'}}</div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button>\n<md-button class=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"recordForm.$valid && gravar(vm.record)\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/go.html","<div id=\"pagina-go\" flex layout=\"column\"><div class=\"cabecalho cor-production\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Production</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"><div class=\"estatisticas\" layout=\"row\" layout-align=\"end center\"><ul><li>\n<md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">5</md-button><div class=\"stat-info font-size-8\">\nDue Orders</div></li><li><md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">18</md-button><div \nclass=\"stat-info font-size-8\">Portal Approved</div></li><li><md-button class=\"orders-buttons\" \nng-click=\"vm.gotoOrderStatus()\">26</md-button><div class=\"stat-info font-size-8\">Approved & Waiting</div></li><li>\n<md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">5</md-button><div class=\"stat-info font-size-8\">\nWaiting for Call</div></li><li><md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">3</md-button><div \nclass=\"stat-info font-size-8\">Waiting for Impression</div></li><li><md-button class=\"orders-buttons\" \nng-click=\"vm.gotoOrderStatus()\">5</md-button><div class=\"stat-info font-size-8\">Inactive</div></li><li><md-button \nclass=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">5</md-button><div class=\"stat-info font-size-8\">Completed</div>\n</li></ul></div></div></div><div class=\"topo\" layout=\"row\" layout-align=\"space-between center\"><div flex=\"50\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" layout=\"row\" layout-align=\"start center\"><a \naria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span class=\"font-size-16 font-weight-300\">Dashboard\n</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Production</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Go</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\"><div \nclass=\"pesquisa\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-primary md-raised\" \nng-click=\"search($event)\">Search</md-button></div></div></div><div class=\"estado estado-awaiting\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex layout=\"row\" layout-align=\"center center\"><span \nclass=\"font-size-18 font-weight-400 status-text\">Awaiting Approval</span></div></div><div class=\"estado-funcoes\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"estado-funcoes-esq\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-primary md-raised\">New Order</md-button><md-button \nclass=\"md-primary md-raised\">Scan Order</md-button><md-button class=\"md-primary md-raised\">Generate Barcode</md-button>\n<md-button class=\"md-primary md-raised\">Cancel</md-button><md-button class=\"md-primary md-raised\">Save</md-button>\n</div><div class=\"estado-funcoes-dir\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-primary md-raised\" \nng-click=\"cancelOrder($event)\">Cancel Order</md-button><md-button class=\"md-primary md-raised\" \nng-click=\"approveOrder($event)\">Approve</md-button><md-button class=\"md-primary md-raised\" \nng-click=\"waitingImpressions($event)\">WFI</md-button><md-button class=\"md-primary md-raised\" \nng-click=\"waitingCall($event)\">WFC</md-button><md-button class=\"md-primary md-raised\" ng-click=\"completeOrder($event)\">\nCompleted</md-button></div></div><div><div layout=\"row\"><div flex class=\"orders-page\"><div class=\"order-info\" \nlayout=\"row\" layout-align=\"center center\" ng-if=\"vm.id!=0\"><md-input-container class=\"md-block\" \nng-repeat=\"order in vm.order\"><label>Order No</label><input type=\"text\" value=\"{{order.ordernumber}}\" \ndisabled=\"disabled\"></md-input-container><md-input-container class=\"md-block\" ng-repeat=\"order in vm.order\"><label>\nApproved via</label><md-select ng-model=\"order.approved\"><md-option value=\"portal\">Portal</md-option><md-option \nvalue=\"email\">E-mail</md-option><md-option value=\"phone\">Phone</md-option><md-option value=\"other\">Other</md-option>\n</md-select><div class=\"order-info-date\">&nbsp;<span ng-if=\"order.status_id==2\">{{order.date}}</span></div>\n</md-input-container><md-input-container class=\"md-block\" ng-repeat=\"order in vm.order\"><label>Current Location</label>\n<input type=\"text\" value=\"{{order.department_name}}\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block\" ng-repeat=\"order in vm.order\"><label>Date Received</label><input type=\"text\" \nvalue=\"{{order.datereceived | date:\'d MMMM yyyy\'}}\" disabled=\"disabled\"></md-input-container></div><md-divider>\n</md-divider><div class=\"order-messages\"><div class=\"order-messages-sub\" layout=\"row\"><md-button \nclass=\"order-add md-fab md-mini\" aria-label=\"Add\" ng-click=\"newOrderAlert($event)\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></md-button><md-whiteframe \nng-repeat=\"stat in vm.estados\" class=\"order-message-box md-whiteframe-4dp order-{{stat.iscustom}}{{stat.status_id}}\" \nlayout layout-align=\"center center\"><div layout=\"column\"><div class=\"order-subject\" ng-if=\"stat.iscustom!=1\">\n{{stat.status}}</div><div class=\"order-subject\" ng-if=\"stat.iscustom==1\">{{stat.subject}}</div><div \nclass=\"order-message-parent\"><div class=\"order-message\">{{stat.description}}</div></div><div class=\"order-date\">\n{{stat.name}}, {{stat.date}}</div></div></md-whiteframe></div></div><md-divider></md-divider><div layout=\"row\"><div \nflex class=\"order-case smallmargin\" layout=\"column\" ng-cloak layout-align=\"center center\"><md-button \nclass=\"md-button md-raised full-width\" ng-click=\"showCaseType($event)\">Case Type: Case Assessment | Fixed Appliance\n</md-button></div></div><h2 class=\"department\">Go</h2><div layout=\"row\"><div flex class=\"order-info-more smallmargin\" \nlayout=\"column\" ng-cloak layout-align=\"center center\"><md-button class=\"md-primary md-raised full-width\" \nng-click=\"showOrderInfo($event)\">Order Info</md-button></div><div flex class=\"order-content smallmargin\" \nlayout=\"column\" ng-cloak layout-align=\"center center\"><md-button class=\"md-primary md-raised full-width\" \nng-click=\"showOrderContent($event)\">Order Content</md-button></div></div></div><div flex=\"25\"><div layout=\"row\" \nng-cloak layout-align=\"center center\"><h3>Verify Order</h3></div><div class=\"card-title\">Products</div><ms-card \ntemplate=\"\'app/main/pages/go/templates/products.html\'\" view-model=\"vm\"></ms-card><div class=\"card-title\">Lab Doc</div>\n<ms-card template=\"\'app/main/pages/go/templates/labdoc.html\'\" view-model=\"vm\"></ms-card><div class=\"card-title\">\nLinked Orders</div><ms-card template=\"\'app/main/pages/go/templates/linkedorders.html\'\" view-model=\"vm\"></ms-card><div \nclass=\"card-title\">DLD Actions</div><ms-card template=\"\'app/main/pages/go/templates/dldactions.html\'\" view-model=\"vm\">\n</ms-card><div class=\"card-title\">Order Comments</div><ms-card \ntemplate=\"\'app/main/pages/go/templates/ordercomments.html\'\" view-model=\"vm\"></ms-card></div></div></div></div>");
$templateCache.put("app/main/pages/go/order-alert.tpl.html","<md-dialog class=\"order-alert\" aria-label=\"Order Alert\" ngapp=\"caseType\"><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.iscustom\" \nng-init=\"vm.record.iscustom=\'1\'\"> <input type=\"hidden\" ng-model=\"vm.record.orders_id\" ng-init=\"vm.record.orders_id=id\">\n <input type=\"hidden\" ng-model=\"vm.record.users_id\" ng-init=\"vm.record.users_id=userid\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>New Custom Order Alert</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex \nlayout-align=\"start center\"><md-input-container flex class=\"md-block\" \nmd-is-error=\"recordForm.subject.$invalid && (recordForm.subject.$touched || recordForm.$submitted)\"><label>Subject\n</label><input type=\"text\" name=\"subject\" ng-model=\"vm.record.subject\" required><div \nng-messages=\"recordForm.subject.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert the subject.</span>\n</div></div></md-input-container></div><div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex \nmd-is-error=\"recordForm.description.$invalid && (recordForm.description.$touched || recordForm.$submitted)\"><label>\nMessage</label><textarea rows=\"5\" name=\"description\" ng-model=\"vm.record.description\" required></textarea><div \nng-messages=\"recordForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert the message.\n</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \ntype=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(vm.record)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/search.tpl.html","<md-dialog aria-label=\"Search\" ngapp=\"caseType\"><form ng-cloak class=\"casetype\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Search</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-button \nclass=\"md-primary md-raised\">Scan</md-button><md-icon md-font-icon=\"icon-barcode\" \nclass=\"s48 md-default-theme md-font material-icons icon-barcode\" aria-hidden=\"true\"></md-icon><div layout=\"row\" \nlayout-align=\"start center\"><md-datepicker flex=\"20\" ng-model=\"ctrl.startDate\" md-placeholder=\"Start date\" \nmd-open-on-focus></md-datepicker><md-datepicker flex=\"20\" ng-model=\"ctrl.endDate\" md-placeholder=\"End date\" \nmd-open-on-focus></md-datepicker><md-input-container layout=\"row\" flex=\"30\" class=\"md-block\"><label>Client</label>\n<input type=\"text\"></md-input-container><md-input-container layout=\"row\" flex=\"30\" class=\"md-block\"><label>City</label>\n<input type=\"text\"></md-input-container></div><div layout=\"row\"><md-input-container flex class=\"md-block\"><label>\nOrder No</label><input type=\"text\"></md-input-container><md-input-container flex class=\"md-block\"><label>Patient Name\n</label><input type=\"text\"></md-input-container><md-input-container flex class=\"md-block\"><label>Country</label><input \ntype=\"text\"></md-input-container></div><div layout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>\nPerscription No</label><input type=\"text\"></md-input-container><md-datepicker flex=\"35\" ng-model=\"ctrl.dateReceived\" \nmd-placeholder=\"Received date\" md-open-on-focus></md-datepicker><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>City</label><input type=\"text\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"33\" \nclass=\"md-block\"><label>Department</label><md-select ng-model=\"search.department\"><md-option value=\"1\">Go</md-option>\n<md-option value=\"2\">Plaster Room</md-option><md-option value=\"3\">3D - CT Scan</md-option><md-option value=\"4\">\n3D - Scanning</md-option></md-select></md-input-container><md-input-container flex=\"33\" class=\"md-block\"><label>Status\n</label><md-select ng-model=\"delivery.route\"><md-option value=\"1\">Awaiting Approval</md-option><md-option value=\"2\">\nApproved</md-option><md-option value=\"3\">On Hold</md-option><md-option value=\"4\">On Stop</md-option><md-option \nvalue=\"5\">Waiting for Call</md-option></md-select></md-input-container></div><md-button class=\"md-primary md-raised\">\nSearch</md-button><span>2 Order(s) Found</span><md-divider></md-divider><div layout=\"row\" class=\"md-dialog-content\">\n<table class=\"simple tabela-pesquisa\" ms-responsive-table><thead><tr><th>Invoice No</th><th>Prescription No</th><th>\nCity</th><th>Country</th><th>Postcode</th><th>Practice Name</th><th>Practice No</th><th>Client</th><th>GDC No</th><th>\nPatient Name</th><th>Client Name</th></tr></thead><tbody><tr><td>I000846</td><td>C000982</td><td>London</td><td>England\n</td><td>N1 8TU</td><td>Dentux Dental</td><td>0633</td><td>James Burlett</td><td>68442</td><td>SN</td><td>IDH</td></tr>\n<tr><td>I000241</td><td>C000962</td><td>London</td><td>England</td><td>N1 1HX</td><td>Top Dental</td><td>0233</td><td>\nJohn Doe</td><td>91342</td><td>ST</td><td>PCT</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"cancel()\">Close</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/wfc.tpl.html","<md-dialog class=\"order-alert\" aria-label=\"Order Alert\" ngapp=\"caseType\"><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.iscustom\" \nng-init=\"vm.record.iscustom=\'0\'\"> <input type=\"hidden\" ng-model=\"vm.record.status_id\" \nng-init=\"vm.record.status_id=\'4\'\"> <input type=\"hidden\" ng-model=\"vm.record.orders_id\" \nng-init=\"vm.record.orders_id=id\"> <input type=\"hidden\" ng-model=\"vm.record.users_id\" \nng-init=\"vm.record.users_id=userid\"><md-toolbar class=\"wfc-bg\"><div class=\"md-toolbar-tools\"><h2>Waiting for Call</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex \nmd-is-error=\"recordForm.description.$invalid && (recordForm.description.$touched || recordForm.$submitted)\"><label>\nMessage</label><textarea rows=\"5\" name=\"description\" ng-model=\"vm.record.description\" required></textarea><div \nng-messages=\"recordForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert the message.\n</span></div></div></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><div class=\"user\">\n{{username}}, {{data | date:\'dd/MM/yyyy H:m\'}}</div></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(vm.record)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/wfi.tpl.html","<md-dialog class=\"order-alert\" aria-label=\"Order Alert\" ngapp=\"caseType\"><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.iscustom\" \nng-init=\"vm.record.iscustom=\'0\'\"> <input type=\"hidden\" ng-model=\"vm.record.status_id\" \nng-init=\"vm.record.status_id=\'3\'\"> <input type=\"hidden\" ng-model=\"vm.record.orders_id\" \nng-init=\"vm.record.orders_id=id\"> <input type=\"hidden\" ng-model=\"vm.record.users_id\" \nng-init=\"vm.record.users_id=userid\"><md-toolbar class=\"wfi-bg\"><div class=\"md-toolbar-tools\"><h2>\nWaiting for Impressions</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\">\n<md-input-container flex \nmd-is-error=\"recordForm.description.$invalid && (recordForm.description.$touched || recordForm.$submitted)\"><label>\nMessage</label><textarea rows=\"5\" name=\"description\" ng-model=\"vm.record.description\" required></textarea><div \nng-messages=\"recordForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert the message.\n</span></div></div></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><div class=\"user\">\n{{username}}, {{data | date:\'dd/MM/yyyy H:m\'}}</div></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(vm.record)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/holidays/holidays.html","<div id=\"pagina-consolidation\" flex layout=\"column\"><div class=\"cabecalho cor-lab\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">NimroDENTAL Lab</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"></div></div><div class=\"topo\" layout=\"row\" layout-align=\"start center\"><div \nflex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" layout=\"row\" layout-align=\"start center\"><a\n aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span class=\"font-size-16 font-weight-300\">Dashboard\n</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Holidays</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\">\n</div></div><div layout=\"row\" layout-align=\"center center\"><div class=\"cor-lab-submenu md-padding\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-primary md-raised\" \nng-class=\"vm.type != 1 ? \'md-primary\' : \'no-pointer\'\" ng-click=\"vm.changeType(1)\">Requests</md-button><md-button \nclass=\"md-primary md-raised\" ng-class=\"vm.type != 2 ? \'md-primary\' : \'no-pointer\'\" ng-click=\"vm.changeType(2)\">\nApproved / Declined</md-button><md-button class=\"md-primary md-raised\" \nng-class=\"vm.type != 3 ? \'md-primary\' : \'no-pointer\'\" ng-click=\"vm.changeType(3)\">Year Planner</md-button></div><div \nclass=\"branco-bg md-padding\" flex=\"25\" layout=\"row\" layout-align=\"center center\"><md-button ng-if=\"vm.caixaedicao!=1\" \nclass=\"md-primary md-raised\" ng-disabled=\"true\">New Request</md-button><md-button ng-if=\"vm.caixaedicao==1\" \nclass=\"md-primary md-raised\" ng-disabled=\"true\">Edit Request</md-button></div></div><div layout=\"row\" \nng-if=\"vm.type==3\"><div class=\"md-padding\" flex=\"25\"><h2 style=\"text-align: center\">January {{vm.currYear}}</h2>\n<mwl-calendar view=\"vm.calendarView\" view-date=\"vm.allmonths.jan.data\" events=\"vm.allmonths.jan.eventos\" \ncell-auto-open-disabled=\"true\" cell-is-open=\"false\"></mwl-calendar></div><div class=\"md-padding\" flex=\"25\"><h2 \nstyle=\"text-align: center\">February {{vm.currYear}}</h2><mwl-calendar view=\"vm.calendarView\" \nview-date=\"vm.allmonths.feb.data\" events=\"vm.allmonths.feb.eventos\" cell-auto-open-disabled=\"true\" \ncell-is-open=\"false\"></mwl-calendar></div><div class=\"md-padding\" flex=\"25\"><h2 style=\"text-align: center\">\nMarch {{vm.currYear}}</h2><mwl-calendar view=\"vm.calendarView\" view-date=\"vm.allmonths.mar.data\" \nevents=\"vm.allmonths.mar.eventos\" cell-auto-open-disabled=\"true\" cell-is-open=\"false\"></mwl-calendar></div><div \nclass=\"md-padding\" flex=\"25\"><h2 style=\"text-align: center\">April {{vm.currYear}}</h2><mwl-calendar \nview=\"vm.calendarView\" view-date=\"vm.allmonths.apr.data\" events=\"vm.allmonths.apr.eventos\" \ncell-auto-open-disabled=\"true\" cell-is-open=\"false\"></mwl-calendar></div></div><div layout=\"row\" ng-if=\"vm.type==3\">\n<div class=\"md-padding\" flex=\"25\"><h2 style=\"text-align: center\">May {{vm.currYear}}</h2><mwl-calendar \nview=\"vm.calendarView\" view-date=\"vm.allmonths.may.data\" events=\"vm.allmonths.may.eventos\" \ncell-auto-open-disabled=\"true\" cell-is-open=\"false\"></mwl-calendar></div><div class=\"md-padding\" flex=\"25\"><h2 \nstyle=\"text-align: center\">June {{vm.currYear}}</h2><mwl-calendar view=\"vm.calendarView\" \nview-date=\"vm.allmonths.jun.data\" events=\"vm.allmonths.jun.eventos\" cell-auto-open-disabled=\"true\" \ncell-is-open=\"false\"></mwl-calendar></div><div class=\"md-padding\" flex=\"25\"><h2 style=\"text-align: center\">\nJuly {{vm.currYear}}</h2><mwl-calendar view=\"vm.calendarView\" view-date=\"vm.allmonths.jul.data\" \nevents=\"vm.allmonths.jul.eventos\" cell-auto-open-disabled=\"true\" cell-is-open=\"false\"></mwl-calendar></div><div \nclass=\"md-padding\" flex=\"25\"><h2 style=\"text-align: center\">August {{vm.currYear}}</h2><mwl-calendar \nview=\"vm.calendarView\" view-date=\"vm.allmonths.aug.data\" events=\"vm.allmonths.aug.eventos\" \ncell-auto-open-disabled=\"true\" cell-is-open=\"false\"></mwl-calendar></div></div><div layout=\"row\" ng-if=\"vm.type==3\">\n<div class=\"md-padding\" flex=\"25\"><h2 style=\"text-align: center\">September {{vm.currYear}}</h2><mwl-calendar \nview=\"vm.calendarView\" view-date=\"vm.allmonths.sep.data\" events=\"vm.allmonths.sep.eventos\" \ncell-auto-open-disabled=\"true\" cell-is-open=\"false\"></mwl-calendar></div><div class=\"md-padding\" flex=\"25\"><h2 \nstyle=\"text-align: center\">October {{vm.currYear}}</h2><mwl-calendar view=\"vm.calendarView\" \nview-date=\"vm.allmonths.oct.data\" events=\"vm.allmonths.oct.eventos\" cell-auto-open-disabled=\"true\" \ncell-is-open=\"false\"></mwl-calendar></div><div class=\"md-padding\" flex=\"25\"><h2 style=\"text-align: center\">\nNovember {{vm.currYear}}</h2><mwl-calendar view=\"vm.calendarView\" view-date=\"vm.allmonths.nov.data\" \nevents=\"vm.allmonths.nov.eventos\" cell-auto-open-disabled=\"true\" cell-is-open=\"false\"></mwl-calendar></div><div \nclass=\"md-padding\" flex=\"25\"><h2 style=\"text-align: center\">December {{vm.currYear}}</h2><mwl-calendar \nview=\"vm.calendarView\" view-date=\"vm.allmonths.dec.data\" events=\"vm.allmonths.dec.eventos\" \ncell-auto-open-disabled=\"true\" cell-is-open=\"false\"></mwl-calendar></div></div><div layout=\"row\"><div flex \nclass=\"md-padding branco-bg\"><div class=\"pagina-orderstatus\"><md-button layout=\"row\" layout-align=\"center center\" \nclass=\"md-primary md-raised\" ng-click=\"vm.reset()\">Reset</md-button><div layout=\"row\"><md-input-container layout=\"row\" \nflex class=\"md-block\"><label>Start date (yyyy-mm-dd)</label><input type=\"text\" name=\"startDate\" mask=\"9999-19-39\" \nng-model=\"vm.startDate\" ng-change=\"vm.searchTable(vm.startDate, 0)\" ng-model-options=\"{ debounce: 750 }\" \nng-disabled=\"vm.searchdisable\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\"><label>\nEnd date (yyyy-mm-dd)</label><input type=\"text\" name=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.endDate\" \nng-change=\"vm.searchTable(vm.endDate, 1)\" ng-model-options=\"{ debounce: 750 }\" ng-disabled=\"vm.searchdisable\">\n</md-input-container><md-input-container layout=\"row\" flex class=\"md-block\"><label>On Date (yyyy-mm-dd)</label><input \ntype=\"text\" name=\"onDate\" mask=\"9999-19-39\" ng-model=\"vm.onDate\" ng-change=\"vm.searchTable(vm.onDate, 5)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container flex class=\"md-block\"><label>Name</label>\n<input name=\"name\" ng-model=\"vm.search.name\" ng-change=\"vm.searchTable(vm.search.name, 2)\" type=\"text\">\n</md-input-container></div></div><div class=\"pagina-orderstatus full-width\" layout=\"row\" \nlayout-align=\"space-between center\"><table datatable=\"\" class=\"row-border hover full-width\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\"></table></div></div><div flex=\"32\"><div\n layout=\"row\" ng-cloak layout-align=\"center center\"></div><ms-card ng-if=\"vm.caixaedicao!=1 && vm.type==1\" flex \ntemplate=\"\'app/templates/cards/holidays/newrequest.html\'\" view-model=\"vm\"></ms-card><ms-card \nng-if=\"vm.caixaedicao==1 && vm.type==1\" flex template=\"\'app/templates/cards/holidays/editrequest.html\'\" \nview-model=\"vm\"></ms-card></div></div></div>");
$templateCache.put("app/main/pages/invoice/invoice.html","<div id=\"pagina-invoice\" flex layout=\"column\"><div class=\"cabecalho cor-accounts\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Invoicing</span></div></div></div><div \nclass=\"topo\" layout=\"row\" layout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\">\n<div class=\"breadcrumbs\" layout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" \nhref=\"/dashboard.html\"><span class=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" \naria-hidden=\"true\"></md-icon><span class=\"font-size-16 font-weight-300\">Invoicing</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" \naria-hidden=\"true\"></md-icon><span class=\"font-size-16 font-weight-300\">Generate Invoice</span></div></div><div \nflex=\"50\" layout=\"row\" layout-align=\"end center\"><div class=\"pesquisa\" layout=\"row\" layout-align=\"end center\">\n<md-button class=\"md-raised cor-accounts\" ng-click=\"vm.openPopupOther($event, \'search\')\">Search</md-button></div></div>\n</div><div class=\"estado-funcoes\" layout=\"row\" layout-align=\"space-between center\"><div class=\"estado-funcoes-esq\" \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised cor-accounts\" \nng-click=\"vm.disabled==false ? vm.createInvoice($event) : \'\'\">New Invoice</md-button><md-button \nng-if=\"vm.invoiceid!=\'\'\" class=\"md-primary md-raised\" ng-click=\"vm.disabled==false ? vm.deleteInvoice($event) : \'\'\">\nDelete Invoice</md-button></div><div ng-if=\"vm.invoiceid!=\'\'\" class=\"estado-funcoes-dir\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-primary md-raised\" ng-click=\"vm.printInvoice()\">Print</md-button>\n<md-button class=\"md-primary md-raised\" ng-click=\"vm.openPopupOther($event, \'sendInvoice\')\">E-mail Invoice</md-button>\n<md-button class=\"md-primary md-raised\" ng-click=\"vm.disabled==false ? vm.modifyInvoice($event) : \'\'\">Modify Invoice\n</md-button><md-button class=\"md-raised\" ng-click=\"vm.disabled==false ? vm.generateInvoice($event) : \'\'\" \nng-class=\"{\'cor-accounts\': vm.invoice.invoices_status == 0, \'md-grey-bg\': vm.invoice.invoices_status == 1}\">\nGenerate Invoice</md-button></div></div><div class=\"orders-row\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"orders-tab\"><div layout=\"row\" layout-align=\"start center\" ng-repeat=\"opened in vm.invoices_opened\" \nng-class=\"opened.invoices_id == vm.invoiceid ? \'order-tab-active\' : \'pointer\'\" class=\"order-tab\"><div layout=\"row\" \nlayout-align=\"start center\" \nng-click=\"opened.invoices_id != vm.invoiceid ? vm.goToPage(\'invoice\', opened.invoices_id, false, true) : \'\'\">\n{{opened.invoice_number}}</div><div ng-if=\"opened.invoices_id == vm.invoiceid\" layout=\"row\" layout-align=\"end center\" \nclass=\"relative\"><md-icon md-font-icon=\"icon-window-close\" \nng-click=\"vm.goToPage(\'invoice\', opened.invoices_id, true, true)\" \nclass=\"s24 md-font icon-window-close pointer botao-fechar\" aria-hidden=\"true\"><md-tooltip md-direction=\"top\">\nClick to close this invoice</md-tooltip></md-icon></div><div ng-if=\"opened.invoices_id != vm.invoiceid\" layout=\"row\" \nlayout-align=\"end center\" class=\"relative\"><md-icon md-font-icon=\"icon-window-close\" \nng-click=\"vm.goToPage(\'invoice\', opened.invoices_id, true, false)\" \nclass=\"s24 md-font icon-window-close pointer botao-fechar\" aria-hidden=\"true\"><md-tooltip md-direction=\"top\">\nClick to close this invoice</md-tooltip></md-icon></div></div></div><div flex layout=\"row\"><div flex \nclass=\"orders-page\"><div class=\"order-messages\" ng-if=\"vm.invoiceid!=\'\'\"><div class=\"order-messages-sub\" layout=\"row\">\n<md-whiteframe ng-repeat=\"stat in vm.estados\" \nclass=\"order-message-box md-whiteframe-4dp order-{{stat.iscustom}}{{stat.status_id}}\" layout \nlayout-align=\"center center\"><div layout=\"column\"><div class=\"order-subject\" ng-if=\"stat.iscustom!=1\">{{stat.status}}\n</div><div class=\"order-subject\" ng-if=\"stat.iscustom==1\">{{stat.subject}}</div><div class=\"order-message-parent\"><div \nclass=\"order-message\">{{stat.description}}</div></div><div class=\"order-date\">{{stat.name}}, {{stat.date}}</div></div>\n</md-whiteframe></div></div><md-divider></md-divider><div class=\"invoice-sheet\" layout=\"row\" ng-if=\"vm.invoiceid!=\'\'\">\n<div flex=\"80\" layout=\"column\"><div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex \nclass=\"md-block\" layout-align=\"start center\"><label>Invoice Number</label><input type=\"text\" name=\"invoice_number\" \nng-model=\"vm.invoice.invoice_number\" disabled=\"disabled\" aria-label=\"Invoice Number\"></md-input-container>\n<md-input-container flex class=\"md-block\" layout-align=\"start center\"><label>Invoice Date</label><input type=\"text\" \nname=\"creation_date\" value=\"{{vm.invoice.creation_date| cmdate:\'dd MMMM yyyy\'}}\" disabled=\"disabled\" \naria-label=\"Invoice Date\"></md-input-container></div><input type=\"hidden\" ng-if=\"item.clientname\" \nng-model=\"vm.cliente.clientname\" ng-init=\"vm.cliente.clientname=\'{{item.clientname}}\'\"> <input type=\"hidden\" \nng-if=\"!item.clientname\" ng-model=\"vm.cliente.clientname\" ng-init=\"vm.cliente.clientname=vm.cliente.clientname\"><div \nlayout=\"row\" layout-align=\"start center\"><md-autocomplete ng-if=\"vm.jaexiste == \'0\'\" flex required \nmd-input-name=\"autocompleteField\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedItem\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchText)\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.clientname\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-require-match md-input-minlength=\"2\" md-input-maxlength=\"18\" \nmd-floating-label=\"Client Name\" ng-disabled=\"vm.isDisabled\" ng-click=\"vm.ativa()\" md-delay=\"400\" md-autofocus>\n<md-item-template><span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.clientname}}</span>\n</md-item-template><md-not-found>No matches found. <a ng-click=\"vm.newClient()\">Create client</a></md-not-found>\n</md-autocomplete><md-input-container flex ng-if=\"vm.jaexiste == \'1\' && vm.disabled == false\" class=\"md-block\" \nng-click=\"vm.alterar()\"><label>Client Name</label><md-tooltip md-direction=\"bottom\">Click to change the client\n</md-tooltip><input required type=\"text\" name=\"clientname\" ng-model=\"vm.cliente.clientname\" \nvalue=\"{{vm.cliente.clientname}}\" disabled=\"disabled\"></md-input-container><md-input-container flex \nng-if=\"vm.disabled == true\" class=\"md-block\"><label>Client Name</label><input required type=\"text\" name=\"clientname\" \nng-model=\"vm.cliente.clientname\" value=\"{{vm.cliente.clientname}}\" disabled=\"disabled\"></md-input-container>\n<md-input-container flex class=\"md-block\" layout-align=\"start center\"><label>Practice Name</label><input type=\"text\" \nname=\"practice_name\" ng-model=\"vm.cliente.practicename\" disabled=\"disabled\" aria-label=\"Practice Name\">\n</md-input-container><md-input-container flex class=\"md-block\" layout-align=\"start center\"><label>Performer</label>\n<input type=\"text\" name=\"performer\" ng-model=\"vm.cliente.performername\" disabled=\"disabled\" aria-label=\"Performer\">\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><div flex-xs flex layout=\"column\">\n<md-input-container flex><label>Address</label><textarea rows=\"4\" name=\"clientaddress\" md-autogrow disabled=\"disabled\">\n{{vm.cliente.caddress1}}&#13;&#10;{{vm.cliente.caddress2}}&#13;&#10;{{vm.cliente.cpostcode}}&#13;&#10;{{vm.cliente.ccity}}&#13;&#10;{{vm.cliente.ccountry}}\n</textarea></md-input-container></div><div flex-xs flex layout=\"column\"><md-input-container flex><label>\nPractice Address</label><textarea rows=\"4\" name=\"practiceaddress\" md-autogrow disabled=\"disabled\">\n{{vm.cliente.address1}}&#13;&#10;{{vm.cliente.address2}}&#13;&#10;{{vm.cliente.postcode}}&#13;&#10;{{vm.cliente.county}} - {{vm.cliente.city}}&#13;&#10;{{vm.cliente.country}}&#13;&#10;&#13;&#10;Practice No {{vm.cliente.practicenumber}}\n</textarea></md-input-container></div><div flex-xs flex layout=\"column\"><md-input-container flex><label>GDC</label>\n<input type=\"text\" name=\"gdc_number\" ng-model=\"vm.cliente.gdc_number\" disabled=\"disabled\" aria-label=\"GDC Number\">\n</md-input-container><md-input-container flex><label>Payment Conditions</label><md-select name=\"payments_id\" \nng-model=\"vm.cliente.payments_id\"><md-option ng-repeat=\"(index,payment) in vm.payments\" ng-value=\"payment.payments_id\" \nng-selected=\"payment.payments_id == \'{{vm.cliente.payments_id}}\'\" disabled=\"disabled\">{{payment.type_payment}}\n</md-option></md-select><div class=\"order-info-date\">&nbsp;<span ng-if=\"order.status_id==2\">{{order.date}}</span></div>\n</md-input-container></div></div></div><div layout=\"row\" flex layout-align=\"end start\"><div class=\"invoice-title\">\nInvoice</div></div></div><div class=\"invoice-products\" layout=\"row\" ng-if=\"vm.invoiceid!=\'\'\"><table datatable=\"ng\" \nclass=\"compact hover row-border\"><thead><tr><th>Product Code</th><th>Description</th><th>Order No.</th><th>Patient</th>\n<th>Order Type</th><th>Ticket Date</th><th>Shipping Date</th><th>Qty</th><th>Unit Rate</th><th>VAT</th><th>Discount\n</th><th>Total</th></tr></thead><tbody><tr ng-repeat-start=\"item in vm.invoicesitems\"><td>{{item.product_code}}</td>\n<td><span ng-if=\"item.upperORlower == 1\">U/</span><span ng-if=\"item.upperORlower == 2\">L/</span>\n{{item.product_description}}</td><td>{{item.ordernumber}}</td><td ng-if=\"item.patient_name != \'\'\">{{item.patient_name}}\n</td><td ng-if=\"item.patient_ref != \'\' && item.patient_name == \'\'\">{{item.patient_ref}}</td><td>{{item.ordertype}}</td>\n<td></td><td></td><td>{{item.qty}}</td><td>£{{item.irate}}</td><td>{{item.VAT}}%</td><td>{{item.discount}}%</td><td>\n<strong>£{{item.ratefinal}}</strong></td></tr><tr ng-repeat-end><td \nng-if=\"item.date!=null && item.date != item.nextdate\" colspan=\"12\" class=\"center italic\">\nInvoiced On {{item.date| cmdate:\'dd-MMM-yy\'}}</td></tr></tbody><tfoot><tr><td colspan=\"11\" \nstyle=\"text-align:right;font-weight:bold\">Net</td><td><strong>£{{vm.invoiceTotalNet}}</strong></td></tr><tr><td \ncolspan=\"11\" style=\"text-align:right;font-weight:bold\">VAT</td><td><strong>£{{vm.invoiceTotalVAT}}</strong></td></tr>\n<tr><td colspan=\"11\" style=\"text-align:right;font-weight:bold\">Total</td><td><strong>£{{vm.invoiceTotalTotal}}</strong>\n</td></tr></tfoot></table></div><div layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.invoiceid!=\'\' && vm.cliente.invoices_status == 0\"><md-button class=\"md-fab md-green-bg\" \naria-label=\"Add Product(s)\" ng-click=\"vm.openPopupOther($event, \'addNewProduct\')\"><md-tooltip md-direction=\"top\">\nAdd Product(s)</md-tooltip><md-icon md-font-icon=\"icon-plus\" class=\"s24 branco md-font material-icons icon-home\" \naria-hidden=\"true\"></md-icon></md-button></div></div><div flex=\"25\" ng-if=\"vm.invoiceid!=\'\'\"><div class=\"card-title\">\nCurrent Orders</div><ms-card ng-if=\"vm.invoiceid!=\'\'\" template=\"\'app/main/pages/invoice/templates/currentorders.html\'\" \nview-model=\"vm\"></ms-card><div class=\"card-title\">On Invoice</div><ms-card ng-if=\"vm.invoiceid!=\'\'\" \ntemplate=\"\'app/main/pages/invoice/templates/oninvoice.html\'\" view-model=\"vm\"></ms-card><div class=\"card-title\">\nInvoice Actions</div><ms-card ng-if=\"vm.invoiceid!=\'\'\" \ntemplate=\"\'app/main/pages/invoice/templates/invoiceactions.html\'\" view-model=\"vm\"></ms-card></div></div></div></div>");
$templateCache.put("app/main/pages/invoicesearch/invoicesearch.html","<div id=\"pagina-invoice\" flex layout=\"column\"><div class=\"cabecalho cor-accounts\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Invoicing</span></div></div></div><div \nclass=\"topo\" layout=\"row\" layout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\">\n<div class=\"breadcrumbs\" layout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" \nhref=\"/dashboard.html\"><span class=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" \naria-hidden=\"true\"></md-icon><span class=\"font-size-16 font-weight-300\">Invoicing</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" \naria-hidden=\"true\"></md-icon><span class=\"font-size-16 font-weight-300\">Invoice Search</span></div></div><div \nflex=\"50\" layout=\"row\" layout-align=\"end center\"><div class=\"pesquisa\" layout=\"row\" layout-align=\"end center\">\n<md-button class=\"md-raised md-primary\" ng-click=\"vm.printInvoices(vm.itemabrir)\">Print ({{vm.itemabrir.length}})\n</md-button><md-button class=\"md-raised md-primary\" ng-click=\"vm.sendEmail(vm.itemabrir)\">\nE-mail Invoice ({{vm.itemabrir.length}})</md-button></div></div></div><div flex layout=\"row\"><div flex \nclass=\"orders-page\"><md-divider></md-divider><div class=\"invoicesearch-page\"><div class=\"estado-funcoes\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"estado-funcoes-esq\" layout=\"row\" layout-align=\"start center\"><md-button\n class=\"md-primary md-raised\" ng-click=\"vm.openPopupOther($event, \'scaninvoice\')\">Scan</md-button><md-icon \nmd-font-icon=\"icon-barcode\" ng-click=\"vm.openPopupOther($event, \'scaninvoice\')\" \nclass=\"s48 md-default-theme md-font material-icons icon-barcode pointer\" aria-hidden=\"true\"></md-icon></div><div \nclass=\"estado-funcoes-dir\" layout=\"row\" layout-align=\"end center\" ng-click=\"vm.reset()\"><md-button \nclass=\"md-primary md-raised\">Reset</md-button><md-icon md-font-icon=\"icon-refresh\" \nclass=\"s36 md-default-theme md-font material-icons icon-refresh pointer\" aria-hidden=\"true\"></md-icon></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>\nStart date (yyyy-mm-dd)</label><input type=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.startDate\" \nng-change=\"vm.searchTable(vm.startDate, 14)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>End date (yyyy-mm-dd)</label><input type=\"text\" \nname=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.endDate\" ng-change=\"vm.searchTable(vm.endDate, 15)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>Creation Date (yyyy-mm-dd)</label><input type=\"text\" name=\"onDate\" mask=\"9999-19-39\" ng-model=\"vm.onDate\" \nng-change=\"vm.searchTable(vm.onDate, 13)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container\n layout=\"row\" flex class=\"md-block\"><label>Invoice No</label><input ng-model=\"vm.search.invoice_number\" \nng-change=\"vm.searchTable(vm.search.invoice_number, 0)\" type=\"text\"></md-input-container><md-input-container \nlayout=\"row\" flex class=\"md-block\"><label>Client Name</label><input type=\"text\" ng-model=\"vm.search.clientname\" \nng-change=\"vm.searchTable(vm.search.clientname, 11)\"></md-input-container></div><div layout=\"row\"><md-input-container \nlayout=\"row\" flex class=\"md-block\"><label>Patient Name</label><input type=\"text\" ng-model=\"vm.search.patient_name\" \nng-change=\"vm.searchTable(vm.search.patient_name, 10)\"></md-input-container><md-input-container layout=\"row\" flex \nclass=\"md-block\"><label>Practice Name</label><input type=\"text\" ng-model=\"vm.search.pratice_name\" \nng-change=\"vm.searchTable(vm.search.pratice_name, 5)\"></md-input-container><md-input-container layout=\"row\" flex \nclass=\"md-block\"><label>Practice No</label><input type=\"text\" ng-model=\"vm.search.practice_number\" \nng-change=\"vm.searchTable(vm.search.practice_number, 6)\"></md-input-container><md-input-container layout=\"row\" flex \nclass=\"md-block\"><label>Client</label><input ng-model=\"vm.search.performername\" \nng-change=\"vm.searchTable(vm.search.performername, 7)\" type=\"text\"></md-input-container><md-input-container \nlayout=\"row\" flex class=\"md-block\"><label>GDC No</label><input ng-model=\"vm.search.gdc_number\" \nng-change=\"vm.searchTable(vm.search.gdc_number, 8)\" type=\"text\"></md-input-container></div><div layout=\"row\">\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>City</label><input ng-model=\"vm.search.ccity\" \nng-change=\"vm.searchTable(vm.search.ccity, 2)\" type=\"text\"></md-input-container><md-input-container layout=\"row\" flex \nclass=\"md-block\"><label>Country</label><input ng-model=\"vm.search.ccountry\" \nng-change=\"vm.searchTable(vm.search.ccountry, 3)\" type=\"text\"></md-input-container><md-input-container layout=\"row\" \nflex class=\"md-block\"><label>Postcode</label><input ng-model=\"vm.search.cpostcode\" \nng-change=\"vm.searchTable(vm.search.cpostcode, 4)\" type=\"text\"></md-input-container><md-input-container flex \nclass=\"md-block\"><label>Invoice Status</label><md-select ng-model=\"vm.search.invoices_status\" \nng-change=\"vm.searchTable(vm.search.invoices_status, 12)\"><md-option value=\"1\">Consolidated</md-option><md-option \nvalue=\"0\">Non-Consolidated</md-option></md-select></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-green-500-bg branco\" ng-if=\"vm.itemabrir && vm.itemabrir.length==1\" \nng-click=\"vm.openInvoice(vm.itemabrir)\">Open Invoice</md-button><md-button class=\"md-green-500-bg branco\" \nng-if=\"vm.itemabrir && vm.itemabrir.length>1\" ng-click=\"vm.openInvoice(vm.itemabrir)\">\nOpen {{vm.itemabrir.length}} Invoices</md-button></div><div layout=\"row\" class=\"full-width\"><table datatable=\"\" \nclass=\"simple tabela-pesquisa full-width\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"></table></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-green-500-bg branco\" ng-if=\"vm.itemabrir && vm.itemabrir.length==1\" ng-click=\"vm.openInvoice(vm.itemabrir)\">\nOpen Invoice</md-button><md-button class=\"md-green-500-bg branco\" ng-if=\"vm.itemabrir && vm.itemabrir.length>1\" \nng-click=\"vm.openInvoice(vm.itemabrir)\">Open {{vm.itemabrir.length}} Invoices</md-button></div></div></div></div></div>");
$templateCache.put("app/main/pages/marketing/marketing.html","<div id=\"pagina-marketing\" flex layout=\"column\"><div class=\"cabecalho cor-marketing\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Marketing</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"></div></div><div class=\"topo\" layout=\"row\" layout-align=\"space-between center\">\n<div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" layout=\"row\" \nlayout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Marketing</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Events / Tasks</span></div></div><div flex=\"50\" layout=\"row\" \nlayout-align=\"end center\"></div></div><div layout=\"row\" layout-align=\"center center\"><div \nclass=\"cor-marketing-sub md-padding\" flex layout=\"row\" layout-align=\"center center\"></div><div \nclass=\"branco-bg md-padding\" flex=\"25\" layout=\"row\" layout-align=\"center center\"><md-button ng-if=\"vm.caixaedicao!=1\" \nclass=\"md-primary md-raised\" ng-disabled=\"true\">New</md-button><md-button ng-if=\"vm.caixaedicao==1\" \nclass=\"md-primary md-raised\" ng-disabled=\"true\">Edit</md-button></div></div><div><div layout=\"row\"><div flex \nclass=\"md-padding full-width branco-bg\"><md-button layout=\"row\" layout-align=\"center center\" \nclass=\"md-primary md-raised\" ng-click=\"vm.reset()\">Reset</md-button><div layout=\"row\"><md-input-container layout=\"row\" \nflex class=\"md-block\"><label>Start date (yyyy-mm-dd)</label><input type=\"text\" name=\"start_date\" mask=\"9999-19-39\" \nng-model=\"vm.search.start_date\" ng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container \nlayout=\"row\" flex class=\"md-block\"><label>End date (yyyy-mm-dd)</label><input type=\"text\" name=\"end_date\" \nmask=\"9999-19-39\" ng-model=\"vm.search.end_date\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container flex class=\"md-block\"><label>Name</label><input name=\"name\" ng-model=\"vm.search.name\" type=\"text\">\n</md-input-container><md-input-container flex class=\"md-block\"><label>Type</label><md-select name=\"type\" \nng-model=\"vm.search.type\"><md-option value=\"\">All</md-option><md-option value=\"1\">Event</md-option><md-option \nvalue=\"2\">Task</md-option></md-select></md-input-container><md-input-container flex class=\"md-block\"><label>Status\n</label><md-select name=\"type\" ng-model=\"vm.search.completed\"><md-option value=\"\">All</md-option><md-option value=\"1\">\nCompleted</md-option><md-option value=\"0\">Uncompleted</md-option></md-select></md-input-container></div><h3>\n{{vm.cards.length}} Events / Tasks</h3><md-card class=\"event-card\" ng-repeat=\"card in vm.cards | filter:vm.search\"><div\n layout=\"row\"><div layout=\"column\" class=\"mkt-coluna-esq color-white\" \nng-class=\"card.type == 1 ? \'cor-marketing\' : \'color-mkt-event-bkg\'\" layout-align=\"center center\" flex=\"40\"><div \nclass=\"mkt-day\">{{card.start_date | cmdate:\'dd\'}}</div><div class=\"mkt-month\">{{card.start_date | cmdate:\'MMMM yyyy\'}}\n</div><div class=\"mkt-time\">{{card.start_date | cmdate:\'HH:ss\'}} - {{card.end_date | cmdate:\'HH:ss\'}}</div><div \nclass=\"mkt-address\"><span ng-if=\"card.address_1\">{{card.address_1}} </span><span ng-if=\"card.address_2\">\n{{card.address_2}} </span><span ng-if=\"card.city\">{{card.city}} </span><span ng-if=\"card.county\">{{card.county}} \n</span><span ng-if=\"card.postcode\">{{card.postcode}} </span><span ng-if=\"card.country\">{{card.country}}</span></div>\n</div><div layout=\"column\" flex class=\"mkt-coluna-dta md-padding\"><div layout=\"row\"><div ng-if=\"card.type == 1\" flex \nlayout-align=\"start center\" class=\"mkt-type color-marketing\">Event</div><div ng-if=\"card.type == 2\" flex \nlayout-align=\"start center\" class=\"mkt-type color-mkt-event\">Task</div><div flex layout-align=\"end center\" \nclass=\"mkt-completed\"><md-input-container><md-checkbox ng-model=\"card.completed\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"completed\" ng-change=\"vm.changeCompleteStatus(card.marketing_id,card.completed)\">Completed</md-checkbox>\n</md-input-container></div></div><div class=\"mkt-name\">{{card.name}}</div><div class=\"mkt-description\">\n{{card.description}}</div><div class=\"mkt-created\">Created By:</div><div class=\"mkt-user\">\n{{card.name}} | {{card.created_date | cmdate:\'dd/MM/yyyy\'}}</div><div class=\"mkt-delete\"><md-icon \nmd-font-icon=\"icon-trash\" class=\"s24 md-font icon-trash pointer\" aria-hidden=\"true\" \nng-click=\"vm.deleteExistingMarketing(event, card.marketing_id)\"></md-icon></div></div></div></md-card></div><div \nflex=\"25\"><div layout=\"row\" ng-cloak layout-align=\"center center\"></div><ms-card ng-if=\"vm.caixaedicao!=1\" flex \ntemplate=\"\'app/templates/cards/marketing/newevent.html\'\" view-model=\"vm\"></ms-card></div></div></div></div>");
$templateCache.put("app/main/pages/members/members.html","<div id=\"pagina-members\" flex layout=\"column\"><div class=\"cabecalho cor-settings\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Members</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"></div></div><div class=\"topo\" layout=\"row\" layout-align=\"space-between center\">\n<div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" layout=\"row\" \nlayout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">System Settings</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Members</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\">\n</div></div><div layout=\"row\" layout-align=\"center center\"><div class=\"cor-delivery md-padding\" flex layout=\"row\" \nlayout-align=\"center center\"><md-input-container flex=\"20\" class=\"md-block\"><label>Code</label><input \nng-model=\"vm.search.code\" ng-change=\"vm.searchTable(vm.search.code, 0)\" type=\"text\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>User Name</label><input ng-model=\"vm.search.name\" \nng-change=\"vm.searchTable(vm.search.name, 1)\" type=\"text\"></md-input-container><md-input-container flex \nclass=\"md-block\"><label>Job Title</label><input ng-model=\"vm.search.jobtitle\" \nng-change=\"vm.searchTable(vm.search.jobtitle, 3)\" type=\"text\"></md-input-container><md-button ng-click=\"vm.reset()\" \nclass=\"md-primary md-raised\">Reset</md-button></div><div class=\"branco-bg md-padding\" flex=\"25\" layout=\"row\" \nlayout-align=\"center center\"><md-button ng-if=\"vm.caixaedicao!=1\" class=\"md-primary md-raised\" ng-disabled=\"true\">\nNew User</md-button><md-button ng-if=\"vm.caixaedicao==1\" class=\"md-primary md-raised\" ng-disabled=\"true\">Edit User\n</md-button></div></div><div><div layout=\"row\"><div flex class=\"md-padding branco-bg\"><table datatable=\"\" \nclass=\"simple tabela-pesquisa\" ms-responsive-table dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"></table></div><div flex=\"25\"><div layout=\"row\" ng-cloak layout-align=\"center center\"></div>\n<ms-card ng-if=\"vm.caixaedicao!=1\" flex template=\"\'app/templates/cards/members/newmember.html\'\" view-model=\"vm\">\n</ms-card><ms-card ng-if=\"vm.caixaedicao==1\" flex template=\"\'app/templates/cards/members/editmember.html\'\" \nview-model=\"vm\"></ms-card></div></div></div></div>");
$templateCache.put("app/main/pages/orderstatus/orderstatus.html","<div id=\"pagina-orderstatus\" flex layout=\"column\"><div class=\"cabecalho cor-accounts\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Production</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"><div class=\"estatisticas\" layout=\"row\" layout-align=\"end center\"><ul><li>\n<md-button class=\"orders-buttons\">{{vm.onstoporders}}</md-button><div class=\"stat-info font-size-8\">On Stop</div></li>\n<li><md-button class=\"orders-buttons\">{{vm.dueorders}}</md-button><div class=\"stat-info font-size-8\">Due Orders</div>\n</li><li><md-button class=\"orders-buttons\">{{vm.approvedvia}}</md-button><div class=\"stat-info font-size-8\">\nPortal Approved</div></li><li><md-button class=\"orders-buttons\">{{vm.approvedwaiting}}</md-button><div \nclass=\"stat-info font-size-8\">Approved & Waiting</div></li><li><md-button class=\"orders-buttons\">{{vm.waitingcall}}\n</md-button><div class=\"stat-info font-size-8\">Waiting for Call</div></li><li><md-button class=\"orders-buttons\">\n{{vm.waitingimpression}}</md-button><div class=\"stat-info font-size-8\">Waiting for Impression</div></li><li><md-button \nclass=\"orders-buttons\">{{vm.inactiveorders}}</md-button><div class=\"stat-info font-size-8\">Inactive</div></li><li>\n<md-button class=\"orders-buttons\">{{vm.numcompleted}}</md-button><div class=\"stat-info font-size-8\">Completed</div>\n</li></ul></div></div></div><div class=\"topo\" layout=\"row\" layout-align=\"start center\"><div flex=\"50\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"breadcrumbs\" layout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" \nui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span class=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" \naria-hidden=\"true\"></md-icon><span class=\"font-size-16 font-weight-300\">Production</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" \naria-hidden=\"true\"></md-icon><span class=\"font-size-16 font-weight-300\">Order Status</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"><div class=\"pesquisa\" layout=\"row\" layout-align=\"end center\"><md-button>\nTotal Orders: {{vm.total}}</md-button></div></div></div><div class=\"pagina-orderstatus\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button ng-class=\"vm.type != 1 ? \'md-primary\' : \'\'\" class=\"md-raised\" \nng-click=\"vm.changeType(1)\">On Stop</md-button><md-button ng-class=\"vm.type != 2 ? \'md-primary\' : \'\'\" \nclass=\"md-raised\" ng-click=\"vm.changeType(2)\">Due Orders</md-button><md-button \nng-class=\"vm.type != 3 ? \'md-primary\' : \'\'\" class=\"md-raised\" ng-click=\"vm.changeType(3)\">Approved Via Portal\n</md-button><md-button ng-class=\"vm.type != 4 ? \'md-primary\' : \'\'\" class=\"md-raised\" ng-click=\"vm.changeType(4)\">\nApproved & Waiting</md-button><md-button ng-class=\"vm.type != 5 ? \'md-primary\' : \'\'\" class=\"md-raised\" \nng-click=\"vm.changeType(5)\">Waiting for Call</md-button><md-button ng-class=\"vm.type != 6 ? \'md-primary\' : \'\'\" \nclass=\"md-raised\" ng-click=\"vm.changeType(6)\">Waiting for Impression</md-button><md-button \nng-class=\"vm.type != 7 ? \'md-primary\' : \'\'\" class=\"md-raised\" ng-click=\"vm.changeType(7)\">Inactive</md-button></div>\n<div class=\"pagina-orderstatus\" layout=\"row\"><md-input-container flex class=\"md-block\"><label>Search Order Number\n</label><input ng-model=\"vm.search\" ng-change=\"vm.searchTable(vm.search)\" type=\"text\" \nng-model-options=\"{ debounce: 250 }\"></md-input-container><md-button class=\"md-primary md-raised\" \nng-click=\"vm.reset()\">Reset</md-button></div><div class=\"pagina-orderstatus\" layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-green-500-bg branco\" ng-if=\"vm.itemabrir && vm.itemabrir.length==1\" \nng-click=\"vm.gravar(vm.itemabrir)\">Open Order</md-button><md-button class=\"md-green-500-bg branco\" \nng-if=\"vm.itemabrir && vm.itemabrir.length>1\" ng-click=\"vm.gravar(vm.itemabrir)\">Open {{vm.itemabrir.length}} Orders\n</md-button></div><div class=\"pagina-orderstatus full-width\" layout=\"row\" layout-align=\"space-between center\"><table \ndatatable=\"\" class=\"row-border hover full-width\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"></table></div><div class=\"pagina-orderstatus\" layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-green-500-bg branco\" ng-if=\"vm.itemabrir && vm.itemabrir.length==1\" \nng-click=\"vm.gravar(vm.itemabrir)\">Open Order</md-button><md-button class=\"md-green-500-bg branco\" \nng-if=\"vm.itemabrir && vm.itemabrir.length>1\" ng-click=\"vm.gravar(vm.itemabrir)\">Open {{vm.itemabrir.length}} Orders\n</md-button></div></div>");
$templateCache.put("app/main/pages/production/production.html","<div id=\"pagina-go\" flex layout=\"column\"><div class=\"cabecalho cor-production\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Production</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"><div class=\"estatisticas\" layout=\"row\" layout-align=\"end center\"><ul><li>\n<md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.onstoporders}}</md-button><div \nclass=\"stat-info font-size-8\">On Stop</div></li><li><md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">\n{{vm.dueorders}}</md-button><div class=\"stat-info font-size-8\">Due Orders</div></li><li><md-button \nclass=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.approvedvia}}</md-button><div \nclass=\"stat-info font-size-8\">Portal Approved</div></li><li><md-button class=\"orders-buttons\" \nng-click=\"vm.gotoOrderStatus()\">{{vm.approvedwaiting}}</md-button><div class=\"stat-info font-size-8\">Approved & Waiting\n</div></li><li><md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.waitingcall}}</md-button><div \nclass=\"stat-info font-size-8\">Waiting for Call</div></li><li><md-button class=\"orders-buttons\" \nng-click=\"vm.gotoOrderStatus()\">{{vm.waitingimpression}}</md-button><div class=\"stat-info font-size-8\">\nWaiting for Impression</div></li><li><md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">\n{{vm.inactiveorders}}</md-button><div class=\"stat-info font-size-8\">Inactive</div></li><li><md-button \nclass=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.numcompleted}}</md-button><div \nclass=\"stat-info font-size-8\">Completed</div></li></ul></div></div></div><div class=\"topo\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Production</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">{{vm.actions[vm.active_module].name}}</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"><div class=\"pesquisa\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.openPopupOther($event, \'search\')\">Search</md-button></div></div></div><div \nlayout=\"row\"><div ng-if=\"vm.statusid>0 && vm.estadosecundario===0\" flex class=\"estado estado-{{vm.statusid}}\" \nlayout=\"row\" layout-align=\"space-between center\"><div flex layout=\"row\" layout-align=\"center center\"><span \nclass=\"font-size-18 font-weight-400 status-text\">{{vm.statusname}}</span></div><span ng-if=\"vm.statusid!=6\" \nclass=\"pointer\" ng-click=\"vm.disabled==false ? vm.openPopupOther($event, \'changeOrderStatus\') : \'\'\" \nstyle=\"font-size:smaller\">Change<md-tooltip md-direction=\"top\">Click to change order status</md-tooltip></span></div>\n<div ng-if=\"vm.statusid>0 && vm.estadosecundario===1\" flex=\"50\" class=\"estado estado-{{vm.statusid}}\" layout=\"column\" \nlayout-align=\"space-between center\"><div flex layout=\"row\" layout-align=\"center center\"><span \nclass=\"font-size-18 font-weight-400 status-text\">{{vm.statusname}}</span></div></div><div \nng-if=\"vm.statusid>0 && vm.estadosecundario===1\" flex=\"50\" class=\"estado estado-{{vm.estados[0].status_id}}\" \nlayout=\"column\" layout-align=\"space-between center\"><div flex layout=\"row\" layout-align=\"center center\"><span \nclass=\"font-size-18 font-weight-400 status-text\">{{vm.estados[0].status}}</span></div></div></div><div \nclass=\"estado-funcoes\" layout=\"row\" layout-align=\"space-between center\"><div class=\"estado-funcoes-esq\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-primary md-raised\" \nng-if=\"vm.module == \'GenerateOrder\' || vm.module == \'generateorder\'\" ng-click=\"vm.createOrder($event)\">New Order\n</md-button><md-button class=\"md-primary md-raised\" ng-click=\"vm.openPopupOther($event, \'scanorder\')\">Scan Order\n</md-button><md-button ng-if=\"vm.id!=\'\'\" class=\"md-primary md-raised\" \nng-click=\"vm.disabled==false ? vm.printBarCode() : \'\'\">Generate Barcode</md-button></div><div ng-if=\"vm.id!=\'\'\" \nclass=\"estado-funcoes-dir\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-primary md-raised\" \nng-click=\"vm.disabled==false ? vm.openPopupOther($event, \'cancelOrder\') : \'\'\">Cancel Order</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.disabled==false ? vm.openPopupOther($event, \'approveOrder\') : \'\'\">Approve\n</md-button><md-button class=\"md-primary md-raised\" \nng-click=\"vm.disabled==false ? vm.openPopupOther($event, \'waitingImpressions\') : \'\'\">Waiting For Impressions\n</md-button><md-button class=\"md-primary md-raised\" \nng-click=\"vm.disabled==false ? vm.openPopupOther($event, \'waitingCall\') : \'\'\">WFC</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.disabled==false ? vm.openPopupOther($event, \'completeOrder\') : \'\'\">Completed\n</md-button></div></div><div class=\"orders-row\"><div layout=\"row\" layout-align=\"start center\" class=\"orders-tab\"><div \nlayout=\"row\" layout-align=\"start center\" \nng-repeat=\"opened in vm.orders_opened | filter:{departments_id: vm.departmentsid}:true\" \nng-class=\"opened.orders_id == vm.id ? \'order-tab-active\' : \'pointer\'\" class=\"order-tab\"><div layout=\"row\" \nlayout-align=\"start center\" \nng-click=\"opened.orders_id != vm.id ? vm.goToPage(\'production\', opened.orders_id, false, opened.orders_opened_id, true) : \'\'\">\n{{opened.ordernumber}}</div><div ng-if=\"opened.orders_id == vm.id\" layout=\"row\" layout-align=\"end center\" \nclass=\"relative\"><md-icon ng-click=\"vm.goToPage(\'production\', opened.orders_id, true, opened.orders_opened_id, true)\" \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font icon-window-close pointer botao-fechar\" aria-hidden=\"true\">\n<md-tooltip md-direction=\"top\">Click to close this order</md-tooltip></md-icon></div><div \nng-if=\"opened.orders_id != vm.id\" layout=\"row\" layout-align=\"end center\" class=\"relative\"><md-icon \nng-click=\"vm.goToPage(\'production\', opened.orders_id, true, opened.orders_opened_id, false)\" \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font icon-window-close pointer botao-fechar\" aria-hidden=\"true\">\n<md-tooltip md-direction=\"top\">Click to close this order</md-tooltip></md-icon></div></div></div><div flex \nlayout=\"row\"><div flex class=\"orders-page\" ng-if=\"vm.id!=\'\'\"><div class=\"order-info\" flex layout=\"row\" \nlayout-align=\"left center\"><md-input-container flex class=\"md-block\" ng-repeat=\"order in vm.order\"><label>Order No\n</label><input type=\"text\" value=\"{{order.ordernumber}}\" disabled=\"disabled\"></md-input-container><md-input-container \nflex class=\"md-block\" ng-repeat=\"order in vm.order\"><label>Approved via</label><md-select ng-model=\"order.approvedvia\" \nng-change=\"vm.saveOnChange(order.approvedvia, \'approvedvia\')\" ng-disabled=\"vm.disabled\"><md-option value=\"Portal\">\nPortal</md-option><md-option value=\"E-mail\">E-mail</md-option><md-option value=\"Phone\">Phone</md-option><md-option \nvalue=\"Other\">Other</md-option></md-select><div class=\"order-info-date\">&nbsp;<span ng-if=\"order.status_id==2\">\n{{order.date}}</span></div></md-input-container><md-input-container flex class=\"md-block\"><label>Current Location\n</label><input type=\"text\" value=\"{{vm.actions[vm.active_module].name}}\" disabled=\"disabled\"></md-input-container>\n<md-input-container flex class=\"md-block\" ng-repeat=\"order in vm.order\"><label>Date Received</label><input type=\"text\" \nvalue=\"{{order.datereceived| cmdate:\'dd MMMM yyyy\'}}\" disabled=\"disabled\"></md-input-container><md-input-container \nflex class=\"md-block\" ng-repeat=\"order in vm.order\"><label>Due Date</label><input type=\"text\" \nng-if=\"order.deliverydate == NULL\" value=\"\" disabled=\"disabled\"><input type=\"text\" ng-if=\"order.deliverydate != NULL\" \nvalue=\"{{order.deliverydate| cmdate:\'dd MMMM yyyy\'}}\" disabled=\"disabled\"></md-input-container></div><md-divider>\n</md-divider><div class=\"order-messages\"><div class=\"order-messages-sub\" layout=\"row\"><md-button \nclass=\"order-add md-fab md-mini\" aria-label=\"Add\" \nng-click=\"vm.disabled==false ? vm.openPopupOther($event, \'newOrderAlert\') : \'\'\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"><md-tooltip md-direction=\"top\">\nClick to create a custom alert</md-tooltip></md-icon></md-button><md-whiteframe ng-repeat=\"stat in vm.estados\" \nclass=\"order-message-box md-whiteframe-4dp order-{{stat.iscustom}}{{stat.status_id}}\" layout \nlayout-align=\"center center\"><div layout=\"column\"><div class=\"order-subject\" ng-if=\"stat.iscustom!=1\">{{stat.status}}\n</div><div class=\"order-subject\" ng-if=\"stat.iscustom==1\">{{stat.subject}}</div><div class=\"order-message-parent\"><div \nclass=\"order-message\">{{stat.description}}</div></div><div class=\"order-date\">{{stat.name}}, {{stat.date}}</div></div>\n</md-whiteframe></div></div><md-divider></md-divider><div layout=\"row\"><div flex class=\"order-case mediummargin\" \nlayout=\"column\" ng-cloak layout-align=\"center center\"><md-button class=\"md-button md-raised full-width cor-casetype\" \nng-click=\"vm.openPopupOther($event, \'showCaseType\')\">Case Type: <span \nng-show=\"(vm.casetypes[0].upper == 1 || vm.casetypes[0].lower == 1 || vm.casetypes[1].upper == 1 || vm.casetypes[1].lower == 1 || vm.casetypes[2].upper == 1 || vm.casetypes[2].lower == 1 || vm.casetypes[3].upper == 1 || vm.casetypes[3].lower == 1 || vm.casetypes[4].upper == 1 || vm.casetypes[4].lower == 1 || vm.casetypes[5].upper == 1 || vm.casetypes[5].lower == 1)\">\n3D |</span> <span \nng-show=\"(vm.casetypes[6].upper == 1 || vm.casetypes[6].lower == 1 || vm.casetypes[7].upper == 1 || vm.casetypes[7].lower == 1 || vm.casetypes[8].upper == 1 || vm.casetypes[8].lower == 1 || vm.casetypes[9].upper == 1 || vm.casetypes[9].lower == 1)\">\nCase Assessment |</span> <span \nng-show=\"(vm.casetypes[10].upper == 1 || vm.casetypes[10].lower == 1 || vm.casetypes[11].upper == 1 || vm.casetypes[11].lower == 1 || vm.casetypes[12].upper == 1 || vm.casetypes[12].lower == 1 || vm.casetypes[13].upper == 1 || vm.casetypes[13].lower == 1 || vm.casetypes[14].upper == 1 || vm.casetypes[14].lower == 1)\">\nClear |</span> <span \nng-show=\"(vm.casetypes[15].upper == 1 || vm.casetypes[15].lower == 1 || vm.casetypes[16].upper == 1 || vm.casetypes[16].lower == 1 || vm.casetypes[17].upper == 1 || vm.casetypes[17].lower == 1 || vm.casetypes[18].upper == 1 || vm.casetypes[18].lower == 1 || vm.casetypes[19].upper == 1 || vm.casetypes[19].lower == 1 || vm.casetypes[20].upper == 1 || vm.casetypes[20].lower == 1)\">\nInam |</span> <span ng-show=\"(vm.casetypes[21].upper == 1 || vm.casetypes[21].lower == 1)\">Implants |</span> <span \nng-show=\"(vm.casetypes[22].upper == 1 || vm.casetypes[22].lower == 1 || vm.casetypes[23].upper == 1 || vm.casetypes[23].lower == 1 || vm.casetypes[24].upper == 1 || vm.casetypes[24].lower == 1 || vm.casetypes[25].upper == 1 || vm.casetypes[25].lower == 1)\">\nTreatment Plan |</span></md-button></div></div><div layout=\"row\" \nng-init=\"filter_len = (vm.ordersdepartments | filter: { department_alias : vm.active_module }).length\"><div flex \nclass=\"order-case align-left full-width\" \nng-if=\"filter_len == \'0\' && department_alias!=\'generateorder\' && vm.active_module!=\'generateorder\'\" \nng-click=\"openPopupDep($event, vm.active_module)\" layout=\"row\" ng-cloak layout-align=\"center center\"><md-button \nclass=\"md-button md-raised full-width\">{{vm.actions[vm.active_module].name}}</md-button></div></div><div layout=\"row\" \nng-repeat=\"department in vm.ordersdepartments\"><div flex class=\"order-case align-left full-width\" \nng-if=\"department.department_alias!=\'generateorder\'\" ng-click=\"openPopupDep($event, department.department_alias)\" \nlayout=\"row\" ng-cloak layout-align=\"center center\"><md-button class=\"md-button md-raised full-width\">\n{{department.department_name}}</md-button></div></div><div layout=\"row\"><div flex class=\"order-info-more smallmargin\" \nlayout=\"column\" ng-cloak layout-align=\"center center\"><md-button class=\"md-button md-raised full-width\" \nng-click=\"openPopupDep($event, \'orderinfo\')\">Order Info</md-button></div><div flex class=\"order-content smallmargin\" \nlayout=\"column\" ng-cloak layout-align=\"center center\"><md-button class=\"md-button md-raised full-width\" \nng-click=\"openPopupDep($event, \'ordercontent\')\">Order Content</md-button></div></div></div><div flex=\"25\" \nng-if=\"vm.id!=\'\'\"><div class=\"verifyorder md-raised md-button\" aria-label=\"Products\" layout=\"row\" \nlayout-align=\"start center\"><md-tooltip ng-if=\"vm.verified==\'0\'\" md-direction=\"top\">Click to verify this order\n</md-tooltip><md-tooltip ng-if=\"vm.verified==\'1\'\" md-direction=\"top\">Click to unverify this order</md-tooltip>\n<md-switch class=\"full-width\" ng-model=\"vm.verified\" aria-label=\"Verify Order\" \nng-change=\"vm.disabled==false ? vm.saveOnChange(vm.verified, \'verified\') : \'\'\"><span ng-if=\"vm.verified==\'0\'\">\nVerify Order</span> <span ng-if=\"vm.verified==\'1\'\">Order Verified</span></md-switch></div><div class=\"card-title\">\nProducts</div><ms-card template=\"\'app/main/pages/production/templates/products.html\'\" view-model=\"vm\"></ms-card><div \nclass=\"card-title\">Lab Doc</div><ms-card template=\"\'app/main/pages/production/templates/labdoc.html\'\" view-model=\"vm\">\n</ms-card><div class=\"card-title\">Linked Orders</div><ms-card \ntemplate=\"\'app/main/pages/production/templates/linkedorders.html\'\" view-model=\"vm\"></ms-card><div layout=\"row\"><div \nflex=\"80\" class=\"card-title\" layout=\"row\" layout-align=\"start center\">DLD Actions (Last 20)</div><div flex=\"20\" \nlayout=\"row\" layout-align=\"center center\"><a href=\"#\" print-div=\"#dldactionsprint\"><md-icon \nmd-font-icon=\"icon-printer\" class=\"s24 md-font icon-printer pointer\" aria-hidden=\"true\"></md-icon><md-tooltip \nmd-direction=\"top\">Click to print last 20 DLD Actions</md-tooltip></a></div></div><ms-card \ntemplate=\"\'app/main/pages/production/templates/dldactions.html\'\" view-model=\"vm\"></ms-card><div class=\"card-title\">\nOrder Comments</div><ms-card template=\"\'app/main/pages/production/templates/ordercomments.html\'\" view-model=\"vm\">\n</ms-card></div></div></div></div><div id=\"dldactionsprint\" layout=\"column\" layout-align=\"start center\" \nstyle=\"display:none;padding:30px\"><h2 style=\"text-align:center\">Last 20 DLD Actions<br>\nFor Order {{vm.order[0].ordernumber}}<br>In {{vm.actions[vm.active_module].name}}</h2><div class=\"full-width\" \nng-repeat=\"action in vm.dldactions\" style=\"margin-bottom:20px;text-align:center\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"department\"><strong>Department: </strong>{{action.department_name}}</div></div>\n<div layout=\"row\" layout-align=\"start center\"><div class=\"user\"><strong>User: </strong>{{action.name}}</div></div><div \nflex layout=\"row\" layout-align=\"start center\"><div class=\"date\"><strong>Date/Time: </strong>{{action.date}}</div></div>\n<md-divider class=\"margem-divisoria\"></md-divider></div></div>");
$templateCache.put("app/main/pages/products/products.html","<div id=\"pagina-productgroup\" flex layout=\"column\"><div class=\"cabecalho cor-accounts\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Products</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"></div></div><div class=\"topo\" layout=\"row\" layout-align=\"space-between center\">\n<div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" layout=\"row\" \nlayout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Products</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Products</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\">\n</div></div><div layout=\"row\" layout-align=\"center center\"><div class=\"cor-delivery md-padding\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-primary md-raised\" ng-disabled=\"true\">Products</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.gotoProductGroups()\">Product Groups</md-button></div><div \nclass=\"branco-bg md-padding\" flex=\"25\" layout=\"row\" layout-align=\"center center\"><md-button \nng-if=\"vm.caixaedicao!=1 && vm.caixaedicaomulti!=1\" class=\"md-primary md-raised\" ng-disabled=\"true\">New Product\n</md-button><md-button ng-if=\"vm.caixaedicao==1 && vm.caixaedicaomulti!=1\" class=\"md-primary md-raised\" \nng-disabled=\"true\">Edit Product</md-button><md-button ng-if=\"vm.caixaedicaomulti==1 && vm.caixaedicao!=1\" \nclass=\"md-primary md-raised\" ng-disabled=\"true\">Edit Multiple Products</md-button></div></div><div><div layout=\"row\">\n<div flex class=\"md-padding branco-bg\"><table datatable=\"ng\" class=\"row-border hover\"><thead><tr><th>Code</th><th>\nDescription</th><th>Product Group</th><th>Rate</th><th>VAT</th><th>Creation Date</th><th>Edit</th></tr></thead><tbody>\n<tr ng-repeat=\"product in vm.products track by $index\" ng-click=\"selectRow($event, $index)\" \nng-class=\"{highlitedRow: isRowSelected($index)}\"><td>{{product.product_code}}</td><td>{{product.product_description}}\n</td><td>{{product.group_name}}</td><td>{{product.rate}}</td><td>{{product.VAT}}%</td><td>{{product.date}}</td><td>\n<md-button ng-click=\"vm.editProduct(product.products_id)\" class=\"icon-pencil font-size-20 yellow-800-fg\" \naria-label=\"Edit\"></md-button></td></tr></tbody></table></div><div flex=\"25\"><div layout=\"row\" ng-cloak \nlayout-align=\"center center\"></div><ms-card ng-if=\"vm.caixaedicao!=1 && vm.caixaedicaomulti!=1\" flex \ntemplate=\"\'app/templates/cards/product/newproduct.html\'\" view-model=\"vm\"></ms-card><ms-card ng-if=\"vm.caixaedicao==1\" \nflex template=\"\'app/templates/cards/product/editproduct.html\'\" view-model=\"vm\"></ms-card><ms-card \nng-if=\"vm.caixaedicaomulti==1 && vm.caixaedicao!=1\" flex \ntemplate=\"\'app/templates/cards/product/productselectionedit.html\'\" view-model=\"vm\"></ms-card></div></div></div></div>");
$templateCache.put("app/main/pages/productsgroups/productsgroups.html","<div id=\"pagina-productgroup\" flex layout=\"column\"><div class=\"cabecalho cor-accounts\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Products</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"></div></div><div class=\"topo\" layout=\"row\" layout-align=\"space-between center\">\n<div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" layout=\"row\" \nlayout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Products</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Product Groups</span></div></div><div flex=\"50\" layout=\"row\" \nlayout-align=\"end center\"></div></div><div layout=\"row\" layout-align=\"center center\"><div \nclass=\"cor-delivery md-padding\" flex layout=\"row\" layout-align=\"center center\"><md-button class=\"md-primary md-raised\" \nng-click=\"vm.gotoProducts()\">Products</md-button><md-button class=\"md-primary md-raised\" ng-disabled=\"true\">\nProduct Groups</md-button></div><div class=\"branco-bg md-padding\" flex=\"25\" layout=\"row\" layout-align=\"center center\">\n<md-button ng-if=\"vm.caixaedicao!=1\" class=\"md-primary md-raised\" ng-disabled=\"true\">New Product Group</md-button>\n<md-button ng-if=\"vm.caixaedicao==1\" class=\"md-primary md-raised\" ng-disabled=\"true\">Edit Product Group</md-button>\n</div></div><div><div layout=\"row\"><div flex class=\"md-padding branco-bg\"><table datatable=\"ng\" \nclass=\"simple row-border hover\"><thead><tr><th>Product Group</th><th>Product Group Description</th><th>Edit</th><th>\nDelete</th></tr></thead><tbody><tr ng-repeat=\"group in vm.groups\"><td>{{group.group_name}}</td><td>\n{{group.group_description}}</td><td><md-button \nng-click=\"vm.disabled==false ? vm.editGroup(group.products_groups_id) : \'\'\" \nclass=\"icon-pencil font-size-20 yellow-800-fg\" aria-label=\"Edit\"></md-button></td><td><md-button \nng-click=\"vm.disabled==false ? vm.deleteExistGroup($event, group.products_groups_id) : \'\'\" \nclass=\"icon-delete font-size-20 red-800-fg\" aria-label=\"Delete\"></md-button></td></tr></tbody></table></div><div \nflex=\"25\"><div layout=\"row\" ng-cloak layout-align=\"center center\"></div><ms-card ng-if=\"vm.caixaedicao!=1\" flex \ntemplate=\"\'app/templates/cards/product/newproductgroup.html\'\" view-model=\"vm\"></ms-card><ms-card \nng-if=\"vm.caixaedicao==1\" flex template=\"\'app/templates/cards/product/editproductgroup.html\'\" view-model=\"vm\">\n</ms-card></div></div></div></div>");
$templateCache.put("app/main/pages/profile/profile.html","<div id=\"pagina-profile\" flex layout=\"column\"><div class=\"cabecalho cor-production\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Invoicing</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"><div class=\"estatisticas\" layout=\"row\" layout-align=\"end center\"><ul><li>\n<md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\" aria-label=\"On Stop Orders\">{{vm.onstoporders}}\n</md-button><div class=\"stat-info font-size-8\">On Stop</div></li><li><md-button class=\"orders-buttons\" \nng-click=\"vm.gotoOrderStatus()\" aria-label=\"Due Orders\">{{vm.dueorders}}</md-button><div class=\"stat-info font-size-8\">\nDue Orders</div></li><li><md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\" \naria-label=\"Approved Via Orders\">{{vm.approvedvia}}</md-button><div class=\"stat-info font-size-8\">Portal Approved</div>\n</li><li><md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\" aria-label=\"Approved and Waiting Orders\">\n{{vm.approvedwaiting}}</md-button><div class=\"stat-info font-size-8\">Approved & Waiting</div></li><li><md-button \nclass=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\" aria-label=\"Waiting Call Orders\">{{vm.waitingcall}}</md-button>\n<div class=\"stat-info font-size-8\">Waiting for Call</div></li><li><md-button class=\"orders-buttons\" \nng-click=\"vm.gotoOrderStatus()\" aria-label=\"Waiting Impression Orders\">{{vm.waitingimpression}}</md-button><div \nclass=\"stat-info font-size-8\">Waiting for Impression</div></li><li><md-button class=\"orders-buttons\" \nng-click=\"vm.gotoOrderStatus()\" aria-label=\"Inactive Orders\">{{vm.inactiveorders}}</md-button><div \nclass=\"stat-info font-size-8\">Inactive</div></li><li><md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\" \naria-label=\"Completed Orders\">{{vm.numcompleted}}</md-button><div class=\"stat-info font-size-8\">Completed</div></li>\n</ul></div></div></div><div class=\"topo\" layout=\"row\" layout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"breadcrumbs\" layout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" \nui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span class=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" \naria-hidden=\"true\"></md-icon><span class=\"font-size-16 font-weight-300\">Invoicing</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" \naria-hidden=\"true\"></md-icon><span class=\"font-size-16 font-weight-300\">Client Profiles</span></div></div><div \nflex=\"50\" layout=\"row\" layout-align=\"end center\"><div class=\"pesquisa\" layout=\"row\" layout-align=\"end center\">\n<md-button class=\"md-primary md-raised\" ng-click=\"vm.gotoProfiles()\">Search</md-button></div></div></div><input \ntype=\"hidden\" ng-if=\"vm.id==\'0\'\" ng-model=\"vm.client.clients_id\" ng-init=\"vm.client.clients_id=\'0\'\"> <input \ntype=\"hidden\" ng-if=\"vm.id!=\'0\'\" ng-model=\"vm.client.clients_id\" ng-init=\"vm.client.clients_id=vm.client.clients_id\">\n<div class=\"estado-funcoes\" layout=\"row\" layout-align=\"space-between center\"><div class=\"estado-funcoes-esq\" \nlayout=\"row\" layout-align=\"start center\"><md-button ng-if=\"vm.id!=0\" class=\"md-primary md-raised\" \nng-click=\"vm.disabled == false ? vm.gotoProfile() : \'\'\">New Client Profile</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.openPopup($event, \'emailclient\')\">Send E-mail</md-button><md-button \nng-if=\"vm.id!=0\" class=\"md-primary md-raised\" \nng-click=\"vm.disabled == false ? vm.genericRemoveConfirm($event, \'clients\', \'client\', vm.id) : \'\'\">Delete Client\n</md-button><md-button class=\"md-primary md-raised\" type=\"submit\" \nng-click=\"vm.disabled == false ? vm.saveClient(vm.client) : \'\'\">Save Client</md-button></div><div ng-if=\"vm.id!=\'\'\" \nclass=\"estado-funcoes-dir\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised preto-bkg\" \nng-click=\"vm.disabled == false ? vm.openPopup($event, \'offstop\') : \'\'\">Off Stop</md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.disabled == false ? vm.openPopup($event, \'onstop\') : \'\'\">ON STOP</md-button>\n</div></div><div class=\"orders-row\"><div flex layout=\"row\"><div flex class=\"orders-page\"><form class=\"saveClient\" \nng-submit=\"submitForm(saveClient.$valid)\" novalidate><div class=\"order-info\" flex layout=\"row\"><md-input-container \nflex=\"20\"><label>Client Type</label><md-select name=\"clients_type_id\" ng-model=\"vm.client.clients_type_id\" required \nng-disabled=\"vm.disabled\"><md-option value=\"1\">Company</md-option><md-option value=\"2\">Practice</md-option><md-option \nvalue=\"3\">Dentist</md-option></md-select><div ng-messages=\"recordForm.clients_type_id.$error\"><div \nng-message=\"required\">Please choose a client type.</div></div></md-input-container><md-input-container flex=\"20\" \nclass=\"md-block\"><label>Client No</label><input type=\"text\" name=\"clientnumber\" ng-model=\"vm.client.clientnumber\" \nrequired ng-disabled=\"vm.disabled\"><div ng-messages=\"recordForm.clientnumber.$error\"><div ng-message=\"required\">\nPlease insert a client number.</div></div></md-input-container></div><md-divider></md-divider><div \nclass=\"order-messages fontsize12rem\"><div class=\"order-messages-sub\" layout=\"row\"><md-button \nclass=\"order-add md-fab md-mini\" aria-label=\"Add\" \nng-click=\"vm.disabled == false ? vm.openPopup($event, \'newalert\') : \'\'\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"><md-tooltip md-direction=\"top\">\nClick to create an alert</md-tooltip></md-icon></md-button><md-whiteframe \nng-repeat=\"stat in vm.clientsstatus | filter:{ isalert: \'1\'}\" class=\"order-message-box md-whiteframe-4dp\" \nng-class=\"stat.status_id==8 ? \'estado-8\' : \'estado-7\'\" layout layout-align=\"center center\"><div layout=\"column\"><div \nclass=\"order-subject order-stop\" ng-if=\"stat.status_id==7 || stat.status_id==8\">{{stat.status}}</div><div \nclass=\"order-subject order-stop\" ng-if=\"stat.status_id==null\">{{stat.subject}}</div><div class=\"order-date\">\n{{stat.name}}, {{stat.date}}</div></div></md-whiteframe></div></div><div class=\"client-info\"><div flex layout=\"row\">\n<md-input-container flex=\"50\" class=\"md-block\"><label>Name</label><input type=\"text\" ng-model=\"vm.client.clientname\" \nng-disabled=\"vm.disabled\"></md-input-container><md-input-container flex=\"30\" class=\"md-block\"><label>Practice No\n</label><input type=\"text\" ng-model=\"vm.client.practicenumber\" ng-disabled=\"vm.disabled\"></md-input-container>\n<md-checkbox class=\"font-size-15\" flex ng-model=\"vm.client.invoice_email\" ng-true-value=\"1\" ng-false-value=\"0\" \naria-label=\"Invoice E-mail\" ng-disabled=\"vm.disabled\">Invoice E-mail</md-checkbox><md-checkbox class=\"font-size-15\" \nflex ng-model=\"vm.client.invoice_print\" ng-true-value=\"1\" ng-false-value=\"0\" aria-label=\"Invoice Print\" \nng-disabled=\"vm.disabled\">Invoice Print</md-checkbox></div><div flex layout=\"row\"><md-input-container flex=\"50\" \nclass=\"md-block\"><label>Address (Line 1)</label><input type=\"text\" ng-model=\"vm.client.caddress1\" \nng-disabled=\"vm.disabled\"></md-input-container><md-input-container flex=\"30\" class=\"md-block\"><label>VAT No</label>\n<input type=\"text\" ng-model=\"vm.client.vatnumber\" ng-disabled=\"vm.disabled\"></md-input-container></div><div flex \nlayout=\"row\"><md-input-container flex=\"50\" class=\"md-block\"><label>Address (Line 2)</label><input type=\"text\" \nng-model=\"vm.client.caddress2\" ng-disabled=\"vm.disabled\"></md-input-container><md-button flex \nclass=\"md-button md-raised full-width button-max-height\" ng-click=\"vm.openPopup($event, \'emails\')\">\nManage E-mail Contacts</md-button></div><div flex layout=\"row\"><md-input-container flex=\"25\" class=\"md-block\"><label>\nTown/City</label><input type=\"text\" ng-model=\"vm.client.ccity\" ng-disabled=\"vm.disabled\"></md-input-container>\n<md-input-container flex=\"25\" class=\"md-block\"><label>County</label><input type=\"text\" ng-model=\"vm.client.ccounty\" \nng-disabled=\"vm.disabled\"></md-input-container><md-button flex \nclass=\"md-button md-raised full-width button-max-height\" ng-click=\"vm.openPopup($event, \'tels\')\">Manage Tel Contacts\n</md-button></div><div flex layout=\"row\"><md-input-container flex=\"25\" class=\"md-block\"><label>Postcode</label><input \ntype=\"text\" ng-model=\"vm.client.cpostcode\" ng-disabled=\"vm.disabled\"></md-input-container><md-input-container \nflex=\"25\" class=\"md-block\"><label>Country</label><input type=\"text\" ng-model=\"vm.client.ccountry\" \nng-disabled=\"vm.disabled\"></md-input-container></div><div flex layout=\"row\"><span class=\"nimrodental-text\">\nNimroDental Portal</span><md-radio-group ng-model=\"vm.client.isportal\" ng-disabled=\"vm.disabled\"><md-radio-button \nvalue=\"0\" aria-label=\"Non User\">Non User</md-radio-button><md-radio-button value=\"1\" aria-label=\"User\">User\n</md-radio-button></md-radio-group><md-input-container flex class=\"md-block\"><label>Portal E-mail</label><input \ntype=\"text\" ng-model=\"vm.client.portalemail\" ng-disabled=\"vm.disabled\"></md-input-container></div></div></form><div \nng-if=\"vm.deliverylength>0\"><h2 ng-show=\"!showDetails\">Delivery Address | <a ng-click=\"showDetails = ! showDetails\" \nclass=\"pointer\">Show Info</a></h2><h2 ng-show=\"showDetails\">Delivery Address | <a \nng-click=\"showDetails = ! showDetails\" class=\"pointer\">Hide Info</a></h2><div ng-show=\"showDetails\"><div flex \nlayout=\"row\"><md-input-container flex class=\"md-block\"><label>Address (Line 1)</label><input type=\"text\" \nng-model=\"vm.delivery.daddress1\" disabled=\"disabled\"></md-input-container></div><div flex layout=\"row\">\n<md-input-container flex class=\"md-block\"><label>Address (Line 2)</label><input type=\"text\" \nng-model=\"vm.delivery.daddress2\" disabled=\"disabled\"></md-input-container></div><div flex layout=\"row\">\n<md-input-container flex=\"50\" class=\"md-block\"><label>Town/City</label><input type=\"text\" ng-model=\"vm.delivery.dcity\" \ndisabled=\"disabled\"></md-input-container><md-input-container flex=\"50\" class=\"md-block\"><label>County</label><input \ntype=\"text\" ng-model=\"vm.delivery.dcounty\" disabled=\"disabled\"></md-input-container></div><div flex layout=\"row\">\n<md-input-container flex=\"50\" class=\"md-block\"><label>Postcode</label><input type=\"text\" \nng-model=\"vm.delivery.dpostcode\" disabled=\"disabled\"></md-input-container><md-input-container flex=\"50\" \nclass=\"md-block\"><label>Country</label><input type=\"text\" ng-model=\"vm.delivery.dcountry\" disabled=\"disabled\">\n</md-input-container></div></div></div><div layout=\"row\"><div flex class=\"full-width\" layout=\"row\" ng-cloak \nlayout-align=\"center center\"><md-button ng-if=\"vm.deliverylength==0\" class=\"md-button md-raised full-width\" \nng-click=\"vm.disabled == false ? vm.openPopup($event, \'deliveryaddress\') : \'\'\">Add Delivery Address</md-button>\n<md-button ng-if=\"vm.deliverylength>0\" flex=\"50\" class=\"md-button md-raised full-width\" \nng-click=\"vm.disabled == false ? vm.openPopup($event, \'deliveryaddress\') : \'\'\">Change Delivery Address</md-button>\n<md-button ng-if=\"vm.deliverylength>0\" flex=\"50\" class=\"md-raised md-warn full-width\" \nng-click=\"vm.disabled == false ? vm.genericRemoveConfirm($event, \'clientsdeliveryaddress\', \'delivery\', vm.delivery.clients_deliveryaddress_id) : \'\'\">\nDelete Delivery Address</md-button></div></div><div ng-if=\"vm.practicelength>0\"><div \nng-repeat=\"practice in vm.practice\"><h2 ng-show=\"!showDetails\">Practice {{practice.clientname}} | <a \nng-click=\"showDetails = ! showDetails\" class=\"pointer\">Show Info</a></h2><h2 ng-show=\"showDetails\">\nPractice {{practice.clientname}} | <a ng-click=\"showDetails = ! showDetails\" class=\"pointer\">Hide Info</a></h2><div \nng-show=\"showDetails\"><div flex layout=\"row\"><md-input-container flex=\"50\" class=\"md-block\"><label>Practice Name\n</label><input type=\"text\" ng-model=\"practice.clientname\" disabled=\"disabled\"></md-input-container><md-input-container \nflex=\"30\" class=\"md-block\"><label>Practice No</label><input type=\"text\" ng-model=\"practice.practicenumber\" \ndisabled=\"disabled\"></md-input-container><md-checkbox class=\"font-size-15\" flex ng-model=\"practice.invoice_email\" \nng-true-value=\"1\" ng-false-value=\"0\" aria-label=\"Invoice E-mail\" disabled=\"disabled\">Invoice E-mail</md-checkbox>\n<md-checkbox class=\"font-size-15\" flex ng-model=\"practice.invoice_print\" ng-true-value=\"1\" ng-false-value=\"0\" \naria-label=\"Invoice Print\" disabled=\"disabled\">Invoice Print</md-checkbox></div><div flex layout=\"row\">\n<md-input-container flex=\"50\" class=\"md-block\"><label>Address (Line 1)</label><input type=\"text\" \nng-model=\"practice.caddress1\" disabled=\"disabled\"></md-input-container><md-input-container flex=\"50\" class=\"md-block\">\n<label>Address (Line 2)</label><input type=\"text\" ng-model=\"practice.caddress2\" disabled=\"disabled\">\n</md-input-container></div><div flex layout=\"row\"><md-input-container flex=\"50\" class=\"md-block\"><label>Town/City\n</label><input type=\"text\" ng-model=\"practice.ccity\" disabled=\"disabled\"></md-input-container><md-input-container \nflex=\"50\" class=\"md-block\"><label>County</label><input type=\"text\" ng-model=\"practice.ccounty\" disabled=\"disabled\">\n</md-input-container></div><div flex layout=\"row\"><md-input-container flex=\"50\" class=\"md-block\"><label>Postcode\n</label><input type=\"text\" ng-model=\"practice.cpostcode\" disabled=\"disabled\"></md-input-container><md-input-container \nflex=\"50\" class=\"md-block\"><label>Country</label><input type=\"text\" ng-model=\"practice.ccountry\" disabled=\"disabled\">\n</md-input-container></div><div flex layout=\"row\"><md-input-container flex=\"30\" class=\"md-block\"><label>\nE-mail (Primary)</label><input type=\"text\" ng-model=\"practice.cemail[0].clients_email\" \nng-pattern=\"/^[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\\.[a-zA-Z]{2,4}$/\" disabled=\"disabled\"></md-input-container>\n<md-input-container flex=\"20\"><label>Select Email Type</label><md-select name=\"clients_email_id\" \nng-model=\"practice.cemail[0].email_type_ids\" multiple=\"true\" disabled=\"disabled\"><md-option \nng-repeat=\"(index,clientemail) in vm.allemailtypes\" ng-value=\"clientemail.email_type_id\">{{clientemail.email_type}}\n</md-option></md-select></md-input-container><md-input-container flex=\"30\" class=\"md-block\"><label>E-mail (Secondary)\n</label><input type=\"text\" ng-model=\"practice.cemail[1].clients_email\" \nng-pattern=\"/^[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\\.[a-zA-Z]{2,4}$/\" disabled=\"disabled\"></md-input-container>\n<md-input-container flex=\"20\"><label>Select Email Type</label><md-select name=\"clients_email_id\" \nng-model=\"practice.cemail[1].email_type_ids\" multiple=\"true\" disabled=\"disabled\"><md-option \nng-repeat=\"(index,clientemail) in vm.allemailtypes\" ng-value=\"clientemail.email_type_id\">{{clientemail.email_type}}\n</md-option></md-select></md-input-container></div><div flex layout=\"row\"><md-input-container flex=\"30\" \nclass=\"md-block\"><label>Tel (Primary)</label><input type=\"text\" disabled=\"disabled\" \nng-model=\"practice.ctel[0].clients_tel\" ng-pattern=\"/^\\+?[0-9]{1}[0-9]{3,15}$/\"></md-input-container>\n<md-input-container flex=\"20\"><label>Select Tel Type</label><md-select name=\"clients_tel_id\" \nng-model=\"practice.ctel[0].tel_type_ids\" multiple=\"true\" disabled=\"disabled\"><md-option \nng-repeat=\"(index,clienttel) in vm.allteltypes\" ng-value=\"clienttel.tel_type_id\">{{clienttel.tel_type}}</md-option>\n</md-select></md-input-container><md-input-container flex=\"30\" class=\"md-block\"><label>Tel (Secondary)</label><input \ndisabled=\"disabled\" type=\"text\" ng-model=\"practice.ctel[1].clients_tel\" ng-pattern=\"/^\\+?[0-9]{1}[0-9]{3,15}$/\">\n</md-input-container><md-input-container flex=\"20\"><label>Select Tel Type</label><md-select name=\"clients_tel_id\" \nng-model=\"practice.ctel[1].tel_type_ids\" multiple=\"true\" disabled=\"disabled\"><md-option \nng-repeat=\"(index,clienttel) in vm.allteltypes\" ng-value=\"clienttel.tel_type_id\">{{clienttel.tel_type}}</md-option>\n</md-select></md-input-container></div></div><div layout=\"row\"><div flex class=\"full-width\" layout=\"row\" ng-cloak \nlayout-align=\"center center\"><md-button flex=\"50\" class=\"md-button md-raised full-width\" \nng-click=\"vm.disabled == false ? vm.openPopup($event, \'practice\', practice.clients_id) : \'\'\">\nChange Practice {{practice.clientname}}</md-button><md-button flex=\"50\" class=\"md-raised md-warn full-width\" \nng-click=\"vm.disabled == false ? vm.genericRemoveConfirm($event, \'clients\', \'practice\', practice.clients_id) : \'\'\">\nDelete Practice</md-button></div></div></div></div><div layout=\"row\"><div flex class=\"full-width\" layout=\"row\" \nng-cloak layout-align=\"center center\"><md-button ng-if=\"vm.client.clients_type_id!=3\" flex \nclass=\"md-button md-raised full-width\" ng-click=\"vm.disabled == false ? vm.openPopup($event, \'practice\') : \'\'\">\nAdd Practice</md-button></div></div><div ng-if=\"vm.dentistlength>0\"><div ng-repeat=\"dentist in vm.dentist\"><h2 \nng-show=\"!showDetails\">Dentist {{dentist.clientname}} | <a ng-click=\"showDetails = ! showDetails\" class=\"pointer\">\nShow Info</a></h2><h2 ng-show=\"showDetails\">Dentist {{dentist.clientname}} | <a ng-click=\"showDetails = ! showDetails\" \nclass=\"pointer\">Hide Info</a></h2><div ng-show=\"showDetails\"><div flex layout=\"row\"><md-input-container flex=\"50\" \nclass=\"md-block\"><label>Client</label><input type=\"text\" ng-model=\"dentist.clientname\" disabled=\"disabled\">\n</md-input-container><md-input-container flex=\"50\" class=\"md-block\"><label>GDC Number</label><input type=\"text\" \nng-model=\"dentist.gdc_number\" disabled=\"disabled\"></md-input-container></div><div flex layout=\"row\"><md-input-container\n flex=\"60\" class=\"md-block\"><label>E-mail (Primary)</label><input type=\"text\" \nng-model=\"dentist.cemail[0].clients_email\" ng-pattern=\"/^[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\\.[a-zA-Z]{2,4}$/\" \ndisabled=\"disabled\"></md-input-container><md-input-container flex=\"40\"><label>Select Email Type</label><md-select \nname=\"clients_email_id\" ng-model=\"dentist.cemail[0].email_type_ids\" multiple=\"true\" disabled=\"disabled\"><md-option \nng-repeat=\"(index,clientemail) in vm.allemailtypes\" ng-value=\"clientemail.email_type_id\">{{clientemail.email_type}}\n</md-option></md-select></md-input-container></div><div flex layout=\"row\"><md-input-container flex=\"60\" \nclass=\"md-block\"><label>E-mail (Secondary)</label><input type=\"text\" ng-model=\"dentist.cemail[1].clients_email\" \nng-pattern=\"/^[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\\.[a-zA-Z]{2,4}$/\" disabled=\"disabled\"></md-input-container>\n<md-input-container flex=\"40\"><label>Select Email Type</label><md-select name=\"clients_email_id\" \nng-model=\"dentist.cemail[1].email_type_ids\" multiple=\"true\" disabled=\"disabled\"><md-option \nng-repeat=\"(index,clientemail) in vm.allemailtypes\" ng-value=\"clientemail.email_type_id\">{{clientemail.email_type}}\n</md-option></md-select></md-input-container></div><div flex layout=\"row\"><md-input-container flex=\"60\" \nclass=\"md-block\"><label>Tel (Primary)</label><input type=\"text\" ng-model=\"dentist.ctel[0].clients_tel\" \nng-pattern=\"/^\\+?[0-9]{1}[0-9]{3,15}$/\" disabled=\"disabled\"></md-input-container><md-input-container flex=\"40\"><label>\nSelect Tel Type</label><md-select name=\"clients_tel_id\" ng-model=\"dentist.ctel[0].tel_type_ids\" multiple=\"true\" \ndisabled=\"disabled\"><md-option ng-repeat=\"(index,clienttel) in vm.allteltypes\" ng-value=\"clienttel.tel_type_id\">\n{{clienttel.tel_type}}</md-option></md-select></md-input-container></div><div flex layout=\"row\"><md-input-container \nflex=\"60\" class=\"md-block\"><label>Tel (Secondary)</label><input type=\"text\" ng-model=\"dentist.ctel[1].clients_tel\" \nng-pattern=\"/^\\+?[0-9]{1}[0-9]{3,15}$/\" disabled=\"disabled\"></md-input-container><md-input-container flex=\"40\"><label>\nSelect Tel Type</label><md-select name=\"clients_tel_id\" ng-model=\"dentist.ctel[1].tel_type_ids\" multiple=\"true\" \ndisabled=\"disabled\"><md-option ng-repeat=\"(index,clienttel) in vm.allteltypes\" ng-value=\"clienttel.tel_type_id\">\n{{clienttel.tel_type}}</md-option></md-select></md-input-container></div></div><div layout=\"row\"><div flex \nclass=\"full-width\" layout=\"row\" ng-cloak layout-align=\"center center\"><md-button flex=\"50\" \nclass=\"md-button md-raised full-width\" \nng-click=\"vm.disabled == false ? vm.openPopup($event, \'dentist\', dentist.clients_id) : \'\'\">\nChange Dentist {{dentist.clientname}}</md-button><md-button flex=\"50\" class=\"md-raised md-warn full-width\" \nng-click=\"vm.disabled == false ? vm.genericRemoveConfirm($event, \'clients\', \'dentist\', dentist.clients_id) : \'\'\">\nDelete Dentist</md-button></div></div></div></div><div layout=\"row\"><div flex class=\"full-width\" layout=\"row\" ng-cloak \nlayout-align=\"center center\"><md-button class=\"md-button md-raised full-width\" \nng-click=\"vm.disabled == false ? vm.openPopup($event, \'dentist\') : \'\'\">Add Dentist</md-button></div></div><div \nlayout=\"row\"><div flex class=\"full-width\" layout=\"row\" ng-cloak layout-align=\"center center\"><md-button \nclass=\"md-button md-raised full-width\" ng-click=\"vm.disabled == false ? vm.openPopup($event, \'payment\') : \'\'\">\nPayment Conditions</md-button></div></div><div layout=\"row\"><div flex class=\"full-width\" layout=\"row\" ng-cloak \nlayout-align=\"center center\"><md-button ng-disabled=\"vm.id==0\" class=\"md-button md-raised full-width\" \nng-click=\"showDetails = ! showDetails\">Product Specification</md-button></div></div><div ng-show=\"showDetails\"><div \nflex layout=\"row\" class=\"md-block\"><md-autocomplete flex required md-input-name=\"autocompleteField\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedItem\" md-search-text-change=\"vm.searchTextChange(vm.searchText)\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" \nmd-item-text=\"item.product_description\" md-selected-item-change=\"vm.selectedItemChange(item)\" md-require-match \nmd-input-minlength=\"0\" md-input-maxlength=\"50\" md-floating-label=\"Search Product\" ng-disabled=\"vm.isDisabled\" \nng-click=\"vm.ativa()\" ng-disabled=\"vm.disabled\"><md-item-template><span md-highlight-text=\"vm.searchText\" \nmd-highlight-flags=\"^i\">{{item.product_description}}</span></md-item-template><md-not-found>No matches found.<div \nng-messages=\"recordForm.autocompleteField.$error\"><div ng-message=\"required\">Please insert a product.</div></div>\n</md-not-found><div ng-messages=\"recordForm.autocompleteField.$error\"><div ng-message=\"required\">\nPlease insert a product.</div></div></md-autocomplete><md-input-container flex class=\"md-block\"><label>Cost</label>\n<input type=\"text\" name=\"rate\" value=\"{{vm.product.rate}}\" disabled=\"disabled\"></md-input-container><md-input-container\n flex class=\"md-block\"><label>Client Cost</label><input type=\"text\" name=\"client_product_cost\" \nng-model=\"vm.product.client_product_cost\" required ng-disabled=\"vm.disabled\"><div \nng-messages=\"recordForm.client_product_cost.$error\"><div ng-message=\"required\">Please insert the client product cost.\n</div></div></md-input-container><md-input-container flex class=\"md-block\"><label>Client Code</label><input \ntype=\"text\" name=\"client_product_code\" ng-model=\"vm.product.client_product_code\" required ng-disabled=\"vm.disabled\">\n<div ng-messages=\"recordForm.client_product_code.$error\"><div ng-message=\"required\">\nPlease insert the client product code.</div></div></md-input-container><md-button flex=\"10\" \nng-click=\"vm.disabled == false ? vm.addProduct(vm.product) : \'\'\" class=\"md-green-500-bg branco\" aria-label=\"Add\">Add\n</md-button></div><table datatable=\"ng\" class=\"row-border hover product-specification\"><thead><tr><th>Product Code</th>\n<th>Description</th><th>Cost</th><th class=\"client-special\">Client Cost</th><th class=\"client-special\">Client Code</th>\n<th width=\"5%\">Delete</th></tr></thead><tbody><tr ng-repeat=\"client in vm.clientsproducts\"><td>{{client.product_code}}\n</td><td>{{client.product_description}}</td><td>{{client.rate}}</td><td class=\"client-special\">\n{{client.client_product_cost}}</td><td class=\"client-special\">{{client.client_product_code}}</td><td><md-button \nng-click=\"vm.disabled == false ? vm.deleteProduct(client.clients_products_id) : \'\'\" \nclass=\"icon-delete font-size-20 red-800-fg\" aria-label=\"Delete\"></md-button></td></tr></tbody></table></div></div><div \nflex=\"25\"><div class=\"card-title\">Notes and Alerts</div><ms-card \ntemplate=\"\'app/main/pages/profile/templates/notes.html\'\" view-model=\"vm\"></ms-card></div></div></div></div>");
$templateCache.put("app/main/pages/profiles/profiles.html","<div id=\"pagina-orderstatus\" flex layout=\"column\"><div class=\"cabecalho cor-accounts\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Clients</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"><div class=\"estatisticas\" layout=\"row\" layout-align=\"end center\"><ul><li>\n<md-button class=\"orders-buttons\">{{vm.onstoporders}}</md-button><div class=\"stat-info font-size-8\">On Stop</div></li>\n<li><md-button class=\"orders-buttons\">{{vm.dueorders}}</md-button><div class=\"stat-info font-size-8\">Due Orders</div>\n</li><li><md-button class=\"orders-buttons\">{{vm.approvedvia}}</md-button><div class=\"stat-info font-size-8\">\nPortal Approved</div></li><li><md-button class=\"orders-buttons\">{{vm.approvedwaiting}}</md-button><div \nclass=\"stat-info font-size-8\">Approved & Waiting</div></li><li><md-button class=\"orders-buttons\">{{vm.waitingcall}}\n</md-button><div class=\"stat-info font-size-8\">Waiting for Call</div></li><li><md-button class=\"orders-buttons\">\n{{vm.waitingimpression}}</md-button><div class=\"stat-info font-size-8\">Waiting for Impression</div></li><li><md-button \nclass=\"orders-buttons\">{{vm.inactiveorders}}</md-button><div class=\"stat-info font-size-8\">Inactive</div></li><li>\n<md-button class=\"orders-buttons\">{{vm.numcompleted}}</md-button><div class=\"stat-info font-size-8\">Completed</div>\n</li></ul></div></div></div><div class=\"topo\" layout=\"row\" layout-align=\"start center\"><div flex layout=\"row\" \nlayout-align=\"start center\"><div class=\"breadcrumbs\" layout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" \nui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span class=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" \naria-hidden=\"true\"></md-icon><span class=\"font-size-16 font-weight-300\">Clients</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" \naria-hidden=\"true\"></md-icon><span class=\"font-size-16 font-weight-300\">Profiles</span></div></div></div><div \nclass=\"pagina-orderstatus\"><div class=\"estado-funcoes\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"estado-funcoes-esq\" layout=\"column\" layout-align=\"start center\"><md-button class=\"md-primary md-raised\" \nng-click=\"vm.settings > \'0\' ? vm.openSettings($event) : \'\'\">Settings</md-button></div><div class=\"estado-funcoes-dir\" \nlayout=\"column\" layout-align=\"end center\"><md-button class=\"md-primary md-raised\" \nng-click=\"vm.disabled == false ? vm.gotoProfile() : \'\'\">New Profile</md-button></div></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button ng-class=\"vm.type != 1 ? \'md-primary\' : \'no-pointer\'\" class=\"md-raised\" \nng-click=\"vm.changeType(1)\">Dentists & Practices</md-button><md-button \nng-class=\"vm.type != 2 ? \'md-primary\' : \'no-pointer\'\" class=\"md-raised\" ng-click=\"vm.changeType(2)\">Companies\n</md-button></div><md-button layout=\"row\" layout-align=\"center center\" class=\"md-primary md-raised\" \nng-click=\"vm.reset()\">Reset</md-button><div layout=\"row\"><md-input-container flex layout=\"row\" class=\"md-block\"><label>\nClient Type</label><md-select name=\"clients_type_id\" ng-model=\"vm.search.clients_type_id\" \nng-change=\"vm.searchTable(vm.search.clients_type_id, 8)\"><md-option ng-repeat=\"clienttype in vm.clientstype\" \nng-if=\"vm.type==1 && (clienttype.clients_type_id==2 || clienttype.clients_type_id==3)\" \nng-value=\"clienttype.clients_type_id\">{{clienttype.type}}</md-option><md-option \nng-repeat=\"clienttype in vm.clientstype\" ng-if=\"vm.type==2 && clienttype.clients_type_id==1\" \nng-value=\"clienttype.clients_type_id\">{{clienttype.type}}</md-option></md-select></md-input-container>\n<md-input-container flex class=\"md-block\"><label>Client No</label><input ng-model=\"vm.search.clientnumber\" type=\"text\" \nng-change=\"vm.searchTable(vm.search.clientnumber, 2)\"></md-input-container><md-input-container flex class=\"md-block\">\n<label>Client Name</label><input ng-model=\"vm.search.clientname\" type=\"text\" \nng-change=\"vm.searchTable(vm.search.clientname, 3)\"></md-input-container><md-input-container flex class=\"md-block\">\n<label>Postcode</label><input ng-model=\"vm.search.cpostcode\" type=\"text\" \nng-change=\"vm.searchTable(vm.search.cpostcode, 4)\"></md-input-container></div><div layout=\"row\"><md-input-container \nflex class=\"md-block\"><label>City</label><input type=\"text\" ng-model=\"vm.search.ccity\" \nng-change=\"vm.searchTable(vm.search.ccity, 5)\"></md-input-container><md-input-container flex class=\"md-block\"><label>\nCountry</label><input type=\"text\" ng-model=\"vm.search.ccountry\" ng-change=\"vm.searchTable(vm.search.ccountry, 6)\">\n</md-input-container><md-input-container flex class=\"md-block\" layout=\"row\"><label>Portal</label><md-select \nng-model=\"vm.search.isportal\" ng-change=\"vm.searchTable(vm.search.isportal, 7)\"><md-option value=\"1\">User</md-option>\n<md-option value=\"0\">Non User</md-option></md-select></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-green-500-bg branco\" ng-if=\"vm.itemabrir!=\'\'\" \nng-click=\"vm.openClient(vm.itemabrir)\">Open Client</md-button></div><div class=\"full-width\" layout=\"row\" \nlayout-align=\"space-between center\"><table datatable=\"\" class=\"row-border hover full-width\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\"></table></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-green-500-bg branco\" ng-if=\"vm.itemabrir!=\'\'\" \nng-click=\"vm.openClient(vm.itemabrir)\">Open Client</md-button></div></div></div>");
$templateCache.put("app/main/pages/reports/reports.html","<div id=\"pagina-reports\" flex layout=\"column\"><div class=\"cabecalho cor-accounts\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Invoicing</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"><div class=\"estatisticas\" layout=\"row\" layout-align=\"end center\"><ul><li>\n<md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.onstoporders}}</md-button><div \nclass=\"stat-info font-size-8\">On Stop</div></li><li><md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">\n{{vm.dueorders}}</md-button><div class=\"stat-info font-size-8\">Due Orders</div></li><li><md-button \nclass=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.approvedvia}}</md-button><div \nclass=\"stat-info font-size-8\">Portal Approved</div></li><li><md-button class=\"orders-buttons\" \nng-click=\"vm.gotoOrderStatus()\">{{vm.approvedwaiting}}</md-button><div class=\"stat-info font-size-8\">Approved & Waiting\n</div></li><li><md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.waitingcall}}</md-button><div \nclass=\"stat-info font-size-8\">Waiting for Call</div></li><li><md-button class=\"orders-buttons\" \nng-click=\"vm.gotoOrderStatus()\">{{vm.waitingimpression}}</md-button><div class=\"stat-info font-size-8\">\nWaiting for Impression</div></li><li><md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">\n{{vm.inactiveorders}}</md-button><div class=\"stat-info font-size-8\">Inactive</div></li><li><md-button \nclass=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.numcompleted}}</md-button><div \nclass=\"stat-info font-size-8\">Completed</div></li></ul></div></div></div><div class=\"topo\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Invoicing</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Reports</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Sales</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\">\n</div></div><div layout=\"row\" layout-align=\"center center\"><div class=\"cor-delivery md-padding\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-primary md-raised\" ng-disabled=\"true\">Sales</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.openPage(\'reportsclients\')\">Clients</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.openPage(\'reportsproducts\')\">Products</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.openPage(\'reportsorders\')\">Orders</md-button></div></div><div \nid=\"reports-page\" class=\"reports-page\"><div layout=\"row\"><div flex=\"20\"><div class=\"md-title md-padding\">Total Sales\n</div><ms-card flex class=\"nomaxwidth\" template=\"\'app/templates/cards/reports/totalsales.html\'\" view-model=\"vm\">\n</ms-card></div><div flex=\"30\"><div class=\"md-title md-padding\">Top Sales</div><ms-card flex class=\"nomaxwidth\" \ntemplate=\"\'app/templates/cards/reports/topsales.html\'\" view-model=\"vm\"></ms-card></div><div flex><div layout=\"row\"><div\n flex=\"80\" layout=\"row\" class=\"md-title md-padding\" layout-align=\"start center\">Total Sales Per Product</div><div \nflex=\"20\" layout=\"row\" layout-align=\"center center\"><a href=\"#\" ng-click=\"vm.autoPrintPage()\"><md-icon \nmd-font-icon=\"icon-printer\" class=\"s24 md-font icon-printer pointer\" aria-hidden=\"true\"></md-icon><md-tooltip \nmd-direction=\"top\">Click to print Reports page</md-tooltip></a></div></div><ms-card flex class=\"nomaxwidth\" \ntemplate=\"\'app/templates/cards/reports/totalsalesproduct.html\'\" view-model=\"vm\"></ms-card></div></div><div \nlayout=\"row\"><div flex=\"50\"><div class=\"md-title md-padding\">Total Sales Per Product Group</div><ms-card flex \nclass=\"nomaxwidth\" template=\"\'app/templates/cards/reports/totalsalesproductgroup.html\'\" view-model=\"vm\"></ms-card>\n</div><div flex=\"50\"><div class=\"md-title md-padding\">Sales Per Location</div><ms-card flex class=\"nomaxwidth\" \ntemplate=\"\'app/templates/cards/reports/totalsalesproductlocation.html\'\" view-model=\"vm\"></ms-card></div></div></div>\n</div>");
$templateCache.put("app/main/pages/reportsclients/reportsclients.html","<div id=\"pagina-reportsclients\" flex layout=\"column\"><div class=\"cabecalho cor-accounts\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Invoicing</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"><div class=\"estatisticas\" layout=\"row\" layout-align=\"end center\"><ul><li>\n<md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.onstoporders}}</md-button><div \nclass=\"stat-info font-size-8\">On Stop</div></li><li><md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">\n{{vm.dueorders}}</md-button><div class=\"stat-info font-size-8\">Due Orders</div></li><li><md-button \nclass=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.approvedvia}}</md-button><div \nclass=\"stat-info font-size-8\">Portal Approved</div></li><li><md-button class=\"orders-buttons\" \nng-click=\"vm.gotoOrderStatus()\">{{vm.approvedwaiting}}</md-button><div class=\"stat-info font-size-8\">Approved & Waiting\n</div></li><li><md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.waitingcall}}</md-button><div \nclass=\"stat-info font-size-8\">Waiting for Call</div></li><li><md-button class=\"orders-buttons\" \nng-click=\"vm.gotoOrderStatus()\">{{vm.waitingimpression}}</md-button><div class=\"stat-info font-size-8\">\nWaiting for Impression</div></li><li><md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">\n{{vm.inactiveorders}}</md-button><div class=\"stat-info font-size-8\">Inactive</div></li><li><md-button \nclass=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.numcompleted}}</md-button><div \nclass=\"stat-info font-size-8\">Completed</div></li></ul></div></div></div><div class=\"topo\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Invoicing</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Reports</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Clients</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\">\n</div></div><div layout=\"row\" layout-align=\"center center\"><div class=\"cor-delivery md-padding\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-primary md-raised\" ng-click=\"vm.openPage(\'reports\')\">Sales\n</md-button><md-button class=\"md-primary md-raised\" ng-disabled=\"true\">Clients</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.openPage(\'reportsproducts\')\">Products</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.openPage(\'reportsorders\')\">Orders</md-button></div></div><div \nid=\"pagina-reports\" class=\"reports-page\"><div layout=\"row\"><div flex=\"50\"><div class=\"md-title md-padding\">New Clients\n</div><ms-card flex class=\"nomaxwidth\" template=\"\'app/templates/cards/reports/newclients.html\'\" view-model=\"vm\">\n</ms-card></div><div flex><div layout=\"row\"><div flex=\"80\" layout=\"row\" class=\"md-title md-padding\" \nlayout-align=\"start center\">Clients Per Location</div><div flex=\"20\" layout=\"row\" layout-align=\"center center\"><a \nhref=\"#\" ng-click=\"vm.autoPrintPage()\"><md-icon md-font-icon=\"icon-printer\" class=\"s24 md-font icon-printer pointer\" \naria-hidden=\"true\"></md-icon><md-tooltip md-direction=\"top\">Click to print Reports page</md-tooltip></a></div></div>\n<ms-card flex class=\"nomaxwidth\" template=\"\'app/templates/cards/reports/clientsperlocation.html\'\" view-model=\"vm\">\n</ms-card></div></div><div layout=\"row\"><div flex><div class=\"md-title md-padding\">Client Distribution</div><ms-card \nflex class=\"nomaxwidth\" template=\"\'app/templates/cards/reports/clientdistribution.html\'\" view-model=\"vm\"></ms-card>\n</div></div><div layout=\"row\"><div flex><div class=\"md-title md-padding\">Clients Location and Product</div><ms-card \nflex class=\"nomaxwidth\" template=\"\'app/templates/cards/reports/clientslocationproduct.html\'\" view-model=\"vm\"></ms-card>\n</div></div></div></div>");
$templateCache.put("app/main/pages/reportsorders/reportsorders.html","<div id=\"pagina-reports\" flex layout=\"column\"><div class=\"cabecalho cor-accounts\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Invoicing</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"><div class=\"estatisticas\" layout=\"row\" layout-align=\"end center\"><ul><li>\n<md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.onstoporders}}</md-button><div \nclass=\"stat-info font-size-8\">On Stop</div></li><li><md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">\n{{vm.dueorders}}</md-button><div class=\"stat-info font-size-8\">Due Orders</div></li><li><md-button \nclass=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.approvedvia}}</md-button><div \nclass=\"stat-info font-size-8\">Portal Approved</div></li><li><md-button class=\"orders-buttons\" \nng-click=\"vm.gotoOrderStatus()\">{{vm.approvedwaiting}}</md-button><div class=\"stat-info font-size-8\">Approved & Waiting\n</div></li><li><md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.waitingcall}}</md-button><div \nclass=\"stat-info font-size-8\">Waiting for Call</div></li><li><md-button class=\"orders-buttons\" \nng-click=\"vm.gotoOrderStatus()\">{{vm.waitingimpression}}</md-button><div class=\"stat-info font-size-8\">\nWaiting for Impression</div></li><li><md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">\n{{vm.inactiveorders}}</md-button><div class=\"stat-info font-size-8\">Inactive</div></li><li><md-button \nclass=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.numcompleted}}</md-button><div \nclass=\"stat-info font-size-8\">Completed</div></li></ul></div></div></div><div class=\"topo\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Invoicing</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Reports</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Orders</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\">\n</div></div><div layout=\"row\" layout-align=\"center center\"><div class=\"cor-delivery md-padding\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-primary md-raised\" ng-click=\"vm.openPage(\'reports\')\">Sales\n</md-button><md-button class=\"md-primary md-raised\" ng-click=\"vm.openPage(\'reportsclients\')\">Clients</md-button>\n<md-button class=\"md-primary md-raised\" ng-click=\"vm.openPage(\'reportsproducts\')\">Products</md-button><md-button \nclass=\"md-primary md-raised\" ng-disabled=\"true\">Orders</md-button></div></div><div id=\"reports-page\" \nclass=\"reports-page\"><div layout=\"row\"><div flex><div class=\"md-title md-padding\">New Orders <span \nng-if=\"vm.startDate[\'neworders\'] == undefined && vm.endDate[\'neworders\'] == undefined\" class=\"smaller\">(Last 15 days)\n</span></div><ms-card flex class=\"nomaxwidth\" template=\"\'app/templates/cards/reports/neworders.html\'\" view-model=\"vm\">\n</ms-card></div><div flex><div class=\"md-title md-padding\">Orders Due</div><ms-card flex class=\"nomaxwidth\" \ntemplate=\"\'app/templates/cards/reports/ordersdue.html\'\" view-model=\"vm\"></ms-card></div><div flex><div \nclass=\"md-title md-padding\">Orders on WFC</div><ms-card flex class=\"nomaxwidth\" \ntemplate=\"\'app/templates/cards/reports/orderswfc.html\'\" view-model=\"vm\"></ms-card></div><div flex><div \nclass=\"md-title md-padding\">Orders on WFI</div><ms-card flex class=\"nomaxwidth\" \ntemplate=\"\'app/templates/cards/reports/orderswfi.html\'\" view-model=\"vm\"></ms-card></div><div flex><div \nclass=\"md-title md-padding\">Orders on STOP</div><ms-card flex class=\"nomaxwidth\" \ntemplate=\"\'app/templates/cards/reports/ordersonstop.html\'\" view-model=\"vm\"></ms-card></div><div flex><div layout=\"row\">\n<div flex=\"80\" layout=\"row\" class=\"md-title md-padding\" layout-align=\"start center\">Completed Orders</div><div \nflex=\"20\" layout=\"row\" layout-align=\"center center\"><a href=\"#\" ng-click=\"vm.autoPrintPage()\"><md-icon \nmd-font-icon=\"icon-printer\" class=\"s24 md-font icon-printer pointer\" aria-hidden=\"true\"></md-icon><md-tooltip \nmd-direction=\"top\">Click to print Reports page</md-tooltip></a></div></div><ms-card flex class=\"nomaxwidth\" \ntemplate=\"\'app/templates/cards/reports/completedorders.html\'\" view-model=\"vm\"></ms-card></div></div></div></div>");
$templateCache.put("app/main/pages/reportsproducts/reportsproducts.html","<div id=\"pagina-reports\" flex layout=\"column\"><div class=\"cabecalho cor-accounts\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Invoicing</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"><div class=\"estatisticas\" layout=\"row\" layout-align=\"end center\"><ul><li>\n<md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.onstoporders}}</md-button><div \nclass=\"stat-info font-size-8\">On Stop</div></li><li><md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">\n{{vm.dueorders}}</md-button><div class=\"stat-info font-size-8\">Due Orders</div></li><li><md-button \nclass=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.approvedvia}}</md-button><div \nclass=\"stat-info font-size-8\">Portal Approved</div></li><li><md-button class=\"orders-buttons\" \nng-click=\"vm.gotoOrderStatus()\">{{vm.approvedwaiting}}</md-button><div class=\"stat-info font-size-8\">Approved & Waiting\n</div></li><li><md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.waitingcall}}</md-button><div \nclass=\"stat-info font-size-8\">Waiting for Call</div></li><li><md-button class=\"orders-buttons\" \nng-click=\"vm.gotoOrderStatus()\">{{vm.waitingimpression}}</md-button><div class=\"stat-info font-size-8\">\nWaiting for Impression</div></li><li><md-button class=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">\n{{vm.inactiveorders}}</md-button><div class=\"stat-info font-size-8\">Inactive</div></li><li><md-button \nclass=\"orders-buttons\" ng-click=\"vm.gotoOrderStatus()\">{{vm.numcompleted}}</md-button><div \nclass=\"stat-info font-size-8\">Completed</div></li></ul></div></div></div><div class=\"topo\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Invoicing</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Reports</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Products</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\">\n</div></div><div layout=\"row\" layout-align=\"center center\"><div class=\"cor-delivery md-padding\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-primary md-raised\" ng-click=\"vm.openPage(\'reports\')\">Sales\n</md-button><md-button class=\"md-primary md-raised\" ng-click=\"vm.openPage(\'reportsclients\')\">Clients</md-button>\n<md-button class=\"md-primary md-raised\" ng-disabled=\"true\">Products</md-button><md-button class=\"md-primary md-raised\" \nng-click=\"vm.openPage(\'reportsorders\')\">Orders</md-button></div></div><div id=\"reports-page\" class=\"reports-page\"><div \nlayout=\"row\"><div flex=\"60\"><div class=\"md-title md-padding\">Total Per Product</div><ms-card flex class=\"nomaxwidth\" \ntemplate=\"\'app/templates/cards/reports/totalproducts.html\'\" view-model=\"vm\"></ms-card></div><div flex><div \nlayout=\"row\"><div flex=\"80\" layout=\"row\" class=\"md-title md-padding\" layout-align=\"start center\">Totals Per Group</div>\n<div flex=\"20\" layout=\"row\" layout-align=\"center center\"><a href=\"#\" ng-click=\"vm.autoPrintPage()\"><md-icon \nmd-font-icon=\"icon-printer\" class=\"s24 md-font icon-printer pointer\" aria-hidden=\"true\"></md-icon><md-tooltip \nmd-direction=\"top\">Click to print Reports page</md-tooltip></a></div></div><ms-card flex class=\"nomaxwidth\" \ntemplate=\"\'app/templates/cards/reports/totalsgroup.html\'\" view-model=\"vm\"></ms-card></div></div></div></div>");
$templateCache.put("app/main/pages/researchd/researchd.html","<div id=\"pagina-researchd\" flex layout=\"column\"><div class=\"cabecalho cor-researchd\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Research & Development</span></div></div><div \nflex=\"50\" layout=\"row\" layout-align=\"end center\"></div></div><div class=\"topo\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Research & Development</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Events / Tasks</span></div></div><div flex=\"50\" layout=\"row\" \nlayout-align=\"end center\"></div></div><div layout=\"row\" layout-align=\"center center\"><div \nclass=\"cor-researchd-sub md-padding\" flex layout=\"row\" layout-align=\"center center\"></div><div \nclass=\"branco-bg md-padding\" flex=\"25\" layout=\"row\" layout-align=\"center center\"><md-button ng-if=\"vm.caixaedicao!=1\" \nclass=\"md-primary md-raised\" ng-disabled=\"true\">New</md-button><md-button ng-if=\"vm.caixaedicao==1\" \nclass=\"md-primary md-raised\" ng-disabled=\"true\">Edit</md-button></div></div><div><div layout=\"row\"><div flex \nclass=\"md-padding full-width branco-bg\"><md-button layout=\"row\" layout-align=\"center center\" \nclass=\"md-primary md-raised\" ng-click=\"vm.reset()\">Reset</md-button><div layout=\"row\"><md-input-container layout=\"row\" \nflex class=\"md-block\"><label>Start date (yyyy-mm-dd)</label><input type=\"text\" name=\"start_date\" mask=\"9999-19-39\" \nng-model=\"vm.search.start_date\" ng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container \nlayout=\"row\" flex class=\"md-block\"><label>End date (yyyy-mm-dd)</label><input type=\"text\" name=\"end_date\" \nmask=\"9999-19-39\" ng-model=\"vm.search.end_date\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container flex class=\"md-block\"><label>Name</label><input name=\"name\" ng-model=\"vm.search.name\" type=\"text\">\n</md-input-container><md-input-container flex class=\"md-block\"><label>Type</label><md-select name=\"type\" \nng-model=\"vm.search.type\"><md-option value=\"\">All</md-option><md-option value=\"1\">Event</md-option><md-option \nvalue=\"2\">Task</md-option></md-select></md-input-container><md-input-container flex class=\"md-block\"><label>Status\n</label><md-select name=\"type\" ng-model=\"vm.search.completed\"><md-option value=\"\">All</md-option><md-option value=\"1\">\nCompleted</md-option><md-option value=\"0\">Uncompleted</md-option></md-select></md-input-container></div><h3>\n{{vm.cards.length}} Events / Tasks</h3><md-card class=\"event-card\" ng-repeat=\"card in vm.cards | filter:vm.search\"><div\n layout=\"row\"><div layout=\"column\" class=\"mkt-coluna-esq color-white\" \nng-class=\"card.type == 1 ? \'cor-researchd\' : \'color-rsd-task-bkg\'\" layout-align=\"center center\" flex=\"40\"><div \nclass=\"mkt-day\">{{card.start_date | cmdate:\'dd\'}}</div><div class=\"mkt-month\">{{card.start_date | cmdate:\'MMMM yyyy\'}}\n</div><div class=\"mkt-time\">{{card.start_date | cmdate:\'HH:ss\'}} - {{card.end_date | cmdate:\'HH:ss\'}}</div><div \nclass=\"mkt-address\"><span ng-if=\"card.address_1\">{{card.address_1}} </span><span ng-if=\"card.address_2\">\n{{card.address_2}} </span><span ng-if=\"card.city\">{{card.city}} </span><span ng-if=\"card.county\">{{card.county}} \n</span><span ng-if=\"card.postcode\">{{card.postcode}} </span><span ng-if=\"card.country\">{{card.country}}</span></div>\n</div><div layout=\"column\" flex class=\"mkt-coluna-dta md-padding\"><div layout=\"row\"><div ng-if=\"card.type == 1\" flex \nlayout-align=\"start center\" class=\"mkt-type color-rsd-event\">Event</div><div ng-if=\"card.type == 2\" flex \nlayout-align=\"start center\" class=\"mkt-type color-rsd-task\">Task</div><div flex layout-align=\"end center\" \nclass=\"mkt-completed\"><md-input-container><md-checkbox ng-model=\"card.completed\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"completed\" ng-change=\"vm.changeCompleteStatus(card.marketing_id,card.completed)\">Completed</md-checkbox>\n</md-input-container></div></div><div class=\"mkt-name\">{{card.name}}</div><div class=\"mkt-description\">\n{{card.description}}</div><div class=\"mkt-created\">Created By:</div><div class=\"mkt-user\">\n{{card.name}} | {{card.created_date | cmdate:\'dd/MM/yyyy\'}}</div><div class=\"mkt-delete\"><md-icon \nmd-font-icon=\"icon-trash\" class=\"s24 md-font icon-trash pointer\" aria-hidden=\"true\" \nng-click=\"vm.deleteExistingMarketing(event, card.marketing_id)\"></md-icon></div></div></div></md-card></div><div \nflex=\"25\"><div layout=\"row\" ng-cloak layout-align=\"center center\"></div><ms-card ng-if=\"vm.caixaedicao!=1\" flex \ntemplate=\"\'app/templates/cards/marketing/neweventrd.html\'\" view-model=\"vm\"></ms-card></div></div></div></div>");
$templateCache.put("app/main/pages/scheduling/scheduling.html","<div id=\"pagina-productgroup\" flex layout=\"column\" ng-cloak><div class=\"cabecalho cor-labs\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"wherepage\" \nlayout=\"row\" layout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s24 branco md-font material-icons icon-home\" aria-hidden=\"true\"></md-icon></a><span \nclass=\"espaco\"></span> <span class=\"md-title font-weight-400 branco\">Scheduling</span></div></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"end center\"></div></div><div class=\"topo\" layout=\"row\" layout-align=\"space-between center\">\n<div flex=\"50\" layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumbs\" layout=\"row\" \nlayout-align=\"start center\"><a aria-label=\"Home\" ui-sref=\"app.dashboard\" href=\"/dashboard.html\"><span \nclass=\"font-size-16 font-weight-300\">Dashboard</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Nimrodental Lab</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s24 separador md-default-theme md-font material-icons icon-chevron-right\" aria-hidden=\"true\"></md-icon><span \nclass=\"font-size-16 font-weight-300\">Scheduling</span></div></div><div flex=\"50\" layout=\"row\" \nlayout-align=\"end center\"></div></div><div><div layout=\"row\"><div flex class=\"md-padding branco-bg\"><table \ndatatable=\"ng\" class=\"row-border hover\"><thead><tr><th colspan=\"2\" style=\"text-align: center\">Starts at<br>Date / Hour\n</th><th colspan=\"2\" style=\"text-align: center\">Ends at<br>Date / Hour</th><th>Name</th><th colspan=\"2\">Recurring Date?\n</th><th>Description</th><th>Invites</th><th>Edit</th></tr></thead><tr ng-repeat=\"schedule in vm.schedules\"><td \nstyle=\"text-align: center\">{{schedule.startdate}} at {{schedule.starthour}}</td><td></td><td \nstyle=\"text-align: center\">{{schedule.enddate}} at {{schedule.endhour}}</td><td></td><td>{{schedule.name}}</td><td>\n<span ng-if=\"schedule.recurring == 1\">Yes</span><span ng-if=\"schedule.recurring != 1\">No</span></td><td><span \nng-if=\"schedule.recurring == 1\">{{schedule.recurdate}}</span><span ng-if=\"schedule.recurring != 1\"></span></td><td>\n{{schedule.description}}</td><td><span \nng-repeat=\"mail in vm.schedulesemails | filter: { \'scheduling_id\': schedule.scheduling_id}:true\">{{mail.email}}<br>\n</span></td><td><md-button ng-click=\"vm.editSchedule(schedule.scheduling_id)\" \nclass=\"icon-pencil font-size-20 yellow-800-fg\" aria-label=\"Edit Schedule\"></md-button></td></tr></table></div><div \nflex=\"25\"><div layout=\"row\" layout-align=\"center center\"><md-button ng-if=\"vm.caixaedicao!=1\" \nclass=\"md-primary md-raised\" ng-disabled=\"true\">New Booking</md-button><md-button ng-if=\"vm.caixaedicao==1\" \nclass=\"md-primary md-raised\" ng-disabled=\"true\">Edit Booking</md-button></div><ms-card ng-if=\"vm.caixaedicao!=1\" flex \ntemplate=\"\'app/templates/cards/booking/newbooking.html\'\" view-model=\"vm\"></ms-card><ms-card ng-if=\"vm.caixaedicao==1\" \nflex template=\"\'app/templates/cards/booking/editbooking.html\'\" view-model=\"vm\"></ms-card></div></div></div></div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/templates/cards/delivery/delivertyselectionedit.html","<div flex class=\"delivery-box\" layout=\"column\" layout-align=\"start center\"><h3>Selection Edit</h3><div layout=\"row\" \nclass=\"full-width\"><div flex><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Cost Increase %\n</label><input type=\"text\"></md-input-container></div><div flex><md-input-container flex layout=\"row\" \nclass=\"full-width md-block\"><label>Cost Decrease %</label><input type=\"text\"></md-input-container></div></div><div \nlayout=\"row\" class=\"full-width\"><div flex><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>\nDelivery Group</label><md-select ng-model=\"delivery.group\"><md-option value=\"1\">DHL</md-option><md-option value=\"2\">\nBike</md-option><md-option value=\"3\">Royal Mail</md-option><md-option value=\"4\">Courier</md-option><md-option \nvalue=\"5\">Collection</md-option></md-select></md-input-container></div><div flex><md-input-container flex layout=\"row\" \nclass=\"full-width md-block\"><label>Departament</label><md-select ng-model=\"delivery.departament\"><md-option value=\"1\">\nGo</md-option><md-option value=\"2\">Plaster Room</md-option><md-option value=\"3\">3D Scanning</md-option></md-select>\n</md-input-container></div></div><div flex layout=\"row\" layout-align=\"start center\"><div><md-button class=\"md-primary\" \nng-click=\"cancelOrder($event)\">Cancel</md-button></div><div><md-button class=\"md-primary\" \nng-click=\"vm.disabled == false ? saveOrder($event) : \'\'\">Save</md-button></div></div></div>");
$templateCache.put("app/templates/cards/delivery/editdeliverygroup.html","<div flex class=\"delivery-box\" layout=\"column\" layout-align=\"start center\"><form name=\"insereGrupo\" \nng-submit=\"submitForm(insereGrupo.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.grupo.deliverygroups_id\" \nng-init=\"vm.grupo.deliverygroups_id=deliverygroups_id\"><h3>New Delivery Group</h3><md-input-container \nmd-is-error=\"insereGrupo.deliverygroup_code.$invalid && (insereGrupo.deliverygroup_code.$touched || insereGrupo.$submitted)\" \nflex layout=\"row\" class=\"full-width md-block\"><label>Code</label><input name=\"deliverygroup_code\" type=\"text\" \nng-model=\"vm.grupo.deliverygroup_code\" required><div ng-messages=\"recordForm.group_description.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Please insert a group code.</span></div></div></md-input-container><md-input-container\n md-is-error=\"insereGrupo.deliverygroup.$invalid && (insereGrupo.deliverygroup.$touched || insereGrupo.$submitted)\" \nflex layout=\"row\" class=\"full-width md-block\"><label>Delivery Group</label><input name=\"deliverygroup\" type=\"text\" \nng-model=\"vm.grupo.deliverygroup\" required><div ng-messages=\"recordForm.deliverygroup.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Please insert a group name.</span></div></div></md-input-container><div flex layout=\"row\" \nlayout-align=\"center center\"><div><md-button class=\"md-primary\" ng-click=\"cancelOrder($event)\">Cancel</md-button></div>\n<div><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"vm.disabled == false ? insereGrupo.$valid && vm.saveExistGroup(vm.grupo) : \'\'\">Save</md-button></div></div>\n</form></div>");
$templateCache.put("app/templates/cards/delivery/editdeliveryroute.html","<div flex class=\"delivery-box\" layout=\"column\" layout-align=\"start center\"><form name=\"insereRoute\" \nng-submit=\"submitForm(insereRoute.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.route.deliveryroutes_id\" \nng-init=\"vm.route.deliveryroutes_id=vm.route.deliveryroutes_id\"><h3>Edit Delivery Route</h3><md-input-container \nmd-is-error=\"insereRoute.deliveryroutes_code.$invalid && (insereRoute.deliveryroutes_code.$touched || insereRoute.$submitted)\" \nflex layout=\"row\" class=\"full-width md-block\"><label>Code</label><input type=\"text\" name=\"deliveryroutes_code\" \nng-model=\"vm.route.deliveryroutes_code\" required><div ng-messages=\"insereRoute.deliveryroutes_code.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Please insert a delivery route code.</span></div></div>\n</md-input-container><md-input-container \nmd-is-error=\"insereRoute.route.$invalid && (insereRoute.route.$touched || insereRoute.$submitted)\" flex layout=\"row\" \nclass=\"full-width md-block\"><label>Route Name</label><input type=\"text\" name=\"route\" ng-model=\"vm.route.route\" \nrequired><div ng-messages=\"insereRoute.route.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease insert a delivery route name.</span></div></div></md-input-container><md-input-container \nmd-is-error=\"insereRoute.deliverygroups_id.$invalid && (insereRoute.deliverygroups_id.$touched || insereProduto.$submitted)\" \nflex layout=\"row\" class=\"full-width md-block\"><label>Delivery Group</label><md-select name=\"deliverygroups_id\" \nng-model=\"vm.route.deliverygroups_id\"><md-option ng-repeat=\"(index,grupo) in vm.groups\" \nng-value=\"grupo.deliverygroups_id\" ng-selected=\"index == \'{{vm.grupo.deliverygroups_id}}\'\">{{grupo.deliverygroup}}\n</md-option></md-select><div ng-messages=\"insereRoute.deliverygroups_id.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Please choose a delivery group.</span></div></div></md-input-container><div layout=\"row\" \nclass=\"full-width\"><div flex=\"50\"><md-input-container \nmd-is-error=\"insereRoute.rate.$invalid && (insereRoute.rate.$touched || insereRoute.$submitted)\" flex layout=\"row\" \nclass=\"full-width md-block\"><label>Unit Rate</label><input type=\"text\" name=\"rate\" ng-model=\"vm.route.rate\" required>\n<div ng-messages=\"insereRoute.rate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert a rate.</span>\n</div></div></md-input-container></div><div flex><md-input-container \nmd-is-error=\"insereRoute.vat.$invalid && (insereRoute.vat.$touched || insereRoute.$submitted)\" flex layout=\"row\" \nclass=\"full-width md-block\"><label>VAT</label><input type=\"text\" name=\"vat\" ng-model=\"vm.route.vat\" required><div \nng-messages=\"insereRoute.vat.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert a VAT rate.</span>\n</div></div></md-input-container></div></div><div layout=\"row\" class=\"full-width\"><div flex><md-input-container flex \nlayout=\"row\" class=\"full-width md-block\"><label>VAT Amount</label><input type=\"text\" value=\"{{vm.vatamountz()}}\" \ndisabled=\"disabled\"></md-input-container></div><div flex><md-input-container flex layout=\"row\" \nclass=\"full-width md-block\"><label>Total</label><input type=\"text\" value=\"{{vm.totalz()}}\" disabled=\"disabled\">\n</md-input-container></div></div><div layout=\"row\" class=\"full-width\"><div flex><md-input-container \nmd-is-error=\"insereRoute.days.$invalid && (insereRoute.days.$touched || insereRoute.$submitted)\" flex layout=\"row\" \nclass=\"full-width md-block\"><label>No of Days</label><input type=\"text\" name=\"days\" ng-model=\"vm.route.days\" required>\n<div ng-messages=\"insereRoute.days.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease insert the number of days.</span></div></div></md-input-container></div><div flex><md-input-container \nmd-is-error=\"insereRoute.hours.$invalid && (insereRoute.hours.$touched || insereRoute.$submitted)\" flex layout=\"row\" \nclass=\"full-width md-block\"><label>No of Hours</label><input type=\"text\" name=\"hours\" ng-model=\"vm.route.hours\" \nrequired><div ng-messages=\"insereRoute.hours.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease insert the number of hours.</span></div></div></md-input-container></div></div><div layout=\"row\" \nclass=\"full-width\"><md-input-container \nmd-is-error=\"insereRoute.departments_id.$invalid && (insereRoute.departments_id.$touched || insereRoute.$submitted)\" \nflex layout=\"row\" class=\"full-width md-block\"><label>Departments</label><md-select name=\"departments_id\" \nng-model=\"vm.route.departments_id\"><md-option ng-repeat=\"(index,departamento) in vm.departamentos\" \nng-value=\"departamento.departments_id\" ng-selected=\"index == \'{{vm.departamento.departments_id}}\'\">\n{{departamento.department_name}}</md-option></md-select><div ng-messages=\"insereRoute.departments_id.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Please choose a department.</span></div></div></md-input-container></div>\n<div flex layout=\"row\" layout-align=\"center center\"><div><md-button class=\"md-primary\" ng-click=\"vm.cancel($event)\">\nCancel</md-button></div><div><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"vm.disabled == false ? insereRoute.$valid && vm.saveExistRoute(vm.route) : \'\'\">Save</md-button></div></div>\n</form></div>");
$templateCache.put("app/templates/cards/delivery/newdeliverygroup.html","<div flex class=\"delivery-box\" layout=\"column\" layout-align=\"start center\"><form name=\"insereGrupo\" \nng-submit=\"submitForm(insereGrupo.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.grupo.deliverygroups_id\" \nng-init=\"vm.grupo.deliverygroups_id=0\"><h3>New Delivery Group</h3><md-input-container \nmd-is-error=\"insereGrupo.deliverygroup_code.$invalid && (insereGrupo.deliverygroup_code.$touched || insereGrupo.$submitted)\" \nflex layout=\"row\" class=\"full-width md-block\"><label>Code</label><input name=\"deliverygroup_code\" type=\"text\" \nng-model=\"vm.grupo.deliverygroup_code\" required><div ng-messages=\"recordForm.group_description.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Please insert a group code.</span></div></div></md-input-container><md-input-container\n md-is-error=\"insereGrupo.deliverygroup.$invalid && (insereGrupo.deliverygroup.$touched || insereGrupo.$submitted)\" \nflex layout=\"row\" class=\"full-width md-block\"><label>Delivery Group</label><input name=\"deliverygroup\" type=\"text\" \nng-model=\"vm.grupo.deliverygroup\" required><div ng-messages=\"recordForm.deliverygroup.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Please insert a group name.</span></div></div></md-input-container><div flex layout=\"row\" \nlayout-align=\"center center\"><div><md-button class=\"md-primary\" ng-click=\"cancelOrder($event)\">Cancel</md-button></div>\n<div><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"vm.disabled == false ? insereGrupo.$valid && vm.saveExistGroup(vm.grupo) : \'\'\">Save</md-button></div></div>\n</form></div>");
$templateCache.put("app/templates/cards/delivery/newdeliveryroute.html","<div flex class=\"delivery-box\" layout=\"column\" layout-align=\"start center\"><form name=\"insereRoute\" \nng-submit=\"submitForm(insereRoute.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.route.deliveryroutes_id\" \nng-init=\"vm.route.deliveryroutes_id=\'0\'\"><h3>New Delivery Route</h3><md-input-container \nmd-is-error=\"insereRoute.deliveryroutes_code.$invalid && (insereRoute.deliveryroutes_code.$touched || insereRoute.$submitted)\" \nflex layout=\"row\" class=\"full-width md-block\"><label>Code</label><input type=\"text\" name=\"deliveryroutes_code\" \nng-model=\"vm.route.deliveryroutes_code\" required><div ng-messages=\"insereRoute.deliveryroutes_code.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Please insert a delivery route code.</span></div></div>\n</md-input-container><md-input-container \nmd-is-error=\"insereRoute.route.$invalid && (insereRoute.route.$touched || insereRoute.$submitted)\" flex layout=\"row\" \nclass=\"full-width md-block\"><label>Route Name</label><input type=\"text\" name=\"route\" ng-model=\"vm.route.route\" \nrequired><div ng-messages=\"insereRoute.route.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease insert a delivery route name.</span></div></div></md-input-container><md-input-container \nmd-is-error=\"insereRoute.deliverygroups_id.$invalid && (insereRoute.deliverygroups_id.$touched || insereProduto.$submitted)\" \nflex layout=\"row\" class=\"full-width md-block\"><label>Delivery Group</label><md-select name=\"deliverygroups_id\" \nng-model=\"vm.route.deliverygroups_id\"><md-option ng-repeat=\"grupo in vm.groups\" ng-value=\"grupo.deliverygroups_id\">\n{{grupo.deliverygroup}}</md-option></md-select><div ng-messages=\"insereRoute.deliverygroups_id.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Please choose a delivery group.</span></div></div></md-input-container><div \nlayout=\"row\" class=\"full-width\"><div flex=\"50\"><md-input-container \nmd-is-error=\"insereRoute.rate.$invalid && (insereRoute.rate.$touched || insereRoute.$submitted)\" flex layout=\"row\" \nclass=\"full-width md-block\"><label>Unit Rate</label><input type=\"text\" name=\"rate\" ng-model=\"vm.route.rate\" \nng-change=\"vm.vattotal()\" required><div ng-messages=\"insereRoute.rate.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Please insert a rate.</span></div></div></md-input-container></div><div flex><md-input-container \nmd-is-error=\"insereRoute.vat.$invalid && (insereRoute.vat.$touched || insereRoute.$submitted)\" flex layout=\"row\" \nclass=\"full-width md-block\"><label>VAT</label><input type=\"text\" name=\"vat\" ng-model=\"vm.route.vat\" \nng-change=\"vm.vattotal()\" required><div ng-messages=\"insereRoute.vat.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Please insert a VAT rate.</span></div></div></md-input-container></div></div><div layout=\"row\" \nclass=\"full-width\"><div flex><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>VAT Amount\n</label><input type=\"text\" ng-model=\"vm.vatamount\" disabled=\"disabled\"></md-input-container></div><div flex>\n<md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Total</label><input type=\"text\" \nng-model=\"vm.total\" disabled=\"disabled\"></md-input-container></div></div><div layout=\"row\" class=\"full-width\"><div \nflex><md-input-container \nmd-is-error=\"insereRoute.days.$invalid && (insereRoute.days.$touched || insereRoute.$submitted)\" flex layout=\"row\" \nclass=\"full-width md-block\"><label>No of Days</label><input type=\"text\" name=\"days\" ng-model=\"vm.route.days\" required>\n<div ng-messages=\"insereRoute.days.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease insert the number of days.</span></div></div></md-input-container></div><div flex><md-input-container \nmd-is-error=\"insereRoute.hours.$invalid && (insereRoute.hours.$touched || insereRoute.$submitted)\" flex layout=\"row\" \nclass=\"full-width md-block\"><label>No of Hours</label><input type=\"text\" name=\"hours\" ng-model=\"vm.route.hours\" \nrequired><div ng-messages=\"insereRoute.hours.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease insert the number of hours.</span></div></div></md-input-container></div></div><div layout=\"row\" \nclass=\"full-width\"><md-input-container \nmd-is-error=\"insereRoute.departments_id.$invalid && (insereRoute.departments_id.$touched || insereRoute.$submitted)\" \nflex layout=\"row\" class=\"full-width md-block\"><label>Departments</label><md-select name=\"departments_id\" \nng-model=\"vm.route.departments_id\"><md-option ng-repeat=\"departamento in vm.departamentos\" \nng-value=\"departamento.departments_id\">{{departamento.department_name}}</md-option></md-select><div \nng-messages=\"insereRoute.departments_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease choose a department.</span></div></div></md-input-container></div><div flex layout=\"row\" \nlayout-align=\"center center\"><div><md-button class=\"md-primary\" ng-click=\"vm.cancel($event)\">Cancel</md-button></div>\n<div><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"vm.disabled == false ? insereRoute.$valid && vm.saveNewRoute(vm.route) : \'\'\">Save</md-button></div></div>\n</form></div>");
$templateCache.put("app/templates/cards/booking/editbooking.html","<div flex class=\"products-box\" layout=\"column\"><form name=\"insereSchedule\" \nng-submit=\"submitForm(insereSchedule.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.schedule.scheduling_id\" \nng-init=\"vm.schedule.scheduling_id=vm.schedule.scheduling_id\"><h3>Edit Booking</h3><md-input-container \nmd-is-error=\"insereSchedule.name.$invalid && (insereSchedule.name.$touched || insereSchedule.$submitted)\" flex \nlayout=\"row\" class=\"full-width md-block\"><label>Name</label><input type=\"text\" name=\"name\" ng-model=\"vm.schedule.name\" \nrequired><div ng-messages=\"insereSchedule.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease insert a name.</span></div></div></md-input-container><div class=\"padding-bottom-5\"><md-input-container flex \nlayout=\"row\" class=\"md-block\" moment-picker=\"vm.schedule.startdate\" format=\"YYYY-MM-DD\" start-view=\"month\" \nautoclose=\"vm.autoclose\"><label>From Date</label><input class=\"form-control\" ng-model=\"vm.schedule.startdate\" required>\n</md-input-container><md-input-container flex layout=\"row\" class=\"md-block\" moment-picker=\"vm.schedule.enddate\" \nformat=\"YYYY-MM-DD\" start-view=\"month\" autoclose=\"vm.autoclose\" min-date=\"vm.schedule.startdate\"><label>To Date</label>\n<input class=\"form-control\" ng-model=\"vm.schedule.enddate\" required></md-input-container></div><div \nclass=\"padding-bottom-20\"><md-input-container class=\"md-block\" moment-picker=\"vm.schedule.starthour\" format=\"HH\" \nautoclose=\"vm.autoclose\"><label>From Hour</label><input class=\"form-control\" ng-model=\"vm.schedule.starthour\" required>\n</md-input-container><md-input-container flex layout=\"row\" class=\"md-block\" moment-picker=\"vm.schedule.endhour\" \nformat=\"HH\" autoclose=\"vm.autoclose\" min-date=\"vm.schedule.starthour\"><label>To Hour</label><input \nclass=\"form-control\" ng-model=\"vm.schedule.endhour\" required></md-input-container><div layout=\"row\" \nlayout-align=\"left center \"><md-input-container flex=\"30\"><md-checkbox ng-model=\"vm.schedule.recurring\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"recur\">Recur</md-checkbox></md-input-container><md-input-container \nflex=\"70\" class=\"padding-top-10 padding-left-5\"><md-select ng-model=\"vm.schedule.recurdate\" placeholder=\"Select\">\n<md-option value=\"2 WEEK\">2 Weeks</md-option><md-option value=\"1 MONTH\">Monthly</md-option><md-option value=\"2 MONTH\">\n2 Months</md-option><md-option value=\"3 MONTH\">3 Months</md-option><md-option value=\"6 MONTH\">6 Months</md-option>\n<md-option value=\"1 YEAR\">1 Year</md-option></md-select></md-input-container></div><p>Invite</p><div layout=\"row\">\n<md-input-container flex=\"80\"><label>Enter Email</label><input type=\"text\" name=\"email\" ng-model=\"vm.novoemail\" \nng-pattern=\"/^[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\\.[a-zA-Z]{2,4}$/\" ng-model=\"vm.novoemail\" \nng-keyup=\"($event.keyCode == 13 && !insereSchedule.email.$invalid && vm.novoemail) ? vm.addEmail(vm.schedule.scheduling_id) : null\">\n<md-hint class=\"hint\" ng-if=\"(!insereSchedule.email.$invalid && vm.novoemail)\">\nPress enter or click on right button to add e-mail.</md-hint><div ng-messages=\"insereSchedule.email.$error\" \nrole=\"alert\"><div ng-message=\"pattern\"><span>Please insert a valid e-mail.</span></div></div></md-input-container>\n<md-button flex><md-icon ng-if=\"vm.novoemail\" class=\"icon-plus font-size-20\" flex aria-hidden=\"true\" \nng-click=\"vm.addEmail(vm.schedule.scheduling_id)\"></md-icon></md-button></div><div layout=\"row\"><ul class=\"email-list\">\n<li ng-repeat=\"mail in vm.scheduleemails\"><a href=\"#\" \nng-click=\"vm.deleteInviteEmail(mail.scheduling_email_id, mail.email)\" title=\"Delete Invite E-mail\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s20 md-font\" aria-hidden=\"true\" aria-label=\"Remove Invite Email\"></md-icon></a>\n{{mail.email}}</li></ul></div><div layout=\"row\"><md-input-container flex class=\"md-block\"><label>Description</label>\n<textarea md-maxlength=\"150\" rows=\"5\" md-select-on-focus ng-model=\"vm.schedule.description\"></textarea>\n</md-input-container></div><div flex layout=\"row\" layout-align=\"center center\"><div><md-button class=\"md-red-500-bg\" \nng-click=\"vm.deleteExistSchedule($event,vm.schedule.scheduling_id)\">Delete</md-button></div><div><md-button \nclass=\"md-primary\" ng-click=\"vm.cancel($event)\">Cancel</md-button></div><div><md-button class=\"md-green-500-bg branco\" \nng-click=\"insereSchedule.$valid && vm.saveSchedule(vm.schedule)\">Save</md-button></div></div></div></form></div>");
$templateCache.put("app/templates/cards/booking/newbooking.html","<div flex class=\"products-box\" layout=\"column\"><form name=\"insereSchedule\" \nng-submit=\"submitForm(insereSchedule.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.schedule.scheduling_id\" \nng-init=\"vm.schedule.scheduling_id=\'0\'\"><h3>New Booking</h3><md-input-container \nmd-is-error=\"insereSchedule.name.$invalid && (insereSchedule.name.$touched || insereSchedule.$submitted)\" flex \nlayout=\"row\" class=\"full-width md-block\"><label>Name</label><input type=\"text\" name=\"name\" ng-model=\"vm.schedule.name\" \nrequired><div ng-messages=\"insereSchedule.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease insert a name.</span></div></div></md-input-container><div class=\"padding-bottom-5\"><md-input-container flex \nlayout=\"row\" class=\"md-block\" moment-picker=\"vm.schedule.startdate\" format=\"YYYY-MM-DD\" start-view=\"month\" \nautoclose=\"vm.autoclose\"><label>From Date</label><input class=\"form-control\" ng-model=\"vm.schedule.startdate\" required>\n</md-input-container><md-input-container flex layout=\"row\" class=\"md-block\" moment-picker=\"vm.schedule.enddate\" \nformat=\"YYYY-MM-DD\" start-view=\"month\" autoclose=\"vm.autoclose\" min-date=\"vm.schedule.startdate\"><label>To Date</label>\n<input class=\"form-control\" ng-model=\"vm.schedule.enddate\" required></md-input-container></div><div \nclass=\"padding-bottom-20\"><md-input-container class=\"md-block\" moment-picker=\"vm.schedule.starthour\" format=\"HH\" \nautoclose=\"vm.autoclose\"><label>From Hour</label><input class=\"form-control\" ng-model=\"vm.schedule.starthour\" required>\n</md-input-container><md-input-container flex layout=\"row\" class=\"md-block\" moment-picker=\"vm.schedule.endhour\" \nformat=\"HH\" autoclose=\"vm.autoclose\" min-date=\"vm.schedule.starthour\"><label>To Hour</label><input \nclass=\"form-control\" ng-model=\"vm.schedule.endhour\" required></md-input-container><div layout=\"row\" \nlayout-align=\"left center \"><md-input-container flex=\"30\"><md-checkbox ng-model=\"vm.schedule.recurring\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"recur\">Recur</md-checkbox></md-input-container><md-input-container \nflex=\"70\" class=\"padding-top-10 padding-left-5\"><md-select ng-model=\"vm.schedule.recurdate\" placeholder=\"Select\">\n<md-option value=\"2 WEEK\">2 Weeks</md-option><md-option value=\"1 MONTH\">Monthly</md-option><md-option value=\"2 MONTH\">\n2 Months</md-option><md-option value=\"3 MONTH\">3 Months</md-option><md-option value=\"6 MONTH\">6 Months</md-option>\n<md-option value=\"1 YEAR\">1 Year</md-option></md-select></md-input-container></div><p>Invite</p><div layout=\"row\">\n<md-input-container flex=\"80\"><label>Enter Email</label><input type=\"text\" name=\"email\" \nng-pattern=\"/^[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\\.[a-zA-Z]{2,4}$/\" ng-model=\"vm.novoemail\" \nng-keyup=\"($event.keyCode == 13 && !insereSchedule.email.$invalid && vm.novoemail) ? vm.addEmail(0) : null\"><md-hint \nclass=\"hint\" ng-if=\"(!insereSchedule.email.$invalid && vm.novoemail)\">\nPress enter or click on right button to add e-mail.</md-hint><div ng-messages=\"insereSchedule.email.$error\" \nrole=\"alert\"><div ng-message=\"pattern\"><span>Please insert a valid e-mail.</span></div></div></md-input-container>\n<md-button><md-icon ng-if=\"vm.novoemail\" class=\"icon-plus font-size-20\" flex aria-hidden=\"true\" \nng-click=\"vm.addEmail(0)\"></md-icon></md-button></div><div layout=\"row\"><ul class=\"email-list\"><li \nng-repeat=\"item in vm.schemail\"><a href=\"#\" ng-click=\"vm.deleteInviteEmail(item.scheduling_email_id, item.email)\" \ntitle=\"Delete Invite E-mail\"><md-icon md-font-icon=\"icon-window-close\" class=\"s20 md-font\" aria-hidden=\"true\" \naria-label=\"Remove Invite Email\"></md-icon></a>{{item.email}}</li></ul></div><div layout=\"row\"><md-input-container \nflex class=\"md-block\"><label>Description</label><textarea md-maxlength=\"150\" rows=\"5\" md-select-on-focus \nng-model=\"vm.schedule.description\"></textarea></md-input-container></div><div flex layout=\"row\" \nlayout-align=\"center center\"><div><md-button class=\"md-primary\" ng-click=\"vm.cancel($event)\">Cancel</md-button></div>\n<div><md-button class=\"md-green-500-bg branco\" ng-click=\"insereSchedule.$valid && vm.saveSchedule(vm.schedule)\">Save\n</md-button></div></div></div></form></div>");
$templateCache.put("app/templates/cards/finances/editbanking.html","<div flex class=\"products-box\" layout=\"column\" layout-align=\"start center\"><form name=\"insereProduto\" \nng-submit=\"submitForm(insereProduto.$valid)\" novalidate class=\"full-width\"><h3>Edit Banking</h3><div layout=\"row\" \nclass=\"full-width\"><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Account Number</label>\n<input type=\"text\" name=\"account_number\" ng-model=\"vm.banking.account_number\" ng-disabled=\"vm.disabled\">\n</md-input-container></div><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Account Name\n</label><input type=\"text\" name=\"account_name\" ng-model=\"vm.banking.account_name\" ng-disabled=\"vm.disabled\">\n</md-input-container><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Amount</label><input \ntype=\"text\" name=\"amount\" ng-model=\"vm.banking.amount\" ng-disabled=\"vm.disabled\" ng-pattern=\"/^\\d{0,10}(\\.\\d{1,2})?$/\">\n<div ng-messages=\"insereProduto.amount.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>\nPlease insert a valid amount: e.g. 120 or 120.24</span></div></div></md-input-container><div flex layout=\"row\" \nlayout-align=\"center center\"><div><md-button class=\"md-red-500-bg\" \nng-click=\"vm.disabled==false ? vm.deleteBanking(vm.banking.banking_id) : \'\'\">Delete</md-button></div><div><md-button \nclass=\"md-primary\" ng-click=\"vm.cancel($event)\">Cancel</md-button></div><div><md-button class=\"md-green-500-bg branco\" \ntype=\"submit\" ng-click=\"vm.disabled==false ? insereProduto.$valid && vm.saveBanking(vm.banking) : \'\'\">Save</md-button>\n</div></div></form></div>");
$templateCache.put("app/templates/cards/finances/editdebt.html","<div flex class=\"products-box\" layout=\"column\" layout-align=\"start center\"><form name=\"insereProduto\" \nng-submit=\"submitForm(insereProduto.$valid)\" novalidate class=\"full-width\"><h3>Edit Debt</h3><div layout=\"row\" \nclass=\"full-width\"><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Description</label><input \ntype=\"text\" name=\"debt\" ng-model=\"vm.debt.description\" ng-disabled=\"vm.disabled\"></md-input-container></div>\n<md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Debt</label><input type=\"text\" name=\"debt\" \nng-model=\"vm.debt.debt\" ng-disabled=\"vm.disabled\" ng-pattern=\"/^\\d{0,10}(\\.\\d{1,2})?$/\"><div \nng-messages=\"insereProduto.debt.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>\nPlease insert a valid debt: e.g. 120 or 120.24</span></div></div></md-input-container><div flex layout=\"row\" \nlayout-align=\"center center\"><div><md-button class=\"md-red-500-bg\" \nng-click=\"vm.disabled==false ? vm.deleteDebt(vm.debt.debt_id) : \'\'\">Delete</md-button></div><div><md-button \nclass=\"md-primary\" ng-click=\"vm.cancel($event)\">Cancel</md-button></div><div><md-button class=\"md-green-500-bg branco\" \ntype=\"submit\" ng-click=\"vm.disabled==false ? insereProduto.$valid && vm.saveDebt(vm.debt) : \'\'\">Save</md-button></div>\n</div></form></div>");
$templateCache.put("app/templates/cards/finances/editexpenditure.html","<div flex class=\"products-box\" layout=\"column\" layout-align=\"start center\"><form name=\"insereProduto\" \nng-submit=\"submitForm(insereProduto.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.expenditure.expenditure_id\" \nng-init=\"vm.expenditure.expenditure_id=vm.expenditure.expenditure_id\"><h3>Edit Expenditure</h3><div layout=\"row\" \nclass=\"full-width\"><div flex=\"50\"><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Type</label>\n<md-select name=\"type\" ng-model=\"vm.expenditure.type\" ng-disabled=\"vm.disabled\"><md-option value=\"Service\">Service\n</md-option><md-option value=\"Material\">Material</md-option><md-option value=\"Consumable\">Consumable</md-option>\n<md-option value=\"Other\">Other</md-option></md-select></md-input-container></div><div flex=\"50\"><md-input-container \nflex layout=\"row\" class=\"full-width md-block\"><label>Supplier</label><input type=\"text\" name=\"supplier\" \nng-model=\"vm.expenditure.supplier\" ng-disabled=\"vm.disabled\"></md-input-container></div></div><md-input-container flex \nlayout=\"row\" class=\"full-width md-block\"><label>Description</label><input type=\"text\" name=\"description\" \nng-model=\"vm.expenditure.description\" ng-disabled=\"vm.disabled\"></md-input-container><div layout=\"row\" \nclass=\"full-width\"><div flex=\"33\"><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Invoice No.\n</label><input type=\"text\" name=\"invoice_number\" ng-model=\"vm.expenditure.invoice_number\" ng-disabled=\"vm.disabled\">\n</md-input-container></div><div flex=\"33\"><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>\nAmount</label><input type=\"text\" name=\"amount\" ng-model=\"vm.expenditure.amount\" ng-disabled=\"vm.disabled\" \nng-pattern=\"/^\\d{0,10}(\\.\\d{1,2})?$/\"><div ng-messages=\"insereProduto.amount.$error\" role=\"alert\"><div \nng-message=\"pattern\"><span>Please insert a valid amount: e.g. 120 or 120.24</span></div></div></md-input-container>\n</div><div flex><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>VAT Amount</label><input \ntype=\"text\" name=\"vat_amount\" ng-model=\"vm.expenditure.vat_amount\" ng-disabled=\"vm.disabled\" \nng-pattern=\"/^\\d{0,10}(\\.\\d{1,2})?$/\"><div ng-messages=\"insereProduto.vat_amount.$error\" role=\"alert\"><div \nng-message=\"pattern\"><span>Please insert a valid amount: e.g. 120 or 120.24</span></div></div></md-input-container>\n</div></div><div layout=\"row\" class=\"full-width\"><div flex=\"33\"><md-input-container flex layout=\"row\" \nclass=\"full-width md-block\" moment-picker=\"vm.expenditure.payment_date\" format=\"YYYY-MM-DD\" start-view=\"month\" \nautoclose=\"vm.autoclose\"><label>Payment Date</label><input class=\"form-control\" ng-model=\"vm.expenditure.payment_date\" \nng-disabled=\"vm.disabled\" ng-disabled=\"vm.disabled\"></md-input-container></div><div flex=\"45\"><md-input-container flex \nlayout=\"row\" class=\"full-width md-block\"><label>Payment Method</label><md-select name=\"payment_method\" \nng-model=\"vm.expenditure.payment_method\" ng-disabled=\"vm.disabled\"><md-option value=\"\">Select</md-option><md-option \nvalue=\"Bank Transfer\">Bank Transfer</md-option><md-option value=\"Credit Card\">Credit Card</md-option><md-option \nvalue=\"Cheque\">Cheque</md-option></md-select></md-input-container></div><div flex class=\"text-right\"><md-checkbox \nng-model=\"vm.expenditure.paid\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Paid\" ng-disabled=\"vm.disabled\">Paid\n</md-checkbox></div></div><div flex layout=\"row\" layout-align=\"center center\"><div><md-button class=\"md-red-500-bg\" \nng-click=\"vm.disabled==false ? vm.deleteExpenditure(vm.expenditure.expenditure_id) : \'\'\">Delete</md-button></div><div>\n<md-button class=\"md-primary\" ng-click=\"vm.cancel($event)\">Cancel</md-button></div><div><md-button \nclass=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"vm.disabled==false ? insereProduto.$valid && vm.saveExpenditure(vm.expenditure) : \'\'\">Save</md-button></div>\n</div></form></div>");
$templateCache.put("app/templates/cards/finances/editowed.html","<div flex class=\"products-box\" layout=\"column\" layout-align=\"start center\"><form name=\"insereProduto\" \nng-submit=\"submitForm(insereProduto.$valid)\" novalidate class=\"full-width\"><h3>Edit Owed</h3><div layout=\"row\" \nclass=\"full-width\"><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Current Debt</label><input \ntype=\"text\" name=\"current_debt\" ng-model=\"vm.owed.current_debt\" ng-disabled=\"vm.disabled\" \nng-pattern=\"/^\\d{0,10}(\\.\\d{1,2})?$/\"><div ng-messages=\"insereProduto.current_debt.$error\" role=\"alert\"><div \nng-message=\"pattern\"><span>Please insert a valid debt: e.g. 120 or 120.24</span></div></div></md-input-container></div>\n<md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Bad Debt</label><input type=\"text\" \nname=\"bad_debt\" ng-model=\"vm.owed.bad_debt\" ng-disabled=\"vm.disabled\" ng-pattern=\"/^\\d{0,10}(\\.\\d{1,2})?$/\"><div \nng-messages=\"insereProduto.bad_debt.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>\nPlease insert a valid debt: e.g. 120 or 120.24</span></div></div></md-input-container><div flex layout=\"row\" \nlayout-align=\"center center\"><div><md-button class=\"md-red-500-bg\" \nng-click=\"vm.disabled==false ? vm.deleteOwed(vm.owed.owed_id) : \'\'\">Delete</md-button></div><div><md-button \nclass=\"md-primary\" ng-click=\"vm.cancel($event)\">Cancel</md-button></div><div><md-button class=\"md-green-500-bg branco\" \ntype=\"submit\" ng-click=\"vm.disabled==false ? insereProduto.$valid && vm.saveOwed(vm.owed) : \'\'\">Save</md-button></div>\n</div></form></div>");
$templateCache.put("app/templates/cards/finances/editrevenue.html","<div flex class=\"products-box\" layout=\"column\" layout-align=\"start center\"><form name=\"insereProduto\" \nng-submit=\"submitForm(insereProduto.$valid)\" novalidate class=\"full-width\"><h3>Edit Revenue</h3><div layout=\"row\" \nclass=\"full-width\"><div flex=\"50\"><md-input-container flex layout=\"row\" class=\"full-width md-block\" \nmoment-picker=\"vm.revenue.start_period\" format=\"YYYY-MM-DD\" start-view=\"month\" autoclose=\"vm.autoclose\"><label>\nStart Date</label><input class=\"form-control\" ng-model=\"vm.revenue.start_period\" ng-disabled=\"vm.disabled\" \nng-disabled=\"vm.disabled\"></md-input-container></div><div flex><md-input-container flex layout=\"row\" \nclass=\"full-width md-block\" moment-picker=\"vm.revenue.end_period\" format=\"YYYY-MM-DD\" start-view=\"month\" \nautoclose=\"vm.autoclose\"><label>End Date</label><input class=\"form-control\" ng-model=\"vm.revenue.end_period\" \nng-disabled=\"vm.disabled\" ng-disabled=\"vm.disabled\"></md-input-container></div></div><md-input-container flex \nlayout=\"row\" class=\"full-width md-block\"><label>Revenue</label><input type=\"text\" name=\"revenue\" \nng-model=\"vm.revenue.revenue\" ng-disabled=\"vm.disabled\" ng-pattern=\"/^\\d{0,10}(\\.\\d{1,2})?$/\"><div \nng-messages=\"insereProduto.revenue.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>\nPlease insert a valid revenue: e.g. 120 or 120.24</span></div></div></md-input-container><div flex layout=\"row\" \nlayout-align=\"center center\"><div><md-button class=\"md-red-500-bg\" \nng-click=\"vm.disabled==false ? vm.deleteRevenue(vm.revenue.revenue_id) : \'\'\">Delete</md-button></div><div><md-button \nclass=\"md-primary\" ng-click=\"vm.cancel($event)\">Cancel</md-button></div><div><md-button class=\"md-green-500-bg branco\" \ntype=\"submit\" ng-click=\"vm.disabled==false ? insereProduto.$valid && vm.saveRevenue(vm.revenue) : \'\'\">Save</md-button>\n</div></div></form></div>");
$templateCache.put("app/templates/cards/finances/newbanking.html","<div flex class=\"products-box\" layout=\"column\" layout-align=\"start center\"><form name=\"insereProduto\" \nng-submit=\"submitForm(insereProduto.$valid)\" novalidate class=\"full-width\"><input type=\"hidden\" \nng-model=\"vm.banking.banking_id\" ng-init=\"vm.banking.banking_id=\'0\'\"><h3>New Banking</h3><div layout=\"row\" \nclass=\"full-width\"><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Account Number</label>\n<input type=\"text\" name=\"account_number\" ng-model=\"vm.banking.account_number\" ng-disabled=\"vm.disabled\">\n</md-input-container></div><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Account Name\n</label><input type=\"text\" name=\"account_name\" ng-model=\"vm.banking.account_name\" ng-disabled=\"vm.disabled\">\n</md-input-container><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Amount</label><input \ntype=\"text\" name=\"amount\" ng-model=\"vm.banking.amount\" ng-disabled=\"vm.disabled\" ng-pattern=\"/^\\d{0,10}(\\.\\d{1,2})?$/\">\n<div ng-messages=\"insereProduto.amount.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>\nPlease insert a valid amount: e.g. 120 or 120.24</span></div></div></md-input-container><div flex layout=\"row\" \nlayout-align=\"center center\"><div><md-button class=\"md-primary\" ng-click=\"vm.cancel($event)\">Cancel</md-button></div>\n<div><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"vm.disabled==false ? insereProduto.$valid && vm.saveBanking(vm.banking) : \'\'\">Save</md-button></div></div>\n</form></div>");
$templateCache.put("app/templates/cards/finances/newdebt.html","<div flex class=\"products-box\" layout=\"column\" layout-align=\"start center\"><form name=\"insereProduto\" \nng-submit=\"submitForm(insereProduto.$valid)\" novalidate class=\"full-width\"><input type=\"hidden\" \nng-model=\"vm.debt.debt_id\" ng-init=\"vm.debt.debt_id=\'0\'\"><h3>New Debt</h3><div layout=\"row\" class=\"full-width\">\n<md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Description</label><input type=\"text\" \nname=\"debt\" ng-model=\"vm.debt.description\" ng-disabled=\"vm.disabled\"></md-input-container></div><md-input-container \nflex layout=\"row\" class=\"full-width md-block\"><label>Debt</label><input type=\"text\" name=\"debt\" \nng-model=\"vm.debt.debt\" ng-disabled=\"vm.disabled\" ng-pattern=\"/^\\d{0,10}(\\.\\d{1,2})?$/\"><div \nng-messages=\"insereProduto.debt.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>\nPlease insert a valid debt: e.g. 120 or 120.24</span></div></div></md-input-container><div flex layout=\"row\" \nlayout-align=\"center center\"><div><md-button class=\"md-primary\" ng-click=\"vm.cancel($event)\">Cancel</md-button></div>\n<div><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"vm.disabled==false ? insereProduto.$valid && vm.saveDebt(vm.debt) : \'\'\">Save</md-button></div></div></form>\n</div>");
$templateCache.put("app/templates/cards/finances/newexpenditure.html","<div flex class=\"products-box\" layout=\"column\" layout-align=\"start center\"><form name=\"insereProduto\" \nng-submit=\"submitForm(insereProduto.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.expenditure.expenditure_id\" \nng-init=\"vm.expenditure.expenditure_id=\'0\'\"><h3>New Expenditure</h3><div layout=\"row\" class=\"full-width\"><div \nflex=\"50\"><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Type</label><md-select name=\"type\" \nng-model=\"vm.expenditure.type\" ng-disabled=\"vm.disabled\"><md-option value=\"Service\">Service</md-option><md-option \nvalue=\"Material\">Material</md-option><md-option value=\"Consumable\">Consumable</md-option><md-option value=\"Other\">Other\n</md-option></md-select></md-input-container></div><div flex=\"50\"><md-input-container flex layout=\"row\" \nclass=\"full-width md-block\"><label>Supplier</label><input type=\"text\" name=\"supplier\" \nng-model=\"vm.expenditure.supplier\" ng-disabled=\"vm.disabled\"></md-input-container></div></div><md-input-container flex \nlayout=\"row\" class=\"full-width md-block\"><label>Description</label><input type=\"text\" name=\"description\" \nng-model=\"vm.expenditure.description\" ng-disabled=\"vm.disabled\"></md-input-container><div layout=\"row\" \nclass=\"full-width\"><div flex=\"33\"><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Invoice No.\n</label><input type=\"text\" name=\"invoice_number\" ng-model=\"vm.expenditure.invoice_number\" ng-disabled=\"vm.disabled\">\n</md-input-container></div><div flex=\"33\"><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>\nAmount</label><input type=\"text\" name=\"amount\" ng-model=\"vm.expenditure.amount\" ng-disabled=\"vm.disabled\" \nng-pattern=\"/^\\d{0,10}(\\.\\d{1,2})?$/\"><div ng-messages=\"insereProduto.amount.$error\" role=\"alert\"><div \nng-message=\"pattern\"><span>Please insert a valid amount: e.g. 120 or 120.24</span></div></div></md-input-container>\n</div><div flex><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>VAT Amount</label><input \ntype=\"text\" name=\"vat_amount\" ng-model=\"vm.expenditure.vat_amount\" ng-disabled=\"vm.disabled\" \nng-pattern=\"/^\\d{0,10}(\\.\\d{1,2})?$/\"><div ng-messages=\"insereProduto.vat_amount.$error\" role=\"alert\"><div \nng-message=\"pattern\"><span>Please insert a valid amount: e.g. 120 or 120.24</span></div></div></md-input-container>\n</div></div><div layout=\"row\" class=\"full-width\"><div flex=\"33\"><md-input-container flex layout=\"row\" \nclass=\"full-width md-block\" moment-picker=\"vm.expenditure.payment_date\" format=\"YYYY-MM-DD\" start-view=\"month\" \nautoclose=\"vm.autoclose\"><label>Payment Date</label><input class=\"form-control\" ng-model=\"vm.expenditure.payment_date\" \nng-disabled=\"vm.disabled\" ng-disabled=\"vm.disabled\"></md-input-container></div><div flex=\"45\"><md-input-container flex \nlayout=\"row\" class=\"full-width md-block\"><label>Payment Method</label><md-select name=\"payment_method\" \nng-model=\"vm.expenditure.payment_method\" ng-disabled=\"vm.disabled\"><md-option value=\"Bank Transfer\">Bank Transfer\n</md-option><md-option value=\"Credit Card\">Credit Card</md-option><md-option value=\"Cheque\">Cheque</md-option>\n</md-select></md-input-container></div><div flex class=\"text-right\"><md-checkbox ng-model=\"vm.expenditure.paid\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Paid\" ng-disabled=\"vm.disabled\">Paid</md-checkbox></div></div><div \nflex layout=\"row\" layout-align=\"center center\"><div><md-button class=\"md-primary\" ng-click=\"vm.cancel($event)\">Cancel\n</md-button></div><div><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"vm.disabled==false ? insereProduto.$valid && vm.saveExpenditure(vm.expenditure) : \'\'\">Save</md-button></div>\n</div></form></div>");
$templateCache.put("app/templates/cards/finances/newowed.html","<div flex class=\"products-box\" layout=\"column\" layout-align=\"start center\"><form name=\"insereProduto\" \nng-submit=\"submitForm(insereProduto.$valid)\" novalidate class=\"full-width\"><input type=\"hidden\" \nng-model=\"vm.owed.owed_id\" ng-init=\"vm.owed.owed_id=\'0\'\"><h3>New Owed</h3><div layout=\"row\" class=\"full-width\">\n<md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Current Debt</label><input type=\"text\" \nname=\"current_debt\" ng-model=\"vm.owed.current_debt\" ng-disabled=\"vm.disabled\" ng-pattern=\"/^\\d{0,10}(\\.\\d{1,2})?$/\">\n<div ng-messages=\"insereProduto.current_debt.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>\nPlease insert a valid debt: e.g. 120 or 120.24</span></div></div></md-input-container></div><md-input-container flex \nlayout=\"row\" class=\"full-width md-block\"><label>Bad Debt</label><input type=\"text\" name=\"bad_debt\" \nng-model=\"vm.owed.bad_debt\" ng-disabled=\"vm.disabled\" ng-pattern=\"/^\\d{0,10}(\\.\\d{1,2})?$/\"><div \nng-messages=\"insereProduto.bad_debt.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>\nPlease insert a valid debt: e.g. 120 or 120.24</span></div></div></md-input-container><div flex layout=\"row\" \nlayout-align=\"center center\"><div><md-button class=\"md-primary\" ng-click=\"vm.cancel($event)\">Cancel</md-button></div>\n<div><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"vm.disabled==false ? insereProduto.$valid && vm.saveOwed(vm.owed) : \'\'\">Save</md-button></div></div></form>\n</div>");
$templateCache.put("app/templates/cards/finances/newrevenue.html","<div flex class=\"products-box\" layout=\"column\" layout-align=\"start center\"><form name=\"insereProduto\" \nng-submit=\"submitForm(insereProduto.$valid)\" novalidate class=\"full-width\"><input type=\"hidden\" \nng-model=\"vm.revenue.revenue_id\" ng-init=\"vm.revenue.revenue_id=\'0\'\"><h3>New Revenue</h3><div layout=\"row\" \nclass=\"full-width\"><div flex=\"50\"><md-input-container flex layout=\"row\" class=\"full-width md-block\" \nmoment-picker=\"vm.revenue.start_period\" format=\"YYYY-MM-DD\" start-view=\"month\" autoclose=\"vm.autoclose\"><label>\nStart Date</label><input class=\"form-control\" ng-model=\"vm.revenue.start_period\" ng-disabled=\"vm.disabled\" \nng-disabled=\"vm.disabled\"></md-input-container></div><div flex><md-input-container flex layout=\"row\" \nclass=\"full-width md-block\" moment-picker=\"vm.revenue.end_period\" format=\"YYYY-MM-DD\" start-view=\"month\" \nautoclose=\"vm.autoclose\"><label>End Date</label><input class=\"form-control\" ng-model=\"vm.revenue.end_period\" \nng-disabled=\"vm.disabled\" ng-disabled=\"vm.disabled\"></md-input-container></div></div><md-input-container flex \nlayout=\"row\" class=\"full-width md-block\"><label>Revenue</label><input type=\"text\" name=\"revenue\" \nng-model=\"vm.revenue.revenue\" ng-disabled=\"vm.disabled\" ng-pattern=\"/^\\d{0,10}(\\.\\d{1,2})?$/\"><div \nng-messages=\"insereProduto.revenue.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>\nPlease insert a valid revenue: e.g. 120 or 120.24</span></div></div></md-input-container><div flex layout=\"row\" \nlayout-align=\"center center\"><div><md-button class=\"md-primary\" ng-click=\"vm.cancel($event)\">Cancel</md-button></div>\n<div><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"vm.disabled==false ? insereProduto.$valid && vm.saveRevenue(vm.revenue) : \'\'\">Save</md-button></div></div>\n</form></div>");
$templateCache.put("app/templates/cards/holidays/editrequest.html","<div flex class=\"products-box\" layout=\"column\" layout-align=\"start center\"><form name=\"insereRequest\" \nng-submit=\"submitForm(insereRequest.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.request.holidays_id\"><div>\n<md-button class=\"md-raised\" mwl-date-modifier date=\"vm.viewDate\" ng-click=\"vm.requestEventos(vm.viewDate)\" \ndecrement=\"vm.calendarView\">Previous</md-button><md-button class=\"md-raised\" mwl-date-modifier date=\"vm.viewDate\" \nng-click=\"vm.requestEventos(vm.viewDate)\" set-to-today>Today</md-button><md-button class=\"md-raised\" mwl-date-modifier \ndate=\"vm.viewDate\" ng-click=\"vm.requestEventos(vm.viewDate)\" increment=\"vm.calendarView\">Next</md-button><h2>\n{{ vm.calendarTitle }}<div class=\"m-20 fetchingdates\" ng-if=\"vm.loading === true\">Fecthing dates... Please wait... <img\n src=\"assets/images/logos/ajax-loader.gif\" alt=\"loading\"></div><mwl-calendar ng-if=\"vm.loading === false\" \nview=\"vm.calendarView\" view-date=\"vm.viewDate\" events=\"vm.eventos\" view-title=\"vm.calendarTitle\" \ncell-auto-open-disabled=\"true\" cell-is-open=\"false\" on-view-change-click=\"vm.viewChangeClicked(calendarNextView)\">\n</mwl-calendar></h2></div><div class=\"m-20\"></div><md-input-container \nmd-is-error=\"insereRequest.managers_id.$invalid && (insereRequest.managers_id.$touched || insereRequest.$submitted)\" \nflex layout=\"row\" class=\"full-width md-block\"><label>Manager Name</label><md-select name=\"managers_id\" \nng-model=\"vm.request.manager_id\" required disabled=\"disabled\"><md-option ng-repeat=\"manager in vm.managers\" \nng-value=\"manager.id\" ng-selected=\"manager.id == \'{{vm.request.manager_id}}\'\">{{manager.name}}</md-option></md-select>\n<div ng-messages=\"insereRequest.managers_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease choose a manager.</span></div></div></md-input-container><div layout=\"row\" class=\"full-width\"><div flex=\"50\">\n<md-input-container flex class=\"md-block\" \nmd-is-error=\"recordForm.fromdate.$invalid && (recordForm.fromdate.$touched || recordForm.$submitted)\" \nmoment-picker=\"vm.request.from_request_date\" format=\"YYYY-MM-DD\" start-view=\"month\" autoclose=\"pctrl.autoclose\"><label>\nStart Date</label><input name=\"fromdate\" class=\"form-control\" ng-model=\"vm.request.from_request_date\" required \ndisabled=\"disabled\"><div ng-messages=\"recordForm.fromdate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease insert a start date.</span></div></div></md-input-container></div><div flex><md-input-container flex \nclass=\"md-block\" \nmd-is-error=\"recordForm.torequestdate.$invalid && (recordForm.torequestdate.$touched || recordForm.$submitted)\" \nmoment-picker=\"vm.request.to_request_date\" format=\"YYYY-MM-DD\" start-view=\"month\" \nmin-date=\"vm.request.from_request_date\" autoclose=\"pctrl.autoclose\"><label>End Date</label><input name=\"torequestdate\" \nclass=\"form-control\" ng-model=\"vm.request.to_request_date\" required disabled=\"disabled\"><div \nng-messages=\"recordForm.torequestdate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert an end date.\n</span></div></div></md-input-container></div></div><md-input-container flex class=\"md-block\"><label>User Name</label>\n<md-select name=\"techid\" ng-model=\"vm.request.name_id\" required disabled=\"disabled\"><md-option \nng-repeat=\"tech in vm.techs\" ng-value=\"tech.id\" ng-selected=\"tech.id == \'{{vm.userid}}\'\">{{tech.name}}</md-option>\n</md-select><div ng-messages=\"insereRequest.techid.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease choose a User.</span></div></div></md-input-container><h3>Comments</h3><div class=\"ordercomments-page\" \nlayout=\"column\" layout-align=\"start center\"><div class=\"full-width\" ng-repeat=\"comment in vm.comments\"><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"comment\">{{comment.comment}}</div></div><div layout=\"row\" \nlayout-align=\"end center\"><div class=\"user small mt10\">{{comment.name}}, {{comment.date}}</div></div><div \nclass=\"margem-divisoria\"></div></div><div class=\"full-width\" ng-if=\"vm.comments.length < 1\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"comment\">There are no comments.</div></div></div></div><div \nclass=\"row full-width\"><div class=\"full-width\" layout=\"row\" flex layout-align=\"start center\"><md-input-container flex \nmd-is-error=\"recordForm.comment.$invalid && (recordForm.comment.$touched || recordForm.$submitted)\"><label>Add Comment:\n</label><textarea rows=\"5\" name=\"comment\" ng-model=\"vm.request.comment\" ng-disabled=\"vm.disabled\"></textarea>\n</md-input-container></div></div><h3>Holiday Allowance</h3><div layout=\"row\" class=\"full-width\"><div flex=\"50\">\n{{vm.user_settings.allowance_days}} Days</div><div flex=\"50\"><span ng-if=\"vm.remainingcdays > 0\" style=\"color:green\">\n{{vm.remainingcdays}} Remaining Days</span> <span ng-if=\"vm.remainingcdays < 1\" style=\"color:red\">\n{{vm.remainingcdays}} Remaining Days</span> <span \nng-if=\"vm.remainingpdays > 0 && vm.remainingpdays < vm.user_settings.allowance_days\" \nstyle=\"color:green;font-size:smaller\"><br>(+ {{vm.remainingpdays}} from previous year)</span></div></div><div \nclass=\"m-20\"></div><div layout=\"row\" class=\"full-width\"><div flex=\"50\"><md-input-container flex class=\"md-block\" \nmoment-picker=\"vm.user_settings.month_start\" format=\"MMMM\" start-view=\"year\" autoclose=\"pctrl.autoclose\"><label>\nFrom Month</label><input class=\"form-control\" value=\"{{vm.user_settings.month_start| cmdate:\'MMMM\'}}\" \ndisabled=\"disabled\"></md-input-container></div><div flex><md-input-container flex class=\"md-block\" \nmoment-picker=\"vm.user_settings.month_finish\" format=\"MMMM\" start-view=\"year\" autoclose=\"pctrl.autoclose\"><label>\nTo Month</label><input class=\"form-control\" value=\"{{vm.user_settings.month_finish| cmdate:\'MMMM\'}}\" \ndisabled=\"disabled\"></md-input-container></div></div><h3>History</h3><div layout=\"row\"><div flex layout=\"column\"><div \nflex=\"100\" layout=\"row\"><div flex>Date (Current)</div><div flex=\"25\">Days</div></div><div class=\"m-5\"></div><div \nflex=\"100\" layout=\"row\" ng-repeat=\"datec in vm.holidayscurr\"><div flex>\n{{datec.from_request_date | cmdate:\'dd-MM-yyyy\'}} - {{datec.to_request_date | cmdate:\'dd-MM-yyyy\'}}</div><div \nflex=\"25\">{{datec.totaldays}} Days</div></div></div></div><div class=\"m-20\"></div><div layout=\"row\"><div flex \nlayout=\"column\"><div flex=\"100\" layout=\"row\"><div flex>Date (Previous)</div><div flex=\"25\">Days</div></div><div \nclass=\"m-5\"></div><div flex=\"100\" layout=\"row\" ng-repeat=\"datep in vm.holidaysprev\"><div flex>\n{{datep.from_request_date | cmdate:\'dd-MM-yyyy\'}} - {{datep.to_request_date | cmdate:\'dd-MM-yyyy\'}}</div><div \nflex=\"25\">{{datep.totaldays}} Days</div></div></div></div><div flex layout=\"row\" layout-align=\"center center\" \nclass=\"md-padding\"><div><md-button class=\"md-primary\" ng-click=\"vm.cancel($event)\">Cancel</md-button></div><div>\n<md-button ng-if=\"vm.admin == 1 || vm.manage == 1 || vm.levelid < 3\" class=\"md-red-500-bg branco\" \nng-click=\"vm.disabled==false ? vm.approveDecline(vm.request.holidays_id, 0, vm.request.comment) : \'\'\">Decline Request\n</md-button></div><div><md-button ng-if=\"vm.admin == 1 || vm.manage == 1 || vm.levelid < 3\" \nclass=\"md-green-500-bg branco\" \nng-click=\"vm.disabled==false ? vm.approveDecline(vm.request.holidays_id, 1, vm.request.comment) : \'\'\">Approve Request\n</md-button></div></div></form></div>");
$templateCache.put("app/templates/cards/holidays/newrequest.html","<div flex class=\"products-box\" layout=\"column\" layout-align=\"start center\"><form name=\"insereRequest\" \nng-submit=\"submitForm(insereRequest.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.request.holidays_id\" \nng-init=\"vm.request.holidays_id=\'0\'\"><div><md-button class=\"md-raised\" mwl-date-modifier date=\"vm.viewDate\" \nng-click=\"vm.requestEventos(vm.viewDate)\" decrement=\"vm.calendarView\">Previous</md-button><md-button class=\"md-raised\" \nmwl-date-modifier date=\"vm.viewDate\" ng-click=\"vm.requestEventos(vm.viewDate)\" set-to-today>Today</md-button><md-button\n class=\"md-raised\" mwl-date-modifier date=\"vm.viewDate\" ng-click=\"vm.requestEventos(vm.viewDate)\" \nincrement=\"vm.calendarView\">Next</md-button><h2>{{ vm.calendarTitle }}</h2><div class=\"m-20 fetchingdates\" \nng-if=\"vm.loading === true\">Fecthing dates... Please wait... <img src=\"assets/images/logos/ajax-loader.gif\" \nalt=\"loading\"></div><mwl-calendar ng-if=\"vm.loading === false\" view=\"vm.calendarView\" view-date=\"vm.viewDate\" \nevents=\"vm.eventos\" view-title=\"vm.calendarTitle\" cell-auto-open-disabled=\"true\" cell-is-open=\"false\" \non-view-change-click=\"vm.viewChangeClicked(calendarNextView)\"></mwl-calendar></div><div class=\"m-20\"></div>\n<md-input-container \nmd-is-error=\"insereRequest.managers_id.$invalid && (insereRequest.managers_id.$touched || insereRequest.$submitted)\" \nflex layout=\"row\" class=\"full-width md-block\"><label>Manager Name</label><md-select name=\"managers_id\" \nng-model=\"vm.request.manager_id\" required><md-option ng-repeat=\"manager in vm.managers\" ng-value=\"manager.id\">\n{{manager.name}}</md-option></md-select><div ng-messages=\"insereRequest.managers_id.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Please choose a manager.</span></div></div></md-input-container><div layout=\"row\" \nclass=\"full-width\"><div flex=\"50\"><md-input-container flex class=\"md-block\" \nmd-is-error=\"recordForm.fromdate.$invalid && (recordForm.fromdate.$touched || recordForm.$submitted)\" \nmoment-picker=\"vm.request.from_request_date\" format=\"YYYY-MM-DD\" start-view=\"month\" autoclose=\"pctrl.autoclose\"><label>\nStart Date</label><input name=\"fromdate\" class=\"form-control\" ng-model=\"vm.request.from_request_date\" required><div \nng-messages=\"recordForm.fromdate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert a start date.\n</span></div></div></md-input-container></div><div flex><md-input-container flex class=\"md-block\" \nmd-is-error=\"recordForm.torequestdate.$invalid && (recordForm.torequestdate.$touched || recordForm.$submitted)\" \nmoment-picker=\"vm.request.to_request_date\" format=\"YYYY-MM-DD\" start-view=\"month\" \nmin-date=\"vm.request.from_request_date\" autoclose=\"pctrl.autoclose\"><label>End Date</label><input name=\"torequestdate\" \nclass=\"form-control\" ng-model=\"vm.request.to_request_date\" required><div ng-messages=\"recordForm.torequestdate.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Please insert an end date.</span></div></div></md-input-container></div>\n</div><md-input-container flex class=\"md-block\"><label>User Name</label><md-select name=\"techid\" \nng-model=\"vm.request.name_id\" required disabled=\"disabled\"><md-option ng-repeat=\"tech in vm.techs\" ng-value=\"tech.id\" \nng-selected=\"tech.id == \'{{vm.userid}}\'\">{{tech.name}}</md-option></md-select><div \nng-messages=\"insereRequest.techid.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please choose a User.</span>\n</div></div></md-input-container><h3>Comments</h3><div class=\"row full-width\"><div class=\"full-width\" layout=\"row\" \nflex layout-align=\"start center\"><md-input-container flex \nmd-is-error=\"recordForm.comment.$invalid && (recordForm.comment.$touched || recordForm.$submitted)\"><label>Add Comment:\n</label><textarea rows=\"5\" name=\"comment\" ng-model=\"vm.request.comment\" ng-disabled=\"vm.disabled\"></textarea>\n</md-input-container></div></div><h3>Holiday Allowance</h3><div layout=\"row\" class=\"full-width\"><div flex=\"50\">\n{{vm.user_settings.allowance_days}} Days</div><div flex=\"50\"><span ng-if=\"vm.remainingcdays > 0\" style=\"color:green\">\n{{vm.remainingcdays}} Remaining Days</span> <span ng-if=\"vm.remainingcdays < 1\" style=\"color:red\">\n{{vm.remainingcdays}} Remaining Days</span> <span \nng-if=\"vm.remainingpdays > 0 && vm.remainingpdays < vm.user_settings.allowance_days\" \nstyle=\"color:green;font-size:smaller\"><br>(+ {{vm.remainingpdays}} from previous year)</span></div></div><div \nclass=\"m-20\"></div><div layout=\"row\" class=\"full-width\"><div flex=\"50\"><md-input-container flex class=\"md-block\" \nmoment-picker=\"vm.user_settings.month_start\" format=\"MMMM\" start-view=\"year\" autoclose=\"pctrl.autoclose\"><label>\nFrom Month</label><input class=\"form-control\" value=\"{{vm.user_settings.month_start| cmdate:\'MMMM\'}}\" \ndisabled=\"disabled\"></md-input-container></div><div flex><md-input-container flex class=\"md-block\" \nmoment-picker=\"vm.user_settings.month_finish\" format=\"MMMM\" start-view=\"year\" autoclose=\"pctrl.autoclose\"><label>\nTo Month</label><input class=\"form-control\" value=\"{{vm.user_settings.month_finish| cmdate:\'MMMM\'}}\" \ndisabled=\"disabled\"></md-input-container></div></div><h3>History</h3><div layout=\"row\"><div flex layout=\"column\"><div \nflex=\"100\" layout=\"row\"><div flex>Date (Current)</div><div flex=\"25\">Days</div></div><div class=\"m-5\"></div><div \nflex=\"100\" layout=\"row\" ng-repeat=\"datec in vm.holidayscurr\"><div flex>\n{{datec.from_request_date | cmdate:\'dd-MM-yyyy\'}} - {{datec.to_request_date | cmdate:\'dd-MM-yyyy\'}}</div><div \nflex=\"25\">{{datec.totaldays}} Days</div></div></div></div><div class=\"m-20\"></div><div layout=\"row\"><div flex \nlayout=\"column\"><div flex=\"100\" layout=\"row\"><div flex>Date (Previous)</div><div flex=\"25\">Days</div></div><div \nclass=\"m-5\"></div><div flex=\"100\" layout=\"row\" ng-repeat=\"datep in vm.holidaysprev\"><div flex>\n{{datep.from_request_date | cmdate:\'dd-MM-yyyy\'}} - {{datep.to_request_date | cmdate:\'dd-MM-yyyy\'}}</div><div \nflex=\"25\">{{datep.totaldays}} Days</div></div></div></div><div flex layout=\"row\" layout-align=\"center center\" \nclass=\"md-padding\"><div><md-button class=\"md-primary\" ng-click=\"vm.cancel($event)\">Cancel</md-button></div><div>\n<md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"vm.disabled==false ? insereRequest.$valid && vm.saveNewRequest(vm.request) : \'\'\">Send Holiday Request\n</md-button></div></div></form></div>");
$templateCache.put("app/templates/cards/marketing/newevent.html","<div flex class=\"products-box\" layout=\"column\"><form name=\"insereMarketing\" \nng-submit=\"submitForm(insereMarketing.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.marketing.marketing_id\" \nng-init=\"vm.marketing.marketing_id=\'0\'\"> <input type=\"hidden\" ng-model=\"vm.marketing.section\" \nng-init=\"vm.marketing.section=\'1\'\"> <input type=\"hidden\" ng-model=\"vm.marketing.created_by\" \nng-init=\"vm.marketing.created_by=vm.userid\"><h3>New</h3><div layout=\"row\" layout-align=\"left center \">\n<md-input-container \nmd-is-error=\"insereMarketing.type.$invalid && (insereMarketing.type.$touched || insereMarketing.$submitted)\" flex=\"70\" \nclass=\"padding-top-10 padding-left-5\"><md-select name=\"type\" ng-model=\"vm.marketing.type\" placeholder=\"Type *\" \nrequired><md-option value=\"1\">Event</md-option><md-option value=\"2\">Task</md-option></md-select><div \nng-messages=\"insereMarketing.type.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please choose a type.</span>\n</div></div></md-input-container><md-input-container flex=\"40\"><md-checkbox ng-model=\"vm.marketing.completed\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"completed\">Completed</md-checkbox></md-input-container></div>\n<md-input-container \nmd-is-error=\"insereMarketing.name.$invalid && (insereMarketing.name.$touched || insereMarketing.$submitted)\" flex \nlayout=\"row\" class=\"full-width md-block\"><label>Name</label><input type=\"text\" name=\"name\" \nng-model=\"vm.marketing.name\" required><div ng-messages=\"insereMarketing.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Please insert a name.</span></div></div></md-input-container><div class=\"padding-bottom-5\">\n<md-input-container flex layout=\"row\" class=\"md-block\" moment-picker=\"vm.marketing.start_date\" \nformat=\"YYYY-MM-DD HH:mm\" start-view=\"month\" autoclose=\"vm.autoclose\"><label>From Date</label><input \nclass=\"form-control\" ng-model=\"vm.marketing.start_date\" required></md-input-container><md-input-container flex \nlayout=\"row\" class=\"md-block\" moment-picker=\"vm.marketing.end_date\" format=\"YYYY-MM-DD HH:mm\" start-view=\"month\" \nautoclose=\"vm.autoclose\" min-date=\"vm.marketing.start_date\"><label>To Date</label><input class=\"form-control\" \nng-model=\"vm.marketing.end_date\" required></md-input-container></div><p>Location</p><md-input-container flex \nlayout=\"row\" class=\"full-width md-block\"><label>Line 1</label><input type=\"text\" name=\"address_1\" \nng-model=\"vm.marketing.address_1\"></md-input-container><md-input-container flex layout=\"row\" \nclass=\"full-width md-block\"><label>Line 2</label><input type=\"text\" name=\"address_2\" ng-model=\"vm.marketing.address_2\">\n</md-input-container><div layout=\"row\"><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>\nTown / City</label><input type=\"text\" name=\"city\" ng-model=\"vm.marketing.city\"></md-input-container><md-input-container\n flex layout=\"row\" class=\"full-width md-block\"><label>County</label><input type=\"text\" name=\"county\" \nng-model=\"vm.marketing.county\"></md-input-container></div><div layout=\"row\"><md-input-container flex layout=\"row\" \nclass=\"full-width md-block\"><label>Postcode</label><input type=\"text\" name=\"postcode\" ng-model=\"vm.marketing.postcode\">\n</md-input-container><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Country</label><input \ntype=\"text\" name=\"country\" ng-model=\"vm.marketing.country\"></md-input-container></div><p>Invite</p><div layout=\"row\">\n<md-input-container flex=\"80\"><label>Enter Email</label><input type=\"text\" name=\"email\" \nng-pattern=\"/^[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\\.[a-zA-Z]{2,4}$/\" ng-model=\"vm.novoemail\" \nng-keyup=\"($event.keyCode == 13 && !insereMarketing.email.$invalid && vm.novoemail) ? vm.addEmail(0) : null\"><md-hint \nclass=\"hint\" ng-if=\"(!insereMarketing.email.$invalid && vm.novoemail)\">\nPress enter or click on right button to add e-mail.</md-hint><div ng-messages=\"insereMarketing.email.$error\" \nrole=\"alert\"><div ng-message=\"pattern\"><span>Please insert a valid e-mail.</span></div></div></md-input-container>\n<md-button><md-icon ng-if=\"vm.novoemail\" class=\"icon-plus font-size-20\" flex aria-hidden=\"true\" \nng-click=\"vm.addEmail(0)\"></md-icon></md-button></div><div layout=\"row\"><ul class=\"email-list\"><li \nng-repeat=\"item in vm.emails\"><a href=\"#\" ng-click=\"vm.deleteInviteEmail(item)\" title=\"Delete Invite E-mail\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s20 md-font\" aria-hidden=\"true\" aria-label=\"Remove Invite Email\"></md-icon></a>\n{{item}}</li></ul></div><div layout=\"row\"><md-input-container flex class=\"md-block\"><label>Description</label><textarea\n md-maxlength=\"150\" rows=\"5\" md-select-on-focus ng-model=\"vm.marketing.description\"></textarea></md-input-container>\n</div><div flex layout=\"row\" layout-align=\"center center\"><div><md-button class=\"md-primary\" \nng-click=\"vm.cancel($event)\">Cancel</md-button></div><div><md-button class=\"md-green-500-bg branco\" \nng-click=\"insereMarketing.$valid && vm.saveMarketing(vm.marketing)\">Save</md-button></div></div></form></div>");
$templateCache.put("app/templates/cards/marketing/neweventrd.html","<div flex class=\"products-box\" layout=\"column\"><form name=\"insereMarketing\" \nng-submit=\"submitForm(insereMarketing.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.marketing.marketing_id\" \nng-init=\"vm.marketing.marketing_id=\'0\'\"> <input type=\"hidden\" ng-model=\"vm.marketing.section\" \nng-init=\"vm.marketing.section=\'2\'\"> <input type=\"hidden\" ng-model=\"vm.marketing.created_by\" \nng-init=\"vm.marketing.created_by=vm.userid\"><h3>New</h3><div layout=\"row\" layout-align=\"left center \">\n<md-input-container \nmd-is-error=\"insereMarketing.type.$invalid && (insereMarketing.type.$touched || insereMarketing.$submitted)\" flex=\"70\" \nclass=\"padding-top-10 padding-left-5\"><md-select name=\"type\" ng-model=\"vm.marketing.type\" placeholder=\"Type *\" \nrequired><md-option value=\"1\">Event</md-option><md-option value=\"2\">Task</md-option></md-select><div \nng-messages=\"insereMarketing.type.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please choose a type.</span>\n</div></div></md-input-container><md-input-container flex=\"40\"><md-checkbox ng-model=\"vm.marketing.completed\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"completed\">Completed</md-checkbox></md-input-container></div>\n<md-input-container \nmd-is-error=\"insereMarketing.name.$invalid && (insereMarketing.name.$touched || insereMarketing.$submitted)\" flex \nlayout=\"row\" class=\"full-width md-block\"><label>Name</label><input type=\"text\" name=\"name\" \nng-model=\"vm.marketing.name\" required><div ng-messages=\"insereMarketing.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Please insert a name.</span></div></div></md-input-container><div class=\"padding-bottom-5\">\n<md-input-container flex layout=\"row\" class=\"md-block\" moment-picker=\"vm.marketing.start_date\" \nformat=\"YYYY-MM-DD HH:mm\" start-view=\"month\" autoclose=\"vm.autoclose\"><label>From Date</label><input \nclass=\"form-control\" ng-model=\"vm.marketing.start_date\" required></md-input-container><md-input-container flex \nlayout=\"row\" class=\"md-block\" moment-picker=\"vm.marketing.end_date\" format=\"YYYY-MM-DD HH:mm\" start-view=\"month\" \nautoclose=\"vm.autoclose\" min-date=\"vm.marketing.start_date\"><label>To Date</label><input class=\"form-control\" \nng-model=\"vm.marketing.end_date\" required></md-input-container></div><p>Location</p><md-input-container flex \nlayout=\"row\" class=\"full-width md-block\"><label>Line 1</label><input type=\"text\" name=\"address_1\" \nng-model=\"vm.marketing.address_1\"></md-input-container><md-input-container flex layout=\"row\" \nclass=\"full-width md-block\"><label>Line 2</label><input type=\"text\" name=\"address_2\" ng-model=\"vm.marketing.address_2\">\n</md-input-container><div layout=\"row\"><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>\nTown / City</label><input type=\"text\" name=\"city\" ng-model=\"vm.marketing.city\"></md-input-container><md-input-container\n flex layout=\"row\" class=\"full-width md-block\"><label>County</label><input type=\"text\" name=\"county\" \nng-model=\"vm.marketing.county\"></md-input-container></div><div layout=\"row\"><md-input-container flex layout=\"row\" \nclass=\"full-width md-block\"><label>Postcode</label><input type=\"text\" name=\"postcode\" ng-model=\"vm.marketing.postcode\">\n</md-input-container><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Country</label><input \ntype=\"text\" name=\"country\" ng-model=\"vm.marketing.country\"></md-input-container></div><p>Invite</p><div layout=\"row\">\n<md-input-container flex=\"80\"><label>Enter Email</label><input type=\"text\" name=\"email\" \nng-pattern=\"/^[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\\.[a-zA-Z]{2,4}$/\" ng-model=\"vm.novoemail\" \nng-keyup=\"($event.keyCode == 13 && !insereMarketing.email.$invalid && vm.novoemail) ? vm.addEmail(0) : null\"><md-hint \nclass=\"hint\" ng-if=\"(!insereMarketing.email.$invalid && vm.novoemail)\">\nPress enter or click on right button to add e-mail.</md-hint><div ng-messages=\"insereMarketing.email.$error\" \nrole=\"alert\"><div ng-message=\"pattern\"><span>Please insert a valid e-mail.</span></div></div></md-input-container>\n<md-button><md-icon ng-if=\"vm.novoemail\" class=\"icon-plus font-size-20\" flex aria-hidden=\"true\" \nng-click=\"vm.addEmail(0)\"></md-icon></md-button></div><div layout=\"row\"><ul class=\"email-list\"><li \nng-repeat=\"item in vm.emails\"><a href=\"#\" ng-click=\"vm.deleteInviteEmail(item)\" title=\"Delete Invite E-mail\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s20 md-font\" aria-hidden=\"true\" aria-label=\"Remove Invite Email\"></md-icon></a>\n{{item}}</li></ul></div><div layout=\"row\"><md-input-container flex class=\"md-block\"><label>Description</label><textarea\n md-maxlength=\"150\" rows=\"5\" md-select-on-focus ng-model=\"vm.marketing.description\"></textarea></md-input-container>\n</div><div flex layout=\"row\" layout-align=\"center center\"><div><md-button class=\"md-primary\" \nng-click=\"vm.cancel($event)\">Cancel</md-button></div><div><md-button class=\"md-green-500-bg branco\" \nng-click=\"insereMarketing.$valid && vm.saveMarketing(vm.marketing)\">Save</md-button></div></div></form></div>");
$templateCache.put("app/templates/cards/members/editmember.html","<div flex class=\"delivery-box member-card\" layout=\"column\" layout-align=\"start center\"><form name=\"insereGrupo\" \nng-submit=\"submitForm(insereGrupo.$valid)\" novalidate><div layout=\"row\" class=\"user-row\"><div layout=\"row\" flex=\"50\">\n<h3>Edit User</h3></div><div layout=\"row\" flex=\"50\"><md-checkbox class=\"correct-upper\" ng-model=\"vm.member.active\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Active\"><label>Active</label></md-checkbox></div></div><div \nlayout=\"row\"><div layout=\"row\" flex=\"50\"><md-button class=\"md-primary md-raised mini-button\">Print ID Card</md-button>\n</div><div layout=\"row\" flex=\"50\"><md-button class=\"md-red-500-bg branco md-raised mini-button\" \nng-click=\"vm.deleteMember($event, vm.member.id)\">Delete User</md-button></div></div><md-input-container layout=\"row\" \nflex md-is-error=\"insereGrupo.code.$invalid && (insereGrupo.code.$touched || insereGrupo.$submitted)\" layout=\"row\" \nclass=\"full-width md-block\"><label>Code</label><input name=\"code\" type=\"text\" ng-model=\"vm.member.code\" required><div \nng-messages=\"insereGrupo.code.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert a member code.</span>\n</div></div></md-input-container><md-input-container \nmd-is-error=\"insereGrupo.name.$invalid && (insereGrupo.name.$touched || insereGrupo.$submitted)\" flex layout=\"row\" \nclass=\"full-width md-block\"><label>Name</label><input name=\"name\" type=\"text\" ng-model=\"vm.member.name\" required><div \nng-messages=\"insereGrupo.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert a member name.</span>\n</div></div></md-input-container><div layout=\"row\"><md-input-container \nmd-is-error=\"insereGrupo.jobtitle.$invalid && (insereGrupo.jobtitle.$touched || insereGrupo.$submitted)\" flex \nlayout=\"row\" class=\"full-width md-block\"><label>Job Title</label><input name=\"jobtitle\" type=\"text\" \nng-model=\"vm.member.jobtitle\" required><div ng-messages=\"insereGrupo.jobtitle.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Please insert a member job title.</span></div></div></md-input-container></div><div \nlayout=\"row\" flex><md-input-container \nmd-is-error=\"insereGrupo.username.$invalid && (insereGrupo.username.$touched || insereGrupo.$submitted)\" flex \nlayout=\"row\" class=\"md-block\"><label>E-mail</label><input name=\"username\" type=\"text\" ng-model=\"vm.member.username\" \nrequired ng-pattern=\"/^[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\\.[a-zA-Z]{2,4}$/\"><div \nng-messages=\"insereGrupo.username.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert a member e-mail.\n</span></div><div ng-message=\"pattern\"><span>Please insert a valid e-mail.</span></div></div></md-input-container>\n</div><div layout=\"row\" flex><md-input-container flex layout=\"row\" class=\"md-block\"><label>\nPassword (only if you want to change it)</label><input name=\"password\" type=\"password\" ng-model=\"vm.member.password\">\n</md-input-container></div><div flex layout=\"row\" layout-align=\"center center\"><md-checkbox \nng-if=\"vm.member.password != \'\'\" ng-model=\"vm.member.sendemail\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Send E-mail\"><label>Send e-mail with login details?</label></md-checkbox></div><md-input-container flex \nlayout=\"row\" class=\"full-width md-block\" \nmd-is-error=\"insereGrupo.levels_id.$invalid && (insereGrupo.deliveryroutes_id.$touched || insereGrupo.$submitted)\">\n<label>User Level</label><md-select name=\"levels_id\" ng-model=\"vm.member.levels_id\"><md-option value=\"1\">Administrator\n</md-option><md-option value=\"2\">Manager</md-option><md-option value=\"3\">NT User</md-option></md-select><div \nng-messages=\"insereGrupo.levels_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please choose a level</span>\n</div></div></md-input-container><div flex layout=\"row\" layout-align=\"center center\"><md-checkbox \nng-model=\"vm.member.admin\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Admin\" \nng-change=\"vm.member.admin==\'1\' ? vm.member.manage=\'0\' : \'\'\"><label>Admin</label></md-checkbox><md-checkbox \nng-model=\"vm.member.manage\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Manage\" \nng-change=\"vm.member.manage==\'1\' ? vm.member.admin=\'0\' : \'\'\"><label>Manage</label></md-checkbox></div><div \nlayout=\"row\" layout-align=\"center center\"><label>Profile</label></div><div layout=\"row\" layout-align=\"center center\">\n<div class=\"user-profile\"><md-icon ng-if=\"!vm.pic\" ng-click=\"vm.openPopup($event, \'addpic\')\" \nmd-font-icon=\"icon-account-box\" class=\"s106 pointer profile-img md-font material-icons icon-account-box\" \naria-hidden=\"true\"></md-icon><img ng-if=\"vm.pic\" ng-click=\"vm.openPopup($event, \'addpic\')\" class=\"profile-pic pointer\" \nhttp-src=\"{{vm.baseurl}}/api/Dlfile?type=profile&name={{vm.pic}}\" width=\"110\" height=\"130\"></div></div><div \nlayout=\"row\" layout-align=\"center center\"><md-button layout=\"row\" class=\"md-primary md-raised mini-button\" \nng-click=\"vm.openPopup($event, \'addpic\')\"><span ng-if=\"!vm.pic\">Add Picture</span><span ng-if=\"vm.pic\">Replace Picture\n</span></md-button></div><div layout=\"row\" layout-align=\"center center\"><md-input-container flex><label>Work Schedule\n</label><md-select class=\"full-width\" name=\"workschedule\" ng-model=\"vm.member.workschedule\" multiple=\"true\"><md-option \nvalue=\"1\">Monday</md-option><md-option value=\"2\">Tuesday</md-option><md-option value=\"3\">Wednesday</md-option>\n<md-option value=\"4\">Thursday</md-option><md-option value=\"5\">Friday</md-option><md-option value=\"6\">Saturday\n</md-option><md-option value=\"7\">Sunday</md-option></md-select></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><div layout=\"row\" flex=\"50\" layout-align=\"center center\"><md-button \nng-if=\"vm.admin == \'1\' || vm.levelid == \'1\'\" layout=\"row\" class=\"md-primary md-raised mini-button\" \nng-click=\"vm.openPopup($event, \'holidays\')\">Holidays</md-button></div><div layout=\"row\" flex=\"50\" \nlayout-align=\"center center\"><md-button ng-if=\"vm.admin == \'1\' || vm.levelid == \'1\'\" layout=\"row\" \nclass=\"md-primary md-raised mini-button\" ng-click=\"vm.openPopup($event, \'userprivileges\')\">User Privileges</md-button>\n</div></div><div flex layout=\"row\" layout-align=\"center center\"><div><md-button class=\"md-primary\" \nng-click=\"vm.cancel()\">Cancel</md-button></div><div><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"vm.disabled == false ? insereGrupo.$valid && vm.saveMember(vm.member) : \'\'\">Save</md-button></div></div>\n</form></div>");
$templateCache.put("app/templates/cards/members/newmember.html","<div flex class=\"delivery-box member-card\" layout=\"column\" layout-align=\"start center\"><form name=\"insereGrupo\" \nclass=\"full-width\" ng-submit=\"submitForm(insereGrupo.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.member.id\" \nng-init=\"vm.member.id=0\"><div layout=\"row\" class=\"user-row\"><div layout=\"row\" flex=\"50\"><h3>New User</h3></div><div \nlayout=\"row\" flex=\"50\"><md-checkbox class=\"correct-upper\" ng-model=\"vm.member.active\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Active\"><label>Active</label></md-checkbox></div></div><md-input-container layout=\"row\" \nflex md-is-error=\"insereGrupo.code.$invalid && (insereGrupo.code.$touched || insereGrupo.$submitted)\" layout=\"row\" \nclass=\"full-width md-block\"><label>Code</label><input name=\"code\" type=\"text\" ng-model=\"vm.member.code\" required><div \nng-messages=\"insereGrupo.code.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert a member code.</span>\n</div></div></md-input-container><md-input-container \nmd-is-error=\"insereGrupo.name.$invalid && (insereGrupo.name.$touched || insereGrupo.$submitted)\" flex layout=\"row\" \nclass=\"full-width md-block\"><label>Name</label><input name=\"name\" type=\"text\" ng-model=\"vm.member.name\" required><div \nng-messages=\"insereGrupo.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert a member name.</span>\n</div></div></md-input-container><div layout=\"row\"><md-input-container \nmd-is-error=\"insereGrupo.jobtitle.$invalid && (insereGrupo.jobtitle.$touched || insereGrupo.$submitted)\" flex \nlayout=\"row\" class=\"full-width md-block\"><label>Job Title</label><input name=\"jobtitle\" type=\"text\" \nng-model=\"vm.member.jobtitle\" required><div ng-messages=\"insereGrupo.jobtitle.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Please insert a member job title.</span></div></div></md-input-container></div><div \nlayout=\"row\" flex><md-input-container \nmd-is-error=\"insereGrupo.username.$invalid && (insereGrupo.username.$touched || insereGrupo.$submitted)\" flex \nlayout=\"row\" class=\"md-block\"><label>E-mail</label><input name=\"username\" type=\"text\" ng-model=\"vm.member.username\" \nrequired ng-pattern=\"/^[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\\.[a-zA-Z]{2,4}$/\"><div \nng-messages=\"insereGrupo.username.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert a member e-mail.\n</span></div><div ng-message=\"pattern\"><span>Please insert a valid e-mail.</span></div></div></md-input-container>\n</div><div layout=\"row\" flex><md-input-container \nmd-is-error=\"insereGrupo.password.$invalid && (insereGrupo.password.$touched || insereGrupo.$submitted)\" flex \nlayout=\"row\" class=\"md-block\"><label>Password</label><input name=\"password\" type=\"password\" \nng-model=\"vm.member.password\" required><div ng-messages=\"insereGrupo.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Please insert a member password.</span></div></div></md-input-container></div><div flex \nlayout=\"row\" layout-align=\"center center\"><md-checkbox ng-model=\"vm.member.sendemail\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Send E-mail\"><label>Send e-mail with login details?</label></md-checkbox></div>\n<md-input-container flex layout=\"row\" class=\"full-width md-block\" \nmd-is-error=\"insereGrupo.levels_id.$invalid && (insereGrupo.levels_id.$touched || insereGrupo.$submitted)\"><label>\nUser Level</label><md-select name=\"levels_id\" ng-model=\"vm.member.levels_id\"><md-option value=\"1\">Administrator\n</md-option><md-option value=\"2\">Manager</md-option><md-option value=\"3\">NT User</md-option></md-select><div \nng-messages=\"insereGrupo.levels_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please choose a level</span>\n</div></div></md-input-container><div flex layout=\"row\" layout-align=\"center center\"><md-checkbox \nng-model=\"vm.member.admin\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Admin\" \nng-change=\"vm.member.admin==\'1\' ? vm.member.manage=\'0\' : \'\'\"><label>Admin</label></md-checkbox><md-checkbox \nng-model=\"vm.member.manage\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Manage\" \nng-change=\"vm.member.manage==\'1\' ? vm.member.admin=\'0\' : \'\'\"><label>Manage</label></md-checkbox></div><div \nlayout=\"row\" layout-align=\"center center\"><label>Profile</label></div><div layout=\"row\" layout-align=\"center center\">\n<div class=\"user-profile\"><md-icon ng-click=\"vm.openPopup($event, \'addpic\')\" md-font-icon=\"icon-account-box\" \nclass=\"s106 profile-img md-font material-icons icon-account-box\" aria-hidden=\"true\"></md-icon></div></div><div \nlayout=\"row\" layout-align=\"center center\"><md-button ng-click=\"vm.openPopup($event, \'addpic\')\" layout=\"row\" \nclass=\"pointer md-primary md-raised mini-button\">Add Image</md-button></div><div layout=\"row\" \nlayout-align=\"center center\"><md-input-container flex><label>Work Schedule</label><md-select class=\"full-width\" \nname=\"workschedule\" ng-model=\"vm.member.workschedule\" multiple=\"true\"><md-option value=\"1\">Monday</md-option><md-option\n value=\"2\">Tuesday</md-option><md-option value=\"3\">Wednesday</md-option><md-option value=\"4\">Thursday</md-option>\n<md-option value=\"5\">Friday</md-option><md-option value=\"6\">Saturday</md-option><md-option value=\"7\">Sunday</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><div layout=\"row\" flex=\"50\" \nlayout-align=\"center center\"><md-button layout=\"row\" class=\"md-primary md-raised mini-button\" \nng-click=\"vm.openPopup($event, \'holidays\')\">Holidays</md-button></div><div layout=\"row\" flex=\"50\" \nlayout-align=\"center center\"><md-button layout=\"row\" class=\"md-primary md-raised mini-button\" \nng-click=\"vm.openPopup($event, \'userprivileges\')\">User Privileges</md-button></div></div><div flex layout=\"row\" \nlayout-align=\"center center\"><div><md-button class=\"md-primary\" ng-click=\"vm.cancel()\">Cancel</md-button></div><div>\n<md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"vm.disabled == false ? insereGrupo.$valid && vm.saveMember(vm.member) : \'\'\">Save</md-button></div></div>\n</form></div>");
$templateCache.put("app/templates/cards/order/order.html","<div class=\"estado estado-awaiting\" layout=\"row\" layout-align=\"center center\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"font-size-18 font-weight-400 status-text\">Awaiting Approval</span></div></div>");
$templateCache.put("app/templates/cards/product/delivertyselectionedit.html","<div flex class=\"delivery-box\" layout=\"column\" layout-align=\"start center\"><h3>Selection Edit</h3><div layout=\"row\" \nclass=\"full-width\"><div flex><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Cost Increase %\n</label><input type=\"text\"></md-input-container></div><div flex><md-input-container flex layout=\"row\" \nclass=\"full-width md-block\"><label>Cost Decrease %</label><input type=\"text\"></md-input-container></div></div><div \nlayout=\"row\" class=\"full-width\"><div flex><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>\nDelivery Group</label><md-select ng-model=\"delivery.group\"><md-option value=\"1\">DHL</md-option><md-option value=\"2\">\nBike</md-option><md-option value=\"3\">Royal Mail</md-option><md-option value=\"4\">Courier</md-option><md-option \nvalue=\"5\">Collection</md-option></md-select></md-input-container></div><div flex><md-input-container flex layout=\"row\" \nclass=\"full-width md-block\"><label>Departament</label><md-select ng-model=\"delivery.departament\"><md-option value=\"1\">\nGo</md-option><md-option value=\"2\">Plaster Room</md-option><md-option value=\"3\">3D Scanning</md-option></md-select>\n</md-input-container></div></div><div flex layout=\"row\" layout-align=\"start center\"><div><md-button class=\"md-primary\" \nng-click=\"cancelOrder($event)\">Cancel</md-button></div><div><md-button class=\"md-primary\" ng-click=\"saveOrder($event)\">\nSave</md-button></div></div></div>");
$templateCache.put("app/templates/cards/product/editdeliveryroute.html","<div flex class=\"delivery-box\" layout=\"column\" layout-align=\"start center\"><h3>Edit Delivery Route</h3>\n<md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Code</label><input type=\"text\">\n</md-input-container><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Delivery Route</label>\n<input type=\"text\"></md-input-container><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>\nDelivery Group</label><md-select ng-model=\"delivery.group\"><md-option value=\"1\">DHL</md-option><md-option value=\"2\">\nBike</md-option><md-option value=\"3\">Royal Mail</md-option><md-option value=\"4\">Courier</md-option><md-option \nvalue=\"5\">Collection</md-option></md-select></md-input-container><div layout=\"row\" class=\"full-width\"><div flex=\"50\">\n<md-input-container flex class=\"md-block\"><label>Unit Rate</label><input type=\"text\"></md-input-container></div><div \nflex><md-input-container flex class=\"md-block\"><label>VAT Rate</label><md-select ng-model=\"delivery.vatrate\"><md-option\n value=\"1\">Not Applicable</md-option><md-option value=\"2\">20%</md-option></md-select></md-input-container></div></div>\n<div layout=\"row\" class=\"full-width\"><div flex><md-input-container flex layout=\"row\" class=\"full-width md-block\">\n<label>VAT Amount</label><input type=\"text\"></md-input-container></div><div flex><md-input-container flex layout=\"row\" \nclass=\"full-width md-block\"><label>Total</label><input type=\"text\" value=\"£15.50\" disabled=\"disabled\">\n</md-input-container></div></div><div layout=\"row\" class=\"full-width\"><div flex><md-input-container flex layout=\"row\" \nclass=\"full-width md-block\"><label>No. of Days</label><input type=\"text\"></md-input-container></div><div flex>\n<md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>No. of Hours</label><input type=\"text\">\n</md-input-container></div></div><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Departament\n</label><md-select ng-model=\"delivery.departament\"><md-option value=\"1\">Go</md-option><md-option value=\"2\">Plaster Room\n</md-option><md-option value=\"3\">3D Scanning</md-option></md-select></md-input-container><div flex layout=\"row\" \nlayout-align=\"start center\"><div><md-button class=\"md-primary\" ng-click=\"cancelOrder($event)\">Cancel</md-button></div>\n<div><md-button class=\"md-primary\" ng-click=\"saveOrder($event)\">Save</md-button></div></div></div>");
$templateCache.put("app/templates/cards/product/editproduct.html","<div flex class=\"products-box\" layout=\"column\" layout-align=\"start center\"><form name=\"editaProduto\" \nng-submit=\"submitForm(editaProduto.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.produto.products_id\" \nng-init=\"vm.produto.products_id=vm.produto.products_id\"><h3>Edit Product</h3><md-input-container \nmd-is-error=\"editaProduto.product_code.$invalid && (editaProduto.product_code.$touched || editaProduto.$submitted)\" \nflex layout=\"row\" class=\"full-width md-block\"><label>Code</label><input type=\"text\" name=\"product_code\" \nng-model=\"vm.produto.product_code\" required ng-disabled=\"vm.disabled\"><div \nng-messages=\"editaProduto.product_code.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease insert a product code.</span></div></div></md-input-container><md-input-container \nmd-is-error=\"editaProduto.product_description.$invalid && (editaProduto.product_description.$touched || editaProduto.$submitted)\" \nflex layout=\"row\" class=\"full-width md-block\"><label>Description</label><input type=\"text\" name=\"product_description\" \nng-model=\"vm.produto.product_description\" required ng-disabled=\"vm.disabled\"><div \nng-messages=\"editaProduto.product_description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease insert a product description.</span></div></div></md-input-container><div layout=\"row\" class=\"full-width\"><div \nflex=\"50\"><md-input-container \nmd-is-error=\"editaProduto.rate.$invalid && (editaProduto.rate.$touched || editaProduto.$submitted)\" flex layout=\"row\" \nclass=\"full-width md-block\"><label>Unit Rate</label><input type=\"text\" name=\"rate\" ng-model=\"vm.produto.rate\" required \nng-disabled=\"vm.blockpricechange\"><div ng-messages=\"editaProduto.rate.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Please insert a rate.</span></div></div></md-input-container></div><div flex><md-input-container \nmd-is-error=\"editaProduto.VAT.$invalid && (editaProduto.VAT.$touched || editaProduto.$submitted)\" flex layout=\"row\" \nclass=\"full-width md-block\"><label>VAT</label><input type=\"text\" name=\"VAT\" ng-model=\"vm.produto.VAT\" required \nng-disabled=\"vm.blockpricechange\"><div ng-messages=\"editaProduto.VAT.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Please insert a VAT rate.</span></div></div></md-input-container></div></div><div layout=\"row\" \nclass=\"full-width\"><div flex><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>VAT Amount\n</label><input type=\"text\" value=\"{{vm.vatamount()}}\" disabled=\"disabled\"></md-input-container></div><div flex>\n<md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Total</label><input type=\"text\" \nvalue=\"{{vm.total()}}\" disabled=\"disabled\"></md-input-container></div></div><md-input-container \nmd-is-error=\"insereProduto.points.$invalid && (insereProduto.points.$touched || insereProduto.$submitted)\" flex \nlayout=\"row\" class=\"full-width md-block\"><label>Number of Points</label><input type=\"text\" name=\"points\" ng-value=\"0\" \nng-model=\"vm.produto.points\" required ng-pattern=\"/^([0-9]{1,6})$/\" ng-disabled=\"vm.disabled\"><div \nng-messages=\"insereProduto.points.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert number of points.\n</span></div><div ng-message=\"pattern\"><span>Please insert only integers.</span></div></div></md-input-container>\n<md-input-container \nmd-is-error=\"editaProduto.products_groups_id.$invalid && (editaProduto.products_groups_id.$touched || editaProduto.$submitted)\" \nflex layout=\"row\" class=\"full-width md-block\"><label>Product Group</label><md-select name=\"products_groups_id\" \nng-model=\"vm.produto.products_groups_id\" ng-disabled=\"vm.disabled\"><md-option ng-repeat=\"(index,grupo) in vm.groups\" \nng-value=\"grupo.products_groups_id\" ng-selected=\"index == \'{{vm.produto.products_groups_id}}\'\">{{grupo.group_name}}\n</md-option></md-select><div ng-messages=\"editaProduto.products_groups_id.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Please choose a product group.</span></div></div></md-input-container><div flex \nlayout=\"row\" layout-align=\"center center\"><div><md-button class=\"md-red-500-bg\" \nng-click=\"vm.disabled==false ? vm.deleteExistProduct($event, vm.produto.products_id) : \'\'\">Delete</md-button></div>\n<div><md-button class=\"md-primary\" ng-click=\"vm.cancel($event)\">Cancel</md-button></div><div><md-button \nclass=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"(vm.disabled==false || vm.blockpricechange == false) ? editaProduto.$valid && vm.saveExistProduct(vm.produto) : \'\'\">\nSave</md-button></div></div></form></div>");
$templateCache.put("app/templates/cards/product/editproductgroup.html","<div flex class=\"delivery-box\" layout=\"column\" layout-align=\"start center\"><form name=\"editaGrupo\" \nng-submit=\"submitForm(editaGrupo.$valid)\" novalidate class=\"full-width\"><input type=\"hidden\" \nng-model=\"vm.grupo.products_groups_id\" ng-init=\"vm.grupo.products_groups_id=vm.grupo.products_groups_id\"><h3>\nEdit Product Group</h3><md-input-container \nmd-is-error=\"editaGrupo.group_name.$invalid && (editaGrupo.group_name.$touched || editaGrupo.$submitted)\" flex \nlayout=\"row\" class=\"full-width md-block\"><label>Group Name</label><input name=\"group_name\" type=\"text\" \nng-model=\"vm.grupo.group_name\" required><div ng-messages=\"editaGrupo.group_name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Please insert a group name.</span></div></div></md-input-container><md-input-container \nmd-is-error=\"editaGrupo.group_description.$invalid && (editaGrupo.group_description.$touched || editaGrupo.$submitted)\" \nflex layout=\"row\" class=\"full-width md-block\"><label>Group Description</label><input name=\"group_description\" \ntype=\"text\" ng-model=\"vm.grupo.group_description\" required><div ng-messages=\"editaGrupo.group_description.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Please insert a group description.</span></div></div>\n</md-input-container><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Departament</label>\n<md-select name=\"departments_id\" ng-model=\"vm.grupo.departments_id\"><md-option value=\"2\">Plaster Room</md-option>\n<md-option value=\"3\">3D</md-option><md-option value=\"7\">Implants</md-option><md-option value=\"12\">Clear Aligner\n</md-option><md-option value=\"16\">Removable Appliance</md-option><md-option value=\"20\">Packaging</md-option>\n</md-select><div ng-messages=\"editaGrupo.departments_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease choose a department.</span></div></div></md-input-container><div flex layout=\"row\" layout-align=\"center center\">\n<div><md-button class=\"md-primary\" ng-click=\"cancelOrder($event)\">Cancel</md-button></div><div><md-button \nclass=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"vm.disabled==false ? editaGrupo.$valid && vm.saveExistGroup(vm.grupo) : \'\'\">Save</md-button></div></div>\n</form></div>");
$templateCache.put("app/templates/cards/product/newdeliveryroute.html","<div flex class=\"delivery-box\" layout=\"column\" layout-align=\"start center\"><h3>New Delivery Route</h3>\n<md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Code</label><input type=\"text\">\n</md-input-container><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Delivery Route</label>\n<input type=\"text\"></md-input-container><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>\nDelivery Group</label><md-select ng-model=\"delivery.group\"><md-option value=\"1\">DHL</md-option><md-option value=\"2\">\nBike</md-option><md-option value=\"3\">Royal Mail</md-option><md-option value=\"4\">Courier</md-option><md-option \nvalue=\"5\">Collection</md-option></md-select></md-input-container><div layout=\"row\" class=\"full-width\"><div flex=\"50\">\n<md-input-container flex class=\"md-block\"><label>Unit Rate</label><input type=\"text\"></md-input-container></div><div \nflex><md-input-container flex class=\"md-block\"><label>VAT Rate</label><md-select ng-model=\"delivery.vatrate\"><md-option\n value=\"1\">Not Applicable</md-option><md-option value=\"2\">20%</md-option></md-select></md-input-container></div></div>\n<div layout=\"row\" class=\"full-width\"><div flex><md-input-container flex layout=\"row\" class=\"full-width md-block\">\n<label>VAT Amount</label><input type=\"text\"></md-input-container></div><div flex><md-input-container flex layout=\"row\" \nclass=\"full-width md-block\"><label>Total</label><input type=\"text\" value=\"£15.50\" disabled=\"disabled\">\n</md-input-container></div></div><div layout=\"row\" class=\"full-width\"><div flex><md-input-container flex layout=\"row\" \nclass=\"full-width md-block\"><label>No. of Days</label><input type=\"text\"></md-input-container></div><div flex>\n<md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>No. of Hours</label><input type=\"text\">\n</md-input-container></div></div><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Departament\n</label><md-select ng-model=\"delivery.departament\"><md-option value=\"1\">Go</md-option><md-option value=\"2\">Plaster Room\n</md-option><md-option value=\"3\">3D Scanning</md-option></md-select></md-input-container><div flex layout=\"row\" \nlayout-align=\"start center\"><div><md-button class=\"md-primary\" ng-click=\"cancelOrder($event)\">Cancel</md-button></div>\n<div><md-button class=\"md-primary\" ng-click=\"saveOrder($event)\">Save</md-button></div></div></div>");
$templateCache.put("app/templates/cards/product/newproduct.html","<div flex class=\"products-box\" layout=\"column\" layout-align=\"start center\"><form name=\"insereProduto\" \nng-submit=\"submitForm(insereProduto.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.produto.products_id\" \nng-init=\"vm.produto.products_id=\'0\'\"><h3>New Product</h3><md-input-container \nmd-is-error=\"insereProduto.product_code.$invalid && (insereProduto.product_code.$touched || insereProduto.$submitted)\" \nflex layout=\"row\" class=\"full-width md-block\"><label>Code</label><input type=\"text\" name=\"product_code\" \nng-model=\"vm.produto.product_code\" required><div ng-messages=\"insereProduto.product_code.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Please insert a product code.</span></div></div></md-input-container><md-input-container \nmd-is-error=\"insereProduto.product_description.$invalid && (insereProduto.product_description.$touched || insereProduto.$submitted)\" \nflex layout=\"row\" class=\"full-width md-block\"><label>Description</label><input type=\"text\" name=\"product_description\" \nng-model=\"vm.produto.product_description\" required><div ng-messages=\"insereProduto.product_description.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Please insert a product description.</span></div></div>\n</md-input-container><div layout=\"row\" class=\"full-width\"><div flex=\"50\"><md-input-container \nmd-is-error=\"insereProduto.rate.$invalid && (insereProduto.rate.$touched || insereProduto.$submitted)\" flex \nlayout=\"row\" class=\"full-width md-block\"><label>Unit Rate</label><input type=\"text\" name=\"rate\" \nng-model=\"vm.produto.rate\" required><div ng-messages=\"insereProduto.rate.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Please insert a rate.</span></div></div></md-input-container></div><div flex>\n<md-input-container \nmd-is-error=\"insereProduto.VAT.$invalid && (insereProduto.VAT.$touched || insereProduto.$submitted)\" flex layout=\"row\" \nclass=\"full-width md-block\"><label>VAT</label><input type=\"text\" name=\"VAT\" ng-model=\"vm.produto.VAT\" required><div \nng-messages=\"insereProduto.VAT.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert a VAT rate.</span>\n</div></div></md-input-container></div></div><div layout=\"row\" class=\"full-width\"><div flex><md-input-container flex \nlayout=\"row\" class=\"full-width md-block\"><label>VAT Amount</label><input type=\"text\" value=\"{{vm.vatamount()}}\" \ndisabled=\"disabled\"></md-input-container></div><div flex><md-input-container flex layout=\"row\" \nclass=\"full-width md-block\"><label>Total</label><input type=\"text\" value=\"{{vm.total()}}\" disabled=\"disabled\">\n</md-input-container></div></div><md-input-container \nmd-is-error=\"insereProduto.points.$invalid && (insereProduto.points.$touched || insereProduto.$submitted)\" flex \nlayout=\"row\" class=\"full-width md-block\"><label>Number of Points</label><input type=\"text\" name=\"points\" ng-value=\"0\" \nng-model=\"vm.produto.points\" required ng-pattern=\"/^([0-9]{1,6})$/\"><div ng-messages=\"insereProduto.points.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Please insert number of points.</span></div><div ng-message=\"pattern\">\n<span>Please insert only integers.</span></div></div></md-input-container><md-input-container \nmd-is-error=\"insereProduto.products_groups_id.$invalid && (insereProduto.products_groups_id.$touched || insereProduto.$submitted)\" \nflex layout=\"row\" class=\"full-width md-block\"><label>Product Group</label><md-select name=\"products_groups_id\" \nng-model=\"vm.produto.products_groups_id\"><md-option ng-repeat=\"(index,grupo) in vm.groups\" \nng-value=\"grupo.products_groups_id\">{{grupo.group_name}}</md-option></md-select><div \nng-messages=\"insereProduto.products_groups_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease choose a product group.</span></div></div></md-input-container><div flex layout=\"row\" \nlayout-align=\"center center\"><div><md-button class=\"md-primary\" ng-click=\"vm.cancel($event)\">Cancel</md-button></div>\n<div><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"vm.disabled==false ? insereProduto.$valid && vm.saveNewProduct(vm.produto) : \'\'\">Save</md-button></div></div>\n</form></div>");
$templateCache.put("app/templates/cards/product/newproductgroup.html","<div flex class=\"delivery-box\" layout=\"column\" layout-align=\"start center\"><form name=\"insereGrupo\" \nng-submit=\"submitForm(insereGrupo.$valid)\" novalidate class=\"full-width\"><input type=\"hidden\" \nng-model=\"vm.grupo.products_groups_id\" ng-init=\"vm.grupo.products_groups_id=0\"><h3>New Product Group</h3>\n<md-input-container \nmd-is-error=\"insereGrupo.group_name.$invalid && (insereGrupo.group_name.$touched || insereGrupo.$submitted)\" flex \nlayout=\"row\" class=\"full-width md-block\"><label>Group Name</label><input name=\"group_name\" type=\"text\" \nng-model=\"vm.grupo.group_name\" required><div ng-messages=\"recordForm.group_name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Please insert a group name.</span></div></div></md-input-container><md-input-container \nmd-is-error=\"insereGrupo.group_description.$invalid && (insereGrupo.group_description.$touched || insereGrupo.$submitted)\" \nflex layout=\"row\" class=\"full-width md-block\"><label>Group Description</label><input name=\"group_description\" \ntype=\"text\" ng-model=\"vm.grupo.group_description\" required><div ng-messages=\"recordForm.group_description.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Please insert a group description.</span></div></div>\n</md-input-container><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Departament</label>\n<md-select name=\"departments_id\" ng-model=\"vm.grupo.departments_id\"><md-option value=\"2\">Plaster Room</md-option>\n<md-option value=\"3\">3D</md-option><md-option value=\"7\">Implants</md-option><md-option value=\"12\">Clear Aligner\n</md-option><md-option value=\"16\">Removable Appliance</md-option><md-option value=\"20\">Packaging</md-option>\n</md-select><div ng-messages=\"recordForm.departments_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease choose a department.</span></div></div></md-input-container><div flex layout=\"row\" layout-align=\"center center\">\n<div><md-button class=\"md-primary\" ng-click=\"cancelOrder($event)\">Cancel</md-button></div><div><md-button \nclass=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"vm.disabled==false ? insereGrupo.$valid && vm.saveExistGroup(vm.grupo) : \'\'\">Save</md-button></div></div>\n</form></div>");
$templateCache.put("app/templates/cards/product/productselectionedit.html","<div flex class=\"products-box\" layout=\"column\" layout-align=\"start center\"><form name=\"editaProduto\" \nng-submit=\"submitForm(editaProduto.$valid)\" novalidate><h3>Selection Edit</h3><div layout=\"row\" class=\"full-width\"><div\n flex><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>Cost Increase %</label><input \nname=\"costincrease\" type=\"text\" ng-model=\"vm.produto.costincrease\" ng-disabled=\"vm.produto.costdecrease\">\n</md-input-container></div><div flex><md-input-container flex layout=\"row\" class=\"full-width md-block\"><label>\nCost Decrease %</label><input name=\"costdecrease\" type=\"text\" ng-model=\"vm.produto.costdecrease\" \nng-disabled=\"vm.produto.costincrease\"></md-input-container></div></div><md-radio-group flex layout=\"row\" \nclass=\"full-width\" layout-align=\"center center\" ng-model=\"vm.produto.upperlower\"><md-radio-button value=\"1\">Upper\n</md-radio-button><md-radio-button value=\"2\">Lower</md-radio-button><md-radio-button value=\"0\">Other</md-radio-button>\n</md-radio-group><div layout=\"row\" class=\"full-width\"><div flex><md-input-container flex layout=\"row\" \nclass=\"full-width md-block\"><label>Product Group</label><md-select name=\"products_groups_id\" \nng-model=\"vm.produto.products_groups_id\"><md-option ng-repeat=\"grupo in vm.groups\" ng-value=\"grupo.products_groups_id\">\n{{grupo.group_name}}</md-option></md-select></md-input-container></div><div flex><md-input-container flex layout=\"row\" \nclass=\"full-width md-block\"><label>Departament</label><md-select name=\"departments_id\" \nng-model=\"vm.produto.departments_id\"><md-option ng-repeat=\"departamento in vm.departamentos\" \nng-value=\"departamento.departments_id\">{{departamento.department_name}}</md-option></md-select></md-input-container>\n</div></div><div flex layout=\"row\" layout-align=\"center center\"><div><md-button class=\"md-red-500-bg\" \nng-click=\"vm.disabled==false ? vm.deleteProducts(vm.produto) : \'\'\">Delete</md-button></div><div><md-button \nclass=\"md-primary\" ng-click=\"vm.cancel($event)\">Cancel</md-button></div><div><md-button class=\"md-green-500-bg branco\" \ntype=\"submit\" ng-click=\"vm.disabled==false ? editaProduto.$valid && vm.saveProducts(vm.produto) : \'\'\">Save</md-button>\n</div></div></form></div>");
$templateCache.put("app/templates/cards/reports/clientdistribution.html","<div flex class=\"topsales-box\" layout=\"row\" layout-align=\"start center\"><div flex=\"20\" class=\"\"><table \nclass=\"table-clientdist full-width\"><thead><tr><th>CITY</th><th>NO. OF CLIENTS</th></tr></thead><tbody><tr \nng-repeat=\"client in vm.clientsdistribution\"><td>{{client.key}}</td><td>{{client.value}}</td></tr></tbody></table>\n</div><div flex class=\"\"><nvd3 options=\"vm.pieChart.options\" data=\"vm.clientsdistribution\"></nvd3></div><div \nclass=\"totalclients\"><span class=\"text-smaller cor-texto-accounts\">Total Clients</span><br><span \nclass=\"text-bigger cor-texto-accounts\">{{vm.total}}</span></div></div>");
$templateCache.put("app/templates/cards/reports/clientslocationproduct.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.reset_7()\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\" class=\"full-width\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Start (yyyy-mm-dd)\n</label><input type=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.search7.startDate\" \nng-change=\"vm.searchTable7(vm.search7.startDate, 0)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>End (yyyy-mm-dd)</label><input type=\"text\" \nname=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.search7.endDate\" ng-change=\"vm.searchTable7(vm.search7.endDate, 1)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>City</label><input type=\"text\" name=\"ccity\" ng-model=\"vm.search7.ccity\" \nng-change=\"vm.searchTable7(vm.search7.ccity, 2)\"></md-input-container><md-input-container layout=\"row\" flex \nclass=\"md-block\"><label>Postcode</label><input type=\"text\" name=\"cpostcode\" ng-model=\"vm.search7.cpostcode\" \nng-change=\"vm.searchTable7(vm.search7.cpostcode, 3)\"></md-input-container><md-input-container layout=\"row\" flex \nclass=\"md-block\"><label>Product Description</label><input type=\"text\" name=\"product_description\" \nng-model=\"vm.search7.product_description\" ng-change=\"vm.searchTable7(vm.search7.product_description, 4)\">\n</md-input-container><md-input-container layout=\"row\" flex class=\"md-block\"><label>Product Code</label><input \ntype=\"text\" name=\"product_code\" ng-model=\"vm.search7.product_code\" \nng-change=\"vm.searchTable7(vm.search7.product_code, 5)\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"full-width\"><table datatable=\"\" class=\"row-border hover full-width\" \ndt-instance=\"vm.dtInstance7\" dt-options=\"vm.dtOptions7\" dt-columns=\"vm.dtColumns7\"></table></div></div>");
$templateCache.put("app/templates/cards/reports/clientsperlocation.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.reset_6()\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\" class=\"full-width\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>City</label><input \ntype=\"text\" name=\"ccity\" ng-model=\"vm.search6.ccity\" ng-change=\"vm.searchTable6(vm.search6.ccity, 2)\">\n</md-input-container><md-input-container layout=\"row\" flex class=\"md-block\"><label>Postcode</label><input type=\"text\" \nname=\"cpostcode\" ng-model=\"vm.search6.cpostcode\" ng-change=\"vm.searchTable6(vm.search6.cpostcode, 3)\">\n</md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" class=\"full-width\"><table \ndatatable=\"\" class=\"row-border hover full-width\" dt-instance=\"vm.dtInstance6\" dt-options=\"vm.dtOptions6\" \ndt-columns=\"vm.dtColumns6\"></table></div></div>");
$templateCache.put("app/templates/cards/reports/completedorders.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button \nng-click=\"vm.clean(\'completedorders\')\" layout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span \nstyle=\"margin:auto\">Reset</span></md-button><div layout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>Start (yyyy-mm-dd)</label><input type=\"text\" name=\"startDate\" mask=\"9999-19-39\" \nng-model=\"vm.startDate[\'completedorders\']\" \nng-change=\"vm.changeTotalSales(\'completedorders\',\'startDate\',vm.startDate[\'completedorders\'])\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>End (yyyy-mm-dd)</label><input type=\"text\" name=\"endDate\" mask=\"9999-19-39\" \nng-model=\"vm.endDate[\'completedorders\']\" \nng-change=\"vm.changeTotalSales(\'completedorders\',\'endDate\',vm.endDate[\'completedorders\'])\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container></div><div layout=\"row md-padding\"><span \nclass=\"text-bigger cor-texto-accounts\">{{vm.order[\'completedorders\']}}</span></div></div>");
$templateCache.put("app/templates/cards/reports/newclients.html","<div flex class=\"padding-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.reset_5()\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\" class=\"full-width\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Start Date (yyyy-mm-dd)\n</label><input type=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.search5.startDate\" \nng-change=\"vm.searchTable5(vm.search5.startDate, 0)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>End Date (yyyy-mm-dd)</label><input type=\"text\" \nname=\"spendDate\" mask=\"9999-19-39\" ng-model=\"vm.search5.endDate\" ng-change=\"vm.searchTable5(vm.search5.endDate, 1)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"full-width\"><table datatable=\"\" class=\"row-border hover full-width\" dt-instance=\"vm.dtInstance5\" \ndt-options=\"vm.dtOptions5\" dt-columns=\"vm.dtColumns5\"></table></div></div>");
$templateCache.put("app/templates/cards/reports/neworders.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.clean(\'neworders\')\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Start (yyyy-mm-dd)</label><input \ntype=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.startDate[\'neworders\']\" \nng-change=\"vm.changeTotalSales(\'neworders\',\'startDate\',vm.startDate[\'neworders\'])\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>End (yyyy-mm-dd)</label><input type=\"text\" name=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.endDate[\'neworders\']\" \nng-change=\"vm.changeTotalSales(\'neworders\',\'endDate\',vm.endDate[\'neworders\'])\" ng-model-options=\"{ debounce: 750 }\">\n</md-input-container></div><div layout=\"row md-padding\"><span class=\"text-bigger cor-texto-accounts\">\n{{vm.order[\'neworders\']}}</span></div></div>");
$templateCache.put("app/templates/cards/reports/ordersdue.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.clean(\'ordersdue\')\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Start (yyyy-mm-dd)</label><input \ntype=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.startDate[\'ordersdue\']\" \nng-change=\"vm.changeTotalSales(\'ordersdue\',\'startDate\',vm.startDate[\'ordersdue\'])\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>End (yyyy-mm-dd)</label><input type=\"text\" name=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.endDate[\'ordersdue\']\" \nng-change=\"vm.changeTotalSales(\'ordersdue\',\'endDate\',vm.endDate[\'ordersdue\'])\" ng-model-options=\"{ debounce: 750 }\">\n</md-input-container></div><div layout=\"row md-padding\"><span class=\"text-bigger cor-texto-accounts\">\n{{vm.order[\'ordersdue\']}}</span></div></div>");
$templateCache.put("app/templates/cards/reports/ordersonstop.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button \nng-click=\"vm.clean(\'ordersonstop\')\" layout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span \nstyle=\"margin:auto\">Reset</span></md-button><div layout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>Start (yyyy-mm-dd)</label><input type=\"text\" name=\"startDate\" mask=\"9999-19-39\" \nng-model=\"vm.startDate[\'ordersonstop\']\" \nng-change=\"vm.changeTotalSales(\'ordersonstop\',\'startDate\',vm.startDate[\'ordersonstop\'])\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>End (yyyy-mm-dd)</label><input type=\"text\" name=\"endDate\" mask=\"9999-19-39\" \nng-model=\"vm.endDate[\'ordersonstop\']\" \nng-change=\"vm.changeTotalSales(\'ordersonstop\',\'endDate\',vm.endDate[\'ordersonstop\'])\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container></div><div layout=\"row md-padding\"><span \nclass=\"text-bigger cor-texto-accounts\">{{vm.order[\'ordersonstop\']}}</span></div></div>");
$templateCache.put("app/templates/cards/reports/orderswfc.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.clean(\'orderswfc\')\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Start (yyyy-mm-dd)</label><input \ntype=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.startDate[\'orderswfc\']\" \nng-change=\"vm.changeTotalSales(\'orderswfc\',\'startDate\',vm.startDate[\'orderswfc\'])\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>End (yyyy-mm-dd)</label><input type=\"text\" name=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.endDate[\'orderswfc\']\" \nng-change=\"vm.changeTotalSales(\'orderswfc\',\'endDate\',vm.endDate[\'orderswfc\'])\" ng-model-options=\"{ debounce: 750 }\">\n</md-input-container></div><div layout=\"row md-padding\"><span class=\"text-bigger cor-texto-accounts\">\n{{vm.order[\'orderswfc\']}}</span></div></div>");
$templateCache.put("app/templates/cards/reports/orderswfi.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.clean(\'orderswfi\')\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Start (yyyy-mm-dd)</label><input \ntype=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.startDate[\'orderswfi\']\" \nng-change=\"vm.changeTotalSales(\'orderswfi\',\'startDate\',vm.startDate[\'orderswfi\'])\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>End (yyyy-mm-dd)</label><input type=\"text\" name=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.endDate[\'orderswfi\']\" \nng-change=\"vm.changeTotalSales(\'orderswfi\',\'endDate\',vm.endDate[\'orderswfi\'])\" ng-model-options=\"{ debounce: 750 }\">\n</md-input-container></div><div layout=\"row md-padding\"><span class=\"text-bigger cor-texto-accounts\">\n{{vm.order[\'orderswfi\']}}</span></div></div>");
$templateCache.put("app/templates/cards/reports/topsales.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.reset_ts()\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\" class=\"full-width\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Start (yyyy-mm-dd)\n</label><input type=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.search4.startDate\" \nng-change=\"vm.searchTable4(vm.search4.startDate, 0)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>End (yyyy-mm-dd)</label><input type=\"text\" \nname=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.search4.endDate\" ng-change=\"vm.searchTable4(vm.search4.endDate, 1)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"full-width\"><table datatable=\"\" class=\"row-border hover full-width\" dt-instance=\"vm.dtInstance4\" \ndt-options=\"vm.dtOptions4\" dt-columns=\"vm.dtColumns4\"></table></div></div>");
$templateCache.put("app/templates/cards/reports/totalproducts.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.reset()\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\" class=\"full-width\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Start (yyyy-mm-dd)\n</label><input type=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.search1.startDate\" \nng-change=\"vm.searchTable1(vm.search1.startDate, 5)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>End (yyyy-mm-dd)</label><input type=\"text\" \nname=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.search1.endDate\" ng-change=\"vm.searchTable1(vm.search1.endDate, 6)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>Product Description</label><input type=\"text\" name=\"product_description\" \nng-model=\"vm.search1.product_description\" ng-change=\"vm.searchTable1(vm.search1.product_description, 0)\">\n</md-input-container><md-input-container layout=\"row\" flex class=\"md-block\"><label>Product Code</label><input \ntype=\"text\" name=\"product_code\" ng-model=\"vm.search1.product_code\" \nng-change=\"vm.searchTable1(vm.search1.product_code, 1)\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"full-width\"><table datatable=\"\" class=\"row-border hover full-width\" \ndt-instance=\"vm.dtInstance1\" dt-options=\"vm.dtOptions1\" dt-columns=\"vm.dtColumns1\"></table></div></div>");
$templateCache.put("app/templates/cards/reports/totalsales.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.clean(\'topsales\')\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Start (yyyy-mm-dd)</label><input \ntype=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.startDate\" \nng-change=\"vm.changeTotalSales(\'startDate\',vm.startDate)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>End (yyyy-mm-dd)</label><input type=\"text\" \nname=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.endDate\" ng-change=\"vm.changeTotalSales(\'endDate\',vm.endDate)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container></div><div layout=\"row md-padding\"><span \nclass=\"text-bigger cor-texto-accounts\">£ {{vm.totalcost | number : 0}}</span></div><div class=\"divisor\"></div><div \nclass=\"row\"><span class=\"text-smaller cor-texto-accounts\">Total VAT</span></div><div class=\"row\"><span \nclass=\"text-small cor-texto-accounts\">£ {{vm.totalvat | number : 0}}</span></div></div>");
$templateCache.put("app/templates/cards/reports/totalsalesproduct.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.reset()\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\" class=\"full-width\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Start (yyyy-mm-dd)\n</label><input type=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.search1.startDate\" \nng-change=\"vm.searchTable1(vm.search1.startDate, 0)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>End (yyyy-mm-dd)</label><input type=\"text\" \nname=\"spendDate\" mask=\"9999-19-39\" ng-model=\"vm.search1.endDate\" ng-change=\"vm.searchTable1(vm.search1.endDate, 1)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>Product Description</label><input type=\"text\" name=\"product_description\" \nng-model=\"vm.search1.product_description\" ng-change=\"vm.searchTable1(vm.search1.product_description, 2)\">\n</md-input-container><md-input-container layout=\"row\" flex class=\"md-block\"><label>Product Code</label><input \ntype=\"text\" name=\"product_code\" ng-model=\"vm.search1.product_code\" \nng-change=\"vm.searchTable1(vm.search1.product_code, 3)\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"full-width\"><table datatable=\"\" class=\"row-border hover full-width\" \ndt-instance=\"vm.dtInstance1\" dt-options=\"vm.dtOptions1\" dt-columns=\"vm.dtColumns1\"></table></div></div>");
$templateCache.put("app/templates/cards/reports/totalsalesproductgroup.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.reset_pg()\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\" class=\"full-width\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Start (yyyy-mm-dd)\n</label><input type=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.search2.startDate\" \nng-change=\"vm.searchTable2(vm.search2.startDate, 0)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>End (yyyy-mm-dd)</label><input type=\"text\" \nname=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.search2.endDate\" ng-change=\"vm.searchTable2(vm.search2.endDate, 1)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>Group Name</label><input type=\"text\" name=\"group_name\" ng-model=\"vm.search2.group_name\" \nng-change=\"vm.searchTable2(vm.search2.group_name, 2)\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"full-width\"><table datatable=\"\" class=\"row-border hover full-width\" \ndt-instance=\"vm.dtInstance2\" dt-options=\"vm.dtOptions2\" dt-columns=\"vm.dtColumns2\"></table></div></div>");
$templateCache.put("app/templates/cards/reports/totalsalesproductlocation.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.reset_cl()\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\" class=\"full-width\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Start (yyyy-mm-dd)\n</label><input type=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.search3.startDate\" \nng-change=\"vm.searchTable3(vm.search3.startDate, 0)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>End (yyyy-mm-dd)</label><input type=\"text\" \nname=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.search3.endDate\" ng-change=\"vm.searchTable3(vm.search3.endDate, 1)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>City</label><input type=\"text\" name=\"ccity\" ng-model=\"vm.search3.ccity\" \nng-change=\"vm.searchTable3(vm.search3.ccity, 2)\"></md-input-container><md-input-container layout=\"row\" flex \nclass=\"md-block\"><label>Postcode</label><input type=\"text\" name=\"cpostcode\" ng-model=\"vm.search3.cpostcode\" \nng-change=\"vm.searchTable2(vm.search3.cpostcode, 3)\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"full-width\"><table datatable=\"\" class=\"row-border hover full-width\" \ndt-instance=\"vm.dtInstance3\" dt-options=\"vm.dtOptions3\" dt-columns=\"vm.dtColumns3\"></table></div></div>");
$templateCache.put("app/templates/cards/reports/totalsgroup.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.reset_pg()\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\" class=\"full-width\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Start (yyyy-mm-dd)\n</label><input type=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.search2.startDate\" \nng-change=\"vm.searchTable2(vm.search2.startDate, 0)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>End (yyyy-mm-dd)</label><input type=\"text\" \nname=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.search2.endDate\" ng-change=\"vm.searchTable2(vm.search2.endDate, 1)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>Group Name</label><input type=\"text\" name=\"group_name\" ng-model=\"vm.search2.group_name\" \nng-change=\"vm.searchTable2(vm.search2.group_name, 2)\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"full-width\"><table datatable=\"\" class=\"row-border hover full-width\" \ndt-instance=\"vm.dtInstance2\" dt-options=\"vm.dtOptions2\" dt-columns=\"vm.dtColumns2\"></table></div></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><img src=\"assets/images/logos/NimrodTRAC_logo.png\" width=\"200\" height=\"25\" \nalt=\"NimrodTRAC Logo\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\">\n</md-progress-circular><md-menu-bar id=\"user-menu\"><md-button class=\"user-button\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img ng-if=\"!vm.userpic\" md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"> <img ng-if=\"vm.userpic\" md-menu-align-target class=\"avatar\" \nhttp-src=\"{{vm.baseurl}}/api/Dlfile?type=profile&name={{vm.userpic}}\"><md-icon md-font-icon \nng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span \nclass=\"username\" hide-sm>{{vm.username}}</span></div></md-button></md-menu-bar><md-menu-bar id=\"user-logout\"><md-button\n class=\"user-button\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\" ng-click=\"vm.logout()\"></md-icon></md-button>\n</md-menu-bar></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular><md-menu-bar \nid=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide \nshow-gt-sm>{{vm.username}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div>\n</md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-divider>\n</md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button\n ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\r\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\r\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\r\n    </ul>\n</script>>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\r\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/main/pages/clientstatus/templates/scanorder.html","<md-dialog flex=\"20\" class=\"adddeliveryroute\" aria-label=\"Scan Order\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2>Scan Order</h2><span\n flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><h3>Scan your order barcode or insert order number</h3><div layout=\"row\" flex \nlayout-align=\"start center\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Order Number</label><input \ntype=\"text\" required md-autofocus name=\"scanorderid\" minlength=\"8\" maxlength=\"8\" ng-model=\"vm.scanorderid\" scan-order>\n<div ng-messages=\"recordForm.scanorderid.$error\"><div ng-message=\"required\">\nPlease scan order barcode or insert an Order Number, starting with *</div><div ng-message=\"maxlength\">\nOrder Number is too long. Please insert only 8 characters.</div><div ng-message=\"minlength\">\nOrder Number is short. Please insert at least 8 characters.</div><div ng-message=\"erro\">\nOrder Number does not exist. Please try another one, starting with *</div><div ng-message=\"opened\">\nOrder already opened.</div></div><div ng-if=\"recordForm.scanorderid.$pending\">Loading, please wait...</div><div \nng-if=\"recordForm.scanorderid.$valid\">Opening order, please wait...</div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/dld/templates/scanorder.html","<md-dialog flex=\"20\" class=\"adddeliveryroute\" aria-label=\"Scan Order\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2>Scan Order</h2><span\n flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><h3>Scan your order barcode or insert order number</h3><div layout=\"row\" flex \nlayout-align=\"start center\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Order Number</label><input \ntype=\"text\" required md-autofocus name=\"scanorderid\" minlength=\"8\" maxlength=\"8\" ng-model=\"vm.scanorderid\" scan-order>\n<div ng-messages=\"recordForm.scanorderid.$error\"><div ng-message=\"required\">\nPlease scan order barcode or insert an Order Number, starting with *</div><div ng-message=\"maxlength\">\nOrder Number is too long. Please insert only 8 characters.</div><div ng-message=\"minlength\">\nOrder Number is short. Please insert at least 8 characters.</div><div ng-message=\"erro\">\nOrder Number does not exist. Please try another one, starting with *</div><div ng-message=\"opened\">\nOrder already opened.</div></div><div ng-if=\"recordForm.scanorderid.$pending\">Loading, please wait...</div><div \nng-if=\"recordForm.scanorderid.$valid\">Opening order, please wait...</div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/templates/adddeliveryroute.tpl.html","<md-dialog flex=\"20\" class=\"adddeliveryroute\" aria-label=\"Add Delivery Route\" ngapp=\"caseType\" ng-cloak><form \nname=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" \nng-model=\"vm.order.orders_id\" ng-init=\"vm.order.orders_id=id\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nAdd Delivery Route</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\">\n<md-input-container flex \nmd-is-error=\"recordForm.deliveryroutes_id.$invalid && (recordForm.deliveryroutes_id.$touched || recordForm.$submitted)\">\n<label>Delivery Route</label><md-select name=\"deliveryroutes_id\" ng-model=\"vm.order.deliveryroutes_id\"><md-option \nng-repeat=\"(index,droute) in ctrlz.droutes\" ng-value=\"droute.deliveryroutes_id\" \nng-selected=\"index == \'{{ctrlz.deliveryroutes_id}}\'\">{{droute.route}}</md-option></md-select><div \nng-messages=\"recordForm.deliveryroutes_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease choose a delivery route.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" \ntype=\"submit\" ng-click=\"recordForm.$valid && gravar(vm.order)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/templates/addnewlinkorder.tpl.html","<md-dialog flex=\"20\" class=\"adddeliveryroute\" aria-label=\"Link New Order\" ngapp=\"caseType\" ng-cloak><form \nname=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" \nng-model=\"vm.order.orders_linked_id\" ng-init=\"vm.order.orders_linked_id=\'0\'\"> <input type=\"hidden\" \nng-model=\"vm.order.orders_id\" ng-init=\"vm.order.orders_id=id\"> <input type=\"hidden\" \nng-model=\"vm.order.linkedto_orders_id\" ng-init=\"vm.order.linkedto_orders_id=linkedtoid\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Link New Order</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex \nlayout-align=\"start center\"><md-autocomplete flex validate-dropdown md-input-name=\"autocompleteField\" \nmd-no-cache=\"ctrlx.noCache\" md-selected-item=\"ctrlx.selectedItem\" \nmd-search-text-change=\"ctrlx.searchTextChange(ctrlx.searchText)\" md-search-text=\"ctrlx.searchText\" \nmd-items=\"item in ctrlx.listorders\" md-item-text=\"item.ordernumber\" \nmd-selected-item-change=\"ctrlx.selectedOrderIdChange(item)\" md-input-minlength=\"2\" md-input-maxlength=\"18\" required \nmd-required-match=\"true\" md-floating-label=\"Order Number\" md-autofocus><md-item-template><span \nmd-highlight-text=\"ctrlx.searchText\" md-highlight-flags=\"^i\">{{item.ordernumber}}</span></md-item-template><div \nng-messages=\"recordForm.autocompleteField.$error\" ng-if=\"recordForm.autocompleteField.$touched\"><div \nng-message=\"required\">Please insert an order number.</div><div ng-message=\"md-require-match\">\nPlease insert a valid order number.</div></div></md-autocomplete></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" \ntype=\"submit\" ng-click=\"recordForm.$valid && gravar(vm.order)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/templates/dldactions.html","<div class=\"dldactions-page\" layout=\"column\" layout-align=\"start center\"><div class=\"full-width\" \nng-repeat=\"action in vm.dldactions\"><div layout=\"row\" layout-align=\"start center\"><div class=\"department\"><strong>\nDepartment: </strong>{{action.department_name}}</div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"user\"><strong>User: </strong>{{action.name}}</div></div><div flex layout=\"row\" layout-align=\"start center\"><div \nclass=\"date\"><strong>Date/Time: </strong>{{action.date}}</div></div><md-divider class=\"margem-divisoria\"></md-divider>\n</div></div>");
$templateCache.put("app/main/pages/go/templates/lab-doc-popup.html","<md-dialog class=\"order-alert\" aria-label=\"Add Lab Doc\" ng-cloak><form name=\"myForm\"><input type=\"hidden\" \nng-model=\"orders_id\" ng-init=\"orders_id=id\"> <input type=\"hidden\" ng-model=\"users_id\" ng-init=\"users_id=userid\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2>Add Lab Doc</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex \nlayout-align=\"start center\"><div ngf-drop ngf-select ng-model=\"files\" class=\"drop-box\" \nngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" accept=\"image/*,application/pdf\" \nngf-pattern=\"\'image/*,application/pdf\'\">Drop files here<br>or<br>click to upload</div><div ngf-no-file-drop>\nFile Drag/Drop is not supported for this browser</div></div><div layout=\"row\" flex layout-align=\"start center\" \nng-if=\"files\">File(s):<ul><li ng-repeat=\"f in files\" style=\"font:smaller\">{{f.name}} {{f.$error}} {{f.$errorParam}}\n</li></ul></div><div layout=\"row\" flex layout-align=\"start center\" ng-if=\"determinateValue>0 && determinateValue<100\">\n<md-progress-linear md-mode=\"determinate\" value=\"{{determinateValue}}\"></md-progress-linear></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Close</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/pages/go/templates/labdoc.html","<div class=\"max-box\" layout=\"column\" layout-align=\"start center\" ng-cloak><div class=\"product-box full-width\"><div \nflex layout=\"row\" layout-align=\"end center\" ng-click=\"vm.addLabDoc($event)\"><div><md-button \nclass=\"md-icon-button botao-produtos\"><md-icon md-font-icon=\"icon-plus\" class=\"s12 md-font icon-plus botao-add\" \naria-hidden=\"true\"></md-icon></md-button></div><div><md-button class=\"md-icon-button botao-produtos\"><md-icon \nmd-font-icon=\"icon-file-document\" class=\"s24 md-font icon-file-document\" aria-hidden=\"true\"></md-icon></md-button>\n</div></div><div flex layout=\"row\" layout-align=\"start center\" ng-repeat=\"labdoc in vm.labdocs\"><a \nhref=\"{{vm.uploadpath}}{{labdoc.filename}}\" target=\"_blank\" title=\"Open {{labdoc.filetitle}}\"><md-input-container \nclass=\"md-block nomargin\"><input type=\"text\" value=\"{{labdoc.filetitle}}\" disabled=\"disabled\"></md-input-container></a>\n<a href=\"#\" ng-click=\"vm.removeLabDoc($event,labdoc.orders_lab_docs_id)\" title=\"Remove Lab Doc\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s12 md-font\" aria-hidden=\"true\" aria-label=\"Remove Lab Doc\"></md-icon></a>\n</div></div></div>");
$templateCache.put("app/main/pages/go/templates/linkedorders.html","<div class=\"max-box\" layout=\"column\" layout-align=\"start center\"><div class=\"product-box full-width\"><div flex \nlayout=\"row\" layout-align=\"end center\" ng-click=\"vm.addNewLinkOrder($event)\"><div><md-button \nclass=\"md-icon-button botao-produtos\"><md-icon md-font-icon=\"icon-plus\" class=\"s12 md-font icon-plus botao-add\" \naria-hidden=\"true\"></md-icon></md-button></div><div><md-button class=\"md-icon-button botao-produtos\"><md-icon \nmd-font-icon=\"icon-file-document\" class=\"s24 md-font icon-file-document\" aria-hidden=\"true\"></md-icon></md-button>\n</div></div><div flex layout=\"row\" layout-align=\"start center\" ng-repeat=\"linked in vm.linkedorders\">\n<md-input-container class=\"md-block nomargin\"><input type=\"text\" value=\"Order No {{linked.ordernumber}}\" \ndisabled=\"disabled\"></md-input-container><a href=\"#\" ng-click=\"vm.removeLinkedOrder($event,linked.orders_linked_id)\" \ntitle=\"Remove Order\"><md-icon md-font-icon=\"icon-window-close\" class=\"s12 md-font\" aria-hidden=\"true\" \naria-label=\"Remove Order\"></md-icon></a></div></div></div>");
$templateCache.put("app/main/pages/go/templates/ordercomments.html","<div class=\"ordercomments-page\" layout=\"column\" layout-align=\"start center\"><div class=\"full-width\" \nng-repeat=\"comment in vm.comments\"><div layout=\"row\" layout-align=\"start center\"><div class=\"comment\">\n{{comment.comment}}</div></div><div layout=\"row\" layout-align=\"end center\"><div class=\"user\">\n{{comment.name}}, {{comment.date}}</div></div><div class=\"margem-divisoria\"></div></div></div><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.orders_comments_id\" \nng-init=\"vm.record.orders_comments_id=\'0\'\"> <input type=\"hidden\" ng-model=\"vm.record.orders_id\" \nng-init=\"vm.record.orders_id=vm.id\"> <input type=\"hidden\" ng-model=\"vm.record.users_id\" \nng-init=\"vm.record.users_id=vm.userid\"><div class=\"ordercomments-add\" layout=\"row\" flex layout-align=\"start center\">\n<md-input-container flex \nmd-is-error=\"recordForm.comment.$invalid && (recordForm.comment.$touched || recordForm.$submitted)\"><label>Add Comment:\n</label><textarea rows=\"5\" name=\"comment\" ng-model=\"vm.record.comment\" required></textarea><div \nng-messages=\"recordForm.comment.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert a message.</span>\n</div></div></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-primary md-raised\" type=\"submit\" ng-click=\"recordForm.$valid && vm.addNewMessage(vm.record)\">Save</md-button>\n</div></form>");
$templateCache.put("app/main/pages/go/templates/products.html","<div class=\"products\" layout=\"column\" layout-align=\"start center\"><div class=\"product-box full-width\"><div \nclass=\"product-option product-blue\">Upper</div><div class=\"md-raised md-button full-width\" aria-label=\"Treatment Plan\" \nlayout=\"row\" layout-align=\"start center\"><div flex layout=\"row\" layout-align=\"start center\"><label>Treatment Plan\n</label></div><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"s12 md-font icon-plus botao-add\" aria-hidden=\"true\"></md-icon><md-icon md-font-icon=\"icon-file-document\" \nclass=\"s24 md-font icon-file-document\" aria-hidden=\"true\"></md-icon></div></div><div \nclass=\"md-raised md-button full-width\" aria-label=\"Products\" layout=\"row\" layout-align=\"start center\"><div flex \nlayout=\"row\" layout-align=\"start center\"><label>Products</label></div></div></div><div class=\"product-box full-width\">\n<div class=\"product-option product-blue\">Lower</div><div class=\"md-raised md-button full-width\" \naria-label=\"Treatment Plan\" layout=\"row\" layout-align=\"start center\"><div flex layout=\"row\" \nlayout-align=\"start center\"><label><div class=\"info-small\"><span style=\"font-size:smaller\">Products</span></div><div \nclass=\"info-normal\">Clear Products</div></label></div><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-click=\"vm.removeProducts($event,id)\" md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font icon-window-close botao-add\" aria-hidden=\"true\"></md-icon></div></div><table \nclass=\"simple products-lower\" ms-responsive><thead><tr><td width=\"50%\">Products</td><td width=\"10%\">Qty</td><td \nwidth=\"10%\">Discount</td><td width=\"25%\">Price</td><td width=\"5%\"></td></tr></thead><tbody><tr \nng-repeat=\"product in vm.products\"><td><md-input-container class=\"md-block\" title=\"{{product.product_description}}\">\n<input type=\"text\" name=\"product_description\" ng-model=\"product.product_description\" disabled=\"disabled\" \naria-label=\"Product\"></md-input-container></td><td><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"product_qty\" ng-model=\"product.product_qty\" disabled=\"disabled\" aria-label=\"Quantity\"></md-input-container></td>\n<td><md-input-container class=\"md-block\"><input type=\"text\" name=\"product_discount\" \nng-model=\"product.product_discount\" disabled=\"disabled\" aria-label=\"Discount\"></md-input-container></td><td>\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"rate\" ng-model=\"product.rate\" disabled=\"disabled\" \naria-label=\"Price\"></md-input-container></td><td><a href=\"#\" \nng-click=\"vm.removeProduct($event,product.orders_product_id)\" title=\"Remove Product\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s20 md-font remove-product\" aria-hidden=\"true\" aria-label=\"Remove Product\">\n</md-icon></a></td></tr></tbody></table><div flex layout=\"row\" layout-align=\"end center\"><div><md-button \nclass=\"md-icon-button botao-produtos\" ng-click=\"addNewProduct($event)\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"s12 md-font icon-plus botao-add\" aria-hidden=\"true\"></md-icon></md-button></div><div><md-button \nclass=\"md-icon-button botao-produtos\" ng-click=\"addNewProduct($event)\"><md-icon md-font-icon=\"icon-file-document\" \nclass=\"s24 md-font icon-file-document\" aria-hidden=\"true\"></md-icon></md-button></div></div></div><div \nclass=\"product-box full-width\"><div class=\"product-option product-grey\">Delivery</div><div \nclass=\"md-raised md-button full-width\" aria-label=\"Delivery\" layout=\"row\" layout-align=\"start center\" \nng-click=\"vm.addNewDeliveryRoute($event)\"><div flex layout=\"row\" class=\"pointer\" layout-align=\"start center\"><label>\nDelivery Route</label></div><div flex layout=\"row\" layout-align=\"end center\"><div><md-icon md-font-icon=\"icon-plus\" \nclass=\"s12 md-font icon-plus botao-add\" aria-hidden=\"true\"></md-icon></div><div><md-icon \nmd-font-icon=\"icon-file-document\" class=\"s24 md-font icon-file-document\" aria-hidden=\"true\"></md-icon></div></div>\n</div><table class=\"simple products-delivery\" ms-responsive ng-if=\"vm.id!=0\"><thead><tr><td width=\"80%\"></td><td \nwidth=\"20%\">Cost</td><td width=\"5%\"></td></tr></thead><tbody><tr><td><md-input-container class=\"md-block\" \nng-repeat=\"delivery in vm.order\" ng-if=\"delivery.deliveryroutes_id!=0\"><input type=\"text\" value=\"{{delivery.route}}\" \ndisabled=\"disabled\" aria-label=\"Delivery Route\"></md-input-container></td><td><md-input-container class=\"md-block\" \nng-repeat=\"delivery in vm.order\" ng-if=\"delivery.deliveryroutes_id!=0\"><input type=\"text\" value=\"{{delivery.rate}}\" \ndisabled=\"disabled\" aria-label=\"Cost\"></md-input-container></td><td><a href=\"#\" title=\"Remove Delivery Route\" \nng-click=\"vm.removeDeliveryRoute($event)\" ng-repeat=\"delivery in vm.order\" ng-if=\"delivery.deliveryroutes_id!=0\">\n<md-icon md-font-icon=\"icon-window-close\" class=\"s12 md-font remove-product\" aria-hidden=\"true\" \naria-label=\"Remove Product\"></md-icon></a></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/pages/invoice/templates/addnewproduct.html","<md-dialog class=\"searchpopup\" aria-label=\"Add Product\" ng-cloak><form class=\"addnewproduct\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Add Product</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-padding\" flex \nlayout=\"row\" layout-align=\"center center\"><md-input-container flex=\"80\" class=\"md-block\"><label>Search Product</label>\n<input ng-model=\"octrl.search\" ng-change=\"octrl.searchTable(octrl.search, 0)\" type=\"text\"></md-input-container>\n<md-button flex ng-click=\"octrl.reset()\" class=\"md-primary md-raised\">Reset</md-button></div><div layout=\"row\" \nclass=\"md-dialog-content\"><table datatable=\"\" class=\"tabela-pesquisa producttable\" ms-responsive-table \ndt-instance=\"octrl.dtInstance\" dt-options=\"octrl.dtOptions\" dt-columns=\"octrl.dtColumns\"></table></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nclass=\"md-green-500-bg branco\" ng-if=\"octrl.itemabrir && octrl.itemabrir.length==1\" ng-click=\"gravar(octrl.itemabrir)\">\nAdd Product</md-button><md-button class=\"md-green-500-bg branco\" ng-if=\"octrl.itemabrir && octrl.itemabrir.length>1\" \nng-click=\"gravar(octrl.itemabrir)\">Add {{octrl.itemabrir.length}} Products</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/invoice/templates/currentorders.html","<div class=\"max-box\" layout=\"column\" layout-align=\"start center\"><div class=\"product-box full-width\"><div layout=\"row\" \nng-if=\"vm.invoice.invoices_status == 0 && vm.disabled == false\"><div layout=\"row\" flex=\"50\" \nlayout-align=\"center center\"><a href=\"#\" ng-click=\"vm.disabled == false ? vm.addAll(0) : \'\'\">Add Selected</a></div><div\n layout=\"row\" flex=\"50\" layout-align=\"center center\"><a href=\"#\" ng-click=\"vm.disabled == false ? vm.addAll(1) : \'\'\">\nAdd All</a></div></div><div ng-repeat=\"(index,order) in vm.current_orders track by $index\" \nclass=\"md-raised md-button full-width\" ng-click=\"vm.disabled == false ? vm.toggleCheckbox(index) : \'\'\" \nng-class=\"{\'md-green-bg branco\': order.verified == 1, \'no-pointer\': order.verified != 1, \'md-grey-bg branco\': order.status_id == 5 && order.verified == 0}\" \naria-label=\"Order Number {{order.ordernumber}}\" layout=\"row\" layout-align=\"start center\">\nOrder No. {{order.ordernumber}} |&nbsp; <span ng-if=\"order.patient_name != null\" style=\"text-transform:uppercase\">\n{{order.patient_name}}</span> <span ng-if=\"order.patient_name == null && order.patient_ref != null\" \nstyle=\"text-transform:uppercase\">{{order.patient_ref}}</span><md-tooltip ng-if=\"order.verified == 1\" \nmd-direction=\"top\">Click to select order</md-tooltip><md-checkbox class=\"ordercheck\" \nng-if=\"order.verified == 1 && vm.invoice.invoices_status == 0\" ng-model=\"order.checked\" \nng-click=\"vm.disabled == false ? vm.toggleCheckbox(index) : \'\'\" aria-label=\"Order\"></md-checkbox></div><p \nng-hide=\"vm.current_orders.length\" class=\"center\">There are no orders.</p></div></div>");
$templateCache.put("app/main/pages/invoice/templates/invoiceactions.html","<div class=\"dldactions-page\" layout=\"column\" layout-align=\"start center\"><div class=\"full-width\" \nng-repeat=\"action in vm.dldactions\"><div layout=\"row\" layout-align=\"start center\"><div class=\"department\"><strong>\nDepartment: </strong>{{action.department_name}}</div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"user\"><strong>User: </strong>{{action.name}}</div></div><div flex layout=\"row\" layout-align=\"start center\"><div \nclass=\"date\"><strong>Date/Time: </strong>{{action.date}}</div></div><md-divider class=\"margem-divisoria\"></md-divider>\n</div></div>");
$templateCache.put("app/main/pages/invoice/templates/oninvoice.html","<div class=\"max-box\" layout=\"column\" layout-align=\"start center\"><div class=\"product-box full-width\"><div layout=\"row\" \nng-if=\"vm.invoice.invoices_status == 0\"><div layout=\"row\" flex layout-align=\"center center\"><a href=\"#\" \nng-click=\"vm.removeAllOrders()\">Remove All</a></div></div><div ng-repeat=\"order in vm.invoices_orders\" \nclass=\"md-raised md-button full-width cor-cabecalho branco\" aria-label=\"Order Number \" layout=\"row\" \nlayout-align=\"start center\">Order No. {{order.ordernumber}} |&nbsp; <span ng-if=\"order.patient_name != null\" \nstyle=\"text-transform:uppercase\">{{order.patient_name}}</span> <span \nng-if=\"order.patient_name == null && order.patient_ref != null\" style=\"text-transform:uppercase\">{{order.patient_ref}}\n</span> <a href=\"#\" ng-if=\"vm.invoice.invoices_status == 0\" ng-click=\"vm.removeOrder($event, order.orders_id)\" \ntitle=\"Remove Order\"><md-icon md-font-icon=\"icon-window-close\" class=\"s20 md-font remove-order branco\" \naria-hidden=\"true\" aria-label=\"Remove Order\"><md-tooltip md-direction=\"top\">Click to remove this order</md-tooltip>\n</md-icon></a></div><p ng-hide=\"vm.invoices_orders.length\" class=\"center\">There are no invoiced orders.</p></div></div>");
$templateCache.put("app/main/pages/invoice/templates/scaninvoice.html","<md-dialog flex=\"20\" class=\"adddeliveryroute\" aria-label=\"Scan Order\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2>Scan Invoice</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><h3>Scan your invoice barcode or insert invoice number</h3><div layout=\"row\" flex \nlayout-align=\"start center\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Invoice Number</label><input \ntype=\"text\" required md-autofocus name=\"scaninvoiceid\" minlength=\"9\" maxlength=\"9\" ng-model=\"vm.scaninvoiceid\" \nscan-invoice><div ng-messages=\"recordForm.scaninvoiceid.$error\"><div ng-message=\"required\">\nPlease scan invoice barcode or insert an Invoice Number, starting with *</div><div ng-message=\"maxlength\">\nInvoice Number is too long. Please insert only 9 characters.</div><div ng-message=\"minlength\">\nInvoice Number is short. Please insert at least 9 characters.</div><div ng-message=\"erro\">\nInvoice Number does not exist. Please try another one, starting with *</div><div ng-message=\"opened\">\nInvoice already opened.</div></div><div ng-if=\"recordForm.scaninvoiceid.$pending\">Loading, please wait...</div><div \nng-if=\"recordForm.scaninvoiceid.$valid\">Opening order, please wait...</div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/invoice/templates/search.html","<md-dialog class=\"searchpopup\" aria-label=\"Search\" ng-cloak><form class=\"casetype\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Search Invoice</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"estado-funcoes\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"estado-funcoes-esq\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-primary md-raised\">Scan</md-button><md-icon \nmd-font-icon=\"icon-barcode\" class=\"s48 md-default-theme md-font material-icons icon-barcode\" aria-hidden=\"true\">\n</md-icon></div><div class=\"estado-funcoes-dir\" layout=\"row\" layout-align=\"end center\" ng-click=\"octrl.reset()\">\n<md-button class=\"md-primary md-raised\">Reset</md-button><md-icon md-font-icon=\"icon-refresh\" \nclass=\"s36 md-default-theme md-font material-icons icon-refresh pointer\" aria-hidden=\"true\"></md-icon></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>\nStart date (yyyy-mm-dd)</label><input type=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"octrl.startDate\" \nng-change=\"octrl.searchTable(octrl.startDate, 14)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>End date (yyyy-mm-dd)</label><input type=\"text\" \nname=\"endDate\" mask=\"9999-19-39\" ng-model=\"octrl.endDate\" ng-change=\"octrl.searchTable(octrl.endDate, 15)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>Creation Date (yyyy-mm-dd)</label><input type=\"text\" name=\"onDate\" mask=\"9999-19-39\" ng-model=\"octrl.onDate\" \nng-change=\"octrl.searchTable(octrl.onDate, 13)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>Invoice No</label><input \nng-model=\"octrl.search.invoice_number\" ng-change=\"octrl.searchTable(octrl.search.invoice_number, 0)\" type=\"text\">\n</md-input-container><md-input-container layout=\"row\" flex class=\"md-block\"><label>Client Name</label><input \ntype=\"text\" ng-model=\"octrl.search.clientname\" ng-change=\"octrl.searchTable(octrl.search.clientname, 11)\">\n</md-input-container></div><div layout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>\nPractice Name</label><input type=\"text\" ng-model=\"octrl.search.pratice_name\" \nng-change=\"octrl.searchTable(octrl.search.pratice_name, 5)\"></md-input-container><md-input-container layout=\"row\" flex \nclass=\"md-block\"><label>Practice No</label><input type=\"text\" ng-model=\"octrl.search.practice_number\" \nng-change=\"octrl.searchTable(octrl.search.practice_number, 6)\"></md-input-container><md-input-container layout=\"row\" \nflex class=\"md-block\"><label>Client</label><input ng-model=\"octrl.search.performername\" \nng-change=\"octrl.searchTable(octrl.search.performername, 7)\" type=\"text\"></md-input-container><md-input-container \nlayout=\"row\" flex class=\"md-block\"><label>GDC No</label><input ng-model=\"octrl.search.gdc_number\" \nng-change=\"octrl.searchTable(octrl.search.gdc_number, 8)\" type=\"text\"></md-input-container></div><div layout=\"row\">\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>City</label><input ng-model=\"octrl.search.ccity\" \nng-change=\"octrl.searchTable(octrl.search.ccity, 2)\" type=\"text\"></md-input-container><md-input-container layout=\"row\" \nflex class=\"md-block\"><label>Country</label><input ng-model=\"octrl.search.ccountry\" \nng-change=\"octrl.searchTable(octrl.search.ccountry, 3)\" type=\"text\"></md-input-container><md-input-container \nlayout=\"row\" flex class=\"md-block\"><label>Postcode</label><input ng-model=\"octrl.search.cpostcode\" \nng-change=\"octrl.searchTable(octrl.search.cpostcode, 4)\" type=\"text\"></md-input-container><md-input-container flex \nclass=\"md-block\"><label>Invoice Status</label><md-select ng-model=\"octrl.search.invoices_status\" \nng-change=\"octrl.searchTable(octrl.search.invoices_status, 12)\"><md-option value=\"1\">Consolidated</md-option><md-option\n value=\"0\">Non-Consolidated</md-option></md-select></md-input-container></div><div layout=\"row\" \nclass=\"md-dialog-content tabela-small\"><table datatable=\"\" class=\"simple tabela-pesquisa\" ms-responsive-table \ndt-instance=\"octrl.dtInstance\" dt-options=\"octrl.dtOptions\" dt-columns=\"octrl.dtColumns\"></table></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"cancel()\">Close</md-button><md-button \nclass=\"md-green-500-bg branco\" ng-if=\"octrl.itemabrir && octrl.itemabrir.length==1\" ng-click=\"gravar(octrl.itemabrir)\">\nOpen Invoice</md-button><md-button class=\"md-green-500-bg branco\" ng-if=\"octrl.itemabrir && octrl.itemabrir.length>1\" \nng-click=\"gravar(octrl.itemabrir)\">Open {{octrl.itemabrir.length}} Invoices</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/invoice/templates/sendinvoice.html","<md-dialog flex=\"40\" aria-label=\"Send Invoice\"><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"octrl.record.invoices_id\" ng-init=\"octrl.record.invoices_id=id\"><md-toolbar \nclass=\"md-default-theme\"><div class=\"md-toolbar-tools\"><h2>Send Invoice</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\"><md-input-container \nng-if=\"octrl.record.emailto.length<2\" flex \nmd-is-error=\"recordForm.emailto.$invalid && (recordForm.emailto.$touched || recordForm.$submitted)\"><label>E-mail\n</label><input type=\"text\" name=\"emailto\" ng-model=\"octrl.record.emailto\" required \nng-pattern=\"/^[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\\.[a-zA-Z]{2,4}$/\"><div ng-messages=\"recordForm.emailto.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Please insert an e-mail.</span></div><div ng-message=\"pattern\"><span>\nPlease insert a valid e-mail.</span></div></div></md-input-container><md-input-container \nng-if=\"octrl.record.emailto.length>1\" flex \nmd-is-error=\"recordForm.emailto.$invalid && (recordForm.emailto.$touched || recordForm.$submitted)\"><label>E-mail\n</label><md-select name=\"emailto\" ng-model=\"octrl.record.emailto\" multiple=\"true\" disabled=\"disabled\"><md-option \nng-repeat=\"email in octrl.record.emailto\" ng-value=\"email\">{{email}}</md-option></md-select></md-input-container></div>\n<div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex \nmd-is-error=\"recordForm.message.$invalid && (recordForm.message.$touched || recordForm.$submitted)\"><label>Message\n</label><textarea rows=\"5\" name=\"message\" ng-model=\"octrl.record.message\" required></textarea><div \nng-messages=\"recordForm.message.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert a message.</span>\n</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" \nng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(octrl.record)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/members/others/addpic.html","<md-dialog class=\"order-alert\" aria-label=\"Upload Profile Picture\" ng-cloak><form name=\"myForm\"><input type=\"hidden\" \nng-model=\"users_id\" ng-init=\"users_id=userid\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Upload Profile Picture</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\"><div ng-disabled=\"pctrl.disabled\" \nngf-drop ngf-select ng-model=\"file\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"false\" \nngf-allow-dir=\"true\" accept=\"image/*\" \nngf-resize=\"{width: 110, height: 130, quality: 0.8,centerCrop: false, type: \'image/jpeg\',\r\n                        pattern=\'.jpg\', restoreExif: false}\" \nngf-pattern=\"\'image/*\'\">Drop file here<br>or<br>click to upload</div><div ngf-no-file-drop>\nFile Drag/Drop is not supported for this browser</div></div><div layout=\"row\" flex layout-align=\"start center\" \nng-if=\"file\">File(s):<ul><li ng-repeat=\"f in file\" style=\"font:smaller\">{{f.name}} {{f.$error}} {{f.$errorParam}}</li>\n</ul></div><div layout=\"row\" flex layout-align=\"start center\" \nng-if=\"pctrl.determinateValue>0 && pctrl.determinateValue<100\"><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{pctrl.determinateValue}}\"></md-progress-linear></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button type=\"submit\" ng-click=\"cancel()\">Close</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/members/others/holidays.html","<md-dialog class=\"order-alert\" aria-label=\"Holidays Settings\" ng-cloak><form name=\"insere\" \nng-submit=\"submitForm(insere.$valid)\" novalidate><input type=\"hidden\" ng-model=\"pctrl.holidays.settings.users_id\" \nng-init=\"pctrl.holidays.settings.users_id=pctrl.userid\"> <input type=\"hidden\" \nng-if=\"!pctrl.holidays.settings.holidays_user_settings_id\" \nng-model=\"pctrl.holidays.settings.holidays_user_settings_id\" \nng-init=\"pctrl.holidays.settings.holidays_user_settings_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nHolidays Settings</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><h3>Holiday Allowance</h3><div layout=\"row\" \nclass=\"full-width\"><div flex=\"50\"><md-input-container \nmd-is-error=\"insere.allowance_days.$invalid && (insere.allowance_days.$touched || insere.$submitted)\" flex \nlayout=\"row\" class=\"full-width md-block\"><label>Allowance Days</label><input type=\"text\" name=\"allowance_days\" \nng-model=\"pctrl.holidays.settings.allowance_days\" required><div ng-messages=\"insere.allowance_days.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Please insert the allowance days.</span></div></div></md-input-container>\n</div><div flex=\"50\"><span ng-if=\"pctrl.remainingcdays > 0\" style=\"color:green\">{{pctrl.remainingcdays}} Remaining Days\n</span> <span ng-if=\"pctrl.remainingcdays < 1\" style=\"color:red\">{{pctrl.remainingcdays}} Remaining Days</span> <span \nng-if=\"pctrl.remainingpdays > 0 && pctrl.remainingpdays < pctrl.holidays.settings.allowance_days\" \nstyle=\"color:green;font-size:smaller\"><br>(+ {{pctrl.remainingpdays}} from previous year)</span></div></div><div \nclass=\"m-20\"></div><div layout=\"row\" class=\"full-width\"><div flex=\"50\"><md-input-container flex class=\"md-block\" \nmoment-picker=\"pctrl.holidays.settings.month_start\" format=\"YYYY-MM-DD\" start-view=\"year\" autoclose=\"pctrl.autoclose\">\n<label>Start Month/Day Range</label><input class=\"form-control\" ng-value=\"pctrl.holidays.settings.month_start\" \nvalue=\"{{pctrl.holidays.settings.month_start}}\"></md-input-container></div><div flex><md-input-container flex \nclass=\"md-block\" moment-picker=\"pctrl.holidays.settings.month_finish\" format=\"YYYY-MM-DD\" start-view=\"year\" \nmin-date=\"pctrl.holidays.settings.month_start\" autoclose=\"pctrl.autoclose\"><label>End Month/Day Range</label><input \nclass=\"form-control\" ng-value=\"pctrl.holidays.settings.month_finish\" value=\"{{pctrl.holidays.settings.month_finish}}\">\n</md-input-container></div></div><h3>History</h3><div layout=\"row\"><div flex layout=\"column\"><div flex=\"100\" \nlayout=\"row\"><div flex>Date (Current)</div><div flex=\"25\">Days</div></div><div class=\"m-5\"></div><div \nng-if=\"pctrl.holidayscurr\" flex=\"100\" layout=\"row\" ng-repeat=\"datec in pctrl.holidayscurr\"><div flex>\n{{datec.from_request_date | cmdate:\'dd-MM-yyyy\'}} - {{datec.to_request_date | cmdate:\'dd-MM-yyyy\'}}</div><div \nflex=\"25\">{{datec.totaldays}} Days</div></div></div></div><div class=\"m-20\"></div><div layout=\"row\"><div flex \nlayout=\"column\"><div flex=\"100\" layout=\"row\"><div flex>Date (Previous)</div><div flex=\"25\">Days</div></div><div \nclass=\"m-5\"></div><div ng-if=\"pctrl.holidaysprev\" flex=\"100\" layout=\"row\" ng-repeat=\"datep in pctrl.holidaysprev\"><div \nflex>{{datep.from_request_date | cmdate:\'dd-MM-yyyy\'}} - {{datep.to_request_date | cmdate:\'dd-MM-yyyy\'}}</div><div \nflex=\"25\">{{datep.totaldays}} Days</div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><div>\n<md-button type=\"submit\" class=\"md-primary\" ng-click=\"cancel()\">Cancel</md-button></div><md-button \nclass=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"pctrl.disabled == false ? gravar(pctrl.holidays) : \'\'\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/members/others/userprivileges.html","<md-dialog flex=\"80\" id=\"userprivileges\" aria-label=\"User Privileges\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-if=\"!pctrl.member.user_privileges_id\" \nng-model=\"pctrl.member.user_privileges_id\" ng-init=\"pctrl.member.user_privileges_id=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[0].privileges.view\" ng-model=\"pctrl.member.privileges[0].privileges.view\" \nng-init=\"pctrl.member.privileges[0].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[1].privileges.view\" ng-model=\"pctrl.member.privileges[1].privileges.view\" \nng-init=\"pctrl.member.privileges[1].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[2].privileges.view\" ng-model=\"pctrl.member.privileges[2].privileges.view\" \nng-init=\"pctrl.member.privileges[2].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[3].privileges.view\" ng-model=\"pctrl.member.privileges[3].privileges.view\" \nng-init=\"pctrl.member.privileges[3].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[4].privileges.view\" ng-model=\"pctrl.member.privileges[4].privileges.view\" \nng-init=\"pctrl.member.privileges[4].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[5].privileges.view\" ng-model=\"pctrl.member.privileges[5].privileges.view\" \nng-init=\"pctrl.member.privileges[5].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[6].privileges.view\" ng-model=\"pctrl.member.privileges[6].privileges.view\" \nng-init=\"pctrl.member.privileges[6].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[7].privileges.view\" ng-model=\"pctrl.member.privileges[7].privileges.view\" \nng-init=\"pctrl.member.privileges[7].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[8].privileges.view\" ng-model=\"pctrl.member.privileges[8].privileges.view\" \nng-init=\"pctrl.member.privileges[8].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[9].privileges.view\" ng-model=\"pctrl.member.privileges[9].privileges.view\" \nng-init=\"pctrl.member.privileges[9].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[10].privileges.view\" ng-model=\"pctrl.member.privileges[10].privileges.view\" \nng-init=\"pctrl.member.privileges[10].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[11].privileges.view\" ng-model=\"pctrl.member.privileges[11].privileges.view\" \nng-init=\"pctrl.member.privileges[11].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[12].privileges.view\" ng-model=\"pctrl.member.privileges[12].privileges.view\" \nng-init=\"pctrl.member.privileges[12].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[13].privileges.view\" ng-model=\"pctrl.member.privileges[13].privileges.view\" \nng-init=\"pctrl.member.privileges[13].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[14].privileges.view\" ng-model=\"pctrl.member.privileges[14].privileges.view\" \nng-init=\"pctrl.member.privileges[14].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[15].privileges.view\" ng-model=\"pctrl.member.privileges[15].privileges.view\" \nng-init=\"pctrl.member.privileges[15].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[16].privileges.view\" ng-model=\"pctrl.member.privileges[16].privileges.view\" \nng-init=\"pctrl.member.privileges[16].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[17].privileges.view\" ng-model=\"pctrl.member.privileges[17].privileges.view\" \nng-init=\"pctrl.member.privileges[17].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[18].privileges.view\" ng-model=\"pctrl.member.privileges[18].privileges.view\" \nng-init=\"pctrl.member.privileges[18].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[19].privileges.view\" ng-model=\"pctrl.member.privileges[19].privileges.view\" \nng-init=\"pctrl.member.privileges[19].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[20].privileges.view\" ng-model=\"pctrl.member.privileges[20].privileges.view\" \nng-init=\"pctrl.member.privileges[20].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[21].privileges.view\" ng-model=\"pctrl.member.privileges[21].privileges.view\" \nng-init=\"pctrl.member.privileges[21].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[22].privileges.view\" ng-model=\"pctrl.member.privileges[22].privileges.view\" \nng-init=\"pctrl.member.privileges[22].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[23].privileges.view\" ng-model=\"pctrl.member.privileges[23].privileges.view\" \nng-init=\"pctrl.member.privileges[23].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[24].privileges.view\" ng-model=\"pctrl.member.privileges[24].privileges.view\" \nng-init=\"pctrl.member.privileges[24].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[25].privileges.view\" ng-model=\"pctrl.member.privileges[25].privileges.view\" \nng-init=\"pctrl.member.privileges[25].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[26].privileges.view\" ng-model=\"pctrl.member.privileges[26].privileges.view\" \nng-init=\"pctrl.member.privileges[26].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[27].privileges.view\" ng-model=\"pctrl.member.privileges[27].privileges.view\" \nng-init=\"pctrl.member.privileges[27].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[28].privileges.view\" ng-model=\"pctrl.member.privileges[28].privileges.view\" \nng-init=\"pctrl.member.privileges[28].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[29].privileges.view\" ng-model=\"pctrl.member.privileges[29].privileges.view\" \nng-init=\"pctrl.member.privileges[29].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[30].privileges.view\" ng-model=\"pctrl.member.privileges[30].privileges.view\" \nng-init=\"pctrl.member.privileges[30].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[31].privileges.view\" ng-model=\"pctrl.member.privileges[31].privileges.view\" \nng-init=\"pctrl.member.privileges[31].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[32].privileges.view\" ng-model=\"pctrl.member.privileges[32].privileges.view\" \nng-init=\"pctrl.member.privileges[32].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[33].privileges.view\" ng-model=\"pctrl.member.privileges[33].privileges.view\" \nng-init=\"pctrl.member.privileges[33].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[34].privileges.view\" ng-model=\"pctrl.member.privileges[34].privileges.view\" \nng-init=\"pctrl.member.privileges[34].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[35].privileges.view\" ng-model=\"pctrl.member.privileges[35].privileges.view\" \nng-init=\"pctrl.member.privileges[35].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[36].privileges.view\" ng-model=\"pctrl.member.privileges[36].privileges.view\" \nng-init=\"pctrl.member.privileges[36].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[37].privileges.view\" ng-model=\"pctrl.member.privileges[37].privileges.view\" \nng-init=\"pctrl.member.privileges[37].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[38].privileges.view\" ng-model=\"pctrl.member.privileges[38].privileges.view\" \nng-init=\"pctrl.member.privileges[38].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[39].privileges.view\" ng-model=\"pctrl.member.privileges[39].privileges.view\" \nng-init=\"pctrl.member.privileges[39].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[40].privileges.view\" ng-model=\"pctrl.member.privileges[40].privileges.view\" \nng-init=\"pctrl.member.privileges[40].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[41].privileges.view\" ng-model=\"pctrl.member.privileges[41].privileges.view\" \nng-init=\"pctrl.member.privileges[41].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[42].privileges.view\" ng-model=\"pctrl.member.privileges[42].privileges.view\" \nng-init=\"pctrl.member.privileges[42].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[43].privileges.view\" ng-model=\"pctrl.member.privileges[43].privileges.view\" \nng-init=\"pctrl.member.privileges[43].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[44].privileges.view\" ng-model=\"pctrl.member.privileges[44].privileges.view\" \nng-init=\"pctrl.member.privileges[44].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[45].privileges.view\" ng-model=\"pctrl.member.privileges[45].privileges.view\" \nng-init=\"pctrl.member.privileges[45].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[46].privileges.view\" ng-model=\"pctrl.member.privileges[46].privileges.view\" \nng-init=\"pctrl.member.privileges[46].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[47].privileges.view\" ng-model=\"pctrl.member.privileges[47].privileges.view\" \nng-init=\"pctrl.member.privileges[47].privileges.view=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[0].privileges.edit\" ng-model=\"pctrl.member.privileges[0].privileges.edit\" \nng-init=\"pctrl.member.privileges[0].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[1].privileges.edit\" ng-model=\"pctrl.member.privileges[1].privileges.edit\" \nng-init=\"pctrl.member.privileges[1].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[2].privileges.edit\" ng-model=\"pctrl.member.privileges[2].privileges.edit\" \nng-init=\"pctrl.member.privileges[2].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[3].privileges.edit\" ng-model=\"pctrl.member.privileges[3].privileges.edit\" \nng-init=\"pctrl.member.privileges[3].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[4].privileges.edit\" ng-model=\"pctrl.member.privileges[4].privileges.edit\" \nng-init=\"pctrl.member.privileges[4].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[5].privileges.edit\" ng-model=\"pctrl.member.privileges[5].privileges.edit\" \nng-init=\"pctrl.member.privileges[5].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[6].privileges.edit\" ng-model=\"pctrl.member.privileges[6].privileges.edit\" \nng-init=\"pctrl.member.privileges[6].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[7].privileges.edit\" ng-model=\"pctrl.member.privileges[7].privileges.edit\" \nng-init=\"pctrl.member.privileges[7].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[8].privileges.edit\" ng-model=\"pctrl.member.privileges[8].privileges.edit\" \nng-init=\"pctrl.member.privileges[8].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[9].privileges.edit\" ng-model=\"pctrl.member.privileges[9].privileges.edit\" \nng-init=\"pctrl.member.privileges[9].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[10].privileges.edit\" ng-model=\"pctrl.member.privileges[10].privileges.edit\" \nng-init=\"pctrl.member.privileges[10].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[11].privileges.edit\" ng-model=\"pctrl.member.privileges[11].privileges.edit\" \nng-init=\"pctrl.member.privileges[11].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[12].privileges.edit\" ng-model=\"pctrl.member.privileges[12].privileges.edit\" \nng-init=\"pctrl.member.privileges[12].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[13].privileges.edit\" ng-model=\"pctrl.member.privileges[13].privileges.edit\" \nng-init=\"pctrl.member.privileges[13].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[14].privileges.edit\" ng-model=\"pctrl.member.privileges[14].privileges.edit\" \nng-init=\"pctrl.member.privileges[14].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[15].privileges.edit\" ng-model=\"pctrl.member.privileges[15].privileges.edit\" \nng-init=\"pctrl.member.privileges[15].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[16].privileges.edit\" ng-model=\"pctrl.member.privileges[16].privileges.edit\" \nng-init=\"pctrl.member.privileges[16].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[17].privileges.edit\" ng-model=\"pctrl.member.privileges[17].privileges.edit\" \nng-init=\"pctrl.member.privileges[17].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[18].privileges.edit\" ng-model=\"pctrl.member.privileges[18].privileges.edit\" \nng-init=\"pctrl.member.privileges[18].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[19].privileges.edit\" ng-model=\"pctrl.member.privileges[19].privileges.edit\" \nng-init=\"pctrl.member.privileges[19].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[20].privileges.edit\" ng-model=\"pctrl.member.privileges[20].privileges.edit\" \nng-init=\"pctrl.member.privileges[20].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[21].privileges.edit\" ng-model=\"pctrl.member.privileges[21].privileges.edit\" \nng-init=\"pctrl.member.privileges[21].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[22].privileges.edit\" ng-model=\"pctrl.member.privileges[22].privileges.edit\" \nng-init=\"pctrl.member.privileges[22].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[23].privileges.edit\" ng-model=\"pctrl.member.privileges[23].privileges.edit\" \nng-init=\"pctrl.member.privileges[23].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[24].privileges.edit\" ng-model=\"pctrl.member.privileges[24].privileges.edit\" \nng-init=\"pctrl.member.privileges[24].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[25].privileges.edit\" ng-model=\"pctrl.member.privileges[25].privileges.edit\" \nng-init=\"pctrl.member.privileges[25].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[26].privileges.edit\" ng-model=\"pctrl.member.privileges[26].privileges.edit\" \nng-init=\"pctrl.member.privileges[26].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[27].privileges.edit\" ng-model=\"pctrl.member.privileges[27].privileges.edit\" \nng-init=\"pctrl.member.privileges[27].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[28].privileges.edit\" ng-model=\"pctrl.member.privileges[28].privileges.edit\" \nng-init=\"pctrl.member.privileges[28].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[29].privileges.edit\" ng-model=\"pctrl.member.privileges[29].privileges.edit\" \nng-init=\"pctrl.member.privileges[29].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[30].privileges.edit\" ng-model=\"pctrl.member.privileges[30].privileges.edit\" \nng-init=\"pctrl.member.privileges[30].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[31].privileges.edit\" ng-model=\"pctrl.member.privileges[31].privileges.edit\" \nng-init=\"pctrl.member.privileges[31].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[32].privileges.edit\" ng-model=\"pctrl.member.privileges[32].privileges.edit\" \nng-init=\"pctrl.member.privileges[32].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[33].privileges.edit\" ng-model=\"pctrl.member.privileges[33].privileges.edit\" \nng-init=\"pctrl.member.privileges[33].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[34].privileges.edit\" ng-model=\"pctrl.member.privileges[34].privileges.edit\" \nng-init=\"pctrl.member.privileges[34].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[35].privileges.edit\" ng-model=\"pctrl.member.privileges[35].privileges.edit\" \nng-init=\"pctrl.member.privileges[35].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[36].privileges.edit\" ng-model=\"pctrl.member.privileges[36].privileges.edit\" \nng-init=\"pctrl.member.privileges[36].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[37].privileges.edit\" ng-model=\"pctrl.member.privileges[37].privileges.edit\" \nng-init=\"pctrl.member.privileges[37].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[38].privileges.edit\" ng-model=\"pctrl.member.privileges[38].privileges.edit\" \nng-init=\"pctrl.member.privileges[38].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[39].privileges.edit\" ng-model=\"pctrl.member.privileges[39].privileges.edit\" \nng-init=\"pctrl.member.privileges[39].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[40].privileges.edit\" ng-model=\"pctrl.member.privileges[40].privileges.edit\" \nng-init=\"pctrl.member.privileges[40].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[41].privileges.edit\" ng-model=\"pctrl.member.privileges[41].privileges.edit\" \nng-init=\"pctrl.member.privileges[41].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[42].privileges.edit\" ng-model=\"pctrl.member.privileges[42].privileges.edit\" \nng-init=\"pctrl.member.privileges[42].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[43].privileges.edit\" ng-model=\"pctrl.member.privileges[43].privileges.edit\" \nng-init=\"pctrl.member.privileges[43].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[44].privileges.edit\" ng-model=\"pctrl.member.privileges[44].privileges.edit\" \nng-init=\"pctrl.member.privileges[44].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[45].privileges.edit\" ng-model=\"pctrl.member.privileges[45].privileges.edit\" \nng-init=\"pctrl.member.privileges[45].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[46].privileges.edit\" ng-model=\"pctrl.member.privileges[46].privileges.edit\" \nng-init=\"pctrl.member.privileges[46].privileges.edit=\'0\'\"> <input type=\"hidden\" \nng-if=\"!pctrl.member.privileges[47].privileges.edit\" ng-model=\"pctrl.member.privileges[47].privileges.edit\" \nng-init=\"pctrl.member.privileges[47].privileges.edit=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nUser Privileges:</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div flex layout=\"row\"><div flex=\"50\" layout=\"row\" \nclass=\"production-bg department-header\"><div flex=\"75\" layout=\"row\" layout-align=\"center center\" \nclass=\"full-width branco\"><h3>Production</h3></div><md-checkbox flex class=\"small-text correct-upper2 branco\" \nlayout=\"row\" layout-align=\"end center\" ng-model=\"pctrl.production\" ng-true-value=\"1\" ng-true-false=\"0\" \nng-change=\"pctrl.selectDeselect(1)\" aria-label=\"Check All Production Options\"><label>Select/Unselect ALL</label>\n</md-checkbox></div><div flex=\"50\" layout=\"row\" class=\"invoicing-bg department-header\"><div flex=\"75\" layout=\"row\" \nlayout-align=\"center center\" class=\"full-width branco\"><h3>Invoicing | Products | Clients</h3></div><md-checkbox flex \nclass=\"small-text correct-upper2 branco\" layout=\"row\" layout-align=\"end center\" ng-model=\"pctrl.invoicing\" \nng-true-value=\"1\" ng-true-false=\"0\" ng-change=\"pctrl.selectDeselect(2)\" aria-label=\"Check All Invoicing Options\">\n<label>Select/Unselect ALL</label></md-checkbox></div></div><div flex layout=\"row\"><div flex=\"50\" layout=\"row\"><table \nflex=\"50\"><thead><tr><th></th><th>View</th><th>Edit</th></tr></thead><tbody><tr><td>Go</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[1].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Go View\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[1].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td>Plaster Room</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[2].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Plaster Room View\"></md-checkbox></td><td><md-checkbox \nng-model=\"pctrl.member.privileges[2].privileges.edit\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Plaster Room Edit\"></md-checkbox></td></tr><tr><td class=\"department-header-production\">3D</td><td></td>\n<td></td></tr><tr><td>Scanning</td><td><md-checkbox ng-model=\"pctrl.member.privileges[3].privileges.view\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td><md-checkbox \nng-model=\"pctrl.member.privileges[3].privileges.edit\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Go Edit\">\n</md-checkbox></td></tr><tr><td>Platforms</td><td><md-checkbox ng-model=\"pctrl.member.privileges[4].privileges.view\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td><md-checkbox \nng-model=\"pctrl.member.privileges[4].privileges.edit\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Go Edit\">\n</md-checkbox></td></tr><tr><td>Designing</td><td><md-checkbox ng-model=\"pctrl.member.privileges[5].privileges.view\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td><md-checkbox \nng-model=\"pctrl.member.privileges[5].privileges.edit\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Go Edit\">\n</md-checkbox></td></tr><tr><td>Manufacturing</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[6].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[6].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td class=\"department-header-production\">Implants\n</td><td></td><td></td></tr><tr><td>Matching</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[7].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[7].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td>Planning</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[8].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[8].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td>Drilling Guide Design</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[9].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[9].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td>Upload Lab Doc</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[10].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[10].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td>DLD & Order Location</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[11].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[11].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr></tbody></table><table flex=\"50\"><thead><tr><th \nclass=\"department-header-production\">Clear Aligner</th><th>View</th><th>Edit</th></tr></thead><tbody><tr><td>\nCase Assessment</td><td><md-checkbox ng-model=\"pctrl.member.privileges[12].privileges.view\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td><md-checkbox \nng-model=\"pctrl.member.privileges[12].privileges.edit\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Go Edit\">\n</md-checkbox></td></tr><tr><td>Clear Movement</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[13].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[13].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td>Bracket Movement</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[14].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[14].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td>Manufacturing</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[15].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[15].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td>Inman Aligner</td><td></td><td></td></tr><tr>\n<td>Case Assessment</td><td><md-checkbox ng-model=\"pctrl.member.privileges[16].privileges.view\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td><md-checkbox \nng-model=\"pctrl.member.privileges[16].privileges.edit\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Go Edit\">\n</md-checkbox></td></tr><tr><td>Movement</td><td><md-checkbox ng-model=\"pctrl.member.privileges[17].privileges.view\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td><md-checkbox \nng-model=\"pctrl.member.privileges[17].privileges.edit\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Go Edit\">\n</md-checkbox></td></tr><tr><td>Manufacturing</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[18].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[18].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td></td><td></td><td></td></tr><tr><td>Shipping\n</td><td><md-checkbox ng-model=\"pctrl.member.privileges[19].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Upper\"></md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[19].privileges.edit\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td>Waiting for Call</td><td>\n<md-checkbox ng-model=\"pctrl.member.privileges[20].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Upper\"></md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[20].privileges.edit\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td>Packaging</td><td><md-checkbox\n ng-model=\"pctrl.member.privileges[21].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[21].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td>Order Status</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[22].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[22].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr></tbody></table></div><div flex=\"50\" layout=\"row\"><table\n flex=\"50\"><thead><tr><th class=\"department-header-production\">Invoicing</th><th>View</th><th>Edit</th></tr></thead>\n<tbody><tr><td>Generate Invoice</td><td><md-checkbox ng-model=\"pctrl.member.privileges[23].privileges.view\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td><md-checkbox \nng-model=\"pctrl.member.privileges[23].privileges.edit\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Go Edit\">\n</md-checkbox></td></tr><tr><td>Invoice Search</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[24].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[24].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td>Consolidation</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[25].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[25].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td class=\"department-header-invoicing\">\nProducts & Groups</td><td></td><td></td></tr><tr><td>Products</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[26].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[26].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td>Product Price Change</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[27].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[27].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td>Product Groups</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[28].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[28].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td>Delivery Routes</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[29].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[29].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr></tbody></table><table flex=\"50\"><thead><tr><th></th>\n<th>View</th><th>Edit</th></tr></thead><tbody><tr><td>Client Status</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[30].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[30].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td>Report</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[31].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[31].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td>Order Status</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[32].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[32].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td class=\"department-header-invoicing\">Clients</td>\n<td></td><td></td></tr><tr><td>Profiles</td><td><md-checkbox ng-model=\"pctrl.member.privileges[33].privileges.view\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td><md-checkbox \nng-model=\"pctrl.member.privileges[33].privileges.edit\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Go Edit\">\n</md-checkbox></td></tr><tr><td>Settings</td><td><md-checkbox ng-model=\"pctrl.member.privileges[34].privileges.view\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td><md-checkbox \nng-model=\"pctrl.member.privileges[34].privileges.edit\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Go Edit\">\n</md-checkbox></td></tr></tbody></table></div></div><div flex layout=\"row\"><div flex=\"50\" layout=\"row\" \nclass=\"analytics-bg department-header\"><div flex=\"75\" layout=\"row\" layout-align=\"center center\" \nclass=\"full-width branco\"><h3>Analytics</h3></div><md-checkbox flex class=\"small-text correct-upper2 branco\" \nlayout=\"row\" layout-align=\"end center\" ng-model=\"pctrl.analytics\" ng-true-value=\"1\" ng-true-false=\"0\" \nng-change=\"pctrl.selectDeselect(3)\" aria-label=\"Check All Production Options\"><label>Select/Unselect ALL</label>\n</md-checkbox></div><div flex=\"50\" layout=\"row\" class=\"system-bg department-header\"><div flex=\"75\" layout=\"row\" \nlayout-align=\"center center\" class=\"full-width branco\"><h3>System Settings</h3></div><md-checkbox flex \nclass=\"small-text correct-upper2 branco\" layout=\"row\" layout-align=\"end center\" ng-model=\"pctrl.system\" \nng-true-value=\"1\" ng-true-false=\"0\" ng-change=\"pctrl.selectDeselect(4)\" aria-label=\"Check All Invoicing Options\">\n<label>Select/Unselect ALL</label></md-checkbox></div></div><div flex layout=\"row\"><div flex=\"50\" layout=\"row\"><table \nflex=\"50\"><thead><tr><th></th><th>View</th><th>Edit</th></tr></thead><tbody><tr><td>MD</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[35].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[35].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td>Inman</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[36].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[36].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td>Invoicing</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[37].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[37].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr></tbody></table><table flex=\"50\"><thead><tr><th></th>\n<th>View</th><th>Edit</th></tr></thead><tbody><tr><td>3D</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[38].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[38].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td>Accounts</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[39].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[39].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td>Points</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[40].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[40].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr></tbody></table></div><div flex=\"50\" layout=\"row\"><table\n flex=\"50\"><thead><tr><th></th><th>View</th><th>Edit</th></tr></thead><tbody><tr><td>Members</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[41].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[41].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr></tbody></table><table flex=\"50\"><thead><tr><th></th>\n<th></th><th></th></tr></thead><tbody><tr><td></td><td></td><td></td></tr></tbody></table></div></div><div flex \nlayout=\"row\"><div flex=\"50\" layout=\"row\" class=\"lab-bg department-header\"><div flex=\"75\" layout=\"row\" \nlayout-align=\"center center\" class=\"full-width branco\"><h3>Nimrodental Lab</h3></div><md-checkbox flex \nclass=\"small-text correct-upper2 branco\" layout=\"row\" layout-align=\"end center\" ng-model=\"pctrl.lab\" ng-true-value=\"1\" \nng-true-false=\"0\" ng-change=\"pctrl.selectDeselect(5)\" aria-label=\"Check All Production Options\"><label>\nSelect/Unselect ALL</label></md-checkbox></div><div flex=\"50\" layout=\"row\" class=\"marketing-bg department-header\"><div \nflex=\"75\" layout=\"row\" layout-align=\"center center\" class=\"full-width branco\"><h3>Marketing</h3></div><md-checkbox \nflex class=\"small-text correct-upper2 branco\" layout=\"row\" layout-align=\"end center\" ng-model=\"pctrl.marketing\" \nng-true-value=\"1\" ng-true-false=\"0\" ng-change=\"pctrl.selectDeselect(6)\" aria-label=\"Check All Invoicing Options\">\n<label>Select/Unselect ALL</label></md-checkbox></div></div><div flex layout=\"row\"><div flex=\"50\" layout=\"row\"><table \nflex=\"50\"><thead><tr><th></th><th>View</th><th>Edit</th></tr></thead><tbody><tr><td>Scheduling</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[42].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[42].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td>Check In / Out</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[43].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[43].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr></tbody></table><table flex=\"50\"><thead><tr><th></th>\n<th>View</th><th>Edit</th></tr></thead><tbody><tr><td>Holidays</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[44].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[44].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr><tr><td>Holidays Approval</td><td><md-checkbox \nng-model=\"pctrl.member.privileges[45].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\n</md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[45].privileges.edit\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr></tbody></table></div><div flex=\"50\" layout=\"row\"><table\n flex=\"50\"><thead><tr><th></th><th>View</th><th>Edit</th></tr></thead><tbody><tr><td>Events / Tasks</td><td>\n<md-checkbox ng-model=\"pctrl.member.privileges[46].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Upper\"></md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[46].privileges.edit\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr></tbody></table><table flex=\"50\">\n<thead><tr><th></th><th></th><th></th></tr></thead><tbody><tr><td></td><td></td><td></td></tr></tbody></table></div>\n</div><div flex layout=\"row\"><div flex=\"50\" layout=\"row\" class=\"rd-bg department-header\"><div flex=\"75\" layout=\"row\" \nlayout-align=\"center center\" class=\"full-width branco\"><h3>Research & Development</h3></div><md-checkbox flex \nclass=\"small-text correct-upper2 branco\" layout=\"row\" layout-align=\"end center\" ng-model=\"pctrl.rd\" ng-true-value=\"1\" \nng-true-false=\"0\" ng-change=\"pctrl.selectDeselect(7)\" aria-label=\"Check All Production Options\"><label>\nSelect/Unselect ALL</label></md-checkbox></div><div flex=\"50\" layout=\"row\"><div flex=\"75\" layout=\"row\" \nlayout-align=\"center center\" class=\"full-width branco\"></div></div></div><div flex layout=\"row\"><div flex=\"50\" \nlayout=\"row\"><table flex=\"50\"><thead><tr><th></th><th>View</th><th>Edit</th></tr></thead><tbody><tr><td>Events / Tasks\n</td><td><md-checkbox ng-model=\"pctrl.member.privileges[47].privileges.view\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Upper\"></md-checkbox></td><td><md-checkbox ng-model=\"pctrl.member.privileges[47].privileges.edit\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Go Edit\"></md-checkbox></td></tr></tbody></table><table flex=\"50\">\n<thead><tr><th></th><th></th><th></th></tr></thead><tbody><tr><td></td><td></td><td></td></tr></tbody></table></div>\n<div flex=\"50\" layout=\"row\"><table flex=\"50\"><thead><tr><th></th><th></th><th></th></tr></thead><tbody><tr><td></td>\n<td></td><td></td></tr></tbody></table><table flex=\"50\"><thead><tr><th></th><th></th><th></th></tr></thead><tbody><tr>\n<td></td><td></td><td></td></tr></tbody></table></div></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"pctrl.disabled == false ? recordForm.$valid && gravar(pctrl.member) : \'\'\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/departments/bracketmovement.html","<md-dialog aria-label=\"Bracket Movement\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"pctrl.bracketmovement.orders_id\" \nng-init=\"pctrl.bracketmovement.orders_id=id\"> <input type=\"hidden\" \nng-if=\"pctrl.bracketmovement.orders_bracket_movement_id\" ng-model=\"pctrl.bracketmovement.orders_bracket_movement_id\" \nng-init=\"pctrl.bracketmovement.orders_bracket_movement_id=pctrl.bracketmovement.orders_bracket_movement_id\"> <input \ntype=\"hidden\" ng-if=\"!pctrl.bracketmovement.orders_bracket_movement_id\" \nng-model=\"pctrl.bracketmovement.orders_bracket_movement_id\" \nng-init=\"pctrl.bracketmovement.orders_bracket_movement_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nBracket Movement</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"center center\"><div \nflex-xs flex=\"50\" layout=\"column\"><h3>Upper</h3><md-input-container flex \nmd-is-error=\"recordForm.upnumbrackets.$invalid && (recordForm.upnumbrackets.$touched || recordForm.$submitted)\" \nclass=\"md-block\" ng-disabled=\"pctrl.disabled\"><label>No of Brackets</label><md-select \nng-model=\"pctrl.bracketmovement.upnumbrackets\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option>\n<md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option \nvalue=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option value=\"9\">9\n</md-option><md-option value=\"10\">10</md-option><md-option value=\"11\">11</md-option><md-option value=\"12\">12\n</md-option><md-option value=\"13\">13</md-option><md-option value=\"14\">14</md-option><md-option value=\"15\">15\n</md-option><md-option value=\"16\">16</md-option></md-select><div ng-messages=\"recordForm.upnumbrackets.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Please choose an option.</span></div></div></md-input-container><div \nlayout=\"row\" class=\"md-padding\"><md-checkbox ng-model=\"pctrl.bracketmovement.upperstents\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Upper Stents\" ng-disabled=\"pctrl.disabled\">Stents</md-checkbox></div><div layout=\"row\" \nclass=\"md-padding\"><md-checkbox ng-model=\"pctrl.bracketmovement.uptreatmentplan\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Upper Treatment Plan\" ng-disabled=\"pctrl.disabled\">Treatment Plan</md-checkbox></div></div><div flex-xs \nflex=\"50\" layout=\"column\"><h3>Lower</h3><md-input-container flex \nmd-is-error=\"recordForm.lownumbrackets.$invalid && (recordForm.lownumbrackets.$touched || recordForm.$submitted)\" \nclass=\"md-block\"><label>No of Brackets</label><md-select ng-model=\"pctrl.bracketmovement.lownumbrackets\" \nng-disabled=\"pctrl.disabled\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3\n</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option>\n<md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option \nvalue=\"10\">10</md-option><md-option value=\"11\">11</md-option><md-option value=\"12\">12</md-option><md-option value=\"13\">\n13</md-option><md-option value=\"14\">14</md-option><md-option value=\"15\">15</md-option><md-option value=\"16\">16\n</md-option></md-select><div ng-messages=\"recordForm.lownumbrackets.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Please choose an option.</span></div></div></md-input-container><div layout=\"row\" class=\"md-padding\"><md-checkbox\n ng-model=\"pctrl.bracketmovement.lowerstents\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Lower Stents\">Stents</md-checkbox></div><div layout=\"row\" class=\"md-padding\"><md-checkbox \nng-model=\"pctrl.bracketmovement.low\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Lower Treatment Plan\">Treatment Plan</md-checkbox></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button ng-if=\"pctrl.disabled==false\" \nclass=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"recordForm.$valid && gravar(pctrl.bracketmovement)\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/departments/caseassessment.html","<md-dialog aria-label=\"Case Assessment\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"pctrl.caseassessment.orders_id\" ng-init=\"pctrl.caseassessment.orders_id=id\"> \n<input type=\"hidden\" ng-if=\"pctrl.caseassessment.orders_case_assessment_id\" \nng-model=\"pctrl.caseassessment.orders_case_assessment_id\" \nng-init=\"pctrl.caseassessment.orders_case_assessment_id=pctrl.caseassessment.orders_case_assessment_id\"> <input \ntype=\"hidden\" ng-if=\"!pctrl.caseassessment.orders_case_assessment_id\" \nng-model=\"pctrl.caseassessment.orders_case_assessment_id\" ng-init=\"pctrl.caseassessment.orders_case_assessment_id=\'0\'\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2>Case Assessment</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" \nlayout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\"><md-checkbox \nng-model=\"pctrl.caseassessment.upper\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Upper\">Upper</md-checkbox></div><md-input-container flex><label>Comments</label><textarea rows=\"5\" \nname=\"commentsupper\" ng-model=\"pctrl.caseassessment.commentsupper\"></textarea></md-input-container></div><div flex-xs \nflex=\"50\" layout=\"column\"><div layout=\"row\"><md-checkbox ng-model=\"pctrl.caseassessment.lower\" \nng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\">Lower</md-checkbox></div>\n<md-input-container flex><label>Comments</label><textarea rows=\"5\" name=\"commentslower\" ng-disabled=\"pctrl.disabled\" \nng-model=\"pctrl.caseassessment.commentslower\"></textarea></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button \nng-if=\"pctrl.disabled==false\" class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(pctrl.caseassessment)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/departments/clearmanufacturing.html","<md-dialog flex=\"30\" aria-label=\"Clear Appliances Manufacturing\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" \nng-model=\"pctrl.clearmanufacturing.orders_id\" ng-init=\"pctrl.clearmanufacturing.orders_id=id\"> <input type=\"hidden\" \nng-if=\"pctrl.clearmanufacturing.orders_clear_manufacturing_id\" \nng-model=\"pctrl.clearmanufacturing.orders_clear_manufacturing_id\" \nng-init=\"pctrl.clearmanufacturing.orders_clear_manufacturing_id=pctrl.clearmanufacturing.orders_clear_manufacturing_id\">\n <input type=\"hidden\" ng-if=\"!pctrl.clearmanufacturing.orders_clear_manufacturing_id\" \nng-model=\"pctrl.clearmanufacturing.orders_clear_manufacturing_id\" \nng-init=\"pctrl.clearmanufacturing.orders_clear_manufacturing_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nClear Appliances Manufacturing</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><fieldset><legend><h3>Clear Aligners</h3></legend><div \nlayout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\">\n<md-checkbox ng-model=\"pctrl.clearmanufacturing.upper\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Upper\">Upper</md-checkbox></div><md-input-container flex \nmd-is-error=\"recordForm.upnumclear.$invalid && (recordForm.upnumclear.$touched || recordForm.$submitted)\" \nclass=\"md-block\"><label>No. of Clear Aligners</label><md-select ng-model=\"pctrl.clearmanufacturing.upnumclear\" \nng-change=\"checkUpClears()\" ng-disabled=\"pctrl.disabled\"><md-option value=\"0\">0</md-option><md-option value=\"1\">1\n</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option>\n<md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option \nvalue=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option><md-option value=\"11\">11\n</md-option><md-option value=\"12\">12</md-option><md-option value=\"13\">13</md-option><md-option value=\"14\">14\n</md-option><md-option value=\"15\">15</md-option><md-option value=\"16\">16</md-option><md-option value=\"17\">17\n</md-option><md-option value=\"18\">18</md-option><md-option value=\"19\">19</md-option><md-option value=\"20\">20\n</md-option><md-option value=\"21\">21</md-option><md-option value=\"22\">22</md-option><md-option value=\"23\">23\n</md-option><md-option value=\"24\">24</md-option><md-option value=\"25\">25</md-option><md-option value=\"26\">26\n</md-option><md-option value=\"27\">27</md-option><md-option value=\"28\">28</md-option><md-option value=\"29\">29\n</md-option><md-option value=\"30\">30</md-option><md-option value=\"31\">31</md-option><md-option value=\"32\">32\n</md-option><md-option value=\"33\">33</md-option><md-option value=\"34\">34</md-option><md-option value=\"35\">35\n</md-option><md-option value=\"36\">36</md-option><md-option value=\"37\">37</md-option><md-option value=\"38\">38\n</md-option><md-option value=\"39\">39</md-option><md-option value=\"40\">40</md-option><md-option value=\"41\">41\n</md-option><md-option value=\"42\">42</md-option><md-option value=\"43\">43</md-option><md-option value=\"44\">44\n</md-option><md-option value=\"45\">45</md-option><md-option value=\"46\">46</md-option><md-option value=\"47\">47\n</md-option><md-option value=\"48\">48</md-option><md-option value=\"49\">49</md-option><md-option value=\"50\">50\n</md-option></md-select><div ng-messages=\"recordForm.upnumclear.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease choose an option.</span></div></div></md-input-container><md-input-container flex \nmd-is-error=\"recordForm.upnumtrays.$invalid && (recordForm.upnumtrays.$touched || recordForm.$submitted)\" \nclass=\"md-block\"><label>No. of Trays</label><md-select ng-model=\"pctrl.clearmanufacturing.upnumtrays\" \nng-change=\"checkUpTrays()\" ng-disabled=\"pctrl.disabled\"><md-option value=\"0\">0</md-option><md-option value=\"1\">1\n</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option>\n<md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option \nvalue=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option><md-option value=\"11\">11\n</md-option><md-option value=\"12\">12</md-option><md-option value=\"13\">13</md-option><md-option value=\"14\">14\n</md-option><md-option value=\"15\">15</md-option><md-option value=\"16\">16</md-option><md-option value=\"17\">17\n</md-option><md-option value=\"18\">18</md-option><md-option value=\"19\">19</md-option><md-option value=\"20\">20\n</md-option><md-option value=\"21\">21</md-option><md-option value=\"22\">22</md-option><md-option value=\"23\">23\n</md-option><md-option value=\"24\">24</md-option><md-option value=\"25\">25</md-option><md-option value=\"26\">26\n</md-option><md-option value=\"27\">27</md-option><md-option value=\"28\">28</md-option><md-option value=\"29\">29\n</md-option><md-option value=\"30\">30</md-option><md-option value=\"31\">31</md-option><md-option value=\"32\">32\n</md-option><md-option value=\"33\">33</md-option><md-option value=\"34\">34</md-option><md-option value=\"35\">35\n</md-option><md-option value=\"36\">36</md-option><md-option value=\"37\">37</md-option><md-option value=\"38\">38\n</md-option><md-option value=\"39\">39</md-option><md-option value=\"40\">40</md-option><md-option value=\"41\">41\n</md-option><md-option value=\"42\">42</md-option><md-option value=\"43\">43</md-option><md-option value=\"44\">44\n</md-option><md-option value=\"45\">45</md-option><md-option value=\"46\">46</md-option><md-option value=\"47\">47\n</md-option><md-option value=\"48\">48</md-option><md-option value=\"49\">49</md-option><md-option value=\"50\">50\n</md-option></md-select><div ng-messages=\"recordForm.upnumtrays.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease choose an option.</span></div></div></md-input-container><div layout=\"row\" class=\"md-padding\"><md-checkbox \nng-model=\"pctrl.clearmanufacturing.upstentsup\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Upper Up Stents\">Stents</md-checkbox></div></div><div flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" \nclass=\"md-padding\"><md-checkbox ng-model=\"pctrl.clearmanufacturing.lower\" ng-disabled=\"pctrl.disabled\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\">Lower</md-checkbox></div><md-input-container flex \nclass=\"md-block\"><label>No. of Clear Aligners</label><md-select ng-model=\"pctrl.clearmanufacturing.lownumclear\" \nng-disabled=\"pctrl.disabled\" ng-change=\"checkLowClears()\"><md-option value=\"0\">0</md-option><md-option value=\"1\">1\n</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option>\n<md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option \nvalue=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option><md-option value=\"11\">11\n</md-option><md-option value=\"12\">12</md-option><md-option value=\"13\">13</md-option><md-option value=\"14\">14\n</md-option><md-option value=\"15\">15</md-option><md-option value=\"16\">16</md-option><md-option value=\"17\">17\n</md-option><md-option value=\"18\">18</md-option><md-option value=\"19\">19</md-option><md-option value=\"20\">20\n</md-option><md-option value=\"21\">21</md-option><md-option value=\"22\">22</md-option><md-option value=\"23\">23\n</md-option><md-option value=\"24\">24</md-option><md-option value=\"25\">25</md-option><md-option value=\"26\">26\n</md-option><md-option value=\"27\">27</md-option><md-option value=\"28\">28</md-option><md-option value=\"29\">29\n</md-option><md-option value=\"30\">30</md-option><md-option value=\"31\">31</md-option><md-option value=\"32\">32\n</md-option><md-option value=\"33\">33</md-option><md-option value=\"34\">34</md-option><md-option value=\"35\">35\n</md-option><md-option value=\"36\">36</md-option><md-option value=\"37\">37</md-option><md-option value=\"38\">38\n</md-option><md-option value=\"39\">39</md-option><md-option value=\"40\">40</md-option><md-option value=\"41\">41\n</md-option><md-option value=\"42\">42</md-option><md-option value=\"43\">43</md-option><md-option value=\"44\">44\n</md-option><md-option value=\"45\">45</md-option><md-option value=\"46\">46</md-option><md-option value=\"47\">47\n</md-option><md-option value=\"48\">48</md-option><md-option value=\"49\">49</md-option><md-option value=\"50\">50\n</md-option></md-select><div ng-messages=\"recordForm.lownumclear.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease choose an option.</span></div></div></md-input-container><md-input-container flex class=\"md-block\"><label>\nNo. of Trays</label><md-select ng-model=\"pctrl.clearmanufacturing.lownumtrays\" ng-change=\"checkLowTrays()\" \nng-disabled=\"pctrl.disabled\"><md-option value=\"0\">0</md-option><md-option value=\"1\">1</md-option><md-option value=\"2\">2\n</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option>\n<md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option \nvalue=\"9\">9</md-option><md-option value=\"10\">10</md-option><md-option value=\"11\">11</md-option><md-option value=\"12\">12\n</md-option><md-option value=\"13\">13</md-option><md-option value=\"14\">14</md-option><md-option value=\"15\">15\n</md-option><md-option value=\"16\">16</md-option><md-option value=\"17\">17</md-option><md-option value=\"18\">18\n</md-option><md-option value=\"19\">19</md-option><md-option value=\"20\">20</md-option><md-option value=\"21\">21\n</md-option><md-option value=\"22\">22</md-option><md-option value=\"23\">23</md-option><md-option value=\"24\">24\n</md-option><md-option value=\"25\">25</md-option><md-option value=\"26\">26</md-option><md-option value=\"27\">27\n</md-option><md-option value=\"28\">28</md-option><md-option value=\"29\">29</md-option><md-option value=\"30\">30\n</md-option><md-option value=\"31\">31</md-option><md-option value=\"32\">32</md-option><md-option value=\"33\">33\n</md-option><md-option value=\"34\">34</md-option><md-option value=\"35\">35</md-option><md-option value=\"36\">36\n</md-option><md-option value=\"37\">37</md-option><md-option value=\"38\">38</md-option><md-option value=\"39\">39\n</md-option><md-option value=\"40\">40</md-option><md-option value=\"41\">41</md-option><md-option value=\"42\">42\n</md-option><md-option value=\"43\">43</md-option><md-option value=\"44\">44</md-option><md-option value=\"45\">45\n</md-option><md-option value=\"46\">46</md-option><md-option value=\"47\">47</md-option><md-option value=\"48\">48\n</md-option><md-option value=\"49\">49</md-option><md-option value=\"50\">50</md-option></md-select></md-input-container>\n<div layout=\"row\" class=\"md-padding\"><md-checkbox ng-model=\"pctrl.clearmanufacturing.lowstentsup\" \nng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower Up Stents\">Stents</md-checkbox>\n</div></div></div></fieldset><fieldset><legend><h3>Bleaching Trays</h3></legend><div layout=\"row\" \nlayout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><md-checkbox \nng-model=\"pctrl.clearmanufacturing.bleachingupper\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Upper Bonded Fixed Retainer\">Upper</md-checkbox></div></div><div flex-xs flex=\"50\" layout=\"column\"><div \nlayout=\"row\" class=\"md-padding\"><md-checkbox ng-model=\"pctrl.clearmanufacturing.bleachinglower\" \nng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower Bonded Fixed Retainer\">Lower\n</md-checkbox></div></div></div></fieldset><fieldset><legend><h3>Essix Retainer</h3></legend><div layout=\"row\" \nlayout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-input-container flex class=\"md-block\"><label>\nNo. of Essix</label><md-select ng-model=\"pctrl.clearmanufacturing.upnumessix\" ng-disabled=\"pctrl.disabled\"><md-option \nvalue=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option></md-select>\n</md-input-container></div><div flex-xs flex=\"50\" layout=\"column\"><md-input-container flex class=\"md-block\"><label>\nNo. of Essix</label><md-select ng-model=\"pctrl.clearmanufacturing.lownumessix\" ng-disabled=\"pctrl.disabled\"><md-option \nvalue=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option></md-select>\n</md-input-container></div></div></fieldset><fieldset><legend><h3>Pull Down Splint</h3></legend><div layout=\"row\" \nlayout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><md-checkbox \nng-model=\"pctrl.clearmanufacturing.pulldownupper\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Upper Brackets\">Upper</md-checkbox></div></div><div flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" \nclass=\"md-padding\"><md-checkbox ng-model=\"pctrl.clearmanufacturing.pulldownlower\" ng-disabled=\"pctrl.disabled\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower Brackets\">Lower</md-checkbox></div></div></div></fieldset>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button>\n<md-button ng-if=\"pctrl.disabled==false\" class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(pctrl.clearmanufacturing)\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/production/departments/clearmovement.html","<md-dialog aria-label=\"Clear Movement\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"pctrl.clearmovement.orders_id\" ng-init=\"pctrl.clearmovement.orders_id=id\"> \n<input type=\"hidden\" ng-if=\"pctrl.clearmovement.orders_clear_movement_id\" \nng-model=\"pctrl.clearmovement.orders_clear_movement_id\" \nng-init=\"pctrl.clearmovement.orders_clear_movement_id=pctrl.clearmovement.orders_clear_movement_id\"> <input \ntype=\"hidden\" ng-if=\"!pctrl.clearmovement.orders_clear_movement_id\" \nng-model=\"pctrl.clearmovement.orders_clear_movement_id\" ng-init=\"pctrl.clearmovement.orders_clear_movement_id=\'0\'\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2>Clear Movement</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" \nlayout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><md-checkbox \nng-model=\"pctrl.clearmovement.upper\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Upper\">Upper</md-checkbox></div><md-input-container flex \nmd-is-error=\"recordForm.upnummodels.$invalid && (recordForm.upnummodels.$touched || recordForm.$submitted)\" \nclass=\"md-block\"><label>No of Models Generated</label><md-select ng-model=\"pctrl.clearmovement.upnummodels\" \nng-disabled=\"pctrl.disabled\"><md-option ng-repeat=\"n in [] | range:30\" value=\"{{$index+1}}\">{{$index+1}}</md-option>\n</md-select><div ng-messages=\"recordForm.upnummodels.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease choose an option.</span></div></div></md-input-container><div layout=\"row\" class=\"md-padding\"><md-checkbox \nng-model=\"pctrl.clearmovement.upstentsup\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Upper Stents Up\">Stents</md-checkbox></div><div layout=\"row\" class=\"md-padding\"><md-checkbox \nng-model=\"pctrl.clearmovement.uptreatmentplan\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Upper Treatment Plan\">Treatment Plan</md-checkbox></div><div layout=\"row\" class=\"md-padding\"><md-checkbox \nng-model=\"pctrl.clearmovement.upsetupplan\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Upper Setup Plan\">Setup Plan</md-checkbox></div></div><div flex-xs flex=\"50\" layout=\"column\"><div \nlayout=\"row\" class=\"md-padding\"><md-checkbox ng-model=\"pctrl.clearmovement.lower\" ng-disabled=\"pctrl.disabled\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\">Lower</md-checkbox></div><md-input-container flex \nmd-is-error=\"recordForm.lownummodels.$invalid && (recordForm.lownummodels.$touched || recordForm.$submitted)\" \nclass=\"md-block\"><label>No of Models Generated</label><md-select ng-model=\"pctrl.clearmovement.lownummodels\" \nng-disabled=\"pctrl.disabled\"><md-option ng-repeat=\"n in [] | range:30\" value=\"{{$index+1}}\">{{$index+1}}</md-option>\n</md-select><div ng-messages=\"recordForm.lownummodels.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease choose an option.</span></div></div></md-input-container><div layout=\"row\" class=\"md-padding\"><md-checkbox \nng-model=\"pctrl.clearmovement.lowstentsup\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Lower Stents Up\">Stents</md-checkbox></div><div layout=\"row\" class=\"md-padding\"><md-checkbox \nng-model=\"pctrl.clearmovement.lowtreatmentplan\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Lower Treatment Plan\">Treatment Plan</md-checkbox></div><div layout=\"row\" class=\"md-padding\"><md-checkbox \nng-model=\"pctrl.clearmovement.lowsetupplan\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Lower Setup Plan\">Setup Plan</md-checkbox></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button ng-if=\"pctrl.disabled==false\" \nclass=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"recordForm.$valid && gravar(pctrl.clearmovement)\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/departments/designing.html","<md-dialog aria-label=\"Designing\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"pctrl.designing.orders_id\" ng-init=\"pctrl.designing.orders_id=id\"> <input \ntype=\"hidden\" ng-if=\"pctrl.designing.orders_designing_id\" ng-model=\"pctrl.designing.orders_designing_id\" \nng-init=\"pctrl.designing.orders_designing_id=pctrl.designing.orders_designing_id\"> <input type=\"hidden\" \nng-if=\"!pctrl.designing.orders_designing_id\" ng-model=\"pctrl.designing.orders_designing_id\" \nng-init=\"pctrl.designing.orders_designing_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Designing</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\">\n<h3>Upper</h3><h4>Type of Work</h4><md-checkbox ng-model=\"pctrl.designing.upsplint\" ng-disabled=\"pctrl.disabled\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper Splint\">Splint</md-checkbox><md-checkbox \nng-model=\"pctrl.designing.upjigs\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Upper Jigs\">Jigs</md-checkbox><md-checkbox ng-model=\"pctrl.designing.upnimrodret\" \nng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper NimrodRetainer\">NimrodRetainer\n</md-checkbox><md-checkbox ng-model=\"pctrl.designing.upnimrodali\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Upper NimrodAligner\">NimrodAligner</md-checkbox><md-checkbox \nng-model=\"pctrl.designing.upstudymodels\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Upper Study Models\">Study Models</md-checkbox><md-checkbox ng-model=\"pctrl.designing.upimplant\" \nng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper Implant Guides\">Implant Guides\n</md-checkbox><md-checkbox ng-model=\"pctrl.designing.upmilled\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Upper Milled Bonded Retainer\">Milled Bonded Retainer</md-checkbox><md-checkbox \nng-model=\"pctrl.designing.up4x4\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Upper 4x4\">4x4</md-checkbox><md-input-container flex><label>Comments</label><textarea rows=\"5\" \nname=\"upcomments\" ng-disabled=\"pctrl.disabled\" ng-model=\"pctrl.designing.upcomments\"></textarea></md-input-container>\n</div><div flex-xs flex=\"50\" layout=\"column\"><h3>Lower</h3><h4>Type of Work</h4><md-checkbox \nng-model=\"pctrl.designing.lowsplint\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Lower Splint\">Splint</md-checkbox><md-checkbox ng-model=\"pctrl.designing.lowjigs\" \nng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower Jigs\">Jigs</md-checkbox><md-checkbox\n ng-model=\"pctrl.designing.lownimrodret\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Lower NimrodRetainer\">NimrodRetainer</md-checkbox><md-checkbox ng-model=\"pctrl.designing.lownimrodali\" \nng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower NimrodAligner\">NimrodAligner\n</md-checkbox><md-checkbox ng-model=\"pctrl.designing.lowstudymodels\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Lower Study Models\">Study Models</md-checkbox><md-checkbox \nng-model=\"pctrl.designing.lowimplant\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Lower Implant Guides\">Implant Guides</md-checkbox><md-checkbox ng-model=\"pctrl.designing.lowmilled\" \nng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower Milled Bonded Retainer\">\nMilled Bonded Retainer</md-checkbox><md-checkbox ng-model=\"pctrl.designing.low4x4\" ng-disabled=\"pctrl.disabled\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower 4x4\">4x4</md-checkbox><md-input-container flex><label>Comments\n</label><textarea rows=\"5\" name=\"lowcomments\" ng-disabled=\"pctrl.disabled\" ng-model=\"pctrl.designing.lowcomments\">\n</textarea></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \ntype=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button ng-if=\"pctrl.disabled==false\" \nclass=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"recordForm.$valid && gravar(pctrl.designing)\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/departments/drillingassembly.html","<md-dialog aria-label=\"Drilling Guide Assembly\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"pctrl.driassembly.orders_id\" \nng-init=\"pctrl.driassembly.orders_id=id\"> <input type=\"hidden\" ng-if=\"pctrl.driassembly.orders_drillingassembly_id\" \nng-model=\"pctrl.driassembly.orders_drillingassembly_id\" \nng-init=\"pctrl.driassembly.orders_drillingassembly_id=pctrl.driassembly.orders_drillingassembly_id\"> <input \ntype=\"hidden\" ng-if=\"!pctrl.driassembly.orders_drillingassembly_id\" \nng-model=\"pctrl.driassembly.orders_drillingassembly_id\" ng-init=\"pctrl.driassembly.orders_drillingassembly_id=\'0\'\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2>Drilling Guide Assembly</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-padding\"><div layout=\"row\" layout-align=\"center center\"><div flex-xs \nflex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" ng-disabled=\"pctrl.disabled\" \nng-model=\"pctrl.driassembly.upperlower\" name=\"upperlower\" value=\"1\" aria-label=\"Upper\">Upper</div></div><div flex-xs \nflex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" ng-disabled=\"pctrl.disabled\" \nng-model=\"pctrl.driassembly.upperlower\" name=\"upperlower\" value=\"2\" aria-label=\"Lower\">Lower</div></div></div><div \nlayout=\"row\" layout-align=\"center center\"><md-input-container flex \nmd-is-error=\"recordForm.numbersleeves.$invalid && (recordForm.numbersleeves.$touched || recordForm.$submitted)\" \nclass=\"md-block\"><label>No of Sleeves</label><md-select ng-model=\"pctrl.driassembly.numbersleeves\" \nng-disabled=\"pctrl.disabled\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3\n</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option>\n<md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option \nvalue=\"10\">10</md-option><md-option value=\"11\">11</md-option><md-option value=\"12\">12</md-option><md-option value=\"13\">\n13</md-option><md-option value=\"14\">14</md-option><md-option value=\"15\">15</md-option><md-option value=\"16\">16\n</md-option><md-option value=\"17\">17</md-option><md-option value=\"18\">18</md-option><md-option value=\"19\">19\n</md-option><md-option value=\"20\">20</md-option></md-select><div ng-messages=\"recordForm.numbersleeves.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Please choose an option.</span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button>\n<md-button ng-if=\"pctrl.disabled==false\" class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(pctrl.driassembly)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/departments/drillingdesign.html","<md-dialog aria-label=\"Drilling Guide Design\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"pctrl.dridesign.orders_id\" \nng-init=\"pctrl.dridesign.orders_id=id\"> <input type=\"hidden\" ng-if=\"pctrl.dridesign.orders_drillingdesign_id\" \nng-model=\"pctrl.dridesign.orders_drillingdesign_id\" \nng-init=\"pctrl.dridesign.orders_drillingdesign_id=pctrl.dridesign.orders_drillingdesign_id\"> <input type=\"hidden\" \nng-if=\"!pctrl.dridesign.orders_drillingdesign_id\" ng-model=\"pctrl.dridesign.orders_drillingdesign_id\" \nng-init=\"pctrl.dridesign.orders_drillingdesign_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nDrilling Guide Design</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-padding\"><div layout=\"row\" \nlayout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><md-checkbox \nng-model=\"pctrl.dridesign.upper\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">\nUpper</md-checkbox></div></div><div flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><md-checkbox\n ng-model=\"pctrl.dridesign.lower\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\">\nLower</md-checkbox></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" \nng-click=\"cancel()\">Cancel</md-button><md-button ng-if=\"pctrl.disabled==false\" class=\"md-green-500-bg branco\" \ntype=\"submit\" ng-click=\"recordForm.$valid && gravar(pctrl.dridesign)\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/production/departments/drillingprinting.html","<md-dialog aria-label=\"Drilling Guide Printing\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"pctrl.driprinting.orders_id\" \nng-init=\"pctrl.driprinting.orders_id=id\"> <input type=\"hidden\" ng-if=\"pctrl.driprinting.orders_drillingprinting_id\" \nng-model=\"pctrl.driprinting.orders_drillingprinting_id\" \nng-init=\"pctrl.driprinting.orders_drillingprinting_id=pctrl.driprinting.orders_drillingprinting_id\"> <input \ntype=\"hidden\" ng-if=\"!pctrl.driprinting.orders_drillingprinting_id\" \nng-model=\"pctrl.driprinting.orders_drillingprinting_id\" ng-init=\"pctrl.driprinting.orders_drillingprinting_id=\'0\'\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2>Drilling Guide Printing</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-padding\"><div layout=\"row\" layout-align=\"center center\"><div flex-xs \nflex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" ng-disabled=\"pctrl.disabled\" \nng-model=\"pctrl.driprinting.upperlower\" name=\"upperlower\" value=\"1\" aria-label=\"Upper\">Upper</div></div><div flex-xs \nflex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" ng-disabled=\"pctrl.disabled\" \nng-model=\"pctrl.driprinting.upperlower\" name=\"upperlower\" value=\"2\" aria-label=\"Lower\">Lower</div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button>\n<md-button ng-if=\"pctrl.disabled==false\" class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(pctrl.driprinting)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/departments/inmancaseassessment.html","<md-dialog aria-label=\"Case Assessment\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"pctrl.incaseassessment.orders_id\" \nng-init=\"pctrl.incaseassessment.orders_id=id\"> <input type=\"hidden\" \nng-if=\"pctrl.incaseassessment.orders_incase_assessment_id\" \nng-model=\"pctrl.incaseassessment.orders_incase_assessment_id\" \nng-init=\"pctrl.incaseassessment.orders_incase_assessment_id=pctrl.incaseassessment.orders_incase_assessment_id\"> <input\n type=\"hidden\" ng-if=\"!pctrl.incaseassessment.orders_incase_assessment_id\" \nng-model=\"pctrl.incaseassessment.orders_incase_assessment_id\" \nng-init=\"pctrl.incaseassessment.orders_incase_assessment_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nCase Assessment</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"center center\"><div \nflex-xs flex=\"50\" layout=\"column\"><div layout=\"row\"><md-checkbox ng-model=\"pctrl.incaseassessment.upper\" \nng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">Upper</md-checkbox></div>\n<md-input-container flex><label>Comments</label><textarea rows=\"5\" name=\"commentsupper\" ng-disabled=\"pctrl.disabled\" \nng-model=\"pctrl.incaseassessment.commentsupper\"></textarea></md-input-container><div layout=\"row\"><md-checkbox \nng-model=\"pctrl.incaseassessment.uptreatmentplan\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Upper Treatment Plan\">Treatment Plan</md-checkbox></div></div><div flex-xs flex=\"50\" layout=\"column\"><div \nlayout=\"row\"><md-checkbox ng-model=\"pctrl.incaseassessment.lower\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Lower\">Lower</md-checkbox></div><md-input-container flex><label>Comments</label><textarea\n rows=\"5\" name=\"commentslower\" ng-disabled=\"pctrl.disabled\" ng-model=\"pctrl.incaseassessment.commentslower\"></textarea>\n</md-input-container><div layout=\"row\"><md-checkbox ng-model=\"pctrl.incaseassessment.lowtreatmentplan\" \nng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower Treatment Plan\">Treatment Plan\n</md-checkbox></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" \nng-click=\"cancel()\">Cancel</md-button><md-button ng-if=\"pctrl.disabled==false\" class=\"md-green-500-bg branco\" \ntype=\"submit\" ng-click=\"recordForm.$valid && gravar(pctrl.incaseassessment)\">Save</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/pages/production/departments/inmanmanufacturing.html","<md-dialog aria-label=\"Inman Appliances Manufacturing\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"pctrl.inmanufacturing.orders_id\" \nng-init=\"pctrl.inmanufacturing.orders_id=id\"> <input type=\"hidden\" \nng-if=\"pctrl.inmanufacturing.orders_in_manufacturing_id\" ng-model=\"pctrl.inmanufacturing.orders_in_manufacturing_id\" \nng-init=\"pctrl.inmanufacturing.orders_in_manufacturing_id=pctrl.inmanufacturing.orders_in_manufacturing_id\"> <input \ntype=\"hidden\" ng-if=\"!pctrl.inmanufacturing.orders_in_manufacturing_id\" \nng-model=\"pctrl.inmanufacturing.orders_in_manufacturing_id\" \nng-init=\"pctrl.inmanufacturing.orders_in_manufacturing_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nInman Appliances Manufacturing</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><fieldset><legend><h3>Inman Aligner</h3></legend><div \nlayout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\">\n<md-checkbox ng-model=\"pctrl.inmanufacturing.upper\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Inman Aligner Upper\">Upper</md-checkbox></div></div><div flex-xs flex=\"50\" layout=\"column\"><div \nlayout=\"row\" class=\"md-padding\"><md-checkbox ng-model=\"pctrl.inmanufacturing.lower\" ng-disabled=\"pctrl.disabled\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Inman Aligner Lower\">Lower</md-checkbox></div></div></div></fieldset>\n<fieldset><legend><h3>Removeable Appliance</h3></legend><div layout=\"row\" layout-align=\"center center\"><div flex-xs \nflex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><md-checkbox \nng-model=\"pctrl.inmanufacturing.upremovable\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Removable Appliance Upper\">Upper</md-checkbox></div></div><div flex-xs flex=\"50\" layout=\"column\"><div \nlayout=\"row\" class=\"md-padding\"><md-checkbox ng-model=\"pctrl.inmanufacturing.loremovable\" ng-disabled=\"pctrl.disabled\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Removable Appliance Lower\">Lower</md-checkbox></div></div></div>\n</fieldset><fieldset><legend><h3>Fixed Appliances</h3></legend><div layout=\"row\" layout-align=\"center center\"><div \nflex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><md-checkbox \nng-model=\"pctrl.inmanufacturing.upfixedapp\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Fixed Appliances Upper\">Upper</md-checkbox></div></div><div flex-xs flex=\"50\" layout=\"column\"><div \nlayout=\"row\" class=\"md-padding\"><md-checkbox ng-model=\"pctrl.inmanufacturing.lofixedapp\" ng-disabled=\"pctrl.disabled\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Fixed Appliances Lower\">Lower</md-checkbox></div></div></div>\n</fieldset><fieldset><legend><h3>Nimrod Aligner</h3></legend><div layout=\"row\" layout-align=\"center center\"><div \nflex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><md-checkbox \nng-model=\"pctrl.inmanufacturing.upnimrodaligner\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Nimrod Aligner Upper\">Upper</md-checkbox></div></div><div flex-xs flex=\"50\" layout=\"column\"><div \nlayout=\"row\" class=\"md-padding\"><md-checkbox ng-model=\"pctrl.inmanufacturing.lonimrodaligner\" \nng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Nimrod Aligner Lower\">Lower</md-checkbox>\n</div></div></div></fieldset><fieldset><legend><h3>Heat Cure</h3></legend><div layout=\"row\" \nlayout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-checkbox \nng-model=\"pctrl.inmanufacturing.upheatcure\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Heat Cure Upper\">Upper</md-checkbox></div><div flex-xs flex=\"50\" layout=\"column\"><md-checkbox \nng-model=\"pctrl.inmanufacturing.loheatcure\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Heat Cure Lower\">Lower</md-checkbox></div></div></fieldset><div layout=\"row\" layout-align=\"center center\" \nclass=\"md-padding\"><md-checkbox ng-model=\"pctrl.inmanufacturing.functionalapp\" ng-disabled=\"pctrl.disabled\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Functional Appliance\">Functional Appliance</md-checkbox></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button>\n<md-button ng-if=\"pctrl.disabled==false\" class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(pctrl.inmanufacturing)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/departments/manufacturing.html","<md-dialog aria-label=\"Manufacturing\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"pctrl.manufacturing.orders_id\" ng-init=\"pctrl.manufacturing.orders_id=id\"> \n<input type=\"hidden\" ng-if=\"pctrl.manufacturing.orders_manufacturing_id\" \nng-model=\"pctrl.manufacturing.orders_manufacturing_id\" \nng-init=\"pctrl.manufacturing.orders_manufacturing_id=pctrl.manufacturing.orders_manufacturing_id\"> <input \ntype=\"hidden\" ng-if=\"!pctrl.manufacturing.orders_manufacturing_id\" \nng-model=\"pctrl.manufacturing.orders_manufacturing_id\" ng-init=\"pctrl.manufacturing.orders_manufacturing_id=\'0\'\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2>Manufacturing</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" \nlayout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><h3>Upper</h3><h4>Type of Work</h4><md-checkbox \nng-model=\"pctrl.manufacturing.upsplint\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Upper Splints\">Splints</md-checkbox><md-checkbox ng-model=\"pctrl.manufacturing.upfixed\" \nng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper Fixed Bonded\">Fixed Bonded\n</md-checkbox><md-checkbox ng-model=\"pctrl.manufacturing.upnimrodret\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Upper NimrodRetainer\">NimrodRetainer</md-checkbox><md-checkbox \nng-model=\"pctrl.manufacturing.upnimrodali\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Upper NimrodAligner\">NimrodAligner</md-checkbox><md-checkbox ng-model=\"pctrl.manufacturing.upimplant\" \nng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper Implant Guides\">Implant Guides\n</md-checkbox></div><div flex-xs flex=\"50\" layout=\"column\"><h3>Lower</h3><h4>Type of Work</h4><md-checkbox \nng-model=\"pctrl.manufacturing.lowsplint\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Lower Splints\">Splints</md-checkbox><md-checkbox ng-model=\"pctrl.manufacturing.lowfixed\" \nng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower Fixed Bonded\">Fixed Bonded\n</md-checkbox><md-checkbox ng-model=\"pctrl.manufacturing.lownimrodret\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Lower NimrodRetainer\">NimrodRetainer</md-checkbox><md-checkbox \nng-model=\"pctrl.manufacturing.lownimrodali\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Lower NimrodAligner\">NimrodAligner</md-checkbox><md-checkbox ng-model=\"pctrl.manufacturing.lowimplant\" \nng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower Implant Guides\">Implant Guides\n</md-checkbox></div></div><div layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\">\n<md-input-container flex class=\"md-block\"><label>No. Implant Guides</label><md-select ng-disabled=\"pctrl.disabled\" \nng-model=\"pctrl.manufacturing.upnumimplants\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option>\n<md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option></md-select>\n</md-input-container></div><div flex-xs flex=\"50\" layout=\"column\"><md-input-container flex class=\"md-block\"><label>\nNo. Implant Guides</label><md-select ng-disabled=\"pctrl.disabled\" ng-model=\"pctrl.manufacturing.lownumimplants\">\n<md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option \nvalue=\"4\">4</md-option><md-option value=\"5\">5</md-option></md-select></md-input-container></div></div><div \nlayout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-input-container flex \nclass=\"md-block\"><label>Steeco Sleeve</label><md-select ng-disabled=\"pctrl.disabled\" \nng-model=\"pctrl.manufacturing.upsteecosleeve\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option>\n<md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option \nvalue=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option value=\"9\">9\n</md-option><md-option value=\"10\">10</md-option></md-select></md-input-container></div><div flex-xs flex=\"50\" \nlayout=\"column\"><md-input-container flex class=\"md-block\"><label>Steeco Sleeve</label><md-select \nng-disabled=\"pctrl.disabled\" ng-model=\"pctrl.manufacturing.lowsteecosleeve\"><md-option value=\"1\">1</md-option>\n<md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option \nvalue=\"5\">5</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8\n</md-option><md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option></md-select></md-input-container>\n</div></div><div layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-input-container \nflex class=\"md-block\"><label>Biohorizon Sleeve</label><md-select ng-disabled=\"pctrl.disabled\" \nng-model=\"pctrl.manufacturing.upbiosleeve\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option>\n<md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option \nvalue=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option value=\"9\">9\n</md-option><md-option value=\"10\">10</md-option></md-select></md-input-container></div><div flex-xs flex=\"50\" \nlayout=\"column\"><md-input-container flex class=\"md-block\"><label>Biohorizon Sleeve</label><md-select \nng-disabled=\"pctrl.disabled\" ng-model=\"pctrl.manufacturing.lowbiosleeve\"><md-option value=\"1\">1</md-option><md-option \nvalue=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5\n</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option>\n<md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option></md-select></md-input-container></div></div><div\n layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-input-container flex \nclass=\"md-block\"><label>Strauman Sleeve</label><md-select ng-disabled=\"pctrl.disabled\" \nng-model=\"pctrl.manufacturing.upstraumansleeve\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option>\n<md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option \nvalue=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option value=\"9\">9\n</md-option><md-option value=\"10\">10</md-option></md-select></md-input-container></div><div flex-xs flex=\"50\" \nlayout=\"column\"><md-input-container flex class=\"md-block\"><label>Strauman Sleeve</label><md-select \nng-disabled=\"pctrl.disabled\" ng-model=\"pctrl.manufacturing.lowstraumansleeve\"><md-option value=\"1\">1</md-option>\n<md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option \nvalue=\"5\">5</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8\n</md-option><md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option></md-select></md-input-container>\n</div></div><div layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-input-container \nflex class=\"md-block\"><label>Bredent Sleeve</label><md-select ng-disabled=\"pctrl.disabled\" \nng-model=\"pctrl.manufacturing.upbredentleeve\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option>\n<md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option \nvalue=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option value=\"9\">9\n</md-option><md-option value=\"10\">10</md-option></md-select></md-input-container></div><div flex-xs flex=\"50\" \nlayout=\"column\"><md-input-container flex class=\"md-block\"><label>Bredent Sleeve</label><md-select \nng-disabled=\"pctrl.disabled\" ng-model=\"pctrl.manufacturing.lowbredentleeve\"><md-option value=\"1\">1</md-option>\n<md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option \nvalue=\"5\">5</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8\n</md-option><md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option></md-select></md-input-container>\n</div></div><div layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-input-container \nflex class=\"md-block\"><label>Neoss Sleeve</label><md-select ng-disabled=\"pctrl.disabled\" \nng-model=\"pctrl.manufacturing.upneossleeve\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option>\n<md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option \nvalue=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option value=\"9\">9\n</md-option><md-option value=\"10\">10</md-option></md-select></md-input-container></div><div flex-xs flex=\"50\" \nlayout=\"column\"><md-input-container flex class=\"md-block\"><label>Neoss Sleeve</label><md-select \nng-disabled=\"pctrl.disabled\" ng-model=\"pctrl.manufacturing.lowneossleeve\"><md-option value=\"1\">1</md-option><md-option \nvalue=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5\n</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option>\n<md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option></md-select></md-input-container></div></div><div\n layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-input-container flex \nclass=\"md-block\"><label>Ankylos Sleeve</label><md-select ng-disabled=\"pctrl.disabled\" \nng-model=\"pctrl.manufacturing.upankylossleeve\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option>\n<md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option \nvalue=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option value=\"9\">9\n</md-option><md-option value=\"10\">10</md-option></md-select></md-input-container></div><div flex-xs flex=\"50\" \nlayout=\"column\"><md-input-container flex class=\"md-block\"><label>Ankylos Sleeve</label><md-select \nng-disabled=\"pctrl.disabled\" ng-model=\"pctrl.manufacturing.lowankylossleeve\"><md-option value=\"1\">1</md-option>\n<md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option \nvalue=\"5\">5</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8\n</md-option><md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option></md-select></md-input-container>\n</div></div><div layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-input-container \nflex class=\"md-block\"><label>Camlog Sleeve</label><md-select ng-disabled=\"pctrl.disabled\" \nng-model=\"pctrl.manufacturing.upcamlogsleeve\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option>\n<md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option \nvalue=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option value=\"9\">9\n</md-option><md-option value=\"10\">10</md-option></md-select></md-input-container></div><div flex-xs flex=\"50\" \nlayout=\"column\"><md-input-container flex class=\"md-block\"><label>Camlog Sleeve</label><md-select \nng-disabled=\"pctrl.disabled\" ng-model=\"pctrl.manufacturing.lowcamlogsleeve\"><md-option value=\"1\">1</md-option>\n<md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option \nvalue=\"5\">5</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8\n</md-option><md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option></md-select></md-input-container>\n</div></div><div layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-input-container \nflex class=\"md-block\"><label>Zimmer Sleeve</label><md-select ng-disabled=\"pctrl.disabled\" \nng-model=\"pctrl.manufacturing.upzimmersleeve\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option>\n<md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option \nvalue=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option value=\"9\">9\n</md-option><md-option value=\"10\">10</md-option></md-select></md-input-container></div><div flex-xs flex=\"50\" \nlayout=\"column\"><md-input-container flex class=\"md-block\"><label>Zimmer Sleeve</label><md-select \nng-disabled=\"pctrl.disabled\" ng-model=\"pctrl.manufacturing.lowzimmersleeve\"><md-option value=\"1\">1</md-option>\n<md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option \nvalue=\"5\">5</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8\n</md-option><md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option></md-select></md-input-container>\n</div></div><div layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-input-container \nclass=\"md-block\"><label>Other</label><input type=\"text\" ng-model=\"pctrl.manufacturing.upother\" \nng-disabled=\"pctrl.disabled\"></md-input-container></div><div flex-xs flex=\"50\" layout=\"column\"><md-input-container \nclass=\"md-block\"><label>Other</label><input type=\"text\" ng-model=\"pctrl.manufacturing.lowother\" \nng-disabled=\"pctrl.disabled\"></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button ng-if=\"pctrl.disabled==false\" \nclass=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"recordForm.$valid && gravar(pctrl.manufacturing)\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/departments/matching.html","<md-dialog flex=\"30\" aria-label=\"Matching\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"pctrl.matching.orders_id\" ng-init=\"pctrl.matching.orders_id=id\"> <input \ntype=\"hidden\" ng-if=\"pctrl.matching.orders_matching_id\" ng-model=\"pctrl.matching.orders_matching_id\" \nng-init=\"pctrl.matching.orders_matching_id=pctrl.matching.orders_matching_id\"> <input type=\"hidden\" \nng-if=\"!pctrl.matching.orders_matching_id\" ng-model=\"pctrl.matching.orders_matching_id\" \nng-init=\"pctrl.matching.orders_matching_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Matching</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-padding\"><div layout=\"row\" layout-align=\"center center\"><div layout=\"row\" \nclass=\"md-padding\"><md-checkbox ng-model=\"pctrl.matching.smop\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Smop\">Smop</md-checkbox></div><div layout=\"row\" class=\"md-padding\"><md-checkbox \nng-model=\"pctrl.matching.waxupmodel\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Wax Up Model\">Wax Up Model</md-checkbox></div><div layout=\"row\" class=\"md-padding\"><md-checkbox \nng-model=\"pctrl.matching.codiagnostix\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"coDiagnostiX\">coDiagnostiX</md-checkbox></div></div><div layout=\"row\" layout-align=\"center center\"><div \nlayout=\"row\" class=\"md-padding\"><md-checkbox ng-model=\"pctrl.matching.upper\" ng-disabled=\"pctrl.disabled\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">Upper</md-checkbox></div><div layout=\"row\" class=\"md-padding\">\n<md-checkbox ng-model=\"pctrl.matching.lower\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Lower\">Lower</md-checkbox></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \ntype=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button ng-if=\"pctrl.disabled==false\" \nclass=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"recordForm.$valid && gravar(pctrl.matching)\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/departments/movement.html","<md-dialog aria-label=\"Removable Movements\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"pctrl.inmovement.orders_id\" ng-init=\"pctrl.inmovement.orders_id=id\"> <input \ntype=\"hidden\" ng-if=\"pctrl.inmovement.orders_in_movement_id\" ng-model=\"pctrl.inmovement.orders_in_movement_id\" \nng-init=\"pctrl.inmovement.orders_in_movement_id=pctrl.inmovement.orders_in_movement_id\"> <input type=\"hidden\" \nng-if=\"!pctrl.inmovement.orders_in_movement_id\" ng-model=\"pctrl.inmovement.orders_in_movement_id\" \nng-init=\"pctrl.inmovement.orders_in_movement_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Removable Movements\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\">\n<div layout=\"row\" class=\"md-padding\"><md-checkbox ng-model=\"pctrl.inmovement.upper\" ng-disabled=\"pctrl.disabled\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\">Upper</md-checkbox></div><md-input-container flex \nclass=\"md-block\"><label>No. of Clear Aligners</label><md-select ng-model=\"pctrl.inmovement.upclear\" \nng-disabled=\"pctrl.disabled\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3\n</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option>\n<md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option \nvalue=\"10\">10</md-option></md-select></md-input-container><div layout=\"row\" class=\"md-padding\"><md-checkbox \nng-model=\"pctrl.inmovement.uptreatmentplan\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Upper Treatment Plan\">Treatment Plan</md-checkbox></div></div><div flex-xs flex=\"50\" layout=\"column\"><div \nlayout=\"row\" class=\"md-padding\"><md-checkbox ng-model=\"pctrl.inmovement.lower\" ng-disabled=\"pctrl.disabled\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\">Lower</md-checkbox></div><md-input-container flex \nclass=\"md-block\"><label>No. of Clear Aligners</label><md-select ng-model=\"pctrl.inmovement.lowclear\"><md-option \nvalue=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4\n</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option>\n<md-option value=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option></md-select>\n</md-input-container><div layout=\"row\" class=\"md-padding\"><md-checkbox ng-model=\"pctrl.inmovement.lowtreatmentplan\" \nng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower Treatment Plan\">Treatment Plan\n</md-checkbox></div></div></div><div layout=\"row\" layout-align=\"left center\"><div flex-xs flex=\"50\" layout=\"column\">\n<div layout=\"row\" class=\"md-padding\"><md-checkbox ng-model=\"pctrl.inmovement.upsetupplan\" ng-disabled=\"pctrl.disabled\" \nng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper Set Up\">Set Up</md-checkbox>\n<md-checkbox ng-model=\"pctrl.inmovement.upgoahead\" ng-disabled=\"pctrl.disabled\" ng-disabled=\"pctrl.disabled\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper Go Ahead\">Go Ahead</md-checkbox></div></div><div flex-xs \nflex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><md-checkbox ng-model=\"pctrl.inmovement.lowsetupplan\" \nng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower Set Up\">Set Up</md-checkbox>\n<md-checkbox ng-model=\"pctrl.inmovement.lowergoahead\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Lower Go Ahead\">Go Ahead</md-checkbox></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button ng-if=\"pctrl.disabled==false\" \nclass=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"recordForm.$valid && gravar(pctrl.inmovement)\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/departments/ordercontent.html","<md-dialog flex=\"40\" aria-label=\"Order Content\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"pctrl.orderscontent.orders_id\" \nng-init=\"pctrl.orderscontent.orders_id=id\"> <input type=\"hidden\" ng-if=\"pctrl.orderscontent.orders_content_id\" \nng-model=\"pctrl.orderscontent.orders_content_id\" \nng-init=\"pctrl.orderscontent.orders_content_id=pctrl.orderscontent.orders_content_id\"> <input type=\"hidden\" \nng-if=\"!pctrl.orderscontent.orders_content_id\" ng-model=\"pctrl.orderscontent.orders_content_id\" \nng-init=\"pctrl.orderscontent.orders_content_id=0\"> <input type=\"hidden\" ng-if=\"!pctrl.orderscontent.digital\" \nng-model=\"pctrl.orderscontent.digital\" ng-init=\"pctrl.orderscontent.digital=0\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Order Content</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" \nclass=\"full-width\" layout-align=\"end center\"><div ng-click=\"pctrl.printOrderContent()\"><md-icon \nmd-font-icon=\"icon-printer\" class=\"s24 md-font icon-printer pointer\" aria-hidden=\"true\"></md-icon><md-tooltip \nmd-direction=\"top\">Click to print Order Content label</md-tooltip></div></div><div layout=\"row\" \nclass=\"md-dialog-content\"><md-input-container flex class=\"md-block\"><label>Prescription No</label><input type=\"text\" \nng-model=\"pctrl.orderscontent.prescription_number\" ng-disabled=\"pctrl.disabled\"></md-input-container>\n<md-input-container flex \nmd-is-error=\"recordForm.digital.$invalid && (recordForm.digital.$touched || recordForm.$submitted)\"><label>Digital\n</label><md-select name=\"digital\" ng-model=\"pctrl.orderscontent.digital\" ng-disabled=\"pctrl.disabled\"><md-option \nvalue=\"1\">Yes</md-option><md-option value=\"0\">No</md-option></md-select><div ng-messages=\"recordForm.digital.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Please choose an option.</span></div></div></md-input-container></div>\n<h3>ORDER CONTENT</h3><div layout=\"row\" class=\"md-dialog-content\"><md-input-container flex class=\"md-block\"><label>\nNo. of Impressions</label><md-select ng-model=\"pctrl.orderscontent.num_impressions\" ng-disabled=\"pctrl.disabled\">\n<md-option value=\"0\">Not Applicable</md-option><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option>\n<md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option \nvalue=\"6\">6</md-option></md-select></md-input-container><md-input-container flex class=\"md-block\"><label>Bite</label>\n<md-select ng-model=\"pctrl.orderscontent.bite\" ng-disabled=\"pctrl.disabled\"><md-option value=\"1\">Yes</md-option>\n<md-option value=\"0\">No</md-option></md-select></md-input-container></div><div layout=\"row\" class=\"md-dialog-content\">\n<md-input-container flex class=\"md-block\"><label>No. of Models</label><md-select \nng-model=\"pctrl.orderscontent.num_models\" ng-disabled=\"pctrl.disabled\"><md-option value=\"0\">Not Applicable</md-option>\n<md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option \nvalue=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option></md-select>\n</md-input-container><md-input-container flex class=\"md-block\"><label>Appliance</label><md-select \nng-model=\"pctrl.orderscontent.appliance\" ng-disabled=\"pctrl.disabled\"><md-option value=\"1\">Yes</md-option><md-option \nvalue=\"0\">No</md-option></md-select></md-input-container></div><div layout=\"row\" flex class=\"md-dialog-content\">\n<md-input-container flex><label>Other</label><textarea rows=\"5\" ng-model=\"pctrl.orderscontent.other\" \nng-disabled=\"pctrl.disabled\"></textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button ng-if=\"pctrl.disabled==false\" \nclass=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"recordForm.$valid && gravar(pctrl.orderscontent)\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/departments/orderinfo.html","<md-dialog flex=\"70\" aria-label=\"Order Info\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"pctrl.cliente.orders_id\" \nng-init=\"pctrl.cliente.orders_id=id\"> <input type=\"hidden\" ng-if=\"pctrl.cliente.clients_id\" \nng-model=\"pctrl.cliente.clients_id\"> <input type=\"hidden\" ng-if=\"pctrl.deliveryroutes_id\" \nng-model=\"pctrl.cliente.deliveryroutes_id\" ng-init=\"pctrl.cliente.deliveryroutes_id=pctrl.deliveryroutes_id\"> <input \ntype=\"hidden\" ng-if=\"!pctrl.packaging.orders_packaging_id\" ng-model=\"pctrl.packaging.orders_packaging_id\" \nng-init=\"pctrl.packaging.orders_packaging_id=\'0\'\"> <input type=\"hidden\" ng-if=\"!pctrl.packaging.orders_id\" \nng-model=\"pctrl.packaging.orders_id\" ng-init=\"pctrl.packaging.orders_id=id\"><md-toolbar><div class=\"md-toolbar-tools\">\n<h2>Order Info</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><md-button ng-show=\"!showDetails1\" \nclass=\"md-primary md-raised\" ng-click=\"showDetails1 = ! showDetails1\">Search/Change Client</md-button><md-button \nng-show=\"showDetails1\" class=\"md-primary md-raised\" ng-click=\"showDetails1 = ! showDetails1\">Hide Client Search\n</md-button><span ng-show=\"showDetails1\">Please search user below and click to select it.</span><div \nng-show=\"showDetails1\" ng-if=\"pctrl.disabled==false\"><div layout=\"row\" layout-align=\"start center\"><md-input-container \nlayout=\"row\" flex=\"13\" class=\"md-block\"><label>Client Number</label><input ng-model=\"pctrl.search.clientnumber\" \nng-change=\"pctrl.searchTable(pctrl.search.clientnumber, 1)\" type=\"text\"></md-input-container><md-input-container \nlayout=\"row\" flex=\"18\" class=\"md-block\"><label>Client Name</label><input ng-model=\"pctrl.search.clientname\" \nng-change=\"pctrl.searchTable(pctrl.search.clientname, 2)\" type=\"text\"></md-input-container><md-input-container \nlayout=\"row\" flex=\"13\" class=\"md-block\"><label>Post Code</label><input ng-model=\"pctrl.search.cpostcode\" \nng-change=\"pctrl.searchTable(pctrl.search.cpostcode, 3)\" type=\"text\"></md-input-container><md-input-container \nlayout=\"row\" flex=\"18\" class=\"md-block\"><label>Address 1</label><input ng-model=\"pctrl.search.caddress1\" \nng-change=\"pctrl.searchTable(pctrl.search.caddress1, 7)\" type=\"text\"></md-input-container><md-input-container \nlayout=\"row\" flex=\"18\" class=\"md-block\"><label>Address 2</label><input ng-model=\"pctrl.search.caddress2\" \nng-change=\"pctrl.searchTable(pctrl.search.caddress2, 8)\" type=\"text\"></md-input-container><md-button flex=\"20\" \nclass=\"md-primary md-raised\" ng-click=\"pctrl.reset()\">Reset</md-button></div><table datatable=\"\" \nclass=\"full-width simple tabela-pesquisa hover\" ms-responsive-table dt-instance=\"pctrl.dtInstance\" \ndt-options=\"pctrl.dtOptions\" dt-columns=\"pctrl.dtColumns\"></table></div><h3>INFO</h3><div layout=\"row\" \nclass=\"md-dialog-content\"><md-input-container flex=\"60\" class=\"md-block\" \nmd-is-error=\"recordForm.clientname.$invalid && (recordForm.clientname.$touched || recordForm.$submitted)\"><label>\nClient Name</label><input required type=\"text\" name=\"clientname\" ng-model=\"pctrl.cliente.clientname\" \ndisabled=\"disabled\"><div ng-messages=\"recordForm.clientname.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease select a client pressing the button above.</span></div></div></md-input-container><md-input-container flex \nclass=\"md-block\"><label>Client Number</label><input type=\"text\" name=\"clientnumber\" \nng-model=\"pctrl.cliente.clientnumber\" disabled=\"disabled\"></md-input-container></div><div layout=\"row\" \nclass=\"md-dialog-content\"><md-input-container flex class=\"md-block\"><label>Client</label><input type=\"text\" \nname=\"performername\" ng-model=\"pctrl.cliente.performername\" disabled=\"disabled\"></md-input-container>\n<md-input-container flex class=\"md-block\"><label>GDC Number</label><input type=\"text\" name=\"gdcnumber\" \nng-model=\"pctrl.cliente.gdcnumber\" disabled=\"disabled\"></md-input-container></div><div layout=\"row\" \nclass=\"md-dialog-content\"><md-input-container flex class=\"md-block\"><label>Patient Name</label><input type=\"text\" \nname=\"patient_name\" ng-model=\"pctrl.order.patient_name\" ng-disabled=\"pctrl.disabled\"></md-input-container>\n<md-input-container flex class=\"md-block\"><label>Patient Ref</label><input type=\"text\" name=\"patient_ref\" \nng-model=\"pctrl.order.patient_ref\" ng-disabled=\"pctrl.disabled\"></md-input-container><md-input-container flex \nclass=\"md-block\"><label>Order Type</label><md-select name=\"ordertype\" ng-model=\"pctrl.order.ordertype\" \nng-disabled=\"pctrl.disabled\"><md-option value=\"NHS\">NHS</md-option><md-option value=\"Private\">Private</md-option>\n<md-option value=\"Independent\">Independent</md-option></md-select></md-input-container></div><div layout=\"row\" \nclass=\"md-dialog-content\"><md-input-container flex class=\"md-block\"><label>Email</label><input type=\"text\" \nname=\"cemail\" ng-model=\"pctrl.cliente.cemail\" disabled=\"disabled\"></md-input-container><md-input-container flex \nclass=\"md-block\"><label>Tel</label><input type=\"text\" ng-model=\"pctrl.cliente.ctel\" disabled=\"disabled\">\n</md-input-container></div><h3>DELIVERY</h3><div layout=\"row\" class=\"md-dialog-content\"><md-input-container flex \nclass=\"md-block\" moment-picker=\"pctrl.packaging.deliverydate\" format=\"YYYY-MM-DD\" start-view=\"month\" \nautoclose=\"pctrl.autoclose\"><label>Delivery Date</label><input class=\"form-control\" \nng-model=\"pctrl.packaging.deliverydate\" ng-disabled=\"pctrl.disabled\"></md-input-container><md-input-container flex \nclass=\"md-block\"><label>Delivery Route</label><md-select name=\"deliveryroutes_id\" \nng-model=\"pctrl.cliente.deliveryroutes\" md-selected-text=\"pctrl.cliente.deliveryroutes.route\" \nng-disabled=\"pctrl.disabled\"><md-option ng-repeat=\"(index,droute) in pctrl.droutes\" ng-value=\"droute\" \nng-selected=\"droute.deliveryroutes_id == \'{{pctrl.deliveryroutes_id}}\'\">{{droute.route}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" class=\"md-dialog-content\"><md-input-container flex class=\"md-block\">\n<label>Address 1</label><input type=\"text\" ng-model=\"pctrl.cliente.caddress1\" disabled=\"disabled\"></md-input-container>\n</div><div layout=\"row\" class=\"md-dialog-content\"><md-input-container flex class=\"md-block\"><label>Address 2</label>\n<input type=\"text\" ng-model=\"pctrl.cliente.caddress2\" disabled=\"disabled\"></md-input-container></div><div layout=\"row\" \nclass=\"md-dialog-content\"><md-input-container flex class=\"md-block\"><label>City</label><input type=\"text\" \nng-model=\"pctrl.cliente.ccity\" disabled=\"disabled\"></md-input-container><md-input-container flex class=\"md-block\">\n<label>County</label><input type=\"text\" ng-model=\"pctrl.cliente.ccounty\" disabled=\"disabled\"></md-input-container>\n<md-input-container flex class=\"md-block\"><label>Postcode</label><input type=\"text\" ng-model=\"pctrl.cliente.cpostcode\" \ndisabled=\"disabled\"></md-input-container></div><div layout=\"row\" class=\"md-dialog-content\"><md-input-container flex \nclass=\"md-block\"><label>Country</label><input type=\"text\" ng-model=\"pctrl.cliente.ccountry\" disabled=\"disabled\">\n</md-input-container><md-input-container flex class=\"md-block\"><label>Email</label><input type=\"text\" name=\"demail\" \nng-model=\"pctrl.cliente.demail\" disabled=\"disabled\"></md-input-container></div><div layout=\"row\" \nclass=\"md-dialog-content\"><md-input-container flex=\"50\" class=\"md-block\"><label>Telephone Number</label><input \ntype=\"text\" ng-model=\"pctrl.cliente.ctel\" disabled=\"disabled\"></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nng-if=\"pctrl.disabled==false\" class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(pctrl.cliente, pctrl.order, pctrl.packaging)\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/departments/packaging.html","<md-dialog aria-label=\"Packaging\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"pctrl.packaging.orders_id\" ng-init=\"pctrl.packaging.orders_id=id\"> <input \ntype=\"hidden\" ng-if=\"pctrl.packaging.orders_packaging_id\" ng-model=\"pctrl.packaging.orders_packaging_id\" \nng-init=\"pctrl.packaging.orders_packaging_id=pctrl.packaging.orders_packaging_id\"> <input type=\"hidden\" \nng-if=\"!pctrl.packaging.orders_packaging_id\" ng-model=\"pctrl.packaging.orders_packaging_id\" \nng-init=\"pctrl.packaging.orders_packaging_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Packaging</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div flex layout=\"row\" layout-align=\"center center\" class=\"md-padding\">\n<md-input-container class=\"md-block\" moment-picker=\"pctrl.packaging.shippingdate\" format=\"YYYY-MM-DD\" \nstart-view=\"month\" autoclose=\"pctrl.autoclose\"><label>Shipping Date</label><input class=\"form-control\" \nng-model=\"pctrl.packaging.shippingdate\" ng-disabled=\"pctrl.disabled\"></md-input-container><md-input-container \nclass=\"md-block\" moment-picker=\"pctrl.packaging.deliverydate\" format=\"YYYY-MM-DD\" start-view=\"month\" \nautoclose=\"pctrl.autoclose\" min-date=\"pctrl.packaging.shippingdate\"><label>Delivery Date</label><input \nclass=\"form-control\" ng-model=\"pctrl.packaging.deliverydate\" ng-disabled=\"pctrl.disabled\"></md-input-container></div>\n<div layout=\"row\" layout-align=\"center center\" class=\"md-padding\"><md-input-container class=\"md-block\" \nmoment-picker=\"pctrl.packaging.fromtime\" format=\"HH\" autoclose=\"pctrl.autoclose\"><label>From Time</label><input \nclass=\"form-control\" ng-model=\"pctrl.packaging.fromtime\" ng-disabled=\"pctrl.disabled\"></md-input-container>\n<md-input-container class=\"md-block\" moment-picker=\"pctrl.packaging.totime\" format=\"HH\" autoclose=\"pctrl.autoclose\" \nmin-date=\"pctrl.packaging.fromtime\"><label>To Time</label><input class=\"form-control\" \nng-model=\"pctrl.packaging.totime\" ng-disabled=\"pctrl.disabled\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\" class=\"md-padding\"><md-input-container flex \nmd-is-error=\"recordForm.deliveryroutes_id.$invalid && (recordForm.deliveryroutes_id.$touched || recordForm.$submitted)\">\n<label>Delivery Route</label><md-select name=\"deliveryroutes_id\" ng-model=\"pctrl.packaging.deliveryroutes\" \nmd-selected-text=\"pctrl.packaging.deliveryroutes.route\" ng-disabled=\"pctrl.disabled\"><md-option \nng-repeat=\"(index,droute) in pctrl.droutes\" ng-value=\"droute\" \nng-selected=\"droute.deliveryroutes_id == \'{{pctrl.packaging.deliveryroutes_id}}\'\">{{droute.route}}</md-option>\n</md-select><div ng-messages=\"recordForm.deliveryroutes_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease choose a delivery route.</span></div></div></md-input-container></div><h2 ng-show=\"!showDetails1\">\nPlaster Room | <a ng-click=\"showDetails1 = ! showDetails1\" class=\"pointer\">Show Info</a></h2><h2 \nng-show=\"showDetails1\">Plaster Room | <a ng-click=\"showDetails1 = ! showDetails1\" class=\"pointer\">Hide Info</a></h2>\n<div ng-show=\"showDetails1\"><div layout=\"row\" layout-align=\"center center\"><md-input-container flex class=\"md-block\">\n<label>Upper</label><md-select ng-model=\"pctrl.plasterroom.upper\" disabled=\"disabled\"><md-option value=\"1\">1\n</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option>\n<md-option value=\"5\">5</md-option></md-select></md-input-container><md-input-container flex class=\"md-block\"><label>\nLower</label><md-select ng-model=\"pctrl.plasterroom.lower\" disabled=\"disabled\"><md-option value=\"1\">1</md-option>\n<md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option \nvalue=\"5\">5</md-option></md-select></md-input-container></div></div><h2 ng-show=\"!showDetails2\">Order Content | <a \nng-click=\"showDetails2 = ! showDetails2\" class=\"pointer\">Show Info</a></h2><h2 ng-show=\"showDetails2\">Order Content | \n<a ng-click=\"showDetails2 = ! showDetails2\" class=\"pointer\">Hide Info</a></h2><div ng-show=\"showDetails2\"><div \nlayout=\"row\" class=\"md-dialog-content\"><md-input-container flex class=\"md-block\"><label>Prescription No</label><input \ntype=\"text\" ng-model=\"pctrl.orderscontent.prescription_number\" disabled=\"disabled\"></md-input-container>\n<md-input-container flex><label>Digital</label><md-select name=\"digital\" ng-model=\"pctrl.orderscontent.digital\" \ndisabled=\"disabled\"><md-option value=\"1\">Yes</md-option><md-option value=\"0\">No</md-option></md-select>\n</md-input-container></div><h3>ORDER CONTENT</h3><div layout=\"row\" class=\"md-dialog-content\"><md-input-container flex \nclass=\"md-block\"><label>No. of Impressions</label><md-select ng-model=\"pctrl.orderscontent.num_impressions\" \ndisabled=\"disabled\"><md-option value=\"0\">Not Applicable</md-option><md-option value=\"1\">1</md-option><md-option \nvalue=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5\n</md-option><md-option value=\"6\">6</md-option></md-select></md-input-container><md-input-container flex \nclass=\"md-block\"><label>Bite</label><md-select ng-model=\"pctrl.orderscontent.bite\" disabled=\"disabled\"><md-option \nvalue=\"1\">Yes</md-option><md-option value=\"0\">No</md-option></md-select></md-input-container></div><div layout=\"row\" \nclass=\"md-dialog-content\"><md-input-container flex class=\"md-block\"><label>No. of Models</label><md-select \nng-model=\"pctrl.orderscontent.num_models\" disabled=\"disabled\"><md-option value=\"0\">Not Applicable</md-option><md-option\n value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4\n</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option></md-select></md-input-container>\n<md-input-container flex class=\"md-block\"><label>Appliance</label><md-select ng-model=\"pctrl.orderscontent.appliance\" \ndisabled=\"disabled\"><md-option value=\"1\">Yes</md-option><md-option value=\"0\">No</md-option></md-select>\n</md-input-container></div><div layout=\"row\" flex class=\"md-dialog-content\"><md-input-container flex><label>Other\n</label><textarea rows=\"5\" ng-model=\"pctrl.orderscontent.other\" disabled=\"disabled\"></textarea></md-input-container>\n</div></div><h2 ng-show=\"!showDetails3\">Platforms | <a ng-click=\"showDetails3 = ! showDetails3\" class=\"pointer\">\nShow Info</a></h2><h2 ng-show=\"showDetails3\">Platforms | <a ng-click=\"showDetails3 = ! showDetails3\" class=\"pointer\">\nHide Info</a></h2><div ng-show=\"showDetails3\"><div layout=\"row\" layout-align=\"center center\"><md-input-container flex \nclass=\"md-block\"><label>Upper</label><md-select ng-model=\"pctrl.platforms.upper\" disabled=\"disabled\"><md-option \nvalue=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4\n</md-option><md-option value=\"5\">5</md-option></md-select></md-input-container><md-input-container flex \nclass=\"md-block\"><label>Lower</label><md-select ng-model=\"pctrl.platforms.lower\" disabled=\"disabled\"><md-option \nvalue=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4\n</md-option><md-option value=\"5\">5</md-option></md-select></md-input-container></div><h3>Type of Model</h3><div \nlayout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-radio-group \nng-model=\"pctrl.platforms.typeupper\"><md-radio-button value=\"horseshoe\" aria-label=\"Upper Horse Shoe\" \ndisabled=\"disabled\">Horse Shoe</md-radio-button></md-radio-group><md-radio-group ng-model=\"pctrl.platforms.typeupper\">\n<md-radio-button value=\"fullmodels\" aria-label=\"Upper Full Models\" disabled=\"disabled\">Full Models</md-radio-button>\n</md-radio-group><md-radio-group ng-model=\"pctrl.platforms.typeupper\"><md-radio-button value=\"clearaligners\" \naria-label=\"Upper Clear Aligners\" disabled=\"disabled\">Clear Aligners</md-radio-button></md-radio-group><md-radio-group \nng-model=\"pctrl.platforms.typeupper\"><md-radio-button value=\"drillinguides\" aria-label=\"Upper Extras\" \ndisabled=\"disabled\">Drilling Guides</md-radio-button></md-radio-group><md-radio-group \nng-model=\"pctrl.platforms.typeupper\"><md-radio-button value=\"extras\" aria-label=\"Upper Extras\" disabled=\"disabled\">\nExtras</md-radio-button></md-radio-group></div><div flex-xs flex=\"50\" layout=\"column\"><md-radio-group \nng-model=\"pctrl.platforms.typelower\"><md-radio-button value=\"horseshoe\" aria-label=\"Upper Horse Shoe\" \ndisabled=\"disabled\">Horse Shoe</md-radio-button></md-radio-group><md-radio-group ng-model=\"pctrl.platforms.typelower\">\n<md-radio-button value=\"fullmodels\" aria-label=\"Upper Full Models\" disabled=\"disabled\">Full Models</md-radio-button>\n</md-radio-group><md-radio-group ng-model=\"pctrl.platforms.typelower\"><md-radio-button value=\"clearaligners\" \naria-label=\"Upper Clear Aligners\" disabled=\"disabled\">Clear Aligners</md-radio-button></md-radio-group><md-radio-group \nng-model=\"pctrl.platforms.typelower\"><md-radio-button value=\"drillinguides\" aria-label=\"Upper Extras\" \ndisabled=\"disabled\">Drilling Guides</md-radio-button></md-radio-group><md-radio-group \nng-model=\"pctrl.platforms.typelower\"><md-radio-button value=\"extras\" aria-label=\"Upper Extras\" disabled=\"disabled\">\nExtras</md-radio-button></md-radio-group></div></div></div><h2 ng-show=\"!showDetails4\">3D Manufacturing | <a \nng-click=\"showDetails4 = ! showDetails4\" class=\"pointer\">Show Info</a></h2><h2 ng-show=\"showDetails4\">\n3D Manufacturing | <a ng-click=\"showDetails4 = ! showDetails4\" class=\"pointer\">Hide Info</a></h2><div \nng-show=\"showDetails4\"><div layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><h3>Upper\n</h3><h4>Type of Work</h4><md-checkbox ng-model=\"pctrl.manufacturing.upsplint\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Upper Splints\" disabled=\"disabled\">Splints</md-checkbox><md-checkbox \nng-model=\"pctrl.manufacturing.upfixed\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper Fixed Bonded\" \ndisabled=\"disabled\">Fixed Bonded</md-checkbox><md-checkbox ng-model=\"pctrl.manufacturing.upnimrodret\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper NimrodRetainer\" disabled=\"disabled\">NimrodRetainer</md-checkbox>\n<md-checkbox ng-model=\"pctrl.manufacturing.upnimrodali\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Upper NimrodAligner\" disabled=\"disabled\">NimrodAligner</md-checkbox><md-checkbox \nng-model=\"pctrl.manufacturing.upimplant\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper Implant Guides\" \ndisabled=\"disabled\">Implant Guides</md-checkbox></div><div flex-xs flex=\"50\" layout=\"column\"><h3>Lower</h3><h4>\nType of Work</h4><md-checkbox ng-model=\"pctrl.manufacturing.lowsplint\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Lower Splints\" disabled=\"disabled\">Splints</md-checkbox><md-checkbox \nng-model=\"pctrl.manufacturing.lowfixed\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower Fixed Bonded\" \ndisabled=\"disabled\">Fixed Bonded</md-checkbox><md-checkbox ng-model=\"pctrl.manufacturing.lownimrodret\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower NimrodRetainer\" disabled=\"disabled\">NimrodRetainer</md-checkbox>\n<md-checkbox ng-model=\"pctrl.manufacturing.lownimrodali\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Lower NimrodAligner\" disabled=\"disabled\">NimrodAligner</md-checkbox><md-checkbox \nng-model=\"pctrl.manufacturing.lowimplant\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower Implant Guides\" \ndisabled=\"disabled\">Implant Guides</md-checkbox></div></div><div layout=\"row\" layout-align=\"center center\"><div \nflex-xs flex=\"50\" layout=\"column\"><md-input-container flex class=\"md-block\"><label>No. Implant Guides</label><md-select\n ng-model=\"pctrl.manufacturing.upnumimplants\" disabled=\"disabled\"><md-option value=\"1\">1</md-option><md-option \nvalue=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5\n</md-option></md-select></md-input-container></div><div flex-xs flex=\"50\" layout=\"column\"><md-input-container flex \nclass=\"md-block\"><label>No. Implant Guides</label><md-select ng-model=\"pctrl.manufacturing.lownumimplants\" \ndisabled=\"disabled\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3\n</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option></md-select></md-input-container></div>\n</div><div layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-input-container flex \nclass=\"md-block\"><label>Steeco Sleeve</label><md-select ng-model=\"pctrl.manufacturing.upsteecosleeve\" \ndisabled=\"disabled\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3\n</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option>\n<md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option \nvalue=\"10\">10</md-option></md-select></md-input-container></div><div flex-xs flex=\"50\" layout=\"column\">\n<md-input-container flex class=\"md-block\"><label>Steeco Sleeve</label><md-select \nng-model=\"pctrl.manufacturing.lowsteecosleeve\" disabled=\"disabled\"><md-option value=\"1\">1</md-option><md-option \nvalue=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5\n</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option>\n<md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option></md-select></md-input-container></div></div><div\n layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-input-container flex \nclass=\"md-block\"><label>Biohorizon Sleeve</label><md-select ng-model=\"pctrl.manufacturing.upbiosleeve\" \ndisabled=\"disabled\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3\n</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option>\n<md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option \nvalue=\"10\">10</md-option></md-select></md-input-container></div><div flex-xs flex=\"50\" layout=\"column\">\n<md-input-container flex class=\"md-block\"><label>Biohorizon Sleeve</label><md-select \nng-model=\"pctrl.manufacturing.lowbiosleeve\" disabled=\"disabled\"><md-option value=\"1\">1</md-option><md-option value=\"2\">\n2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option>\n<md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option \nvalue=\"9\">9</md-option><md-option value=\"10\">10</md-option></md-select></md-input-container></div></div><div \nlayout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-input-container flex \nclass=\"md-block\"><label>Strauman Sleeve</label><md-select ng-model=\"pctrl.manufacturing.upstraumansleeve\" \ndisabled=\"disabled\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3\n</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option>\n<md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option \nvalue=\"10\">10</md-option></md-select></md-input-container></div><div flex-xs flex=\"50\" layout=\"column\">\n<md-input-container flex class=\"md-block\"><label>Strauman Sleeve</label><md-select \nng-model=\"pctrl.manufacturing.lowstraumansleeve\" disabled=\"disabled\"><md-option value=\"1\">1</md-option><md-option \nvalue=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5\n</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option>\n<md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option></md-select></md-input-container></div></div><div\n layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-input-container flex \nclass=\"md-block\"><label>Bredent Sleeve</label><md-select ng-model=\"pctrl.manufacturing.upbredentleeve\" \ndisabled=\"disabled\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3\n</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option>\n<md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option \nvalue=\"10\">10</md-option></md-select></md-input-container></div><div flex-xs flex=\"50\" layout=\"column\">\n<md-input-container flex class=\"md-block\"><label>Bredent Sleeve</label><md-select \nng-model=\"pctrl.manufacturing.lowbredentleeve\" disabled=\"disabled\"><md-option value=\"1\">1</md-option><md-option \nvalue=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5\n</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option>\n<md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option></md-select></md-input-container></div></div><div\n layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-input-container flex \nclass=\"md-block\"><label>Neoss Sleeve</label><md-select ng-model=\"pctrl.manufacturing.upneossleeve\" disabled=\"disabled\">\n<md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option \nvalue=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7\n</md-option><md-option value=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option>\n</md-select></md-input-container></div><div flex-xs flex=\"50\" layout=\"column\"><md-input-container flex \nclass=\"md-block\"><label>Neoss Sleeve</label><md-select ng-model=\"pctrl.manufacturing.lowneossleeve\" \ndisabled=\"disabled\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3\n</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option>\n<md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option \nvalue=\"10\">10</md-option></md-select></md-input-container></div></div><div layout=\"row\" layout-align=\"center center\">\n<div flex-xs flex=\"50\" layout=\"column\"><md-input-container flex class=\"md-block\"><label>Ankylos Sleeve</label>\n<md-select ng-model=\"pctrl.manufacturing.upankylossleeve\" disabled=\"disabled\"><md-option value=\"1\">1</md-option>\n<md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option \nvalue=\"5\">5</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8\n</md-option><md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option></md-select></md-input-container>\n</div><div flex-xs flex=\"50\" layout=\"column\"><md-input-container flex class=\"md-block\"><label>Ankylos Sleeve</label>\n<md-select ng-model=\"pctrl.manufacturing.lowankylossleeve\" disabled=\"disabled\"><md-option value=\"1\">1</md-option>\n<md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option \nvalue=\"5\">5</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8\n</md-option><md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option></md-select></md-input-container>\n</div></div><div layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-input-container \nflex class=\"md-block\"><label>Camlog Sleeve</label><md-select ng-model=\"pctrl.manufacturing.upcamlogsleeve\" \ndisabled=\"disabled\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3\n</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option>\n<md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option \nvalue=\"10\">10</md-option></md-select></md-input-container></div><div flex-xs flex=\"50\" layout=\"column\">\n<md-input-container flex class=\"md-block\"><label>Camlog Sleeve</label><md-select \nng-model=\"pctrl.manufacturing.lowcamlogsleeve\" disabled=\"disabled\"><md-option value=\"1\">1</md-option><md-option \nvalue=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5\n</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option>\n<md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option></md-select></md-input-container></div></div><div\n layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-input-container flex \nclass=\"md-block\"><label>Zimmer Sleeve</label><md-select ng-model=\"pctrl.manufacturing.upzimmersleeve\" \ndisabled=\"disabled\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3\n</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option>\n<md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option \nvalue=\"10\">10</md-option></md-select></md-input-container></div><div flex-xs flex=\"50\" layout=\"column\">\n<md-input-container flex class=\"md-block\"><label>Zimmer Sleeve</label><md-select \nng-model=\"pctrl.manufacturing.lowzimmersleeve\" disabled=\"disabled\"><md-option value=\"1\">1</md-option><md-option \nvalue=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5\n</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option>\n<md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option></md-select></md-input-container></div></div><div\n layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-input-container class=\"md-block\">\n<label>Other</label><input type=\"text\" ng-model=\"pctrl.manufacturing.upother\" disabled=\"disabled\"></md-input-container>\n</div><div flex-xs flex=\"50\" layout=\"column\"><md-input-container class=\"md-block\"><label>Other</label><input \ntype=\"text\" ng-model=\"pctrl.manufacturing.lowother\" disabled=\"disabled\"></md-input-container></div></div></div><h2 \nng-show=\"!showDetails5\">Clear Manufacturing | <a ng-click=\"showDetails5 = ! showDetails5\" class=\"pointer\">Show Info</a>\n</h2><h2 ng-show=\"showDetails5\">Clear Manufacturing | <a ng-click=\"showDetails5 = ! showDetails5\" class=\"pointer\">\nHide Info</a></h2><div ng-show=\"showDetails5\"><fieldset><legend><h3>Clear Aligners</h3></legend><div layout=\"row\" \nlayout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><md-checkbox \nng-model=\"pctrl.clearmanufacturing.upper\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\" disabled=\"disabled\">\nUpper</md-checkbox></div><md-input-container flex class=\"md-block\"><label>No. of Clear Aligners</label><md-select \nng-model=\"pctrl.clearmanufacturing.upnumclear\" disabled=\"disabled\"><md-option value=\"0\">0</md-option><md-option \nvalue=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4\n</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option>\n<md-option value=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option><md-option \nvalue=\"11\">11</md-option><md-option value=\"12\">12</md-option><md-option value=\"13\">13</md-option><md-option value=\"14\">\n14</md-option><md-option value=\"15\">15</md-option><md-option value=\"16\">16</md-option><md-option value=\"17\">17\n</md-option><md-option value=\"18\">18</md-option><md-option value=\"19\">19</md-option><md-option value=\"20\">20\n</md-option><md-option value=\"21\">21</md-option><md-option value=\"22\">22</md-option><md-option value=\"23\">23\n</md-option><md-option value=\"24\">24</md-option><md-option value=\"25\">25</md-option><md-option value=\"26\">26\n</md-option><md-option value=\"27\">27</md-option><md-option value=\"28\">28</md-option><md-option value=\"29\">29\n</md-option><md-option value=\"30\">30</md-option><md-option value=\"31\">31</md-option><md-option value=\"32\">32\n</md-option><md-option value=\"33\">33</md-option><md-option value=\"34\">34</md-option><md-option value=\"35\">35\n</md-option><md-option value=\"36\">36</md-option><md-option value=\"37\">37</md-option><md-option value=\"38\">38\n</md-option><md-option value=\"39\">39</md-option><md-option value=\"40\">40</md-option><md-option value=\"41\">41\n</md-option><md-option value=\"42\">42</md-option><md-option value=\"43\">43</md-option><md-option value=\"44\">44\n</md-option><md-option value=\"45\">45</md-option><md-option value=\"46\">46</md-option><md-option value=\"47\">47\n</md-option><md-option value=\"48\">48</md-option><md-option value=\"49\">49</md-option><md-option value=\"50\">50\n</md-option></md-select></md-input-container><md-input-container flex class=\"md-block\"><label>No. of Trays</label>\n<md-select ng-model=\"pctrl.clearmanufacturing.upnumtrays\" disabled=\"disabled\"><md-option value=\"0\">0</md-option>\n<md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option \nvalue=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7\n</md-option><md-option value=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option>\n<md-option value=\"11\">11</md-option><md-option value=\"12\">12</md-option><md-option value=\"13\">13</md-option><md-option \nvalue=\"14\">14</md-option><md-option value=\"15\">15</md-option><md-option value=\"16\">16</md-option><md-option value=\"17\">\n17</md-option><md-option value=\"18\">18</md-option><md-option value=\"19\">19</md-option><md-option value=\"20\">20\n</md-option><md-option value=\"21\">21</md-option><md-option value=\"22\">22</md-option><md-option value=\"23\">23\n</md-option><md-option value=\"24\">24</md-option><md-option value=\"25\">25</md-option><md-option value=\"26\">26\n</md-option><md-option value=\"27\">27</md-option><md-option value=\"28\">28</md-option><md-option value=\"29\">29\n</md-option><md-option value=\"30\">30</md-option><md-option value=\"31\">31</md-option><md-option value=\"32\">32\n</md-option><md-option value=\"33\">33</md-option><md-option value=\"34\">34</md-option><md-option value=\"35\">35\n</md-option><md-option value=\"36\">36</md-option><md-option value=\"37\">37</md-option><md-option value=\"38\">38\n</md-option><md-option value=\"39\">39</md-option><md-option value=\"40\">40</md-option><md-option value=\"41\">41\n</md-option><md-option value=\"42\">42</md-option><md-option value=\"43\">43</md-option><md-option value=\"44\">44\n</md-option><md-option value=\"45\">45</md-option><md-option value=\"46\">46</md-option><md-option value=\"47\">47\n</md-option><md-option value=\"48\">48</md-option><md-option value=\"49\">49</md-option><md-option value=\"50\">50\n</md-option></md-select></md-input-container><div layout=\"row\" class=\"md-padding\"><md-checkbox \nng-model=\"pctrl.clearmanufacturing.upstentsup\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper Up Stents\" \ndisabled=\"disabled\">Stents</md-checkbox></div></div><div flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" \nclass=\"md-padding\"><md-checkbox ng-model=\"pctrl.clearmanufacturing.lower\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Lower\" disabled=\"disabled\">Lower</md-checkbox></div><md-input-container flex class=\"md-block\"><label>\nNo. of Clear Aligners</label><md-select ng-model=\"pctrl.clearmanufacturing.lownumclear\" disabled=\"disabled\"><md-option \nvalue=\"0\">0</md-option><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3\n</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option>\n<md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option \nvalue=\"10\">10</md-option><md-option value=\"11\">11</md-option><md-option value=\"12\">12</md-option><md-option value=\"13\">\n13</md-option><md-option value=\"14\">14</md-option><md-option value=\"15\">15</md-option><md-option value=\"16\">16\n</md-option><md-option value=\"17\">17</md-option><md-option value=\"18\">18</md-option><md-option value=\"19\">19\n</md-option><md-option value=\"20\">20</md-option><md-option value=\"21\">21</md-option><md-option value=\"22\">22\n</md-option><md-option value=\"23\">23</md-option><md-option value=\"24\">24</md-option><md-option value=\"25\">25\n</md-option><md-option value=\"26\">26</md-option><md-option value=\"27\">27</md-option><md-option value=\"28\">28\n</md-option><md-option value=\"29\">29</md-option><md-option value=\"30\">30</md-option><md-option value=\"31\">31\n</md-option><md-option value=\"32\">32</md-option><md-option value=\"33\">33</md-option><md-option value=\"34\">34\n</md-option><md-option value=\"35\">35</md-option><md-option value=\"36\">36</md-option><md-option value=\"37\">37\n</md-option><md-option value=\"38\">38</md-option><md-option value=\"39\">39</md-option><md-option value=\"40\">40\n</md-option><md-option value=\"41\">41</md-option><md-option value=\"42\">42</md-option><md-option value=\"43\">43\n</md-option><md-option value=\"44\">44</md-option><md-option value=\"45\">45</md-option><md-option value=\"46\">46\n</md-option><md-option value=\"47\">47</md-option><md-option value=\"48\">48</md-option><md-option value=\"49\">49\n</md-option><md-option value=\"50\">50</md-option></md-select></md-input-container><md-input-container flex \nclass=\"md-block\"><label>No. of Trays</label><md-select ng-model=\"pctrl.clearmanufacturing.lownumtrays\" \ndisabled=\"disabled\"><md-option value=\"0\">0</md-option><md-option value=\"1\">1</md-option><md-option value=\"2\">2\n</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option>\n<md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option \nvalue=\"9\">9</md-option><md-option value=\"10\">10</md-option><md-option value=\"11\">11</md-option><md-option value=\"12\">12\n</md-option><md-option value=\"13\">13</md-option><md-option value=\"14\">14</md-option><md-option value=\"15\">15\n</md-option><md-option value=\"16\">16</md-option><md-option value=\"17\">17</md-option><md-option value=\"18\">18\n</md-option><md-option value=\"19\">19</md-option><md-option value=\"20\">20</md-option><md-option value=\"21\">21\n</md-option><md-option value=\"22\">22</md-option><md-option value=\"23\">23</md-option><md-option value=\"24\">24\n</md-option><md-option value=\"25\">25</md-option><md-option value=\"26\">26</md-option><md-option value=\"27\">27\n</md-option><md-option value=\"28\">28</md-option><md-option value=\"29\">29</md-option><md-option value=\"30\">30\n</md-option><md-option value=\"31\">31</md-option><md-option value=\"32\">32</md-option><md-option value=\"33\">33\n</md-option><md-option value=\"34\">34</md-option><md-option value=\"35\">35</md-option><md-option value=\"36\">36\n</md-option><md-option value=\"37\">37</md-option><md-option value=\"38\">38</md-option><md-option value=\"39\">39\n</md-option><md-option value=\"40\">40</md-option><md-option value=\"41\">41</md-option><md-option value=\"42\">42\n</md-option><md-option value=\"43\">43</md-option><md-option value=\"44\">44</md-option><md-option value=\"45\">45\n</md-option><md-option value=\"46\">46</md-option><md-option value=\"47\">47</md-option><md-option value=\"48\">48\n</md-option><md-option value=\"49\">49</md-option><md-option value=\"50\">50</md-option></md-select></md-input-container>\n<div layout=\"row\" class=\"md-padding\"><md-checkbox ng-model=\"pctrl.clearmanufacturing.lowstentsup\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Lower Up Stents\" disabled=\"disabled\">Stents</md-checkbox></div></div></div></fieldset>\n<fieldset><legend><h3>Bleaching Trays</h3></legend><div layout=\"row\" layout-align=\"center center\"><div flex-xs \nflex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><md-checkbox \nng-model=\"pctrl.clearmanufacturing.bleachingupper\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Upper Bonded Fixed Retainer\" disabled=\"disabled\">Upper</md-checkbox></div></div><div flex-xs flex=\"50\" \nlayout=\"column\"><div layout=\"row\" class=\"md-padding\"><md-checkbox ng-model=\"pctrl.clearmanufacturing.bleachinglower\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower Bonded Fixed Retainer\" disabled=\"disabled\">Lower</md-checkbox>\n</div></div></div></fieldset><fieldset><legend><h3>Essix Retainer</h3></legend><div layout=\"row\" \nlayout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-input-container flex class=\"md-block\"><label>\nNo. of Essix</label><md-select ng-model=\"pctrl.clearmanufacturing.upnumessix\" disabled=\"disabled\"><md-option value=\"1\">\n1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option></md-select></md-input-container>\n</div><div flex-xs flex=\"50\" layout=\"column\"><md-input-container flex class=\"md-block\"><label>No. of Essix</label>\n<md-select ng-model=\"pctrl.clearmanufacturing.lownumessix\" disabled=\"disabled\"><md-option value=\"1\">1</md-option>\n<md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option></md-select></md-input-container></div></div>\n</fieldset><fieldset><legend><h3>Pull Down Splint</h3></legend><div layout=\"row\" layout-align=\"center center\"><div \nflex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><md-checkbox \nng-model=\"pctrl.clearmanufacturing.pulldownupper\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper Brackets\" \ndisabled=\"disabled\">Upper</md-checkbox></div></div><div flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" \nclass=\"md-padding\"><md-checkbox ng-model=\"pctrl.clearmanufacturing.pulldownlower\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Lower Brackets\" disabled=\"disabled\">Lower</md-checkbox></div></div></div></fieldset></div><h2 \nng-show=\"!showDetails6\">Removeable Appliance Manufacturing | <a ng-click=\"showDetails6 = ! showDetails6\" \nclass=\"pointer\">Show Info</a></h2><h2 ng-show=\"showDetails6\">Removeable Appliance Manufacturing | <a \nng-click=\"showDetails6 = ! showDetails6\" class=\"pointer\">Hide Info</a></h2><div ng-show=\"showDetails6\"><fieldset>\n<legend><h3>Inman Aligner</h3></legend><div layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" \nlayout=\"column\"><div layout=\"row\" class=\"md-padding\"><md-checkbox ng-model=\"pctrl.inmanufacturing.upper\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Inman Aligner Upper\" disabled=\"disabled\">Upper</md-checkbox></div>\n</div><div flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><md-checkbox \nng-model=\"pctrl.inmanufacturing.lower\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Inman Aligner Lower\" \ndisabled=\"disabled\">Lower</md-checkbox></div></div></div></fieldset><fieldset><legend><h3>Removeable Appliance</h3>\n</legend><div layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" \nclass=\"md-padding\"><md-checkbox ng-model=\"pctrl.inmanufacturing.upremovable\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Removable Appliance Upper\" disabled=\"disabled\">Upper</md-checkbox></div></div><div flex-xs flex=\"50\" \nlayout=\"column\"><div layout=\"row\" class=\"md-padding\"><md-checkbox ng-model=\"pctrl.inmanufacturing.loremovable\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Removable Appliance Lower\" disabled=\"disabled\">Lower</md-checkbox>\n</div></div></div></fieldset><fieldset><legend><h3>Fixed Appliances</h3></legend><div layout=\"row\" \nlayout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><md-checkbox \nng-model=\"pctrl.inmanufacturing.upfixedapp\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Fixed Appliances Upper\" \ndisabled=\"disabled\">Upper</md-checkbox></div></div><div flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" \nclass=\"md-padding\"><md-checkbox ng-model=\"pctrl.inmanufacturing.lofixedapp\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Fixed Appliances Lower\" disabled=\"disabled\">Lower</md-checkbox></div></div></div></fieldset><fieldset>\n<legend><h3>Nimrod Aligner</h3></legend><div layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" \nlayout=\"column\"><div layout=\"row\" class=\"md-padding\"><md-checkbox ng-model=\"pctrl.inmanufacturing.upnimrodaligner\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Nimrod Aligner Upper\" disabled=\"disabled\">Upper</md-checkbox></div>\n</div><div flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><md-checkbox \nng-model=\"pctrl.inmanufacturing.lonimrodaligner\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Nimrod Aligner Lower\" \ndisabled=\"disabled\">Lower</md-checkbox></div></div></div></fieldset><fieldset><legend><h3>Heat Cure</h3></legend><div \nlayout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-checkbox \nng-model=\"pctrl.inmanufacturing.upheatcure\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Heat Cure Upper\" \ndisabled=\"disabled\">Upper</md-checkbox></div><div flex-xs flex=\"50\" layout=\"column\"><md-checkbox \nng-model=\"pctrl.inmanufacturing.loheatcure\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Heat Cure Lower\" \ndisabled=\"disabled\">Lower</md-checkbox></div></div></fieldset><div layout=\"row\" layout-align=\"center center\" \nclass=\"md-padding\"><md-checkbox ng-model=\"pctrl.inmanufacturing.functionalapp\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Functional Appliance\" disabled=\"disabled\">Functional Appliance</md-checkbox></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button>\n<md-button ng-if=\"pctrl.disabled==false\" class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(pctrl.packaging)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/departments/planning.html","<md-dialog flex=\"30\" aria-label=\"Planning\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"pctrl.planning.orders_id\" ng-init=\"pctrl.planning.orders_id=id\"> <input \ntype=\"hidden\" ng-if=\"pctrl.planning.orders_planning_id\" ng-model=\"pctrl.planning.orders_planning_id\" \nng-init=\"pctrl.planning.orders_planning_id=pctrl.planning.orders_planning_id\"> <input type=\"hidden\" \nng-if=\"!pctrl.planning.orders_planning_id\" ng-model=\"pctrl.planning.orders_planning_id\" \nng-init=\"pctrl.planning.orders_planning_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Planning</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-padding\"><div layout=\"row\" layout-align=\"center center\"><div flex-xs \nflex=\"45\" layout=\"column\"><md-checkbox ng-model=\"pctrl.planning.bredent\" ng-disabled=\"pctrl.disabled\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Bredent\">Bredent</md-checkbox><md-checkbox \nng-model=\"pctrl.planning.osstem\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Osstem\">\nOsstem</md-checkbox><md-checkbox ng-model=\"pctrl.planning.sic\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"SIC\">SIC</md-checkbox></div><div flex-xs flex=\"55\" layout=\"column\"><md-checkbox \nng-model=\"pctrl.planning.camlog\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Camlog\">\nCamlog</md-checkbox><md-checkbox ng-model=\"pctrl.planning.biohorizons\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Biohorizons\">Biohorizons</md-checkbox><md-checkbox ng-model=\"pctrl.planning.straumann\" \nng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Straumann\">Straumann</md-checkbox></div>\n</div><div flex layout=\"row\" layout-align=\"center center\"><md-input-container flex><label>Comments</label><textarea \nclass=\"full-width\" rows=\"5\" name=\"other\" ng-disabled=\"pctrl.disabled\" ng-model=\"pctrl.planning.comments\"></textarea>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" \nng-click=\"cancel()\">Cancel</md-button><md-button ng-if=\"pctrl.disabled==false\" class=\"md-green-500-bg branco\" \ntype=\"submit\" ng-click=\"recordForm.$valid && gravar(pctrl.planning)\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/production/departments/plasterroom.html","<md-dialog aria-label=\"Plaster Room\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"pctrl.plasterroom.orders_id\" ng-init=\"pctrl.plasterroom.orders_id=id\"> <input\n type=\"hidden\" ng-if=\"pctrl.plasterroom.orders_plasterroom_id\" ng-model=\"pctrl.plasterroom.orders_plasterroom_id\" \nng-init=\"pctrl.plasterroom.orders_plasterroom_id=pctrl.plasterroom.orders_plasterroom_id\"> <input type=\"hidden\" \nng-if=\"!pctrl.plasterroom.orders_plasterroom_id\" ng-model=\"pctrl.plasterroom.orders_plasterroom_id\" \nng-init=\"pctrl.plasterroom.orders_plasterroom_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Plaster Room</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"center center\"><md-input-container flex \nmd-is-error=\"recordForm.upper.$invalid && (recordForm.upper.$touched || recordForm.$submitted)\" class=\"md-block\">\n<label>Upper</label><md-select ng-model=\"pctrl.plasterroom.upper\" ng-disabled=\"pctrl.disabled\"><md-option value=\"1\">1\n</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option>\n<md-option value=\"5\">5</md-option></md-select><div ng-messages=\"recordForm.upper.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Please choose an option.</span></div></div></md-input-container><md-input-container flex \nmd-is-error=\"recordForm.lower.$invalid && (recordForm.lower.$touched || recordForm.$submitted)\" class=\"md-block\">\n<label>Lower</label><md-select ng-model=\"pctrl.plasterroom.lower\" ng-disabled=\"pctrl.disabled\"><md-option value=\"1\">1\n</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option>\n<md-option value=\"5\">5</md-option></md-select><div ng-messages=\"recordForm.lower.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Please choose an option.</span></div></div></md-input-container></div><md-dialog-actions \nlayout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button ng-if=\"pctrl.disabled==false\" \nclass=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"recordForm.$valid && gravar(pctrl.plasterroom)\">Save</md-button>\n</md-dialog-actions></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/pages/production/departments/platforms.html","<md-dialog aria-label=\"Platforms\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"pctrl.platforms.orders_id\" ng-init=\"pctrl.platforms.orders_id=id\"> <input \ntype=\"hidden\" ng-if=\"pctrl.platforms.orders_platforms_id\" ng-model=\"pctrl.platforms.orders_platforms_id\" \nng-init=\"pctrl.platforms.orders_platforms_id=pctrl.platforms.orders_platforms_id\"> <input type=\"hidden\" \nng-if=\"!pctrl.platforms.orders_platforms_id\" ng-model=\"pctrl.platforms.orders_platforms_id\" \nng-init=\"pctrl.platforms.orders_platforms_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Platforms</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"center center\"><md-input-container flex \nmd-is-error=\"recordForm.upper.$invalid && (recordForm.upper.$touched || recordForm.$submitted)\" class=\"md-block\">\n<label>Upper</label><md-select ng-model=\"pctrl.platforms.upper\" ng-disabled=\"pctrl.disabled\"><md-option value=\"1\">1\n</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option>\n<md-option value=\"5\">5</md-option></md-select><div ng-messages=\"recordForm.upper.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Please choose an option.</span></div></div></md-input-container><md-input-container flex \nmd-is-error=\"recordForm.lower.$invalid && (recordForm.lower.$touched || recordForm.$submitted)\" class=\"md-block\">\n<label>Lower</label><md-select ng-model=\"pctrl.platforms.lower\" ng-disabled=\"pctrl.disabled\"><md-option value=\"1\">1\n</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option>\n<md-option value=\"5\">5</md-option></md-select><div ng-messages=\"recordForm.lower.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Please choose an option.</span></div></div></md-input-container></div><h3>Type of Model\n</h3><div layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-radio-group \nng-model=\"pctrl.platforms.typeupper\"><md-radio-button value=\"horseshoe\" aria-label=\"Upper Horse Shoe\" \nng-disabled=\"pctrl.disabled\">Horse Shoe</md-radio-button></md-radio-group><md-radio-group \nng-model=\"pctrl.platforms.typeupper\"><md-radio-button value=\"fullmodels\" aria-label=\"Upper Full Models\" \nng-disabled=\"pctrl.disabled\">Full Models</md-radio-button></md-radio-group><md-radio-group \nng-model=\"pctrl.platforms.typeupper\"><md-radio-button value=\"clearaligners\" aria-label=\"Upper Clear Aligners\" \nng-disabled=\"pctrl.disabled\">Clear Aligners</md-radio-button></md-radio-group><md-radio-group \nng-model=\"pctrl.platforms.typeupper\"><md-radio-button value=\"drillinguides\" aria-label=\"Upper Extras\" \nng-disabled=\"pctrl.disabled\">Drilling Guides</md-radio-button></md-radio-group><md-radio-group \nng-model=\"pctrl.platforms.typeupper\"><md-radio-button value=\"extras\" aria-label=\"Upper Extras\" \nng-disabled=\"pctrl.disabled\">Extras</md-radio-button></md-radio-group></div><div flex-xs flex=\"50\" layout=\"column\">\n<md-radio-group ng-model=\"pctrl.platforms.typelower\"><md-radio-button value=\"horseshoe\" aria-label=\"Upper Horse Shoe\" \nng-disabled=\"pctrl.disabled\">Horse Shoe</md-radio-button></md-radio-group><md-radio-group \nng-model=\"pctrl.platforms.typelower\"><md-radio-button value=\"fullmodels\" aria-label=\"Upper Full Models\" \nng-disabled=\"pctrl.disabled\">Full Models</md-radio-button></md-radio-group><md-radio-group \nng-model=\"pctrl.platforms.typelower\"><md-radio-button value=\"clearaligners\" aria-label=\"Upper Clear Aligners\" \nng-disabled=\"pctrl.disabled\">Clear Aligners</md-radio-button></md-radio-group><md-radio-group \nng-model=\"pctrl.platforms.typelower\"><md-radio-button value=\"drillinguides\" aria-label=\"Upper Extras\" \nng-disabled=\"pctrl.disabled\">Drilling Guides</md-radio-button></md-radio-group><md-radio-group \nng-model=\"pctrl.platforms.typelower\"><md-radio-button value=\"extras\" aria-label=\"Upper Extras\" \nng-disabled=\"pctrl.disabled\">Extras</md-radio-button></md-radio-group></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button \nng-if=\"pctrl.disabled==false\" class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(pctrl.platforms)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/departments/scanning.html","<md-dialog id=\"scanning\" flex=\"60\" aria-label=\"Scanning\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"pctrl.scanning.orders_id\" \nng-init=\"pctrl.scanning.orders_id=id\"> <input type=\"hidden\" ng-if=\"pctrl.scanning.orders_scanning_id\" \nng-model=\"pctrl.scanning.orders_scanning_id\" \nng-init=\"pctrl.scanning.orders_scanning_id=pctrl.scanning.orders_scanning_id\"> <input type=\"hidden\" \nng-if=\"!pctrl.scanning.orders_scanning_id\" ng-model=\"pctrl.scanning.orders_scanning_id\" \nng-init=\"pctrl.scanning.orders_scanning_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Scanning</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"center center\"><md-input-container flex \nmd-is-error=\"recordForm.upper.$invalid && (recordForm.upper.$touched || recordForm.$submitted)\" class=\"md-block\">\n<label>Upper</label><md-select ng-model=\"pctrl.scanning.upper\" ng-disabled=\"pctrl.disabled\"><md-option value=\"1\">1\n</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option>\n<md-option value=\"5\">5</md-option></md-select><div ng-messages=\"recordForm.upper.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Please choose an option.</span></div></div></md-input-container><md-input-container flex \nmd-is-error=\"recordForm.lower.$invalid && (recordForm.lower.$touched || recordForm.$submitted)\" class=\"md-block\">\n<label>Lower</label><md-select ng-model=\"pctrl.scanning.lower\" ng-disabled=\"pctrl.disabled\"><md-option value=\"1\">1\n</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option>\n<md-option value=\"5\">5</md-option></md-select><div ng-messages=\"recordForm.lower.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Please choose an option.</span></div></div></md-input-container></div><h3>Work Type</h3>\n<div layout=\"row\" layout-align=\"center center\"><table flex class=\"tableradio full-width\"><thead><tr><th \nclass=\"type1-bk\">Clear Aligners</th><th class=\"type2-bk\">Clear Aligners<br>Case Assessment</th><th class=\"type3-bk\">\nInman Case Assessment<br>Inman Treatment Plan</th><th class=\"type4-bk\">Join Case<br>(Same Dept.)</th><th \nclass=\"type5-bk\">Join Case<br>(Different Depts.)</th></tr></thead><tbody><tr><td><md-radio-group \nng-model=\"pctrl.scanning.type\"><md-radio-button value=\"clearaligners\" ng-disabled=\"pctrl.disabled\" \naria-label=\"Clear Aligners\"></md-radio-button></md-radio-group></td><td><md-radio-group ng-model=\"pctrl.scanning.type\">\n<md-radio-button value=\"cacaseass\" ng-disabled=\"pctrl.disabled\" aria-label=\"Case Assessment\"></md-radio-button>\n</md-radio-group></td><td><md-radio-group ng-model=\"pctrl.scanning.type\"><md-radio-button value=\"inmancaseass\" \nng-disabled=\"pctrl.disabled\" aria-label=\"InmanCase Assessment\"></md-radio-button></md-radio-group></td><td>\n<md-radio-group ng-model=\"pctrl.scanning.type\"><md-radio-button value=\"joincasesame\" ng-disabled=\"pctrl.disabled\" \naria-label=\"Join Case (Same Dept.)\"></md-radio-button></md-radio-group></td><td><md-radio-group \nng-model=\"pctrl.scanning.type\"><md-radio-button value=\"joincasediff\" ng-disabled=\"pctrl.disabled\" \naria-label=\"Join Case (Diff. Depts.)\"></md-radio-button></md-radio-group></td></tr></tbody><thead><tr><th \nclass=\"type6-bk\">3D Department</th><th class=\"type7-bk\">Removable<br>Appliances</th><th class=\"type8-bk\">Inman</th><th \nclass=\"type9-bk\">Brackets</th><th class=\"type10-bk\">Fixed Bonded</th></tr></thead><tbody><tr><td><md-radio-group \nng-model=\"pctrl.scanning.type\"><md-radio-button value=\"threeddepartment\" ng-disabled=\"pctrl.disabled\" \naria-label=\"3D Deparment\"></md-radio-button></md-radio-group></td><td><md-radio-group ng-model=\"pctrl.scanning.type\">\n<md-radio-button value=\"remappl\" ng-disabled=\"pctrl.disabled\" aria-label=\"Removable Appliances\"></md-radio-button>\n</md-radio-group></td><td><md-radio-group ng-model=\"pctrl.scanning.type\"><md-radio-button value=\"inman\" \nng-disabled=\"pctrl.disabled\" aria-label=\"Inman\"></md-radio-button></md-radio-group></td><td><md-radio-group \nng-model=\"pctrl.scanning.type\"><md-radio-button value=\"brackets\" ng-disabled=\"pctrl.disabled\" aria-label=\"Brackets\">\n</md-radio-button></md-radio-group></td><td><md-radio-group ng-model=\"pctrl.scanning.type\"><md-radio-button \nvalue=\"fixedbonded\" ng-disabled=\"pctrl.disabled\" aria-label=\"Fixed Bonded\"></md-radio-button></md-radio-group></td>\n</tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" \nng-click=\"cancel()\">Cancel</md-button><md-button ng-if=\"pctrl.disabled==false\" class=\"md-green-500-bg branco\" \ntype=\"submit\" ng-click=\"recordForm.$valid && gravar(pctrl.scanning)\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/production/departments/waiting.html","<md-dialog aria-label=\"Waiting for Call\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"pctrl.waiting.orders_id\" ng-init=\"pctrl.waiting.orders_id=id\"> <input \ntype=\"hidden\" ng-if=\"pctrl.waiting.orders_waitingcall_id\" ng-model=\"pctrl.waiting.orders_waitingcall_id\" \nng-init=\"pctrl.waiting.orders_waitingcall_id=pctrl.waiting.orders_waitingcall_id\"> <input type=\"hidden\" \nng-if=\"!pctrl.waiting.orders_waitingcall_id\" ng-model=\"pctrl.waiting.orders_waitingcall_id\" \nng-init=\"pctrl.waiting.orders_waitingcall_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Waiting for Call</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\">\n<h3>Upper</h3><h4>Type of Appliance</h4><md-checkbox ng-model=\"pctrl.waiting.upclear\" ng-disabled=\"pctrl.disabled\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Clear\">Clear</md-checkbox><md-checkbox \nng-model=\"pctrl.waiting.upinman\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Inman\">\nInman</md-checkbox><md-checkbox ng-model=\"pctrl.waiting.upbrackets\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Brackets\">Brackets</md-checkbox><md-checkbox ng-model=\"pctrl.waiting.upnimrodali\" \nng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"NimrodAligners\">NimrodAligners\n</md-checkbox><md-checkbox ng-model=\"pctrl.waiting.updrillingguides\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Drilling Guides\">Drilling Guides</md-checkbox><md-checkbox \nng-model=\"pctrl.waiting.upother\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Other\">\nOther</md-checkbox></div><div flex-xs flex=\"50\" layout=\"column\"><h3>Lower</h3><h4>Type of Appliance</h4><md-checkbox \nng-model=\"pctrl.waiting.lowclear\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Clear\">\nClear</md-checkbox><md-checkbox ng-model=\"pctrl.waiting.lowinman\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Inman\">Inman</md-checkbox><md-checkbox ng-model=\"pctrl.waiting.lowbrackets\" \nng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Brackets\">Brackets</md-checkbox>\n<md-checkbox ng-model=\"pctrl.waiting.lownimrodali\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"NimrodAligners\">NimrodAligners</md-checkbox><md-checkbox ng-model=\"pctrl.waiting.lowdrillingguides\" \nng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Drilling Guides\">Drilling Guides\n</md-checkbox><md-checkbox ng-model=\"pctrl.waiting.lowother\" ng-disabled=\"pctrl.disabled\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Other\">Other</md-checkbox></div></div><div layout=\"row\" layout-align=\"center center\"><div\n flex-xs flex=\"50\" layout=\"column\"><md-input-container flex><label>Comments</label><textarea rows=\"5\" \nname=\"upcomments\" ng-disabled=\"pctrl.disabled\" ng-model=\"pctrl.waiting.upcomments\"></textarea></md-input-container>\n</div><div flex-xs flex=\"50\" layout=\"column\"><md-input-container flex><label>Comments</label><textarea rows=\"5\" \nname=\"lowcomments\" ng-disabled=\"pctrl.disabled\" ng-model=\"pctrl.waiting.lowcomments\"></textarea></md-input-container>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel\n</md-button><md-button ng-if=\"pctrl.disabled==false\" class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(pctrl.waiting)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/others/addlabdoc.html","<md-dialog class=\"order-alert\" aria-label=\"Add Lab Doc\" ng-cloak><form name=\"myForm\"><input type=\"hidden\" \nng-model=\"orders_id\" ng-init=\"orders_id=id\"> <input type=\"hidden\" ng-model=\"users_id\" ng-init=\"users_id=userid\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2>Add Lab Doc</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex \nlayout-align=\"start center\"><div ngf-drop ngf-select ng-model=\"files\" class=\"drop-box\" \nngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" accept=\"image/*,application/pdf\" \nngf-pattern=\"\'image/*,application/pdf\'\">Drop files here<br>or<br>click to upload</div><div ngf-no-file-drop>\nFile Drag/Drop is not supported for this browser</div></div><div layout=\"row\" flex layout-align=\"start center\" \nng-if=\"files\">File(s):<ul><li ng-repeat=\"f in files\" style=\"font:smaller\">{{f.name}} {{f.$error}} {{f.$errorParam}}\n</li></ul></div><div layout=\"row\" flex layout-align=\"start center\" ng-if=\"determinateValue>0 && determinateValue<100\">\n<md-progress-linear md-mode=\"determinate\" value=\"{{determinateValue}}\"></md-progress-linear></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Close</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/pages/production/others/addnewdeliveryroute.html","<md-dialog flex=\"20\" class=\"adddeliveryroute\" aria-label=\"Add Delivery Route\" ngapp=\"caseType\" ng-cloak><form \nname=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" \nng-model=\"vm.order.orders_id\" ng-init=\"vm.order.orders_id=id\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nAdd Delivery Route</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\">\n<md-input-container flex \nmd-is-error=\"recordForm.deliveryroutes_id.$invalid && (recordForm.deliveryroutes_id.$touched || recordForm.$submitted)\">\n<label>Delivery Route</label><md-select name=\"deliveryroutes_id\" ng-model=\"vm.order.deliveryroutes_id\"><md-option \nng-repeat=\"(index,droute) in octrl.droutes\" ng-value=\"droute.deliveryroutes_id\" \nng-selected=\"droute.deliveryroutes_id == \'{{octrl.deliveryroutes_id}}\'\">{{droute.route}}</md-option></md-select><div \nng-messages=\"recordForm.deliveryroutes_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease choose a delivery route.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" \ntype=\"submit\" ng-click=\"recordForm.$valid && gravar(vm.order)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/others/addnewlinkorder.html","<md-dialog class=\"addnewlinkorder\" aria-label=\"Link New Order\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.order.orders_linked_id\" \nng-init=\"vm.order.orders_linked_id=\'0\'\"> <input type=\"hidden\" ng-model=\"vm.order.orders_id\" \nng-init=\"vm.order.orders_id=id\"> <input type=\"hidden\" ng-model=\"vm.order.linkedto_orders_id\" \nng-init=\"vm.order.linkedto_orders_id=linkedtoid\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Link New Order</h2><span\n flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\"><div class=\"md-padding\" flex \nlayout=\"row\" layout-align=\"center center\"><md-input-container flex=\"50\" class=\"md-block\"><label>Search Order</label>\n<input ng-model=\"octrl.search\" ng-change=\"octrl.searchTable(octrl.search, 0)\" type=\"text\"></md-input-container>\n<md-button ng-click=\"octrl.reset()\" class=\"md-primary md-raised\">Reset</md-button></div></div><div layout=\"row\" \nclass=\"md-dialog-content\"><table datatable=\"\" class=\"producttable hover\" ms-responsive-table \ndt-instance=\"octrl.dtInstance\" dt-options=\"octrl.dtOptions\" dt-columns=\"octrl.dtColumns\"></table></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button>\n<md-button class=\"md-green-500-bg branco\" ng-if=\"octrl.itemabrir && octrl.itemabrir.length==1\" \nng-click=\"gravar(octrl.itemabrir)\">Link Order</md-button><md-button class=\"md-green-500-bg branco\" \nng-if=\"octrl.itemabrir && octrl.itemabrir.length>1\" ng-click=\"gravar(octrl.itemabrir)\">\nLink {{octrl.itemabrir.length}} Orders</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/others/addnewproduct.html","<md-dialog class=\"searchpopup\" aria-label=\"Add Product\" ng-cloak><form class=\"addnewproduct\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Add Product</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-padding\" flex \nlayout=\"row\" layout-align=\"center center\"><md-input-container flex=\"80\" class=\"md-block\"><label>Search Product</label>\n<input ng-model=\"octrl.search\" ng-change=\"octrl.searchTable(octrl.search, 0)\" type=\"text\"></md-input-container>\n<md-button flex ng-click=\"octrl.reset()\" class=\"md-primary md-raised\">Reset</md-button></div><div layout=\"row\" \nclass=\"md-dialog-content\"><table datatable=\"\" class=\"tabela-pesquisa producttable\" ms-responsive-table \ndt-instance=\"octrl.dtInstance\" dt-options=\"octrl.dtOptions\" dt-columns=\"octrl.dtColumns\"></table></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"cancel()\">Cancel</md-button><md-button \nclass=\"md-green-500-bg branco\" ng-if=\"octrl.itemabrir && octrl.itemabrir.length==1\" ng-click=\"gravar(octrl.itemabrir)\">\nAdd Product</md-button><md-button class=\"md-green-500-bg branco\" ng-if=\"octrl.itemabrir && octrl.itemabrir.length>1\" \nng-click=\"gravar(octrl.itemabrir)\">Add {{octrl.itemabrir.length}} Products</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/production/others/approveorder.html","<md-dialog class=\"order-alert\" aria-label=\"Order Alert\" ngapp=\"caseType\"><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.iscustom\" \nng-init=\"vm.record.iscustom=\'0\'\"> <input type=\"hidden\" ng-model=\"vm.record.status_id\" \nng-init=\"vm.record.status_id=\'2\'\"> <input type=\"hidden\" ng-model=\"vm.record.orders_id\" \nng-init=\"vm.record.orders_id=id\"> <input type=\"hidden\" ng-model=\"vm.record.users_id\" \nng-init=\"vm.record.users_id=userid\"><md-toolbar class=\"approveorder-bg\"><div class=\"md-toolbar-tools\"><h2>Approve Order\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex \nmd-is-error=\"recordForm.description.$invalid && (recordForm.description.$touched || recordForm.$submitted)\"><label>\nMessage</label><textarea rows=\"5\" name=\"description\" ng-model=\"vm.record.description\" required></textarea><div \nng-messages=\"recordForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease insert a approval message.</span></div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"end center\"><div class=\"user\">{{username}}, {{data | date:\'dd/MM/yyyy H:m\'}}</div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button>\n<md-button class=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"recordForm.$valid && gravar(vm.record)\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/others/cancelorder.html","<md-dialog class=\"order-alert\" aria-label=\"Order Alert\" ngapp=\"caseType\"><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.iscustom\" \nng-init=\"vm.record.iscustom=\'0\'\"> <input type=\"hidden\" ng-model=\"vm.record.status_id\" \nng-init=\"vm.record.status_id=\'1\'\"> <input type=\"hidden\" ng-model=\"vm.record.orders_id\" \nng-init=\"vm.record.orders_id=id\"> <input type=\"hidden\" ng-model=\"vm.record.users_id\" \nng-init=\"vm.record.users_id=userid\"><md-toolbar class=\"cancelorder-bg\"><div class=\"md-toolbar-tools\"><h2>Cancel Order\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex \nmd-is-error=\"recordForm.description.$invalid && (recordForm.description.$touched || recordForm.$submitted)\"><label>\nMessage</label><textarea rows=\"5\" name=\"description\" ng-model=\"vm.record.description\" required></textarea><div \nng-messages=\"recordForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease insert a cancelation message.</span></div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"end center\"><div class=\"user\">{{username}}, {{data | date:\'dd/MM/yyyy H:m\'}}</div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button>\n<md-button class=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"recordForm.$valid && gravar(vm.record)\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/others/changeorderstatus.html","<md-dialog flex=\"20\" aria-label=\"Change Order Status\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.order.orders_id\" \nng-init=\"vm.order.orders_id=id\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Change Order Status</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex \nmd-is-error=\"recordForm.status_id.$invalid && (recordForm.status_id.$touched || recordForm.$submitted)\"><label>\nOrder Status</label><md-select name=\"status_id\" ng-model=\"vm.order.status_id\"><md-option \nng-repeat=\"(index,statuz) in octrl.statuses\" ng-value=\"statuz.status_id\" \nng-selected=\"statuz.status_id == \'{{octrl.status_id}}\'\">{{statuz.status}}</md-option></md-select><div \nng-messages=\"recordForm.status_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please choose a status.</span>\n</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" \nng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(vm.order)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/others/completeorder.html","<md-dialog class=\"order-alert\" aria-label=\"Order Alert\" ngapp=\"caseType\"><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.iscustom\" \nng-init=\"vm.record.iscustom=\'0\'\"> <input type=\"hidden\" ng-model=\"vm.record.status_id\" \nng-init=\"vm.record.status_id=\'5\'\"> <input type=\"hidden\" ng-model=\"vm.record.orders_id\" \nng-init=\"vm.record.orders_id=id\"> <input type=\"hidden\" ng-model=\"vm.record.users_id\" \nng-init=\"vm.record.users_id=userid\"><md-toolbar class=\"approveorder-bg\"><div class=\"md-toolbar-tools\"><h2>\nComplete Order</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\">\n<md-input-container flex \nmd-is-error=\"recordForm.description.$invalid && (recordForm.description.$touched || recordForm.$submitted)\"><label>\nMessage</label><textarea rows=\"5\" name=\"description\" ng-model=\"vm.record.description\" required></textarea><div \nng-messages=\"recordForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease insert a completion message.</span></div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"end center\"><div class=\"user\">{{username}}, {{data | date:\'dd/MM/yyyy H:m\'}}</div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button>\n<md-button class=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"recordForm.$valid && gravar(vm.record)\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/others/neworderalert.html","<md-dialog class=\"order-alert\" aria-label=\"Order Alert\" ngapp=\"caseType\"><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.iscustom\" \nng-init=\"vm.record.iscustom=\'1\'\"> <input type=\"hidden\" ng-model=\"vm.record.orders_id\" ng-init=\"vm.record.orders_id=id\">\n <input type=\"hidden\" ng-model=\"vm.record.users_id\" ng-init=\"vm.record.users_id=userid\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>New Custom Order Alert</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex \nlayout-align=\"start center\"><md-input-container flex class=\"md-block\" \nmd-is-error=\"recordForm.subject.$invalid && (recordForm.subject.$touched || recordForm.$submitted)\"><label>Subject\n</label><input type=\"text\" name=\"subject\" ng-model=\"vm.record.subject\" required><div \nng-messages=\"recordForm.subject.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert the subject.</span>\n</div></div></md-input-container></div><div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex \nmd-is-error=\"recordForm.description.$invalid && (recordForm.description.$touched || recordForm.$submitted)\"><label>\nMessage</label><textarea rows=\"5\" name=\"description\" ng-model=\"vm.record.description\" required></textarea><div \nng-messages=\"recordForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert the message.\n</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \ntype=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(vm.record)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/others/scanorder.html","<md-dialog flex=\"20\" class=\"adddeliveryroute\" aria-label=\"Scan Order\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><md-toolbar><div class=\"md-toolbar-tools\"><h2>Scan Order</h2><span\n flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><h3>Scan your order barcode or insert order number</h3><div layout=\"row\" flex \nlayout-align=\"start center\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Order Number</label><input \ntype=\"text\" required md-autofocus name=\"scanorderid\" minlength=\"8\" maxlength=\"8\" ng-model=\"vm.scanorderid\" \norder-available><div ng-messages=\"recordForm.scanorderid.$error\"><div ng-message=\"required\">\nPlease scan order barcode or insert an Order Number, starting with *</div><div ng-message=\"maxlength\">\nOrder Number is too long. Please insert only 8 characters.</div><div ng-message=\"minlength\">\nOrder Number is short. Please insert at least 8 characters.</div><div ng-message=\"erro\">\nOrder Number does not exist. Please try another one, starting with *</div><div ng-message=\"opened\">\nOrder already opened.</div></div><div ng-if=\"recordForm.scanorderid.$pending\">Loading, please wait...</div><div \nng-if=\"recordForm.scanorderid.$valid\">Opening order, please wait...</div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/others/search.html","<md-dialog class=\"searchpopup\" aria-label=\"Search\" ng-cloak><form class=\"casetype\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Search Order</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"estado-funcoes\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"estado-funcoes-esq\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-primary md-raised\">Scan</md-button><md-icon \nmd-font-icon=\"icon-barcode\" class=\"s48 md-default-theme md-font material-icons icon-barcode\" aria-hidden=\"true\">\n</md-icon></div><div class=\"estado-funcoes-dir\" layout=\"row\" layout-align=\"end center\" ng-click=\"octrl.reset()\">\n<md-button class=\"md-primary md-raised\">Reset</md-button><md-icon md-font-icon=\"icon-refresh\" \nclass=\"s36 md-default-theme md-font material-icons icon-refresh pointer\" aria-hidden=\"true\"></md-icon></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>\nStart date (yyyy-mm-dd)</label><input type=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"octrl.startDate\" \nng-change=\"octrl.searchTable(octrl.startDate, 16)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>End date (yyyy-mm-dd)</label><input type=\"text\" \nname=\"endDate\" mask=\"9999-19-39\" ng-model=\"octrl.endDate\" ng-change=\"octrl.searchTable(octrl.endDate, 17)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>Received Date (yyyy-mm-dd)</label><input type=\"text\" name=\"onDate\" mask=\"9999-19-39\" ng-model=\"octrl.onDate\" \nng-change=\"octrl.searchTable(octrl.onDate, 15)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>Client</label><input \nng-model=\"octrl.search.performername\" ng-change=\"octrl.searchTable(octrl.search.performername, 8)\" type=\"text\">\n</md-input-container><md-input-container layout=\"row\" flex class=\"md-block\"><label>City</label><input \nng-model=\"octrl.search.ccity\" ng-change=\"octrl.searchTable(octrl.search.ccity, 3)\" type=\"text\"></md-input-container>\n<md-input-container flex class=\"md-block\"><label>Country</label><input ng-model=\"octrl.search.ccountry\" \nng-change=\"octrl.searchTable(octrl.search.ccountry, 4)\" type=\"text\"></md-input-container></div><div layout=\"row\">\n<md-input-container flex class=\"md-block\"><label>Order No</label><input ng-model=\"octrl.search.ordernumber\" \nng-change=\"octrl.searchTable(octrl.search.ordernumber, 0)\" type=\"text\"></md-input-container><md-input-container \nlayout=\"row\" flex class=\"md-block\"><label>Perscription No</label><input ng-model=\"octrl.search.prescription_number\" \nng-change=\"octrl.searchTable(octrl.search.prescription_number, 2)\" type=\"text\"></md-input-container><md-input-container\n flex class=\"md-block\"><label>Patient Name</label><input ng-model=\"octrl.search.patient_name\" \nng-change=\"octrl.searchTable(octrl.search.patient_name, 10)\" type=\"text\"></md-input-container><md-input-container flex \nclass=\"md-block\"><label>Department</label><md-select name=\"departments_id\" ng-model=\"octrl.search.departments_id\" \nng-change=\"octrl.searchTable(octrl.search.departments_id, 13)\"><md-option value=\"\">All</md-option><md-option \nng-repeat=\"department in octrl.departments\" ng-value=\"department.departments_id\">{{department.department_name}}\n</md-option></md-select></md-input-container><md-input-container flex class=\"md-block\"><label>Status</label><md-select \nname=\"status_id\" ng-model=\"octrl.search.status_id\" ng-change=\"octrl.searchTable(octrl.search.status_id, 14)\"><md-option\n value=\"\">All</md-option><md-option value=\"2\">Approved</md-option><md-option value=\"6\">Awaiting Approval</md-option>\n<md-option value=\"1\">Cancelled</md-option><md-option value=\"5\">Completed</md-option></md-select></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>Postcode</label><input ng-model=\"octrl.search.cpostcode\" \nng-change=\"octrl.searchTable(octrl.search.cpostcode, 5)\" type=\"text\"></md-input-container></div><md-input-container \nflex class=\"md-block\"><label>Invoice No</label><input ng-model=\"octrl.search.invoice_number\" \nng-change=\"octrl.searchTable(octrl.search.invoice_number, 1)\" type=\"text\"></md-input-container><div layout=\"row\" \nclass=\"production-search tabela-small full-width\"><table datatable=\"\" class=\"row-border hover full-width\" \ndt-instance=\"octrl.dtInstance\" dt-options=\"octrl.dtOptions\" dt-columns=\"octrl.dtColumns\"></table></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"cancel()\">Close</md-button><md-button \nclass=\"md-green-500-bg branco\" ng-if=\"octrl.itemabrir && octrl.itemabrir.length==1\" ng-click=\"gravar(octrl.itemabrir)\">\nOpen Order</md-button><md-button class=\"md-green-500-bg branco\" ng-if=\"octrl.itemabrir && octrl.itemabrir.length>1\" \nng-click=\"gravar(octrl.itemabrir)\">Open {{octrl.itemabrir.length}} Orders</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/production/others/showcasetype.html","<md-dialog flex=\"80\" id=\"casetype\" aria-label=\"Case Type: Case Assessment | Fixed Appliance\" ng-cloak><form \nname=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" \nng-if=\"octrl.casetypes[0].case_types_id!=null\" ng-model=\"octrl.casetypes[0].case_types_id\" \nng-init=\"octrl.casetypes[0].case_types_id=\'1\'\"> <input type=\"hidden\" ng-if=\"octrl.casetypes[1].case_types_id!=null\" \nng-model=\"octrl.casetypes[1].case_types_id\" ng-init=\"octrl.casetypes[1].case_types_id=\'2\'\"> <input type=\"hidden\" \nng-if=\"octrl.casetypes[2].case_types_id!=null\" ng-model=\"octrl.casetypes[2].case_types_id\" \nng-init=\"octrl.casetypes[2].case_types_id=\'4\'\"> <input type=\"hidden\" ng-if=\"octrl.casetypes[3].case_types_id!=null\" \nng-model=\"octrl.casetypes[3].case_types_id\" ng-init=\"octrl.casetypes[3].case_types_id=\'5\'\"> <input type=\"hidden\" \nng-if=\"octrl.casetypes[4].case_types_id!=null\" ng-model=\"octrl.casetypes[4].case_types_id\" \nng-init=\"octrl.casetypes[4].case_types_id=\'6\'\"> <input type=\"hidden\" ng-if=\"octrl.casetypes[5].case_types_id!=null\" \nng-model=\"octrl.casetypes[5].case_types_id\" ng-init=\"octrl.casetypes[5].case_types_id=\'7\'\"> <input type=\"hidden\" \nng-if=\"octrl.casetypes[6].case_types_id!=null\" ng-model=\"octrl.casetypes[6].case_types_id\" \nng-init=\"octrl.casetypes[6].case_types_id=\'8\'\"> <input type=\"hidden\" ng-if=\"octrl.casetypes[7].case_types_id!=null\" \nng-model=\"octrl.casetypes[7].case_types_id\" ng-init=\"octrl.casetypes[7].case_types_id=\'9\'\"> <input type=\"hidden\" \nng-if=\"octrl.casetypes[8].case_types_id!=null\" ng-model=\"octrl.casetypes[8].case_types_id\" \nng-init=\"octrl.casetypes[8].case_types_id=\'10\'\"> <input type=\"hidden\" ng-if=\"octrl.casetypes[9].case_types_id!=null\" \nng-model=\"octrl.casetypes[9].case_types_id\" ng-init=\"octrl.casetypes[9].case_types_id=\'11\'\"> <input type=\"hidden\" \nng-if=\"octrl.casetypes[10].case_types_id!=null\" ng-model=\"octrl.casetypes[10].case_types_id\" \nng-init=\"octrl.casetypes[10].case_types_id=\'12\'\"> <input type=\"hidden\" ng-if=\"octrl.casetypes[11].case_types_id!=null\" \nng-model=\"octrl.casetypes[11].case_types_id\" ng-init=\"octrl.casetypes[11].case_types_id=\'13\'\"> <input type=\"hidden\" \nng-if=\"octrl.casetypes[12].case_types_id!=null\" ng-model=\"octrl.casetypes[12].case_types_id\" \nng-init=\"octrl.casetypes[12].case_types_id=\'14\'\"> <input type=\"hidden\" ng-if=\"octrl.casetypes[13].case_types_id!=null\" \nng-model=\"octrl.casetypes[13].case_types_id\" ng-init=\"octrl.casetypes[13].case_types_id=\'15\'\"> <input type=\"hidden\" \nng-if=\"octrl.casetypes[14].case_types_id!=null\" ng-model=\"octrl.casetypes[14].case_types_id\" \nng-init=\"octrl.casetypes[14].case_types_id=\'16\'\"> <input type=\"hidden\" ng-if=\"octrl.casetypes[15].case_types_id!=null\" \nng-model=\"octrl.casetypes[15].case_types_id\" ng-init=\"octrl.casetypes[15].case_types_id=\'17\'\"> <input type=\"hidden\" \nng-if=\"octrl.casetypes[16].case_types_id!=null\" ng-model=\"octrl.casetypes[16].case_types_id\" \nng-init=\"octrl.casetypes[16].case_types_id=\'18\'\"> <input type=\"hidden\" ng-if=\"octrl.casetypes[17].case_types_id!=null\" \nng-model=\"octrl.casetypes[17].case_types_id\" ng-init=\"octrl.casetypes[17].case_types_id=\'19\'\"> <input type=\"hidden\" \nng-if=\"octrl.casetypes[18].case_types_id!=null\" ng-model=\"octrl.casetypes[18].case_types_id\" \nng-init=\"octrl.casetypes[18].case_types_id=\'20\'\"> <input type=\"hidden\" ng-if=\"octrl.casetypes[19].case_types_id!=null\" \nng-model=\"octrl.casetypes[19].case_types_id\" ng-init=\"octrl.casetypes[19].case_types_id=\'21\'\"> <input type=\"hidden\" \nng-if=\"octrl.casetypes[20].case_types_id!=null\" ng-model=\"octrl.casetypes[20].case_types_id\" \nng-init=\"octrl.casetypes[20].case_types_id=\'22\'\"> <input type=\"hidden\" ng-if=\"octrl.casetypes[21].case_types_id!=null\" \nng-model=\"octrl.casetypes[21].case_types_id\" ng-init=\"octrl.casetypes[21].case_types_id=\'23\'\"> <input type=\"hidden\" \nng-if=\"octrl.casetypes[22].case_types_id!=null\" ng-model=\"octrl.casetypes[22].case_types_id\" \nng-init=\"octrl.casetypes[22].case_types_id=\'24\'\"> <input type=\"hidden\" ng-if=\"octrl.casetypes[23].case_types_id!=null\" \nng-model=\"octrl.casetypes[23].case_types_id\" ng-init=\"octrl.casetypes[23].case_types_id=\'25\'\"> <input type=\"hidden\" \nng-if=\"octrl.casetypes[24].case_types_id!=null\" ng-model=\"octrl.casetypes[24].case_types_id\" \nng-init=\"octrl.casetypes[24].case_types_id=\'26\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Case Type: <span \nng-show=\"(octrl.casetypes[0].upper == 1 || octrl.casetypes[0].lower == 1 || octrl.casetypes[1].upper == 1 || octrl.casetypes[1].lower == 1 || octrl.casetypes[2].upper == 1 || octrl.casetypes[2].lower == 1 || octrl.casetypes[3].upper == 1 || octrl.casetypes[3].lower == 1 || octrl.casetypes[4].upper == 1 || octrl.casetypes[4].lower == 1 || octrl.casetypes[5].upper == 1 || octrl.casetypes[5].lower == 1)\">\n3D |</span> <span \nng-show=\"(octrl.casetypes[6].upper == 1 || octrl.casetypes[6].lower == 1 || octrl.casetypes[7].upper == 1 || octrl.casetypes[7].lower == 1 || octrl.casetypes[8].upper == 1 || octrl.casetypes[8].lower == 1 || octrl.casetypes[9].upper == 1 || octrl.casetypes[9].lower == 1)\">\nCase Assessment |</span> <span \nng-show=\"(octrl.casetypes[10].upper == 1 || octrl.casetypes[10].lower == 1 || octrl.casetypes[11].upper == 1 || octrl.casetypes[11].lower == 1 || octrl.casetypes[12].upper == 1 || octrl.casetypes[12].lower == 1 || octrl.casetypes[13].upper == 1 || octrl.casetypes[13].lower == 1 || octrl.casetypes[14].upper == 1 || octrl.casetypes[14].lower == 1)\">\nClear |</span> <span \nng-show=\"(octrl.casetypes[15].upper == 1 || octrl.casetypes[15].lower == 1 || octrl.casetypes[16].upper == 1 || octrl.casetypes[16].lower == 1 || octrl.casetypes[17].upper == 1 || octrl.casetypes[17].lower == 1 || octrl.casetypes[18].upper == 1 || octrl.casetypes[18].lower == 1 || octrl.casetypes[19].upper == 1 || octrl.casetypes[19].lower == 1 || octrl.casetypes[20].upper == 1 || octrl.casetypes[20].lower == 1)\">\nInam |</span> <span ng-show=\"(octrl.casetypes[21].upper == 1 || octrl.casetypes[21].lower == 1)\">Implants |</span> \n<span \nng-show=\"(octrl.casetypes[22].upper == 1 || octrl.casetypes[22].lower == 1 || octrl.casetypes[23].upper == 1 || octrl.casetypes[23].lower == 1 || octrl.casetypes[24].upper == 1 || octrl.casetypes[24].lower == 1 || octrl.casetypes[25].upper == 1 || octrl.casetypes[25].lower == 1)\">\nTreatment Plan |</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" class=\"md-dialog-content\"><table \nflex=\"25\"><thead><tr><th>3D</th><th>Upper</th><th>Lower</th></tr></thead><tbody><tr><td>Extras</td><td><md-checkbox \nng-model=\"octrl.casetypes[0].upper\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td>\n<md-checkbox ng-model=\"octrl.casetypes[0].lower\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\"></md-checkbox>\n</td></tr><tr><td>Gigs</td><td><md-checkbox ng-model=\"octrl.casetypes[1].upper\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Upper\"></md-checkbox></td><td><md-checkbox ng-model=\"octrl.casetypes[1].lower\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Lower\"></md-checkbox></td></tr><tr><td>NimrodAligner</td><td><md-checkbox \nng-model=\"octrl.casetypes[2].upper\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td>\n<md-checkbox ng-model=\"octrl.casetypes[2].lower\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\"></md-checkbox>\n</td></tr><tr><td>NimrodRetainer</td><td><md-checkbox ng-model=\"octrl.casetypes[3].upper\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td><md-checkbox ng-model=\"octrl.casetypes[3].lower\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\"></md-checkbox></td></tr><tr><td>Splints</td><td><md-checkbox \nng-model=\"octrl.casetypes[4].upper\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td>\n<md-checkbox ng-model=\"octrl.casetypes[4].lower\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\"></md-checkbox>\n</td></tr><tr><td>Study Models</td><td><md-checkbox ng-model=\"octrl.casetypes[5].upper\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td><md-checkbox ng-model=\"octrl.casetypes[5].lower\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\"></md-checkbox></td></tr></tbody></table><table flex=\"25\"><thead>\n<tr><th>Case Assessment</th><th>Upper</th><th>Lower</th></tr></thead><tbody><tr><td>Brackets</td><td><md-checkbox \nng-model=\"octrl.casetypes[6].upper\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td>\n<md-checkbox ng-model=\"octrl.casetypes[6].lower\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\"></md-checkbox>\n</td></tr><tr><td>Clears</td><td><md-checkbox ng-model=\"octrl.casetypes[7].upper\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Upper\"></md-checkbox></td><td><md-checkbox ng-model=\"octrl.casetypes[7].lower\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Lower\"></md-checkbox></td></tr><tr><td>Inman</td><td><md-checkbox \nng-model=\"octrl.casetypes[8].upper\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td>\n<md-checkbox ng-model=\"octrl.casetypes[8].lower\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\"></md-checkbox>\n</td></tr><tr><td>Other</td><td><md-checkbox ng-model=\"octrl.casetypes[9].upper\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Upper\"></md-checkbox></td><td><md-checkbox ng-model=\"octrl.casetypes[9].lower\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Lower\"></md-checkbox></td></tr></tbody></table><table flex=\"25\"><thead><tr><th>Clear</th>\n<th>Upper</th><th>Lower</th></tr></thead><tbody><tr><td>Bonded Fixed Retainer</td><td><md-checkbox \nng-model=\"octrl.casetypes[10].upper\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td>\n<md-checkbox ng-model=\"octrl.casetypes[10].lower\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\"></md-checkbox>\n</td></tr><tr><td>Brackets</td><td><md-checkbox ng-model=\"octrl.casetypes[11].upper\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td><md-checkbox ng-model=\"octrl.casetypes[11].lower\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\"></md-checkbox></td></tr><tr><td>Clear Aligners</td><td>\n<md-checkbox ng-model=\"octrl.casetypes[12].upper\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox>\n</td><td><md-checkbox ng-model=\"octrl.casetypes[12].lower\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\">\n</md-checkbox></td></tr><tr><td>Essix Retainer</td><td><md-checkbox ng-model=\"octrl.casetypes[13].upper\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td><md-checkbox \nng-model=\"octrl.casetypes[13].lower\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\"></md-checkbox></td></tr>\n<tr><td>Hard & Soft Splints</td><td><md-checkbox ng-model=\"octrl.casetypes[14].upper\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td><md-checkbox ng-model=\"octrl.casetypes[14].lower\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\"></md-checkbox></td></tr></tbody></table><table flex=\"25\"><thead>\n<tr><th>Inman</th><th>Upper</th><th>Lower</th></tr></thead><tbody><tr><td>Fixed Appliance</td><td><md-checkbox \nng-model=\"octrl.casetypes[15].upper\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td>\n<md-checkbox ng-model=\"octrl.casetypes[15].lower\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\"></md-checkbox>\n</td></tr><tr><td>Functional Appliance</td><td><md-checkbox ng-model=\"octrl.casetypes[16].upper\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td><md-checkbox ng-model=\"octrl.casetypes[16].lower\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\"></md-checkbox></td></tr><tr><td>Heat Cure</td><td><md-checkbox \nng-model=\"octrl.casetypes[17].upper\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td>\n<md-checkbox ng-model=\"octrl.casetypes[17].lower\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\"></md-checkbox>\n</td></tr><tr><td>InmanAligner</td><td><md-checkbox ng-model=\"octrl.casetypes[18].upper\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td><md-checkbox ng-model=\"octrl.casetypes[18].lower\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\"></md-checkbox></td></tr><tr><td>NimrodAligner</td><td>\n<md-checkbox ng-model=\"octrl.casetypes[19].upper\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox>\n</td><td><md-checkbox ng-model=\"octrl.casetypes[19].lower\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\">\n</md-checkbox></td></tr><tr><td>Removable Appliance</td><td><md-checkbox ng-model=\"octrl.casetypes[20].upper\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td><md-checkbox \nng-model=\"octrl.casetypes[20].lower\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\"></md-checkbox></td></tr>\n</tbody></table></div><div layout=\"row\" class=\"md-dialog-content\"><table flex=\"25\"><thead><tr><th>Implants</th><th>\nUpper</th><th>Lower</th></tr></thead><tbody><tr><td>Implant Case</td><td><md-checkbox \nng-model=\"octrl.casetypes[21].upper\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td>\n<md-checkbox ng-model=\"octrl.casetypes[21].lower\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\"></md-checkbox>\n</td></tr></tbody></table><table flex=\"25\"><thead><tr><th>Treatment Plan</th><th>Upper</th><th>Lower</th></tr></thead>\n<tbody><tr><td>T. P. Brackets</td><td><md-checkbox ng-model=\"octrl.casetypes[22].upper\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td><md-checkbox ng-model=\"octrl.casetypes[22].lower\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\"></md-checkbox></td></tr><tr><td>T. P. Clears</td><td>\n<md-checkbox ng-model=\"octrl.casetypes[23].upper\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox>\n</td><td><md-checkbox ng-model=\"octrl.casetypes[23].lower\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\">\n</md-checkbox></td></tr><tr><td>T. P. Iman</td><td><md-checkbox ng-model=\"octrl.casetypes[24].upper\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td><md-checkbox ng-model=\"octrl.casetypes[24].lower\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\"></md-checkbox></td></tr><tr><td>T. P. Other</td><td><md-checkbox\n ng-model=\"octrl.casetypes[25].upper\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Upper\"></md-checkbox></td><td>\n<md-checkbox ng-model=\"octrl.casetypes[25].lower\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Lower\"></md-checkbox>\n</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" \nng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(octrl.casetypes)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/others/treatmentplan_lower.html","<md-dialog class=\"adddeliveryroute\" aria-label=\"Add Lower Treatment Plan Product\" ngapp=\"caseType\" ng-cloak><form \nname=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" \nng-model=\"octrl.prod.orders_id\" ng-init=\"octrl.prod.orders_id=id\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nAdd Lower Treatment Plan Product</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\">\n<md-input-container flex \nmd-is-error=\"recordForm.orders_product_id.$invalid && (recordForm.orders_product_id.$touched || recordForm.$submitted)\">\n<label>Product</label><md-select name=\"orders_product_id\" ng-model=\"octrl.prod.orders_product_id\"><md-option \nng-repeat=\"product in octrl.products | filter:{ upperORlower: \'2\'} as filtered1\" ng-value=\"product.orders_product_id\" \nng-selected=\"product.orders_product_id == \'{{octrl.orders_product_id}}\'\">{{product.product_description}}</md-option>\n</md-select><div ng-messages=\"recordForm.orders_product_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease choose a product.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" \ntype=\"submit\" ng-click=\"recordForm.$valid && gravar(octrl.prod)\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/production/others/treatmentplan_upper.html","<md-dialog class=\"adddeliveryroute\" aria-label=\"Add Upper Treatment Plan Product\" ngapp=\"caseType\" ng-cloak><form \nname=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" \nng-model=\"octrl.prod.orders_id\" ng-init=\"octrl.prod.orders_id=id\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nAdd Upper Treatment Plan Product</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\">\n<md-input-container flex \nmd-is-error=\"recordForm.orders_product_id.$invalid && (recordForm.orders_product_id.$touched || recordForm.$submitted)\">\n<label>Product</label><md-select name=\"orders_product_id\" ng-model=\"octrl.prod.orders_product_id\"><md-option \nng-repeat=\"product in octrl.products | filter:{ upperORlower: \'1\'} as filtered1\" ng-value=\"product.orders_product_id\" \nng-selected=\"product.orders_product_id == \'{{octrl.orders_product_id}}\'\">{{product.product_description}}</md-option>\n</md-select><div ng-messages=\"recordForm.orders_product_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease choose a product.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" \ntype=\"submit\" ng-click=\"recordForm.$valid && gravar(octrl.prod)\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/production/others/waitingcall.html","<md-dialog class=\"order-alert\" aria-label=\"Order Alert\" ngapp=\"caseType\"><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.iscustom\" \nng-init=\"vm.record.iscustom=\'0\'\"> <input type=\"hidden\" ng-model=\"vm.record.status_id\" \nng-init=\"vm.record.status_id=\'4\'\"> <input type=\"hidden\" ng-model=\"vm.record.orders_id\" \nng-init=\"vm.record.orders_id=id\"> <input type=\"hidden\" ng-model=\"vm.record.users_id\" \nng-init=\"vm.record.users_id=userid\"><md-toolbar class=\"wfc-bg\"><div class=\"md-toolbar-tools\"><h2>Waiting for Call</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex \nmd-is-error=\"recordForm.description.$invalid && (recordForm.description.$touched || recordForm.$submitted)\"><label>\nMessage</label><textarea rows=\"5\" name=\"description\" ng-model=\"vm.record.description\" required></textarea><div \nng-messages=\"recordForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert the message.\n</span></div></div></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><div class=\"user\">\n{{username}}, {{data | date:\'dd/MM/yyyy H:m\'}}</div></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(vm.record)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/others/waitingimpressions.html","<md-dialog class=\"order-alert\" aria-label=\"Order Alert\" ngapp=\"caseType\"><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.iscustom\" \nng-init=\"vm.record.iscustom=\'0\'\"> <input type=\"hidden\" ng-model=\"vm.record.status_id\" \nng-init=\"vm.record.status_id=\'3\'\"> <input type=\"hidden\" ng-model=\"vm.record.orders_id\" \nng-init=\"vm.record.orders_id=id\"> <input type=\"hidden\" ng-model=\"vm.record.users_id\" \nng-init=\"vm.record.users_id=userid\"><md-toolbar class=\"wfi-bg\"><div class=\"md-toolbar-tools\"><h2>\nWaiting for Impressions</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\">\n<md-input-container flex \nmd-is-error=\"recordForm.description.$invalid && (recordForm.description.$touched || recordForm.$submitted)\"><label>\nMessage</label><textarea rows=\"5\" name=\"description\" ng-model=\"vm.record.description\" required></textarea><div \nng-messages=\"recordForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert the message.\n</span></div></div></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><div class=\"user\">\n{{username}}, {{data | date:\'dd/MM/yyyy H:m\'}}</div></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(vm.record)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/production/templates/dldactions.html","<div class=\"dldactions-page\" layout=\"column\" layout-align=\"start center\"><div class=\"full-width\" \nng-repeat=\"action in vm.dldactions\"><div layout=\"row\" layout-align=\"start center\"><div class=\"department\"><strong>\nDepartment: </strong>{{action.department_name}}</div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"user\"><strong>User: </strong>{{action.name}}</div></div><div flex layout=\"row\" layout-align=\"start center\"><div \nclass=\"date\"><strong>Date/Time: </strong>{{action.date}}</div></div><md-divider class=\"margem-divisoria\"></md-divider>\n</div></div>");
$templateCache.put("app/main/pages/production/templates/labdoc.html","<div class=\"max-box\" layout=\"column\" layout-align=\"start center\" ng-cloak><div class=\"product-box full-width\"><div \nflex layout=\"row\" layout-align=\"start center\" ng-repeat=\"labdoc in vm.labdocs\"><md-button class=\"\" \naria-label=\"Open Lab Doc {{labdoc.ordernumber}}\" ng-click=\"vm.openLabDoc()\">{{labdoc.ordernumber}}.pdf</md-button><a \nhref=\"#\" ng-click=\"vm.genericRemoveConfirm($event, \'removeLabDoc\', labdoc.orders_lab_docs_id)\" title=\"Remove Lab Doc\">\n<md-icon md-font-icon=\"icon-window-close\" class=\"s12 md-font\" aria-hidden=\"true\" aria-label=\"Remove Lab Doc\"></md-icon>\n</a></div></div></div>");
$templateCache.put("app/main/pages/production/templates/linkedorders.html","<div class=\"max-box\" layout=\"column\" layout-align=\"start center\"><div class=\"product-box full-width\"><div flex \nlayout=\"row\" layout-align=\"end center\" \nng-click=\"vm.disabled==false ? vm.openPopupOther($event, \'addNewLinkOrder\') : \'\'\"><md-tooltip md-direction=\"top\">\nClick to link an order</md-tooltip><div><md-button class=\"md-icon-button botao-produtos\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"s12 md-font icon-plus botao-add\" aria-hidden=\"true\"></md-icon></md-button></div><div>\n<md-button class=\"md-icon-button botao-produtos\"><md-icon md-font-icon=\"icon-file-document\" \nclass=\"s24 md-font icon-file-document\" aria-hidden=\"true\"></md-icon></md-button></div></div><div flex layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"linked in vm.linkedorders\"><md-input-container class=\"md-block nomargin\"><input \ntype=\"text\" value=\"Order No {{linked.ordernumber}}\" disabled=\"disabled\"></md-input-container><a href=\"#\" \nng-click=\"vm.disabled==false ? vm.genericRemoveConfirm($event, \'removeLinkedOrder\', linked.orders_linked_id) : \'\'\" \ntitle=\"Remove Order\"><md-icon md-font-icon=\"icon-window-close\" class=\"s12 md-font\" aria-hidden=\"true\" \naria-label=\"Remove Order\"><md-tooltip md-direction=\"top\">Click to close this linked order</md-tooltip></md-icon></a>\n</div></div></div>");
$templateCache.put("app/main/pages/production/templates/ordercomments.html","<div class=\"ordercomments-page\" layout=\"column\" layout-align=\"start center\"><div class=\"full-width\" \nng-repeat=\"comment in vm.comments\"><div layout=\"row\" layout-align=\"start center\"><div class=\"comment\">\n{{comment.comment}}</div></div><div layout=\"row\" layout-align=\"end center\"><div class=\"user\">\n{{comment.name}}, {{comment.date}}</div></div><div class=\"margem-divisoria\"></div></div><div class=\"full-width\" \nng-if=\"vm.comments.length < 1\"><div layout=\"row\" layout-align=\"start center\"><div class=\"comment\">\nThere are no comments yet.</div></div></div></div><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"vm.record.orders_comments_id\" ng-init=\"vm.record.orders_comments_id=\'0\'\"> \n<input type=\"hidden\" ng-model=\"vm.record.orders_id\" ng-init=\"vm.record.orders_id=vm.id\"> <input type=\"hidden\" \nng-model=\"vm.record.users_id\" ng-init=\"vm.record.users_id=vm.userid\"><div class=\"ordercomments-add\" layout=\"row\" flex \nlayout-align=\"start center\"><md-input-container flex \nmd-is-error=\"recordForm.comment.$invalid && (recordForm.comment.$touched || recordForm.$submitted)\"><label>Add Comment:\n</label><textarea rows=\"5\" name=\"comment\" ng-model=\"vm.record.comment\" required ng-disabled=\"vm.disabled\"></textarea>\n<div ng-messages=\"recordForm.comment.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert a message.\n</span></div></div></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><md-button \nng-if=\"vm.disabled==false\" class=\"md-primary md-raised\" type=\"submit\" \nng-click=\"recordForm.$valid && vm.otherSave(vm.record, \'New Comment was \', \'addNewMessage\')\">Save</md-button></div>\n</form>");
$templateCache.put("app/main/pages/production/templates/products.html","<div class=\"products\" layout=\"column\" layout-align=\"start center\"><div class=\"product-box full-width\"><div \nclass=\"treatmentplan product-option product-blue\">Upper</div><div class=\"md-raised md-button full-width\" \naria-label=\"Treatment Plan Upper\" layout=\"row\" layout-align=\"start center\"><md-tooltip \nng-if=\"vm.treatmentplan_upper==false\" md-direction=\"top\">Click to include Treatment Plan for Upper</md-tooltip>\n<md-tooltip ng-if=\"vm.treatmentplan_upper==true\" md-direction=\"top\">Click to remove Treatment Plan for Upper\n</md-tooltip><md-switch class=\"full-width\" ng-model=\"vm.treatmentplan_upper\" \nng-change=\"vm.disabled==false && vm.dld==0 ? vm.openPopupOther($event, \'treatmentplan_upper\', vm.treatmentplan_upper) : \'\'\" \naria-label=\"Treatment Plan Upper\"><span>Treatment Plan</span></md-switch></div><div class=\"treatp-product full-width\" \nng-if=\"vm.order[0].treatmentplan_upper==1 && vm.order[0].treatmentplan_upper_products_id>0\" \nng-repeat=\"prodtreatment in vm.products | filter:{ orders_product_id: vm.order[0].treatmentplan_upper_products_id}\">\nFor product <strong>{{prodtreatment.product_description}}</strong></div><div class=\"product-title full-width\" \naria-label=\"Products\" layout=\"row\" layout-align=\"start center\"><div><div class=\"info-normal\">Products</div></div></div>\n<div class=\"max-box\"><table class=\"simple products-lower\" ms-responsive><thead><tr><td width=\"50%\">Products</td><td \nwidth=\"10%\">Qty</td><td width=\"10%\">Discount</td><td width=\"25%\">Final Price</td><td width=\"5%\"></td></tr></thead>\n<tbody><tr ng-repeat=\"product in vm.products | filter:{ upperORlower: \'1\'} as filtered1\"><td><md-input-container \nclass=\"md-block\" title=\"Code: {{product.product_code}}\"><input type=\"text\" name=\"product_description\" \nng-model=\"product.product_description\" disabled=\"disabled\" aria-label=\"Product\"></md-input-container></td><td>\n<md-input-container ng-click=\"vm.editaCampo(product.products_id, \'qty\')\" class=\"md-block pointer\"><input type=\"text\" \nname=\"product_qty\" ng-change=\"vm.atualizaValor(product.orders_product_id, \'product_qty\', product.product_qty)\" \nng-model=\"product.product_qty\" ng-disabled=\"vm.isDisabled[product.products_id][\'qty\']\" aria-label=\"Quantity\">\n<md-tooltip md-direction=\"top\">Click to edit</md-tooltip></md-input-container></td><td><md-input-container \nng-click=\"vm.editaCampo(product.products_id, \'discount\')\" class=\"md-block pointer\"><input type=\"text\" \nname=\"product_discount\" \nng-change=\"vm.atualizaValor(product.orders_product_id, \'product_discount\', product.product_discount)\" \nng-model=\"product.product_discount\" ng-disabled=\"vm.isDisabled[product.products_id][\'discount\']\" aria-label=\"Discount\">\n<md-tooltip md-direction=\"top\">Click to edit</md-tooltip></md-input-container></td><td><md-input-container \nng-click=\"vm.editaCampo(product.products_id, \'price\')\" class=\"md-block pointer\"><input type=\"text\" \nname=\"product_rate_final\" \nng-change=\"vm.atualizaValor(product.orders_product_id, \'product_rate_final\', product.product_rate_final)\" \nng-model=\"product.product_rate_final\" ng-disabled=\"vm.isDisabled[product.products_id][\'price\']\" \naria-label=\"Final Price\"><md-tooltip md-direction=\"top\">Click to edit</md-tooltip></md-input-container></td><td \nng-if=\"vm.isDisabled[product.products_id].qty==true && vm.isDisabled[product.products_id].discount==true && vm.isDisabled[product.products_id].price==true\">\n<a href=\"#\" \nng-click=\"vm.disabled==false ? vm.genericRemoveConfirm($event, \'removeProduct\', product.orders_product_id) : \'\'\" \ntitle=\"Remove Product\"><md-icon md-font-icon=\"icon-window-close\" class=\"s20 md-font remove-product\" aria-hidden=\"true\" \naria-label=\"Remove Product\"><md-tooltip md-direction=\"top\">Click to remove this product</md-tooltip></md-icon></a></td>\n<td \nng-if=\"vm.isDisabled[product.products_id].qty==false || vm.isDisabled[product.products_id].discount==false || vm.isDisabled[product.products_id].price==false\">\n<a href=\"#\" ng-click=\"vm.disabled==false ? vm.gravaCampos(product.orders_product_id) : \'\'\" title=\"Save Product\">\n<md-icon md-font-icon=\"icon-check\" class=\"s20 md-font check\" aria-hidden=\"true\" aria-label=\"Save Product\"><md-tooltip \nmd-direction=\"top\">Click to save this product</md-tooltip></md-icon></a></td></tr></tbody></table></div><div flex \nlayout=\"row\" layout-align=\"end center\" title=\"Add New Product(s)\" \nng-click=\"vm.disabled==false ? vm.openPopupOther($event, \'addNewProduct\', 1) : \'\'\"><div><md-button \nclass=\"md-icon-button botao-produtos\"><md-icon md-font-icon=\"icon-plus\" class=\"s12 md-font icon-plus botao-add\" \naria-hidden=\"true\"></md-icon></md-button></div><div><md-button class=\"md-icon-button botao-produtos\"><md-icon \nmd-font-icon=\"icon-file-document\" class=\"s24 md-font icon-file-document\" aria-hidden=\"true\"></md-icon></md-button>\n</div><md-tooltip md-direction=\"top\">Click to add new product(s)</md-tooltip></div></div><div \nclass=\"product-box full-width\"><div class=\"product-option product-blue\">Lower</div><div \nclass=\"md-raised md-button full-width\" aria-label=\"Treatment Plan Lower\" layout=\"row\" layout-align=\"start center\">\n<md-tooltip ng-if=\"vm.treatmentplan_lower==false\" md-direction=\"top\">Click to include Treatment Plan for Lower\n</md-tooltip><md-tooltip ng-if=\"vm.treatmentplan_lower==true\" md-direction=\"top\">\nClick to remove Treatment Plan for Lower</md-tooltip><md-switch ng-model=\"vm.treatmentplan_lower\" \nng-change=\"vm.disabled==false && vm.dld==0 ? vm.openPopupOther($event, \'treatmentplan_lower\', vm.treatmentplan_lower) : \'\'\" \nclass=\"full-width\" aria-label=\"Treatment Plan Upper\"><span>Treatment Plan</span></md-switch></div><div \nclass=\"treatp-product full-width\" \nng-if=\"vm.order[0].treatmentplan_lower==1 && vm.order[0].treatmentplan_lower_products_id>0\" \nng-repeat=\"prodtreatmentz in vm.products | filter:{ orders_product_id: vm.order[0].treatmentplan_lower_products_id}\">\nFor product <strong>{{prodtreatmentz.product_description}}</strong></div><div class=\"product-title full-width\" \naria-label=\"Products\" layout=\"row\" layout-align=\"start center\"><div><div class=\"info-normal\">Products</div></div></div>\n<div class=\"max-box\"><table class=\"simple products-lower\" ms-responsive><thead><tr><td width=\"50%\">Products</td><td \nwidth=\"10%\">Qty</td><td width=\"10%\">Discount</td><td width=\"25%\">Final Price</td><td width=\"5%\"></td></tr></thead>\n<tbody><tr ng-repeat=\"produkt in vm.products | filter:{ upperORlower: \'2\'} as filtered2\"><td><md-input-container \nclass=\"md-block\" title=\"Code: {{produkt.product_code}}\"><input type=\"text\" name=\"product_description\" \nng-model=\"produkt.product_description\" disabled=\"disabled\" aria-label=\"Product\"></md-input-container></td><td>\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"product_qty\" ng-model=\"produkt.product_qty\" \ndisabled=\"disabled\" aria-label=\"Quantity\"></md-input-container></td><td><md-input-container class=\"md-block\"><input \ntype=\"text\" name=\"product_discount\" value=\"{{produkt.product_discount}} %\" disabled=\"disabled\" aria-label=\"Discount\">\n</md-input-container></td><td><md-input-container class=\"md-block\"><input type=\"text\" name=\"product_rate_final\" \nvalue=\"£ {{produkt.product_rate_final}}\" disabled=\"disabled\" aria-label=\"Final Price\"></md-input-container></td><td><a \nhref=\"#\" \nng-click=\"vm.disabled==false ? vm.genericRemoveConfirm($event, \'removeProduct\', produkt.orders_product_id) : \'\'\" \ntitle=\"Remove Product\"><md-icon md-font-icon=\"icon-window-close\" class=\"s20 md-font remove-product\" aria-hidden=\"true\" \naria-label=\"Remove Product\"><md-tooltip md-direction=\"top\">Click to remove this product</md-tooltip></md-icon></a></td>\n</tr></tbody></table></div><div flex layout=\"row\" layout-align=\"end center\" title=\"Add New Product(s)\" \nng-click=\"vm.disabled==false ? vm.openPopupOther($event, \'addNewProduct\', 2) : \'\'\"><div><md-button \nclass=\"md-icon-button botao-produtos\"><md-icon md-font-icon=\"icon-plus\" class=\"s12 md-font icon-plus botao-add\" \naria-hidden=\"true\"></md-icon></md-button></div><div><md-button class=\"md-icon-button botao-produtos\"><md-icon \nmd-font-icon=\"icon-file-document\" class=\"s24 md-font icon-file-document\" aria-hidden=\"true\"></md-icon></md-button>\n</div><md-tooltip md-direction=\"top\">Click to add new product(s)</md-tooltip></div></div><div \nclass=\"product-box full-width\"><div class=\"product-option product-grey\">Delivery</div><div \nclass=\"md-raised md-button full-width\" aria-label=\"Delivery\" layout=\"row\" layout-align=\"start center\" \nng-click=\"vm.disabled==false ? vm.openPopupOther($event, \'addNewDeliveryRoute\') : \'\'\"><md-tooltip md-direction=\"top\">\nClick to add a delivery route</md-tooltip><div flex layout=\"row\" class=\"pointer\" layout-align=\"start center\"><label>\nDelivery Route</label></div><div flex layout=\"row\" layout-align=\"end center\"><div><md-icon md-font-icon=\"icon-plus\" \nclass=\"s12 md-font icon-plus botao-add\" aria-hidden=\"true\"></md-icon></div><div><md-icon \nmd-font-icon=\"icon-file-document\" class=\"s24 md-font icon-file-document\" aria-hidden=\"true\"></md-icon></div></div>\n</div><table class=\"simple products-delivery\" ms-responsive ng-if=\"vm.id!=0\"><thead><tr><td width=\"80%\"></td><td \nwidth=\"20%\">Cost</td><td width=\"5%\"></td></tr></thead><tbody><tr><td><md-input-container class=\"md-block\" \nng-if=\"vm.order[0].deliveryroutes_id!=0\"><input type=\"text\" value=\"{{vm.order[0].route}}\" disabled=\"disabled\" \naria-label=\"Delivery Route\"></md-input-container></td><td><md-input-container class=\"md-block\" \nng-if=\"vm.order[0].deliveryroutes_id!=0\"><input type=\"text\" value=\"{{vm.order[0].rate}}\" disabled=\"disabled\" \naria-label=\"Cost\"></md-input-container></td><td><a href=\"#\" title=\"Remove Delivery Route\" \nng-click=\"vm.disabled==false ? vm.genericRemoveConfirm($event, \'RemoveDeliveryRoute\') : \'\'\" \nng-if=\"vm.order[0].deliveryroutes_id!=0\"><md-icon md-font-icon=\"icon-window-close\" class=\"s12 md-font remove-product\" \naria-hidden=\"true\" aria-label=\"Remove Delivery Route\"><md-tooltip md-direction=\"top\">Click to remove delivery route\n</md-tooltip></md-icon></a></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/pages/profile/templates/deliveryaddress.html","<md-dialog aria-label=\"Add Delivery Address\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-if=\"!pctrl.delivery.clients_id\" \nng-model=\"pctrl.delivery.clients_id\" ng-init=\"pctrl.delivery.clients_id=id\"> <input type=\"hidden\" \nng-if=\"!pctrl.delivery.clients_deliveryaddress_id\" ng-model=\"pctrl.delivery.clients_deliveryaddress_id\" \nng-init=\"pctrl.delivery.clients_deliveryaddress_id=0\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nAdd Delivery Address</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div flex layout=\"row\"><md-input-container flex \nclass=\"md-block\"><label>Address (Line 1)</label><input type=\"text\" ng-model=\"pctrl.delivery.daddress1\">\n</md-input-container></div><div flex layout=\"row\"><md-input-container flex class=\"md-block\"><label>Address (Line 2)\n</label><input type=\"text\" ng-model=\"pctrl.delivery.daddress2\"></md-input-container></div><div flex layout=\"row\">\n<md-input-container flex=\"50\" class=\"md-block\"><label>Town/City</label><input type=\"text\" \nng-model=\"pctrl.delivery.dcity\"></md-input-container><md-input-container flex=\"50\" class=\"md-block\"><label>County\n</label><input type=\"text\" ng-model=\"pctrl.delivery.dcounty\"></md-input-container></div><div flex layout=\"row\">\n<md-input-container flex=\"50\" class=\"md-block\"><label>Postcode</label><input type=\"text\" \nng-model=\"pctrl.delivery.dpostcode\"></md-input-container><md-input-container flex=\"50\" class=\"md-block\"><label>Country\n</label><input type=\"text\" ng-model=\"pctrl.delivery.dcountry\"></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button \nclass=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"recordForm.$valid && gravar(pctrl.delivery)\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/profile/templates/dentist.html","<md-dialog flex=\"50\" aria-label=\"Add Dentist\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-if=\"!pctrl.dentist.clients_id\" \nng-model=\"pctrl.dentist.clients_id\" ng-init=\"pctrl.dentist.clients_id=0\"> <input type=\"hidden\" \nng-if=\"!pctrl.dentist.parent\" ng-model=\"pctrl.dentist.parent\" ng-init=\"pctrl.dentist.parent=id\"> <input type=\"hidden\" \nng-if=\"!pctrl.dentist.clients_type_id\" ng-model=\"pctrl.dentist.clients_type_id\" \nng-init=\"pctrl.dentist.clients_type_id=3\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Add Dentist</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div flex layout=\"row\"><md-input-container flex=\"50\" class=\"md-block\"><label>Client\n</label><input type=\"text\" ng-model=\"pctrl.dentist.clientname\"></md-input-container><md-input-container flex=\"50\" \nclass=\"md-block\"><label>GDC Number</label><input type=\"text\" ng-model=\"pctrl.dentist.gdc_number\"></md-input-container>\n</div><div flex layout=\"row\"><md-input-container flex=\"60\" class=\"md-block\"><label>E-mail (Primary)</label><input \ntype=\"text\" ng-model=\"pctrl.dentist.cemail[0].clients_email\" \nng-pattern=\"/^[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\\.[a-zA-Z]{2,4}$/\"></md-input-container><md-input-container flex=\"40\">\n<label>Select Email Type</label><md-select name=\"clients_email_id\" ng-model=\"pctrl.dentist.cemail[0].email_type_ids\" \nmultiple=\"true\"><md-option ng-repeat=\"(index,clientemail) in pctrl.allemailtypes\" ng-value=\"clientemail.email_type_id\">\n{{clientemail.email_type}}</md-option></md-select><div ng-messages=\"recordForm.clients_email_id.$error\"><div \nng-message=\"pattern\">Please insert a valid e-mail.</div></div></md-input-container></div><div flex layout=\"row\">\n<md-input-container flex=\"60\" class=\"md-block\"><label>E-mail (Secondary)</label><input type=\"text\" \nng-model=\"pctrl.dentist.cemail[1].clients_email\" ng-pattern=\"/^[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\\.[a-zA-Z]{2,4}$/\">\n</md-input-container><md-input-container flex=\"40\"><label>Select Email Type</label><md-select name=\"clients_email_id\" \nng-model=\"pctrl.dentist.cemail[1].email_type_ids\" multiple=\"true\"><md-option \nng-repeat=\"(index,clientemail) in pctrl.allemailtypes\" ng-value=\"clientemail.email_type_id\">{{clientemail.email_type}}\n</md-option></md-select><div ng-messages=\"recordForm.clients_email_id.$error\"><div ng-message=\"pattern\">\nPlease insert a valid e-mail.</div></div></md-input-container></div><div flex layout=\"row\"><md-input-container \nflex=\"60\" class=\"md-block\"><label>Tel (Primary)</label><input type=\"text\" ng-model=\"pctrl.dentist.ctel[0].clients_tel\" \nng-pattern=\"/^\\+?[0-9]{1}[0-9]{3,15}$/\"></md-input-container><md-input-container flex=\"40\"><label>Select Tel Type\n</label><md-select name=\"clients_tel_id\" ng-model=\"pctrl.dentist.ctel[0].tel_type_ids\" multiple=\"true\"><md-option \nng-repeat=\"(index,clienttel) in pctrl.allteltypes\" ng-value=\"clienttel.tel_type_id\">{{clienttel.tel_type}}</md-option>\n</md-select><div ng-messages=\"recordForm.clients_tel_id.$error\"><div ng-message=\"pattern\">Please insert a valid tel.\n</div></div></md-input-container></div><div flex layout=\"row\"><md-input-container flex=\"60\" class=\"md-block\"><label>\nTel (Secondary)</label><input type=\"text\" ng-model=\"pctrl.dentist.ctel[1].clients_tel\" \nng-pattern=\"/^\\+?[0-9]{1}[0-9]{3,15}$/\"></md-input-container><md-input-container flex=\"40\"><label>Select Tel Type\n</label><md-select name=\"clients_tel_id\" ng-model=\"pctrl.dentist.ctel[1].tel_type_ids\" multiple=\"true\"><md-option \nng-repeat=\"(index,clienttel) in pctrl.allteltypes\" ng-value=\"clienttel.tel_type_id\">{{clienttel.tel_type}}</md-option>\n</md-select><div ng-messages=\"recordForm.clients_tel_id.$error\"><div ng-message=\"pattern\">Please insert a valid tel.\n</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" \nng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(pctrl.dentist)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/profile/templates/emailclient.html","<md-dialog class=\"emailclient\" flex=\"40\" aria-label=\"Email Client\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\">\n<h2>E-mail Client</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><h3>Client E-mails</h3><div flex layout=\"row\" \nng-repeat=\"emailclient in pctrl.emailsclient\"><md-input-container flex=\"40\" class=\"md-block\"><label>Email</label><input\n type=\"text\" ng-model=\"emailclient.clients_email\" disabled=\"disabled\"></md-input-container><md-input-container \nflex=\"30\"><label>Email Type</label><md-select name=\"clients_email_id\" ng-model=\"emailclient.email_type_ids\" \nmultiple=\"true\" disabled=\"disabled\"><md-option \nng-repeat=\"clientemail in pctrl.allemailtypes track by clientemail.email_type_id\" ng-value=\"clientemail.email_type_id\">\n{{clientemail.email_type}}</md-option></md-select></md-input-container><a \nng-href=\"mailto:{{ emailclient.clients_email }}\" target=\"_blank\"><md-button \nclass=\"md-raised md-primary button-max-height\">Send E-mail</md-button></a></div><h3>Practice E-mails</h3><div flex \nlayout=\"row\" ng-repeat=\"emailparent in pctrl.emailsparents\"><md-input-container flex=\"40\" class=\"md-block\"><label>Email\n</label><input type=\"text\" ng-model=\"emailparent.clients_email\" disabled=\"disabled\"></md-input-container>\n<md-input-container flex=\"30\"><label>Email Type</label><md-select name=\"clients_email_id\" \nng-model=\"emailparent.email_type_ids\" multiple=\"true\" disabled=\"disabled\"><md-option \nng-repeat=\"parentmail in pctrl.allemailtypes track by parentmail.email_type_id\" ng-value=\"parentmail.email_type_id\">\n{{parentmail.email_type}}</md-option></md-select></md-input-container><a \nng-href=\"mailto:{{ parentmail.clients_email }}\" target=\"_blank\"><md-button \nclass=\"md-raised md-primary button-max-height\">Send E-mail</md-button></a></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button ng-click=\"cancel()\">Close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/pages/profile/templates/emails.html","<md-dialog flex=\"40\" aria-label=\"Manage Email Contacts\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-if=\"!pctrl.clientemail.clients_id\" \nng-model=\"pctrl.clientemail.clients_id\" ng-init=\"pctrl.clientemail.clients_id=id\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Manage Email Contacts</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div flex layout=\"row\">\n<md-input-container flex=\"60\" class=\"md-block\"><label>E-mail</label><input type=\"text\" \nng-model=\"pctrl.clientemail.cemail[0].clients_email\" ng-pattern=\"/^[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\\.[a-zA-Z]{2,4}$/\" \nng-disabled=\"pctrl.disabled\"></md-input-container><md-input-container flex=\"40\"><label>Select Email Type</label>\n<md-select name=\"clients_email_id\" ng-model=\"pctrl.clientemail.cemail[0].email_type_ids\" multiple=\"true\" \nng-disabled=\"pctrl.disabled\"><md-option ng-repeat=\"(index,clientemail) in pctrl.allemailtypes\" \nng-value=\"clientemail.email_type_id\">{{clientemail.email_type}}</md-option></md-select><div \nng-messages=\"recordForm.clients_email_id.$error\"><div ng-message=\"pattern\">Please insert a valid e-mail.</div></div>\n</md-input-container></div><div flex layout=\"row\"><md-input-container flex=\"60\" class=\"md-block\"><label>E-mail</label>\n<input type=\"text\" ng-model=\"pctrl.clientemail.cemail[1].clients_email\" \nng-pattern=\"/^[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\\.[a-zA-Z]{2,4}$/\" ng-disabled=\"pctrl.disabled\"></md-input-container>\n<md-input-container flex=\"40\"><label>Select Email Type</label><md-select name=\"clients_email_id\" \nng-model=\"pctrl.clientemail.cemail[1].email_type_ids\" multiple=\"true\" ng-disabled=\"pctrl.disabled\"><md-option \nng-repeat=\"(index,clientemail) in pctrl.allemailtypes\" ng-value=\"clientemail.email_type_id\">{{clientemail.email_type}}\n</md-option></md-select><div ng-messages=\"recordForm.clients_email_id.$error\"><div ng-message=\"pattern\">\nPlease insert a valid e-mail.</div></div></md-input-container></div><div flex layout=\"row\"><md-input-container \nflex=\"60\" class=\"md-block\"><label>E-mail</label><input type=\"text\" \nng-model=\"pctrl.clientemail.cemail[2].clients_email\" ng-pattern=\"/^[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\\.[a-zA-Z]{2,4}$/\" \nng-disabled=\"pctrl.disabled\"></md-input-container><md-input-container flex=\"40\"><label>Select Email Type</label>\n<md-select name=\"clients_email_id\" ng-model=\"pctrl.clientemail.cemail[2].email_type_ids\" multiple=\"true\" \nng-disabled=\"pctrl.disabled\"><md-option ng-repeat=\"(index,clientemail) in pctrl.allemailtypes\" \nng-value=\"clientemail.email_type_id\">{{clientemail.email_type}}</md-option></md-select><div \nng-messages=\"recordForm.clients_email_id.$error\"><div ng-message=\"pattern\">Please insert a valid e-mail.</div></div>\n</md-input-container></div><div flex layout=\"row\"><md-input-container flex=\"60\" class=\"md-block\"><label>E-mail</label>\n<input type=\"text\" ng-model=\"pctrl.clientemail.cemail[3].clients_email\" \nng-pattern=\"/^[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\\.[a-zA-Z]{2,4}$/\" ng-disabled=\"pctrl.disabled\"></md-input-container>\n<md-input-container flex=\"40\"><label>Select Email Type</label><md-select name=\"clients_email_id\" \nng-model=\"pctrl.clientemail.cemail[3].email_type_ids\" multiple=\"true\" ng-disabled=\"pctrl.disabled\"><md-option \nng-repeat=\"(index,clientemail) in pctrl.allemailtypes\" ng-value=\"clientemail.email_type_id\">{{clientemail.email_type}}\n</md-option></md-select><div ng-messages=\"recordForm.clients_email_id.$error\"><div ng-message=\"pattern\">\nPlease insert a valid e-mail.</div></div></md-input-container></div><div flex layout=\"row\"><md-input-container \nflex=\"60\" class=\"md-block\"><label>E-mail</label><input type=\"text\" \nng-model=\"pctrl.clientemail.cemail[4].clients_email\" ng-pattern=\"/^[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\\.[a-zA-Z]{2,4}$/\" \nng-disabled=\"pctrl.disabled\"></md-input-container><md-input-container flex=\"40\"><label>Select Email Type</label>\n<md-select name=\"clients_email_id\" ng-model=\"pctrl.clientemail.cemail[4].email_type_ids\" multiple=\"true\" \nng-disabled=\"pctrl.disabled\"><md-option ng-repeat=\"(index,clientemail) in pctrl.allemailtypes\" \nng-value=\"clientemail.email_type_id\">{{clientemail.email_type}}</md-option></md-select><div \nng-messages=\"recordForm.clients_email_id.$error\"><div ng-message=\"pattern\">Please insert a valid e-mail.</div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" \nng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"pctrl.disabled == false ? recordForm.$valid && gravar(pctrl.clientemail) : \'\'\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/profile/templates/newalert.html","<md-dialog class=\"order-alert\" aria-label=\"New Alert\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.clients_status_id\" \nng-init=\"vm.record.clients_status_id=\'0\'\"> <input type=\"hidden\" ng-model=\"vm.record.isalert\" \nng-init=\"vm.record.isalert=\'1\'\"> <input type=\"hidden\" ng-model=\"vm.record.clients_id\" \nng-init=\"vm.record.clients_id=id\"> <input type=\"hidden\" ng-model=\"vm.record.users_id\" \nng-init=\"vm.record.users_id=userid\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>New Alert</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex \nclass=\"md-block\" md-is-error=\"recordForm.subject.$invalid && (recordForm.subject.$touched || recordForm.$submitted)\">\n<label>Subject</label><input type=\"text\" name=\"subject\" ng-model=\"vm.record.subject\" required><div \nng-messages=\"recordForm.subject.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert the subject.</span>\n</div></div></md-input-container></div><div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex \nmd-is-error=\"recordForm.description.$invalid && (recordForm.description.$touched || recordForm.$submitted)\"><label>\nMessage</label><textarea rows=\"5\" name=\"description\" ng-model=\"vm.record.description\" required></textarea><div \nng-messages=\"recordForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert the message.\n</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(vm.record)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/profile/templates/newnote.html","<md-dialog class=\"order-alert\" aria-label=\"New Note\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.clients_status_id\" \nng-init=\"vm.record.clients_status_id=\'0\'\"> <input type=\"hidden\" ng-model=\"vm.record.isalert\" \nng-init=\"vm.record.isalert=\'0\'\"> <input type=\"hidden\" ng-model=\"vm.record.clients_id\" \nng-init=\"vm.record.clients_id=id\"> <input type=\"hidden\" ng-model=\"vm.record.users_id\" \nng-init=\"vm.record.users_id=userid\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>New Note</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex \nclass=\"md-block\" md-is-error=\"recordForm.subject.$invalid && (recordForm.subject.$touched || recordForm.$submitted)\">\n<label>Subject</label><input type=\"text\" name=\"subject\" ng-model=\"vm.record.subject\" required><div \nng-messages=\"recordForm.subject.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert the subject.</span>\n</div></div></md-input-container></div><div layout=\"row\" flex layout-align=\"start center\"><md-input-container flex \nmd-is-error=\"recordForm.description.$invalid && (recordForm.description.$touched || recordForm.$submitted)\"><label>\nMessage</label><textarea rows=\"5\" name=\"description\" ng-model=\"vm.record.description\" required></textarea><div \nng-messages=\"recordForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert the message.\n</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(vm.record)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/profile/templates/notes.html","<div class=\"notes-page\" layout-align=\"start center\"><div class=\"md-raised md-button full-width\" aria-label=\"Delivery\" \nlayout=\"row\" layout-align=\"start center\" ng-click=\"vm.disabled == false ? vm.openPopup($event, \'newnote\') : \'\'\">\n<md-tooltip md-direction=\"top\">Click to add a note</md-tooltip><div flex layout=\"row\" class=\"pointer\" \nlayout-align=\"start center\"><label>Notes</label></div><div flex layout=\"row\" layout-align=\"end center\"><div><md-icon \nmd-font-icon=\"icon-plus\" class=\"s12 md-font icon-plus botao-add\" aria-hidden=\"true\"></md-icon></div><div><md-icon \nmd-font-icon=\"icon-file-document\" class=\"s24 md-font icon-file-document\" aria-hidden=\"true\"></md-icon></div></div>\n</div><div ng-if=\"vm.id > 0\" class=\"full-width note-box\" ng-repeat=\"stat in vm.clientsstatus\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"note-subject full-width\" aria-label=\"Remove Note/Alert\"><div flex layout=\"row\" \nlayout-align=\"start center\"><label ng-if=\"stat.status_id==\'7\' || stat.status_id==\'8\'\">{{stat.status}}</label><label \nng-if=\"stat.status_id!=\'7\'\">{{stat.subject}}</label></div><div flex layout=\"row\" layout-align=\"end center\" \nng-click=\"vm.disabled == false ? vm.genericRemoveConfirm($event, \'clientsstatus\', \'alert\', stat.clients_status_id) : \'\'\">\n<md-icon layout-align=\"end center\" md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font icon-window-close botao-add pointer remove-alert-button\" aria-hidden=\"true\"></md-icon><md-tooltip \nmd-direction=\"top\">Click to remove the note/alert</md-tooltip></div></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"note-description full-width\">{{stat.description}}</div><div layout=\"row\" \nlayout-align=\"end center\" class=\"note-user full-width\">{{stat.name}}, {{stat.date}}</div><md-divider \nclass=\"margem-divisoria md-default-theme\"></md-divider></div><div class=\"full-width\" \nng-if=\"vm.clientsstatus.length < 1\"><div layout=\"row\" layout-align=\"start center\"><div class=\"comment\">\nThere are no notes yet.</div></div></div></div>");
$templateCache.put("app/main/pages/profile/templates/offstop.html","<md-dialog class=\"order-alert\" aria-label=\"Off Stop\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.clients_status_id\" \nng-init=\"vm.record.clients_status_id=\'0\'\"> <input type=\"hidden\" ng-model=\"vm.record.status_id\" \nng-init=\"vm.record.status_id=\'8\'\"> <input type=\"hidden\" ng-model=\"vm.record.isalert\" ng-init=\"vm.record.isalert=\'1\'\"> \n<input type=\"hidden\" ng-model=\"vm.record.clients_id\" ng-init=\"vm.record.clients_id=id\"> <input type=\"hidden\" \nng-model=\"vm.record.users_id\" ng-init=\"vm.record.users_id=userid\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nOff Stop</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"start center\">\n<md-input-container flex \nmd-is-error=\"recordForm.description.$invalid && (recordForm.description.$touched || recordForm.$submitted)\"><label>\nMessage</label><textarea rows=\"5\" name=\"description\" ng-model=\"vm.record.description\" required></textarea><div \nng-messages=\"recordForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert the message.\n</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(vm.record)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/profile/templates/onstop.html","<md-dialog class=\"order-alert\" aria-label=\"On Stop\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.record.clients_status_id\" \nng-init=\"vm.record.clients_status_id=\'0\'\"> <input type=\"hidden\" ng-model=\"vm.record.status_id\" \nng-init=\"vm.record.status_id=\'7\'\"> <input type=\"hidden\" ng-model=\"vm.record.isalert\" ng-init=\"vm.record.isalert=\'1\'\"> \n<input type=\"hidden\" ng-model=\"vm.record.clients_id\" ng-init=\"vm.record.clients_id=id\"> <input type=\"hidden\" \nng-model=\"vm.record.users_id\" ng-init=\"vm.record.users_id=userid\"><md-toolbar class=\"cancelorder-bg\"><div \nclass=\"md-toolbar-tools\"><h2>On Stop</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" flex \nlayout-align=\"start center\"><md-input-container flex \nmd-is-error=\"recordForm.description.$invalid && (recordForm.description.$touched || recordForm.$submitted)\"><label>\nMessage</label><textarea rows=\"5\" name=\"description\" ng-model=\"vm.record.description\" required></textarea><div \nng-messages=\"recordForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert the message.\n</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(vm.record)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/profile/templates/payment.html","<md-dialog flex=\"50\" aria-label=\"Payment Conditions\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-if=\"!pctrl.client.clients_id\" \nng-model=\"pctrl.client.clients_id\" ng-init=\"pctrl.client.clients_id=id\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nPayment Conditions</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div flex layout=\"row\"><md-input-container flex><label>\nPayment Conditions</label><md-select name=\"payments_id\" ng-model=\"pctrl.client.payments_id\"><md-option \nng-repeat=\"(index,payment) in pctrl.payments\" ng-value=\"payment.payments_id\" \nng-selected=\"payment.payments_id == \'{{pctrl.payments_id}}\'\">{{payment.type_payment}}</md-option></md-select>\n</md-input-container><md-radio-group ng-model=\"pctrl.client.chargevat\" class=\"radio-horizontal\"><span class=\"vat-text\">\nVAT</span><md-radio-button value=\"0\" aria-label=\"Non Chargeable\">Non Chargeable</md-radio-button><md-radio-button \nvalue=\"1\" aria-label=\"Chargeable\">Chargeable</md-radio-button></md-radio-group><md-input-container flex><label>Discount\n</label><md-select name=\"discounts_id\" ng-model=\"pctrl.client.discounts_id\"><md-option \nng-repeat=\"(index,discount) in pctrl.discounts\" ng-value=\"discount.discounts_id\" \nng-selected=\"discount.discounts_id == \'{{pctrl.discounts_id}}\'\">{{discount.discount}} %</md-option></md-select>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"cancel()\">Cancel\n</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(pctrl.client)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/profile/templates/practice.html","<md-dialog flex=\"70\" aria-label=\"Add Practice\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-if=\"!pctrl.practice.clients_id\" \nng-model=\"pctrl.practice.clients_id\" ng-init=\"pctrl.practice.clients_id=0\"> <input type=\"hidden\" \nng-if=\"!pctrl.practice.parent\" ng-model=\"pctrl.practice.parent\" ng-init=\"pctrl.practice.parent=id\"> <input \ntype=\"hidden\" ng-if=\"!pctrl.practice.clients_type_id\" ng-model=\"pctrl.practice.clients_type_id\" \nng-init=\"pctrl.practice.clients_type_id=2\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Add Practice</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div flex layout=\"row\"><md-input-container flex=\"50\" class=\"md-block\"><label>\nPractice Name</label><input type=\"text\" ng-model=\"pctrl.practice.clientname\"></md-input-container><md-input-container \nflex=\"30\" class=\"md-block\"><label>Practice No</label><input type=\"text\" ng-model=\"pctrl.practice.practicenumber\">\n</md-input-container><md-checkbox class=\"font-size-15\" flex ng-model=\"pctrl.practice.invoice_email\" ng-true-value=\"1\" \nng-false-value=\"0\" aria-label=\"Invoice E-mail\">Invoice E-mail</md-checkbox><md-checkbox class=\"font-size-15\" flex \nng-model=\"pctrl.practice.invoice_print\" ng-true-value=\"1\" ng-false-value=\"0\" aria-label=\"Invoice Print\">Invoice Print\n</md-checkbox></div><div flex layout=\"row\"><md-input-container flex=\"50\" class=\"md-block\"><label>Address (Line 1)\n</label><input type=\"text\" ng-model=\"pctrl.practice.caddress1\"></md-input-container><md-input-container flex=\"50\" \nclass=\"md-block\"><label>Address (Line 2)</label><input type=\"text\" ng-model=\"pctrl.practice.caddress2\">\n</md-input-container></div><div flex layout=\"row\"><md-input-container flex=\"50\" class=\"md-block\"><label>Town/City\n</label><input type=\"text\" ng-model=\"pctrl.practice.ccity\"></md-input-container><md-input-container flex=\"50\" \nclass=\"md-block\"><label>County</label><input type=\"text\" ng-model=\"pctrl.practice.ccounty\"></md-input-container></div>\n<div flex layout=\"row\"><md-input-container flex=\"50\" class=\"md-block\"><label>Postcode</label><input type=\"text\" \nng-model=\"pctrl.practice.cpostcode\"></md-input-container><md-input-container flex=\"50\" class=\"md-block\"><label>Country\n</label><input type=\"text\" ng-model=\"pctrl.practice.ccountry\"></md-input-container></div><div flex layout=\"row\">\n<md-input-container flex=\"30\" class=\"md-block\"><label>E-mail (Primary)</label><input type=\"text\" \nng-model=\"pctrl.practice.cemail[0].clients_email\" ng-pattern=\"/^[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\\.[a-zA-Z]{2,4}$/\">\n</md-input-container><md-input-container flex=\"20\"><label>Select Email Type</label><md-select name=\"clients_email_id\" \nng-model=\"pctrl.practice.cemail[0].email_type_ids\" multiple=\"true\"><md-option \nng-repeat=\"(index,clientemail) in pctrl.allemailtypes\" ng-value=\"clientemail.email_type_id\">{{clientemail.email_type}}\n</md-option></md-select><div ng-messages=\"recordForm.clients_email_id.$error\"><div ng-message=\"pattern\">\nPlease insert a valid e-mail.</div></div></md-input-container><md-input-container flex=\"30\" class=\"md-block\"><label>\nE-mail (Secondary)</label><input type=\"text\" ng-model=\"pctrl.practice.cemail[1].clients_email\" \nng-pattern=\"/^[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\\.[a-zA-Z]{2,4}$/\"></md-input-container><md-input-container flex=\"20\">\n<label>Select Email Type</label><md-select name=\"clients_email_id\" ng-model=\"pctrl.practice.cemail[1].email_type_ids\" \nmultiple=\"true\"><md-option ng-repeat=\"(index,clientemail) in pctrl.allemailtypes\" ng-value=\"clientemail.email_type_id\">\n{{clientemail.email_type}}</md-option></md-select><div ng-messages=\"recordForm.clients_email_id.$error\"><div \nng-message=\"pattern\">Please insert a valid e-mail.</div></div></md-input-container></div><div flex layout=\"row\">\n<md-input-container flex=\"30\" class=\"md-block\"><label>Tel (Primary)</label><input type=\"text\" \nng-model=\"pctrl.practice.ctel[0].clients_tel\" ng-pattern=\"/^\\+?[0-9]{1}[0-9]{3,15}$/\"></md-input-container>\n<md-input-container flex=\"20\"><label>Select Tel Type</label><md-select name=\"clients_tel_id\" \nng-model=\"pctrl.practice.ctel[0].tel_type_ids\" multiple=\"true\"><md-option \nng-repeat=\"(index,clienttel) in pctrl.allteltypes\" ng-value=\"clienttel.tel_type_id\">{{clienttel.tel_type}}</md-option>\n</md-select><div ng-messages=\"recordForm.clients_tel_id.$error\"><div ng-message=\"pattern\">Please insert a valid tel.\n</div></div></md-input-container><md-input-container flex=\"30\" class=\"md-block\"><label>Tel (Secondary)</label><input \ntype=\"text\" ng-model=\"pctrl.practice.ctel[1].clients_tel\" ng-pattern=\"/^\\+?[0-9]{1}[0-9]{3,15}$/\"></md-input-container>\n<md-input-container flex=\"20\"><label>Select Tel Type</label><md-select name=\"clients_tel_id\" \nng-model=\"pctrl.practice.ctel[1].tel_type_ids\" multiple=\"true\"><md-option \nng-repeat=\"(index,clienttel) in pctrl.allteltypes\" ng-value=\"clienttel.tel_type_id\">{{clienttel.tel_type}}</md-option>\n</md-select><div ng-messages=\"recordForm.clients_tel_id.$error\"><div ng-message=\"pattern\">Please insert a valid tel.\n</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" \nng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(pctrl.practice)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/profile/templates/tels.html","<md-dialog flex=\"40\" aria-label=\"Manage Tel Contacts\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-if=\"!pctrl.clienttel.clients_id\" \nng-model=\"pctrl.clienttel.clients_id\" ng-init=\"pctrl.clienttel.clients_id=id\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Manage Tel Contacts</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div flex layout=\"row\">\n<md-input-container flex=\"60\" class=\"md-block\"><label>Tel</label><input type=\"text\" \nng-model=\"pctrl.clienttel.ctel[0].clients_tel\" ng-pattern=\"/^\\+?[0-9]{1}[0-9]{3,15}$/\" ng-disabled=\"pctrl.disabled\">\n</md-input-container><md-input-container flex=\"40\"><label>Select Tel Type</label><md-select name=\"clients_tel_id\" \nng-model=\"pctrl.clienttel.ctel[0].tel_type_ids\" multiple=\"true\" ng-disabled=\"pctrl.disabled\"><md-option \nng-repeat=\"(index,clienttel) in pctrl.allteltypes\" ng-value=\"clienttel.tel_type_id\">{{clienttel.tel_type}}</md-option>\n</md-select><div ng-messages=\"recordForm.clients_tel_id.$error\"><div ng-message=\"pattern\">Please insert a valid tel.\n</div></div></md-input-container></div><div flex layout=\"row\"><md-input-container flex=\"60\" class=\"md-block\"><label>Tel\n</label><input type=\"text\" ng-model=\"pctrl.clienttel.ctel[1].clients_tel\" ng-pattern=\"/^\\+?[0-9]{1}[0-9]{3,15}$/\" \nng-disabled=\"pctrl.disabled\"></md-input-container><md-input-container flex=\"40\"><label>Select Tel Type</label>\n<md-select name=\"clients_tel_id\" ng-model=\"pctrl.clienttel.ctel[1].tel_type_ids\" multiple=\"true\" \nng-disabled=\"pctrl.disabled\"><md-option ng-repeat=\"(index,clienttel) in pctrl.allteltypes\" \nng-value=\"clienttel.tel_type_id\">{{clienttel.tel_type}}</md-option></md-select><div \nng-messages=\"recordForm.clients_tel_id.$error\"><div ng-message=\"pattern\">Please insert a valid tel.</div></div>\n</md-input-container></div><div flex layout=\"row\"><md-input-container flex=\"60\" class=\"md-block\"><label>Tel</label>\n<input type=\"text\" ng-model=\"pctrl.clienttel.ctel[2].clients_tel\" ng-pattern=\"/^\\+?[0-9]{1}[0-9]{3,15}$/\" \nng-disabled=\"pctrl.disabled\"></md-input-container><md-input-container flex=\"40\"><label>Select Tel Type</label>\n<md-select name=\"clients_tel_id\" ng-model=\"pctrl.clienttel.ctel[2].tel_type_ids\" multiple=\"true\" \nng-disabled=\"pctrl.disabled\"><md-option ng-repeat=\"(index,clienttel) in pctrl.allteltypes\" \nng-value=\"clienttel.tel_type_id\">{{clienttel.tel_type}}</md-option></md-select><div \nng-messages=\"recordForm.clients_tel_id.$error\"><div ng-message=\"pattern\">Please insert a valid tel.</div></div>\n</md-input-container></div><div flex layout=\"row\"><md-input-container flex=\"60\" class=\"md-block\"><label>Tel</label>\n<input type=\"text\" ng-model=\"pctrl.clienttel.ctel[3].clients_tel\" ng-pattern=\"/^\\+?[0-9]{1}[0-9]{3,15}$/\" \nng-disabled=\"pctrl.disabled\"></md-input-container><md-input-container flex=\"40\"><label>Select Tel Type</label>\n<md-select name=\"clients_tel_id\" ng-model=\"pctrl.clienttel.ctel[3].tel_type_ids\" multiple=\"true\" \nng-disabled=\"pctrl.disabled\"><md-option ng-repeat=\"(index,clienttel) in pctrl.allteltypes\" \nng-value=\"clienttel.tel_type_id\">{{clienttel.tel_type}}</md-option></md-select><div \nng-messages=\"recordForm.clients_tel_id.$error\"><div ng-message=\"pattern\">Please insert a valid tel.</div></div>\n</md-input-container></div><div flex layout=\"row\"><md-input-container flex=\"60\" class=\"md-block\"><label>Tel</label>\n<input type=\"text\" ng-model=\"pctrl.clienttel.ctel[4].clients_tel\" ng-pattern=\"/^\\+?[0-9]{1}[0-9]{3,15}$/\" \nng-disabled=\"pctrl.disabled\"></md-input-container><md-input-container flex=\"40\"><label>Select Tel Type</label>\n<md-select name=\"clients_tel_id\" ng-model=\"pctrl.clienttel.ctel[4].tel_type_ids\" multiple=\"true\" \nng-disabled=\"pctrl.disabled\"><md-option ng-repeat=\"(index,clienttel) in pctrl.allteltypes\" \nng-value=\"clienttel.tel_type_id\">{{clienttel.tel_type}}</md-option></md-select><div \nng-messages=\"recordForm.clients_tel_id.$error\"><div ng-message=\"pattern\">Please insert a valid tel.</div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" \nng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"pctrl.disabled == false ? recordForm.$valid && gravar(pctrl.clienttel) : \'\'\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/profiles/others/settings.html","<md-dialog flex=\"50\" class=\"settings-others\" aria-label=\"Change Settings\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"vm.order.orders_id\" \nng-init=\"vm.order.orders_id=id\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Settings</h2><span flex></span><md-button\n class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" flex layout-align=\"center start\"><div flex layout=\"column\"><span>\nPayment Conditions</span><div layout=\"row\"><ul class=\"list-settings\"><li \nng-repeat=\"($index,payment) in sctrl.allpayments\"><md-input-container \nng-click=\"vm.settings == \'2\' ? editaCampo($index, \'payments\') : \'\'\"><input aria-label=\"Change Payment Name\" \ntype=\"text\" ng-model=\"payment.type_payment\" ng-disabled=\"payment.isDisabled\"><md-tooltip md-direction=\"top\">\nClick to edit this payment name</md-tooltip></md-input-container><a href=\"#\" ng-if=\"payment.isDisabled!=false\" \nng-click=\"vm.settings == \'2\' ? removeOption(\'payments\', payment.payments_id) : \'\'\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font delete\" aria-hidden=\"true\" aria-label=\"Remove Payment Name\">\n<md-tooltip md-direction=\"top\">Click to remove this payment name</md-tooltip></md-icon></a><a href=\"#\" \nng-if=\"payment.isDisabled!=true\" \nng-click=\"vm.settings == \'2\' ? addOption(\'payments\', payment.type_payment, payment.payments_id, $index) : \'\'\"><md-icon \nmd-font-icon=\"icon-check\" class=\"s24 md-font check\" aria-hidden=\"true\" aria-label=\"Change Payment Name\"><md-tooltip \nmd-direction=\"top\">Click to save this payment name</md-tooltip></md-icon></a></li><li><md-input-container \nmd-is-error=\"recordForm.type_payment.$invalid && (recordForm.type_payment.$touched || recordForm.$submitted)\"><label>\nAdd Payment Name</label><input aria-label=\"Add Payment Name\" type=\"text\" name=\"type_payment\" \nng-model=\"sctrl.type_payment\" required><div ng-messages=\"recordForm.type_payment.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Please insert a payment name.</span></div></div></md-input-container><a href=\"#\" \nng-click=\"vm.settings == \'2\' ? addOption(\'payments\', sctrl.type_payment, 0) : \'\'\"><md-icon md-font-icon=\"icon-check\" \nclass=\"s24 md-font check\" aria-hidden=\"true\" aria-label=\"Change Payment Name\"></md-icon></a><md-tooltip \nmd-direction=\"top\">Click to add payment name</md-tooltip></li></ul></div></div><div flex layout=\"column\"><span>\nDiscounts (%)</span><div layout=\"row\"><ul class=\"list-settings\"><li ng-repeat=\"($index,discounts) in sctrl.discounts\">\n<md-input-container ng-click=\"vm.settings == \'2\' ? editaCampo($index, \'discounts\') : \'\'\"><input \naria-label=\"Change Discount Value\" type=\"text\" ng-model=\"discounts.discount\" ng-disabled=\"discounts.isDisabled\">\n<md-tooltip md-direction=\"top\">Click to edit this discount value</md-tooltip></md-input-container><a href=\"#\" \nng-if=\"discounts.isDisabled!=false\" \nng-click=\"vm.settings == \'2\' ? removeOption(\'discounts\', discounts.discounts_id) : \'\'\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font delete\" aria-hidden=\"true\" aria-label=\"Remove Discount Value\">\n<md-tooltip md-direction=\"top\">Click to remove this discount value</md-tooltip></md-icon></a><a href=\"#\" \nng-if=\"discounts.isDisabled!=true\" \nng-click=\"vm.settings == \'2\' ? addOption(\'discounts\', discounts.discount, discounts.discounts_id, $index): \'\'\"><md-icon\n md-font-icon=\"icon-check\" class=\"s24 md-font check\" aria-hidden=\"true\" aria-label=\"Change Discount Value\"><md-tooltip \nmd-direction=\"top\">Click to save this discount value</md-tooltip></md-icon></a></li><li><md-input-container \nmd-is-error=\"recordForm.discount.$invalid && (recordForm.discount.$touched || recordForm.$submitted)\"><label>\nAdd Discount Value</label><input aria-label=\"Add Discount Value\" type=\"text\" name=\"discount\" ng-model=\"sctrl.discount\" \nrequired><div ng-messages=\"recordForm.discount.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease insert a discount value.</span></div></div></md-input-container><a href=\"#\" \nng-click=\"vm.settings == \'2\' ? addOption(\'discounts\', sctrl.discount, 0) : \'\'\"><md-icon md-font-icon=\"icon-check\" \nclass=\"s24 md-font check\" aria-hidden=\"true\" aria-label=\"Change Discount Value\"></md-icon></a><md-tooltip \nmd-direction=\"top\">Click to add discount value</md-tooltip></li></ul></div></div><div flex layout=\"column\"><span>\nVAT (%)</span><div layout=\"row\"><ul class=\"list-settings\"><li ng-repeat=\"($index,vat) in sctrl.vat\"><md-input-container\n ng-click=\"vm.settings == \'2\' ? editaCampo($index, \'vat\') : \'\'\"><input aria-label=\"Change VAT Value\" type=\"text\" \nng-model=\"vat.vat\" ng-disabled=\"vat.isDisabled\"><md-tooltip md-direction=\"top\">Click to edit this VAT value\n</md-tooltip></md-input-container><a href=\"#\" ng-if=\"vat.isDisabled!=false\" \nng-click=\"vm.settings == \'2\' ? removeOption(\'vat\', vat.vat_id) : \'\'\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font delete\" aria-hidden=\"true\" aria-label=\"Remove VAT Value\"><md-tooltip md-direction=\"top\">\nClick to remove this VAT value</md-tooltip></md-icon></a><a href=\"#\" ng-if=\"vat.isDisabled!=true\" \nng-click=\"vm.settings == \'2\' ? addOption(\'vat\', vat.vat, vat.vat_id, $index) : \'\'\"><md-icon md-font-icon=\"icon-check\" \nclass=\"s24 md-font check\" aria-hidden=\"true\" aria-label=\"Change VAT Value\"><md-tooltip md-direction=\"top\">\nClick to save this VAT value</md-tooltip></md-icon></a></li><li><md-input-container \nmd-is-error=\"recordForm.vatname.$invalid && (recordForm.vatname.$touched || recordForm.$submitted)\"><label>\nAdd VAT Value</label><input aria-label=\"Add VAT Value\" type=\"text\" name=\"vatname\" ng-model=\"sctrl.vatname\" required>\n<div ng-messages=\"recordForm.vatname.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please insert a VAT value.\n</span></div></div></md-input-container><a href=\"#\" \nng-click=\"vm.settings == \'2\' ? addOption(\'vat\', sctrl.vatname, 0) : \'\'\"><md-icon md-font-icon=\"icon-check\" \nclass=\"s24 md-font check\" aria-hidden=\"true\" aria-label=\"Change VAT Value\"></md-icon></a><md-tooltip \nmd-direction=\"top\">Click to add VAT value</md-tooltip></li></ul></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Close</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/pages/reportsproducts/others/searchpergroup.html","<md-dialog class=\"searchpopup\" aria-label=\"Search\" ng-cloak><form class=\"casetype\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Search Order</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"estado-funcoes\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"estado-funcoes-esq\" layout=\"row\" \nlayout-align=\"start center\"></div><div class=\"estado-funcoes-dir\" layout=\"row\" layout-align=\"end center\" \nng-click=\"octrl.reset()\"><md-button class=\"md-primary md-raised\">Reset</md-button><md-icon md-font-icon=\"icon-refresh\" \nclass=\"s36 md-default-theme md-font material-icons icon-refresh pointer\" aria-hidden=\"true\"></md-icon></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>\nStart date (yyyy-mm-dd)</label><input type=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"octrl.startDate\" \nng-change=\"octrl.searchTable(octrl.startDate, 7)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>End date (yyyy-mm-dd)</label><input type=\"text\" \nname=\"endDate\" mask=\"9999-19-39\" ng-model=\"octrl.endDate\" ng-change=\"octrl.searchTable(octrl.endDate, 8)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>On Date (yyyy-mm-dd)</label><input type=\"text\" name=\"onDate\" mask=\"9999-19-39\" ng-model=\"octrl.onDate\" \nng-change=\"octrl.searchTable(octrl.onDate, 6)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container></div><div \nlayout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Order No</label><input \nng-model=\"octrl.search.ordernumber\" ng-change=\"octrl.searchTable(octrl.search.ordernumber, 1)\" type=\"text\">\n</md-input-container><md-input-container layout=\"row\" flex class=\"md-block\"><label>Invoice No</label><input \nng-model=\"octrl.search.invoice_number\" ng-change=\"octrl.searchTable(octrl.search.invoice_number, 2)\" type=\"text\">\n</md-input-container><md-input-container layout=\"row\" flex class=\"md-block\"><label>Client Name</label><input \nng-model=\"octrl.search.clientname\" ng-change=\"octrl.searchTable(octrl.search.clientname, 3)\" type=\"text\">\n</md-input-container><md-input-container flex class=\"md-block\"><label>Patient Name</label><input \nng-model=\"octrl.search.patient_name\" ng-change=\"octrl.searchTable(octrl.search.patient_name, 4)\" type=\"text\">\n</md-input-container></div><div layout=\"row\" class=\"production-search md-dialog-content tabela-small\"><table \ndatatable=\"\" class=\"row-border hover full-width\" dt-instance=\"octrl.dtInstance\" dt-options=\"octrl.dtOptions\" \ndt-columns=\"octrl.dtColumns\"></table></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"cancel()\">Close</md-button><md-button class=\"md-green-500-bg branco\" \nng-if=\"octrl.itemabrir && octrl.itemabrir.length==1\" ng-click=\"gravar(octrl.itemabrir)\">Open Order</md-button>\n<md-button class=\"md-green-500-bg branco\" ng-if=\"octrl.itemabrir && octrl.itemabrir.length>1\" \nng-click=\"gravar(octrl.itemabrir)\">Open {{octrl.itemabrir.length}} Orders</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/reportsproducts/others/searchperproduct.html","<md-dialog class=\"searchpopup\" aria-label=\"Search\" ng-cloak><form class=\"casetype\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Search Order</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\">\n<md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"estado-funcoes\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"estado-funcoes-esq\" layout=\"row\" \nlayout-align=\"start center\"></div><div class=\"estado-funcoes-dir\" layout=\"row\" layout-align=\"end center\" \nng-click=\"octrl.reset()\"><md-button class=\"md-primary md-raised\">Reset</md-button><md-icon md-font-icon=\"icon-refresh\" \nclass=\"s36 md-default-theme md-font material-icons icon-refresh pointer\" aria-hidden=\"true\"></md-icon></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>\nStart date (yyyy-mm-dd)</label><input type=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"octrl.startDate\" \nng-change=\"octrl.searchTable(octrl.startDate, 7)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>End date (yyyy-mm-dd)</label><input type=\"text\" \nname=\"endDate\" mask=\"9999-19-39\" ng-model=\"octrl.endDate\" ng-change=\"octrl.searchTable(octrl.endDate, 8)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>On Date (yyyy-mm-dd)</label><input type=\"text\" name=\"onDate\" mask=\"9999-19-39\" ng-model=\"octrl.onDate\" \nng-change=\"octrl.searchTable(octrl.onDate, 6)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container></div><div \nlayout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Order No</label><input \nng-model=\"octrl.search.ordernumber\" ng-change=\"octrl.searchTable(octrl.search.ordernumber, 1)\" type=\"text\">\n</md-input-container><md-input-container layout=\"row\" flex class=\"md-block\"><label>Invoice No</label><input \nng-model=\"octrl.search.invoice_number\" ng-change=\"octrl.searchTable(octrl.search.invoice_number, 2)\" type=\"text\">\n</md-input-container><md-input-container layout=\"row\" flex class=\"md-block\"><label>Client Name</label><input \nng-model=\"octrl.search.clientname\" ng-change=\"octrl.searchTable(octrl.search.clientname, 3)\" type=\"text\">\n</md-input-container><md-input-container flex class=\"md-block\"><label>Patient Name</label><input \nng-model=\"octrl.search.patient_name\" ng-change=\"octrl.searchTable(octrl.search.patient_name, 4)\" type=\"text\">\n</md-input-container></div><div layout=\"row\" class=\"production-search md-dialog-content tabela-small\"><table \ndatatable=\"\" class=\"row-border hover full-width\" dt-instance=\"octrl.dtInstance\" dt-options=\"octrl.dtOptions\" \ndt-columns=\"octrl.dtColumns\"></table></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"cancel()\">Close</md-button><md-button class=\"md-green-500-bg branco\" \nng-if=\"octrl.itemabrir && octrl.itemabrir.length==1\" ng-click=\"gravar(octrl.itemabrir)\">Open Order</md-button>\n<md-button class=\"md-green-500-bg branco\" ng-if=\"octrl.itemabrir && octrl.itemabrir.length>1\" \nng-click=\"gravar(octrl.itemabrir)\">Open {{octrl.itemabrir.length}} Orders</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/templates/cards/analytics/accounts/activeclients.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><div layout=\"row\" class=\"center\"><span \nclass=\"text-smaller cor-texto-analytics\">Active Clients</span></div><div layout=\"row\" class=\"center full-width\"><div \nflex=\"50\" class=\"text-larger cor-texto-analytics text-right mr-10\">\n{{vm.clients[\'activeclients\'].activeclients.activeclients}}</div><div flex=\"50\" class=\"pt-10\"><div layout=\"row\" \nclass=\"text-smallest cor-info text-left\">Average (6 Mth)</div><div layout=\"row\" \nclass=\"text-smallest cor-info text-left\">{{vm.clients[\'activeclients\'].activeclientsA.activeclients}}</div></div></div>\n</div>");
$templateCache.put("app/templates/cards/analytics/accounts/inactiveclients.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><div layout=\"row\" class=\"center\"><span \nclass=\"text-smaller cor-texto-analytics\">Inactive Clients</span></div><div layout=\"row\" class=\"center full-width\"><div \nflex=\"50\" class=\"text-larger cor-texto-analytics text-right mr-10\">\n{{vm.clients[\'inactiveclients\'].inactiveclients.inactiveclients}}</div><div flex=\"50\" class=\"pt-10\"><div layout=\"row\" \nclass=\"text-smallest cor-info text-left\">Average (6 Mth)</div><div layout=\"row\" \nclass=\"text-smallest cor-info text-left\">{{vm.clients[\'inactiveclients\'].inactiveclientsA.inactiveclients}}</div></div>\n</div></div>");
$templateCache.put("app/templates/cards/analytics/accounts/pastmonthclients.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><div layout=\"row\" class=\"center\"><span \nclass=\"text-smaller cor-texto-analytics\">Past Month Active Clients</span></div><div layout=\"row\" \nclass=\"center full-width\"><div flex=\"50\" class=\"text-larger cor-texto-analytics text-right mr-10\">\n{{vm.clients[\'pastmonthactiveclients\'].pastmonthactiveclients.pastmonthactiveclients}}</div><div flex=\"50\" \nclass=\"pt-10\"><div layout=\"row\" class=\"text-smallest cor-info text-left\">Average (6 Mth)</div><div layout=\"row\" \nclass=\"text-smallest cor-info text-left\">\n{{vm.clients[\'pastmonthactiveclients\'].pastmonthactiveclientsA.pastmonthactiveclients}}</div></div></div></div>");
$templateCache.put("app/templates/cards/analytics/accounts/top10clients.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"full-width\"><table datatable=\"\" class=\"row-border hover full-width\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\"></table></div></div>");
$templateCache.put("app/templates/cards/analytics/accounts/totalclients.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><div layout=\"row\" class=\"center\"><span \nclass=\"text-smaller cor-texto-analytics\">Total Clients</span></div><div layout=\"row\" class=\"center full-width\"><div \nflex=\"50\" class=\"text-larger cor-texto-analytics text-right mr-10\">{{vm.clients[\'totalclients\'].totalclients}}</div>\n<div flex=\"50\" class=\"pt-10\"><div layout=\"row\" class=\"text-smallest cor-info text-left\">Average (12 Mth)</div><div \nlayout=\"row\" class=\"text-smallest cor-info text-left\">{{vm.clients[\'totalclients\'].totalclientsA.totalclientsA}}</div>\n</div></div></div>");
$templateCache.put("app/templates/cards/analytics/md/balance.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.reset()\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Start (yyyy-mm-dd)</label><input \ntype=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.startDate\" \nng-change=\"vm.searchTable(\'startDate\',vm.startDate)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>End (yyyy-mm-dd)</label><input type=\"text\" \nname=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.endDate\" ng-change=\"vm.searchTable(\'endDate\',vm.endDate)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container></div><div layout=\"row md-padding\"><span \nclass=\"text-bigger cor-texto-analytics\">£ {{vm.totalcost | number : 0}}</span></div><div class=\"divisor\"></div><div \nclass=\"row\"><span class=\"text-smaller cor-texto-analytics\">Total VAT</span></div><div class=\"row\"><span \nclass=\"text-small cor-texto-analytics\">£ {{vm.totalvat | number : 0}}</span></div></div>");
$templateCache.put("app/templates/cards/analytics/md/bankbalance.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button \nng-click=\"vm.clean(\'bankbalance\')\" layout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span \nstyle=\"margin:auto\">Reset</span></md-button><div layout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\" \nmoment-picker=\"vm.startDate[\'bankbalance\']\" format=\"YYYY-MM-DD\" set-on-select=\"true\" start-view=\"month\" \nchange=\"vm.changeTotalSales(\'bankbalance\',\'startDate\',vm.startDate[\'bankbalance\'])\"><label>Start date</label><input \nclass=\"form-control\" name=\"startDate\" ng-model=\"vm.startDate[\'bankbalance\']\"></md-input-container><md-input-container \nlayout=\"row\" flex class=\"md-block\" moment-picker=\"vm.endDate[\'bankbalance\']\" format=\"YYYY-MM-DD\" set-on-select=\"true\" \nstart-view=\"month\" change=\"vm.changeTotalSales(\'bankbalance\',\'endDate\',vm.endDate[\'bankbalance\'])\"><label>End date\n</label><input class=\"form-control\" name=\"endDate\" ng-model=\"vm.endDate[\'bankbalance\']\"></md-input-container></div><div\n class=\"center\"><span class=\"text-smaller cor-texto-analytics\">Bank Balance</span></div><div class=\"center\"><span \nclass=\"text-medium cor-texto-analytics\">{{vm.order[\'bankbalance\']}}</span></div></div>");
$templateCache.put("app/templates/cards/analytics/md/completedorders.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button \nng-click=\"vm.clean(\'completedorders\')\" layout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span \nstyle=\"margin:auto\">Reset</span></md-button><div layout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\" \nmoment-picker=\"vm.startDate[\'completedorders\']\" format=\"YYYY-MM-DD\" set-on-select=\"true\" start-view=\"month\" \nchange=\"vm.changeTotalSales(\'completedorders\',\'startDate\',vm.startDate[\'completedorders\'])\"><label>Start date</label>\n<input class=\"form-control\" name=\"startDate\" ng-model=\"vm.startDate[\'completedorders\']\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\" moment-picker=\"vm.endDate[\'completedorders\']\" \nformat=\"YYYY-MM-DD\" set-on-select=\"true\" start-view=\"month\" \nchange=\"vm.changeTotalSales(\'completedorders\',\'endDate\',vm.endDate[\'completedorders\'])\"><label>End date</label><input \nclass=\"form-control\" name=\"endDate\" ng-model=\"vm.endDate[\'completedorders\']\"></md-input-container></div><div \nlayout=\"row md-padding\"><span class=\"text-bigger cor-texto-analytics\">{{vm.order[\'completedorders\']}}</span></div>\n</div>");
$templateCache.put("app/templates/cards/analytics/md/employees.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><div layout=\"row\" \nclass=\"md-padding full-width\"><div flex><div class=\"center\"><span class=\"text-smaller cor-texto-analytics\">\nEmployees at Work</span></div><div class=\"center\"><span class=\"text-bigger cor-texto-analytics\">{{vm.employees.atwork}}\n</span></div></div><div flex><div class=\"center\"><span class=\"text-smaller cor-texto-analytics\">Total Employees</span>\n</div><div class=\"center\"><span class=\"text-bigger cor-texto-analytics\">{{vm.employees.total}}</span></div></div><div \nflex><div class=\"center\"><span class=\"text-smaller cor-texto-analytics\">Employees Not Checked In</span></div><div \nclass=\"center\"><span class=\"text-bigger cor-texto-analytics\">{{vm.employees.notchecked}}</span></div></div></div><div \nlayout=\"row\" class=\"center\"><span class=\"text-smaller cor-texto-analytics\">Departments</span></div><div layout=\"row\" \nclass=\"md-padding full-width\"><div flex><div ng-repeat=\"numuser in vm.numusers | limitTo: 12\" class=\"mb-10\"><span \nclass=\"info-grey\">{{numuser.department_name}}: {{numuser.numusers}}</span></div></div><div flex><div \nng-repeat=\"numuser in vm.numusers | limitTo: 12 : 12\" class=\"mb-10\"><span class=\"info-grey\">\n{{numuser.department_name}}: {{numuser.numusers}}</span></div></div></div></div>");
$templateCache.put("app/templates/cards/analytics/md/expenditure.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button \nng-click=\"vm.clean(\'expenditure\')\" layout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span \nstyle=\"margin:auto\">Reset</span></md-button><div layout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\" \nmoment-picker=\"vm.startDate[\'expenditure\']\" format=\"YYYY-MM-DD\" set-on-select=\"true\" start-view=\"month\" \nchange=\"vm.changeTotalSales(\'expenditure\',\'startDate\',vm.startDate[\'expenditure\'])\"><label>Start date</label><input \nclass=\"form-control\" name=\"startDate\" ng-model=\"vm.startDate[\'expenditure\']\"></md-input-container><md-input-container \nlayout=\"row\" flex class=\"md-block\" moment-picker=\"vm.endDate[\'expenditure\']\" format=\"YYYY-MM-DD\" set-on-select=\"true\" \nstart-view=\"month\" change=\"vm.changeTotalSales(\'expenditure\',\'endDate\',vm.endDate[\'expenditure\'])\"><label>End date\n</label><input class=\"form-control\" name=\"endDate\" ng-model=\"vm.endDate[\'expenditure\']\"></md-input-container></div><div\n class=\"center\"><span class=\"text-smaller cor-texto-analytics\">Expenditure</span></div><div class=\"center\"><span \nclass=\"text-medium cor-texto-analytics\">{{vm.order[\'expenditure\']}}</span></div></div>");
$templateCache.put("app/templates/cards/analytics/md/financesincome.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button \nng-click=\"vm.clean(\'financesincome\')\" layout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span \nstyle=\"margin:auto\">Reset</span></md-button><div layout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\" \nmoment-picker=\"vm.startDate[\'financesincome\']\" format=\"YYYY-MM-DD\" set-on-select=\"true\" start-view=\"month\" \nchange=\"vm.changeTotalSales(\'financesincome\',\'startDate\',vm.startDate[\'financesincome\'])\"><label>Start date</label>\n<input class=\"form-control\" name=\"startDate\" ng-model=\"vm.startDate[\'financesincome\']\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\" moment-picker=\"vm.endDate[\'financesincome\']\" \nformat=\"YYYY-MM-DD\" set-on-select=\"true\" start-view=\"month\" \nchange=\"vm.changeTotalSales(\'financesincome\',\'endDate\',vm.endDate[\'financesincome\'])\"><label>End date</label><input \nclass=\"form-control\" name=\"endDate\" ng-model=\"vm.endDate[\'financesincome\']\"></md-input-container></div><div \nclass=\"center\"><span class=\"text-smaller cor-texto-analytics\">Income</span></div><div class=\"center\"><span \nclass=\"text-medium cor-texto-analytics\">{{vm.order[\'financesincome\']}}</span></div></div>");
$templateCache.put("app/templates/cards/analytics/md/income.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.clean(\'topsales\')\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Start (yyyy-mm-dd)</label><input \ntype=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.startDate\" \nng-change=\"vm.changeTotalSales(\'startDate\',vm.startDate)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>End (yyyy-mm-dd)</label><input type=\"text\" \nname=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.endDate\" ng-change=\"vm.changeTotalSales(\'endDate\',vm.endDate)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container></div><div layout=\"row md-padding\"><span class=\"text-bigger\">\n£ {{vm.totalcost | number : 0}}</span></div><div class=\"divisor\"></div><div class=\"row\"><span class=\"text-smaller\">\nTotal VAT</span></div><div class=\"row\"><span class=\"text-small\">£ {{vm.totalvat | number : 0}}</span></div></div>");
$templateCache.put("app/templates/cards/analytics/md/moneyowed.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.clean(\'moneyowed\')\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\" moment-picker=\"vm.startDate[\'moneyowed\']\" \nformat=\"YYYY-MM-DD\" set-on-select=\"true\" start-view=\"month\" \nchange=\"vm.changeTotalSales(\'moneyowed\',\'startDate\',vm.startDate[\'moneyowed\'])\"><label>Start date</label><input \nclass=\"form-control\" name=\"startDate\" ng-model=\"vm.startDate[\'moneyowed\']\"></md-input-container><md-input-container \nlayout=\"row\" flex class=\"md-block\" moment-picker=\"vm.endDate[\'moneyowed\']\" format=\"YYYY-MM-DD\" set-on-select=\"true\" \nstart-view=\"month\" change=\"vm.changeTotalSales(\'moneyowed\',\'endDate\',vm.endDate[\'moneyowed\'])\"><label>End date</label>\n<input class=\"form-control\" name=\"endDate\" ng-model=\"vm.endDate[\'moneyowed\']\"></md-input-container></div><div \nclass=\"center\"><span class=\"text-smaller cor-texto-analytics\">Money Owed and Divided</span></div><div class=\"center\">\n<span class=\"text-medium cor-texto-analytics\">{{vm.order[\'moneyowed\']}}</span></div></div>");
$templateCache.put("app/templates/cards/analytics/md/neworders.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.clean(\'neworders\')\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\" moment-picker=\"vm.startDate[\'neworders\']\" \nformat=\"YYYY-MM-DD\" set-on-select=\"true\" start-view=\"month\" \nchange=\"vm.changeTotalSales(\'neworders\',\'startDate\',vm.startDate[\'neworders\'])\"><label>Start date</label><input \nclass=\"form-control\" name=\"startDate\" ng-model=\"vm.startDate[\'neworders\']\"></md-input-container><md-input-container \nlayout=\"row\" flex class=\"md-block\" moment-picker=\"vm.endDate[\'neworders\']\" format=\"YYYY-MM-DD\" set-on-select=\"true\" \nstart-view=\"month\" change=\"vm.changeTotalSales(\'neworders\',\'endDate\',vm.endDate[\'neworders\'])\"><label>End date</label>\n<input class=\"form-control\" name=\"endDate\" ng-model=\"vm.endDate[\'neworders\']\"></md-input-container></div><div \nlayout=\"row md-padding\"><span class=\"text-bigger cor-texto-analytics\">{{vm.order[\'neworders\']}}</span></div></div>");
$templateCache.put("app/templates/cards/analytics/md/ordersdue.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.clean(\'ordersdue\')\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\" moment-picker=\"vm.startDate[\'ordersdue\']\" \nformat=\"YYYY-MM-DD\" set-on-select=\"true\" start-view=\"month\" \nchange=\"vm.changeTotalSales(\'ordersdue\',\'startDate\',vm.startDate[\'ordersdue\'])\"><label>Start date</label><input \nclass=\"form-control\" name=\"startDate\" ng-model=\"vm.startDate[\'ordersdue\']\"></md-input-container><md-input-container \nlayout=\"row\" flex class=\"md-block\" moment-picker=\"vm.endDate[\'ordersdue\']\" format=\"YYYY-MM-DD\" set-on-select=\"true\" \nstart-view=\"month\" change=\"vm.changeTotalSales(\'ordersdue\',\'endDate\',vm.endDate[\'ordersdue\'])\"><label>End date</label>\n<input class=\"form-control\" name=\"endDate\" ng-model=\"vm.endDate[\'ordersdue\']\"></md-input-container></div><div \nlayout=\"row md-padding\"><span class=\"text-bigger cor-texto-analytics\">{{vm.order[\'ordersdue\']}}</span></div></div>");
$templateCache.put("app/templates/cards/analytics/md/ordersonstop.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button \nng-click=\"vm.clean(\'ordersonstop\')\" layout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span \nstyle=\"margin:auto\">Reset</span></md-button><div layout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\" \nmoment-picker=\"vm.startDate[\'ordersonstop\']\" format=\"YYYY-MM-DD\" set-on-select=\"true\" start-view=\"month\" \nchange=\"vm.changeTotalSales(\'ordersonstop\',\'startDate\',vm.startDate[\'ordersonstop\'])\"><label>Start date</label><input \nclass=\"form-control\" name=\"startDate\" ng-model=\"vm.startDate[\'ordersonstop\']\"></md-input-container><md-input-container \nlayout=\"row\" flex class=\"md-block\" moment-picker=\"vm.endDate[\'ordersonstop\']\" format=\"YYYY-MM-DD\" set-on-select=\"true\" \nstart-view=\"month\" change=\"vm.changeTotalSales(\'ordersonstop\',\'endDate\',vm.endDate[\'ordersonstop\'])\"><label>End date\n</label><input class=\"form-control\" name=\"endDate\" ng-model=\"vm.endDate[\'ordersonstop\']\"></md-input-container></div>\n<div layout=\"row md-padding\"><span class=\"text-bigger cor-texto-analytics\">{{vm.order[\'ordersonstop\']}}</span></div>\n</div>");
$templateCache.put("app/templates/cards/analytics/md/orderswfc.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.clean(\'orderswfc\')\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\" moment-picker=\"vm.startDate[\'orderswfc\']\" \nformat=\"YYYY-MM-DD\" set-on-select=\"true\" start-view=\"month\" \nchange=\"vm.changeTotalSales(\'orderswfc\',\'startDate\',vm.startDate[\'orderswfc\'])\"><label>Start date</label><input \nclass=\"form-control\" name=\"startDate\" ng-model=\"vm.startDate[\'orderswfc\']\"></md-input-container><md-input-container \nlayout=\"row\" flex class=\"md-block\" moment-picker=\"vm.endDate[\'orderswfc\']\" format=\"YYYY-MM-DD\" set-on-select=\"true\" \nstart-view=\"month\" change=\"vm.changeTotalSales(\'orderswfc\',\'endDate\',vm.endDate[\'orderswfc\'])\"><label>End date</label>\n<input class=\"form-control\" name=\"endDate\" ng-model=\"vm.endDate[\'orderswfc\']\"></md-input-container></div><div \nlayout=\"row md-padding\"><span class=\"text-bigger cor-texto-analytics\">{{vm.order[\'orderswfc\']}}</span></div></div>");
$templateCache.put("app/templates/cards/analytics/md/orderswfi.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.clean(\'orderswfi\')\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\" moment-picker=\"vm.startDate[\'orderswfi\']\" \nformat=\"YYYY-MM-DD\" set-on-select=\"true\" start-view=\"month\" \nchange=\"vm.changeTotalSales(\'orderswfi\',\'startDate\',vm.startDate[\'orderswfi\'])\"><label>Start date</label><input \nclass=\"form-control\" name=\"startDate\" ng-model=\"vm.startDate[\'orderswfi\']\"></md-input-container><md-input-container \nlayout=\"row\" flex class=\"md-block\" moment-picker=\"vm.endDate[\'orderswfi\']\" format=\"YYYY-MM-DD\" set-on-select=\"true\" \nstart-view=\"month\" change=\"vm.changeTotalSales(\'orderswfi\',\'endDate\',vm.endDate[\'orderswfi\'])\"><label>End date</label>\n<input class=\"form-control\" name=\"endDate\" ng-model=\"vm.endDate[\'orderswfi\']\"></md-input-container></div><div \nlayout=\"row md-padding\"><span class=\"text-bigger cor-texto-analytics\">{{vm.order[\'orderswfi\']}}</span></div></div>");
$templateCache.put("app/templates/cards/analytics/md/owed.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.clean(\'topsales\')\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Start (yyyy-mm-dd)</label><input \ntype=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.startDate\" \nng-change=\"vm.changeTotalSales(\'startDate\',vm.startDate)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>End (yyyy-mm-dd)</label><input type=\"text\" \nname=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.endDate\" ng-change=\"vm.changeTotalSales(\'endDate\',vm.endDate)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container></div><div layout=\"row md-padding\"><span class=\"text-bigger\">\n£ {{vm.totalcost | number : 0}}</span></div><div class=\"divisor\"></div><div class=\"row\"><span class=\"text-smaller\">\nTotal VAT</span></div><div class=\"row\"><span class=\"text-small\">£ {{vm.totalvat | number : 0}}</span></div></div>");
$templateCache.put("app/templates/cards/analytics/md/total.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.reset()\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\" class=\"full-width\"><md-input-container layout=\"row\" flex class=\"md-block\" \nmoment-picker=\"vm.search.startDate\" format=\"YYYY-MM-DD\" set-on-select=\"true\" start-view=\"month\" \nchange=\"vm.searchTable(vm.search.startDate, 1)\"><label>Start date</label><input class=\"form-control\" name=\"startDate\" \nng-model=\"vm.search.startDate\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\" \nmoment-picker=\"vm.search.endDate\" format=\"YYYY-MM-DD\" set-on-select=\"true\" start-view=\"month\" \nchange=\"vm.searchTable(vm.search.endDate, 2)\"><label>End date</label><input class=\"form-control\" name=\"endDate\" \nng-model=\"vm.search.endDate\"></md-input-container></div><div layout=\"row md-padding\"><span \nclass=\"text-bigger cor-texto-analytics\">Total: {{vm.totalexpenses}}</span></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"full-width\"><table datatable=\"\" class=\"row-border hover responsive\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\"></table></div></div>");
$templateCache.put("app/templates/cards/analytics/md/totaldebt.html","<div flex class=\"topsales-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.clean(\'totaldebt\')\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\" moment-picker=\"vm.startDate[\'totaldebt\']\" \nformat=\"YYYY-MM-DD\" set-on-select=\"true\" start-view=\"month\" \nchange=\"vm.changeTotalSales(\'totaldebt\',\'startDate\',vm.startDate[\'totaldebt\'])\"><label>Start date</label><input \nclass=\"form-control\" name=\"startDate\" ng-model=\"vm.startDate[\'totaldebt\']\"></md-input-container><md-input-container \nlayout=\"row\" flex class=\"md-block\" moment-picker=\"vm.endDate[\'totaldebt\']\" format=\"YYYY-MM-DD\" set-on-select=\"true\" \nstart-view=\"month\" change=\"vm.changeTotalSales(\'totaldebt\',\'endDate\',vm.endDate[\'totaldebt\'])\"><label>End date</label>\n<input class=\"form-control\" name=\"endDate\" ng-model=\"vm.endDate[\'totaldebt\']\"></md-input-container></div><div \nclass=\"center\"><span class=\"text-smaller cor-texto-analytics\">Total Debt</span></div><div class=\"center\"><span \nclass=\"text-medium cor-texto-analytics\">{{vm.order[\'totaldebt\']}}</span></div></div>");
$templateCache.put("app/templates/cards/analytics/sections/tecorders.html","<div flex class=\"pointsdate-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.resetteco()\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Start (yyyy-mm-dd)</label><input \ntype=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.search2.startDate\" \nng-change=\"vm.searchTable2(vm.search2.startDate,2)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>End (yyyy-mm-dd)</label><input type=\"text\" \nname=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.search2.endDate\" ng-change=\"vm.searchTable2(vm.search2.endDate,3)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"full-width\"><table datatable=\"\" class=\"row-border hover full-width\" dt-instance=\"vm.dtInstance2\" \ndt-options=\"vm.dtOptions2\" dt-columns=\"vm.dtColumns2\"></table></div></div>");
$templateCache.put("app/templates/cards/analytics/sections/top10clients.html","<div flex class=\"pointsdate-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.resettop10()\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Start (yyyy-mm-dd)</label><input \ntype=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.search1.startDate\" \nng-change=\"vm.searchTable1(vm.search1.startDate,3)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>End (yyyy-mm-dd)</label><input type=\"text\" \nname=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.search1.endDate\" ng-change=\"vm.searchTable1(vm.search1.endDate,4)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"full-width\"><table datatable=\"\" class=\"row-border hover full-width\" dt-instance=\"vm.dtInstance1\" \ndt-options=\"vm.dtOptions1\" dt-columns=\"vm.dtColumns1\"></table></div></div>");
$templateCache.put("app/templates/cards/analytics/sections/top5tecs.html","<div flex class=\"pointsdate-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.resettop5tec()\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Start (yyyy-mm-dd)</label><input \ntype=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.search3.startDate\" \nng-change=\"vm.searchTable3(vm.search3.startDate,2)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>End (yyyy-mm-dd)</label><input type=\"text\" \nname=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.search3.endDate\" ng-change=\"vm.searchTable3(vm.search3.endDate,3)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"full-width\"><table datatable=\"\" class=\"row-border hover full-width\" dt-instance=\"vm.dtInstance3\" \ndt-options=\"vm.dtOptions3\" dt-columns=\"vm.dtColumns3\"></table></div></div>");
$templateCache.put("app/templates/cards/analytics/points/pointsperdate.html","<div flex class=\"pointsdate-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.resetpd()\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Start (yyyy-mm-dd)</label><input \ntype=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.search1.startDate\" \nng-change=\"vm.searchTable1(vm.search1.startDate,1)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>End (yyyy-mm-dd)</label><input type=\"text\" \nname=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.search1.endDate\" ng-change=\"vm.searchTable1(vm.search1.endDate,3)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"full-width\"><table datatable=\"\" class=\"row-border hover full-width\" dt-instance=\"vm.dtInstance1\" \ndt-options=\"vm.dtOptions1\" dt-columns=\"vm.dtColumns1\"></table></div></div>");
$templateCache.put("app/templates/cards/analytics/points/pointspertec.html","<div flex class=\"pointsdate-box\" layout=\"column\" layout-align=\"start center\"><md-button ng-click=\"vm.reset_tec()\" \nlayout=\"row\" class=\"pointer md-primary md-raised mini-button\"><span style=\"margin:auto\">Reset</span></md-button><div \nlayout=\"row\" class=\"full-width\"><md-input-container layout=\"row\" flex class=\"md-block\"><label>Start (yyyy-mm-dd)\n</label><input type=\"text\" name=\"startDate\" mask=\"9999-19-39\" ng-model=\"vm.search2.startDate\" \nng-change=\"vm.searchTable2(vm.search2.startDate, 1)\" ng-model-options=\"{ debounce: 750 }\"></md-input-container>\n<md-input-container layout=\"row\" flex class=\"md-block\"><label>End (yyyy-mm-dd)</label><input type=\"text\" \nname=\"endDate\" mask=\"9999-19-39\" ng-model=\"vm.search2.endDate\" ng-change=\"vm.searchTable2(vm.search2.endDate, 3)\" \nng-model-options=\"{ debounce: 750 }\"></md-input-container><md-input-container layout=\"row\" flex class=\"md-block\">\n<label>Tec Name</label><input type=\"text\" name=\"ccity\" ng-model=\"vm.search2.name\" \nng-change=\"vm.searchTable2(vm.search2.name, 0)\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"full-width\"><table datatable=\"\" class=\"row-border hover full-width\" \ndt-instance=\"vm.dtInstance2\" dt-options=\"vm.dtOptions2\" dt-columns=\"vm.dtColumns2\"></table></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/apps/scrumboard/dialogs/card/card-dialog.html","<md-dialog class=\"card-dialog\" aria-label=\"Card Dialog\" ng-cloak><md-toolbar class=\"md-accent\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><div class=\"due-date\"><div \nng-if=\"!vm.card.due\" moment-picker=\"vm.card.due\" format=\"x\" min-view=\"year\" max-view=\"hour\" start-view=\"month\">\n<md-button class=\"md-icon-button\" aria-label=\"Due date\" translate translate-attr-aria-label=\"SB.DUE_DATE\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-calendar\"></md-icon></md-button></div></div><md-menu \nng-if=\"vm.card.due\" md-offset=\"0 48\" class=\"remove-due-date\"><md-button class=\"md-icon-button\" aria-label=\"Members\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-calendar\"></md-icon></md-button><md-menu-content \nclass=\"remove-due-date-menu-content\" width=\"4\" ms-scroll><md-menu-item><md-button ng-click=\"vm.card.due = \'\'\" \naria-label=\"remove due date\" translate-attr-aria-label=\"SB.REMOVE_DUE_DATE\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><span translate=\"SB.REMOVE_DUE_DATE\">Remove Due Date</span></md-button></md-menu-item></md-menu-content>\n</md-menu><md-menu md-offset=\"0 48\" class=\"labels\"><md-button class=\"md-icon-button\" aria-label=\"Label\" translate \ntranslate-attr-aria-label=\"SB.LABEL\" ng-click=\"vm.labelTabIndex = 0;$mdOpenMenu($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-label-outline\"></md-icon></md-button><md-menu-content class=\"labels-menu-content\" width=\"4\" \nms-scroll><md-tabs md-selected=\"vm.labelTabIndex\" md-dynamic-height><md-tab><md-tab-body><md-menu-item>\n<md-input-container class=\"no-errors-spacer\" md-no-float><input placeholder=\"Search labels...\" type=\"text\" \nng-model=\"vm.labelSearchText\" autocomplete=\"off\" translate-attr-palceholder=\"SB.SEARCH_LABELS\"></md-input-container>\n</md-menu-item><md-menu-item class=\"label\" ng-repeat=\"label in vm.labels | filter: vm.filterLabel\"><md-button \nclass=\"label-toggle-button\" md-prevent-menu-close ng-class=\"\'md-\'+label.color+\'-bg\'\" \nng-click=\"vm.toggleInArray(label.id, vm.card.idLabels)\" aria-label=\"Toggle Label\" translate \ntranslate-attr-aria-label=\"SB.TOGGLE_LABEL\"><div layout=\"row\" layout-align=\"space-between center\" flex><span>\n{{label.name}}</span> <i ng-if=\"vm.exists(label.id, vm.card.idLabels)\" class=\"icon-check s16\"></i></div></md-button>\n<md-button class=\"md-icon-button label-edit-button\" md-prevent-menu-close \nng-click=\"vm.editLabelId = label.id; vm.labelTabIndex = 2\" aria-label=\"Edit Label\" translate \ntranslate-attr-aria-label=\"SB.EDIT_LABEL\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></md-button>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button class=\"add-label-button\" \nmd-prevent-menu-close ng-click=\"vm.labelTabIndex = 1\"><md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon><span \ntranslate=\"SB.ADD_NEW_LABEL\">Add new label</span></md-button></md-menu-item></md-tab-body></md-tab><md-tab>\n<md-tab-body><div class=\"add-label-tab-content\"><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<md-button class=\"md-icon-button\" md-prevent-menu-close ng-click=\"vm.labelTabIndex = 0\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"SB.BACK\"><i class=\"icon-arrow-left s20\"></i></md-button><span flex \ntranslate=\"SB.CREATE_LABEL\">Create Label</span></div><div class=\"content\" layout=\"column\" layout-align=\"start stretch\">\n<form ng-submit=\"vm.addNewLabel(); vm.labelTabIndex = 0\" layout=\"column\"><md-input-container class=\"no-errors-spacer\" \nmd-no-float><input placeholder=\"Label Name\" type=\"text\" ng-model=\"vm.newLabelName\" translate \ntranslate-attr-placeholder=\"SB.LABEL_NAME\"></md-input-container><div class=\"label-color-picker\" layout=\"row\" \nlayout-wrap><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" \nlayout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"vm.newLabelColor\" ng-value=\"palette\" \naria-label=\"{{palette}}\"> <i class=\"icon-check s18\" ng-if=\"vm.newLabelColor === palette\"></i></label></div><md-button \ntype=\"submit\" md-prevent-menu-close class=\"create-button md-accent md-raised\" aria-label=\"Create\" translate \ntranslate-attr-aria-label=\"SB.CREATE\"><span translate=\"SB.CREATE\">Create</span></md-button></form></div></div>\n</md-tab-body></md-tab><md-tab><md-tab-body><div class=\"edit-label-tab-content\"><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-icon-button\" md-prevent-menu-close \nng-click=\"vm.labelTabIndex = 0\" aria-label=\"back\" translate translate-attr-aria-label=\"SB.BACK\"><i \nclass=\"icon-arrow-left s20\"></i></md-button><span flex translate=\"SB.EDIT_LABEL\">Edit Label</span></div><div \nclass=\"content\" layout=\"column\" layout-align=\"start stretch\"><md-input-container class=\"no-errors-spacer\" md-no-float>\n<input placeholder=\"Label Name\" type=\"text\" ng-model=\"vm.board.labels.getById(vm.editLabelId).name\" translate \ntranslate-attr-placeholder=\"SB.LABEL_NAME\"></md-input-container><div class=\"label-color-picker\" layout=\"row\" \nlayout-wrap><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" \nlayout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" \nng-model=\"vm.board.labels.getById(vm.editLabelId).color\" ng-value=\"palette\" aria-label=\"{{palette}}\"> <i \nng-if=\"vm.board.labels.getById(vm.editLabelId).color === palette\" class=\"icon-check s18\"></i></label></div><div \nlayout=\"row\" layout-align=\"end center\" flex><md-button class=\"remove-button md-icon-button\" type=\"submit\" \nmd-prevent-menu-close ng-click=\"vm.removeLabel(); vm.labelTabIndex=0\" aria-label=\"remove\" translate \ntranslate-attr-aria-label=\"SB.REMOVE\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div></div>\n</md-tab-body></md-tab></md-tabs></md-menu-content></md-menu><md-menu md-offset=\"0 48\" class=\"members\"><md-button \nclass=\"md-icon-button\" aria-label=\"Members\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-account-multiple\"></md-icon></md-button><md-menu-content class=\"members-menu-content\" width=\"4\" \nms-scroll><md-menu-item><md-input-container class=\"no-errors-spacer\" md-no-float><input \nplaceholder=\"Search members...\" autocomplete=\"off\" type=\"text\" ng-model=\"vm.memberSearchText\" translate \ntranslate-attr-placeholder=\"SB.SEARCH_MEMBERS\"></md-input-container></md-menu-item><md-menu-item class=\"member\" \nng-repeat=\"member in vm.members  | filter: vm.filterMember\"><md-button \nng-click=\"vm.toggleInArray(member.id, vm.card.idMembers)\" md-prevent-menu-close aria-label=\"toggle member\" translate \ntranslate-attr-aria-label=\"SB.TOGGLE_MEMBER\"><div layout=\"row\" layout-align=\"space-between center\" flex><div \nlayout=\"row\" layout-align=\"start center\"><img alt=\"{{ member.name }}\" ng-src=\"{{ member.avatar }}\" class=\"avatar\"><p \nclass=\"member-name\">{{ member.name }}</p></div><i class=\"icon-check s16\" \nng-if=\"vm.exists(member.id, vm.card.idMembers)\"></i></div></md-button></md-menu-item></md-menu-content></md-menu>\n<md-button class=\"md-icon-button\" ng-click=\"\" aria-label=\"Attachment\" translate \ntranslate-attr-aria-label=\"SB.ATTACHMENT\"><md-icon md-font-icon=\"icon-attachment\"></md-icon></md-button><md-menu \nmd-offset=\"0 48px\" class=\"checklist\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" \naria-label=\"checklist\" translate translate-attr-aria-label=\"SB.CHECKLIST\"><md-icon md-menu-origin \nmd-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-menu-content class=\"checklist-menu-content\" width=\"4\">\n<form ng-submit=\"vm.createCheckList()\" layout=\"column\" layout-align=\"start end\"><md-input-container \nclass=\"no-errors-spacer\" md-no-float><input placeholder=\"Checklist Title\" autocomplete=\"off\" type=\"text\" \nng-model=\"vm.newCheckListTitle\" translate translate-attr-placeholder=\"SB.CHECKLIST_TITLE\"></md-input-container>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Add Checklist\" translate \ntranslate-attr-aria-label=\"SB.ADD_CHECKLIST\"><span translate=\"SB.ADD_CHECKLIST\">Add Checklist</span></md-button></form>\n</md-menu-content></md-menu><md-menu md-offset=\"0 48px\" class=\"subscribe\"><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"Subscribe\" translate translate-attr-aria-label=\"SB.SUBSCRIBE\"><md-icon \nmd-menu-origin ng-if=\"vm.card.subscribed\" md-font-icon=\"icon-eye\"></md-icon><md-icon md-menu-origin \nng-if=\"!vm.card.subscribed\" md-font-icon=\"icon-eye-off\"></md-icon></md-button><md-menu-content \nclass=\"subscribe-menu-content\" width=\"4\"><md-menu-item><md-button ng-click=\"vm.card.subscribed = !vm.card.subscribed\" \naria-label=\"Subscribed\" translate translate-attr-aria-label=\"SB.SUBSCRIBED\"><span ng-if=\"!vm.card.subscribed\" \ntranslate=\"SB.SUBSCRIBE\">Subscribe</span> <span ng-if=\"vm.card.subscribed\" translate=\"SB.UNSUBSCRIBE\">Unsubscribe\n</span></md-button></md-menu-item></md-menu-content></md-menu><md-menu md-offset=\"0 48px\" class=\"options\"><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Options\" translate \ntranslate-attr-aria-label=\"SB.OPTIONS\"><md-icon md-menu-origin md-font-icon=\"icon-dots-horizontal\"></md-icon>\n</md-button><md-menu-content class=\"options-menu-content\" width=\"4\"><md-menu-item><md-button \nng-click=\"vm.removeCard()\" aria-label=\"Remove Card\" translate translate-attr-aria-label=\"SB.REMOVE_CARD\"><md-icon \nmd-font-icon=\"icon-delete\" md-menu-align-target></md-icon><span translate=\"SB.REMOVE_CARD\">Remove Card</span>\n</md-button></md-menu-item></md-menu-content></md-menu><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close Dialog\" translate translate-attr-aria-label=\"SB.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\" \nlayout-align=\"space-between start\"><div layout=\"column\" layout-align=\"start stretch\" flex><div class=\"card-breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><span>{{vm.board.name}}</span> <i class=\"icon-menu-right\"></i> <span>\n{{vm.getCardList().name}}</span></div><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"vm.card.subscribed\" class=\"card-subscribe s18\" md-font-icon=\"icon-eye\"></md-icon><div class=\"card-name\"><span \neditable-text=\"vm.card.name\">{{vm.card.name}}</span></div></div></div><div ng-if=\"vm.card.due\" class=\"due-date\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"picker day-picker\" moment-picker=\"vm.card.due\" format=\"x\" \nmin-view=\"year\" max-view=\"month\" start-view=\"month\"><div layout=\"row\" layout-align=\"start center\"><i \nclass=\"s18 icon icon-calendar\"></i> <span>{{vm.card.due | date:\'mediumDate\'}}</span></div></div><div \nclass=\"picker hour-picker\" moment-picker=\"vm.card.due\" format=\"x\" min-view=\"day\" max-view=\"hour\" start-view=\"day\"><div \nlayout=\"row\" layout-align=\"start center\"><i class=\"s18 icon icon-clock\"></i> <span>{{vm.card.due | date:\'shortTime\'}}\n</span></div></div><div class=\"remove-due-date\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.card.due = \'\'\">\n<i class=\"s16 icon icon-close\"></i></div></div></div><div class=\"description\"><md-input-container class=\"md-block\">\n<label translate=\"SB.DESCRIPTION\">Description</label><textarea ng-model=\"vm.card.description\" columns=\"1\" \nmd-maxlength=\"150\" max-rows=\"4\"></textarea></md-input-container></div><div class=\"sections\"><div \nng-if=\"vm.card.idLabels[0] || vm.card.idMembers[0]\" class=\"section\" layout=\"row\"><div ng-if=\"vm.card.idLabels[0]\" flex \nclass=\"labels\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-label-outline s18\">\n</i> <span class=\"section-title\" translate=\"SB.LABELS\">Labels</span></div><div class=\"section-content\"><md-chips \nclass=\"label-chips\" ng-model=\"vm.card.idLabels\" md-autocomplete-snap md-require-match=\"true\" \nmd-transform-chip=\"$chip.id\"><md-autocomplete md-selected-item=\"vm.selectedLabel\" md-search-text=\"vm.searchLabelText\" \nmd-items=\"label in vm.labelQuerySearch(vm.searchLabelText)\" md-item-text=\"label.name\" placeholder=\"Search for a label\">\n<span md-highlight-text=\"vm.searchLabelText\">{{label.name}}</span></md-autocomplete><md-chip-template \nclass=\"label-chip\" ng-class=\"\'md-\'+vm.board.labels.getById($chip).color+\'-bg\'\"><span>\n{{vm.board.labels.getById($chip).name}}</span></md-chip-template><button md-chip-remove class=\"md-primary\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s18\"></md-icon></button></md-chips></div></div><div ng-if=\"vm.card.idMembers[0]\" flex \nclass=\"members\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon-account-multiple s18\"></i> <span class=\"section-title\" translate=\"SB.MEMBERS\">Members</span></div><div \nclass=\"section-content\"><md-chips class=\"member-chips\" ng-model=\"vm.card.idMembers\" md-autocomplete-snap \nmd-require-match=\"true\" md-transform-chip=\"$chip.id\"><md-autocomplete md-selected-item=\"vm.selectedMember\" \nmd-search-text=\"vm.searchText\" md-items=\"member in vm.memberQuerySearch(vm.searchText)\" md-item-text=\"member.name\" \nplaceholder=\"Search for a member\"><span md-highlight-text=\"vm.searchText\">{{member.name}}</span></md-autocomplete>\n<md-chip-template class=\"member-chip\"><img class=\"member-chip-avatar\" \nng-src=\"{{vm.board.members.getById($chip).avatar}}\"><md-tooltip>{{vm.board.members.getById($chip).name}}</md-tooltip>\n</md-chip-template><button md-chip-remove class=\"md-primary\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon>\n</button></md-chips></div></div></div><div ng-if=\"vm.card.attachments[0]\" class=\"section\"><div class=\"attachments\"><div\n class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-attachment s18\"></i> <span \nclass=\"section-title\" translate=\"SB.ATTACHMENTS\">Attachments</span></div><div class=\"section-content\"><div \nclass=\"attachment\" ng-repeat=\"item in vm.card.attachments\" ng-switch=\"item.type\"><div ng-switch-when=\"image\" \nlayout=\"row\"><div class=\"attachment-preview md-whiteframe-2dp\" ng-style=\"{\'background-image\': \'url({{item.src}})\'}\">\n</div><div class=\"attachment-content\" layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"attachment-name\">{{item.name}}</span> <i ng-if=\"vm.card.idAttachmentCover === item.id\" \nclass=\"icon-star yellow-700-fg attachment-is-cover s18\"></i></div><span class=\"attachment-time\">{{item.time}}</span>\n<md-menu><md-button class=\"md-raised attachment-actions-button\" ng-click=\"$mdOpenMenu($event)\" \naria-label=\"attachment actions\"><span layout=\"row\" layout-align=\"center center\"><span translate=\"SB.ACTIONS\">Actions\n</span> <i class=\"icon-chevron-down s20\"></i></span></md-button><md-menu-content><md-menu-item><md-button \nng-click=\"vm.toggleCoverImage(item.id)\" aria-label=\"Toggle Cover Image\" translate \ntranslate-attr-aria-label=\"SB.TOGGLE_COVER_IMAGE\"><span ng-if=\"vm.card.idAttachmentCover !== item.id\" translate \ntranslate=\"SB.MAKE_COVER\">Make Cover</span> <span ng-if=\"vm.card.idAttachmentCover === item.id\" translate \ntranslate=\"SB.REMOVE_COVER\">Remove Cover</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.removeAttachment(item)\" aria-label=\"Remove Attachment\" translate \ntranslate-attr-aria-label=\"SB.REMOVE_ATTACHMENT\"><span translate=\"SB.REMOVE_ATTACHMENT\">Remove Attachment</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div></div><div ng-switch-when=\"link\" layout=\"row\"><div \nclass=\"attachment-preview md-whiteframe-2dp\" layout=\"column\" layout-align=\"center center\"><span translate=\"SB.LINK\">\nLINK</span></div><div class=\"attachment-content\" layout=\"column\"><span class=\"attachment-url\">{{item.url}}</span> <span\n class=\"attachment-time\">{{item.time}}</span></div></div></div><md-button class=\"add-attachment-button\" \naria-label=\"add attachment\"><div layout=\"row\" layout-align=\"start center\"><i class=\"icon-plus s20\"></i> <span \ntranslate=\"SB.ADD_AN_ATTACHMENT\">Add an attachment</span></div></md-button></div></div></div><div \nng-if=\"vm.card.checklists\" class=\"section\" ng-repeat=\"checklist in vm.card.checklists\"><div class=\"checklist\"><div \nclass=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-checkbox-marked s18\"></i> <span flex \nclass=\"section-title\" ng-hide=\"editChecklistForm.$visible\">{{checklist.name}}</span> <span flex class=\"section-title\" \neditable-text=\"checklist.name\" ng-show=\"editChecklistForm.$visible\" e-form=\"editChecklistForm\"></span><md-menu \nmd-position-mode=\"target-right target\" class=\"options\"><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"options\" translate translate-attr-aria-label=\"SB.OPTIONS\"><md-icon \nmd-menu-origin md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\">\n<md-menu-item><md-button ng-click=\"editChecklistForm.$show()\" aria-label=\"Edit\" translate \ntranslate-attr-aria-label=\"SB.EDIT\"><md-icon md-font-icon=\"icon-pencil\" class=\"s20\"></md-icon><span \ntranslate=\"SB.EDIT_CHECKLIST\">Edit Checklist</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.removeChecklist(checklist)\" aria-label=\"Remove Checklist\" translate \ntranslate-attr-aria-label=\"SB.REMOVE_CHECKLIST\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"SB.REMOVE_CHECKLIST\">Remove Checklist</span></md-button></md-menu-item></md-menu-content></md-menu></div>\n<div class=\"section-content\"><div class=\"checklist-progress\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"checklist-progress-value\">{{checklist.checkItemsChecked}} / {{checklist.checkItems.length}}</span>\n<md-progress-linear class=\"md-accent checklist-progressbar\" md-mode=\"determinate\" \nvalue=\"{{100 * checklist.checkItemsChecked / checklist.checkItems.length}}\"></md-progress-linear></div><div \nclass=\"check-items\"><div class=\"check-item\" ng-repeat=\"checkItem in checklist.checkItems\" layout=\"row\" \nlayout-align=\"space-between center\"><md-checkbox ng-model=\"checkItem.checked\" \nng-change=\"vm.updateCheckedCount(checklist)\" aria-label=\"{{checkItem.name}}\" ng-hide=\"editCheckItemForm.$visible\">\n{{checkItem.name}}</md-checkbox><span flex editable-text=\"checkItem.name\" ng-show=\"editCheckItemForm.$visible\" \ne-form=\"editCheckItemForm\"></span><md-menu md-position-mode=\"target-right target\" class=\"options\"><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"options\" translate \ntranslate-attr-aria-label=\"SB.OPTIONS\"><md-icon md-menu-origin md-font-icon=\"icon-dots-vertical\" class=\"s20\"></md-icon>\n</md-button><md-menu-content class=\"options-menu-content\"><md-menu-item><md-button \nng-click=\"editCheckItemForm.$show()\" aria-label=\"Edit\" translate translate-attr-aria-label=\"SB.EDIT\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s20\"></md-icon><span translate=\"SB.EDIT\">Edit</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.removeChecklistItem(checkItem, checklist.checkItems)\" aria-label=\"Remove\" \ntranslate translate-attr-aria-label=\"SB.REMOVE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"SB.REMOVE\">Remove</span></md-button></md-menu-item></md-menu-content></md-menu></div></div><form \nname=\"newCheckItemForm\" class=\"new-check-item-form\" \nng-submit=\"vm.addCheckItem(vm[checklist.id].newCheckItem, checklist);vm[checklist.id].newCheckItem = \'\'\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container class=\"no-errors-spacer\" flex><label><i class=\"icon-plus s18\"></i> \n<span translate=\"SB.ADD_AN_ITEM\">Add an item</span></label><input type=\"text\" autocomplete=\"off\" \nng-model=\"vm[checklist.id].newCheckItem\"></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" \naria-label=\"Add\" translate translate-attr-aria-label=\"SB.ADD\"><span translate=\"SB.ADD\">Add</span></md-button></form>\n</div></div></div><div class=\"section\"><div class=\"comments\"><div class=\"section-header\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-comment s18\"></i> <span class=\"section-title\" translate=\"SB.COMMENTS\">\nComments</span></div><div class=\"section-content\"><form name=\"cardCommentForm\" \nng-submit=\"vm.addNewComment(vm.newCommentText); vm.newCommentText =\'\'\" class=\"comment new-comment\" layout=\"column\" \nlayout-align=\"start\" no-validate><div layout=\"row\"><img class=\"comment-member-avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-input-container flex md-no-float><textarea placeholder=\"Write a comment..\" \nng-model=\"vm.newCommentText\" required max-rows=\"4\" translate translate-attr-placeholder=\"SB.WRITE_A_COMMENT\">\n</textarea></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent\" ng-disabled=\"cardCommentForm.$invalid || cardCommentForm.$pristine\" aria-label=\"Add\"><span \ntranslate=\"SB.ADD\">Add</span></md-button></div></form><div class=\"comment\" layout=\"row\" \nng-repeat=\"comment in vm.card.comments\"><img class=\"comment-member-avatar\" \nng-src=\"{{vm.board.members.getById(comment.idMember).avatar}}\"><div layout=\"column\"><div class=\"comment-member-name\">\n{{vm.board.members.getById(comment.idMember).name}}</div><div class=\"comment-bubble\">{{comment.message}}</div><div \nclass=\"comment-time secondary-text\">{{comment.time}}</div></div></div></div></div></div><div \nng-if=\"vm.card.activities[0]\" class=\"section\"><div class=\"activities\"><div class=\"section-header\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-format-list-bulleted s18\"></i> <span class=\"section-title\" \ntranslate=\"SB.ACTIVITY\">Activity</span></div><div class=\"section-content\"><div class=\"activity\" layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"activity in vm.card.activities\"><img class=\"activity-member-avatar\" \nng-src=\"{{vm.board.members.getById(activity.idMember).avatar}}\"><div class=\"activity-member-name\">\n{{vm.board.members.getById(activity.idMember).name}}</div><div class=\"activity-message\">{{activity.message}}</div><div \nclass=\"activity-time secondary-text\">{{activity.time}}</div></div></div></div></div></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/apps/scrumboard/directives/ms-sb-add-card/ms-sb-add-card.html","<div class=\"ms-sb-add-card-button\" layout=\"row\" layout-align=\"start center\" ng-hide=\"formActive\"><div><i \nclass=\"icon-plus s20\"></i></div><span translate=\"SB.ADD_A_CARD\">Add a card</span></div><div \nclass=\"ms-sb-add-card-form-wrapper\" ng-hide=\"!formActive\"><form ng-submit=\"vm.addNewCard()\" \nclass=\"ms-sb-add-card-form\" layout=\"column\"><md-input-container flex md-no-float><input placeholder=\"Card title\" \ntype=\"text\" autocomplete=\"off\" ng-model=\"vm.newCardName\" translate-attr-placeholder=\"SB.CARD_TITLE\">\n</md-input-container><div layout=\"row\" layout-align=\"space-between center\"><md-button type=\"submit\" \nclass=\"add-button md-accent md-raised\" aria-label=\"add\" translate-attr-aria-label=\"SB.ADD\"><span translate=\"SB.ADD\">Add\n</span></md-button><md-button ng-click=\"toggleForm()\" class=\"cancel-button md-icon-button\" aria-label=\"cancel\" \ntranslate-attr-aria-label=\"SB.CANCEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></form></div>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><span flex \nclass=\"menu-title\" translate=\"SB.FILTER_CARDS\">Filter Cards</span><md-button ng-if=\"vm.filteringIsOn()\" \nng-click=\"vm.clearFilters()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"SB.CLEAR_FILTER\">Clear Filters</span>\n</md-tooltip></md-button></div></md-toolbar><md-content class=\"\" ms-scroll><md-list><md-subheader class=\"md-no-sticky\" \ntranslate=\"SB.FILTER_BY_CARD_NAME\">Filter by Card Name</md-subheader><md-list-item><input flex \nplaceholder=\"Type Card Name\" type=\"text\" ng-model=\"vm.cardFilters.name\" translate \ntranslate-attr-placeholder=\"SB.TYPE_CARD_NAME\"></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\" translate=\"SB.FILTER_BY_LABELS\">Filter by Labels</md-subheader><md-list-item class=\"label\" \nng-repeat=\"label in vm.labels\" ng-click=\"vm.toggleInArray(label.id, vm.cardFilters.labels)\"><md-icon \nmd-font-icon=\"icon-label\" ng-class=\"label.color+\'-fg\'\" class=\"label-icon\"></md-icon><p>{{label.name}}</p><i \nclass=\"icon-check s16\" ng-if=\"vm.exists(label.id, vm.cardFilters.labels)\"></i></md-list-item><md-divider></md-divider>\n<md-subheader class=\"md-no-sticky\" translate=\"SB.FILTER_BY_MEMBERS\">Filter by Members</md-subheader><md-list-item \nclass=\"member\" ng-repeat=\"member in vm.members\" ng-click=\"vm.toggleInArray(member.id, vm.cardFilters.members)\" \naria-label=\"Toggle Member\"><img alt=\"{{ member.name }}\" ng-src=\"{{ member.avatar }}\" class=\"md-avatar\"><p \nclass=\"member-name\">{{ member.name }}</p><i class=\"icon-check s16\" \nng-if=\"vm.exists(member.id, vm.cardFilters.members)\"></i></md-list-item></md-list></md-content>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/settings/settings-sidenav.html","<md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><md-button \nng-hide=\"vm.selectedMenu === \'Settings\'\" class=\"md-icon-button\" ng-click=\"vm.selectedMenu = \'Settings\'\" \naria-label=\"back\" translate translate-attr-aria-label=\"SB.BACK\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button><span flex class=\"menu-title\">{{vm.selectedMenu}}</span></div></md-toolbar><md-content \nng-show=\"vm.selectedMenu === \'Settings\'\" class=\"animate-slide-right settings\" ms-scroll ms-sidenav-helper><md-list>\n<md-list-item class=\"item\" ng-click=\"vm.selectedMenu = \'Board Color\'\"><md-icon md-font-icon=\"icon-format-color-fill\" \nclass=\"s18\"></md-icon><p class=\"title\" translate=\"SB.BOARD_COLOR\">Board Color</p></md-list-item><md-list-item \nclass=\"item\" ng-click=\"vm.board.settings.cardCoverImages = !vm.board.settings.cardCoverImages\"><md-icon \nmd-font-icon=\"icon-image-area\" class=\"s18\"></md-icon><p flex class=\"title\" translate=\"SB.CARD_COVER_IMAGES\">\nCard Cover Images</p><md-icon ng-show=\"vm.board.settings.cardCoverImages\" md-font-icon=\"icon-check\" class=\"s18\">\n</md-icon></md-list-item><md-list-item class=\"item\" \nng-click=\"vm.board.settings.subscribed = !vm.board.settings.subscribed\"><md-icon md-font-icon=\"icon-eye\" class=\"s18\">\n</md-icon><p flex class=\"title\" translate=\"SB.SUBSCRIBE\">Subscribe</p><md-icon ng-show=\"vm.board.settings.subscribed\" \nmd-font-icon=\"icon-check\" class=\"s18\"></md-icon></md-list-item><md-list-item class=\"item\"><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"s18\"></md-icon><p class=\"title\" translate=\"SB.COPY_BOARD\">Copy Board</p>\n</md-list-item><md-list-item class=\"item\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon><p class=\"title\" \ntranslate=\"SB.DELETE_BOARD\">Delete Board</p></md-list-item><md-divider></md-divider><md-list-item class=\"item\" \nng-click=\"vm.selectedMenu = \'Labels\'\" aria-label=\"inbox\"><md-icon md-font-icon=\"icon-label\" class=\"s18\"></md-icon><p \nclass=\"title\" translate=\"SB.LABELS\">Labels</p></md-list-item><md-list-item class=\"item\" \nng-click=\"vm.selectedMenu = \'Members\'\" aria-label=\"inbox\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"s18\">\n</md-icon><p class=\"title\" translate=\"SB.MEMBERS\">Members</p></md-list-item></md-list></md-content><md-content \nng-show=\"vm.selectedMenu === \'Board Color\'\" class=\"animate-slide-left board-color-selection\"><div layout=\"column\" \nlayout-fill ng-include=\"\'app/main/apps/scrumboard/sidenavs/settings/menus/color/color-menu.html\'\" \nng-controller=\"ColorMenuController as vm\"></div></md-content><md-content ng-show=\"vm.selectedMenu === \'Labels\'\" \nclass=\"animate-slide-left labels\"><div layout=\"column\" layout-fill \nng-include=\"\'app/main/apps/scrumboard/sidenavs/settings/menus/labels/labels-menu.html\'\" \nng-controller=\"LabelsMenuController as vm\"></div></md-content><md-content ng-show=\"vm.selectedMenu === \'Members\'\" \nclass=\"animate-slide-left members\"><div layout=\"column\" layout-fill \nng-include=\"\'app/main/apps/scrumboard/sidenavs/settings/menus/members/members-menu.html\'\" \nng-controller=\"MembersMenuController as vm\"></div></md-content>");
$templateCache.put("app/main/apps/scrumboard/views/board/board-view.html","<textarea>{{vm.board}}</textarea><div id=\"board\" ng-class=\"vm.board.settings.color+\'-100-bg\'\" \nui-sortable=\"vm.sortableListOptions\" ng-model=\"vm.board.lists\" layout=\"row\"><div class=\"list-wrapper\" \nng-repeat=\"list in vm.board.lists track by list.id\"><div class=\"list md-whiteframe-1dp\" layout=\"column\"><div \nclass=\"list-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"list-header-name\"><span \neditable-text=\"list.name\">{{list.name}}</span></div><md-menu md-offset=\"0 48px\" \nclass=\"options list-header-option-button\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" \naria-label=\"Options\" translate translate-attr-aria-label=\"SB.OPTIONS\"><md-icon md-menu-origin \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" width=\"4\">\n<md-menu-item><md-button ng-click=\"vm.removeList($event,list)\" aria-label=\"Remove List\" translate \ntranslate-attr-aria-label=\"SB.REMOVE_LIST\"><md-icon md-font-icon=\"icon-delete\" md-menu-align-target></md-icon><span \ntranslate=\"SB.REMOVE_LIST\">Remove List</span></md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"list-content\" layout=\"column\"><div class=\"list-cards\" ui-sortable=\"vm.sortableCardOptions\" \nng-model=\"list.idCards\" ms-scroll><div ng-if=\"cardId\" class=\"list-card md-whiteframe-2dp\" \nng-repeat=\"cardId in list.idCards | filter: vm.cardFilter track by $index\" \nng-click=\"vm.openCardDialog($event, cardId)\"><div \nng-if=\"vm.board.settings.cardCoverImages && vm.board.cards.getById(cardId).idAttachmentCover\" class=\"list-card-cover\">\n<img \nng-src=\"{{vm.board.cards.getById(cardId).attachments.getById(vm.board.cards.getById(cardId).idAttachmentCover).src}}\">\n</div><div class=\"list-card-details\"><div class=\"list-card-sort-handle\"><md-icon md-font-icon=\"icon-cursor-move\" \nclass=\"icon s16\"></md-icon></div><div ng-if=\"vm.board.cards.getById(cardId).idLabels.length > 0\" \nclass=\"list-card-labels\" layout=\"row\" layout-wrap><span class=\"list-card-label\" \nng-class=\"\'md-\'+vm.board.labels.getById(labelId).color+\'-bg\'\" \nng-repeat=\"labelId in vm.board.cards.getById(cardId).idLabels\"><md-tooltip>{{vm.board.labels.getById(labelId).name}}\n</md-tooltip></span></div><div class=\"list-card-name\">{{vm.board.cards.getById(cardId).name}}</div><div \nng-if=\"vm.board.cards.getById(cardId).due || vm.board.cards.getById(cardId).checkItems\" class=\"list-card-badges\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"badge due-date\" \nng-class=\"{\'overdue\': vm.isOverdue(vm.board.cards.getById(cardId).due)}\" ng-if=\"vm.board.cards.getById(cardId).due\" \nlayout=\"row\" layout-align=\"start center\"><i class=\"icon-clock s16\"></i> <span>\n{{vm.board.cards.getById(cardId).due | date:\'mediumDate\'}}</span> </span><span \nng-if=\"vm.board.cards.getById(cardId).checkItems\" class=\"badge check-items\" \nng-class=\"{\'completed\': vm.board.cards.getById(cardId).checkItemsChecked === vm.board.cards.getById(cardId).checkItems}\" \nlayout=\"row\" layout-align=\"start center\"><i class=\"icon-checkbox-marked-circle s16\"></i> <span>\n{{vm.board.cards.getById(cardId).checkItemsChecked}}</span> <span>/</span> <span>\n{{vm.board.cards.getById(cardId).checkItems}}</span></span></div><div \nng-if=\"vm.board.cards.getById(cardId).idMembers.length > 0\" class=\"list-card-members\" layout=\"row\"><div \nclass=\"list-card-member\" ng-repeat=\"memberId in vm.board.cards.getById(cardId).idMembers\"><img \nclass=\"list-card-member-avatar\" ng-src=\"{{vm.board.members.getById(memberId).avatar}}\"><md-tooltip><div class=\"name\">\n{{ vm.board.members.getById(memberId).name}}</div></md-tooltip></div></div></div><div class=\"list-card-footer\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span \nng-if=\"vm.board.cards.getById(cardId).subscribed\" class=\"list-card-footer-item\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-eye s18\"></i> </span><span \nng-if=\"vm.board.cards.getById(cardId).description !== \'\'\" class=\"list-card-footer-item\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-document s18\"></i></span></div><div layout=\"row\" layout-align=\"end center\">\n<span class=\"list-card-footer-item\" ng-if=\"vm.board.cards.getById(cardId).attachments\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-attachment s18\"></i> <span class=\"value\">\n{{vm.board.cards.getById(cardId).attachments.length}}</span> </span><span class=\"list-card-footer-item\" \nng-if=\"vm.board.cards.getById(cardId).comments\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-comment s18\">\n</i> <span class=\"value\">{{vm.board.cards.getById(cardId).comments.length}}</span></span></div></div></div></div></div>\n<div class=\"list-footer\"><ms-sb-add-card ms-list-id=\"list.id\"></ms-sb-add-card></div></div></div><div \nclass=\"new-list-wrapper\"><div class=\"list new-list md-whiteframe-1dp\"><span editable-text=\"vm.newListName\" \ne-form=\"newListForm\" onaftersave=\"vm.addNewList()\"></span><md-button class=\"new-list-form-button\" \nng-click=\"newListForm.$show()\" ng-hide=\"newListForm.$visible\"><div layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon-plus md-red-bg\"></i> <span translate=\"SB.ADD_A_LIST\">Add a list</span></div></md-button></div></div></div>");
$templateCache.put("app/main/apps/scrumboard/views/boards/boards-view.html","<div id=\"boards\" class=\"md-accent-bg\" layout=\"column\" flex><div id=\"board-selector\" layout=\"column\" \nlayout-align=\"start center\" flex><h1 translate=\"SB.SCRUMBOARD_APP\">Scrumboard App</h1><div class=\"board-list\" \nlayout=\"row\" layout-align=\"center center\" layout-wrap><div class=\"board-list-item\" ng-repeat=\"board in vm.boardList\" \nui-sref=\"app.scrumboard.boards.board({id:board.id, uri:board.uri})\" layout=\"column\" layout-align=\"center center\">\n<md-icon md-font-icon=\"icon-trello\" class=\"icon s64\"></md-icon><div class=\"board-name\">{{board.name}}</div></div><div \nclass=\"board-list-item add-new-board\" layout=\"column\" layout-align=\"center center\" \nui-sref=\"app.scrumboard.boards.addBoard\"><md-icon md-font-icon=\"icon-plus-circle\" class=\"icon s64\"></md-icon><div \nclass=\"board-name\" translate=\"SB.ADD_NEW_BOARD\">Add new board</div></div></div></div></div>");
$templateCache.put("app/main/apps/scrumboard/views/calendar/calendar-view.html","<div id=\"board-calendar\" class=\"page-layout simple right-sidenav\" flex layout=\"row\" \nng-class=\"vm.board.settings.color+\'-100-bg\'\"><md-sidenav class=\"sidenav scheduled-tasks-sidenav md-sidenav-left\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"scheduled-tasks-sidenav\" \nng-include=\"\'app/main/apps/scrumboard/views/calendar/sidenavs/scheduled-tasks/scheduled-tasks-sidenav.html\'\" ms-scroll \nms-sidenav-helper></md-sidenav><div id=\"calendar\" class=\"md-whiteframe-2dp\" flex layout=\"column\" \nng-class=\"vm.currentMonthShort\"><div class=\"calendar-header\" layout=\"row\" layout-align=\"space-between center\" \nlayout-xs=\"column\"><md-button hide-gt-md class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'scheduled-tasks-sidenav\')\" \naria-label=\"Scheduled Cards Sidenav\"><md-icon md-font-icon=\"icon-calendar-clock\"></md-icon><md-tooltip><span \ntranslate=\"SB.SCHEDULED_CARDS\">Scheduled Cards</span></md-tooltip></md-button><div class=\"\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" \naria-label=\"Previous\" translate translate-attr-aria-label=\"SB.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon></md-button><div class=\"title\">{{vm.calendarView.title}}</div><md-button class=\"md-icon-button arrow\" \nng-click=\"vm.calendar.next()\" aria-label=\"Next\" translate translate-attr-aria-label=\"SB.NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div><div><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.today()\" aria-label=\"Today\" translate translate-attr-aria-label=\"SB.TODAY\"><md-icon \nmd-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip><span translate=\"SB.TODAY\">Today</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" \ntranslate translate-attr-aria-label=\"SB.DAY\"><md-icon md-font-icon=\"icon-view-day\"></md-icon><md-tooltip><span \ntranslate=\"SB.DAY\">Day</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'agendaWeek\')\" aria-label=\"Week\" translate translate-attr-aria-label=\"SB.WEEK\">\n<md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip><span translate=\"SB.WEEK\">Week</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"Month\" translate \ntranslate-attr-aria-label=\"SB.MONTH\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span \ntranslate=\"SB.MONTH\">Month</span></md-tooltip></md-button></div></div><div class=\"calendar-main\" ms-scroll flex \nui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.eventSources\" calendar=\"main\"></div></div></div>");
$templateCache.put("app/main/pages/go/templates/departments/bracketmovement.html","<md-dialog aria-label=\"Bracket Movement\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"pctrl.bracketmovement.orders_id\" \nng-init=\"pctrl.bracketmovement.orders_id=id\"> <input type=\"hidden\" \nng-if=\"pctrl.bracketmovement.orders_bracket_movement_id\" ng-model=\"pctrl.bracketmovement.orders_bracket_movement_id\" \nng-init=\"pctrl.bracketmovement.orders_bracket_movement_id=pctrl.bracketmovement.orders_bracket_movement_id\"> <input \ntype=\"hidden\" ng-if=\"!pctrl.bracketmovement.orders_bracket_movement_id\" \nng-model=\"pctrl.bracketmovement.orders_bracket_movement_id\" \nng-init=\"pctrl.bracketmovement.orders_bracket_movement_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nBracket Movement</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"center center\"><div \nflex-xs flex=\"50\" layout=\"column\"><h3>Upper</h3><md-input-container flex \nmd-is-error=\"recordForm.upnumbrackets.$invalid && (recordForm.upnumbrackets.$touched || recordForm.$submitted)\" \nclass=\"md-block\"><label>No of Brackets</label><md-select ng-model=\"pctrl.bracketmovement.upnumbrackets\"><md-option \nvalue=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4\n</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option>\n<md-option value=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option><md-option \nvalue=\"11\">11</md-option><md-option value=\"12\">12</md-option><md-option value=\"13\">13</md-option><md-option value=\"14\">\n14</md-option><md-option value=\"15\">15</md-option><md-option value=\"16\">16</md-option></md-select><div \nng-messages=\"recordForm.upnumbrackets.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please choose an option.\n</span></div></div></md-input-container><h3>Stents</h3><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" \nname=\"stentsup\" ng-model=\"pctrl.bracketmovement.stentsup\" value=\"0\" aria-label=\"No\">No <input type=\"radio\" \nname=\"stentsup\" ng-model=\"pctrl.bracketmovement.stentsup\" value=\"1\" aria-label=\"Yes\">Yes</div><div layout=\"row\" \nclass=\"md-padding\"><input type=\"radio\" name=\"treatmentplan\" ng-model=\"pctrl.bracketmovement.treatmentplan\" value=\"1\" \naria-label=\"Treatment Plan\">Treatment Plan</div></div><div flex-xs flex=\"50\" layout=\"column\"><h3>Lower</h3>\n<md-input-container flex \nmd-is-error=\"recordForm.lownumbrackets.$invalid && (recordForm.lownumbrackets.$touched || recordForm.$submitted)\" \nclass=\"md-block\"><label>No of Brackets</label><md-select ng-model=\"pctrl.bracketmovement.lownumbrackets\"><md-option \nvalue=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4\n</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option>\n<md-option value=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option><md-option \nvalue=\"11\">11</md-option><md-option value=\"12\">12</md-option><md-option value=\"13\">13</md-option><md-option value=\"14\">\n14</md-option><md-option value=\"15\">15</md-option><md-option value=\"16\">16</md-option></md-select><div \nng-messages=\"recordForm.lownumbrackets.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please choose an option.\n</span></div></div></md-input-container><h3>Stents</h3><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" \nname=\"stentslow\" ng-model=\"pctrl.bracketmovement.stentslow\" value=\"0\" aria-label=\"No\">No <input type=\"radio\" \nname=\"stentslow\" ng-model=\"pctrl.bracketmovement.stentslow\" value=\"1\" aria-label=\"Yes\">Yes</div><div layout=\"row\" \nclass=\"md-padding\"><input type=\"radio\" name=\"treatmentplan\" ng-model=\"pctrl.bracketmovement.treatmentplan\" value=\"2\" \naria-label=\"Treatment Plan\">Treatment Plan</div></div></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(pctrl.bracketmovement)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/templates/departments/caseassessment.html","<md-dialog aria-label=\"Case Assessment\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"pctrl.caseassessment.orders_id\" ng-init=\"pctrl.caseassessment.orders_id=id\"> \n<input type=\"hidden\" ng-if=\"pctrl.caseassessment.orders_case_assessment_id\" \nng-model=\"pctrl.caseassessment.orders_case_assessment_id\" \nng-init=\"pctrl.caseassessment.orders_case_assessment_id=pctrl.caseassessment.orders_case_assessment_id\"> <input \ntype=\"hidden\" ng-if=\"!pctrl.caseassessment.orders_case_assessment_id\" \nng-model=\"pctrl.caseassessment.orders_case_assessment_id\" ng-init=\"pctrl.caseassessment.orders_case_assessment_id=\'0\'\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2>Case Assessment</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" \nlayout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\"><input type=\"radio\" \nng-model=\"pctrl.caseassessment.upperlower\" name=\"upperlower\" value=\"1\" aria-label=\"Upper\">Upper</div>\n<md-input-container flex><label>Comments</label><textarea rows=\"5\" name=\"commentsupper\" \nng-model=\"pctrl.caseassessment.commentsupper\" ng-disabled=\"pctrl.caseassessment.upperlower!=\'1\'\"></textarea>\n</md-input-container><div layout=\"row\"><input type=\"radio\" name=\"treatmentplan\" \nng-model=\"pctrl.caseassessment.treatmentplan\" value=\"1\" aria-label=\"Treatment Plan\">Treatment Plan</div></div><div \nflex-xs flex=\"50\" layout=\"column\"><div layout=\"row\"><input type=\"radio\" name=\"upperlower\" \nng-model=\"pctrl.caseassessment.upperlower\" value=\"2\" aria-label=\"Lower\">Lower</div><md-input-container flex><label>\nComments</label><textarea rows=\"5\" name=\"commentslower\" ng-model=\"pctrl.caseassessment.commentslower\" \nng-disabled=\"pctrl.caseassessment.upperlower!=\'2\'\"></textarea></md-input-container><div layout=\"row\"><input \ntype=\"radio\" name=\"treatmentplan\" ng-model=\"pctrl.caseassessment.treatmentplan\" value=\"2\" aria-label=\"Treatment Plan\">\nTreatment Plan</div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" \nng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(pctrl.caseassessment)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/templates/departments/clearmanufacturing.html","<md-dialog aria-label=\"Clear Appliances Manufacturing\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" \nng-model=\"pctrl.clearmanufacturing.orders_id\" ng-init=\"pctrl.clearmanufacturing.orders_id=id\"> <input type=\"hidden\" \nng-if=\"pctrl.clearmanufacturing.orders_clear_manufacturing_id\" \nng-model=\"pctrl.clearmanufacturing.orders_clear_manufacturing_id\" \nng-init=\"pctrl.clearmanufacturing.orders_clear_manufacturing_id=pctrl.clearmanufacturing.orders_clear_manufacturing_id\">\n <input type=\"hidden\" ng-if=\"!pctrl.clearmanufacturing.orders_clear_manufacturing_id\" \nng-model=\"pctrl.clearmanufacturing.orders_clear_manufacturing_id\" \nng-init=\"pctrl.clearmanufacturing.orders_clear_manufacturing_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nClear Appliances Manufacturing</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><fieldset><legend><h3>Clear Aligners</h3></legend><div \nlayout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><h4>Upper</h4><md-input-container \nflex md-is-error=\"recordForm.upnumclear.$invalid && (recordForm.upnumclear.$touched || recordForm.$submitted)\" \nclass=\"md-block\"><label>No. of Clear Aligners</label><md-select ng-model=\"pctrl.clearmanufacturing.upnumclear\">\n<md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option \nvalue=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7\n</md-option><md-option value=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option>\n<md-option value=\"11\">11</md-option><md-option value=\"12\">12</md-option><md-option value=\"13\">13</md-option><md-option \nvalue=\"14\">14</md-option><md-option value=\"15\">15</md-option><md-option value=\"16\">16</md-option><md-option value=\"17\">\n17</md-option><md-option value=\"18\">18</md-option><md-option value=\"19\">19</md-option><md-option value=\"20\">20\n</md-option></md-select><div ng-messages=\"recordForm.upnumclear.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease choose an option.</span></div></div></md-input-container><md-input-container flex \nmd-is-error=\"recordForm.upnumtrays.$invalid && (recordForm.upnumtrays.$touched || recordForm.$submitted)\" \nclass=\"md-block\"><label>No. of Trays</label><md-select ng-model=\"pctrl.clearmanufacturing.upnumtrays\"><md-option \nvalue=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4\n</md-option><md-option value=\"5\">5</md-option></md-select><div ng-messages=\"recordForm.upnumtrays.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Please choose an option.</span></div></div></md-input-container><h4>Stents</h4><div \nlayout=\"row\" class=\"md-padding\"><input type=\"radio\" name=\"upstents\" ng-model=\"pctrl.clearmanufacturing.upstents\" \nvalue=\"0\" aria-label=\"No\">No <input type=\"radio\" name=\"upstents\" ng-model=\"pctrl.clearmanufacturing.upstents\" \nvalue=\"1\" aria-label=\"Yes\">Yes</div><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" name=\"treatmentplan\" \nng-model=\"pctrl.clearmanufacturing.treatmentplan\" value=\"1\" aria-label=\"Treatment Plan\">Treatment Plan</div></div><div \nflex-xs flex=\"50\" layout=\"column\"><h4>Upper</h4><md-input-container flex class=\"md-block\"><label>No. of Clear Aligners\n</label><md-select ng-model=\"pctrl.clearmanufacturing.lownumclear\"><md-option value=\"1\">1</md-option><md-option \nvalue=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5\n</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option>\n<md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option><md-option value=\"11\">11</md-option><md-option \nvalue=\"12\">12</md-option><md-option value=\"13\">13</md-option><md-option value=\"14\">14</md-option><md-option value=\"15\">\n15</md-option><md-option value=\"16\">16</md-option><md-option value=\"17\">17</md-option><md-option value=\"18\">18\n</md-option><md-option value=\"19\">19</md-option><md-option value=\"20\">20</md-option></md-select><div \nng-messages=\"recordForm.lownumclear.$error\" role=\"alert\"><div ng-message=\"required\"><span>Please choose an option.\n</span></div></div></md-input-container><md-input-container flex class=\"md-block\"><label>No. of Trays</label><md-select\n ng-model=\"pctrl.clearmanufacturing.lownumtrays\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option>\n<md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option></md-select>\n</md-input-container><h4>Stents</h4><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" name=\"stentslow\" \nng-model=\"pctrl.clearmanufacturing.stentslow\" value=\"0\" aria-label=\"No\">No <input type=\"radio\" name=\"stentslow\" \nng-model=\"pctrl.clearmanufacturing.stentslow\" value=\"1\" aria-label=\"Yes\">Yes</div><div layout=\"row\" class=\"md-padding\">\n<input type=\"radio\" name=\"treatmentplan\" ng-model=\"pctrl.clearmanufacturing.treatmentplan\" value=\"2\" \naria-label=\"Treatment Plan\">Treatment Plan</div></div></div></fieldset><fieldset><legend><h3>Bonded Fixed Retainer</h3>\n</legend><div layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" \nclass=\"md-padding\"><input type=\"radio\" name=\"bondedupperlower\" ng-model=\"pctrl.clearmanufacturing.bondedupperlower\" \nvalue=\"1\" aria-label=\"Upper\">Upper</div></div><div flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" \nclass=\"md-padding\"><input type=\"radio\" name=\"bondedupperlower\" ng-model=\"pctrl.clearmanufacturing.bondedupperlower\" \nvalue=\"2\" aria-label=\"Lower\">Lower</div></div></div></fieldset><fieldset><legend><h3>Essix Retainer</h3></legend><div \nlayout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-input-container flex \nclass=\"md-block\"><label>No. of Essix</label><md-select ng-model=\"pctrl.clearmanufacturing.upnumessix\"><md-option \nvalue=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option></md-select>\n</md-input-container></div><div flex-xs flex=\"50\" layout=\"column\"><md-input-container flex class=\"md-block\"><label>\nNo. of Essix</label><md-select ng-model=\"pctrl.clearmanufacturing.lownumessix\"><md-option value=\"1\">1</md-option>\n<md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option></md-select></md-input-container></div></div>\n</fieldset><fieldset><legend><h3>Brackets</h3></legend><div layout=\"row\" layout-align=\"center center\"><div flex-xs \nflex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" name=\"bracketsupperlower\" \nng-model=\"pctrl.clearmanufacturing.bracketsupperlower\" value=\"1\" aria-label=\"Upper\">Upper</div></div><div flex-xs \nflex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" name=\"bracketsupperlower\" \nng-model=\"pctrl.clearmanufacturing.bracketsupperlower\" value=\"2\" aria-label=\"Lower\">Lower</div></div></div></fieldset>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button>\n<md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(pctrl.clearmanufacturing)\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/go/templates/departments/clearmovement.html","<md-dialog aria-label=\"Case Movement\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"pctrl.clearmovement.orders_id\" ng-init=\"pctrl.clearmovement.orders_id=id\"> \n<input type=\"hidden\" ng-if=\"pctrl.clearmovement.orders_clear_movement_id\" \nng-model=\"pctrl.clearmovement.orders_clear_movement_id\" \nng-init=\"pctrl.clearmovement.orders_clear_movement_id=pctrl.clearmovement.orders_clear_movement_id\"> <input \ntype=\"hidden\" ng-if=\"!pctrl.clearmovement.orders_clear_movement_id\" \nng-model=\"pctrl.clearmovement.orders_clear_movement_id\" ng-init=\"pctrl.clearmovement.orders_clear_movement_id=\'0\'\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2>Case Movement</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" \nlayout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><h3>Upper</h3><md-input-container flex \nmd-is-error=\"recordForm.upnummodels.$invalid && (recordForm.upnummodels.$touched || recordForm.$submitted)\" \nclass=\"md-block\"><label>No of Models Generated</label><md-select ng-model=\"pctrl.clearmovement.upnummodels\"><md-option \nvalue=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4\n</md-option><md-option value=\"5\">5</md-option></md-select><div ng-messages=\"recordForm.upnummodels.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Please choose an option.</span></div></div></md-input-container><h3>\nStents</h3><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" name=\"stentsup\" \nng-model=\"pctrl.clearmovement.stentsup\" value=\"0\" aria-label=\"No\">No <input type=\"radio\" name=\"stentsup\" \nng-model=\"pctrl.clearmovement.stentsup\" value=\"1\" aria-label=\"Yes\">Yes</div><div layout=\"row\" class=\"md-padding\"><input\n type=\"radio\" name=\"treatmentplan\" ng-model=\"pctrl.clearmovement.treatmentplan\" value=\"1\" aria-label=\"Treatment Plan\">\nTreatment Plan</div></div><div flex-xs flex=\"50\" layout=\"column\"><h3>Lower</h3><md-input-container flex \nmd-is-error=\"recordForm.lownummodels.$invalid && (recordForm.lownummodels.$touched || recordForm.$submitted)\" \nclass=\"md-block\"><label>No of Models Generated</label><md-select ng-model=\"pctrl.clearmovement.lownummodels\"><md-option\n value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4\n</md-option><md-option value=\"5\">5</md-option></md-select><div ng-messages=\"recordForm.lownummodels.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Please choose an option.</span></div></div></md-input-container><h3>\nStents</h3><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" name=\"stentslow\" \nng-model=\"pctrl.clearmovement.stentslow\" value=\"0\" aria-label=\"No\">No <input type=\"radio\" name=\"stentslow\" \nng-model=\"pctrl.clearmovement.stentslow\" value=\"1\" aria-label=\"Yes\">Yes</div><div layout=\"row\" class=\"md-padding\">\n<input type=\"radio\" name=\"treatmentplan\" ng-model=\"pctrl.clearmovement.treatmentplan\" value=\"2\" \naria-label=\"Treatment Plan\">Treatment Plan</div></div></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(pctrl.clearmovement)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/templates/departments/designing.html","<md-dialog aria-label=\"Designing\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"pctrl.designing.orders_id\" ng-init=\"pctrl.designing.orders_id=id\"> <input \ntype=\"hidden\" ng-if=\"pctrl.designing.orders_designing_id\" ng-model=\"pctrl.designing.orders_designing_id\" \nng-init=\"pctrl.designing.orders_designing_id=pctrl.designing.orders_designing_id\"> <input type=\"hidden\" \nng-if=\"!pctrl.designing.orders_designing_id\" ng-model=\"pctrl.designing.orders_designing_id\" \nng-init=\"pctrl.designing.orders_designing_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Designing</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\">\n<h3>Upper</h3><h4>Type of Work</h4><md-checkbox ng-model=\"pctrl.designing.upsplint\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Splint\">Splint</md-checkbox><md-checkbox ng-model=\"pctrl.designing.upjigs\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Jigs\">Jigs</md-checkbox><md-checkbox \nng-model=\"pctrl.designing.upnimrodret\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"NimrodRetainer\">NimrodRetainer\n</md-checkbox><md-checkbox ng-model=\"pctrl.designing.upnimrodali\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"NimrodAligner\">NimrodAligner</md-checkbox><md-checkbox ng-model=\"pctrl.designing.upstudymodels\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Study Models\">Study Models</md-checkbox><md-checkbox \nng-model=\"pctrl.designing.upimplant\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Implant Guides\">Implant Guides\n</md-checkbox><md-checkbox ng-model=\"pctrl.designing.upextras\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Extras\">\nExtras</md-checkbox></div><div flex-xs flex=\"50\" layout=\"column\"><h3>Lower</h3><h4>Type of Work</h4><md-checkbox \nng-model=\"pctrl.designing.lowsplint\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Splint\">Splint</md-checkbox>\n<md-checkbox ng-model=\"pctrl.designing.lowjigs\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Jigs\">Jigs\n</md-checkbox><md-checkbox ng-model=\"pctrl.designing.lownimrodret\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"NimrodRetainer\">NimrodRetainer</md-checkbox><md-checkbox ng-model=\"pctrl.designing.lownimrodali\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"NimrodAligner\">NimrodAligner</md-checkbox><md-checkbox \nng-model=\"pctrl.designing.lowstudymodels\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Study Models\">Study Models\n</md-checkbox><md-checkbox ng-model=\"pctrl.designing.lowimplant\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Implant Guides\">Implant Guides</md-checkbox><md-checkbox ng-model=\"pctrl.designing.lowextras\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Extras\">Extras</md-checkbox></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button \nclass=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"recordForm.$valid && gravar(pctrl.designing)\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/templates/departments/drillingassembly.html","<md-dialog aria-label=\"Drilling Guide Assembly\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"pctrl.driassembly.orders_id\" \nng-init=\"pctrl.driassembly.orders_id=id\"> <input type=\"hidden\" ng-if=\"pctrl.driassembly.orders_drillingassembly_id\" \nng-model=\"pctrl.driassembly.orders_drillingassembly_id\" \nng-init=\"pctrl.driassembly.orders_drillingassembly_id=pctrl.driassembly.orders_drillingassembly_id\"> <input \ntype=\"hidden\" ng-if=\"!pctrl.driassembly.orders_drillingassembly_id\" \nng-model=\"pctrl.driassembly.orders_drillingassembly_id\" ng-init=\"pctrl.driassembly.orders_drillingassembly_id=\'0\'\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2>Drilling Guide Assembly</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-padding\"><div layout=\"row\" layout-align=\"center center\"><div flex-xs \nflex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" \nng-model=\"pctrl.driassembly.upperlower\" name=\"upperlower\" value=\"1\" aria-label=\"Upper\">Upper</div></div><div flex-xs \nflex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" \nng-model=\"pctrl.driassembly.upperlower\" name=\"upperlower\" value=\"2\" aria-label=\"Lower\">Lower</div></div></div><div \nlayout=\"row\" layout-align=\"center center\"><md-input-container flex \nmd-is-error=\"recordForm.numbersleeves.$invalid && (recordForm.numbersleeves.$touched || recordForm.$submitted)\" \nclass=\"md-block\"><label>No of Sleeves</label><md-select ng-model=\"pctrl.driassembly.numbersleeves\"><md-option \nvalue=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4\n</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option>\n<md-option value=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option><md-option \nvalue=\"11\">11</md-option><md-option value=\"12\">12</md-option><md-option value=\"13\">13</md-option><md-option value=\"14\">\n14</md-option><md-option value=\"15\">15</md-option><md-option value=\"16\">16</md-option><md-option value=\"17\">17\n</md-option><md-option value=\"18\">18</md-option><md-option value=\"19\">19</md-option><md-option value=\"20\">20\n</md-option></md-select><div ng-messages=\"recordForm.numbersleeves.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Please choose an option.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" \ntype=\"submit\" ng-click=\"recordForm.$valid && gravar(pctrl.driassembly)\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/go/templates/departments/drillingdesign.html","<md-dialog aria-label=\"Drilling Guide Design\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"pctrl.dridesign.orders_id\" \nng-init=\"pctrl.dridesign.orders_id=id\"> <input type=\"hidden\" ng-if=\"pctrl.dridesign.orders_drillingdesign_id\" \nng-model=\"pctrl.dridesign.orders_drillingdesign_id\" \nng-init=\"pctrl.dridesign.orders_drillingdesign_id=pctrl.dridesign.orders_drillingdesign_id\"> <input type=\"hidden\" \nng-if=\"!pctrl.dridesign.orders_drillingdesign_id\" ng-model=\"pctrl.dridesign.orders_drillingdesign_id\" \nng-init=\"pctrl.dridesign.orders_drillingdesign_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nDrilling Guide Design</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-padding\"><div layout=\"row\" \nlayout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><input \ntype=\"radio\" ng-model=\"pctrl.dridesign.upperlower\" name=\"upperlower\" value=\"1\" aria-label=\"Upper\">Upper</div></div><div\n flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" \nng-model=\"pctrl.dridesign.upperlower\" name=\"upperlower\" value=\"2\" aria-label=\"Lower\">Lower</div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button>\n<md-button class=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"recordForm.$valid && gravar(pctrl.dridesign)\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/templates/departments/drillingprinting.html","<md-dialog aria-label=\"Drilling Guide Printing\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"pctrl.driprinting.orders_id\" \nng-init=\"pctrl.driprinting.orders_id=id\"> <input type=\"hidden\" ng-if=\"pctrl.driprinting.orders_drillingprinting_id\" \nng-model=\"pctrl.driprinting.orders_drillingprinting_id\" \nng-init=\"pctrl.driprinting.orders_drillingprinting_id=pctrl.driprinting.orders_drillingprinting_id\"> <input \ntype=\"hidden\" ng-if=\"!pctrl.driprinting.orders_drillingprinting_id\" \nng-model=\"pctrl.driprinting.orders_drillingprinting_id\" ng-init=\"pctrl.driprinting.orders_drillingprinting_id=\'0\'\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2>Drilling Guide Printing</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-padding\"><div layout=\"row\" layout-align=\"center center\"><div flex-xs \nflex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" \nng-model=\"pctrl.driprinting.upperlower\" name=\"upperlower\" value=\"1\" aria-label=\"Upper\">Upper</div></div><div flex-xs \nflex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" \nng-model=\"pctrl.driprinting.upperlower\" name=\"upperlower\" value=\"2\" aria-label=\"Lower\">Lower</div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button>\n<md-button class=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"recordForm.$valid && gravar(pctrl.driprinting)\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/templates/departments/inmancaseassessment.html","<md-dialog aria-label=\"Case Assessment\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"pctrl.incaseassessment.orders_id\" \nng-init=\"pctrl.incaseassessment.orders_id=id\"> <input type=\"hidden\" \nng-if=\"pctrl.incaseassessment.orders_incase_assessment_id\" \nng-model=\"pctrl.incaseassessment.orders_incase_assessment_id\" \nng-init=\"pctrl.incaseassessment.orders_incase_assessment_id=pctrl.incaseassessment.orders_incase_assessment_id\"> <input\n type=\"hidden\" ng-if=\"!pctrl.incaseassessment.orders_incase_assessment_id\" \nng-model=\"pctrl.incaseassessment.orders_incase_assessment_id\" \nng-init=\"pctrl.incaseassessment.orders_incase_assessment_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nCase Assessment</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"center center\"><div \nflex-xs flex=\"50\" layout=\"column\"><div layout=\"row\"><input type=\"radio\" ng-model=\"pctrl.incaseassessment.upperlower\" \nname=\"upperlower\" value=\"1\" aria-label=\"Upper\">Upper</div><md-input-container flex><label>Comments</label><textarea \nrows=\"5\" name=\"commentsupper\" ng-model=\"pctrl.incaseassessment.commentsupper\" \nng-disabled=\"pctrl.incaseassessment.upperlower!=\'1\'\"></textarea></md-input-container><div layout=\"row\"><input \ntype=\"radio\" name=\"treatmentplan\" ng-model=\"pctrl.incaseassessment.treatmentplan\" value=\"1\" \naria-label=\"Treatment Plan\">Treatment Plan</div></div><div flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\"><input \ntype=\"radio\" name=\"upperlower\" ng-model=\"pctrl.incaseassessment.upperlower\" value=\"2\" aria-label=\"Lower\">Lower</div>\n<md-input-container flex><label>Comments</label><textarea rows=\"5\" name=\"commentslower\" \nng-model=\"pctrl.incaseassessment.commentslower\" ng-disabled=\"pctrl.incaseassessment.upperlower!=\'2\'\"></textarea>\n</md-input-container><div layout=\"row\"><input type=\"radio\" name=\"treatmentplan\" \nng-model=\"pctrl.incaseassessment.treatmentplan\" value=\"2\" aria-label=\"Treatment Plan\">Treatment Plan</div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button>\n<md-button class=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"recordForm.$valid && gravar(pctrl.incaseassessment)\">\nSave</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/templates/departments/inmanmanufacturing.html","<md-dialog aria-label=\"Inman Appliances Manufacturing\" ng-cloak><form name=\"recordForm\" \nng-submit=\"submitForm(recordForm.$valid)\" novalidate><input type=\"hidden\" ng-model=\"pctrl.inmanufacturing.orders_id\" \nng-init=\"pctrl.inmanufacturing.orders_id=id\"> <input type=\"hidden\" \nng-if=\"pctrl.inmanufacturing.orders_in_manufacturing_id\" ng-model=\"pctrl.inmanufacturing.orders_in_manufacturing_id\" \nng-init=\"pctrl.inmanufacturing.orders_in_manufacturing_id=pctrl.inmanufacturing.orders_in_manufacturing_id\"> <input \ntype=\"hidden\" ng-if=\"!pctrl.inmanufacturing.orders_in_manufacturing_id\" \nng-model=\"pctrl.inmanufacturing.orders_in_manufacturing_id\" \nng-init=\"pctrl.inmanufacturing.orders_in_manufacturing_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nInman Appliances Manufacturing</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><fieldset><legend><h3>Inman Aligner</h3></legend><div \nlayout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\">\n<input type=\"radio\" name=\"inmanaligner\" ng-model=\"pctrl.inmanufacturing.inmanaligner\" value=\"1\" aria-label=\"Upper\">\nUpper</div></div><div flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" \nname=\"inmanaligner\" ng-model=\"pctrl.inmanufacturing.inmanaligner\" value=\"2\" aria-label=\"Lower\">Lower</div></div></div>\n</fieldset><fieldset><legend><h3>Removeable Appliance</h3></legend><div layout=\"row\" layout-align=\"center center\"><div \nflex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" name=\"removeapp\" \nng-model=\"pctrl.inmanufacturing.removeapp\" value=\"1\" aria-label=\"Upper\">Upper</div></div><div flex-xs flex=\"50\" \nlayout=\"column\"><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" name=\"removeapp\" \nng-model=\"pctrl.inmanufacturing.removeapp\" value=\"2\" aria-label=\"Lower\">Lower</div></div></div></fieldset><fieldset>\n<legend><h3>Fixed Appliances</h3></legend><div layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" \nlayout=\"column\"><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" name=\"fixedapp\" \nng-model=\"pctrl.inmanufacturing.fixedapp\" value=\"1\" aria-label=\"Upper\">Upper</div></div><div flex-xs flex=\"50\" \nlayout=\"column\"><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" name=\"fixedapp\" \nng-model=\"pctrl.inmanufacturing.fixedapp\" value=\"2\" aria-label=\"Lower\">Lower</div></div></div></fieldset><fieldset>\n<legend><h3>Nimrod Aligner</h3></legend><div layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" \nlayout=\"column\"><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" name=\"nimrodaligner\" \nng-model=\"pctrl.inmanufacturing.nimrodaligner\" value=\"1\" aria-label=\"Upper\">Upper</div></div><div flex-xs flex=\"50\" \nlayout=\"column\"><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" name=\"nimrodaligner\" \nng-model=\"pctrl.inmanufacturing.nimrodaligner\" value=\"2\" aria-label=\"Lower\">Lower</div></div></div></fieldset>\n<fieldset><legend><h3>Heat Cure</h3></legend><div layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" \nlayout=\"column\"><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" name=\"heatcure\" \nng-model=\"pctrl.inmanufacturing.heatcure\" value=\"1\" aria-label=\"Upper\">Upper</div></div><div flex-xs flex=\"50\" \nlayout=\"column\"><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" name=\"heatcure\" \nng-model=\"pctrl.inmanufacturing.heatcure\" value=\"2\" aria-label=\"Lower\">Lower</div></div></div></fieldset><div \nlayout=\"row\" layout-align=\"center center\" class=\"md-padding\"><md-checkbox \nng-model=\"pctrl.inmanufacturing.functionalapp\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Functional Appliance\">\nFunctional Appliance</md-checkbox></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" \nng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(pctrl.inmanufacturing)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/templates/departments/inmanmovement.html","<md-dialog aria-label=\"Movement\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" novalidate>\n<input type=\"hidden\" ng-model=\"pctrl.inmovement.orders_id\" ng-init=\"pctrl.inmovement.orders_id=id\"> <input \ntype=\"hidden\" ng-if=\"pctrl.inmovement.orders_in_movement_id\" ng-model=\"pctrl.inmovement.orders_in_movement_id\" \nng-init=\"pctrl.inmovement.orders_in_movement_id=pctrl.inmovement.orders_in_movement_id\"> <input type=\"hidden\" \nng-if=\"!pctrl.inmovement.orders_in_movement_id\" ng-model=\"pctrl.inmovement.orders_in_movement_id\" \nng-init=\"pctrl.inmovement.orders_in_movement_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Movement</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\">\n<h3>Upper</h3><md-input-container flex class=\"md-block\"><label>No. of Clear Aligners</label><md-select \nng-model=\"pctrl.inmovement.upclear\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option \nvalue=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6\n</md-option><md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option value=\"9\">9</md-option>\n<md-option value=\"10\">10</md-option></md-select></md-input-container><div layout=\"row\" class=\"md-padding\"><input \ntype=\"radio\" name=\"treatmentplan\" ng-model=\"pctrl.inmovement.treatmentplan\" value=\"1\" aria-label=\"Treatment Plan\">\nTreatment Plan</div></div><div flex-xs flex=\"50\" layout=\"column\"><h3>Lower</h3><md-input-container flex \nclass=\"md-block\"><label>No. of Clear Aligners</label><md-select ng-model=\"pctrl.inmovement.lowclear\"><md-option \nvalue=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4\n</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option><md-option value=\"7\">7</md-option>\n<md-option value=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option value=\"10\">10</md-option></md-select>\n</md-input-container><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" name=\"treatmentplan\" \nng-model=\"pctrl.inmovement.treatmentplan\" value=\"2\" aria-label=\"Treatment Plan\">Treatment Plan</div></div></div><div \nlayout=\"row\" layout-align=\"left center\"><div flex-xs flex=\"50\" layout=\"column\"><div layout=\"row\" class=\"md-padding\">\n<input type=\"radio\" name=\"setupgoahead\" ng-model=\"pctrl.inmovement.setupgoahead\" value=\"1\" aria-label=\"Set Up\">Set Up \n<input type=\"radio\" name=\"setupgoahead\" ng-model=\"pctrl.inmovement.setupgoahead\" value=\"2\" aria-label=\"Go Ahead\">\nGo Ahead</div></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" \nng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(pctrl.inmovement)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/templates/departments/manufacturing.html","<md-dialog aria-label=\"Manufacturing\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"pctrl.manufacturing.orders_id\" ng-init=\"pctrl.manufacturing.orders_id=id\"> \n<input type=\"hidden\" ng-if=\"pctrl.manufacturing.orders_manufacturing_id\" \nng-model=\"pctrl.manufacturing.orders_manufacturing_id\" \nng-init=\"pctrl.manufacturing.orders_manufacturing_id=pctrl.manufacturing.orders_manufacturing_id\"> <input \ntype=\"hidden\" ng-if=\"!pctrl.manufacturing.orders_manufacturing_id\" \nng-model=\"pctrl.manufacturing.orders_manufacturing_id\" ng-init=\"pctrl.manufacturing.orders_manufacturing_id=\'0\'\">\n<md-toolbar><div class=\"md-toolbar-tools\"><h2>Manufacturing</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" class=\"s24 md-font material-icons\" aria-hidden=\"true\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" \nlayout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><h3>Upper</h3><h4>Type of Work</h4><md-checkbox \nng-model=\"pctrl.manufacturing.upsplint\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Splint\">Splint</md-checkbox>\n<md-checkbox ng-model=\"pctrl.manufacturing.upjigs\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Jigs\">Jigs\n</md-checkbox><md-checkbox ng-model=\"pctrl.manufacturing.upnimrodret\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"NimrodRetainer\">NimrodRetainer</md-checkbox><md-checkbox ng-model=\"pctrl.manufacturing.upnimrodali\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"NimrodAligner\">NimrodAligner</md-checkbox><md-checkbox \nng-model=\"pctrl.manufacturing.upstudymodels\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Study Models\">Study Models\n</md-checkbox><md-checkbox ng-model=\"pctrl.manufacturing.upimplant\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Implant Guides\">Implant Guides</md-checkbox><md-checkbox ng-model=\"pctrl.manufacturing.upextras\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Extras\">Extras</md-checkbox></div><div flex-xs flex=\"50\" \nlayout=\"column\"><h3>Lower</h3><h4>Type of Work</h4><md-checkbox ng-model=\"pctrl.manufacturing.lowsplint\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Splint\">Splint</md-checkbox><md-checkbox \nng-model=\"pctrl.manufacturing.lowjigs\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Jigs\">Jigs</md-checkbox>\n<md-checkbox ng-model=\"pctrl.manufacturing.lownimrodret\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"NimrodRetainer\">NimrodRetainer</md-checkbox><md-checkbox ng-model=\"pctrl.manufacturing.lownimrodali\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"NimrodAligner\">NimrodAligner</md-checkbox><md-checkbox \nng-model=\"pctrl.manufacturing.lowstudymodels\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Study Models\">\nStudy Models</md-checkbox><md-checkbox ng-model=\"pctrl.manufacturing.lowimplant\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Implant Guides\">Implant Guides</md-checkbox><md-checkbox ng-model=\"pctrl.manufacturing.lowextras\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Extras\">Extras</md-checkbox></div></div><div layout=\"row\" \nlayout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-input-container flex \nmd-is-error=\"recordForm.upnumimplants.$invalid && (recordForm.upnumimplants.$touched || recordForm.$submitted)\" \nclass=\"md-block\"><label>No. Implant Guides</label><md-select ng-model=\"pctrl.manufacturing.upnumimplants\"><md-option \nvalue=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4\n</md-option><md-option value=\"5\">5</md-option></md-select><div ng-messages=\"recordForm.upnumimplants.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Please choose an option.</span></div></div></md-input-container></div>\n<div flex-xs flex=\"50\" layout=\"column\"><md-input-container flex \nmd-is-error=\"recordForm.lownumimplants.$invalid && (recordForm.lownumimplants.$touched || recordForm.$submitted)\" \nclass=\"md-block\"><label>No. Implant Guides</label><md-select ng-model=\"pctrl.manufacturing.lownumimplants\"><md-option \nvalue=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4\n</md-option><md-option value=\"5\">5</md-option></md-select><div ng-messages=\"recordForm.lownumimplants.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Please choose an option.</span></div></div></md-input-container></div>\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel\n</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(pctrl.manufacturing)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/templates/departments/matching.html","<md-dialog aria-label=\"Matching\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" novalidate>\n<input type=\"hidden\" ng-model=\"pctrl.matching.orders_id\" ng-init=\"pctrl.matching.orders_id=id\"> <input type=\"hidden\" \nng-if=\"pctrl.matching.orders_matching_id\" ng-model=\"pctrl.matching.orders_matching_id\" \nng-init=\"pctrl.matching.orders_matching_id=pctrl.matching.orders_matching_id\"> <input type=\"hidden\" \nng-if=\"!pctrl.matching.orders_matching_id\" ng-model=\"pctrl.matching.orders_matching_id\" \nng-init=\"pctrl.matching.orders_matching_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Matching</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-padding\"><div layout=\"row\" layout-align=\"center center\"><div flex-xs \nflex=\"40\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" name=\"matching\" \nng-model=\"pctrl.matching.smopcodiagnostix\" value=\"smop\" aria-label=\"Smop\">Smop</div><div layout=\"row\" \nclass=\"md-padding\"><input type=\"radio\" name=\"upperlower\" ng-model=\"pctrl.matching.upperlower\" value=\"1\" \naria-label=\"Upper\">Upper</div></div><div flex-xs flex=\"60\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><input \ntype=\"radio\" name=\"matching\" ng-model=\"pctrl.matching.smopcodiagnostix\" value=\"codiagnosticx\" \naria-label=\"coDiagnostiX\">coDiagnostiX</div><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" name=\"upperlower\" \nng-model=\"pctrl.matching.upperlower\" value=\"2\" aria-label=\"Lower\">Lower</div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button \nclass=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"recordForm.$valid && gravar(pctrl.matching)\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/templates/departments/ordercontent.html","<md-dialog aria-label=\"Order Content\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"pctrl.orderscontent.orders_id\" ng-init=\"pctrl.orderscontent.orders_id=id\"> \n<input type=\"hidden\" ng-if=\"pctrl.orderscontent.orders_content_id\" ng-model=\"pctrl.orderscontent.orders_content_id\" \nng-init=\"pctrl.orderscontent.orders_content_id=pctrl.orderscontent.orders_content_id\"> <input type=\"hidden\" \nng-if=\"!pctrl.orderscontent.orders_content_id\" ng-model=\"pctrl.orderscontent.orders_content_id\" \nng-init=\"pctrl.orderscontent.orders_content_id=0\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Order Content</h2><span\n flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" class=\"md-dialog-content\"><md-input-container flex class=\"md-block\">\n<label>Prescription No</label><input type=\"text\" ng-model=\"pctrl.orderscontent.prescription_number\">\n</md-input-container><md-input-container flex \nmd-is-error=\"recordForm.digital.$invalid && (recordForm.digital.$touched || recordForm.$submitted)\"><label>Digital\n</label><md-select name=\"digital\" ng-model=\"pctrl.orderscontent.digital\"><md-option value=\"1\">Yes</md-option><md-option\n value=\"0\">No</md-option></md-select><div ng-messages=\"recordForm.digital.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Please choose an option.</span></div></div></md-input-container></div><h3>ORDER CONTENT\n</h3><div layout=\"row\" class=\"md-dialog-content\"><md-input-container flex class=\"md-block\"><label>No. of Impressions\n</label><md-select ng-model=\"pctrl.orderscontent.num_impressions\"><md-option value=\"0\">Not Applicable</md-option>\n<md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option \nvalue=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option></md-select>\n</md-input-container><md-input-container flex class=\"md-block\"><label>Bite</label><md-select \nng-model=\"pctrl.orderscontent.bite\"><md-option value=\"1\">Yes</md-option><md-option value=\"0\">No</md-option></md-select>\n</md-input-container></div><div layout=\"row\" class=\"md-dialog-content\"><md-input-container flex class=\"md-block\">\n<label>No. of Models</label><md-select ng-model=\"pctrl.orderscontent.num_models\"><md-option value=\"0\">Not Applicable\n</md-option><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option>\n<md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option></md-select>\n</md-input-container><md-input-container flex class=\"md-block\"><label>Appliance</label><md-select \nng-model=\"pctrl.orderscontent.appliance\"><md-option value=\"1\">Yes</md-option><md-option value=\"0\">No</md-option>\n</md-select></md-input-container></div><div layout=\"row\" flex class=\"md-dialog-content\"><md-input-container flex>\n<label>Other</label><textarea rows=\"5\" ng-model=\"pctrl.orderscontent.other\"></textarea></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button>\n<md-button class=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"recordForm.$valid && gravar(pctrl.orderscontent)\">\nSave</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/templates/departments/orderinfo.html","<md-dialog aria-label=\"Order Info\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"pctrl.cliente.orders_id\" ng-init=\"pctrl.cliente.orders_id=id\"> <input \ntype=\"hidden\" ng-if=\"pctrl.cliente.clients_id\" ng-model=\"pctrl.cliente.clients_id\"> <input type=\"hidden\" \nng-if=\"!pctrl.cliente.clients_id\" ng-model=\"pctrl.cliente.clients_id\" ng-init=\"pctrl.cliente.clients_id=\'0\'\"> <input \ntype=\"hidden\" ng-if=\"item.clientname\" ng-model=\"pctrl.cliente.clientname\" \nng-init=\"pctrl.cliente.clientname=\'{{item.clientname}}\'\"> <input type=\"hidden\" ng-if=\"!item.clientname\" \nng-model=\"pctrl.cliente.clientname\" ng-init=\"pctrl.cliente.clientname=pctrl.cliente.clientname\"> <input type=\"hidden\" \nng-if=\"pctrl.cliente.clients_deliveryaddress_id\" ng-model=\"pctrl.cliente.clients_deliveryaddress_id\"> <input \ntype=\"hidden\" ng-if=\"!pctrl.cliente.clients_deliveryaddress_id\" ng-model=\"pctrl.cliente.clients_deliveryaddress_id\" \nng-init=\"pctrl.cliente.clients_deliveryaddress_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Order Info</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><h3>INFO</h3><div layout=\"row\" class=\"md-dialog-content\"><md-autocomplete \nng-if=\"pctrl.jaexiste == \'0\'\" flex required md-input-name=\"autocompleteField\" md-no-cache=\"pctrl.noCache\" \nmd-selected-item=\"pctrl.selectedItem\" md-search-text-change=\"pctrl.searchTextChange(pctrl.searchText)\" \nmd-search-text=\"pctrl.searchText\" md-items=\"item in pctrl.querySearch(pctrl.searchText)\" \nmd-item-text=\"item.clientname\" md-selected-item-change=\"pctrl.selectedItemChange(item)\" md-require-match \nmd-input-minlength=\"2\" md-input-maxlength=\"18\" md-floating-label=\"Client Name\" ng-disabled=\"pctrl.isDisabled\" \nng-click=\"pctrl.ativa()\" title=\"pctrl.titulo\" md-autofocus><md-item-template><span \nmd-highlight-text=\"pctrl.searchText\" md-highlight-flags=\"^i\">{{item.clientname}}</span></md-item-template>\n<md-not-found>No matches found. <a ng-click=\"pctrl.newClient(pctrl.searchText)\">Create a new with inserted name</a>\n</md-not-found><div ng-messages=\"recordForm.autocompleteField.$error\"><div ng-message=\"required\">\nPlease insert a client name.</div></div></md-autocomplete><md-input-container flex ng-if=\"pctrl.jaexiste == \'1\'\" \nclass=\"md-block\" ng-click=\"pctrl.alterar()\"><label>Client Name</label><md-tooltip md-direction=\"bottom\">\nClick to add a new client</md-tooltip><input required type=\"text\" name=\"clientname\" \nng-model=\"pctrl.cliente.clientname\" value=\"{{pctrl.cliente.clientname}}\" disabled=\"disabled\"><div \nng-messages=\"recordForm.clientname.$error\"><div ng-message=\"required\">Please insert a client name.</div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Client Number</label><input required type=\"text\" \nname=\"clientnumber\" ng-model=\"pctrl.cliente.clientnumber\" value=\"{{pctrl.cliente.clientnumber}}\"><div \nng-messages=\"recordForm.clientnumber.$error\"><div ng-message=\"required\">Please insert a client number.</div></div>\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-input-container class=\"md-block\"><label>\nClient</label><input type=\"text\"></md-input-container><md-input-container class=\"md-block\"><label>GDC Number</label>\n<input type=\"text\"></md-input-container><md-input-container class=\"md-block\"><label>Patient Name</label><input \ntype=\"text\"></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-input-container \nclass=\"md-block\"><label>Email</label><input type=\"text\" name=\"cemail\" ng-model=\"pctrl.cliente.cemail\" \nvalue=\"{{pctrl.cliente.cemail}}\" ng-pattern=\"/^[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\\.[a-zA-Z]{2,4}$/\">\n</md-input-container><md-input-container class=\"md-block\"><label>Tel</label><input type=\"text\" \nng-model=\"pctrl.cliente.ctel\" value=\"{{pctrl.cliente.ctel}}\"></md-input-container><md-input-container class=\"md-block\">\n<label>Patient Ref</label><input type=\"text\"></md-input-container></div><h3>DELIVERY</h3><div layout=\"row\" \nclass=\"md-dialog-content\"><md-input-container flex class=\"md-block\"><label>Address 1</label><input type=\"text\" \nng-model=\"pctrl.cliente.daddress1\" value=\"{{pctrl.cliente.daddress1}}\"></md-input-container></div><div layout=\"row\" \nclass=\"md-dialog-content\"><md-input-container flex class=\"md-block\"><label>Address 2</label><input type=\"text\" \nng-model=\"pctrl.cliente.daddress2\" value=\"{{pctrl.cliente.daddress2}}\"></md-input-container></div><div layout=\"row\" \nclass=\"md-dialog-content\"><md-input-container flex class=\"md-block\"><label>City</label><input type=\"text\" \nng-model=\"pctrl.cliente.dcity\" value=\"{{pctrl.cliente.dcity}}\"></md-input-container><md-input-container flex \nclass=\"md-block\"><label>County</label><input type=\"text\" ng-model=\"pctrl.cliente.dcounty\" \nvalue=\"{{pctrl.cliente.dcounty}}\"></md-input-container><md-input-container flex class=\"md-block\"><label>Postcode\n</label><input type=\"text\" ng-model=\"pctrl.cliente.dpostcode\" value=\"{{pctrl.cliente.dpostcode}}\"></md-input-container>\n</div><div layout=\"row\" class=\"md-dialog-content\"><md-input-container flex class=\"md-block\"><label>Country</label>\n<input type=\"text\" ng-model=\"pctrl.cliente.dcountry\" value=\"{{pctrl.cliente.dcountry}}\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Email</label><input type=\"text\" name=\"demail\" \nng-model=\"pctrl.cliente.demail\" value=\"{{pctrl.cliente.demail}}\" \nng-pattern=\"/^[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\\.[a-zA-Z]{2,4}$/\"></md-input-container></div><div layout=\"row\" \nclass=\"md-dialog-content\"><md-input-container flex class=\"md-block\"><label>Telephone Number</label><input type=\"text\" \nng-model=\"pctrl.cliente.dtel\" value=\"{{pctrl.cliente.dtel}}\"></md-input-container><md-input-container flex \nclass=\"md-block\"><label>Delivery Route</label><md-select ng-model=\"pctrl.cliente.deliveryroutes_id\"><md-option \nvalue=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4\n</md-option><md-option value=\"5\">5</md-option></md-select></md-input-container></div><div layout=\"row\" \nclass=\"md-dialog-content\"><md-input-container flex class=\"md-block\"><label>GDC Number</label><input type=\"text\">\n</md-input-container><md-input-container flex class=\"md-block\"><label>Time</label><input type=\"text\" value=\"14:33\" \ndisabled=\"disabled\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \ntype=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(pctrl.cliente)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/templates/departments/packaging.html","<md-dialog aria-label=\"Packaging\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"pctrl.packaging.orders_id\" ng-init=\"pctrl.packaging.orders_id=id\"> <input \ntype=\"hidden\" ng-if=\"pctrl.packaging.orders_packaging_id\" ng-model=\"pctrl.packaging.orders_packaging_id\" \nng-init=\"pctrl.packaging.orders_packaging_id=pctrl.packaging.orders_packaging_id\"> <input type=\"hidden\" \nng-if=\"!pctrl.packaging.orders_packaging_id\" ng-model=\"pctrl.packaging.orders_packaging_id\" \nng-init=\"pctrl.packaging.orders_packaging_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Packaging</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div flex layout=\"row\" layout-align=\"center center\" class=\"md-padding\">\n<md-input-container class=\"md-block\" moment-picker=\"pctrl.packaging.shippingdate\" format=\"YYYY-MM-DD\" \nstart-view=\"month\" autoclose=\"pctrl.autoclose\"><label>Shipping Date</label><input class=\"form-control\" \nng-model=\"pctrl.packaging.shippingdate\"></md-input-container><md-input-container class=\"md-block\" \nmoment-picker=\"pctrl.packaging.deliverydate\" format=\"YYYY-MM-DD\" start-view=\"month\" autoclose=\"pctrl.autoclose\" \nmin-date=\"pctrl.packaging.shippingdate\"><label>Delivery Date Date</label><input class=\"form-control\" \nng-model=\"pctrl.packaging.deliverydate\"></md-input-container></div><div layout=\"row\" layout-align=\"center center\" \nclass=\"md-padding\"><md-input-container class=\"md-block\" moment-picker=\"pctrl.packaging.fromtime\" format=\"HH\" \nautoclose=\"pctrl.autoclose\"><label>From Time</label><input class=\"form-control\" ng-model=\"pctrl.packaging.fromtime\">\n</md-input-container><md-input-container class=\"md-block\" moment-picker=\"pctrl.packaging.totime\" format=\"HH\" \nautoclose=\"pctrl.autoclose\" min-date=\"pctrl.packaging.fromtime\"><label>To Time</label><input class=\"form-control\" \nng-model=\"pctrl.packaging.totime\"></md-input-container></div><div layout=\"row\" layout-align=\"center center\" \nclass=\"md-padding\"><md-input-container flex \nmd-is-error=\"recordForm.deliveryroutes_id.$invalid && (recordForm.deliveryroutes_id.$touched || recordForm.$submitted)\">\n<label>Delivery Route</label><md-select name=\"deliveryroutes_id\" ng-model=\"pctrl.packaging.deliveryroutes_id\">\n<md-option ng-repeat=\"(index,droute) in pctrl.droutes\" ng-value=\"droute.deliveryroutes_id\" \nng-selected=\"droute.deliveryroutes_id == \'{{pctrl.packaging.deliveryroutes_id}}\'\">{{droute.route}}</md-option>\n</md-select><div ng-messages=\"recordForm.deliveryroutes_id.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease choose a delivery route.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" \ntype=\"submit\" ng-click=\"recordForm.$valid && gravar(pctrl.packaging)\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pages/go/templates/departments/planning.html","<md-dialog aria-label=\"Planning\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" novalidate>\n<input type=\"hidden\" ng-model=\"pctrl.planning.orders_id\" ng-init=\"pctrl.planning.orders_id=id\"> <input type=\"hidden\" \nng-if=\"pctrl.planning.orders_planning_id\" ng-model=\"pctrl.planning.orders_planning_id\" \nng-init=\"pctrl.planning.orders_planning_id=pctrl.planning.orders_planning_id\"> <input type=\"hidden\" \nng-if=\"!pctrl.planning.orders_planning_id\" ng-model=\"pctrl.planning.orders_planning_id\" \nng-init=\"pctrl.planning.orders_planning_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Planning</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"md-padding\"><div layout=\"row\" layout-align=\"center center\"><div flex-xs \nflex=\"45\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" ng-model=\"pctrl.planning.planning\" \nname=\"planning\" value=\"bredent\" aria-label=\"Bredent\">Bredent</div><div layout=\"row\" class=\"md-padding\"><input \ntype=\"radio\" ng-model=\"pctrl.planning.planning\" name=\"planning\" value=\"osstem\" aria-label=\"Osstem\">Osstem</div><div \nlayout=\"row\" class=\"md-padding\"><input type=\"radio\" ng-model=\"pctrl.planning.planning\" name=\"planning\" value=\"SIC\" \naria-label=\"SIC\">SIC</div></div><div flex-xs flex=\"55\" layout=\"column\"><div layout=\"row\" class=\"md-padding\"><input \ntype=\"radio\" ng-model=\"pctrl.planning.planning\" name=\"planning\" value=\"camlog\" aria-label=\"Camlog\">Camlog</div><div \nlayout=\"row\" class=\"md-padding\"><input type=\"radio\" ng-model=\"pctrl.planning.planning\" name=\"planning\" \nvalue=\"biohorizons\" aria-label=\"Biohorizons\">Biohorizons</div><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" \nng-model=\"pctrl.planning.planning\" name=\"planning\" value=\"straumann\" aria-label=\"Straumann\">Straumann</div></div></div>\n<div layout=\"column\" layout-align=\"center center\"><div layout=\"row\" class=\"md-padding\"><input type=\"radio\" \nng-model=\"pctrl.planning.planning\" name=\"planning\" value=\"Other\" aria-label=\"Other\">Other</div><md-input-container \nflex><label>Other</label><textarea rows=\"5\" name=\"other\" ng-model=\"pctrl.planning.other\" \nng-disabled=\"pctrl.planning.planning!=\'Other\'\"></textarea></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button \nclass=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"recordForm.$valid && gravar(pctrl.planning)\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/templates/departments/plasterroom.html","<md-dialog aria-label=\"Plaster Room\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"pctrl.plasterroom.orders_id\" ng-init=\"pctrl.plasterroom.orders_id=id\"> <input\n type=\"hidden\" ng-if=\"pctrl.plasterroom.orders_plasterroom_id\" ng-model=\"pctrl.plasterroom.orders_plasterroom_id\" \nng-init=\"pctrl.plasterroom.orders_plasterroom_id=pctrl.plasterroom.orders_plasterroom_id\"> <input type=\"hidden\" \nng-if=\"!pctrl.plasterroom.orders_plasterroom_id\" ng-model=\"pctrl.plasterroom.orders_plasterroom_id\" \nng-init=\"pctrl.plasterroom.orders_plasterroom_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Plaster Room</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"center center\"><md-input-container flex \nmd-is-error=\"recordForm.upper.$invalid && (recordForm.upper.$touched || recordForm.$submitted)\" class=\"md-block\">\n<label>Upper</label><md-select ng-model=\"pctrl.plasterroom.upper\"><md-option value=\"1\">1</md-option><md-option \nvalue=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5\n</md-option></md-select><div ng-messages=\"recordForm.upper.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease choose an option.</span></div></div></md-input-container><md-input-container flex \nmd-is-error=\"recordForm.lower.$invalid && (recordForm.lower.$touched || recordForm.$submitted)\" class=\"md-block\">\n<label>Lower</label><md-select ng-model=\"pctrl.plasterroom.lower\"><md-option value=\"1\">1</md-option><md-option \nvalue=\"2\">2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5\n</md-option></md-select><div ng-messages=\"recordForm.lower.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease choose an option.</span></div></div></md-input-container></div><md-dialog-actions layout=\"row\"><md-button \ntype=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(pctrl.plasterroom)\">Save</md-button></md-dialog-actions></md-dialog-content>\n</form></md-dialog>");
$templateCache.put("app/main/pages/go/templates/departments/platforms.html","<md-dialog aria-label=\"Platforms\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"pctrl.platforms.orders_id\" ng-init=\"pctrl.platforms.orders_id=id\"> <input \ntype=\"hidden\" ng-if=\"pctrl.platforms.orders_platforms_id\" ng-model=\"pctrl.platforms.orders_platforms_id\" \nng-init=\"pctrl.platforms.orders_platforms_id=pctrl.platforms.orders_platforms_id\"> <input type=\"hidden\" \nng-if=\"!pctrl.platforms.orders_platforms_id\" ng-model=\"pctrl.platforms.orders_platforms_id\" \nng-init=\"pctrl.platforms.orders_platforms_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Platforms</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"center center\"><md-input-container flex \nmd-is-error=\"recordForm.upper.$invalid && (recordForm.upper.$touched || recordForm.$submitted)\" class=\"md-block\">\n<label>Upper</label><md-select ng-model=\"pctrl.platforms.upper\"><md-option value=\"1\">1</md-option><md-option value=\"2\">\n2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option>\n</md-select><div ng-messages=\"recordForm.upper.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease choose an option.</span></div></div></md-input-container><md-input-container flex \nmd-is-error=\"recordForm.lower.$invalid && (recordForm.lower.$touched || recordForm.$submitted)\" class=\"md-block\">\n<label>Lower</label><md-select ng-model=\"pctrl.platforms.lower\"><md-option value=\"1\">1</md-option><md-option value=\"2\">\n2</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option>\n</md-select><div ng-messages=\"recordForm.lower.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease choose an option.</span></div></div></md-input-container></div><h3>Type of Model</h3><div layout=\"row\" \nlayout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-checkbox \nng-model=\"pctrl.platforms.uphorseshoe\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Horse Shoe\">Horse Shoe\n</md-checkbox><md-checkbox ng-model=\"pctrl.platforms.upfullmodels\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Full Models\">Full Models</md-checkbox><md-checkbox ng-model=\"pctrl.platforms.upclearaligners\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Clear Aligners\">Clear Aligners</md-checkbox><md-checkbox \nng-model=\"pctrl.platforms.upextras\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Extras\">Extras</md-checkbox></div>\n<div flex-xs flex=\"50\" layout=\"column\"><md-checkbox ng-model=\"pctrl.platforms.lowhorseshoe\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Horse Shoe\">Horse Shoe</md-checkbox><md-checkbox \nng-model=\"pctrl.platforms.lowfullmodels\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Full Models\">Full Models\n</md-checkbox><md-checkbox ng-model=\"pctrl.platforms.lowclearaligners\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Clear Aligners\">Clear Aligners</md-checkbox><md-checkbox ng-model=\"pctrl.platforms.lowextras\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Extras\">Extras</md-checkbox></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button><md-button \nclass=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"recordForm.$valid && gravar(pctrl.platforms)\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/templates/departments/scanning.html","<md-dialog flex=\"60\" aria-label=\"Scanning\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"pctrl.scanning.orders_id\" ng-init=\"pctrl.scanning.orders_id=id\"> <input \ntype=\"hidden\" ng-if=\"pctrl.scanning.orders_scanning_id\" ng-model=\"pctrl.scanning.orders_scanning_id\" \nng-init=\"pctrl.scanning.orders_scanning_id=pctrl.scanning.orders_scanning_id\"> <input type=\"hidden\" \nng-if=\"!pctrl.scanning.orders_scanning_id\" ng-model=\"pctrl.scanning.orders_scanning_id\" \nng-init=\"pctrl.scanning.orders_scanning_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Scanning</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"center center\"><md-input-container flex \nmd-is-error=\"recordForm.upper.$invalid && (recordForm.upper.$touched || recordForm.$submitted)\" class=\"md-block\">\n<label>Upper</label><md-select ng-model=\"pctrl.scanning.upper\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2\n</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option>\n</md-select><div ng-messages=\"recordForm.upper.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease choose an option.</span></div></div></md-input-container><md-input-container flex \nmd-is-error=\"recordForm.lower.$invalid && (recordForm.lower.$touched || recordForm.$submitted)\" class=\"md-block\">\n<label>Lower</label><md-select ng-model=\"pctrl.scanning.lower\"><md-option value=\"1\">1</md-option><md-option value=\"2\">2\n</md-option><md-option value=\"3\">3</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option>\n</md-select><div ng-messages=\"recordForm.lower.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPlease choose an option.</span></div></div></md-input-container></div><h3>Work Type</h3><div layout=\"row\" \nlayout-align=\"center center\"><table flex class=\"tableradio\"><thead><tr><th colspan=\"2\">Clear Aligners</th><th \ncolspan=\"2\">Clear Aligners<br>Case Assessment</th><th colspan=\"2\">Inman Case Assessment<br>Inman Treatment Plan</th><th\n colspan=\"2\">Join Case<br>(Same Dept.)</th><th colspan=\"2\">Join Case<br>(Different Depts.)</th></tr></thead><tbody><tr>\n<td>&nbsp;Up<br><input type=\"radio\" name=\"clearaligners\" ng-model=\"pctrl.scanning.clearaligners\" value=\"1\" \narial-label=\"Up\"></td><td>Low<br><input type=\"radio\" name=\"clearaligners\" ng-model=\"pctrl.scanning.clearaligners\" \nvalue=\"2\" arial-label=\"Low\"></td><td>&nbsp;Up<br><input type=\"radio\" name=\"cacaseass\" \nng-model=\"pctrl.scanning.cacaseass\" value=\"1\" arial-label=\"Up\"></td><td>Low<br><input type=\"radio\" name=\"cacaseass\" \nng-model=\"pctrl.scanning.cacaseass\" value=\"2\" arial-label=\"Low\"></td><td>&nbsp;Up<br><input type=\"radio\" \nname=\"inmancaseass\" ng-model=\"pctrl.scanning.inmancaseass\" value=\"1\" arial-label=\"Up\"></td><td>Low<br><input \ntype=\"radio\" name=\"inmancaseass\" ng-model=\"pctrl.scanning.inmancaseass\" value=\"2\" arial-label=\"Low\"></td><td>&nbsp;Up\n<br><input type=\"radio\" name=\"joincasesame\" ng-model=\"pctrl.scanning.joincasesame\" value=\"1\" arial-label=\"Up\"></td><td>\nLow<br><input type=\"radio\" name=\"joincasesame\" ng-model=\"pctrl.scanning.joincasesame\" value=\"2\" arial-label=\"Low\"></td>\n<td>&nbsp;Up<br><input type=\"radio\" name=\"joincasediff\" ng-model=\"pctrl.scanning.joincasediff\" value=\"1\" \narial-label=\"Up\"></td><td>Low<br><input type=\"radio\" name=\"joincasediff\" ng-model=\"pctrl.scanning.joincasediff\" \nvalue=\"2\" arial-label=\"Low\"></td></tr></tbody><thead><tr><th colspan=\"2\">3D Department</th><th colspan=\"2\">Removable\n<br>Appliances</th><th colspan=\"2\">Inman</th><th colspan=\"2\">Brackets</th><th colspan=\"2\">Fixed Bonded</th></tr>\n</thead><tbody><tr><td>&nbsp;Up<br><input type=\"radio\" name=\"threeddepartment\" \nng-model=\"pctrl.scanning.threeddepartment\" value=\"1\" arial-label=\"Up\"></td><td>Low<br><input type=\"radio\" \nname=\"threeddepartment\" ng-model=\"pctrl.scanning.threeddepartment\" value=\"2\" arial-label=\"Low\"></td><td>&nbsp;Up<br>\n<input type=\"radio\" name=\"remappl\" ng-model=\"pctrl.scanning.remappl\" value=\"1\" arial-label=\"Up\"></td><td>Low<br><input \ntype=\"radio\" name=\"remappl\" ng-model=\"pctrl.scanning.remappl\" value=\"2\" arial-label=\"Low\"></td><td>&nbsp;Up<br><input \ntype=\"radio\" name=\"inman\" ng-model=\"pctrl.scanning.inman\" value=\"1\" arial-label=\"Up\"></td><td>Low<br><input \ntype=\"radio\" name=\"inman\" ng-model=\"pctrl.scanning.inman\" value=\"2\" arial-label=\"Low\"></td><td>&nbsp;Up<br><input \ntype=\"radio\" name=\"brackets\" ng-model=\"pctrl.scanning.brackets\" value=\"1\" arial-label=\"Up\"></td><td>Low<br><input \ntype=\"radio\" name=\"brackets\" ng-model=\"pctrl.scanning.brackets\" value=\"2\" arial-label=\"Low\"></td><td>&nbsp;Up<br><input\n type=\"radio\" name=\"fixedbonded\" ng-model=\"pctrl.scanning.fixedbonded\" value=\"1\" arial-label=\"Up\"></td><td>Low<br>\n<input type=\"radio\" name=\"fixedbonded\" ng-model=\"pctrl.scanning.fixedbonded\" value=\"2\" arial-label=\"Low\"></td></tr>\n</tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">\nCancel</md-button><md-button class=\"md-green-500-bg branco\" type=\"submit\" \nng-click=\"recordForm.$valid && gravar(pctrl.scanning)\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/go/templates/departments/waiting.html","<md-dialog aria-label=\"Waiting for Call\" ng-cloak><form name=\"recordForm\" ng-submit=\"submitForm(recordForm.$valid)\" \nnovalidate><input type=\"hidden\" ng-model=\"pctrl.waiting.orders_id\" ng-init=\"pctrl.waiting.orders_id=id\"> <input \ntype=\"hidden\" ng-if=\"pctrl.waiting.orders_waitingcall_id\" ng-model=\"pctrl.waiting.orders_waitingcall_id\" \nng-init=\"pctrl.waiting.orders_waitingcall_id=pctrl.waiting.orders_waitingcall_id\"> <input type=\"hidden\" \nng-if=\"!pctrl.waiting.orders_waitingcall_id\" ng-model=\"pctrl.waiting.orders_waitingcall_id\" \nng-init=\"pctrl.waiting.orders_waitingcall_id=\'0\'\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Waiting for Call</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s24 md-font material-icons\" aria-hidden=\"true\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\">\n<h3>Upper</h3><h4>Type of Appliance</h4><md-checkbox ng-model=\"pctrl.waiting.upclear\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Clear\">Clear</md-checkbox><md-checkbox ng-model=\"pctrl.waiting.upinman\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Inman\">Inman</md-checkbox><md-checkbox \nng-model=\"pctrl.waiting.upbrackets\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Brackets\">Brackets</md-checkbox>\n<md-checkbox ng-model=\"pctrl.waiting.upnimrodali\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"NimrodAligners\">\nNimrodAligners</md-checkbox><md-checkbox ng-model=\"pctrl.waiting.updrillingguides\" ng-true-value=\"1\" ng-true-false=\"0\" \naria-label=\"Drilling Guides\">Drilling Guides</md-checkbox><md-checkbox ng-model=\"pctrl.waiting.upother\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Other\">Other</md-checkbox></div><div flex-xs flex=\"50\" layout=\"column\">\n<h3>Lower</h3><h4>Type of Appliance</h4><md-checkbox ng-model=\"pctrl.waiting.lowclear\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Clear\">Clear</md-checkbox><md-checkbox ng-model=\"pctrl.waiting.lowinman\" \nng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Inman\">Inman</md-checkbox><md-checkbox \nng-model=\"pctrl.waiting.lowbrackets\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Brackets\">Brackets</md-checkbox>\n<md-checkbox ng-model=\"pctrl.waiting.lownimrodali\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"NimrodAligners\">\nNimrodAligners</md-checkbox><md-checkbox ng-model=\"pctrl.waiting.lowdrillingguides\" ng-true-value=\"1\" \nng-true-false=\"0\" aria-label=\"Drilling Guides\">Drilling Guides</md-checkbox><md-checkbox \nng-model=\"pctrl.waiting.lowother\" ng-true-value=\"1\" ng-true-false=\"0\" aria-label=\"Other\">Other</md-checkbox></div>\n</div><div layout=\"row\" layout-align=\"center center\"><div flex-xs flex=\"50\" layout=\"column\"><md-input-container flex>\n<label>Comments</label><textarea rows=\"5\" name=\"upcomments\" ng-model=\"pctrl.waiting.upcomments\"></textarea>\n</md-input-container></div><div flex-xs flex=\"50\" layout=\"column\"><md-input-container flex><label>Comments</label>\n<textarea rows=\"5\" name=\"lowcomments\" ng-model=\"pctrl.waiting.lowcomments\"></textarea></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button type=\"submit\" ng-click=\"cancel()\">Cancel</md-button>\n<md-button class=\"md-green-500-bg branco\" type=\"submit\" ng-click=\"recordForm.$valid && gravar(pctrl.waiting)\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" layout=\"row\" layout-align=\"start center\"><div class=\"step\" \nlayout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">\nOptional</div></div></md-button><div class=\"ms-stepper-step-content\" ng-transclude></div><div \nclass=\"ms-stepper-controls\" layout=\"row\" layout-align=\"start center\" \nng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button class=\"md-accent md-raised\" \nng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/settings/menus/color/color-menu.html","<div class=\"header md-whiteframe-2dp\"><md-list><md-list-item class=\"selected-color\"><p class=\"title\" flex>\nSelected Color:</p><div ng-if=\"!vm.board.settings.color\" class=\"preview md-background-bg md-hue-1\"></div><div \nng-if=\"vm.board.settings.color\" class=\"preview\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\">\n{{vm.board.settings.color}}</div><md-button class=\"md-icon-button\" ng-click=\"vm.board.settings.color = \'\'\" \naria-label=\"Default Color\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon></md-button></md-list-item></md-list>\n</div><div flex class=\"content\" ms-scroll ms-sidenav-helper><md-list><md-list-item class=\"color\" \nng-repeat=\"(paletteName, palette) in vm.palettes\" ng-click=\"vm.board.settings.color = paletteName\" \nng-class=\"\'md-\'+paletteName+\'-bg\'\" aria-label=\"color select\"><p flex>{{paletteName}}</p><i class=\"icon-check s16\" \nng-if=\"paletteName === vm.board.settings.color\"></i></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/settings/menus/labels/labels-menu.html","<md-list><md-subheader class=\"md-no-sticky\">Add New Label</md-subheader><md-list-item class=\"label\"><div layout=\"row\" \nlayout-align=\"start center\"><md-menu md-offset=\"0 52px\"><md-button class=\"md-icon-button label-color-button\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"label color\"><md-icon md-font-icon=\"icon-label\" \nng-class=\"vm.newLabelColor+\'-fg\'\" class=\"label-icon\"></md-icon></md-button><md-menu-content \nclass=\"labels-settings-menu-content\" width=\"3\"><div class=\"new-label-color-pick\" layout=\"row\" layout-wrap><label \nclass=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" \nlayout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"vm.newLabelColor\" ng-value=\"palette\" \naria-label=\"{{palette}}\" ng-click=\"$mdMenu.hide()\"> <i class=\"icon-check s18\" ng-if=\"label.color === palette\"></i>\n</label></div></md-menu-content></md-menu><span editable-text=\"vm.newLabelName\" e-form=\"newLabelForm\" \nonaftersave=\"vm.addNewLabel()\"></span><p flex class=\"title new-label-form-button\" ng-click=\"newLabelForm.$show()\" \nng-hide=\"newLabelForm.$visible\">Enter New Label Name</p></div></md-list-item><md-divider></md-divider><md-list-item \nclass=\"label\" ng-repeat=\"label in vm.board.labels\"><div layout=\"row\" layout-align=\"start center\" flex><md-menu \nmd-offset=\"0 52px\"><md-button class=\"md-icon-button label-color-button\" ng-click=\"$mdOpenMenu($event)\" \naria-label=\"label color\"><md-icon md-font-icon=\"icon-label\" ng-class=\"label.color+\'-fg\'\" class=\"label-icon\"></md-icon>\n</md-button><md-menu-content class=\"labels-settings-menu-content\" width=\"3\"><div class=\"new-label-color-pick\" \nlayout=\"row\" layout-wrap><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" \nlayout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"label.color\" ng-value=\"palette\" \naria-label=\"{{palette}}\" ng-click=\"$mdMenu.hide()\"> <i class=\"icon-check s18\" ng-if=\"label.color === palette\"></i>\n</label></div></md-menu-content></md-menu><p flex class=\"title\" editable-text=\"label.name\">{{label.name}}</p><md-button\n ng-click=\"vm.removeLabel($event, label.id);\" class=\"remove-button md-icon-button\" aria-label=\"remove\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div></md-list-item></md-list>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/settings/menus/members/members-menu.html","<md-list><md-subheader class=\"md-no-sticky\">Add New Member</md-subheader><md-list-item class=\"add-new-member\"><form \nng-submit=\"vm.newMember()\" layout=\"row\" layout-align=\"start center\"><input flex placeholder=\"Type Member Name\" \ntype=\"text\" ng-model=\"vm.newMemberSearchInput\"><md-button type=\"submit\" class=\"md-accent md-raised\" \naria-label=\"Add New Member\">Add</md-button></form></md-list-item><md-divider></md-divider><md-list-item class=\"member\" \nng-repeat=\"member in vm.board.members\"><img alt=\"{{ member.name }}\" ng-src=\"{{ member.avatar }}\" class=\"md-avatar\"><p \nclass=\"member-name\">{{ member.name }}</p><md-button ng-click=\"vm.removeMember($event, member.id);\" \nclass=\"remove-button md-icon-button\" aria-label=\"remove\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button>\n</md-list-item></md-list>");
$templateCache.put("app/main/apps/scrumboard/views/calendar/dialogs/event/event-dialog.html","<md-dialog class=\"event-calendar-dialog\" aria-label=\"Event Dialog\" ng-cloak><md-toolbar class=\"md-accent\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">\n{{vm.dueDate | date:\'mediumDate\':\'UTC\'}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"close dialog\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-tabs md-dynamic-height><md-tab><md-tab-label>\n<span translate=\"SB.ADD_A_CARD\">Add a card</span></md-tab-label><md-tab-body><div class=\"new-card\" layout=\"column\">\n<form name=\"newCardForm\" novalidate><md-input-container class=\"new-card-name md-block\" md-no-float><input name=\"name\" \nng-model=\"vm.newCard.name\" placeholder=\"Card name\" required><div ng-messages=\"newCardForm.name.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"SB.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div>\n</md-input-container><div class=\"lists\"><p>Select a list:</p><md-radio-group ng-model=\"vm.newCard.listId\" required>\n<md-radio-button ng-repeat=\"list in vm.board.lists\" ng-value=\"list.id\">{{list.name}}</md-radio-button></md-radio-group>\n</div><md-dialog-actions><md-button class=\"md-accent md-raised\" ng-click=\"vm.addNewCard()\" \nng-disabled=\"newCardForm.$invalid || newCardForm.$pristine\">Add</md-button></md-dialog-actions></form></div>\n</md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"SB.ASSIGN_THE_DATE_TO_CARDS\">Assign the date to cards\n</span></md-tab-label><md-tab-body><div class=\"assign-due-date\"><md-list class=\"cards\"><md-content \nclass=\"cards-content\" flex ms-scroll><md-list-item class=\"card\" ng-repeat=\"card in vm.board.cards\" \nng-click=\"vm.toggleInArray(card.id, vm.selectedCards)\" aria-label=\"card\"><p layout=\"column\" layout-align=\"start start\">\n<span class=\"card-name\">{{card.name}}</span> <span ng-if=\"card.due\" class=\"card-date\">{{card.due | date}}</span></p>\n<md-checkbox ng-checked=\"vm.exists(card.id, vm.selectedCards)\" ng-click=\"vm.toggleInArray(card.id, vm.selectedCards)\" \nclass=\"md-secondary\" aria-label=\"card\"></md-checkbox></md-list-item></md-content></md-list><md-dialog-actions>\n<md-button ng-disabled=\"!vm.selectedCards[0]\" ng-click=\"vm.assignDueDate()\" class=\"md-accent md-raised\">Assign\n</md-button></md-dialog-actions></div></md-tab-body></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/scrumboard/views/calendar/sidenavs/scheduled-tasks/scheduled-tasks-sidenav.html","<div class=\"md-title sidenav-title\">Scheduled Cards</div><div class=\"cards\"><div ng-if=\"vm.cards.length <= 0\"><span \ntranslate=\"SB.NO_SCHEDULED_CARD\">There is no scheduled card.</span></div><div class=\"card\" layout=\"row\" \nng-repeat=\"card in vm.cards\"><md-button class=\"md-raised card-date\" ng-click=\"vm.goToDate(card.start)\"><div \nclass=\"day-in-week\">{{card.due | date:\'EEEE\'}}</div><div class=\"day\">{{card.due | date:\'d\' }}</div><div \nclass=\"month-year\">{{card.due | date:\'MMM yyyy\'}}</div></md-button><div class=\"card-title\" flex layout=\"column\" \nlayout-align=\"center start\" ng-click=\"vm.openCardDialog($event, card.idCard)\"><span>{{card.title}}</span></div></div>\n</div>");}]);